
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire319e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire319e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7hzE7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "use", () => $54d5c583314c33f7$export$1f96ae73734a86cc);
$parcel$export(module.exports, "default", () => $54d5c583314c33f7$export$2e2bcd8739ae039);

var $8Zslt = parcelRequire("8Zslt");
const $54d5c583314c33f7$export$1f96ae73734a86cc = false;
var $54d5c583314c33f7$export$2e2bcd8739ae039 = (0, $8Zslt.default);
$parcel$exportWildcard(module.exports, $8Zslt);

});
parcelRegister("8Zslt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PureComponent", () => $68ba0205fbe0f146$export$221d75b3f55bb0bd);
$parcel$export(module.exports, "memo", () => $68ba0205fbe0f146$export$7c73462e0d25e514);
$parcel$export(module.exports, "forwardRef", () => $68ba0205fbe0f146$export$257a8862b851cb5b);
$parcel$export(module.exports, "Children", () => $68ba0205fbe0f146$export$dca3b0875bd9a954);
$parcel$export(module.exports, "Suspense", () => $68ba0205fbe0f146$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "lazy", () => $68ba0205fbe0f146$export$488013bae63b21da);
$parcel$export(module.exports, "SuspenseList", () => $68ba0205fbe0f146$export$998bcd577473dd93);
$parcel$export(module.exports, "createPortal", () => $68ba0205fbe0f146$export$d39a5bbd09211389);
$parcel$export(module.exports, "render", () => $68ba0205fbe0f146$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $68ba0205fbe0f146$export$fa8d919ba61d84db);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $68ba0205fbe0f146$export$ae55be85d98224ed);
$parcel$export(module.exports, "useDeferredValue", () => $68ba0205fbe0f146$export$6a7bc4e911dc01cf);
$parcel$export(module.exports, "useInsertionEffect", () => $68ba0205fbe0f146$export$aaabe4eda9ed9969);
$parcel$export(module.exports, "useSyncExternalStore", () => $68ba0205fbe0f146$export$306c0aa65ff9ec16);
$parcel$export(module.exports, "useTransition", () => $68ba0205fbe0f146$export$7b286972b8d8ccbf);
$parcel$export(module.exports, "version", () => $68ba0205fbe0f146$export$83d89fbfd8236492);
$parcel$export(module.exports, "createFactory", () => $68ba0205fbe0f146$export$d38cd72104c1f0e9);
$parcel$export(module.exports, "isValidElement", () => $68ba0205fbe0f146$export$a8257692ac88316c);
$parcel$export(module.exports, "isFragment", () => $68ba0205fbe0f146$export$9522e17588c12572);
$parcel$export(module.exports, "isMemo", () => $68ba0205fbe0f146$export$56885ab8b9c456ab);
$parcel$export(module.exports, "cloneElement", () => $68ba0205fbe0f146$export$e530037191fcd5d7);
$parcel$export(module.exports, "unmountComponentAtNode", () => $68ba0205fbe0f146$export$502457920280e6be);
$parcel$export(module.exports, "findDOMNode", () => $68ba0205fbe0f146$export$466bfc07425424d5);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $68ba0205fbe0f146$export$c78a37762a8d58e1);
$parcel$export(module.exports, "flushSync", () => $68ba0205fbe0f146$export$cd75ccfd720a3cd4);
$parcel$export(module.exports, "StrictMode", () => $68ba0205fbe0f146$export$5f8d39834fd61797);
$parcel$export(module.exports, "startTransition", () => $68ba0205fbe0f146$export$7568632d0d33d16d);
$parcel$export(module.exports, "isElement", () => $68ba0205fbe0f146$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "default", () => $68ba0205fbe0f146$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Component", () => (parcelRequire("9Oehh")).Component);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("9Oehh")).Fragment);
$parcel$export(module.exports, "createContext", () => (parcelRequire("9Oehh")).createContext);
$parcel$export(module.exports, "createElement", () => (parcelRequire("9Oehh")).createElement);
$parcel$export(module.exports, "createRef", () => (parcelRequire("9Oehh")).createRef);

var $9Oehh = parcelRequire("9Oehh");

var $6F3kv = parcelRequire("6F3kv");
function $68ba0205fbe0f146$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $68ba0205fbe0f146$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $68ba0205fbe0f146$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $68ba0205fbe0f146$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $68ba0205fbe0f146$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $9Oehh.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($68ba0205fbe0f146$export$221d75b3f55bb0bd.prototype = new (0, $9Oehh.Component)).isPureReactComponent = !0, $68ba0205fbe0f146$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $68ba0205fbe0f146$var$E(this.props, n) || $68ba0205fbe0f146$var$E(this.state, t);
};
var $68ba0205fbe0f146$var$R = (0, $9Oehh.options).__b;
(0, $9Oehh.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $68ba0205fbe0f146$var$R && $68ba0205fbe0f146$var$R(n);
};
var $68ba0205fbe0f146$var$w = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $68ba0205fbe0f146$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $68ba0205fbe0f146$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $68ba0205fbe0f146$var$w, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $68ba0205fbe0f146$var$I = function(n, t) {
    return null == n ? null : (0, $9Oehh.toChildArray)((0, $9Oehh.toChildArray)(n).map(t));
}, $68ba0205fbe0f146$export$dca3b0875bd9a954 = {
    map: $68ba0205fbe0f146$var$I,
    forEach: $68ba0205fbe0f146$var$I,
    count: function(n) {
        return n ? (0, $9Oehh.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $9Oehh.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $9Oehh.toChildArray)
}, $68ba0205fbe0f146$var$M = (0, $9Oehh.options).__e;
(0, $9Oehh.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $68ba0205fbe0f146$var$M(n, t, e, r);
};
var $68ba0205fbe0f146$var$T = (0, $9Oehh.options).unmount;
function $68ba0205fbe0f146$var$A(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $68ba0205fbe0f146$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $68ba0205fbe0f146$var$A(n, t, e);
    })), n;
}
function $68ba0205fbe0f146$var$D(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $68ba0205fbe0f146$var$D(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $68ba0205fbe0f146$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $68ba0205fbe0f146$var$O(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $68ba0205fbe0f146$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $9Oehh.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $68ba0205fbe0f146$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $9Oehh.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $68ba0205fbe0f146$var$T && $68ba0205fbe0f146$var$T(n);
}, ($68ba0205fbe0f146$export$74bf444e3cd11ea5.prototype = new (0, $9Oehh.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $68ba0205fbe0f146$var$O(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(c) : c());
    };
    e.__R = i;
    var c = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $68ba0205fbe0f146$var$D(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $68ba0205fbe0f146$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $68ba0205fbe0f146$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $68ba0205fbe0f146$var$A(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $9Oehh.createElement)((0, $9Oehh.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $9Oehh.createElement)((0, $9Oehh.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $68ba0205fbe0f146$var$V = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $68ba0205fbe0f146$var$W(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $68ba0205fbe0f146$var$P(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $9Oehh.render)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        contains: function() {
            return !0;
        },
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $9Oehh.render)((0, $9Oehh.createElement)($68ba0205fbe0f146$var$W, {
        context: e.context
    }, n.__v), e.l);
}
function $68ba0205fbe0f146$export$d39a5bbd09211389(n, e) {
    var r = (0, $9Oehh.createElement)($68ba0205fbe0f146$var$P, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($68ba0205fbe0f146$export$998bcd577473dd93.prototype = new (0, $9Oehh.Component)).__a = function(n) {
    var t = this, e = $68ba0205fbe0f146$var$O(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $68ba0205fbe0f146$var$V(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $68ba0205fbe0f146$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $9Oehh.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $68ba0205fbe0f146$export$998bcd577473dd93.prototype.componentDidUpdate = $68ba0205fbe0f146$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $68ba0205fbe0f146$var$V(n, e, t);
    });
};
var $68ba0205fbe0f146$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $68ba0205fbe0f146$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $68ba0205fbe0f146$var$H = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $68ba0205fbe0f146$var$Z = /[A-Z0-9]/g, $68ba0205fbe0f146$var$Y = "undefined" != typeof document, $68ba0205fbe0f146$var$$ = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $68ba0205fbe0f146$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $9Oehh.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $68ba0205fbe0f146$export$fa8d919ba61d84db(n, t, e) {
    return (0, $9Oehh.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $9Oehh.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $9Oehh.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $68ba0205fbe0f146$var$J = (0, $9Oehh.options).event;
function $68ba0205fbe0f146$var$K() {}
function $68ba0205fbe0f146$var$Q() {
    return this.cancelBubble;
}
function $68ba0205fbe0f146$var$X() {
    return this.defaultPrevented;
}
(0, $9Oehh.options).event = function(n) {
    return $68ba0205fbe0f146$var$J && (n = $68ba0205fbe0f146$var$J(n)), n.persist = $68ba0205fbe0f146$var$K, n.isPropagationStopped = $68ba0205fbe0f146$var$Q, n.isDefaultPrevented = $68ba0205fbe0f146$var$X, n.nativeEvent = n;
};
var $68ba0205fbe0f146$var$nn, $68ba0205fbe0f146$var$tn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $68ba0205fbe0f146$var$en = (0, $9Oehh.options).vnode;
(0, $9Oehh.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var c = t[i];
            if (!("value" === i && "defaultValue" in t && null == c || $68ba0205fbe0f146$var$Y && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var l = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === c ? c = "" : "translate" === l && "no" === c ? c = !1 : "o" === l[0] && "n" === l[1] ? "ondoubleclick" === l ? i = "ondblclick" : "onchange" !== l || "input" !== e && "textarea" !== e || $68ba0205fbe0f146$var$$(t.type) ? "onfocus" === l ? i = "onfocusin" : "onblur" === l ? i = "onfocusout" : $68ba0205fbe0f146$var$H.test(i) && (i = l) : l = i = "oninput" : o && $68ba0205fbe0f146$var$B.test(i) ? i = i.replace($68ba0205fbe0f146$var$Z, "-$&").toLowerCase() : null === c && (c = void 0), "oninput" === l && u[i = l] && (i = "oninputCapture"), u[i] = c;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $9Oehh.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $9Oehh.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $68ba0205fbe0f146$var$tn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $68ba0205fbe0f146$var$z, $68ba0205fbe0f146$var$en && $68ba0205fbe0f146$var$en(n);
};
var $68ba0205fbe0f146$var$rn = (0, $9Oehh.options).__r;
(0, $9Oehh.options).__r = function(n) {
    $68ba0205fbe0f146$var$rn && $68ba0205fbe0f146$var$rn(n), $68ba0205fbe0f146$var$nn = n.__c;
};
var $68ba0205fbe0f146$var$un = (0, $9Oehh.options).diffed;
(0, $9Oehh.options).diffed = function(n) {
    $68ba0205fbe0f146$var$un && $68ba0205fbe0f146$var$un(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $68ba0205fbe0f146$var$nn = null;
};
var $68ba0205fbe0f146$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $68ba0205fbe0f146$var$nn.__n[n.__c].props.value;
            },
            useCallback: (0, $6F3kv.useCallback),
            useContext: (0, $6F3kv.useContext),
            useDebugValue: (0, $6F3kv.useDebugValue),
            useDeferredValue: $68ba0205fbe0f146$export$6a7bc4e911dc01cf,
            useEffect: (0, $6F3kv.useEffect),
            useId: (0, $6F3kv.useId),
            useImperativeHandle: (0, $6F3kv.useImperativeHandle),
            useInsertionEffect: $68ba0205fbe0f146$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $6F3kv.useLayoutEffect),
            useMemo: (0, $6F3kv.useMemo),
            useReducer: (0, $6F3kv.useReducer),
            useRef: (0, $6F3kv.useRef),
            useState: (0, $6F3kv.useState),
            useSyncExternalStore: $68ba0205fbe0f146$export$306c0aa65ff9ec16,
            useTransition: $68ba0205fbe0f146$export$7b286972b8d8ccbf
        }
    }
}, $68ba0205fbe0f146$export$83d89fbfd8236492 = "18.3.1";
function $68ba0205fbe0f146$export$d38cd72104c1f0e9(n) {
    return (0, $9Oehh.createElement).bind(null, n);
}
function $68ba0205fbe0f146$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $68ba0205fbe0f146$var$z;
}
function $68ba0205fbe0f146$export$9522e17588c12572(n) {
    return $68ba0205fbe0f146$export$a8257692ac88316c(n) && n.type === (0, $9Oehh.Fragment);
}
function $68ba0205fbe0f146$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $68ba0205fbe0f146$export$e530037191fcd5d7(n) {
    return $68ba0205fbe0f146$export$a8257692ac88316c(n) ? (0, $9Oehh.cloneElement).apply(null, arguments) : n;
}
function $68ba0205fbe0f146$export$502457920280e6be(n) {
    return !!n.__k && ((0, $9Oehh.render)(null, n), !0);
}
function $68ba0205fbe0f146$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $68ba0205fbe0f146$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $68ba0205fbe0f146$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $68ba0205fbe0f146$export$5f8d39834fd61797 = (0, $9Oehh.Fragment);
function $68ba0205fbe0f146$export$7568632d0d33d16d(n) {
    n();
}
function $68ba0205fbe0f146$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $68ba0205fbe0f146$export$7b286972b8d8ccbf() {
    return [
        !1,
        $68ba0205fbe0f146$export$7568632d0d33d16d
    ];
}
var $68ba0205fbe0f146$export$aaabe4eda9ed9969 = (0, $6F3kv.useLayoutEffect), $68ba0205fbe0f146$export$45a5e7f76e0caa8d = $68ba0205fbe0f146$export$a8257692ac88316c;
function $68ba0205fbe0f146$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $6F3kv.useState)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $6F3kv.useLayoutEffect)(function() {
        u.__ = e, u.v = t, $68ba0205fbe0f146$var$xn(u) && o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $6F3kv.useEffect)(function() {
        return $68ba0205fbe0f146$var$xn(u) && o({
            h: u
        }), n(function() {
            $68ba0205fbe0f146$var$xn(u) && o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
function $68ba0205fbe0f146$var$xn(n) {
    var t, e, r = n.v, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
var $68ba0205fbe0f146$export$2e2bcd8739ae039 = {
    useState: (0, $6F3kv.useState),
    useId: (0, $6F3kv.useId),
    useReducer: (0, $6F3kv.useReducer),
    useEffect: (0, $6F3kv.useEffect),
    useLayoutEffect: (0, $6F3kv.useLayoutEffect),
    useInsertionEffect: $68ba0205fbe0f146$export$aaabe4eda9ed9969,
    useTransition: $68ba0205fbe0f146$export$7b286972b8d8ccbf,
    useDeferredValue: $68ba0205fbe0f146$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $68ba0205fbe0f146$export$306c0aa65ff9ec16,
    startTransition: $68ba0205fbe0f146$export$7568632d0d33d16d,
    useRef: (0, $6F3kv.useRef),
    useImperativeHandle: (0, $6F3kv.useImperativeHandle),
    useMemo: (0, $6F3kv.useMemo),
    useCallback: (0, $6F3kv.useCallback),
    useContext: (0, $6F3kv.useContext),
    useDebugValue: (0, $6F3kv.useDebugValue),
    version: "18.3.1",
    Children: $68ba0205fbe0f146$export$dca3b0875bd9a954,
    render: $68ba0205fbe0f146$export$b3890eb0ae9dca99,
    hydrate: $68ba0205fbe0f146$export$fa8d919ba61d84db,
    unmountComponentAtNode: $68ba0205fbe0f146$export$502457920280e6be,
    createPortal: $68ba0205fbe0f146$export$d39a5bbd09211389,
    createElement: (0, $9Oehh.createElement),
    createContext: (0, $9Oehh.createContext),
    createFactory: $68ba0205fbe0f146$export$d38cd72104c1f0e9,
    cloneElement: $68ba0205fbe0f146$export$e530037191fcd5d7,
    createRef: (0, $9Oehh.createRef),
    Fragment: (0, $9Oehh.Fragment),
    isValidElement: $68ba0205fbe0f146$export$a8257692ac88316c,
    isElement: $68ba0205fbe0f146$export$45a5e7f76e0caa8d,
    isFragment: $68ba0205fbe0f146$export$9522e17588c12572,
    isMemo: $68ba0205fbe0f146$export$56885ab8b9c456ab,
    findDOMNode: $68ba0205fbe0f146$export$466bfc07425424d5,
    Component: (0, $9Oehh.Component),
    PureComponent: $68ba0205fbe0f146$export$221d75b3f55bb0bd,
    memo: $68ba0205fbe0f146$export$7c73462e0d25e514,
    forwardRef: $68ba0205fbe0f146$export$257a8862b851cb5b,
    flushSync: $68ba0205fbe0f146$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $68ba0205fbe0f146$export$c78a37762a8d58e1,
    StrictMode: $68ba0205fbe0f146$export$5f8d39834fd61797,
    Suspense: $68ba0205fbe0f146$export$74bf444e3cd11ea5,
    SuspenseList: $68ba0205fbe0f146$export$998bcd577473dd93,
    lazy: $68ba0205fbe0f146$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $68ba0205fbe0f146$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $6F3kv);

});
parcelRegister("9Oehh", function(module, exports) {

$parcel$export(module.exports, "options", () => $7243dbd523c5b038$export$41c562ebe57d11e2);
$parcel$export(module.exports, "createElement", () => $7243dbd523c5b038$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $7243dbd523c5b038$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $7243dbd523c5b038$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $7243dbd523c5b038$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $7243dbd523c5b038$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $7243dbd523c5b038$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $7243dbd523c5b038$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $7243dbd523c5b038$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $7243dbd523c5b038$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "h", () => $7243dbd523c5b038$export$c8a8987d4410bf2d);
var $7243dbd523c5b038$var$n, $7243dbd523c5b038$export$41c562ebe57d11e2, $7243dbd523c5b038$var$u, $7243dbd523c5b038$export$a8257692ac88316c, $7243dbd523c5b038$var$i, $7243dbd523c5b038$var$o, $7243dbd523c5b038$var$r, $7243dbd523c5b038$var$f, $7243dbd523c5b038$var$e, $7243dbd523c5b038$var$c, $7243dbd523c5b038$var$s, $7243dbd523c5b038$var$a, $7243dbd523c5b038$var$h = {}, $7243dbd523c5b038$var$v = [], $7243dbd523c5b038$var$p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $7243dbd523c5b038$var$y = Array.isArray;
function $7243dbd523c5b038$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $7243dbd523c5b038$var$w(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $7243dbd523c5b038$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $7243dbd523c5b038$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $7243dbd523c5b038$var$g(l, f, i, o, null);
}
function $7243dbd523c5b038$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$7243dbd523c5b038$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $7243dbd523c5b038$export$41c562ebe57d11e2.vnode && $7243dbd523c5b038$export$41c562ebe57d11e2.vnode(f), f;
}
function $7243dbd523c5b038$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $7243dbd523c5b038$export$ffb0004e005737fa(n) {
    return n.children;
}
function $7243dbd523c5b038$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $7243dbd523c5b038$var$x(n, l) {
    if (null == l) return n.__ ? $7243dbd523c5b038$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $7243dbd523c5b038$var$x(n) : null;
}
function $7243dbd523c5b038$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $7243dbd523c5b038$var$C(n);
    }
}
function $7243dbd523c5b038$var$M(n) {
    (!n.__d && (n.__d = !0) && $7243dbd523c5b038$var$i.push(n) && !$7243dbd523c5b038$var$P.__r++ || $7243dbd523c5b038$var$o !== $7243dbd523c5b038$export$41c562ebe57d11e2.debounceRendering) && (($7243dbd523c5b038$var$o = $7243dbd523c5b038$export$41c562ebe57d11e2.debounceRendering) || $7243dbd523c5b038$var$r)($7243dbd523c5b038$var$P);
}
function $7243dbd523c5b038$var$P() {
    var n, u, t, o, r, e, c, s;
    for($7243dbd523c5b038$var$i.sort($7243dbd523c5b038$var$f); n = $7243dbd523c5b038$var$i.shift();)n.__d && (u = $7243dbd523c5b038$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $7243dbd523c5b038$var$d({}, r)).__v = r.__v + 1, $7243dbd523c5b038$export$41c562ebe57d11e2.vnode && $7243dbd523c5b038$export$41c562ebe57d11e2.vnode(o), $7243dbd523c5b038$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $7243dbd523c5b038$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $7243dbd523c5b038$var$j(c, o, s), o.__e != e && $7243dbd523c5b038$var$C(o)), $7243dbd523c5b038$var$i.length > u && $7243dbd523c5b038$var$i.sort($7243dbd523c5b038$var$f));
    $7243dbd523c5b038$var$P.__r = 0;
}
function $7243dbd523c5b038$var$S(n, l, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, w, _ = t && t.__k || $7243dbd523c5b038$var$v, g = l.length;
    for(u.__d = e, $7243dbd523c5b038$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && (p = -1 === y.__i ? $7243dbd523c5b038$var$h : _[y.__i] || $7243dbd523c5b038$var$h, y.__i = a, $7243dbd523c5b038$var$O(n, y, p, i, o, r, f, e, c, s), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $7243dbd523c5b038$var$N(p.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || p.__k === y.__k ? e = $7243dbd523c5b038$var$I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $7243dbd523c5b038$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = l[t]) && "boolean" != typeof i && "function" != typeof i ? (r = t + a, (i = n.__k[t] = "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $7243dbd523c5b038$var$g(null, i, null, null, null) : $7243dbd523c5b038$var$y(i) ? $7243dbd523c5b038$var$g($7243dbd523c5b038$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $7243dbd523c5b038$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i).__ = n, i.__b = n.__b + 1, o = null, -1 !== (f = i.__i = $7243dbd523c5b038$var$L(i, u, r, s)) && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a-- : f == r + 1 ? a++ : (f > r ? a-- : a++, i.__u |= 65536))) : i = n.__k[t] = null;
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $7243dbd523c5b038$var$x(o)), $7243dbd523c5b038$var$V(o, o));
}
function $7243dbd523c5b038$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $7243dbd523c5b038$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $7243dbd523c5b038$var$x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $7243dbd523c5b038$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($7243dbd523c5b038$var$y(n) ? n.some(function(n) {
        $7243dbd523c5b038$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $7243dbd523c5b038$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $7243dbd523c5b038$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $7243dbd523c5b038$var$p.test(l) ? u : u + "px";
}
function $7243dbd523c5b038$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $7243dbd523c5b038$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $7243dbd523c5b038$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $7243dbd523c5b038$var$e, n.addEventListener(l, o ? $7243dbd523c5b038$var$s : $7243dbd523c5b038$var$c, o)) : n.removeEventListener(l, o ? $7243dbd523c5b038$var$s : $7243dbd523c5b038$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $7243dbd523c5b038$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $7243dbd523c5b038$var$e++;
            else if (u.t < t.u) return;
            return t($7243dbd523c5b038$export$41c562ebe57d11e2.event ? $7243dbd523c5b038$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $7243dbd523c5b038$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, v, p, w, _, g, m, x, C, M, P, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $7243dbd523c5b038$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, M) : (u.__c = h = new $7243dbd523c5b038$export$16fa2f45be04daa8(m, M), h.constructor = T, h.render = $7243dbd523c5b038$var$q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = M, h.__n = i, v = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $7243dbd523c5b038$var$d({}, h.__s)), $7243dbd523c5b038$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), p = h.props, w = h.state, h.__v = u, v) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== p && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, M) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, M), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(p, w, _);
            });
        }
        if (h.context = M, h.props = m, h.__P = n, h.__e = !1, $ = $7243dbd523c5b038$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $7243dbd523c5b038$var$d($7243dbd523c5b038$var$d({}, i), h.getChildContext())), x && !v && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(p, w)), $7243dbd523c5b038$var$S(n, $7243dbd523c5b038$var$y(L = null != a && a.type === $7243dbd523c5b038$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 32; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        $7243dbd523c5b038$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $7243dbd523c5b038$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $7243dbd523c5b038$export$41c562ebe57d11e2.diffed) && a(u);
}
function $7243dbd523c5b038$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$7243dbd523c5b038$var$N(t[i], t[++i], t[++i]);
    $7243dbd523c5b038$export$41c562ebe57d11e2.__c && $7243dbd523c5b038$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $7243dbd523c5b038$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $7243dbd523c5b038$var$z(u, t, i, o, r, f, e, c, s) {
    var a, v, p, d, _, g, m, b = i.props, k = t.props, C = t.type;
    if ("svg" === C ? r = "http://www.w3.org/2000/svg" : "math" === C ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), null != f) {
        for(a = 0; a < f.length; a++)if ((_ = f[a]) && "setAttribute" in _ == !!C && (C ? _.localName === C : 3 === _.nodeType)) {
            u = _, f[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null === C) return document.createTextNode(k);
        u = document.createElementNS(r, C, k.is && k), c && ($7243dbd523c5b038$export$41c562ebe57d11e2.__m && $7243dbd523c5b038$export$41c562ebe57d11e2.__m(t, f), c = !1), f = null;
    }
    if (null === C) b === k || c && u.data === k || (u.data = k);
    else {
        if (f = f && $7243dbd523c5b038$var$n.call(u.childNodes), b = i.props || $7243dbd523c5b038$var$h, !c && null != f) for(b = {}, a = 0; a < u.attributes.length; a++)b[(_ = u.attributes[a]).name] = _.value;
        for(a in b)if (_ = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) p = _;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $7243dbd523c5b038$var$A(u, a, null, _, r);
        }
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? m = _ : c && "function" != typeof _ || b[a] === _ || $7243dbd523c5b038$var$A(u, a, _, b[a], r);
        if (v) c || p && (v.__html === p.__html || v.__html === u.innerHTML) || (u.innerHTML = v.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $7243dbd523c5b038$var$S(u, $7243dbd523c5b038$var$y(d) ? d : [
            d
        ], t, i, o, "foreignObject" === C ? "http://www.w3.org/1999/xhtml" : r, f, e, f ? f[0] : i.__k && $7243dbd523c5b038$var$x(i, 0), c, s), null != f) for(a = f.length; a--;)$7243dbd523c5b038$var$w(f[a]);
        c || (a = "value", "progress" === C && null == g ? u.removeAttribute("value") : void 0 !== g && (g !== u[a] || "progress" === C && !g || "option" === C && g !== b[a]) && $7243dbd523c5b038$var$A(u, a, g, b[a], r), a = "checked", void 0 !== m && m !== u[a] && $7243dbd523c5b038$var$A(u, a, m, b[a], r));
    }
    return u;
}
function $7243dbd523c5b038$var$N(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $7243dbd523c5b038$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $7243dbd523c5b038$var$V(n, u, t) {
    var i, o;
    if ($7243dbd523c5b038$export$41c562ebe57d11e2.unmount && $7243dbd523c5b038$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $7243dbd523c5b038$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $7243dbd523c5b038$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $7243dbd523c5b038$var$V(i[o], u, t || "function" != typeof n.type);
    t || $7243dbd523c5b038$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $7243dbd523c5b038$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $7243dbd523c5b038$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $7243dbd523c5b038$export$41c562ebe57d11e2.__ && $7243dbd523c5b038$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $7243dbd523c5b038$var$O(t, u = (!o && i || t).__k = $7243dbd523c5b038$export$c8a8987d4410bf2d($7243dbd523c5b038$export$ffb0004e005737fa, null, [
        u
    ]), r || $7243dbd523c5b038$var$h, $7243dbd523c5b038$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $7243dbd523c5b038$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $7243dbd523c5b038$var$j(f, u, e);
}
function $7243dbd523c5b038$export$fa8d919ba61d84db(n, l) {
    $7243dbd523c5b038$export$b3890eb0ae9dca99(n, l, $7243dbd523c5b038$export$fa8d919ba61d84db);
}
function $7243dbd523c5b038$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $7243dbd523c5b038$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $7243dbd523c5b038$var$n.call(arguments, 2) : t), $7243dbd523c5b038$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $7243dbd523c5b038$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $7243dbd523c5b038$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $7243dbd523c5b038$var$M(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$7243dbd523c5b038$var$n = $7243dbd523c5b038$var$v.slice, $7243dbd523c5b038$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $7243dbd523c5b038$var$u = 0, $7243dbd523c5b038$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $7243dbd523c5b038$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $7243dbd523c5b038$var$d({}, this.state), "function" == typeof n && (n = n($7243dbd523c5b038$var$d({}, u), this.props)), n && $7243dbd523c5b038$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $7243dbd523c5b038$var$M(this));
}, $7243dbd523c5b038$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $7243dbd523c5b038$var$M(this));
}, $7243dbd523c5b038$export$16fa2f45be04daa8.prototype.render = $7243dbd523c5b038$export$ffb0004e005737fa, $7243dbd523c5b038$var$i = [], $7243dbd523c5b038$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $7243dbd523c5b038$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $7243dbd523c5b038$var$P.__r = 0, $7243dbd523c5b038$var$e = 0, $7243dbd523c5b038$var$c = $7243dbd523c5b038$var$F(!1), $7243dbd523c5b038$var$s = $7243dbd523c5b038$var$F(!0), $7243dbd523c5b038$var$a = 0;

});

parcelRegister("6F3kv", function(module, exports) {

$parcel$export(module.exports, "useState", () => $4d99279dbc98f950$export$60241385465d0a34);
$parcel$export(module.exports, "useReducer", () => $4d99279dbc98f950$export$13e3392192263954);
$parcel$export(module.exports, "useEffect", () => $4d99279dbc98f950$export$6d9c69b0de29b591);
$parcel$export(module.exports, "useLayoutEffect", () => $4d99279dbc98f950$export$e5c5a5f917a5871c);
$parcel$export(module.exports, "useRef", () => $4d99279dbc98f950$export$b8f5890fc79d6aca);
$parcel$export(module.exports, "useMemo", () => $4d99279dbc98f950$export$1538c33de8887b59);
$parcel$export(module.exports, "useImperativeHandle", () => $4d99279dbc98f950$export$d5a552a76deda3c2);
$parcel$export(module.exports, "useCallback", () => $4d99279dbc98f950$export$35808ee640e87ca7);
$parcel$export(module.exports, "useContext", () => $4d99279dbc98f950$export$fae74005e78b1a27);
$parcel$export(module.exports, "useDebugValue", () => $4d99279dbc98f950$export$dc8fbce3eb94dc1e);
$parcel$export(module.exports, "useErrorBoundary", () => $4d99279dbc98f950$export$c052f6604b7d51fe);
$parcel$export(module.exports, "useId", () => $4d99279dbc98f950$export$f680877a34711e37);

var $9Oehh = parcelRequire("9Oehh");
var $4d99279dbc98f950$var$t, $4d99279dbc98f950$var$r, $4d99279dbc98f950$var$u, $4d99279dbc98f950$var$i, $4d99279dbc98f950$var$o = 0, $4d99279dbc98f950$var$f = [], $4d99279dbc98f950$var$c = (0, $9Oehh.options), $4d99279dbc98f950$var$e = $4d99279dbc98f950$var$c.__b, $4d99279dbc98f950$var$a = $4d99279dbc98f950$var$c.__r, $4d99279dbc98f950$var$v = $4d99279dbc98f950$var$c.diffed, $4d99279dbc98f950$var$l = $4d99279dbc98f950$var$c.__c, $4d99279dbc98f950$var$m = $4d99279dbc98f950$var$c.unmount, $4d99279dbc98f950$var$s = $4d99279dbc98f950$var$c.__;
function $4d99279dbc98f950$var$d(n, t) {
    $4d99279dbc98f950$var$c.__h && $4d99279dbc98f950$var$c.__h($4d99279dbc98f950$var$r, n, $4d99279dbc98f950$var$o || t), $4d99279dbc98f950$var$o = 0;
    var u = $4d99279dbc98f950$var$r.__H || ($4d99279dbc98f950$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $4d99279dbc98f950$export$60241385465d0a34(n) {
    return $4d99279dbc98f950$var$o = 1, $4d99279dbc98f950$export$13e3392192263954($4d99279dbc98f950$var$D, n);
}
function $4d99279dbc98f950$export$13e3392192263954(n, u, i) {
    var o = $4d99279dbc98f950$var$d($4d99279dbc98f950$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $4d99279dbc98f950$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $4d99279dbc98f950$var$r, !$4d99279dbc98f950$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $4d99279dbc98f950$var$r.u = !0;
        var c = $4d99279dbc98f950$var$r.shouldComponentUpdate, e = $4d99279dbc98f950$var$r.componentWillUpdate;
        $4d99279dbc98f950$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $4d99279dbc98f950$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $4d99279dbc98f950$export$6d9c69b0de29b591(n, u) {
    var i = $4d99279dbc98f950$var$d($4d99279dbc98f950$var$t++, 3);
    !$4d99279dbc98f950$var$c.__s && $4d99279dbc98f950$var$C(i.__H, u) && (i.__ = n, i.i = u, $4d99279dbc98f950$var$r.__H.__h.push(i));
}
function $4d99279dbc98f950$export$e5c5a5f917a5871c(n, u) {
    var i = $4d99279dbc98f950$var$d($4d99279dbc98f950$var$t++, 4);
    !$4d99279dbc98f950$var$c.__s && $4d99279dbc98f950$var$C(i.__H, u) && (i.__ = n, i.i = u, $4d99279dbc98f950$var$r.__h.push(i));
}
function $4d99279dbc98f950$export$b8f5890fc79d6aca(n) {
    return $4d99279dbc98f950$var$o = 5, $4d99279dbc98f950$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $4d99279dbc98f950$export$d5a552a76deda3c2(n, t, r) {
    $4d99279dbc98f950$var$o = 6, $4d99279dbc98f950$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $4d99279dbc98f950$export$1538c33de8887b59(n, r) {
    var u = $4d99279dbc98f950$var$d($4d99279dbc98f950$var$t++, 7);
    return $4d99279dbc98f950$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $4d99279dbc98f950$export$35808ee640e87ca7(n, t) {
    return $4d99279dbc98f950$var$o = 8, $4d99279dbc98f950$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $4d99279dbc98f950$export$fae74005e78b1a27(n) {
    var u = $4d99279dbc98f950$var$r.context[n.__c], i = $4d99279dbc98f950$var$d($4d99279dbc98f950$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($4d99279dbc98f950$var$r)), u.props.value) : n.__;
}
function $4d99279dbc98f950$export$dc8fbce3eb94dc1e(n, t) {
    $4d99279dbc98f950$var$c.useDebugValue && $4d99279dbc98f950$var$c.useDebugValue(t ? t(n) : n);
}
function $4d99279dbc98f950$export$c052f6604b7d51fe(n) {
    var u = $4d99279dbc98f950$var$d($4d99279dbc98f950$var$t++, 10), i = $4d99279dbc98f950$export$60241385465d0a34();
    return u.__ = n, $4d99279dbc98f950$var$r.componentDidCatch || ($4d99279dbc98f950$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $4d99279dbc98f950$export$f680877a34711e37() {
    var n = $4d99279dbc98f950$var$d($4d99279dbc98f950$var$t++, 11);
    if (!n.__) {
        for(var u = $4d99279dbc98f950$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $4d99279dbc98f950$var$j() {
    for(var n; n = $4d99279dbc98f950$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($4d99279dbc98f950$var$z), n.__H.__h.forEach($4d99279dbc98f950$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $4d99279dbc98f950$var$c.__e(t, n.__v);
    }
}
$4d99279dbc98f950$var$c.__b = function(n) {
    $4d99279dbc98f950$var$r = null, $4d99279dbc98f950$var$e && $4d99279dbc98f950$var$e(n);
}, $4d99279dbc98f950$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $4d99279dbc98f950$var$s && $4d99279dbc98f950$var$s(n, t);
}, $4d99279dbc98f950$var$c.__r = function(n) {
    $4d99279dbc98f950$var$a && $4d99279dbc98f950$var$a(n), $4d99279dbc98f950$var$t = 0;
    var i = ($4d99279dbc98f950$var$r = n.__c).__H;
    i && ($4d99279dbc98f950$var$u === $4d99279dbc98f950$var$r ? (i.__h = [], $4d99279dbc98f950$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
    })) : (i.__h.forEach($4d99279dbc98f950$var$z), i.__h.forEach($4d99279dbc98f950$var$B), i.__h = [], $4d99279dbc98f950$var$t = 0)), $4d99279dbc98f950$var$u = $4d99279dbc98f950$var$r;
}, $4d99279dbc98f950$var$c.diffed = function(n) {
    $4d99279dbc98f950$var$v && $4d99279dbc98f950$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $4d99279dbc98f950$var$f.push(t) && $4d99279dbc98f950$var$i === $4d99279dbc98f950$var$c.requestAnimationFrame || (($4d99279dbc98f950$var$i = $4d99279dbc98f950$var$c.requestAnimationFrame) || $4d99279dbc98f950$var$w)($4d99279dbc98f950$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.i = void 0;
    })), $4d99279dbc98f950$var$u = $4d99279dbc98f950$var$r = null;
}, $4d99279dbc98f950$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($4d99279dbc98f950$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $4d99279dbc98f950$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $4d99279dbc98f950$var$c.__e(r, n.__v);
        }
    }), $4d99279dbc98f950$var$l && $4d99279dbc98f950$var$l(n, t);
}, $4d99279dbc98f950$var$c.unmount = function(n) {
    $4d99279dbc98f950$var$m && $4d99279dbc98f950$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $4d99279dbc98f950$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $4d99279dbc98f950$var$c.__e(t, r.__v));
};
var $4d99279dbc98f950$var$k = "function" == typeof requestAnimationFrame;
function $4d99279dbc98f950$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $4d99279dbc98f950$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $4d99279dbc98f950$var$k && (t = requestAnimationFrame(r));
}
function $4d99279dbc98f950$var$z(n) {
    var t = $4d99279dbc98f950$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $4d99279dbc98f950$var$r = t;
}
function $4d99279dbc98f950$var$B(n) {
    var t = $4d99279dbc98f950$var$r;
    n.__c = n.__(), $4d99279dbc98f950$var$r = t;
}
function $4d99279dbc98f950$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $4d99279dbc98f950$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});



parcelRegister("2Wppk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2244b4f5a813178a$var$React = $2244b4f5a813178a$var$_interopRequireWildcard((parcelRequire("7hzE7")));

var $iykXw = parcelRequire("iykXw");

var $2244b4f5a813178a$var$_clsx = $2244b4f5a813178a$var$_interopRequireDefault((parcelRequire("cfW2W")));

var $85pJf = parcelRequire("85pJf");

var $6byAd = parcelRequire("6byAd");

var $2244b4f5a813178a$var$_GridItem = $2244b4f5a813178a$var$_interopRequireDefault((parcelRequire("kA7VV")));

var $2244b4f5a813178a$var$_ReactGridLayoutPropTypes = $2244b4f5a813178a$var$_interopRequireDefault((parcelRequire("11VIj")));
function $2244b4f5a813178a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2244b4f5a813178a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2244b4f5a813178a$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $2244b4f5a813178a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $2244b4f5a813178a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $2244b4f5a813178a$var$_defineProperty(obj, key, value) {
    key = $2244b4f5a813178a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2244b4f5a813178a$var$_toPropertyKey(arg) {
    var key = $2244b4f5a813178a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2244b4f5a813178a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  CompactType,
  GridResizeEvent,
  GridDragEvent,
  DragOverEvent,
  Layout,
  DroppingPosition,
  LayoutItem
} from "./utils";*/ // Types
/*:: import type { PositionParams } from "./calculateUtils";*/ /*:: type State = {
  activeDrag: ?LayoutItem,
  layout: Layout,
  mounted: boolean,
  oldDragItem: ?LayoutItem,
  oldLayout: ?Layout,
  oldResizeItem: ?LayoutItem,
  resizing: boolean,
  droppingDOMNode: ?ReactElement<any>,
  droppingPosition?: DroppingPosition,
  // Mirrored props
  children: ReactChildrenArray<ReactElement<any>>,
  compactType?: CompactType,
  propsLayout?: Layout
};*/ /*:: import type { Props, DefaultProps } from "./ReactGridLayoutPropTypes";*/ // End Types
const $2244b4f5a813178a$var$layoutClassName = "react-grid-layout";
let $2244b4f5a813178a$var$isFirefox = false;
// Try...catch will protect from navigator not existing (e.g. node) or a bad implementation of navigator
try {
    $2244b4f5a813178a$var$isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e) {
/* Ignore */ }
/**
 * A reactive, fluid grid layout with draggable, resizable components.
 */ class $2244b4f5a813178a$var$ReactGridLayout extends $2244b4f5a813178a$var$React.Component /*:: <Props, State>*/  {
    constructor(){
        super(...arguments);
        $2244b4f5a813178a$var$_defineProperty(this, "state", {
            activeDrag: null,
            layout: (0, $85pJf.synchronizeLayoutWithChildren)(this.props.layout, this.props.children, this.props.cols, // Legacy support for verticalCompact: false
            (0, $85pJf.compactType)(this.props), this.props.allowOverlap),
            mounted: false,
            oldDragItem: null,
            oldLayout: null,
            oldResizeItem: null,
            resizing: false,
            droppingDOMNode: null,
            children: []
        });
        $2244b4f5a813178a$var$_defineProperty(this, "dragEnterCounter", 0);
        /**
     * When dragging starts
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $2244b4f5a813178a$var$_defineProperty(this, "onDragStart", (i /*: string*/ , x /*: number*/ , y /*: number*/ , _ref /*:: */ )=>{
            let { e: e, node: node } /*: GridDragEvent*/  = _ref /*: GridDragEvent*/ ;
            const { layout: layout } = this.state;
            const l = (0, $85pJf.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            this.setState({
                oldDragItem: (0, $85pJf.cloneLayoutItem)(l),
                oldLayout: layout,
                activeDrag: placeholder
            });
            return this.props.onDragStart(layout, l, l, null, e, node);
        });
        /**
     * Each drag movement create a new dragelement and move the element to the dragged location
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $2244b4f5a813178a$var$_defineProperty(this, "onDrag", (i, x, y, _ref2)=>{
            let { e: e, node: node } = _ref2;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, allowOverlap: allowOverlap, preventCollision: preventCollision } = this.props;
            const l = (0, $85pJf.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            // Move the element to the dragged location.
            const isUserAction = true;
            layout = (0, $85pJf.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $85pJf.compactType)(this.props), cols, allowOverlap);
            this.props.onDrag(layout, oldDragItem, l, placeholder, e, node);
            this.setState({
                layout: allowOverlap ? layout : (0, $85pJf.compact)(layout, (0, $85pJf.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        /**
     * When dragging stops, figure out which position the element is closest to and update its x and y.
     * @param  {String} i Index of the child.
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $2244b4f5a813178a$var$_defineProperty(this, "onDragStop", (i, x, y, _ref3)=>{
            let { e: e, node: node } = _ref3;
            if (!this.state.activeDrag) return;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            const l = (0, $85pJf.getLayoutItem)(layout, i);
            if (!l) return;
            // Move the element here
            const isUserAction = true;
            layout = (0, $85pJf.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $85pJf.compactType)(this.props), cols, allowOverlap);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $85pJf.compact)(layout, (0, $85pJf.compactType)(this.props), cols);
            this.props.onDragStop(newLayout, oldDragItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldDragItem: null,
                oldLayout: null
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        $2244b4f5a813178a$var$_defineProperty(this, "onResizeStart", (i, w, h, _ref4)=>{
            let { e: e, node: node } = _ref4;
            const { layout: layout } = this.state;
            const l = (0, $85pJf.getLayoutItem)(layout, i);
            if (!l) return;
            this.setState({
                oldResizeItem: (0, $85pJf.cloneLayoutItem)(l),
                oldLayout: this.state.layout,
                resizing: true
            });
            this.props.onResizeStart(layout, l, l, null, e, node);
        });
        $2244b4f5a813178a$var$_defineProperty(this, "onResize", (i, w, h, _ref5)=>{
            let { e: e, node: node, size: size, handle: handle } = _ref5;
            const { oldResizeItem: oldResizeItem } = this.state;
            const { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            let shouldMoveItem = false;
            let finalLayout;
            let x;
            let y;
            const [newLayout, l] = (0, $85pJf.withLayoutItem)(layout, i, (l)=>{
                let hasCollisions;
                x = l.x;
                y = l.y;
                if ([
                    "sw",
                    "w",
                    "nw",
                    "n",
                    "ne"
                ].indexOf(handle) !== -1) {
                    if ([
                        "sw",
                        "nw",
                        "w"
                    ].indexOf(handle) !== -1) {
                        x = l.x + (l.w - w);
                        w = l.x !== x && x < 0 ? l.w : w;
                        x = x < 0 ? 0 : x;
                    }
                    if ([
                        "ne",
                        "n",
                        "nw"
                    ].indexOf(handle) !== -1) {
                        y = l.y + (l.h - h);
                        h = l.y !== y && y < 0 ? l.h : h;
                        y = y < 0 ? 0 : y;
                    }
                    shouldMoveItem = true;
                }
                // Something like quad tree should be used
                // to find collisions faster
                if (preventCollision && !allowOverlap) {
                    const collisions = (0, $85pJf.getAllCollisions)(layout, {
                        ...l,
                        w: w,
                        h: h,
                        x: x,
                        y: y
                    }).filter((layoutItem)=>layoutItem.i !== l.i);
                    hasCollisions = collisions.length > 0;
                    // If we're colliding, we need adjust the placeholder.
                    if (hasCollisions) {
                        // Reset layoutItem dimensions if there were collisions
                        y = l.y;
                        h = l.h;
                        x = l.x;
                        w = l.w;
                        shouldMoveItem = false;
                    }
                }
                l.w = w;
                l.h = h;
                return l;
            });
            // Shouldn't ever happen, but typechecking makes it necessary
            if (!l) return;
            finalLayout = newLayout;
            if (shouldMoveItem) {
                // Move the element to the new position.
                const isUserAction = true;
                finalLayout = (0, $85pJf.moveElement)(newLayout, l, x, y, isUserAction, this.props.preventCollision, (0, $85pJf.compactType)(this.props), cols, allowOverlap);
            }
            // Create placeholder element (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                static: true,
                i: i
            };
            this.props.onResize(finalLayout, oldResizeItem, l, placeholder, e, node);
            // Re-compact the newLayout and set the drag placeholder.
            this.setState({
                layout: allowOverlap ? finalLayout : (0, $85pJf.compact)(finalLayout, (0, $85pJf.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        $2244b4f5a813178a$var$_defineProperty(this, "onResizeStop", (i, w, h, _ref6)=>{
            let { e: e, node: node } = _ref6;
            const { layout: layout, oldResizeItem: oldResizeItem } = this.state;
            const { cols: cols, allowOverlap: allowOverlap } = this.props;
            const l = (0, $85pJf.getLayoutItem)(layout, i);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $85pJf.compact)(layout, (0, $85pJf.compactType)(this.props), cols);
            this.props.onResizeStop(newLayout, oldResizeItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldResizeItem: null,
                oldLayout: null,
                resizing: false
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        // Called while dragging an element. Part of browser native drag/drop API.
        // Native event target might be the layout itself, or an element within the layout.
        $2244b4f5a813178a$var$_defineProperty(this, "onDragOver", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            // we should ignore events from layout's children in Firefox
            // to avoid unpredictable jumping of a dropping placeholder
            // FIXME remove this hack
            if ($2244b4f5a813178a$var$isFirefox && // $FlowIgnore can't figure this out
            !e.nativeEvent.target?.classList.contains($2244b4f5a813178a$var$layoutClassName)) return false;
            const { droppingItem: droppingItem, onDropDragOver: onDropDragOver, margin: margin, cols: cols, rowHeight: rowHeight, maxRows: maxRows, width: width, containerPadding: containerPadding, transformScale: transformScale } = this.props;
            // Allow user to customize the dropping item or short-circuit the drop based on the results
            // of the `onDragOver(e: Event)` callback.
            const onDragOverResult = onDropDragOver?.(e);
            if (onDragOverResult === false) {
                if (this.state.droppingDOMNode) this.removeDroppingPlaceholder();
                return false;
            }
            const finalDroppingItem = {
                ...droppingItem,
                ...onDragOverResult
            };
            const { layout: layout } = this.state;
            // $FlowIgnore missing def
            const gridRect = e.currentTarget.getBoundingClientRect(); // The grid's position in the viewport
            // Calculate the mouse position relative to the grid
            const layerX = e.clientX - gridRect.left;
            const layerY = e.clientY - gridRect.top;
            const droppingPosition = {
                left: layerX / transformScale,
                top: layerY / transformScale,
                e: e
            };
            if (!this.state.droppingDOMNode) {
                const positionParams /*: PositionParams*/  = {
                    cols: cols,
                    margin: margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    containerWidth: width,
                    containerPadding: containerPadding || margin
                };
                const calculatedPosition = (0, $6byAd.calcXY)(positionParams, layerY, layerX, finalDroppingItem.w, finalDroppingItem.h);
                this.setState({
                    droppingDOMNode: /*#__PURE__*/ $2244b4f5a813178a$var$React.createElement("div", {
                        key: finalDroppingItem.i
                    }),
                    droppingPosition: droppingPosition,
                    layout: [
                        ...layout,
                        {
                            ...finalDroppingItem,
                            x: calculatedPosition.x,
                            y: calculatedPosition.y,
                            static: false,
                            isDraggable: true
                        }
                    ]
                });
            } else if (this.state.droppingPosition) {
                const { left: left, top: top } = this.state.droppingPosition;
                const shouldUpdatePosition = left != layerX || top != layerY;
                if (shouldUpdatePosition) this.setState({
                    droppingPosition: droppingPosition
                });
            }
        });
        $2244b4f5a813178a$var$_defineProperty(this, "removeDroppingPlaceholder", ()=>{
            const { droppingItem: droppingItem, cols: cols } = this.props;
            const { layout: layout } = this.state;
            const newLayout = (0, $85pJf.compact)(layout.filter((l)=>l.i !== droppingItem.i), (0, $85pJf.compactType)(this.props), cols, this.props.allowOverlap);
            this.setState({
                layout: newLayout,
                droppingDOMNode: null,
                activeDrag: null,
                droppingPosition: undefined
            });
        });
        $2244b4f5a813178a$var$_defineProperty(this, "onDragLeave", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter--;
            // onDragLeave can be triggered on each layout's child.
            // But we know that count of dragEnter and dragLeave events
            // will be balanced after leaving the layout's container
            // so we can increase and decrease count of dragEnter and
            // when it'll be equal to 0 we'll remove the placeholder
            if (this.dragEnterCounter === 0) this.removeDroppingPlaceholder();
        });
        $2244b4f5a813178a$var$_defineProperty(this, "onDragEnter", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter++;
        });
        $2244b4f5a813178a$var$_defineProperty(this, "onDrop", (e /*: Event*/ )=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            const { droppingItem: droppingItem } = this.props;
            const { layout: layout } = this.state;
            const item = layout.find((l)=>l.i === droppingItem.i);
            // reset dragEnter counter on drop
            this.dragEnterCounter = 0;
            this.removeDroppingPlaceholder();
            this.props.onDrop(layout, item, e);
        });
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
        // Possibly call back with layout on mount. This should be done after correcting the layout width
        // to ensure we don't rerender with the wrong width.
        this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
    }
    static getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State> | null*/ {
        let newLayoutBase;
        if (prevState.activeDrag) return null;
        // Legacy support for compactType
        // Allow parent to set layout directly.
        if (!(0, $iykXw.deepEqual)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) newLayoutBase = nextProps.layout;
        else if (!(0, $85pJf.childrenEqual)(nextProps.children, prevState.children)) // If children change, also regenerate the layout. Use our state
        // as the base in case because it may be more up to date than
        // what is in props.
        newLayoutBase = prevState.layout;
        // We need to regenerate the layout.
        if (newLayoutBase) {
            const newLayout = (0, $85pJf.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, $85pJf.compactType)(nextProps), nextProps.allowOverlap);
            return {
                layout: newLayout,
                // We need to save these props to state for using
                // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
                compactType: nextProps.compactType,
                children: nextProps.children,
                propsLayout: nextProps.layout
            };
        }
        return null;
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        return(// NOTE: this is almost always unequal. Therefore the only way to get better performance
        // from SCU is if the user intentionally memoizes children. If they do, and they can
        // handle changes properly, performance will increase.
        this.props.children !== nextProps.children || !(0, $85pJf.fastRGLPropsEqual)(this.props, nextProps, $iykXw.deepEqual) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition);
    }
    componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
        if (!this.state.activeDrag) {
            const newLayout = this.state.layout;
            const oldLayout = prevState.layout;
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        }
    }
    /**
   * Calculates a pixel value for the container.
   * @return {String} Container height in pixels.
   */ containerHeight() /*: ?string*/ {
        if (!this.props.autoSize) return;
        const nbRow = (0, $85pJf.bottom)(this.state.layout);
        const containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
        return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
    }
    onLayoutMaybeChanged(newLayout /*: Layout*/ , oldLayout /*: ?Layout*/ ) {
        if (!oldLayout) oldLayout = this.state.layout;
        if (!(0, $iykXw.deepEqual)(oldLayout, newLayout)) this.props.onLayoutChange(newLayout);
    }
    /**
   * Create a placeholder object.
   * @return {Element} Placeholder div.
   */ placeholder() /*: ?ReactElement<any>*/ {
        const { activeDrag: activeDrag } = this.state;
        if (!activeDrag) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, useCSSTransforms: useCSSTransforms, transformScale: transformScale } = this.props;
        // {...this.state.activeDrag} is pretty slow, actually
        return /*#__PURE__*/ $2244b4f5a813178a$var$React.createElement($2244b4f5a813178a$var$_GridItem.default, {
            w: activeDrag.w,
            h: activeDrag.h,
            x: activeDrag.x,
            y: activeDrag.y,
            i: activeDrag.i,
            className: `react-grid-placeholder ${this.state.resizing ? "placeholder-resizing" : ""}`,
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            isDraggable: false,
            isResizable: false,
            isBounded: false,
            useCSSTransforms: useCSSTransforms,
            transformScale: transformScale
        }, /*#__PURE__*/ $2244b4f5a813178a$var$React.createElement("div", null));
    }
    /**
   * Given a grid item, set its style attributes & surround in a <Draggable>.
   * @param  {Element} child React element.
   * @return {Element}       Element wrapped in draggable and properly placed.
   */ processGridItem(child /*: ReactElement<any>*/ , isDroppingItem /*: boolean*/ ) /*: ?ReactElement<any>*/ {
        if (!child || !child.key) return;
        const l = (0, $85pJf.getLayoutItem)(this.state.layout, String(child.key));
        if (!l) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, isDraggable: isDraggable, isResizable: isResizable, isBounded: isBounded, useCSSTransforms: useCSSTransforms, transformScale: transformScale, draggableCancel: draggableCancel, draggableHandle: draggableHandle, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const { mounted: mounted, droppingPosition: droppingPosition } = this.state;
        // Determine user manipulations possible.
        // If an item is static, it can't be manipulated by default.
        // Any properties defined directly on the grid item will take precedence.
        const draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
        const resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
        const resizeHandlesOptions = l.resizeHandles || resizeHandles;
        // isBounded set on child if set on parent, and child is not explicitly false
        const bounded = draggable && isBounded && l.isBounded !== false;
        return /*#__PURE__*/ $2244b4f5a813178a$var$React.createElement($2244b4f5a813178a$var$_GridItem.default, {
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            cancel: draggableCancel,
            handle: draggableHandle,
            onDragStop: this.onDragStop,
            onDragStart: this.onDragStart,
            onDrag: this.onDrag,
            onResizeStart: this.onResizeStart,
            onResize: this.onResize,
            onResizeStop: this.onResizeStop,
            isDraggable: draggable,
            isResizable: resizable,
            isBounded: bounded,
            useCSSTransforms: useCSSTransforms && mounted,
            usePercentages: !mounted,
            transformScale: transformScale,
            w: l.w,
            h: l.h,
            x: l.x,
            y: l.y,
            i: l.i,
            minH: l.minH,
            minW: l.minW,
            maxH: l.maxH,
            maxW: l.maxW,
            static: l.static,
            droppingPosition: isDroppingItem ? droppingPosition : undefined,
            resizeHandles: resizeHandlesOptions,
            resizeHandle: resizeHandle
        }, child);
    }
    render() /*: React.Element<"div">*/ {
        const { className: className, style: style, isDroppable: isDroppable, innerRef: innerRef } = this.props;
        const mergedClassName = (0, $2244b4f5a813178a$var$_clsx.default)($2244b4f5a813178a$var$layoutClassName, className);
        const mergedStyle = {
            height: this.containerHeight(),
            ...style
        };
        return /*#__PURE__*/ $2244b4f5a813178a$var$React.createElement("div", {
            ref: innerRef,
            className: mergedClassName,
            style: mergedStyle,
            onDrop: isDroppable ? this.onDrop : $85pJf.noop,
            onDragLeave: isDroppable ? this.onDragLeave : $85pJf.noop,
            onDragEnter: isDroppable ? this.onDragEnter : $85pJf.noop,
            onDragOver: isDroppable ? this.onDragOver : $85pJf.noop
        }, $2244b4f5a813178a$var$React.Children.map(this.props.children, (child)=>this.processGridItem(child)), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
    }
}
module.exports.default = $2244b4f5a813178a$var$ReactGridLayout;
// TODO publish internal ReactClass displayName transform
$2244b4f5a813178a$var$_defineProperty($2244b4f5a813178a$var$ReactGridLayout, "displayName", "ReactGridLayout");
// Refactored to another module to make way for preval
$2244b4f5a813178a$var$_defineProperty($2244b4f5a813178a$var$ReactGridLayout, "propTypes", $2244b4f5a813178a$var$_ReactGridLayoutPropTypes.default);
$2244b4f5a813178a$var$_defineProperty($2244b4f5a813178a$var$ReactGridLayout, "defaultProps", {
    autoSize: true,
    cols: 12,
    className: "",
    style: {},
    draggableHandle: "",
    draggableCancel: "",
    containerPadding: null,
    rowHeight: 150,
    maxRows: Infinity,
    // infinite vertical growth
    layout: [],
    margin: [
        10,
        10
    ],
    isBounded: false,
    isDraggable: true,
    isResizable: true,
    allowOverlap: false,
    isDroppable: false,
    useCSSTransforms: true,
    transformScale: 1,
    verticalCompact: true,
    compactType: "vertical",
    preventCollision: false,
    droppingItem: {
        i: "__dropping-elem__",
        h: 1,
        w: 1
    },
    resizeHandles: [
        "se"
    ],
    onLayoutChange: $85pJf.noop,
    onDragStart: $85pJf.noop,
    onDrag: $85pJf.noop,
    onDragStop: $85pJf.noop,
    onResizeStart: $85pJf.noop,
    onResize: $85pJf.noop,
    onResizeStop: $85pJf.noop,
    onDrop: $85pJf.noop,
    onDropDragOver: $85pJf.noop
});

});
parcelRegister("iykXw", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    /**
   * Default equality comparator pass-through, used as the standard `isEqual` creator for
   * use inside the built comparator.
   */ function createDefaultIsNestedEqual(comparator) {
        return function isEqual(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, meta) {
            return comparator(a, b, meta);
        };
    }
    /**
   * Wrap the provided `areItemsEqual` method to manage the circular cache, allowing
   * for circular references to be safely included in the comparison without creating
   * stack overflows.
   */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, isEqual, cache) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, isEqual, cache);
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, isEqual, cache);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
   * Targeted shallow merge of two objects.
   *
   * @NOTE
   * This exists as a tinier compiled version of the `__assign` helper that
   * `tsc` injects in case of `Object.assign` not being present.
   */ function merge(a, b) {
        var merged = {};
        for(var key in a)merged[key] = a[key];
        for(var key in b)merged[key] = b[key];
        return merged;
    }
    /**
   * Whether the value is a plain object.
   *
   * @NOTE
   * This is a same-realm compariosn only.
   */ function isPlainObject(value) {
        return value.constructor === Object || value.constructor == null;
    }
    /**
   * When the value is `Promise`-like, aka "then-able".
   */ function isPromiseLike(value) {
        return typeof value.then === 'function';
    }
    /**
   * Whether the values passed are strictly equal or both NaN.
   */ function sameValueZeroEqual(a, b) {
        return a === b || a !== a && b !== b;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var REG_EXP_TAG = '[object RegExp]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var toString = Object.prototype.toString;
    function createComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, createIsNestedEqual = _a.createIsNestedEqual;
        var isEqual = createIsNestedEqual(comparator);
        /**
       * compare the value of the two objects and return true if they are equivalent in values
       */ function comparator(a, b, meta) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid the `toString.call()` cost unless necessary.
            if (isPlainObject(a) && isPlainObject(b)) return areObjectsEqual(a, b, isEqual, meta);
            // `isArray()` works on subclasses and is cross-realm, so we can again avoid
            // the `toString.call()` cost unless necessary by just checking if either
            // and then both are arrays.
            var aArray = Array.isArray(a);
            var bArray = Array.isArray(b);
            if (aArray || bArray) return aArray === bArray && areArraysEqual(a, b, isEqual, meta);
            // Since this is a custom object, use the classic `toString.call()` to get its
            // type. This is reasonably performant in modern environments like v8 and
            // SpiderMonkey, and allows for cross-realm comparison when other checks like
            // `instanceof` do not.
            var aTag = toString.call(a);
            if (aTag !== toString.call(b)) return false;
            if (aTag === DATE_TAG) // `getTime()` showed better results compared to alternatives like `valueOf()`
            // or the unary `+` operator.
            return areDatesEqual(a, b, isEqual, meta);
            if (aTag === REG_EXP_TAG) return areRegExpsEqual(a, b, isEqual, meta);
            if (aTag === MAP_TAG) return areMapsEqual(a, b, isEqual, meta);
            if (aTag === SET_TAG) return areSetsEqual(a, b, isEqual, meta);
            // If a simple object tag, then we can prioritize a simple object comparison because
            // it is likely a custom class. If an arguments tag, it should be treated as a standard
            // object.
            if (aTag === OBJECT_TAG || aTag === ARGUMENTS_TAG) // The exception for value comparison is `Promise`-like contracts. These should be
            // treated the same as standard `Promise` objects, which means strict equality.
            return isPromiseLike(a) || isPromiseLike(b) ? false : areObjectsEqual(a, b, isEqual, meta);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (aTag === BOOLEAN_TAG || aTag === NUMBER_TAG || aTag === STRING_TAG) return sameValueZeroEqual(a.valueOf(), b.valueOf());
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        }
        return comparator;
    }
    /**
   * Whether the arrays are equal in value.
   */ function areArraysEqual(a, b, isEqual, meta) {
        var index = a.length;
        if (b.length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isEqual(a[index], b[index], index, index, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the arrays are equal in value, including circular references.
   */ var areArraysEqualCircular = createIsCircular(areArraysEqual);
    /**
   * Whether the dates passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides.
   */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
   * Whether the `Map`s are equal in value.
   */ function areMapsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        var indexA = 0;
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndexB = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndexB] && (hasMatch = isEqual(aKey, bKey, indexA, matchIndexB, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndexB] = true;
                matchIndexB++;
            });
            indexA++;
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Map`s are equal in value, including circular references.
   */ var areMapsEqualCircular = createIsCircular(areMapsEqual);
    var OWNER = '_owner';
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Whether the objects are equal in value.
   */ function areObjectsEqual(a, b, isEqual, meta) {
        var keysA = Object.keys(a);
        var index = keysA.length;
        if (Object.keys(b).length !== index) return false;
        var key;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            key = keysA[index];
            if (key === OWNER) {
                var reactElementA = !!a.$$typeof;
                var reactElementB = !!b.$$typeof;
                if ((reactElementA || reactElementB) && reactElementA !== reactElementB) return false;
            }
            if (!hasOwnProperty.call(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the objects are equal in value, including circular references.
   */ var areObjectsEqualCircular = createIsCircular(areObjectsEqual);
    /**
   * Whether the regexps passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides. An example of this would be supporting a
   * pre-ES2015 environment where the `flags` property is not available.
   */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
   * Whether the `Set`s are equal in value.
   */ function areSetsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndex = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndex] = true;
                matchIndex++;
            });
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Set`s are equal in value, including circular references.
   */ var areSetsEqualCircular = createIsCircular(areSetsEqual);
    var DEFAULT_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqual,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqual,
        areObjectsEqual: areObjectsEqual,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqual,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var DEFAULT_CIRCULAR_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqualCircular,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqualCircular,
        areObjectsEqual: areObjectsEqualCircular,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqualCircular,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var isDeepEqual = createComparator(DEFAULT_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value.
   */ function deepEqual(a, b) {
        return isDeepEqual(a, b, undefined);
    }
    var isShallowEqual = createComparator(merge(DEFAULT_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value.
   */ function shallowEqual(a, b) {
        return isShallowEqual(a, b, undefined);
    }
    var isCircularDeepEqual = createComparator(DEFAULT_CIRCULAR_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value, including circular references.
   */ function circularDeepEqual(a, b) {
        return isCircularDeepEqual(a, b, new WeakMap());
    }
    var isCircularShallowEqual = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value, including circular references.
   */ function circularShallowEqual(a, b) {
        return isCircularShallowEqual(a, b, new WeakMap());
    }
    /**
   * Create a custom equality comparison method.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `RegExp.prototype.flags` out of the box.
   */ function createCustomEqual(getComparatorOptions) {
        return createComparator(merge(DEFAULT_CONFIG, getComparatorOptions(DEFAULT_CONFIG)));
    }
    /**
   * Create a custom equality comparison method that handles circular references. This is very
   * similar to `createCustomEqual`, with the only difference being that `meta` expects to be
   * populated with a `WeakMap`-like contract.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `WeakMap` out of the box.
   */ function createCustomCircularEqual(getComparatorOptions) {
        var comparator = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, getComparatorOptions(DEFAULT_CIRCULAR_CONFIG)));
        return function(a, b, meta) {
            if (meta === void 0) meta = new WeakMap();
            return comparator(a, b, meta);
        };
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomCircularEqual = createCustomCircularEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("cfW2W", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $cb5bd1e3bc9842c3$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $cb5bd1e3bc9842c3$export$2e2bcd8739ae039);
function $cb5bd1e3bc9842c3$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $cb5bd1e3bc9842c3$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $cb5bd1e3bc9842c3$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $cb5bd1e3bc9842c3$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $cb5bd1e3bc9842c3$export$2e2bcd8739ae039 = $cb5bd1e3bc9842c3$export$4f5d2d50c9deca37;

});

parcelRegister("85pJf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bottom = $5e32bf91aa196f43$var$bottom;
module.exports.childrenEqual = $5e32bf91aa196f43$var$childrenEqual;
module.exports.cloneLayout = $5e32bf91aa196f43$var$cloneLayout;
module.exports.cloneLayoutItem = $5e32bf91aa196f43$var$cloneLayoutItem;
module.exports.collides = $5e32bf91aa196f43$var$collides;
module.exports.compact = $5e32bf91aa196f43$var$compact;
module.exports.compactItem = $5e32bf91aa196f43$var$compactItem;
module.exports.compactType = $5e32bf91aa196f43$var$compactType;
module.exports.correctBounds = $5e32bf91aa196f43$var$correctBounds;
module.exports.fastPositionEqual = $5e32bf91aa196f43$var$fastPositionEqual;
module.exports.fastRGLPropsEqual = void 0;
module.exports.getAllCollisions = $5e32bf91aa196f43$var$getAllCollisions;
module.exports.getFirstCollision = $5e32bf91aa196f43$var$getFirstCollision;
module.exports.getLayoutItem = $5e32bf91aa196f43$var$getLayoutItem;
module.exports.getStatics = $5e32bf91aa196f43$var$getStatics;
module.exports.modifyLayout = $5e32bf91aa196f43$var$modifyLayout;
module.exports.moveElement = $5e32bf91aa196f43$var$moveElement;
module.exports.moveElementAwayFromCollision = $5e32bf91aa196f43$var$moveElementAwayFromCollision;
module.exports.noop = void 0;
module.exports.perc = $5e32bf91aa196f43$var$perc;
module.exports.resizeItemInDirection = $5e32bf91aa196f43$var$resizeItemInDirection;
module.exports.setTopLeft = $5e32bf91aa196f43$var$setTopLeft;
module.exports.setTransform = $5e32bf91aa196f43$var$setTransform;
module.exports.sortLayoutItems = $5e32bf91aa196f43$var$sortLayoutItems;
module.exports.sortLayoutItemsByColRow = $5e32bf91aa196f43$var$sortLayoutItemsByColRow;
module.exports.sortLayoutItemsByRowCol = $5e32bf91aa196f43$var$sortLayoutItemsByRowCol;
module.exports.synchronizeLayoutWithChildren = $5e32bf91aa196f43$var$synchronizeLayoutWithChildren;
module.exports.validateLayout = $5e32bf91aa196f43$var$validateLayout;
module.exports.withLayoutItem = $5e32bf91aa196f43$var$withLayoutItem;

var $iykXw = parcelRequire("iykXw");

var $5e32bf91aa196f43$var$_react = $5e32bf91aa196f43$var$_interopRequireDefault((parcelRequire("7hzE7")));
function $5e32bf91aa196f43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: export type ResizeHandleAxis =
  | "s"
  | "w"
  | "e"
  | "n"
  | "sw"
  | "nw"
  | "se"
  | "ne";*/ /*:: export type LayoutItem = {
  w: number,
  h: number,
  x: number,
  y: number,
  i: string,
  minW?: number,
  minH?: number,
  maxW?: number,
  maxH?: number,
  moved?: boolean,
  static?: boolean,
  isDraggable?: ?boolean,
  isResizable?: ?boolean,
  resizeHandles?: Array<ResizeHandleAxis>,
  isBounded?: ?boolean
};*/ /*:: export type Layout = $ReadOnlyArray<LayoutItem>;*/ /*:: export type Position = {
  left: number,
  top: number,
  width: number,
  height: number
};*/ /*:: export type ReactDraggableCallbackData = {
  node: HTMLElement,
  x?: number,
  y?: number,
  deltaX: number,
  deltaY: number,
  lastX?: number,
  lastY?: number
};*/ /*:: export type PartialPosition = { left: number, top: number };*/ /*:: export type DroppingPosition = { left: number, top: number, e: Event };*/ /*:: export type Size = { width: number, height: number };*/ /*:: export type GridDragEvent = {
  e: Event,
  node: HTMLElement,
  newPosition: PartialPosition
};*/ /*:: export type GridResizeEvent = {
  e: Event,
  node: HTMLElement,
  size: Size,
  handle: string
};*/ /*:: export type DragOverEvent = MouseEvent & {
  nativeEvent: {
    layerX: number,
    layerY: number,
    ...Event
  }
};*/ /*:: export type Pick<FromType, Properties: { [string]: 0 }> = $Exact<
  $ObjMapi<Properties, <K, V>(k: K, v: V) => $ElementType<FromType, K>>
>;*/ // Helpful port from TS
/*:: type REl = ReactElement<any>;*/ /*:: export type ReactChildren = ReactChildrenArray<REl>;*/ /*:: export type EventCallback = (
  Layout,
  oldItem: ?LayoutItem,
  newItem: ?LayoutItem,
  placeholder: ?LayoutItem,
  Event,
  ?HTMLElement
) => void;*/ // All callbacks are of the signature (layout, oldItem, newItem, placeholder, e).
/*:: export type CompactType = ?("horizontal" | "vertical");*/ const $5e32bf91aa196f43$var$isProduction = true;
const $5e32bf91aa196f43$var$DEBUG = false;
/**
 * Return the bottom coordinate of the layout.
 *
 * @param  {Array} layout Layout array.
 * @return {Number}       Bottom coordinate.
 */ function $5e32bf91aa196f43$var$bottom(layout /*: Layout*/ ) /*: number*/ {
    let max = 0, bottomY;
    for(let i = 0, len = layout.length; i < len; i++){
        bottomY = layout[i].y + layout[i].h;
        if (bottomY > max) max = bottomY;
    }
    return max;
}
function $5e32bf91aa196f43$var$cloneLayout(layout /*: Layout*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)newLayout[i] = $5e32bf91aa196f43$var$cloneLayoutItem(layout[i]);
    return newLayout;
}
// Modify a layoutItem inside a layout. Returns a new Layout,
// does not mutate. Carries over all other LayoutItems unmodified.
function $5e32bf91aa196f43$var$modifyLayout(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)if (layoutItem.i === layout[i].i) newLayout[i] = layoutItem;
    else newLayout[i] = layout[i];
    return newLayout;
}
// Function to be called to modify a layout item.
// Does defensive clones to ensure the layout is not modified.
function $5e32bf91aa196f43$var$withLayoutItem(layout /*: Layout*/ , itemKey /*: string*/ , cb /*: LayoutItem => LayoutItem*/ ) /*: [Layout, ?LayoutItem]*/ {
    let item = $5e32bf91aa196f43$var$getLayoutItem(layout, itemKey);
    if (!item) return [
        layout,
        null
    ];
    item = cb($5e32bf91aa196f43$var$cloneLayoutItem(item)); // defensive clone then modify
    // FIXME could do this faster if we already knew the index
    layout = $5e32bf91aa196f43$var$modifyLayout(layout, item);
    return [
        layout,
        item
    ];
}
// Fast path to cloning, since this is monomorphic
function $5e32bf91aa196f43$var$cloneLayoutItem(layoutItem /*: LayoutItem*/ ) /*: LayoutItem*/ {
    return {
        w: layoutItem.w,
        h: layoutItem.h,
        x: layoutItem.x,
        y: layoutItem.y,
        i: layoutItem.i,
        minW: layoutItem.minW,
        maxW: layoutItem.maxW,
        minH: layoutItem.minH,
        maxH: layoutItem.maxH,
        moved: Boolean(layoutItem.moved),
        static: Boolean(layoutItem.static),
        // These can be null/undefined
        isDraggable: layoutItem.isDraggable,
        isResizable: layoutItem.isResizable,
        resizeHandles: layoutItem.resizeHandles,
        isBounded: layoutItem.isBounded
    };
}
/**
 * Comparing React `children` is a bit difficult. This is a good way to compare them.
 * This will catch differences in keys, order, and length.
 */ function $5e32bf91aa196f43$var$childrenEqual(a /*: ReactChildren*/ , b /*: ReactChildren*/ ) /*: boolean*/ {
    return (0, $iykXw.deepEqual)($5e32bf91aa196f43$var$_react.default.Children.map(a, (c)=>c?.key), $5e32bf91aa196f43$var$_react.default.Children.map(b, (c)=>c?.key)) && (0, $iykXw.deepEqual)($5e32bf91aa196f43$var$_react.default.Children.map(a, (c)=>c?.props["data-grid"]), $5e32bf91aa196f43$var$_react.default.Children.map(b, (c)=>c?.props["data-grid"]));
}

/**
 * See `fastRGLPropsEqual.js`.
 * We want this to run as fast as possible - it is called often - and to be
 * resilient to new props that we add. So rather than call lodash.isEqual,
 * which isn't suited to comparing props very well, we use this specialized
 * function in conjunction with preval to generate the fastest possible comparison
 * function, tuned for exactly our props.
 */ /*:: type FastRGLPropsEqual = (Object, Object, Function) => boolean;*/ const $5e32bf91aa196f43$var$fastRGLPropsEqual /*: FastRGLPropsEqual*/  = module.exports.fastRGLPropsEqual = (parcelRequire("6T6Yr"));
// Like the above, but a lot simpler.
function $5e32bf91aa196f43$var$fastPositionEqual(a /*: Position*/ , b /*: Position*/ ) /*: boolean*/ {
    return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
/**
 * Given two layoutitems, check if they collide.
 */ function $5e32bf91aa196f43$var$collides(l1 /*: LayoutItem*/ , l2 /*: LayoutItem*/ ) /*: boolean*/ {
    if (l1.i === l2.i) return false; // same element
    if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
    if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
    if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
    if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
    return true; // boxes overlap
}
/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 *
 * Does not modify layout items (clones). Creates a new layout array.
 *
 * @param  {Array} layout Layout.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @param  {Boolean} allowOverlap When `true`, allows overlapping grid items.
 * @return {Array}       Compacted Layout.
 */ function $5e32bf91aa196f43$var$compact(layout /*: Layout*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // Statics go in the compareWith array right away so items flow around them.
    const compareWith = $5e32bf91aa196f43$var$getStatics(layout);
    // We go through the items by row and column.
    const sorted = $5e32bf91aa196f43$var$sortLayoutItems(layout, compactType);
    // Holding for new items.
    const out = Array(layout.length);
    for(let i = 0, len = sorted.length; i < len; i++){
        let l = $5e32bf91aa196f43$var$cloneLayoutItem(sorted[i]);
        // Don't move static elements
        if (!l.static) {
            l = $5e32bf91aa196f43$var$compactItem(compareWith, l, compactType, cols, sorted, allowOverlap);
            // Add to comparison array. We only collide with items before this one.
            // Statics are already in this array.
            compareWith.push(l);
        }
        // Add to output array to make sure they still come out in the right order.
        out[layout.indexOf(sorted[i])] = l;
        // Clear moved flag, if it exists.
        l.moved = false;
    }
    return out;
}
const $5e32bf91aa196f43$var$heightWidth = {
    x: "w",
    y: "h"
};
/**
 * Before moving item down, it will check if the movement will cause collisions and move those items down before.
 */ function $5e32bf91aa196f43$var$resolveCompactionCollision(layout /*: Layout*/ , item /*: LayoutItem*/ , moveToCoord /*: number*/ , axis /*: "x" | "y"*/ ) {
    const sizeProp = $5e32bf91aa196f43$var$heightWidth[axis];
    item[axis] += 1;
    const itemIndex = layout.map((layoutItem)=>{
        return layoutItem.i;
    }).indexOf(item.i);
    // Go through each item we collide with.
    for(let i = itemIndex + 1; i < layout.length; i++){
        const otherItem = layout[i];
        // Ignore static items
        if (otherItem.static) continue;
        // Optimization: we can break early if we know we're past this el
        // We can do this b/c it's a sorted layout
        if (otherItem.y > item.y + item.h) break;
        if ($5e32bf91aa196f43$var$collides(item, otherItem)) $5e32bf91aa196f43$var$resolveCompactionCollision(layout, otherItem, moveToCoord + item[sizeProp], axis);
    }
    item[axis] = moveToCoord;
}
/**
 * Compact an item in the layout.
 *
 * Modifies item.
 *
 */ function $5e32bf91aa196f43$var$compactItem(compareWith /*: Layout*/ , l /*: LayoutItem*/ , compactType /*: CompactType*/ , cols /*: number*/ , fullLayout /*: Layout*/ , allowOverlap /*: ?boolean*/ ) /*: LayoutItem*/ {
    const compactV = compactType === "vertical";
    const compactH = compactType === "horizontal";
    if (compactV) {
        // Bottom 'y' possible is the bottom of the layout.
        // This allows you to do nice stuff like specify {y: Infinity}
        // This is here because the layout must be sorted in order to get the correct bottom `y`.
        l.y = Math.min($5e32bf91aa196f43$var$bottom(compareWith), l.y);
        // Move the element up as far as it can go without colliding.
        while(l.y > 0 && !$5e32bf91aa196f43$var$getFirstCollision(compareWith, l))l.y--;
    } else if (compactH) // Move the element left as far as it can go without colliding.
    while(l.x > 0 && !$5e32bf91aa196f43$var$getFirstCollision(compareWith, l))l.x--;
    // Move it down, and keep moving it down if it's colliding.
    let collides;
    // Checking the compactType null value to avoid breaking the layout when overlapping is allowed.
    while((collides = $5e32bf91aa196f43$var$getFirstCollision(compareWith, l)) && !(compactType === null && allowOverlap)){
        if (compactH) $5e32bf91aa196f43$var$resolveCompactionCollision(fullLayout, l, collides.x + collides.w, "x");
        else $5e32bf91aa196f43$var$resolveCompactionCollision(fullLayout, l, collides.y + collides.h, "y");
        // Since we can't grow without bounds horizontally, if we've overflown, let's move it down and try again.
        if (compactH && l.x + l.w > cols) {
            l.x = cols - l.w;
            l.y++;
            // ALso move element as left as we can
            while(l.x > 0 && !$5e32bf91aa196f43$var$getFirstCollision(compareWith, l))l.x--;
        }
    }
    // Ensure that there are no negative positions
    l.y = Math.max(l.y, 0);
    l.x = Math.max(l.x, 0);
    return l;
}
/**
 * Given a layout, make sure all elements fit within its bounds.
 *
 * Modifies layout items.
 *
 * @param  {Array} layout Layout array.
 * @param  {Number} bounds Number of columns.
 */ function $5e32bf91aa196f43$var$correctBounds(layout /*: Layout*/ , bounds /*: { cols: number }*/ ) /*: Layout*/ {
    const collidesWith = $5e32bf91aa196f43$var$getStatics(layout);
    for(let i = 0, len = layout.length; i < len; i++){
        const l = layout[i];
        // Overflows right
        if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
        // Overflows left
        if (l.x < 0) {
            l.x = 0;
            l.w = bounds.cols;
        }
        if (!l.static) collidesWith.push(l);
        else // If this is static and collides with other statics, we must move it down.
        // We have to do something nicer than just letting them overlap.
        while($5e32bf91aa196f43$var$getFirstCollision(collidesWith, l))l.y++;
    }
    return layout;
}
/**
 * Get a layout item by ID. Used so we can override later on if necessary.
 *
 * @param  {Array}  layout Layout array.
 * @param  {String} id     ID
 * @return {LayoutItem}    Item at ID.
 */ function $5e32bf91aa196f43$var$getLayoutItem(layout /*: Layout*/ , id /*: string*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if (layout[i].i === id) return layout[i];
    }
}
/**
 * Returns the first item this layout collides with.
 * It doesn't appear to matter which order we approach this from, although
 * perhaps that is the wrong thing to do.
 *
 * @param  {Object} layoutItem Layout item.
 * @return {Object|undefined}  A colliding layout item, or undefined.
 */ function $5e32bf91aa196f43$var$getFirstCollision(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if ($5e32bf91aa196f43$var$collides(layout[i], layoutItem)) return layout[i];
    }
}
function $5e32bf91aa196f43$var$getAllCollisions(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>$5e32bf91aa196f43$var$collides(l, layoutItem));
}
/**
 * Get all static elements.
 * @param  {Array} layout Array of layout objects.
 * @return {Array}        Array of static layout items..
 */ function $5e32bf91aa196f43$var$getStatics(layout /*: Layout*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>l.static);
}
/**
 * Move an element. Responsible for doing cascading movements of other elements.
 *
 * Modifies layout items.
 *
 * @param  {Array}      layout            Full layout to modify.
 * @param  {LayoutItem} l                 element to move.
 * @param  {Number}     [x]               X position in grid units.
 * @param  {Number}     [y]               Y position in grid units.
 */ function $5e32bf91aa196f43$var$moveElement(layout /*: Layout*/ , l /*: LayoutItem*/ , x /*: ?number*/ , y /*: ?number*/ , isUserAction /*: ?boolean*/ , preventCollision /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // If this is static and not explicitly enabled as draggable,
    // no move is possible, so we can short-circuit this immediately.
    if (l.static && l.isDraggable !== true) return layout;
    // Short-circuit if nothing to do.
    if (l.y === y && l.x === x) return layout;
    $5e32bf91aa196f43$var$log(`Moving element ${l.i} to [${String(x)},${String(y)}] from [${l.x},${l.y}]`);
    const oldX = l.x;
    const oldY = l.y;
    // This is quite a bit faster than extending the object
    if (typeof x === "number") l.x = x;
    if (typeof y === "number") l.y = y;
    l.moved = true;
    // If this collides with anything, move it.
    // When doing this comparison, we have to sort the items we compare with
    // to ensure, in the case of multiple collisions, that we're getting the
    // nearest collision.
    let sorted = $5e32bf91aa196f43$var$sortLayoutItems(layout, compactType);
    const movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false;
    // $FlowIgnore acceptable modification of read-only array as it was recently cloned
    if (movingUp) sorted = sorted.reverse();
    const collisions = $5e32bf91aa196f43$var$getAllCollisions(sorted, l);
    const hasCollisions = collisions.length > 0;
    // We may have collisions. We can short-circuit if we've turned off collisions or
    // allowed overlap.
    if (hasCollisions && allowOverlap) // Easy, we don't need to resolve collisions. But we *did* change the layout,
    // so clone it on the way out.
    return $5e32bf91aa196f43$var$cloneLayout(layout);
    else if (hasCollisions && preventCollision) {
        // If we are preventing collision but not allowing overlap, we need to
        // revert the position of this element so it goes to where it came from, rather
        // than the user's desired location.
        $5e32bf91aa196f43$var$log(`Collision prevented on ${l.i}, reverting.`);
        l.x = oldX;
        l.y = oldY;
        l.moved = false;
        return layout; // did not change so don't clone
    }
    // Move each item that collides away from this element.
    for(let i = 0, len = collisions.length; i < len; i++){
        const collision = collisions[i];
        $5e32bf91aa196f43$var$log(`Resolving collision between ${l.i} at [${l.x},${l.y}] and ${collision.i} at [${collision.x},${collision.y}]`);
        // Short circuit so we can't infinite loop
        if (collision.moved) continue;
        // Don't move static items - we have to move *this* element away
        if (collision.static) layout = $5e32bf91aa196f43$var$moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType, cols);
        else layout = $5e32bf91aa196f43$var$moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType, cols);
    }
    return layout;
}
/**
 * This is where the magic needs to happen - given a collision, move an element away from the collision.
 * We attempt to move it up if there's room, otherwise it goes below.
 *
 * @param  {Array} layout            Full layout to modify.
 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
 * @param  {LayoutItem} itemToMove   Layout item we're moving.
 */ function $5e32bf91aa196f43$var$moveElementAwayFromCollision(layout /*: Layout*/ , collidesWith /*: LayoutItem*/ , itemToMove /*: LayoutItem*/ , isUserAction /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ ) /*: Layout*/ {
    const compactH = compactType === "horizontal";
    // Compact vertically if not set to horizontal
    const compactV = compactType === "vertical";
    const preventCollision = collidesWith.static; // we're already colliding (not for static items)
    // If there is enough space above the collision to put this element, move it there.
    // We only do this on the main collision as this can get funky in cascades and cause
    // unwanted swapping behavior.
    if (isUserAction) {
        // Reset isUserAction flag because we're not in the main collision anymore.
        isUserAction = false;
        // Make a mock item so we don't modify the item here, only modify in moveElement.
        const fakeItem /*: LayoutItem*/  = {
            x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
            y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
            w: itemToMove.w,
            h: itemToMove.h,
            i: "-1"
        };
        const firstCollision = $5e32bf91aa196f43$var$getFirstCollision(layout, fakeItem);
        const collisionNorth = firstCollision && firstCollision.y + firstCollision.h > collidesWith.y;
        const collisionWest = firstCollision && collidesWith.x + collidesWith.w > firstCollision.x;
        // No collision? If so, we can go up there; otherwise, we'll end up moving down as normal
        if (!firstCollision) {
            $5e32bf91aa196f43$var$log(`Doing reverse collision on ${itemToMove.i} up to [${fakeItem.x},${fakeItem.y}].`);
            return $5e32bf91aa196f43$var$moveElement(layout, itemToMove, compactH ? fakeItem.x : undefined, compactV ? fakeItem.y : undefined, isUserAction, preventCollision, compactType, cols);
        } else if (collisionNorth && compactV) return $5e32bf91aa196f43$var$moveElement(layout, itemToMove, undefined, collidesWith.y + 1, isUserAction, preventCollision, compactType, cols);
        else if (collisionNorth && compactType == null) {
            collidesWith.y = itemToMove.y;
            itemToMove.y = itemToMove.y + itemToMove.h;
            return layout;
        } else if (collisionWest && compactH) return $5e32bf91aa196f43$var$moveElement(layout, collidesWith, itemToMove.x, undefined, isUserAction, preventCollision, compactType, cols);
    }
    const newX = compactH ? itemToMove.x + 1 : undefined;
    const newY = compactV ? itemToMove.y + 1 : undefined;
    if (newX == null && newY == null) return layout;
    return $5e32bf91aa196f43$var$moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : undefined, compactV ? itemToMove.y + 1 : undefined, isUserAction, preventCollision, compactType, cols);
}
/**
 * Helper to convert a number to a percentage string.
 *
 * @param  {Number} num Any number
 * @return {String}     That number as a percentage.
 */ function $5e32bf91aa196f43$var$perc(num /*: number*/ ) /*: string*/ {
    return num * 100 + "%";
}
/**
 * Helper functions to constrain dimensions of a GridItem
 */ const $5e32bf91aa196f43$var$constrainWidth = (left /*: number*/ , currentWidth /*: number*/ , newWidth /*: number*/ , containerWidth /*: number*/ )=>{
    return left + newWidth > containerWidth ? currentWidth : newWidth;
};
const $5e32bf91aa196f43$var$constrainHeight = (top /*: number*/ , currentHeight /*: number*/ , newHeight /*: number*/ )=>{
    return top < 0 ? currentHeight : newHeight;
};
const $5e32bf91aa196f43$var$constrainLeft = (left /*: number*/ )=>Math.max(0, left);
const $5e32bf91aa196f43$var$constrainTop = (top /*: number*/ )=>Math.max(0, top);
const $5e32bf91aa196f43$var$resizeNorth = (currentSize, _ref, _containerWidth)=>{
    let { left: left, height: height, width: width } = _ref;
    const top = currentSize.top - (height - currentSize.height);
    return {
        left: left,
        width: width,
        height: $5e32bf91aa196f43$var$constrainHeight(top, currentSize.height, height),
        top: $5e32bf91aa196f43$var$constrainTop(top)
    };
};
const $5e32bf91aa196f43$var$resizeEast = (currentSize, _ref2, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref2;
    return {
        top: top,
        height: height,
        width: $5e32bf91aa196f43$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        left: $5e32bf91aa196f43$var$constrainLeft(left)
    };
};
const $5e32bf91aa196f43$var$resizeWest = (currentSize, _ref3, containerWidth)=>{
    let { top: top, height: height, width: width } = _ref3;
    const left = currentSize.left - (width - currentSize.width);
    return {
        height: height,
        width: left < 0 ? currentSize.width : $5e32bf91aa196f43$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        top: $5e32bf91aa196f43$var$constrainTop(top),
        left: $5e32bf91aa196f43$var$constrainLeft(left)
    };
};
const $5e32bf91aa196f43$var$resizeSouth = (currentSize, _ref4, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref4;
    return {
        width: width,
        left: left,
        height: $5e32bf91aa196f43$var$constrainHeight(top, currentSize.height, height),
        top: $5e32bf91aa196f43$var$constrainTop(top)
    };
};
const $5e32bf91aa196f43$var$resizeNorthEast = function() {
    return $5e32bf91aa196f43$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $5e32bf91aa196f43$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $5e32bf91aa196f43$var$resizeNorthWest = function() {
    return $5e32bf91aa196f43$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $5e32bf91aa196f43$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $5e32bf91aa196f43$var$resizeSouthEast = function() {
    return $5e32bf91aa196f43$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $5e32bf91aa196f43$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $5e32bf91aa196f43$var$resizeSouthWest = function() {
    return $5e32bf91aa196f43$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $5e32bf91aa196f43$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $5e32bf91aa196f43$var$ordinalResizeHandlerMap = {
    n: $5e32bf91aa196f43$var$resizeNorth,
    ne: $5e32bf91aa196f43$var$resizeNorthEast,
    e: $5e32bf91aa196f43$var$resizeEast,
    se: $5e32bf91aa196f43$var$resizeSouthEast,
    s: $5e32bf91aa196f43$var$resizeSouth,
    sw: $5e32bf91aa196f43$var$resizeSouthWest,
    w: $5e32bf91aa196f43$var$resizeWest,
    nw: $5e32bf91aa196f43$var$resizeNorthWest
};
/**
 * Helper for clamping width and position when resizing an item.
 */ function $5e32bf91aa196f43$var$resizeItemInDirection(direction /*: ResizeHandleAxis*/ , currentSize /*: Position*/ , newSize /*: Position*/ , containerWidth /*: number*/ ) /*: Position*/ {
    const ordinalHandler = $5e32bf91aa196f43$var$ordinalResizeHandlerMap[direction];
    // Shouldn't be possible given types; that said, don't fail hard
    if (!ordinalHandler) return newSize;
    return ordinalHandler(currentSize, {
        ...currentSize,
        ...newSize
    }, containerWidth);
}
function $5e32bf91aa196f43$var$setTransform(_ref5 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref5 /*: Position*/ ;
    // Replace unitless items with px
    const translate = `translate(${left}px,${top}px)`;
    return {
        transform: translate,
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
function $5e32bf91aa196f43$var$setTopLeft(_ref6 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref6 /*: Position*/ ;
    return {
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */ function $5e32bf91aa196f43$var$sortLayoutItems(layout /*: Layout*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    if (compactType === "horizontal") return $5e32bf91aa196f43$var$sortLayoutItemsByColRow(layout);
    if (compactType === "vertical") return $5e32bf91aa196f43$var$sortLayoutItemsByRowCol(layout);
    else return layout;
}
/**
 * Sort layout items by row ascending and column ascending.
 *
 * Does not modify Layout.
 */ function $5e32bf91aa196f43$var$sortLayoutItemsByRowCol(layout /*: Layout*/ ) /*: Layout*/ {
    // Slice to clone array as sort modifies
    return layout.slice(0).sort(function(a, b) {
        if (a.y > b.y || a.y === b.y && a.x > b.x) return 1;
        else if (a.y === b.y && a.x === b.x) // Without this, we can get different sort results in IE vs. Chrome/FF
        return 0;
        return -1;
    });
}
/**
 * Sort layout items by column ascending then row ascending.
 *
 * Does not modify Layout.
 */ function $5e32bf91aa196f43$var$sortLayoutItemsByColRow(layout /*: Layout*/ ) /*: Layout*/ {
    return layout.slice(0).sort(function(a, b) {
        if (a.x > b.x || a.x === b.x && a.y > b.y) return 1;
        return -1;
    });
}
/**
 * Generate a layout using the initialLayout and children as a template.
 * Missing entries will be added, extraneous ones will be truncated.
 *
 * Does not modify initialLayout.
 *
 * @param  {Array}  initialLayout Layout passed in through props.
 * @param  {String} breakpoint    Current responsive breakpoint.
 * @param  {?String} compact      Compaction option.
 * @return {Array}                Working layout.
 */ function $5e32bf91aa196f43$var$synchronizeLayoutWithChildren(initialLayout /*: Layout*/ , children /*: ReactChildren*/ , cols /*: number*/ , compactType /*: CompactType*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    initialLayout = initialLayout || [];
    // Generate one layout item per child.
    const layout /*: LayoutItem[]*/  = [];
    $5e32bf91aa196f43$var$_react.default.Children.forEach(children, (child /*: ReactElement<any>*/ )=>{
        // Child may not exist
        if (child?.key == null) return;
        const exists = $5e32bf91aa196f43$var$getLayoutItem(initialLayout, String(child.key));
        const g = child.props["data-grid"];
        // Don't overwrite the layout item if it's already in the initial layout.
        // If it has a `data-grid` property, prefer that over what's in the layout.
        if (exists && g == null) layout.push($5e32bf91aa196f43$var$cloneLayoutItem(exists));
        else // Hey, this item has a data-grid property, use it.
        if (g) {
            if (!$5e32bf91aa196f43$var$isProduction) $5e32bf91aa196f43$var$validateLayout([
                g
            ], "ReactGridLayout.children");
            // FIXME clone not really necessary here
            layout.push($5e32bf91aa196f43$var$cloneLayoutItem({
                ...g,
                i: child.key
            }));
        } else // Nothing provided: ensure this is added to the bottom
        // FIXME clone not really necessary here
        layout.push($5e32bf91aa196f43$var$cloneLayoutItem({
            w: 1,
            h: 1,
            x: 0,
            y: $5e32bf91aa196f43$var$bottom(layout),
            i: String(child.key)
        }));
    });
    // Correct the layout.
    const correctedLayout = $5e32bf91aa196f43$var$correctBounds(layout, {
        cols: cols
    });
    return allowOverlap ? correctedLayout : $5e32bf91aa196f43$var$compact(correctedLayout, compactType, cols);
}
/**
 * Validate a layout. Throws errors.
 *
 * @param  {Array}  layout        Array of layout items.
 * @param  {String} [contextName] Context name for errors.
 * @throw  {Error}                Validation error.
 */ function $5e32bf91aa196f43$var$validateLayout(layout /*: Layout*/ ) /*: void*/ {
    let contextName /*: string*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Layout";
    const subProps = [
        "x",
        "y",
        "w",
        "h"
    ];
    if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
    for(let i = 0, len = layout.length; i < len; i++){
        const item = layout[i];
        for(let j = 0; j < subProps.length; j++){
            if (typeof item[subProps[j]] !== "number") throw new Error("ReactGridLayout: " + contextName + "[" + i + "]." + subProps[j] + " must be a number!");
        }
    }
}
// Legacy support for verticalCompact: false
function $5e32bf91aa196f43$var$compactType(props /*: ?{ verticalCompact: boolean, compactType: CompactType }*/ ) /*: CompactType*/ {
    const { verticalCompact: verticalCompact, compactType: compactType } = props || {};
    return verticalCompact === false ? null : compactType;
}
function $5e32bf91aa196f43$var$log() {
    if (!$5e32bf91aa196f43$var$DEBUG) return;
    // eslint-disable-next-line no-console
    console.log(...arguments);
}
const $5e32bf91aa196f43$var$noop = ()=>{};
module.exports.noop = $5e32bf91aa196f43$var$noop;

});
parcelRegister("6T6Yr", function(module, exports) {
// this file was prevaled
module.exports = function fastRGLPropsEqual(a, b, isEqualImpl) {
    if (a === b) return true;
    return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.allowOverlap === b.allowOverlap && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};

});


parcelRegister("6byAd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcGridColWidth = $480e98a129c49cbb$var$calcGridColWidth;
module.exports.calcGridItemPosition = $480e98a129c49cbb$var$calcGridItemPosition;
module.exports.calcGridItemWHPx = $480e98a129c49cbb$var$calcGridItemWHPx;
module.exports.calcWH = $480e98a129c49cbb$var$calcWH;
module.exports.calcXY = $480e98a129c49cbb$var$calcXY;
module.exports.clamp = $480e98a129c49cbb$var$clamp;
/*:: import type { Position } from "./utils";*/ /*:: export type PositionParams = {
  margin: [number, number],
  containerPadding: [number, number],
  containerWidth: number,
  cols: number,
  rowHeight: number,
  maxRows: number
};*/ // Helper for generating column width
function $480e98a129c49cbb$var$calcGridColWidth(positionParams /*: PositionParams*/ ) /*: number*/ {
    const { margin: margin, containerPadding: containerPadding, containerWidth: containerWidth, cols: cols } = positionParams;
    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
}
// This can either be called:
// calcGridItemWHPx(w, colWidth, margin[0])
// or
// calcGridItemWHPx(h, rowHeight, margin[1])
function $480e98a129c49cbb$var$calcGridItemWHPx(gridUnits /*: number*/ , colOrRowSize /*: number*/ , marginPx /*: number*/ ) /*: number*/ {
    // 0 * Infinity === NaN, which causes problems with resize contraints
    if (!Number.isFinite(gridUnits)) return gridUnits;
    return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
/**
 * Return position on the page given an x, y, w, h.
 * left, top, width, height are all in pixels.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number}  x                      X coordinate in grid units.
 * @param  {Number}  y                      Y coordinate in grid units.
 * @param  {Number}  w                      W coordinate in grid units.
 * @param  {Number}  h                      H coordinate in grid units.
 * @return {Position}                       Object containing coords.
 */ function $480e98a129c49cbb$var$calcGridItemPosition(positionParams /*: PositionParams*/ , x /*: number*/ , y /*: number*/ , w /*: number*/ , h /*: number*/ , state /*: ?Object*/ ) /*: Position*/ {
    const { margin: margin, containerPadding: containerPadding, rowHeight: rowHeight } = positionParams;
    const colWidth = $480e98a129c49cbb$var$calcGridColWidth(positionParams);
    const out = {};
    // If resizing, use the exact width and height as returned from resizing callbacks.
    if (state && state.resizing) {
        out.width = Math.round(state.resizing.width);
        out.height = Math.round(state.resizing.height);
    } else {
        out.width = $480e98a129c49cbb$var$calcGridItemWHPx(w, colWidth, margin[0]);
        out.height = $480e98a129c49cbb$var$calcGridItemWHPx(h, rowHeight, margin[1]);
    }
    // If dragging, use the exact width and height as returned from dragging callbacks.
    if (state && state.dragging) {
        out.top = Math.round(state.dragging.top);
        out.left = Math.round(state.dragging.left);
    } else if (state && state.resizing && typeof state.resizing.top === "number" && typeof state.resizing.left === "number") {
        out.top = Math.round(state.resizing.top);
        out.left = Math.round(state.resizing.left);
    } else {
        out.top = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
        out.left = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
    }
    return out;
}
/**
 * Translate x and y coordinates from pixels to grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number} top                     Top position (relative to parent) in pixels.
 * @param  {Number} left                    Left position (relative to parent) in pixels.
 * @param  {Number} w                       W coordinate in grid units.
 * @param  {Number} h                       H coordinate in grid units.
 * @return {Object}                         x and y in grid units.
 */ function $480e98a129c49cbb$var$calcXY(positionParams /*: PositionParams*/ , top /*: number*/ , left /*: number*/ , w /*: number*/ , h /*: number*/ ) /*: { x: number, y: number }*/ {
    const { margin: margin, cols: cols, rowHeight: rowHeight, maxRows: maxRows } = positionParams;
    const colWidth = $480e98a129c49cbb$var$calcGridColWidth(positionParams);
    // left = colWidth * x + margin * (x + 1)
    // l = cx + m(x+1)
    // l = cx + mx + m
    // l - m = cx + mx
    // l - m = x(c + m)
    // (l - m) / (c + m) = x
    // x = (left - margin) / (coldWidth + margin)
    let x = Math.round((left - margin[0]) / (colWidth + margin[0]));
    let y = Math.round((top - margin[1]) / (rowHeight + margin[1]));
    // Capping
    x = $480e98a129c49cbb$var$clamp(x, 0, cols - w);
    y = $480e98a129c49cbb$var$clamp(y, 0, maxRows - h);
    return {
        x: x,
        y: y
    };
}
/**
 * Given a height and width in pixel values, calculate grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calcluations.
 * @param  {Number} height                  Height in pixels.
 * @param  {Number} width                   Width in pixels.
 * @param  {Number} x                       X coordinate in grid units.
 * @param  {Number} y                       Y coordinate in grid units.
 * @param {String} handle Resize Handle.
 * @return {Object}                         w, h as grid units.
 */ function $480e98a129c49cbb$var$calcWH(positionParams /*: PositionParams*/ , width /*: number*/ , height /*: number*/ , x /*: number*/ , y /*: number*/ , handle /*: string*/ ) /*: { w: number, h: number }*/ {
    const { margin: margin, maxRows: maxRows, cols: cols, rowHeight: rowHeight } = positionParams;
    const colWidth = $480e98a129c49cbb$var$calcGridColWidth(positionParams);
    // width = colWidth * w - (margin * (w - 1))
    // ...
    // w = (width + margin) / (colWidth + margin)
    let w = Math.round((width + margin[0]) / (colWidth + margin[0]));
    let h = Math.round((height + margin[1]) / (rowHeight + margin[1]));
    // Capping
    let _w = $480e98a129c49cbb$var$clamp(w, 0, cols - x);
    let _h = $480e98a129c49cbb$var$clamp(h, 0, maxRows - y);
    if ([
        "sw",
        "w",
        "nw"
    ].indexOf(handle) !== -1) _w = $480e98a129c49cbb$var$clamp(w, 0, cols);
    if ([
        "nw",
        "n",
        "ne"
    ].indexOf(handle) !== -1) _h = $480e98a129c49cbb$var$clamp(h, 0, maxRows);
    return {
        w: _w,
        h: _h
    };
}
// Similar to _.clamp
function $480e98a129c49cbb$var$clamp(num /*: number*/ , lowerBound /*: number*/ , upperBound /*: number*/ ) /*: number*/ {
    return Math.max(Math.min(num, upperBound), lowerBound);
}

});

parcelRegister("kA7VV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efbd52cd3b236156$var$_react = $efbd52cd3b236156$var$_interopRequireDefault((parcelRequire("7hzE7")));

var $efbd52cd3b236156$var$_propTypes = $efbd52cd3b236156$var$_interopRequireDefault((parcelRequire("lvJGa")));

var $5tu7N = parcelRequire("5tu7N");

var $3GHv3 = parcelRequire("3GHv3");

var $85pJf = parcelRequire("85pJf");

var $6byAd = parcelRequire("6byAd");

var $11VIj = parcelRequire("11VIj");

var $efbd52cd3b236156$var$_clsx = $efbd52cd3b236156$var$_interopRequireDefault((parcelRequire("cfW2W")));
function $efbd52cd3b236156$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $efbd52cd3b236156$var$_defineProperty(obj, key, value) {
    key = $efbd52cd3b236156$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $efbd52cd3b236156$var$_toPropertyKey(arg) {
    var key = $efbd52cd3b236156$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $efbd52cd3b236156$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type { Element as ReactElement, Node as ReactNode } from "react";*/ /*:: import type {
  ReactDraggableCallbackData,
  GridDragEvent,
  GridResizeEvent,
  DroppingPosition,
  Position,
  ResizeHandleAxis
} from "./utils";*/ /*:: import type { PositionParams } from "./calculateUtils";*/ /*:: import type { ResizeHandle, ReactRef } from "./ReactGridLayoutPropTypes";*/ /*:: type PartialPosition = { top: number, left: number };*/ /*:: type GridItemCallback<Data: GridDragEvent | GridResizeEvent> = (
  i: string,
  w: number,
  h: number,
  Data
) => void;*/ /*:: type ResizeCallbackData = {
  node: HTMLElement,
  size: Position,
  handle: ResizeHandleAxis
};*/ /*:: type GridItemResizeCallback = (
  e: Event,
  data: ResizeCallbackData,
  position: Position
) => void;*/ /*:: type State = {
  resizing: ?{ top: number, left: number, width: number, height: number },
  dragging: ?{ top: number, left: number },
  className: string
};*/ /*:: type Props = {
  children: ReactElement<any>,
  cols: number,
  containerWidth: number,
  margin: [number, number],
  containerPadding: [number, number],
  rowHeight: number,
  maxRows: number,
  isDraggable: boolean,
  isResizable: boolean,
  isBounded: boolean,
  static?: boolean,
  useCSSTransforms?: boolean,
  usePercentages?: boolean,
  transformScale: number,
  droppingPosition?: DroppingPosition,

  className: string,
  style?: Object,
  // Draggability
  cancel: string,
  handle: string,

  x: number,
  y: number,
  w: number,
  h: number,

  minW: number,
  maxW: number,
  minH: number,
  maxH: number,
  i: string,

  resizeHandles?: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,

  onDrag?: GridItemCallback<GridDragEvent>,
  onDragStart?: GridItemCallback<GridDragEvent>,
  onDragStop?: GridItemCallback<GridDragEvent>,
  onResize?: GridItemCallback<GridResizeEvent>,
  onResizeStart?: GridItemCallback<GridResizeEvent>,
  onResizeStop?: GridItemCallback<GridResizeEvent>
};*/ /*:: type DefaultProps = {
  className: string,
  cancel: string,
  handle: string,
  minH: number,
  minW: number,
  maxH: number,
  maxW: number,
  transformScale: number
};*/ /**
 * An individual item within a ReactGridLayout.
 */ class $efbd52cd3b236156$var$GridItem extends $efbd52cd3b236156$var$_react.default.Component /*:: <Props, State>*/  {
    constructor(){
        super(...arguments);
        $efbd52cd3b236156$var$_defineProperty(this, "state", {
            resizing: null,
            dragging: null,
            className: ""
        });
        $efbd52cd3b236156$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $efbd52cd3b236156$var$_react.default.createRef());
        /**
     * onDragStart event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $efbd52cd3b236156$var$_defineProperty(this, "onDragStart", (e, _ref)=>{
            let { node: node } = _ref;
            const { onDragStart: onDragStart, transformScale: transformScale } = this.props;
            if (!onDragStart) return;
            const newPosition /*: PartialPosition*/  = {
                top: 0,
                left: 0
            };
            // TODO: this wont work on nested parents
            const { offsetParent: offsetParent } = node;
            if (!offsetParent) return;
            const parentRect = offsetParent.getBoundingClientRect();
            const clientRect = node.getBoundingClientRect();
            const cLeft = clientRect.left / transformScale;
            const pLeft = parentRect.left / transformScale;
            const cTop = clientRect.top / transformScale;
            const pTop = parentRect.top / transformScale;
            newPosition.left = cLeft - pLeft + offsetParent.scrollLeft;
            newPosition.top = cTop - pTop + offsetParent.scrollTop;
            this.setState({
                dragging: newPosition
            });
            // Call callback with this data
            const { x: x, y: y } = (0, $6byAd.calcXY)(this.getPositionParams(), newPosition.top, newPosition.left, this.props.w, this.props.h);
            return onDragStart.call(this, this.props.i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDrag event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $efbd52cd3b236156$var$_defineProperty(this, "onDrag", (e, _ref2)=>{
            let { node: node, deltaX: deltaX, deltaY: deltaY } = _ref2;
            const { onDrag: onDrag } = this.props;
            if (!onDrag) return;
            if (!this.state.dragging) throw new Error("onDrag called before onDragStart.");
            let top = this.state.dragging.top + deltaY;
            let left = this.state.dragging.left + deltaX;
            const { isBounded: isBounded, i: i, w: w, h: h, containerWidth: containerWidth } = this.props;
            const positionParams = this.getPositionParams();
            // Boundary calculations; keeps items within the grid
            if (isBounded) {
                const { offsetParent: offsetParent } = node;
                if (offsetParent) {
                    const { margin: margin, rowHeight: rowHeight, containerPadding: containerPadding } = this.props;
                    const bottomBoundary = offsetParent.clientHeight - (0, $6byAd.calcGridItemWHPx)(h, rowHeight, margin[1]);
                    top = (0, $6byAd.clamp)(top - containerPadding[1], 0, bottomBoundary);
                    const colWidth = (0, $6byAd.calcGridColWidth)(positionParams);
                    const rightBoundary = containerWidth - (0, $6byAd.calcGridItemWHPx)(w, colWidth, margin[0]);
                    left = (0, $6byAd.clamp)(left - containerPadding[0], 0, rightBoundary);
                }
            }
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            this.setState({
                dragging: newPosition
            });
            // Call callback with this data
            const { containerPadding: containerPadding } = this.props;
            const { x: x, y: y } = (0, $6byAd.calcXY)(positionParams, top - containerPadding[1], left - containerPadding[0], w, h);
            return onDrag.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDragStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $efbd52cd3b236156$var$_defineProperty(this, "onDragStop", (e, _ref3)=>{
            let { node: node } = _ref3;
            const { onDragStop: onDragStop } = this.props;
            if (!onDragStop) return;
            if (!this.state.dragging) throw new Error("onDragEnd called before onDragStart.");
            const { w: w, h: h, i: i, containerPadding: containerPadding } = this.props;
            const { left: left, top: top } = this.state.dragging;
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            this.setState({
                dragging: null
            });
            const { x: x, y: y } = (0, $6byAd.calcXY)(this.getPositionParams(), top - containerPadding[1], left - containerPadding[0], w, h);
            return onDragStop.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onResizeStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node and size information
     */ $efbd52cd3b236156$var$_defineProperty(this, "onResizeStop", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStop"));
        // onResizeStart event handler
        $efbd52cd3b236156$var$_defineProperty(this, "onResizeStart", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStart"));
        // onResize event handler
        $efbd52cd3b236156$var$_defineProperty(this, "onResize", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResize"));
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        // We can't deeply compare children. If the developer memoizes them, we can
        // use this optimization.
        if (this.props.children !== nextProps.children) return true;
        if (this.props.droppingPosition !== nextProps.droppingPosition) return true;
        // TODO memoize these calculations so they don't take so long?
        const oldPosition = (0, $6byAd.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
        const newPosition = (0, $6byAd.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
        return !(0, $85pJf.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
    }
    componentDidMount() {
        this.moveDroppingItem({});
    }
    componentDidUpdate(prevProps /*: Props*/ ) {
        this.moveDroppingItem(prevProps);
    }
    // When a droppingPosition is present, this means we should fire a move event, as if we had moved
    // this element by `x, y` pixels.
    moveDroppingItem(prevProps /*: Props*/ ) {
        const { droppingPosition: droppingPosition } = this.props;
        if (!droppingPosition) return;
        const node = this.elementRef.current;
        // Can't find DOM node (are we unmounted?)
        if (!node) return;
        const prevDroppingPosition = prevProps.droppingPosition || {
            left: 0,
            top: 0
        };
        const { dragging: dragging } = this.state;
        const shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
        if (!dragging) this.onDragStart(droppingPosition.e, {
            node: node,
            deltaX: droppingPosition.left,
            deltaY: droppingPosition.top
        });
        else if (shouldDrag) {
            const deltaX = droppingPosition.left - dragging.left;
            const deltaY = droppingPosition.top - dragging.top;
            this.onDrag(droppingPosition.e, {
                node: node,
                deltaX: deltaX,
                deltaY: deltaY
            });
        }
    }
    getPositionParams() /*: PositionParams*/ {
        let props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        return {
            cols: props.cols,
            containerPadding: props.containerPadding,
            containerWidth: props.containerWidth,
            margin: props.margin,
            maxRows: props.maxRows,
            rowHeight: props.rowHeight
        };
    }
    /**
   * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
   * well when server rendering, and the only way to do that properly is to use percentage width/left because
   * we don't know exactly what the browser viewport is.
   * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
   * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
   *
   * @param  {Object} pos Position object with width, height, left, top.
   * @return {Object}     Style object.
   */ createStyle(pos /*: Position*/ ) /*: { [key: string]: ?string }*/ {
        const { usePercentages: usePercentages, containerWidth: containerWidth, useCSSTransforms: useCSSTransforms } = this.props;
        let style;
        // CSS Transforms support (default)
        if (useCSSTransforms) style = (0, $85pJf.setTransform)(pos);
        else {
            // top,left (slow)
            style = (0, $85pJf.setTopLeft)(pos);
            // This is used for server rendering.
            if (usePercentages) {
                style.left = (0, $85pJf.perc)(pos.left / containerWidth);
                style.width = (0, $85pJf.perc)(pos.width / containerWidth);
            }
        }
        return style;
    }
    /**
   * Mix a Draggable instance into a child.
   * @param  {Element} child    Child element.
   * @return {Element}          Child wrapped in Draggable.
   */ mixinDraggable(child /*: ReactElement<any>*/ , isDraggable /*: boolean*/ ) /*: ReactElement<any>*/ {
        return /*#__PURE__*/ $efbd52cd3b236156$var$_react.default.createElement($5tu7N.DraggableCore, {
            disabled: !isDraggable,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop,
            handle: this.props.handle,
            cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
            scale: this.props.transformScale,
            nodeRef: this.elementRef
        }, child);
    }
    /**
   * Utility function to setup callback handler definitions for
   * similarily structured resize events.
   */ curryResizeHandler(position /*: Position*/ , handler /*: Function*/ ) /*: Function*/ {
        return (e /*: Event*/ , data /*: ResizeCallbackData*/ )=>/*: Function*/ handler(e, data, position);
    }
    /**
   * Mix a Resizable instance into a child.
   * @param  {Element} child    Child element.
   * @param  {Object} position  Position object (pixel values)
   * @return {Element}          Child wrapped in Resizable.
   */ mixinResizable(child /*: ReactElement<any>*/ , position /*: Position*/ , isResizable /*: boolean*/ ) /*: ReactElement<any>*/ {
        const { cols: cols, minW: minW, minH: minH, maxW: maxW, maxH: maxH, transformScale: transformScale, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const positionParams = this.getPositionParams();
        // This is the max possible width - doesn't go to infinity because of the width of the window
        const maxWidth = (0, $6byAd.calcGridItemPosition)(positionParams, 0, 0, cols, 0).width;
        // Calculate min/max constraints using our min & maxes
        const mins = (0, $6byAd.calcGridItemPosition)(positionParams, 0, 0, minW, minH);
        const maxes = (0, $6byAd.calcGridItemPosition)(positionParams, 0, 0, maxW, maxH);
        const minConstraints = [
            mins.width,
            mins.height
        ];
        const maxConstraints = [
            Math.min(maxes.width, maxWidth),
            Math.min(maxes.height, Infinity)
        ];
        return /*#__PURE__*/ $efbd52cd3b236156$var$_react.default.createElement($3GHv3.Resizable, {
            draggableOpts: {
                disabled: !isResizable
            },
            className: isResizable ? undefined : "react-resizable-hide",
            width: position.width,
            height: position.height,
            minConstraints: minConstraints,
            maxConstraints: maxConstraints,
            onResizeStop: this.curryResizeHandler(position, this.onResizeStop),
            onResizeStart: this.curryResizeHandler(position, this.onResizeStart),
            onResize: this.curryResizeHandler(position, this.onResize),
            transformScale: transformScale,
            resizeHandles: resizeHandles,
            handle: resizeHandle
        }, child);
    }
    /**
   * Wrapper around resize events to provide more useful data.
   */ onResizeHandler(e /*: Event*/ , _ref4 /*:: */ , // 'size' is updated position
    position /*: Position*/ , // existing position
    handlerName /*: string*/ ) /*: void*/ {
        let { node: node, size: size, handle: handle } /*: ResizeCallbackData*/  = _ref4 /*: ResizeCallbackData*/ ;
        const handler = this.props[handlerName];
        if (!handler) return;
        const { x: x, y: y, i: i, maxH: maxH, minH: minH, containerWidth: containerWidth } = this.props;
        const { minW: minW, maxW: maxW } = this.props;
        // Clamping of dimensions based on resize direction
        let updatedSize = size;
        if (node) {
            updatedSize = (0, $85pJf.resizeItemInDirection)(handle, position, size, containerWidth);
            this.setState({
                resizing: handlerName === "onResizeStop" ? null : updatedSize
            });
        }
        // Get new XY based on pixel size
        let { w: w, h: h } = (0, $6byAd.calcWH)(this.getPositionParams(), updatedSize.width, updatedSize.height, x, y, handle);
        // Min/max capping.
        // minW should be at least 1 (TODO propTypes validation?)
        w = (0, $6byAd.clamp)(w, Math.max(minW, 1), maxW);
        h = (0, $6byAd.clamp)(h, minH, maxH);
        handler.call(this, i, w, h, {
            e: e,
            node: node,
            size: updatedSize,
            handle: handle
        });
    }
    render() /*: ReactNode*/ {
        const { x: x, y: y, w: w, h: h, isDraggable: isDraggable, isResizable: isResizable, droppingPosition: droppingPosition, useCSSTransforms: useCSSTransforms } = this.props;
        const pos = (0, $6byAd.calcGridItemPosition)(this.getPositionParams(), x, y, w, h, this.state);
        const child = $efbd52cd3b236156$var$_react.default.Children.only(this.props.children);
        // Create the child element. We clone the existing element but modify its className and style.
        let newChild = /*#__PURE__*/ $efbd52cd3b236156$var$_react.default.cloneElement(child, {
            ref: this.elementRef,
            className: (0, $efbd52cd3b236156$var$_clsx.default)("react-grid-item", child.props.className, this.props.className, {
                static: this.props.static,
                resizing: Boolean(this.state.resizing),
                "react-draggable": isDraggable,
                "react-draggable-dragging": Boolean(this.state.dragging),
                dropping: Boolean(droppingPosition),
                cssTransforms: useCSSTransforms
            }),
            // We can set the width and height on the child, but unfortunately we can't set the position.
            style: {
                ...this.props.style,
                ...child.props.style,
                ...this.createStyle(pos)
            }
        });
        // Resizable support. This is usually on but the user can toggle it off.
        newChild = this.mixinResizable(newChild, pos, isResizable);
        // Draggable support. This is always on, except for with placeholders.
        newChild = this.mixinDraggable(newChild, isDraggable);
        return newChild;
    }
}
module.exports.default = $efbd52cd3b236156$var$GridItem;
$efbd52cd3b236156$var$_defineProperty($efbd52cd3b236156$var$GridItem, "propTypes", {
    // Children must be only a single element
    children: $efbd52cd3b236156$var$_propTypes.default.element,
    // General grid attributes
    cols: $efbd52cd3b236156$var$_propTypes.default.number.isRequired,
    containerWidth: $efbd52cd3b236156$var$_propTypes.default.number.isRequired,
    rowHeight: $efbd52cd3b236156$var$_propTypes.default.number.isRequired,
    margin: $efbd52cd3b236156$var$_propTypes.default.array.isRequired,
    maxRows: $efbd52cd3b236156$var$_propTypes.default.number.isRequired,
    containerPadding: $efbd52cd3b236156$var$_propTypes.default.array.isRequired,
    // These are all in grid units
    x: $efbd52cd3b236156$var$_propTypes.default.number.isRequired,
    y: $efbd52cd3b236156$var$_propTypes.default.number.isRequired,
    w: $efbd52cd3b236156$var$_propTypes.default.number.isRequired,
    h: $efbd52cd3b236156$var$_propTypes.default.number.isRequired,
    // All optional
    minW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minWidth not Number");
        if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
    },
    maxW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxWidth not Number");
        if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
    },
    minH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minHeight not Number");
        if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
    },
    maxH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxHeight not Number");
        if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
    },
    // ID is nice to have for callbacks
    i: $efbd52cd3b236156$var$_propTypes.default.string.isRequired,
    // Resize handle options
    resizeHandles: $11VIj.resizeHandleAxesType,
    resizeHandle: $11VIj.resizeHandleType,
    // Functions
    onDragStop: $efbd52cd3b236156$var$_propTypes.default.func,
    onDragStart: $efbd52cd3b236156$var$_propTypes.default.func,
    onDrag: $efbd52cd3b236156$var$_propTypes.default.func,
    onResizeStop: $efbd52cd3b236156$var$_propTypes.default.func,
    onResizeStart: $efbd52cd3b236156$var$_propTypes.default.func,
    onResize: $efbd52cd3b236156$var$_propTypes.default.func,
    // Flags
    isDraggable: $efbd52cd3b236156$var$_propTypes.default.bool.isRequired,
    isResizable: $efbd52cd3b236156$var$_propTypes.default.bool.isRequired,
    isBounded: $efbd52cd3b236156$var$_propTypes.default.bool.isRequired,
    static: $efbd52cd3b236156$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $efbd52cd3b236156$var$_propTypes.default.bool.isRequired,
    transformScale: $efbd52cd3b236156$var$_propTypes.default.number,
    // Others
    className: $efbd52cd3b236156$var$_propTypes.default.string,
    // Selector for draggable handle
    handle: $efbd52cd3b236156$var$_propTypes.default.string,
    // Selector for draggable cancel (see react-draggable)
    cancel: $efbd52cd3b236156$var$_propTypes.default.string,
    // Current position of a dropping element
    droppingPosition: $efbd52cd3b236156$var$_propTypes.default.shape({
        e: $efbd52cd3b236156$var$_propTypes.default.object.isRequired,
        left: $efbd52cd3b236156$var$_propTypes.default.number.isRequired,
        top: $efbd52cd3b236156$var$_propTypes.default.number.isRequired
    })
});
$efbd52cd3b236156$var$_defineProperty($efbd52cd3b236156$var$GridItem, "defaultProps", {
    className: "",
    cancel: "",
    handle: "",
    minH: 1,
    minW: 1,
    maxH: Infinity,
    maxW: Infinity,
    transformScale: 1
});

});
parcelRegister("lvJGa", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa8fed2a759396d2$var$ReactIs, $fa8fed2a759396d2$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("dUsdG"))();

});
parcelRegister("dUsdG", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lzkKn = parcelRequire("lzkKn");
function $a206652b04fb06d6$var$emptyFunction() {}
function $a206652b04fb06d6$var$emptyFunctionWithReset() {}
$a206652b04fb06d6$var$emptyFunctionWithReset.resetWarningCache = $a206652b04fb06d6$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lzkKn) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a206652b04fb06d6$var$emptyFunctionWithReset,
        resetWarningCache: $a206652b04fb06d6$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lzkKn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fb3cf5c61dde43c8$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fb3cf5c61dde43c8$var$ReactPropTypesSecret;

});



parcelRegister("5tu7N", function(module, exports) {
"use strict";

var $dRK3X = parcelRequire("dRK3X");
var $010756d3ed3c498c$require$Draggable = $dRK3X.default;
var $010756d3ed3c498c$require$DraggableCore = $dRK3X.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = $010756d3ed3c498c$require$Draggable;
module.exports.default = $010756d3ed3c498c$require$Draggable;
module.exports.DraggableCore = $010756d3ed3c498c$require$DraggableCore;

});
parcelRegister("dRK3X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $a183f4b90cdb5266$var$_DraggableCore.default;
    }
});
module.exports.default = void 0;

var $a183f4b90cdb5266$var$React = $a183f4b90cdb5266$var$_interopRequireWildcard((parcelRequire("7hzE7")));

var $a183f4b90cdb5266$var$_propTypes = $a183f4b90cdb5266$var$_interopRequireDefault((parcelRequire("lvJGa")));

var $a183f4b90cdb5266$var$_reactDom = $a183f4b90cdb5266$var$_interopRequireDefault((parcelRequire("8Zslt")));

var $a183f4b90cdb5266$var$_clsx = $a183f4b90cdb5266$var$_interopRequireDefault((parcelRequire("lLChg")));

var $48Nya = parcelRequire("48Nya");

var $2JkOR = parcelRequire("2JkOR");

var $axmqm = parcelRequire("axmqm");

var $a183f4b90cdb5266$var$_DraggableCore = $a183f4b90cdb5266$var$_interopRequireDefault((parcelRequire("acoRP")));

var $a183f4b90cdb5266$var$_log = $a183f4b90cdb5266$var$_interopRequireDefault((parcelRequire("c2zEl")));
function $a183f4b90cdb5266$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a183f4b90cdb5266$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a183f4b90cdb5266$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a183f4b90cdb5266$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a183f4b90cdb5266$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a183f4b90cdb5266$var$_extends() {
    $a183f4b90cdb5266$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a183f4b90cdb5266$var$_extends.apply(this, arguments);
}
function $a183f4b90cdb5266$var$_defineProperty(obj, key, value) {
    key = $a183f4b90cdb5266$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a183f4b90cdb5266$var$_toPropertyKey(arg) {
    var key = $a183f4b90cdb5266$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a183f4b90cdb5266$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $a183f4b90cdb5266$var$Draggable extends $a183f4b90cdb5266$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $a183f4b90cdb5266$var$_log.default)('Draggable: getDerivedStateFromProps %j', {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $a183f4b90cdb5266$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $a183f4b90cdb5266$var$_log.default)('Draggable: onDragStart: %j', coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $2JkOR.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $a183f4b90cdb5266$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $a183f4b90cdb5266$var$_log.default)('Draggable: onDrag: %j', coreData);
            const uiData = (0, $2JkOR.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $2JkOR.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $a183f4b90cdb5266$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $2JkOR.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $a183f4b90cdb5266$var$_log.default)('Draggable: onDragStop: %j', coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $a183f4b90cdb5266$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $2JkOR.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $2JkOR.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $48Nya.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $48Nya.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $a183f4b90cdb5266$var$_clsx.default)(children.props.className || '', defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $a183f4b90cdb5266$var$React.createElement($a183f4b90cdb5266$var$_DraggableCore.default, $a183f4b90cdb5266$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $a183f4b90cdb5266$var$React.cloneElement($a183f4b90cdb5266$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
module.exports.default = $a183f4b90cdb5266$var$Draggable;
$a183f4b90cdb5266$var$_defineProperty($a183f4b90cdb5266$var$Draggable, "displayName", 'Draggable');
$a183f4b90cdb5266$var$_defineProperty($a183f4b90cdb5266$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$a183f4b90cdb5266$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $a183f4b90cdb5266$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $a183f4b90cdb5266$var$_propTypes.default.oneOfType([
        $a183f4b90cdb5266$var$_propTypes.default.shape({
            left: $a183f4b90cdb5266$var$_propTypes.default.number,
            right: $a183f4b90cdb5266$var$_propTypes.default.number,
            top: $a183f4b90cdb5266$var$_propTypes.default.number,
            bottom: $a183f4b90cdb5266$var$_propTypes.default.number
        }),
        $a183f4b90cdb5266$var$_propTypes.default.string,
        $a183f4b90cdb5266$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $a183f4b90cdb5266$var$_propTypes.default.string,
    defaultClassNameDragging: $a183f4b90cdb5266$var$_propTypes.default.string,
    defaultClassNameDragged: $a183f4b90cdb5266$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $a183f4b90cdb5266$var$_propTypes.default.shape({
        x: $a183f4b90cdb5266$var$_propTypes.default.number,
        y: $a183f4b90cdb5266$var$_propTypes.default.number
    }),
    positionOffset: $a183f4b90cdb5266$var$_propTypes.default.shape({
        x: $a183f4b90cdb5266$var$_propTypes.default.oneOfType([
            $a183f4b90cdb5266$var$_propTypes.default.number,
            $a183f4b90cdb5266$var$_propTypes.default.string
        ]),
        y: $a183f4b90cdb5266$var$_propTypes.default.oneOfType([
            $a183f4b90cdb5266$var$_propTypes.default.number,
            $a183f4b90cdb5266$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $a183f4b90cdb5266$var$_propTypes.default.shape({
        x: $a183f4b90cdb5266$var$_propTypes.default.number,
        y: $a183f4b90cdb5266$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $axmqm.dontSetMe,
    style: $axmqm.dontSetMe,
    transform: $axmqm.dontSetMe
});
$a183f4b90cdb5266$var$_defineProperty($a183f4b90cdb5266$var$Draggable, "defaultProps", {
    ...$a183f4b90cdb5266$var$_DraggableCore.default.defaultProps,
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});

});
parcelRegister("lLChg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $fd8badd82f577f92$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $fd8badd82f577f92$export$2e2bcd8739ae039);
function $fd8badd82f577f92$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $fd8badd82f577f92$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $fd8badd82f577f92$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $fd8badd82f577f92$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fd8badd82f577f92$export$2e2bcd8739ae039 = $fd8badd82f577f92$export$4f5d2d50c9deca37;

});

parcelRegister("48Nya", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $303e586b48a0bea0$var$addClassName;
module.exports.addEvent = $303e586b48a0bea0$var$addEvent;
module.exports.addUserSelectStyles = $303e586b48a0bea0$var$addUserSelectStyles;
module.exports.createCSSTransform = $303e586b48a0bea0$var$createCSSTransform;
module.exports.createSVGTransform = $303e586b48a0bea0$var$createSVGTransform;
module.exports.getTouch = $303e586b48a0bea0$var$getTouch;
module.exports.getTouchIdentifier = $303e586b48a0bea0$var$getTouchIdentifier;
module.exports.getTranslation = $303e586b48a0bea0$var$getTranslation;
module.exports.innerHeight = $303e586b48a0bea0$var$innerHeight;
module.exports.innerWidth = $303e586b48a0bea0$var$innerWidth;
module.exports.matchesSelector = $303e586b48a0bea0$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $303e586b48a0bea0$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $303e586b48a0bea0$var$offsetXYFromParent;
module.exports.outerHeight = $303e586b48a0bea0$var$outerHeight;
module.exports.outerWidth = $303e586b48a0bea0$var$outerWidth;
module.exports.removeClassName = $303e586b48a0bea0$var$removeClassName;
module.exports.removeEvent = $303e586b48a0bea0$var$removeEvent;
module.exports.removeUserSelectStyles = $303e586b48a0bea0$var$removeUserSelectStyles;

var $axmqm = parcelRequire("axmqm");

var $303e586b48a0bea0$var$_getPrefix = $303e586b48a0bea0$var$_interopRequireWildcard((parcelRequire("cYwXC")));
function $303e586b48a0bea0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($303e586b48a0bea0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $303e586b48a0bea0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $303e586b48a0bea0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $303e586b48a0bea0$var$matchesSelectorFunc = '';
function $303e586b48a0bea0$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$303e586b48a0bea0$var$matchesSelectorFunc) $303e586b48a0bea0$var$matchesSelectorFunc = (0, $axmqm.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $axmqm.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $axmqm.isFunction)(el[$303e586b48a0bea0$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$303e586b48a0bea0$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $303e586b48a0bea0$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($303e586b48a0bea0$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $303e586b48a0bea0$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function $303e586b48a0bea0$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function $303e586b48a0bea0$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $axmqm.int)(computedStyle.borderTopWidth);
    height += (0, $axmqm.int)(computedStyle.borderBottomWidth);
    return height;
}
function $303e586b48a0bea0$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $axmqm.int)(computedStyle.borderLeftWidth);
    width += (0, $axmqm.int)(computedStyle.borderRightWidth);
    return width;
}
function $303e586b48a0bea0$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $axmqm.int)(computedStyle.paddingTop);
    height -= (0, $axmqm.int)(computedStyle.paddingBottom);
    return height;
}
function $303e586b48a0bea0$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $axmqm.int)(computedStyle.paddingLeft);
    width -= (0, $axmqm.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $303e586b48a0bea0$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $303e586b48a0bea0$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $303e586b48a0bea0$var$getTranslation(controlPos, positionOffset, 'px');
    return {
        [(0, $303e586b48a0bea0$var$_getPrefix.browserPrefixToKey)('transform', $303e586b48a0bea0$var$_getPrefix.default)]: translation
    };
}
function $303e586b48a0bea0$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $303e586b48a0bea0$var$getTranslation(controlPos, positionOffset, '');
    return translation;
}
function $303e586b48a0bea0$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        const defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
        const defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $303e586b48a0bea0$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $axmqm.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $axmqm.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $303e586b48a0bea0$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $303e586b48a0bea0$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) $303e586b48a0bea0$var$addClassName(doc.body, 'react-draggable-transparent-selection');
}
function $303e586b48a0bea0$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $303e586b48a0bea0$var$removeClassName(doc.body, 'react-draggable-transparent-selection');
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $303e586b48a0bea0$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $303e586b48a0bea0$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
}

});
parcelRegister("axmqm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $7abe6172d15015e1$var$dontSetMe;
module.exports.findInArray = $7abe6172d15015e1$var$findInArray;
module.exports.int = $7abe6172d15015e1$var$int;
module.exports.isFunction = $7abe6172d15015e1$var$isFunction;
module.exports.isNum = $7abe6172d15015e1$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $7abe6172d15015e1$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $7abe6172d15015e1$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function $7abe6172d15015e1$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function $7abe6172d15015e1$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $7abe6172d15015e1$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});

parcelRegister("cYwXC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $9724a7f0fb32fb6b$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $9724a7f0fb32fb6b$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $9724a7f0fb32fb6b$var$getPrefix;
const $9724a7f0fb32fb6b$var$prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function $9724a7f0fb32fb6b$var$getPrefix() /*: string*/ {
    var _window$document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return '';
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return '';
    if (prop in style) return '';
    for(let i = 0; i < $9724a7f0fb32fb6b$var$prefixes.length; i++){
        if ($9724a7f0fb32fb6b$var$browserPrefixToKey(prop, $9724a7f0fb32fb6b$var$prefixes[i]) in style) return $9724a7f0fb32fb6b$var$prefixes[i];
    }
    return '';
}
function $9724a7f0fb32fb6b$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat($9724a7f0fb32fb6b$var$kebabToTitleCase(prop)) : prop;
}
function $9724a7f0fb32fb6b$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $9724a7f0fb32fb6b$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = '';
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $9724a7f0fb32fb6b$var$_default = module.exports.default = $9724a7f0fb32fb6b$var$getPrefix();

});


parcelRegister("2JkOR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $1fcfef09538478a1$var$canDragX;
module.exports.canDragY = $1fcfef09538478a1$var$canDragY;
module.exports.createCoreData = $1fcfef09538478a1$var$createCoreData;
module.exports.createDraggableData = $1fcfef09538478a1$var$createDraggableData;
module.exports.getBoundPosition = $1fcfef09538478a1$var$getBoundPosition;
module.exports.getControlPosition = $1fcfef09538478a1$var$getControlPosition;
module.exports.snapToGrid = $1fcfef09538478a1$var$snapToGrid;

var $axmqm = parcelRequire("axmqm");

var $48Nya = parcelRequire("48Nya");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $1fcfef09538478a1$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === 'string' ? bounds : $1fcfef09538478a1$var$cloneBounds(bounds);
    const node = $1fcfef09538478a1$var$findDOMNode(draggable);
    if (typeof bounds === 'string') {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $axmqm.int)(boundNodeStyle.paddingLeft) + (0, $axmqm.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $axmqm.int)(boundNodeStyle.paddingTop) + (0, $axmqm.int)(nodeStyle.marginTop),
            right: (0, $48Nya.innerWidth)(boundNodeEl) - (0, $48Nya.outerWidth)(node) - node.offsetLeft + (0, $axmqm.int)(boundNodeStyle.paddingRight) - (0, $axmqm.int)(nodeStyle.marginRight),
            bottom: (0, $48Nya.innerHeight)(boundNodeEl) - (0, $48Nya.outerHeight)(node) - node.offsetTop + (0, $axmqm.int)(boundNodeStyle.paddingBottom) - (0, $axmqm.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $axmqm.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $axmqm.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $axmqm.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $axmqm.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $1fcfef09538478a1$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $1fcfef09538478a1$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function $1fcfef09538478a1$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}
// Get {x, y} positions from event.
function $1fcfef09538478a1$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === 'number' ? (0, $48Nya.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    const node = $1fcfef09538478a1$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $48Nya.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $1fcfef09538478a1$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $axmqm.isNum)(draggable.lastX);
    const node = $1fcfef09538478a1$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $1fcfef09538478a1$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $1fcfef09538478a1$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $1fcfef09538478a1$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("acoRP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76ce5079b3ff0684$var$React = $76ce5079b3ff0684$var$_interopRequireWildcard((parcelRequire("7hzE7")));

var $76ce5079b3ff0684$var$_propTypes = $76ce5079b3ff0684$var$_interopRequireDefault((parcelRequire("lvJGa")));

var $76ce5079b3ff0684$var$_reactDom = $76ce5079b3ff0684$var$_interopRequireDefault((parcelRequire("8Zslt")));

var $48Nya = parcelRequire("48Nya");

var $2JkOR = parcelRequire("2JkOR");

var $axmqm = parcelRequire("axmqm");

var $76ce5079b3ff0684$var$_log = $76ce5079b3ff0684$var$_interopRequireDefault((parcelRequire("c2zEl")));
function $76ce5079b3ff0684$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76ce5079b3ff0684$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($76ce5079b3ff0684$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $76ce5079b3ff0684$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $76ce5079b3ff0684$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $76ce5079b3ff0684$var$_defineProperty(obj, key, value) {
    key = $76ce5079b3ff0684$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $76ce5079b3ff0684$var$_toPropertyKey(arg) {
    var key = $76ce5079b3ff0684$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $76ce5079b3ff0684$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $76ce5079b3ff0684$var$eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
// Default to mouse events.
let $76ce5079b3ff0684$var$dragEventFor = $76ce5079b3ff0684$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $76ce5079b3ff0684$var$DraggableCore extends $76ce5079b3ff0684$var$React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        $76ce5079b3ff0684$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $76ce5079b3ff0684$var$_defineProperty(this, "lastX", NaN);
        $76ce5079b3ff0684$var$_defineProperty(this, "lastY", NaN);
        $76ce5079b3ff0684$var$_defineProperty(this, "touchIdentifier", null);
        $76ce5079b3ff0684$var$_defineProperty(this, "mounted", false);
        $76ce5079b3ff0684$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $48Nya.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $48Nya.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart') e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $48Nya.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $2JkOR.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $2JkOR.createCoreData)(this, x, y);
            (0, $76ce5079b3ff0684$var$_log.default)('DraggableCore: handleDragStart: %j', coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $76ce5079b3ff0684$var$_log.default)('calling', this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $48Nya.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $48Nya.addEvent)(ownerDocument, $76ce5079b3ff0684$var$dragEventFor.move, this.handleDrag);
            (0, $48Nya.addEvent)(ownerDocument, $76ce5079b3ff0684$var$dragEventFor.stop, this.handleDragStop);
        });
        $76ce5079b3ff0684$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $2JkOR.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $2JkOR.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $2JkOR.createCoreData)(this, x, y);
            (0, $76ce5079b3ff0684$var$_log.default)('DraggableCore: handleDrag: %j', coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent('MouseEvents');
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $76ce5079b3ff0684$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $2JkOR.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $2JkOR.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $2JkOR.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $48Nya.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $76ce5079b3ff0684$var$_log.default)('DraggableCore: handleDragStop: %j', coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $76ce5079b3ff0684$var$_log.default)('DraggableCore: Removing handlers');
                (0, $48Nya.removeEvent)(thisNode.ownerDocument, $76ce5079b3ff0684$var$dragEventFor.move, this.handleDrag);
                (0, $48Nya.removeEvent)(thisNode.ownerDocument, $76ce5079b3ff0684$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $76ce5079b3ff0684$var$_defineProperty(this, "onMouseDown", (e)=>{
            $76ce5079b3ff0684$var$dragEventFor = $76ce5079b3ff0684$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $76ce5079b3ff0684$var$_defineProperty(this, "onMouseUp", (e)=>{
            $76ce5079b3ff0684$var$dragEventFor = $76ce5079b3ff0684$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $76ce5079b3ff0684$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $76ce5079b3ff0684$var$dragEventFor = $76ce5079b3ff0684$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $76ce5079b3ff0684$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $76ce5079b3ff0684$var$dragEventFor = $76ce5079b3ff0684$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $48Nya.addEvent)(thisNode, $76ce5079b3ff0684$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $48Nya.removeEvent)(ownerDocument, $76ce5079b3ff0684$var$eventsFor.mouse.move, this.handleDrag);
            (0, $48Nya.removeEvent)(ownerDocument, $76ce5079b3ff0684$var$eventsFor.touch.move, this.handleDrag);
            (0, $48Nya.removeEvent)(ownerDocument, $76ce5079b3ff0684$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $48Nya.removeEvent)(ownerDocument, $76ce5079b3ff0684$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $48Nya.removeEvent)(thisNode, $76ce5079b3ff0684$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $48Nya.removeUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props, _this$props2;
        return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : $76ce5079b3ff0684$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $76ce5079b3ff0684$var$React.cloneElement($76ce5079b3ff0684$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
module.exports.default = $76ce5079b3ff0684$var$DraggableCore;
$76ce5079b3ff0684$var$_defineProperty($76ce5079b3ff0684$var$DraggableCore, "displayName", 'DraggableCore');
$76ce5079b3ff0684$var$_defineProperty($76ce5079b3ff0684$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $76ce5079b3ff0684$var$_propTypes.default.bool,
    children: $76ce5079b3ff0684$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $76ce5079b3ff0684$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $76ce5079b3ff0684$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $76ce5079b3ff0684$var$_propTypes.default.arrayOf($76ce5079b3ff0684$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $76ce5079b3ff0684$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $76ce5079b3ff0684$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $76ce5079b3ff0684$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $76ce5079b3ff0684$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $76ce5079b3ff0684$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $76ce5079b3ff0684$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $76ce5079b3ff0684$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $76ce5079b3ff0684$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $axmqm.dontSetMe,
    style: $axmqm.dontSetMe,
    transform: $axmqm.dontSetMe
});
$76ce5079b3ff0684$var$_defineProperty($76ce5079b3ff0684$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("c2zEl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c41533e2603d643$var$log;
/*eslint no-console:0*/ function $8c41533e2603d643$var$log() {}

});




parcelRegister("3GHv3", function(module, exports) {
'use strict';
module.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};

module.exports.Resizable = (parcelRequire("ji3fW")).default;

module.exports.ResizableBox = (parcelRequire("cPRtU")).default;

});
parcelRegister("ji3fW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $e0b2395cc879a2ce$export$1e511d4a378977f5, (v) => $e0b2395cc879a2ce$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $e0b2395cc879a2ce$export$2e2bcd8739ae039, (v) => $e0b2395cc879a2ce$export$2e2bcd8739ae039 = v);
var $e0b2395cc879a2ce$export$1e511d4a378977f5;
var $e0b2395cc879a2ce$export$2e2bcd8739ae039;
"use strict";
$e0b2395cc879a2ce$export$1e511d4a378977f5 = true;
$e0b2395cc879a2ce$export$2e2bcd8739ae039 = void 0;

var $e0b2395cc879a2ce$var$React = $e0b2395cc879a2ce$var$_interopRequireWildcard((parcelRequire("7hzE7")));

var $5tu7N = parcelRequire("5tu7N");

var $9hj2w = parcelRequire("9hj2w");

var $fza6r = parcelRequire("fza6r");
var $e0b2395cc879a2ce$var$_excluded = [
    "children",
    "className",
    "draggableOpts",
    "width",
    "height",
    "handle",
    "handleSize",
    "lockAspectRatio",
    "axis",
    "minConstraints",
    "maxConstraints",
    "onResize",
    "onResizeStop",
    "onResizeStart",
    "resizeHandles",
    "transformScale"
];
function $e0b2395cc879a2ce$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e0b2395cc879a2ce$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e0b2395cc879a2ce$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e0b2395cc879a2ce$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e0b2395cc879a2ce$var$_extends() {
    $e0b2395cc879a2ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0b2395cc879a2ce$var$_extends.apply(this, arguments);
}
function $e0b2395cc879a2ce$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e0b2395cc879a2ce$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e0b2395cc879a2ce$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e0b2395cc879a2ce$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e0b2395cc879a2ce$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e0b2395cc879a2ce$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e0b2395cc879a2ce$var$_defineProperty(obj, key, value) {
    key = $e0b2395cc879a2ce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e0b2395cc879a2ce$var$_toPropertyKey(arg) {
    var key = $e0b2395cc879a2ce$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e0b2395cc879a2ce$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e0b2395cc879a2ce$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $e0b2395cc879a2ce$var$_setPrototypeOf(subClass, superClass);
}
function $e0b2395cc879a2ce$var$_setPrototypeOf(o, p) {
    $e0b2395cc879a2ce$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e0b2395cc879a2ce$var$_setPrototypeOf(o, p);
}
// The base <Resizable> component.
// This component does not have state and relies on the parent to set its props based on callback data.
var $e0b2395cc879a2ce$var$Resizable = /*#__PURE__*/ function(_React$Component) {
    $e0b2395cc879a2ce$var$_inheritsLoose(Resizable, _React$Component);
    function Resizable() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleRefs = {};
        _this.lastHandleRect = null;
        _this.slack = null;
        return _this;
    }
    var _proto = Resizable.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.resetData();
    };
    _proto.resetData = function resetData() {
        this.lastHandleRect = this.slack = null;
    };
    _proto.runConstraints = function runConstraints(width, height) {
        var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
        // short circuit
        if (!minConstraints && !maxConstraints && !lockAspectRatio) return [
            width,
            height
        ];
        // If constraining to min and max, we need to also fit width and height to aspect ratio.
        if (lockAspectRatio) {
            var ratio = this.props.width / this.props.height;
            var deltaW = width - this.props.width;
            var deltaH = height - this.props.height;
            // Find which coordinate was greater and should push the other toward it.
            // E.g.:
            // ratio = 1, deltaW = 10, deltaH = 5, deltaH should become 10.
            // ratio = 2, deltaW = 10, deltaH = 6, deltaW should become 12.
            if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) height = width / ratio;
            else width = height * ratio;
        }
        var oldW = width, oldH = height;
        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.
        var _ref = this.slack || [
            0,
            0
        ], slackW = _ref[0], slackH = _ref[1];
        width += slackW;
        height += slackH;
        if (minConstraints) {
            width = Math.max(minConstraints[0], width);
            height = Math.max(minConstraints[1], height);
        }
        if (maxConstraints) {
            width = Math.min(maxConstraints[0], width);
            height = Math.min(maxConstraints[1], height);
        }
        // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
        this.slack = [
            slackW + (oldW - width),
            slackH + (oldH - height)
        ];
        return [
            width,
            height
        ];
    };
    _proto.resizeHandler = function resizeHandler(handlerName, axis) {
        var _this2 = this;
        return function(e, _ref2) {
            var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            // Reset data in case it was left over somehow (should not be possible)
            if (handlerName === 'onResizeStart') _this2.resetData();
            // Axis restrictions
            var canDragX = (_this2.props.axis === 'both' || _this2.props.axis === 'x') && axis !== 'n' && axis !== 's';
            var canDragY = (_this2.props.axis === 'both' || _this2.props.axis === 'y') && axis !== 'e' && axis !== 'w';
            // No dragging possible.
            if (!canDragX && !canDragY) return;
            // Decompose axis for later use
            var axisV = axis[0];
            var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
            // Track the element being dragged to account for changes in position.
            // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
            // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
            var handleRect = node.getBoundingClientRect();
            if (_this2.lastHandleRect != null) {
                // If the handle has repositioned on either axis since last render,
                // we need to increase our callback values by this much.
                // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
                if (axisH === 'w') {
                    var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
                    deltaX += deltaLeftSinceLast;
                }
                if (axisV === 'n') {
                    var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
                    deltaY += deltaTopSinceLast;
                }
            }
            // Storage of last rect so we know how much it has really moved.
            _this2.lastHandleRect = handleRect;
            // Reverse delta if using top or left drag handles.
            if (axisH === 'w') deltaX = -deltaX;
            if (axisV === 'n') deltaY = -deltaY;
            // Update w/h by the deltas. Also factor in transformScale.
            var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
            var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0);
            // Run user-provided constraints.
            var _this2$runConstraints = _this2.runConstraints(width, height);
            width = _this2$runConstraints[0];
            height = _this2$runConstraints[1];
            var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height;
            // Call user-supplied callback if present.
            var cb = typeof _this2.props[handlerName] === 'function' ? _this2.props[handlerName] : null;
            // Don't call 'onResize' if dimensions haven't changed.
            var shouldSkipCb = handlerName === 'onResize' && !dimensionsChanged;
            if (cb && !shouldSkipCb) {
                e.persist == null || e.persist();
                cb(e, {
                    node: node,
                    size: {
                        width: width,
                        height: height
                    },
                    handle: axis
                });
            }
            // Reset internal data
            if (handlerName === 'onResizeStop') _this2.resetData();
        };
    };
    _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref) {
        var handle = this.props.handle;
        // No handle provided, make the default
        if (!handle) return /*#__PURE__*/ $e0b2395cc879a2ce$var$React.createElement("span", {
            className: "react-resizable-handle react-resizable-handle-" + handleAxis,
            ref: ref
        });
        // Handle is a function, such as:
        // `handle={(handleAxis) => <span className={...} />}`
        if (typeof handle === 'function') return handle(handleAxis, ref);
        // Handle is a React component (composite or DOM).
        var isDOMElement = typeof handle.type === 'string';
        var props = $e0b2395cc879a2ce$var$_objectSpread({
            ref: ref
        }, isDOMElement ? {} : {
            handleAxis: handleAxis
        });
        return /*#__PURE__*/ $e0b2395cc879a2ce$var$React.cloneElement(handle, props);
    };
    _proto.render = function render() {
        var _this3 = this;
        // Pass along only props not meant for the `<Resizable>`.`
        // eslint-disable-next-line no-unused-vars
        var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts, width = _this$props2.width, height = _this$props2.height, handle = _this$props2.handle, handleSize = _this$props2.handleSize, lockAspectRatio = _this$props2.lockAspectRatio, axis = _this$props2.axis, minConstraints = _this$props2.minConstraints, maxConstraints = _this$props2.maxConstraints, onResize = _this$props2.onResize, onResizeStop = _this$props2.onResizeStop, onResizeStart = _this$props2.onResizeStart, resizeHandles = _this$props2.resizeHandles, transformScale = _this$props2.transformScale, p = $e0b2395cc879a2ce$var$_objectWithoutPropertiesLoose(_this$props2, $e0b2395cc879a2ce$var$_excluded);
        // What we're doing here is getting the child of this element, and cloning it with this element's props.
        // We are then defining its children as:
        // 1. Its original children (resizable's child's children), and
        // 2. One or more draggable handles.
        return (0, $9hj2w.cloneElement)(children, $e0b2395cc879a2ce$var$_objectSpread($e0b2395cc879a2ce$var$_objectSpread({}, p), {}, {
            className: (className ? className + " " : '') + "react-resizable",
            children: [].concat(children.props.children, resizeHandles.map(function(handleAxis) {
                var _this3$handleRefs$han;
                // Create a ref to the handle so that `<DraggableCore>` doesn't have to use ReactDOM.findDOMNode().
                var ref = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /*#__PURE__*/ $e0b2395cc879a2ce$var$React.createRef();
                return /*#__PURE__*/ $e0b2395cc879a2ce$var$React.createElement($5tu7N.DraggableCore, $e0b2395cc879a2ce$var$_extends({}, draggableOpts, {
                    nodeRef: ref,
                    key: "resizableHandle-" + handleAxis,
                    onStop: _this3.resizeHandler('onResizeStop', handleAxis),
                    onStart: _this3.resizeHandler('onResizeStart', handleAxis),
                    onDrag: _this3.resizeHandler('onResize', handleAxis)
                }), _this3.renderResizeHandle(handleAxis, ref));
            }))
        }));
    };
    return Resizable;
}($e0b2395cc879a2ce$var$React.Component);
$e0b2395cc879a2ce$export$2e2bcd8739ae039 = $e0b2395cc879a2ce$var$Resizable;
$e0b2395cc879a2ce$var$Resizable.propTypes = $fza6r.resizableProps;
$e0b2395cc879a2ce$var$Resizable.defaultProps = {
    axis: 'both',
    handleSize: [
        20,
        20
    ],
    lockAspectRatio: false,
    minConstraints: [
        20,
        20
    ],
    maxConstraints: [
        Infinity,
        Infinity
    ],
    resizeHandles: [
        'se'
    ],
    transformScale: 1
};

});
parcelRegister("9hj2w", function(module, exports) {

$parcel$export(module.exports, "cloneElement", () => $6c147875e41b4807$export$e530037191fcd5d7, (v) => $6c147875e41b4807$export$e530037191fcd5d7 = v);
var $6c147875e41b4807$export$1e511d4a378977f5;
var $6c147875e41b4807$export$e530037191fcd5d7;
"use strict";
$6c147875e41b4807$export$1e511d4a378977f5 = true;
$6c147875e41b4807$export$e530037191fcd5d7 = $6c147875e41b4807$var$cloneElement;

var $6c147875e41b4807$var$_react = $6c147875e41b4807$var$_interopRequireDefault((parcelRequire("7hzE7")));
function $6c147875e41b4807$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6c147875e41b4807$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6c147875e41b4807$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6c147875e41b4807$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6c147875e41b4807$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6c147875e41b4807$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6c147875e41b4807$var$_defineProperty(obj, key, value) {
    key = $6c147875e41b4807$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6c147875e41b4807$var$_toPropertyKey(arg) {
    var key = $6c147875e41b4807$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6c147875e41b4807$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// React.addons.cloneWithProps look-alike that merges style & className.
function $6c147875e41b4807$var$cloneElement(element, props) {
    if (props.style && element.props.style) props.style = $6c147875e41b4807$var$_objectSpread($6c147875e41b4807$var$_objectSpread({}, element.props.style), props.style);
    if (props.className && element.props.className) props.className = element.props.className + " " + props.className;
    return /*#__PURE__*/ $6c147875e41b4807$var$_react.default.cloneElement(element, props);
}

});

parcelRegister("fza6r", function(module, exports) {

$parcel$export(module.exports, "resizableProps", () => $b551f62124408d56$export$32a002ec6a601762, (v) => $b551f62124408d56$export$32a002ec6a601762 = v);
var $b551f62124408d56$export$1e511d4a378977f5;
var $b551f62124408d56$export$32a002ec6a601762;
"use strict";
$b551f62124408d56$export$1e511d4a378977f5 = true;
$b551f62124408d56$export$32a002ec6a601762 = void 0;

var $b551f62124408d56$var$_propTypes = $b551f62124408d56$var$_interopRequireDefault((parcelRequire("lvJGa")));
parcelRequire("5tu7N");
function $b551f62124408d56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b551f62124408d56$var$resizableProps = {
    /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */ axis: $b551f62124408d56$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    className: $b551f62124408d56$var$_propTypes.default.string,
    /*
  * Require that one and only one child be present.
  * */ children: $b551f62124408d56$var$_propTypes.default.element.isRequired,
    /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */ draggableOpts: $b551f62124408d56$var$_propTypes.default.shape({
        allowAnyClick: $b551f62124408d56$var$_propTypes.default.bool,
        cancel: $b551f62124408d56$var$_propTypes.default.string,
        children: $b551f62124408d56$var$_propTypes.default.node,
        disabled: $b551f62124408d56$var$_propTypes.default.bool,
        enableUserSelectHack: $b551f62124408d56$var$_propTypes.default.bool,
        offsetParent: $b551f62124408d56$var$_propTypes.default.node,
        grid: $b551f62124408d56$var$_propTypes.default.arrayOf($b551f62124408d56$var$_propTypes.default.number),
        handle: $b551f62124408d56$var$_propTypes.default.string,
        nodeRef: $b551f62124408d56$var$_propTypes.default.object,
        onStart: $b551f62124408d56$var$_propTypes.default.func,
        onDrag: $b551f62124408d56$var$_propTypes.default.func,
        onStop: $b551f62124408d56$var$_propTypes.default.func,
        onMouseDown: $b551f62124408d56$var$_propTypes.default.func,
        scale: $b551f62124408d56$var$_propTypes.default.number
    }),
    /*
  * Initial height
  * */ height: function height() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var props = args[0];
        // Required if resizing height or both
        if (props.axis === 'both' || props.axis === 'y') {
            var _PropTypes$number;
            return (_PropTypes$number = $b551f62124408d56$var$_propTypes.default.number).isRequired.apply(_PropTypes$number, args);
        }
        return $b551f62124408d56$var$_propTypes.default.number.apply($b551f62124408d56$var$_propTypes.default, args);
    },
    /*
  * Customize cursor resize handle
  * */ handle: $b551f62124408d56$var$_propTypes.default.oneOfType([
        $b551f62124408d56$var$_propTypes.default.node,
        $b551f62124408d56$var$_propTypes.default.func
    ]),
    /*
  * If you change this, be sure to update your css
  * */ handleSize: $b551f62124408d56$var$_propTypes.default.arrayOf($b551f62124408d56$var$_propTypes.default.number),
    lockAspectRatio: $b551f62124408d56$var$_propTypes.default.bool,
    /*
  * Max X & Y measure
  * */ maxConstraints: $b551f62124408d56$var$_propTypes.default.arrayOf($b551f62124408d56$var$_propTypes.default.number),
    /*
  * Min X & Y measure
  * */ minConstraints: $b551f62124408d56$var$_propTypes.default.arrayOf($b551f62124408d56$var$_propTypes.default.number),
    /*
  * Called on stop resize event
  * */ onResizeStop: $b551f62124408d56$var$_propTypes.default.func,
    /*
  * Called on start resize event
  * */ onResizeStart: $b551f62124408d56$var$_propTypes.default.func,
    /*
  * Called on resize event
  * */ onResize: $b551f62124408d56$var$_propTypes.default.func,
    /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */ resizeHandles: $b551f62124408d56$var$_propTypes.default.arrayOf($b551f62124408d56$var$_propTypes.default.oneOf([
        's',
        'w',
        'e',
        'n',
        'sw',
        'nw',
        'se',
        'ne'
    ])),
    /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */ transformScale: $b551f62124408d56$var$_propTypes.default.number,
    /*
   * Initial width
   */ width: function width() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var props = args[0];
        // Required if resizing width or both
        if (props.axis === 'both' || props.axis === 'x') {
            var _PropTypes$number2;
            return (_PropTypes$number2 = $b551f62124408d56$var$_propTypes.default.number).isRequired.apply(_PropTypes$number2, args);
        }
        return $b551f62124408d56$var$_propTypes.default.number.apply($b551f62124408d56$var$_propTypes.default, args);
    }
};
$b551f62124408d56$export$32a002ec6a601762 = $b551f62124408d56$var$resizableProps;

});


parcelRegister("cPRtU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9583bbbdf445a491$export$2e2bcd8739ae039, (v) => $9583bbbdf445a491$export$2e2bcd8739ae039 = v);
var $9583bbbdf445a491$export$1e511d4a378977f5;
var $9583bbbdf445a491$export$2e2bcd8739ae039;
"use strict";
$9583bbbdf445a491$export$1e511d4a378977f5 = true;
$9583bbbdf445a491$export$2e2bcd8739ae039 = void 0;

var $9583bbbdf445a491$var$React = $9583bbbdf445a491$var$_interopRequireWildcard((parcelRequire("7hzE7")));

var $9583bbbdf445a491$var$_propTypes = $9583bbbdf445a491$var$_interopRequireDefault((parcelRequire("lvJGa")));

var $9583bbbdf445a491$var$_Resizable = $9583bbbdf445a491$var$_interopRequireDefault((parcelRequire("ji3fW")));

var $fza6r = parcelRequire("fza6r");
var $9583bbbdf445a491$var$_excluded = [
    "handle",
    "handleSize",
    "onResize",
    "onResizeStart",
    "onResizeStop",
    "draggableOpts",
    "minConstraints",
    "maxConstraints",
    "lockAspectRatio",
    "axis",
    "width",
    "height",
    "resizeHandles",
    "style",
    "transformScale"
];
function $9583bbbdf445a491$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9583bbbdf445a491$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9583bbbdf445a491$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9583bbbdf445a491$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9583bbbdf445a491$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9583bbbdf445a491$var$_extends() {
    $9583bbbdf445a491$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9583bbbdf445a491$var$_extends.apply(this, arguments);
}
function $9583bbbdf445a491$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9583bbbdf445a491$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9583bbbdf445a491$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9583bbbdf445a491$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9583bbbdf445a491$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9583bbbdf445a491$var$_defineProperty(obj, key, value) {
    key = $9583bbbdf445a491$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9583bbbdf445a491$var$_toPropertyKey(arg) {
    var key = $9583bbbdf445a491$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $9583bbbdf445a491$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9583bbbdf445a491$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9583bbbdf445a491$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $9583bbbdf445a491$var$_setPrototypeOf(subClass, superClass);
}
function $9583bbbdf445a491$var$_setPrototypeOf(o, p) {
    $9583bbbdf445a491$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9583bbbdf445a491$var$_setPrototypeOf(o, p);
}
var $9583bbbdf445a491$var$ResizableBox = /*#__PURE__*/ function(_React$Component) {
    $9583bbbdf445a491$var$_inheritsLoose(ResizableBox, _React$Component);
    function ResizableBox() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            width: _this.props.width,
            height: _this.props.height,
            propsWidth: _this.props.width,
            propsHeight: _this.props.height
        };
        _this.onResize = function(e, data) {
            var size = data.size;
            if (_this.props.onResize) {
                e.persist == null || e.persist();
                _this.setState(size, function() {
                    return _this.props.onResize && _this.props.onResize(e, data);
                });
            } else _this.setState(size);
        };
        return _this;
    }
    ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If parent changes height/width, set that in our state.
        if (state.propsWidth !== props.width || state.propsHeight !== props.height) return {
            width: props.width,
            height: props.height,
            propsWidth: props.width,
            propsHeight: props.height
        };
        return null;
    };
    var _proto = ResizableBox.prototype;
    _proto.render = function render() {
        // Basic wrapper around a Resizable instance.
        // If you use Resizable directly, you are responsible for updating the child component
        // with a new width and height.
        var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize, onResize = _this$props.onResize, onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, width = _this$props.width, height = _this$props.height, resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = $9583bbbdf445a491$var$_objectWithoutPropertiesLoose(_this$props, $9583bbbdf445a491$var$_excluded);
        return /*#__PURE__*/ $9583bbbdf445a491$var$React.createElement($9583bbbdf445a491$var$_Resizable.default, {
            axis: axis,
            draggableOpts: draggableOpts,
            handle: handle,
            handleSize: handleSize,
            height: this.state.height,
            lockAspectRatio: lockAspectRatio,
            maxConstraints: maxConstraints,
            minConstraints: minConstraints,
            onResizeStart: onResizeStart,
            onResize: this.onResize,
            onResizeStop: onResizeStop,
            resizeHandles: resizeHandles,
            transformScale: transformScale,
            width: this.state.width
        }, /*#__PURE__*/ $9583bbbdf445a491$var$React.createElement("div", $9583bbbdf445a491$var$_extends({}, props, {
            style: $9583bbbdf445a491$var$_objectSpread($9583bbbdf445a491$var$_objectSpread({}, style), {}, {
                width: this.state.width + 'px',
                height: this.state.height + 'px'
            })
        })));
    };
    return ResizableBox;
}($9583bbbdf445a491$var$React.Component);
$9583bbbdf445a491$export$2e2bcd8739ae039 = $9583bbbdf445a491$var$ResizableBox;
// PropTypes are identical to <Resizable>, except that children are not strictly required to be present.
$9583bbbdf445a491$var$ResizableBox.propTypes = $9583bbbdf445a491$var$_objectSpread($9583bbbdf445a491$var$_objectSpread({}, $fza6r.resizableProps), {}, {
    children: $9583bbbdf445a491$var$_propTypes.default.element
});

});


parcelRegister("11VIj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resizeHandleType = module.exports.resizeHandleAxesType = module.exports.default = void 0;

var $0c02a72f38cf935f$var$_propTypes = $0c02a72f38cf935f$var$_interopRequireDefault((parcelRequire("lvJGa")));

var $0c02a72f38cf935f$var$_react = $0c02a72f38cf935f$var$_interopRequireDefault((parcelRequire("7hzE7")));
function $0c02a72f38cf935f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*:: import type {
  Ref,
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  DragOverEvent,
  EventCallback,
  CompactType,
  Layout,
  LayoutItem,
  ResizeHandleAxis
} from "./utils";*/ /*:: export type ReactRef<T: HTMLElement> = {|
  +current: T | null
|};*/ // util
/*:: export type ResizeHandle =
  | ReactElement<any>
  | ((
      resizeHandleAxis: ResizeHandleAxis,
      ref: ReactRef<HTMLElement>
    ) => ReactElement<any>);*/ // Defines which resize handles should be rendered (default: 'se')
// Allows for any combination of:
// 's' - South handle (bottom-center)
// 'w' - West handle (left-center)
// 'e' - East handle (right-center)
// 'n' - North handle (top-center)
// 'sw' - Southwest handle (bottom-left)
// 'nw' - Northwest handle (top-left)
// 'se' - Southeast handle (bottom-right)
// 'ne' - Northeast handle (top-right)
const $0c02a72f38cf935f$var$resizeHandleAxesType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleAxesType = $0c02a72f38cf935f$var$_propTypes.default.arrayOf($0c02a72f38cf935f$var$_propTypes.default.oneOf([
    "s",
    "w",
    "e",
    "n",
    "sw",
    "nw",
    "se",
    "ne"
]));
// Custom component for resize handles
const $0c02a72f38cf935f$var$resizeHandleType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleType = $0c02a72f38cf935f$var$_propTypes.default.oneOfType([
    $0c02a72f38cf935f$var$_propTypes.default.node,
    $0c02a72f38cf935f$var$_propTypes.default.func
]);

/*:: export type Props = {|
  className: string,
  style: Object,
  width: number,
  autoSize: boolean,
  cols: number,
  draggableCancel: string,
  draggableHandle: string,
  verticalCompact: boolean,
  compactType: CompactType,
  layout: Layout,
  margin: [number, number],
  containerPadding: ?[number, number],
  rowHeight: number,
  maxRows: number,
  isBounded: boolean,
  isDraggable: boolean,
  isResizable: boolean,
  isDroppable: boolean,
  preventCollision: boolean,
  useCSSTransforms: boolean,
  transformScale: number,
  droppingItem: $Shape<LayoutItem>,
  resizeHandles: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,
  allowOverlap: boolean,

  // Callbacks
  onLayoutChange: Layout => void,
  onDrag: EventCallback,
  onDragStart: EventCallback,
  onDragStop: EventCallback,
  onResize: EventCallback,
  onResizeStart: EventCallback,
  onResizeStop: EventCallback,
  onDropDragOver: (e: DragOverEvent) => ?({| w?: number, h?: number |} | false),
  onDrop: (layout: Layout, item: ?LayoutItem, e: Event) => void,
  children: ReactChildrenArray<ReactElement<any>>,
  innerRef?: Ref<"div">
|};*/ /*:: export type DefaultProps = $Diff<
  Props,
  {
    children: ReactChildrenArray<ReactElement<any>>,
    width: number
  }
>;*/ var $0c02a72f38cf935f$var$_default = module.exports.default = {
    //
    // Basic props
    //
    className: $0c02a72f38cf935f$var$_propTypes.default.string,
    style: $0c02a72f38cf935f$var$_propTypes.default.object,
    // This can be set explicitly. If it is not set, it will automatically
    // be set to the container width. Note that resizes will *not* cause this to adjust.
    // If you need that behavior, use WidthProvider.
    width: $0c02a72f38cf935f$var$_propTypes.default.number,
    // If true, the container height swells and contracts to fit contents
    autoSize: $0c02a72f38cf935f$var$_propTypes.default.bool,
    // # of cols.
    cols: $0c02a72f38cf935f$var$_propTypes.default.number,
    // A selector that will not be draggable.
    draggableCancel: $0c02a72f38cf935f$var$_propTypes.default.string,
    // A selector for the draggable handler
    draggableHandle: $0c02a72f38cf935f$var$_propTypes.default.string,
    // Deprecated
    verticalCompact: function(props /*: Props*/ ) {
        props.verticalCompact;
    },
    // Choose vertical or hotizontal compaction
    compactType: $0c02a72f38cf935f$var$_propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    // layout is an array of object with the format:
    // {x: Number, y: Number, w: Number, h: Number, i: String}
    layout: function(props /*: Props*/ ) {
        var layout = props.layout;
        // I hope you're setting the data-grid property on the grid items
        if (layout === undefined) return;
        (parcelRequire("85pJf")).validateLayout(layout, "layout");
    },
    //
    // Grid Dimensions
    //
    // Margin between items [x, y] in px
    margin: $0c02a72f38cf935f$var$_propTypes.default.arrayOf($0c02a72f38cf935f$var$_propTypes.default.number),
    // Padding inside the container [x, y] in px
    containerPadding: $0c02a72f38cf935f$var$_propTypes.default.arrayOf($0c02a72f38cf935f$var$_propTypes.default.number),
    // Rows have a static height, but you can change this based on breakpoints if you like
    rowHeight: $0c02a72f38cf935f$var$_propTypes.default.number,
    // Default Infinity, but you can specify a max here if you like.
    // Note that this isn't fully fleshed out and won't error if you specify a layout that
    // extends beyond the row capacity. It will, however, not allow users to drag/resize
    // an item past the barrier. They can push items beyond the barrier, though.
    // Intentionally not documented for this reason.
    maxRows: $0c02a72f38cf935f$var$_propTypes.default.number,
    //
    // Flags
    //
    isBounded: $0c02a72f38cf935f$var$_propTypes.default.bool,
    isDraggable: $0c02a72f38cf935f$var$_propTypes.default.bool,
    isResizable: $0c02a72f38cf935f$var$_propTypes.default.bool,
    // If true, grid can be placed one over the other.
    allowOverlap: $0c02a72f38cf935f$var$_propTypes.default.bool,
    // If true, grid items won't change position when being dragged over.
    preventCollision: $0c02a72f38cf935f$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $0c02a72f38cf935f$var$_propTypes.default.bool,
    // parent layout transform scale
    transformScale: $0c02a72f38cf935f$var$_propTypes.default.number,
    // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
    isDroppable: $0c02a72f38cf935f$var$_propTypes.default.bool,
    // Resize handle options
    resizeHandles: $0c02a72f38cf935f$var$resizeHandleAxesType,
    resizeHandle: $0c02a72f38cf935f$var$resizeHandleType,
    //
    // Callbacks
    //
    // Callback so you can save the layout. Calls after each drag & resize stops.
    onLayoutChange: $0c02a72f38cf935f$var$_propTypes.default.func,
    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
    onDragStart: $0c02a72f38cf935f$var$_propTypes.default.func,
    // Calls on each drag movement.
    onDrag: $0c02a72f38cf935f$var$_propTypes.default.func,
    // Calls when drag is complete.
    onDragStop: $0c02a72f38cf935f$var$_propTypes.default.func,
    //Calls when resize starts.
    onResizeStart: $0c02a72f38cf935f$var$_propTypes.default.func,
    // Calls when resize movement happens.
    onResize: $0c02a72f38cf935f$var$_propTypes.default.func,
    // Calls when resize is complete.
    onResizeStop: $0c02a72f38cf935f$var$_propTypes.default.func,
    // Calls when some element is dropped.
    onDrop: $0c02a72f38cf935f$var$_propTypes.default.func,
    //
    // Other validations
    //
    droppingItem: $0c02a72f38cf935f$var$_propTypes.default.shape({
        i: $0c02a72f38cf935f$var$_propTypes.default.string.isRequired,
        w: $0c02a72f38cf935f$var$_propTypes.default.number.isRequired,
        h: $0c02a72f38cf935f$var$_propTypes.default.number.isRequired
    }),
    // Children must not have duplicate keys.
    children: function(props /*: Props*/ , propName /*: string*/ ) {
        const children = props[propName];
        // Check children keys for duplicates. Throw if found.
        const keys = {};
        $0c02a72f38cf935f$var$_react.default.Children.forEach(children, function(child) {
            if (child?.key == null) return;
            if (keys[child.key]) throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
            keys[child.key] = true;
        });
    },
    // Optional ref for getting a reference for the wrapping div.
    innerRef: $0c02a72f38cf935f$var$_propTypes.default.any
};

});



parcelRegister("lN2PJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdd05f39d866c549$var$React = $fdd05f39d866c549$var$_interopRequireWildcard((parcelRequire("7hzE7")));

var $fdd05f39d866c549$var$_propTypes = $fdd05f39d866c549$var$_interopRequireDefault((parcelRequire("lvJGa")));

var $iykXw = parcelRequire("iykXw");

var $85pJf = parcelRequire("85pJf");

var $6SzlB = parcelRequire("6SzlB");

var $fdd05f39d866c549$var$_ReactGridLayout = $fdd05f39d866c549$var$_interopRequireDefault((parcelRequire("2Wppk")));
function $fdd05f39d866c549$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fdd05f39d866c549$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fdd05f39d866c549$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $fdd05f39d866c549$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $fdd05f39d866c549$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $fdd05f39d866c549$var$_extends() {
    $fdd05f39d866c549$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fdd05f39d866c549$var$_extends.apply(this, arguments);
}
function $fdd05f39d866c549$var$_defineProperty(obj, key, value) {
    key = $fdd05f39d866c549$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fdd05f39d866c549$var$_toPropertyKey(arg) {
    var key = $fdd05f39d866c549$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $fdd05f39d866c549$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import { type Layout, type Pick } from "./utils";*/  /*:: import { type ResponsiveLayout, type OnLayoutChangeCallback, type Breakpoints } from "./responsiveUtils";*/ 
// $FlowFixMe[method-unbinding]
const $fdd05f39d866c549$var$type = (obj)=>Object.prototype.toString.call(obj);
/**
 * Get a value of margin or containerPadding.
 *
 * @param  {Array | Object} param Margin | containerPadding, e.g. [10, 10] | {lg: [10, 10], ...}.
 * @param  {String} breakpoint   Breakpoint: lg, md, sm, xs and etc.
 * @return {Array}
 */ function $fdd05f39d866c549$var$getIndentationValue(param /*: { [key: string]: T } | T*/ , breakpoint /*: string*/ ) /*: T*/ {
    // $FlowIgnore TODO fix this typedef
    if (param == null) return null;
    // $FlowIgnore TODO fix this typedef
    return Array.isArray(param) ? param : param[breakpoint];
}
/*:: type State = {
  layout: Layout,
  breakpoint: string,
  cols: number,
  layouts?: ResponsiveLayout<string>
};*/ /*:: type Props<Breakpoint: string = string> = {|
  ...React.ElementConfig<typeof ReactGridLayout>,

  // Responsive config
  breakpoint?: ?Breakpoint,
  breakpoints: Breakpoints<Breakpoint>,
  cols: { [key: Breakpoint]: number },
  layouts: ResponsiveLayout<Breakpoint>,
  width: number,
  margin: { [key: Breakpoint]: [number, number] } | [number, number],
  /* prettier-ignore *-/
  containerPadding: { [key: Breakpoint]: ?[number, number] } | ?[number, number],

  // Callbacks
  onBreakpointChange: (Breakpoint, cols: number) => void,
  onLayoutChange: OnLayoutChangeCallback,
  onWidthChange: (
    containerWidth: number,
    margin: [number, number],
    cols: number,
    containerPadding: ?[number, number]
  ) => void
|};*/ /*:: type DefaultProps = Pick<
  Props<>,
  {|
    allowOverlap: 0,
    breakpoints: 0,
    cols: 0,
    containerPadding: 0,
    layouts: 0,
    margin: 0,
    onBreakpointChange: 0,
    onLayoutChange: 0,
    onWidthChange: 0
  |}
>;*/ class $fdd05f39d866c549$var$ResponsiveReactGridLayout extends $fdd05f39d866c549$var$React.Component {
    constructor(){
        super(...arguments);
        $fdd05f39d866c549$var$_defineProperty(this, "state", this.generateInitialState());
        // wrap layouts so we do not need to pass layouts to child
        $fdd05f39d866c549$var$_defineProperty(this, "onLayoutChange", (layout /*: Layout*/ )=>{
            this.props.onLayoutChange(layout, {
                ...this.props.layouts,
                [this.state.breakpoint]: layout
            });
        });
    }
    generateInitialState() /*: State*/ {
        const { width: width, breakpoints: breakpoints, layouts: layouts, cols: cols } = this.props;
        const breakpoint = (0, $6SzlB.getBreakpointFromWidth)(breakpoints, width);
        const colNo = (0, $6SzlB.getColsFromBreakpoint)(breakpoint, cols);
        // verticalCompact compatibility, now deprecated
        const compactType = this.props.verticalCompact === false ? null : this.props.compactType;
        // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
        // for this layout.
        const initialLayout = (0, $6SzlB.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType);
        return {
            layout: initialLayout,
            breakpoint: breakpoint,
            cols: colNo
        };
    }
    static getDerivedStateFromProps(nextProps /*: Props<*>*/ , prevState /*: State*/ ) /*: ?$Shape<State>*/ {
        if (!(0, $iykXw.deepEqual)(nextProps.layouts, prevState.layouts)) {
            // Allow parent to set layouts directly.
            const { breakpoint: breakpoint, cols: cols } = prevState;
            // Since we're setting an entirely new layout object, we must generate a new responsive layout
            // if one does not exist.
            const newLayout = (0, $6SzlB.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, cols, nextProps.compactType);
            return {
                layout: newLayout,
                layouts: nextProps.layouts
            };
        }
        return null;
    }
    componentDidUpdate(prevProps /*: Props<*>*/ ) {
        // Allow parent to set width or breakpoint directly.
        if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, $iykXw.deepEqual)(this.props.breakpoints, prevProps.breakpoints) || !(0, $iykXw.deepEqual)(this.props.cols, prevProps.cols)) this.onWidthChange(prevProps);
    }
    /**
   * When the width changes work through breakpoints and reset state with the new width & breakpoint.
   * Width changes are necessary to figure out the widget widths.
   */ onWidthChange(prevProps /*: Props<*>*/ ) {
        const { breakpoints: breakpoints, cols: cols, layouts: layouts, compactType: compactType } = this.props;
        const newBreakpoint = this.props.breakpoint || (0, $6SzlB.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
        const lastBreakpoint = this.state.breakpoint;
        const newCols /*: number*/  = (0, $6SzlB.getColsFromBreakpoint)(newBreakpoint, cols);
        const newLayouts = {
            ...layouts
        };
        // Breakpoint change
        if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
            // Preserve the current layout if the current breakpoint is not present in the next layouts.
            if (!(lastBreakpoint in newLayouts)) newLayouts[lastBreakpoint] = (0, $85pJf.cloneLayout)(this.state.layout);
            // Find or generate a new layout.
            let layout = (0, $6SzlB.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType);
            // This adds missing items.
            layout = (0, $85pJf.synchronizeLayoutWithChildren)(layout, this.props.children, newCols, compactType, this.props.allowOverlap);
            // Store the new layout.
            newLayouts[newBreakpoint] = layout;
            // callbacks
            this.props.onLayoutChange(layout, newLayouts);
            this.props.onBreakpointChange(newBreakpoint, newCols);
            this.setState({
                breakpoint: newBreakpoint,
                layout: layout,
                cols: newCols
            });
        }
        const margin = $fdd05f39d866c549$var$getIndentationValue(this.props.margin, newBreakpoint);
        const containerPadding = $fdd05f39d866c549$var$getIndentationValue(this.props.containerPadding, newBreakpoint);
        //call onWidthChange on every change of width, not only on breakpoint changes
        this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
    }
    render() /*: React.Element<typeof ReactGridLayout>*/ {
        /* eslint-disable no-unused-vars */ const { breakpoint: breakpoint, breakpoints: breakpoints, cols: cols, layouts: layouts, margin: margin, containerPadding: containerPadding, onBreakpointChange: onBreakpointChange, onLayoutChange: onLayoutChange, onWidthChange: onWidthChange, ...other } = this.props;
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $fdd05f39d866c549$var$React.createElement($fdd05f39d866c549$var$_ReactGridLayout.default, $fdd05f39d866c549$var$_extends({}, other, {
            // $FlowIgnore should allow nullable here due to DefaultProps
            margin: $fdd05f39d866c549$var$getIndentationValue(margin, this.state.breakpoint),
            containerPadding: $fdd05f39d866c549$var$getIndentationValue(containerPadding, this.state.breakpoint),
            onLayoutChange: this.onLayoutChange,
            layout: this.state.layout,
            cols: this.state.cols
        }));
    }
}
module.exports.default = $fdd05f39d866c549$var$ResponsiveReactGridLayout;
// This should only include propTypes needed in this code; RGL itself
// will do validation of the rest props passed to it.
$fdd05f39d866c549$var$_defineProperty($fdd05f39d866c549$var$ResponsiveReactGridLayout, "propTypes", {
    //
    // Basic props
    //
    // Optional, but if you are managing width yourself you may want to set the breakpoint
    // yourself as well.
    breakpoint: $fdd05f39d866c549$var$_propTypes.default.string,
    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
    breakpoints: $fdd05f39d866c549$var$_propTypes.default.object,
    allowOverlap: $fdd05f39d866c549$var$_propTypes.default.bool,
    // # of cols. This is a breakpoint -> cols map
    cols: $fdd05f39d866c549$var$_propTypes.default.object,
    // # of margin. This is a breakpoint -> margin map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Margin between items [x, y] in px
    // e.g. [10, 10]
    margin: $fdd05f39d866c549$var$_propTypes.default.oneOfType([
        $fdd05f39d866c549$var$_propTypes.default.array,
        $fdd05f39d866c549$var$_propTypes.default.object
    ]),
    // # of containerPadding. This is a breakpoint -> containerPadding map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Padding inside the container [x, y] in px
    // e.g. [10, 10]
    containerPadding: $fdd05f39d866c549$var$_propTypes.default.oneOfType([
        $fdd05f39d866c549$var$_propTypes.default.array,
        $fdd05f39d866c549$var$_propTypes.default.object
    ]),
    // layouts is an object mapping breakpoints to layouts.
    // e.g. {lg: Layout, md: Layout, ...}
    layouts (props /*: Props<>*/ , propName /*: string*/ ) {
        if ($fdd05f39d866c549$var$type(props[propName]) !== "[object Object]") throw new Error("Layout property must be an object. Received: " + $fdd05f39d866c549$var$type(props[propName]));
        Object.keys(props[propName]).forEach((key)=>{
            if (!(key in props.breakpoints)) throw new Error("Each key in layouts must align with a key in breakpoints.");
            (0, $85pJf.validateLayout)(props.layouts[key], "layouts." + key);
        });
    },
    // The width of this component.
    // Required in this propTypes stanza because generateInitialState() will fail without it.
    width: $fdd05f39d866c549$var$_propTypes.default.number.isRequired,
    //
    // Callbacks
    //
    // Calls back with breakpoint and new # cols
    onBreakpointChange: $fdd05f39d866c549$var$_propTypes.default.func,
    // Callback so you can save the layout.
    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
    onLayoutChange: $fdd05f39d866c549$var$_propTypes.default.func,
    // Calls back with (containerWidth, margin, cols, containerPadding)
    onWidthChange: $fdd05f39d866c549$var$_propTypes.default.func
});
$fdd05f39d866c549$var$_defineProperty($fdd05f39d866c549$var$ResponsiveReactGridLayout, "defaultProps", {
    breakpoints: {
        lg: 1200,
        md: 996,
        sm: 768,
        xs: 480,
        xxs: 0
    },
    cols: {
        lg: 12,
        md: 10,
        sm: 6,
        xs: 4,
        xxs: 2
    },
    containerPadding: {
        lg: null,
        md: null,
        sm: null,
        xs: null,
        xxs: null
    },
    layouts: {},
    margin: [
        10,
        10
    ],
    allowOverlap: false,
    onBreakpointChange: $85pJf.noop,
    onLayoutChange: $85pJf.noop,
    onWidthChange: $85pJf.noop
});

});
parcelRegister("6SzlB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findOrGenerateResponsiveLayout = $50233479bdf0f8e2$var$findOrGenerateResponsiveLayout;
module.exports.getBreakpointFromWidth = $50233479bdf0f8e2$var$getBreakpointFromWidth;
module.exports.getColsFromBreakpoint = $50233479bdf0f8e2$var$getColsFromBreakpoint;
module.exports.sortBreakpoints = $50233479bdf0f8e2$var$sortBreakpoints;

var $85pJf = parcelRequire("85pJf");
/*:: import type { CompactType, Layout } from "./utils";*/ /*:: export type Breakpoint = string;*/ /*:: export type DefaultBreakpoints = "lg" | "md" | "sm" | "xs" | "xxs";*/ /*:: export type ResponsiveLayout<T: Breakpoint> = {
  +[breakpoint: T]: Layout
};*/ // + indicates read-only
/*:: export type Breakpoints<T: Breakpoint> = {
  +[breakpoint: T]: number
};*/ /*:: export type OnLayoutChangeCallback = (
  Layout,
  { [key: Breakpoint]: Layout }
) => void;*/ /**
 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
 *
 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
 * @param  {Number} width Screen width.
 * @return {String}       Highest breakpoint that is less than width.
 */ function $50233479bdf0f8e2$var$getBreakpointFromWidth(breakpoints /*: Breakpoints<Breakpoint>*/ , width /*: number*/ ) /*: Breakpoint*/ {
    const sorted = $50233479bdf0f8e2$var$sortBreakpoints(breakpoints);
    let matching = sorted[0];
    for(let i = 1, len = sorted.length; i < len; i++){
        const breakpointName = sorted[i];
        if (width > breakpoints[breakpointName]) matching = breakpointName;
    }
    return matching;
}
/**
 * Given a breakpoint, get the # of cols set for it.
 * @param  {String} breakpoint Breakpoint name.
 * @param  {Object} cols       Map of breakpoints to cols.
 * @return {Number}            Number of cols.
 */ function $50233479bdf0f8e2$var$getColsFromBreakpoint(breakpoint /*: Breakpoint*/ , cols /*: Breakpoints<Breakpoint>*/ ) /*: number*/ {
    if (!cols[breakpoint]) throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
    return cols[breakpoint];
}
/**
 * Given existing layouts and a new breakpoint, find or generate a new layout.
 *
 * This finds the layout above the new one and generates from it, if it exists.
 *
 * @param  {Object} layouts     Existing layouts.
 * @param  {Array} breakpoints All breakpoints.
 * @param  {String} breakpoint New breakpoint.
 * @param  {String} breakpoint Last breakpoint (for fallback).
 * @param  {Number} cols       Column count at new breakpoint.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}             New layout.
 */ function $50233479bdf0f8e2$var$findOrGenerateResponsiveLayout(layouts /*: ResponsiveLayout<Breakpoint>*/ , breakpoints /*: Breakpoints<Breakpoint>*/ , breakpoint /*: Breakpoint*/ , lastBreakpoint /*: Breakpoint*/ , cols /*: number*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    // If it already exists, just return it.
    if (layouts[breakpoint]) return (0, $85pJf.cloneLayout)(layouts[breakpoint]);
    // Find or generate the next layout
    let layout = layouts[lastBreakpoint];
    const breakpointsSorted = $50233479bdf0f8e2$var$sortBreakpoints(breakpoints);
    const breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
    for(let i = 0, len = breakpointsAbove.length; i < len; i++){
        const b = breakpointsAbove[i];
        if (layouts[b]) {
            layout = layouts[b];
            break;
        }
    }
    layout = (0, $85pJf.cloneLayout)(layout || []); // clone layout so we don't modify existing items
    return (0, $85pJf.compact)((0, $85pJf.correctBounds)(layout, {
        cols: cols
    }), compactType, cols);
}
/**
 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
 * e.g. ['xxs', 'xs', 'sm', ...]
 *
 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
 * @return {Array}              Sorted breakpoints.
 */ function $50233479bdf0f8e2$var$sortBreakpoints(breakpoints /*: Breakpoints<Breakpoint>*/ ) /*: Array<Breakpoint>*/ {
    const keys /*: Array<string>*/  = Object.keys(breakpoints);
    return keys.sort(function(a, b) {
        return breakpoints[a] - breakpoints[b];
    });
}

});


parcelRegister("8EWbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64df305b32f81af1$var$WidthProvideRGL;

var $64df305b32f81af1$var$React = $64df305b32f81af1$var$_interopRequireWildcard((parcelRequire("7hzE7")));

var $64df305b32f81af1$var$_propTypes = $64df305b32f81af1$var$_interopRequireDefault((parcelRequire("lvJGa")));

var $64df305b32f81af1$var$_resizeObserverPolyfill = $64df305b32f81af1$var$_interopRequireDefault((parcelRequire("4kqCC")));

var $64df305b32f81af1$var$_clsx = $64df305b32f81af1$var$_interopRequireDefault((parcelRequire("cfW2W")));
function $64df305b32f81af1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $64df305b32f81af1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($64df305b32f81af1$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $64df305b32f81af1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $64df305b32f81af1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $64df305b32f81af1$var$_extends() {
    $64df305b32f81af1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $64df305b32f81af1$var$_extends.apply(this, arguments);
}
function $64df305b32f81af1$var$_defineProperty(obj, key, value) {
    key = $64df305b32f81af1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $64df305b32f81af1$var$_toPropertyKey(arg) {
    var key = $64df305b32f81af1$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $64df305b32f81af1$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type { ReactRef } from "../ReactGridLayoutPropTypes";*/ /*:: type WPDefaultProps = {|
  measureBeforeMount: boolean
|};*/ /*:: type WPProps = {|
  className?: string,
  style?: Object,
  ...WPDefaultProps
|};*/ // eslint-disable-next-line no-unused-vars
/*:: type WPState = {|
  width: number
|};*/ /*:: type ComposedProps<Config> = {|
  ...Config,
  measureBeforeMount?: boolean,
  className?: string,
  style?: Object,
  width?: number
|};*/ const $64df305b32f81af1$var$layoutClassName = "react-grid-layout";
/*
 * A simple HOC that provides facility for listening to container resizes.
 *
 * The Flow type is pretty janky here. I can't just spread `WPProps` into this returned object - I wish I could - but it triggers
 * a flow bug of some sort that causes it to stop typechecking.
 */ function $64df305b32f81af1$var$WidthProvideRGL(ComposedComponent /*: React.AbstractComponent<Config>*/ ) /*: React.AbstractComponent<ComposedProps<Config>>*/ {
    var _class;
    return _class = class WidthProvider extends $64df305b32f81af1$var$React.Component {
        constructor(){
            super(...arguments);
            $64df305b32f81af1$var$_defineProperty(this, "state", {
                width: 1280
            });
            $64df305b32f81af1$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $64df305b32f81af1$var$React.createRef());
            $64df305b32f81af1$var$_defineProperty(this, "mounted", false);
            $64df305b32f81af1$var$_defineProperty(this, "resizeObserver", void 0);
        }
        componentDidMount() {
            this.mounted = true;
            this.resizeObserver = new $64df305b32f81af1$var$_resizeObserverPolyfill.default((entries)=>{
                const node = this.elementRef.current;
                if (node instanceof HTMLElement) {
                    const width = entries[0].contentRect.width;
                    this.setState({
                        width: width
                    });
                }
            });
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.observe(node);
        }
        componentWillUnmount() {
            this.mounted = false;
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.unobserve(node);
            this.resizeObserver.disconnect();
        }
        render() {
            const { measureBeforeMount: measureBeforeMount, ...rest } = this.props;
            if (measureBeforeMount && !this.mounted) return /*#__PURE__*/ $64df305b32f81af1$var$React.createElement("div", {
                className: (0, $64df305b32f81af1$var$_clsx.default)(this.props.className, $64df305b32f81af1$var$layoutClassName),
                style: this.props.style,
                ref: this.elementRef
            });
            return /*#__PURE__*/ $64df305b32f81af1$var$React.createElement(ComposedComponent, $64df305b32f81af1$var$_extends({
                innerRef: this.elementRef
            }, rest, this.state));
        }
    }, $64df305b32f81af1$var$_defineProperty(_class, "defaultProps", {
        measureBeforeMount: false
    }), $64df305b32f81af1$var$_defineProperty(_class, "propTypes", {
        // If true, will not render children until mounted. Useful for getting the exact width before
        // rendering, to prevent any unsightly resizing.
        measureBeforeMount: $64df305b32f81af1$var$_propTypes.default.bool
    }), _class;
}

});
parcelRegister("4kqCC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $326dae3bb84cf9e4$export$2e2bcd8739ae039);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $326dae3bb84cf9e4$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $326dae3bb84cf9e4$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $326dae3bb84cf9e4$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $326dae3bb84cf9e4$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($326dae3bb84cf9e4$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $326dae3bb84cf9e4$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $326dae3bb84cf9e4$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $326dae3bb84cf9e4$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $326dae3bb84cf9e4$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $326dae3bb84cf9e4$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $326dae3bb84cf9e4$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $326dae3bb84cf9e4$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $326dae3bb84cf9e4$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $326dae3bb84cf9e4$var$throttle(this.refresh.bind(this), $326dae3bb84cf9e4$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$326dae3bb84cf9e4$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($326dae3bb84cf9e4$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$326dae3bb84cf9e4$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $326dae3bb84cf9e4$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $326dae3bb84cf9e4$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $326dae3bb84cf9e4$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $326dae3bb84cf9e4$var$global$1;
};
// Placeholder of an empty content rectangle.
var $326dae3bb84cf9e4$var$emptyRect = $326dae3bb84cf9e4$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $326dae3bb84cf9e4$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $326dae3bb84cf9e4$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $326dae3bb84cf9e4$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $326dae3bb84cf9e4$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $326dae3bb84cf9e4$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $326dae3bb84cf9e4$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $326dae3bb84cf9e4$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $326dae3bb84cf9e4$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $326dae3bb84cf9e4$var$emptyRect;
    var styles = $326dae3bb84cf9e4$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $326dae3bb84cf9e4$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $326dae3bb84cf9e4$var$toFloat(styles.width), height = $326dae3bb84cf9e4$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $326dae3bb84cf9e4$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $326dae3bb84cf9e4$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$326dae3bb84cf9e4$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $326dae3bb84cf9e4$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $326dae3bb84cf9e4$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $326dae3bb84cf9e4$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $326dae3bb84cf9e4$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $326dae3bb84cf9e4$var$isDocumentElement(target) {
    return target === $326dae3bb84cf9e4$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $326dae3bb84cf9e4$var$getContentRect(target) {
    if (!$326dae3bb84cf9e4$var$isBrowser) return $326dae3bb84cf9e4$var$emptyRect;
    if ($326dae3bb84cf9e4$var$isSVGGraphicsElement(target)) return $326dae3bb84cf9e4$var$getSVGContentRect(target);
    return $326dae3bb84cf9e4$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $326dae3bb84cf9e4$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $326dae3bb84cf9e4$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $326dae3bb84cf9e4$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $326dae3bb84cf9e4$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $326dae3bb84cf9e4$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $326dae3bb84cf9e4$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $326dae3bb84cf9e4$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $326dae3bb84cf9e4$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $326dae3bb84cf9e4$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $326dae3bb84cf9e4$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $326dae3bb84cf9e4$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $326dae3bb84cf9e4$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $326dae3bb84cf9e4$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $326dae3bb84cf9e4$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $326dae3bb84cf9e4$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $326dae3bb84cf9e4$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $326dae3bb84cf9e4$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $326dae3bb84cf9e4$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $326dae3bb84cf9e4$var$ResizeObserverController.getInstance();
        var observer = new $326dae3bb84cf9e4$var$ResizeObserverSPI(callback, controller, this);
        $326dae3bb84cf9e4$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $326dae3bb84cf9e4$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $326dae3bb84cf9e4$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $326dae3bb84cf9e4$var$index = function() {
    // Export existing implementation if available.
    if (typeof $326dae3bb84cf9e4$var$global$1.ResizeObserver !== 'undefined') return $326dae3bb84cf9e4$var$global$1.ResizeObserver;
    return $326dae3bb84cf9e4$var$ResizeObserver;
}();
var $326dae3bb84cf9e4$export$2e2bcd8739ae039 = $326dae3bb84cf9e4$var$index;

});



var $9Oehh = parcelRequire("9Oehh");
var $046b5a639d530697$var$t = /["&<]/;
function $046b5a639d530697$var$n(r) {
    if (0 === r.length || !1 === $046b5a639d530697$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $046b5a639d530697$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $046b5a639d530697$var$f = 0, $046b5a639d530697$var$i = Array.isArray;
function $046b5a639d530697$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: --$046b5a639d530697$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $9Oehh.options).vnode && (0, $9Oehh.options).vnode(l), l;
}
function $046b5a639d530697$export$45700d561b2268ac(r) {
    var t = $046b5a639d530697$export$34b9dba7ce09269b((0, $9Oehh.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $046b5a639d530697$var$c = {}, $046b5a639d530697$var$p = /[A-Z]/g;
function $046b5a639d530697$export$991f6ffe102e5bac(e, t) {
    if ((0, $9Oehh.options).attr) {
        var f = (0, $9Oehh.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if ("ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $046b5a639d530697$var$c[u] || ($046b5a639d530697$var$c[u] = u.replace($046b5a639d530697$var$p, "-$&").toLowerCase()), _ = ";";
                "number" != typeof a || l.startsWith("--") || $046b5a639d530697$var$o.test(l) || (_ = "px;"), i = i + l + ":" + a + _;
            }
        }
        return e + '="' + i + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $046b5a639d530697$var$n(t) + '"';
}
function $046b5a639d530697$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($046b5a639d530697$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $046b5a639d530697$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $046b5a639d530697$var$n("" + r);
}


parcelRequire("7hzE7");
var $8Zslt = parcelRequire("8Zslt");

parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");

parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");
var $ce8f606811d8b5da$var$p = (e)=>!!e;
var $ce8f606811d8b5da$var$n = (e)=>Array.from(new Set(e));
var $ce8f606811d8b5da$export$8aa9c21fdc1955ee = (e, o, ...s)=>{
    for (let i of s){
        let t = $ce8f606811d8b5da$var$l(o, i);
        if (t) return t;
    }
    return e;
}, $ce8f606811d8b5da$var$l = (e, o)=>{
    let s = o().map((r)=>r.toLowerCase()), i = $ce8f606811d8b5da$var$n(s.flatMap((r)=>[
            r,
            r.split("-")[0]
        ])), t = e.map((r)=>r.toLowerCase());
    return i.map((r)=>{
        let c = t.findIndex((x)=>x === r);
        return c >= 0 && e[c];
    }).find($ce8f606811d8b5da$var$p);
};


var $f649875aa6d5db64$var$r = (o, c)=>{
    let t = o?.split(";").map((e)=>e.trim()).find((e)=>e.startsWith(c))?.split("=")[1];
    return t ? [
        t
    ] : [];
};
var $f649875aa6d5db64$export$16ba005fe561ca9a = (o = "lang")=>()=>$f649875aa6d5db64$var$r(document?.cookie, o), $f649875aa6d5db64$export$6834dddc7bf6251a = $f649875aa6d5db64$export$16ba005fe561ca9a();


var $05c61409bedd88cf$var$r = (e)=>!!e;
var $05c61409bedd88cf$export$19d21abe1cae7323 = ()=>[
        document?.documentElement?.lang
    ].filter($05c61409bedd88cf$var$r);


var $9c36dc9dd0aa3b9a$var$e = (r)=>!!r;
var $9c36dc9dd0aa3b9a$export$8b98524ea1702263 = (r = "lang")=>()=>[
            window?.localStorage?.getItem(r)
        ].filter($9c36dc9dd0aa3b9a$var$e), $9c36dc9dd0aa3b9a$export$77b13df39d21d85 = $9c36dc9dd0aa3b9a$export$8b98524ea1702263();


var $fa2c1c82139800cc$export$8131985a11e9904f = ()=>navigator?.languages || [];


var $3907e1549a0c9046$export$2d338d69677752c5 = (e = "lang")=>()=>{
        let t = location?.search?.slice(1).split("&").find((r)=>r.startsWith(e))?.split("=")[1];
        return t ? [
            t
        ] : [];
    }, $3907e1549a0c9046$export$2949d5ee810e90f6 = $3907e1549a0c9046$export$2d338d69677752c5();


var $8bc14c2d78441de9$var$r = (e)=>!!e;
var $8bc14c2d78441de9$export$ede5cdc6204147f7 = (e = "lang")=>()=>[
            window?.sessionStorage?.getItem(e)
        ].filter($8bc14c2d78441de9$var$r), $8bc14c2d78441de9$export$3e7cd3d90ecf4baa = $8bc14c2d78441de9$export$ede5cdc6204147f7();


var $f6febd6ca5bbee8b$var$t = (r)=>r !== "";
var $f6febd6ca5bbee8b$var$s = /;|,/, $f6febd6ca5bbee8b$export$2e228f3c6603c51a = ({ headers: r }, o = "accept-language")=>()=>r.get(o)?.split($f6febd6ca5bbee8b$var$s).filter((e)=>!e.startsWith("q")).map((e)=>e.trim()).filter((e)=>e !== "*").filter($f6febd6ca5bbee8b$var$t) || [];


var $01e3277b6c9a8af9$var$s = (e, t)=>{
    let r = e?.split(";").map((o)=>o.trim()).find((o)=>o.startsWith(t))?.split("=")[1];
    return r ? [
        r
    ] : [];
};
var $01e3277b6c9a8af9$export$139d3b33d50d33f4 = (e, t = "lang")=>()=>$01e3277b6c9a8af9$var$s(e?.cookies, t);


var $2b3877ebc5ac5e3e$var$o = /^((?:\w{2,3}(?:-\w{3})?)(?:-\w{4})?(?:-\w{2}|-\d{3})?(?:-[\w\d]{5,8}|-\d[\w\d]{3})*)\./, $2b3877ebc5ac5e3e$export$d1dac200cc0212f = (e)=>()=>{
        let t = e?.hostname?.match($2b3877ebc5ac5e3e$var$o);
        return t && t[1] ? [
            t[1]
        ] : [];
    };


var $4b42f964dc142e6f$var$e = (r)=>!!r;
var $4b42f964dc142e6f$export$c6e70ab892981e62 = (r, t = "lang")=>()=>[
            r?.params?.[t]
        ].filter($4b42f964dc142e6f$var$e);




// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
// @ts-check
/* eslint-disable */ /**
 * @typedef { import('typesafe-i18n/react').ReactInit<Locales, Translations, TranslationFunctions> } ReactInit
 * @typedef { import('typesafe-i18n/react').I18nContextType<Locales, Translations, TranslationFunctions> } I18nContextType
 * @typedef { import('./i18n-types.js').Formatters } Formatters
 * @typedef { import('./i18n-types.js').Locales } Locales
 * @typedef { import('./i18n-types.js').TranslationFunctions } TranslationFunctions
 * @typedef { import('./i18n-types.js').Translations } Translations
 */ parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");
// src/index.tsx

var $7hzE7 = parcelRequire("7hzE7");
// ../runtime/src/core-utils.mts
var $589c109e31169a8d$var$getFallbackProxy = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    new Proxy(Object.assign(()=>"", {}), {
        get: (_target, key)=>key === "length" ? 0 : $589c109e31169a8d$var$getFallbackProxy()
    });
// ../parser/src/basic.mts
var $589c109e31169a8d$var$removeEmptyValues = (object)=>Object.fromEntries(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(object).map(([key, value])=>key !== "i" && value && value != "0" && [
            key,
            value
        ]).filter(Boolean));
var $589c109e31169a8d$var$trimAllValues = (part)=>Object.fromEntries(Object.keys(part).map((key)=>{
        const val = part[key];
        return [
            key,
            Array.isArray(val) ? val.map((v)=>v?.trim()) : val === !!val ? val : val?.trim()
        ];
    }));
var $589c109e31169a8d$var$parseArgumentPart = (text)=>{
    const [keyPart = "", ...formatterKeys] = text.split("|");
    const [keyWithoutType = "", type] = keyPart.split(":");
    const [key, isOptional] = keyWithoutType.split("?");
    return {
        k: key,
        i: type,
        n: isOptional === "",
        f: formatterKeys
    };
};
var $589c109e31169a8d$var$isBasicPluralPart = (part)=>!!(part.o || part.r);
var $589c109e31169a8d$var$parsePluralPart = (content, lastAccessor)=>{
    let [key, values] = content.split(":");
    if (!values) {
        values = key;
        key = lastAccessor;
    }
    const entries = values.split("|");
    const [zero, one, two, few, many, rest] = entries;
    const nrOfEntries = entries.filter((entry)=>entry !== void 0).length;
    if (nrOfEntries === 1) return {
        k: key,
        r: zero
    };
    if (nrOfEntries === 2) return {
        k: key,
        o: zero,
        r: one
    };
    if (nrOfEntries === 3) return {
        k: key,
        z: zero,
        o: one,
        r: two
    };
    return {
        k: key,
        z: zero,
        o: one,
        t: two,
        f: few,
        m: many,
        r: rest
    };
};
var $589c109e31169a8d$var$REGEX_SWITCH_CASE = /^\{.*\}$/;
var $589c109e31169a8d$var$parseCases = (text)=>Object.fromEntries($589c109e31169a8d$var$removeOuterBrackets(text).split(",").map((part)=>part.split(":")).reduce((accumulator, entry)=>{
        if (entry.length === 2) return [
            ...accumulator,
            entry.map((entry2)=>entry2.trim())
        ];
        accumulator[accumulator.length - 1][1] += "," + entry[0];
        return accumulator;
    }, []));
var $589c109e31169a8d$var$REGEX_BRACKETS_SPLIT = /(\{(?:[^{}]+|\{(?:[^{}]+)*\})*\})/g;
var $589c109e31169a8d$var$removeOuterBrackets = (text)=>text.substring(1, text.length - 1);
var $589c109e31169a8d$var$parseRawText = (rawText, optimize = true, firstKey = "", lastKey = "")=>rawText.split($589c109e31169a8d$var$REGEX_BRACKETS_SPLIT).map((part)=>{
        if (!part.match($589c109e31169a8d$var$REGEX_BRACKETS_SPLIT)) return part;
        const content = $589c109e31169a8d$var$removeOuterBrackets(part);
        if (content.startsWith("{")) return $589c109e31169a8d$var$parsePluralPart($589c109e31169a8d$var$removeOuterBrackets(content), lastKey);
        const parsedPart = $589c109e31169a8d$var$parseArgumentPart(content);
        lastKey = parsedPart.k || lastKey;
        !firstKey && (firstKey = lastKey);
        return parsedPart;
    }).map((part)=>{
        if (typeof part === "string") return part;
        if (!part.k) part.k = firstKey || "0";
        const trimmed = $589c109e31169a8d$var$trimAllValues(part);
        return optimize ? $589c109e31169a8d$var$removeEmptyValues(trimmed) : trimmed;
    });
// ../runtime/src/core.mts
var $589c109e31169a8d$var$applyFormatters = (formatters, formatterKeys, initialValue)=>formatterKeys.reduce((value, formatterKey)=>(formatterKey.match($589c109e31169a8d$var$REGEX_SWITCH_CASE) ? ((cases)=>cases[value] ?? cases["*"])($589c109e31169a8d$var$parseCases(formatterKey)) : formatters[formatterKey]?.(value)) ?? value, initialValue);
var $589c109e31169a8d$var$getPlural = (pluralRules, { z: z, o: o, t: t, f: f, m: m, r: r }, value)=>{
    switch(z && value == 0 ? "zero" : pluralRules.select(value)){
        case "zero":
            return z;
        case "one":
            return o;
        case "two":
            return t;
        case "few":
            return f ?? r;
        case "many":
            return m ?? r;
        default:
            return r;
    }
};
var $589c109e31169a8d$var$REGEX_PLURAL_VALUE_INJECTION = /\?\?/g;
var $589c109e31169a8d$var$applyArguments = (textParts, pluralRules, formatters, args)=>textParts.map((part)=>{
        if (typeof part === "string") return part;
        const { k: key = "0", f: formatterKeys = [] } = part;
        const value = args[key];
        if ($589c109e31169a8d$var$isBasicPluralPart(part)) return ((typeof value === "boolean" ? value ? part.o : part.r : $589c109e31169a8d$var$getPlural(pluralRules, part, value)) || "").replace($589c109e31169a8d$var$REGEX_PLURAL_VALUE_INJECTION, value);
        const formattedValue = formatterKeys.length ? $589c109e31169a8d$var$applyFormatters(formatters, formatterKeys, value) : value;
        return ("" + (formattedValue ?? "")).trim();
    }).join("");
var $589c109e31169a8d$var$translate = (textParts, pluralRules, formatters, args)=>{
    const firstArg = args[0];
    const isObject = firstArg && typeof firstArg === "object" && firstArg.constructor === Object;
    const transformedArgs = args.length === 1 && isObject ? firstArg : args;
    return $589c109e31169a8d$var$applyArguments(textParts, pluralRules, formatters, transformedArgs);
};
// ../runtime/src/util.string.mts
var $589c109e31169a8d$var$getPartsFromString = (cache, text)=>cache[text] || (cache[text] = $589c109e31169a8d$var$parseRawText(text));
// ../runtime/src/util.object.mts
var $589c109e31169a8d$var$getTranslateInstance = (locale, formatters)=>{
    const cache = {};
    const pluralRules = new Intl.PluralRules(locale);
    return (text, ...args)=>$589c109e31169a8d$var$translate($589c109e31169a8d$var$getPartsFromString(cache, text), pluralRules, formatters, args);
};
function $589c109e31169a8d$var$i18nObject(locale, translations, formatters = {}) {
    return $589c109e31169a8d$var$createProxy(translations, $589c109e31169a8d$var$getTranslateInstance(locale, formatters));
}
var $589c109e31169a8d$var$wrap = (proxyObject = {}, translateFn)=>typeof proxyObject === "string" ? translateFn.bind(null, proxyObject) : Object.assign(Object.defineProperty(()=>"", "name", {
        writable: true
    }), proxyObject);
var $589c109e31169a8d$var$createProxy = (proxyObject, translateFn)=>new Proxy($589c109e31169a8d$var$wrap(proxyObject, translateFn), {
        get: (target, key)=>{
            if (key === Symbol.iterator) return [][Symbol.iterator].bind(Object.values(target).map((entry)=>$589c109e31169a8d$var$wrap(entry, translateFn)));
            return $589c109e31169a8d$var$createProxy(target[key], translateFn);
        }
    });
// src/index.tsx
var $589c109e31169a8d$var$React = (0, $7hzE7.default);
var $589c109e31169a8d$export$5af0174a488ca60a = (translations, formatters = {})=>{
    const context = $589c109e31169a8d$var$React.createContext({});
    const component = (props)=>{
        const [locale, _setLocale] = $589c109e31169a8d$var$React.useState(props.locale);
        const [LL, setLL] = $589c109e31169a8d$var$React.useState(()=>!locale ? $589c109e31169a8d$var$getFallbackProxy() : $589c109e31169a8d$var$i18nObject(locale, translations[locale], formatters[locale]));
        const setLocale = $589c109e31169a8d$var$React.useCallback((newLocale)=>{
            _setLocale(newLocale);
            setLL(()=>$589c109e31169a8d$var$i18nObject(newLocale, translations[newLocale], formatters[newLocale]));
        }, []);
        const ctx = $589c109e31169a8d$var$React.useMemo(()=>({
                setLocale: setLocale,
                locale: locale,
                LL: LL
            }), [
            setLocale,
            locale,
            LL
        ]);
        return /* @__PURE__ */ $589c109e31169a8d$var$React.createElement(context.Provider, {
            value: ctx
        }, props.children);
    };
    return {
        component: component,
        context: context
    };
};


// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
// @ts-check
/* eslint-disable */ /**
 * @typedef { import('typesafe-i18n').TranslateByString } TranslateByString
 * @typedef { import('typesafe-i18n').LocaleTranslations<Locales, Translations> } LocaleTranslations
 * @typedef { import('typesafe-i18n').LocaleTranslationFunctions<Locales, Translations, TranslationFunctions> } LocaleTranslationFunctions
 * @typedef { import('typesafe-i18n/detectors').LocaleDetector } LocaleDetector
 * @typedef { import('./i18n-types.js').Locales } Locales
 * @typedef { import('./i18n-types.js').Formatters } Formatters
 * @typedef { import('./i18n-types.js').Translations } Translations
 * @typedef { import('./i18n-types.js').TranslationFunctions } TranslationFunctions
 */ // --------------------------------------------------------------------------------------------------------------------
// types --------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------
// implementation -----------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------
// eslint-disable-next-line prettier/prettier
const $fd8f1f7ec5c6336c$var$removeEmptyValues = (object)=>Object.fromEntries(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(object).map(([key, value])=>key !== 'i' && value && value != '0' && [
            key,
            value
        ]).filter(Boolean));
// --------------------------------------------------------------------------------------------------------------------
const $fd8f1f7ec5c6336c$var$trimAllValues = (part)=>Object.fromEntries(Object.keys(part).map((key)=>{
        const val = part[key];
        return [
            key,
            Array.isArray(val) ? val.map((v)=>v === null || v === void 0 ? void 0 : v.trim()) : val === !!val ? val : val === null || val === void 0 ? void 0 : val.trim()
        ];
    }));
// --------------------------------------------------------------------------------------------------------------------
const $fd8f1f7ec5c6336c$var$parseArgumentPart = (text)=>{
    const [keyPart = '', ...formatterKeys] = text.split('|');
    const [keyWithoutType = '', type] = keyPart.split(':');
    const [key, isOptional] = keyWithoutType.split('?');
    return {
        k: key,
        i: type,
        n: isOptional === '',
        f: formatterKeys
    };
};
const $fd8f1f7ec5c6336c$export$483f8473660d1429 = (part)=>!!(part.o || part.r);
const $fd8f1f7ec5c6336c$var$parsePluralPart = (content, lastAccessor)=>{
    let [key, values] = content.split(':');
    if (!values) {
        values = key;
        key = lastAccessor;
    }
    const entries = values.split('|');
    const [zero, one, two, few, many, rest] = entries;
    const nrOfEntries = entries.filter((entry)=>entry !== undefined).length;
    if (nrOfEntries === 1) return {
        k: key,
        r: zero
    };
    if (nrOfEntries === 2) return {
        k: key,
        o: zero,
        r: one
    };
    if (nrOfEntries === 3) return {
        k: key,
        z: zero,
        o: one,
        r: two
    };
    return {
        k: key,
        z: zero,
        o: one,
        t: two,
        f: few,
        m: many,
        r: rest
    };
};
const $fd8f1f7ec5c6336c$export$b82f70a878a73fc1 = /^\{.*\}$/;
const $fd8f1f7ec5c6336c$export$d6af03549465130a = (text)=>Object.fromEntries($fd8f1f7ec5c6336c$export$1c7de4b974ed8536(text).split(',').map((part)=>part.split(':')).reduce((accumulator, entry)=>{
        if (entry.length === 2) return [
            ...accumulator,
            entry.map((entry)=>entry.trim())
        ];
        accumulator[accumulator.length - 1][1] += ',' + entry[0];
        return accumulator;
    }, []));
// --------------------------------------------------------------------------------------------------------------------
const $fd8f1f7ec5c6336c$var$REGEX_BRACKETS_SPLIT = /(\{(?:[^{}]+|\{(?:[^{}]+)*\})*\})/g;
const $fd8f1f7ec5c6336c$export$1c7de4b974ed8536 = (text)=>text.substring(1, text.length - 1);
const $fd8f1f7ec5c6336c$export$db8208116b0213ae = (rawText, optimize = true, firstKey = '', lastKey = '')=>rawText.split($fd8f1f7ec5c6336c$var$REGEX_BRACKETS_SPLIT).map((part)=>{
        if (!part.match($fd8f1f7ec5c6336c$var$REGEX_BRACKETS_SPLIT)) return part;
        const content = $fd8f1f7ec5c6336c$export$1c7de4b974ed8536(part);
        if (content.startsWith('{')) return $fd8f1f7ec5c6336c$var$parsePluralPart($fd8f1f7ec5c6336c$export$1c7de4b974ed8536(content), lastKey);
        const parsedPart = $fd8f1f7ec5c6336c$var$parseArgumentPart(content);
        lastKey = parsedPart.k || lastKey;
        !firstKey && (firstKey = lastKey);
        return parsedPart;
    }).map((part)=>{
        if (typeof part === 'string') return part;
        if (!part.k) part.k = firstKey || '0';
        const trimmed = $fd8f1f7ec5c6336c$var$trimAllValues(part);
        return optimize ? $fd8f1f7ec5c6336c$var$removeEmptyValues(trimmed) : trimmed;
    });


// --------------------------------------------------------------------------------------------------------------------
// implementation -----------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------
const $049426cd8bbd84e4$var$applyFormatters = (formatters, formatterKeys, initialValue)=>formatterKeys.reduce((value, formatterKey)=>{
        var _a, _b;
        return (_b = formatterKey.match((0, $fd8f1f7ec5c6336c$export$b82f70a878a73fc1)) ? ((cases)=>{
            var _a;
            return (_a = cases[value]) !== null && _a !== void 0 ? _a : cases['*'];
        })((0, $fd8f1f7ec5c6336c$export$d6af03549465130a)(formatterKey)) : (_a = formatters[formatterKey]) === null || _a === void 0 ? void 0 : _a.call(formatters, value)) !== null && _b !== void 0 ? _b : value;
    }, initialValue);
const $049426cd8bbd84e4$var$getPlural = (pluralRules, { z: z, o: o, t: t, f: f, m: m, r: r }, value)=>{
    switch(z && value == 0 ? 'zero' : pluralRules.select(value)){
        case 'zero':
            return z;
        case 'one':
            return o;
        case 'two':
            return t;
        case 'few':
            return f !== null && f !== void 0 ? f : r;
        case 'many':
            return m !== null && m !== void 0 ? m : r;
        default:
            return r;
    }
};
const $049426cd8bbd84e4$var$REGEX_PLURAL_VALUE_INJECTION = /\?\?/g;
const $049426cd8bbd84e4$var$applyArguments = (textParts, pluralRules, formatters, args)=>textParts.map((part)=>{
        if (typeof part === 'string') return part;
        const { k: key = '0', f: formatterKeys = [] } = part;
        const value = args[key];
        if ((0, $fd8f1f7ec5c6336c$export$483f8473660d1429)(part)) return ((typeof value === 'boolean' ? value ? part.o : part.r : $049426cd8bbd84e4$var$getPlural(pluralRules, part, value)) || '').replace($049426cd8bbd84e4$var$REGEX_PLURAL_VALUE_INJECTION, value);
        const formattedValue = formatterKeys.length ? $049426cd8bbd84e4$var$applyFormatters(formatters, formatterKeys, value) : value;
        return ('' + (formattedValue !== null && formattedValue !== void 0 ? formattedValue : '')).trim();
    }).join('');
const $049426cd8bbd84e4$export$d73ee8ef04f5226a = (textParts, pluralRules, formatters, args)=>{
    const firstArg = args[0];
    const isObject = firstArg && typeof firstArg === 'object' && firstArg.constructor === Object;
    const transformedArgs = args.length === 1 && isObject ? firstArg : args;
    return $049426cd8bbd84e4$var$applyArguments(textParts, pluralRules, formatters, transformedArgs);
}; // type TransformArgsArray<A extends Array<Record<string, unknown>>> = keyof A[0] extends `${number}`
 // 	? ToIndexBasedArgs<A>
 // 	: A
 // type ToIndexBasedArgs<A extends Array<Record<string, unknown>>, B extends keyof A[0] = keyof A[0]> = GetTypesFromRecord<
 // 	A[0],
 // 	Sort<ToNumberArray<ToTuple<B>>>
 // >
 // type GetTypesFromRecordAsArray<A extends Record<string, unknown>, B extends unknown[]> = B extends [infer Item, ...infer Rest]
 // 	? [A[Item], ...XX<A, Rest>]
 // 	: []
 // type UnionToParm<U> = U extends any ? (k: U) => void : never
 // type UnionToSect<U> = UnionToParm<U> extends (k: infer I) => void ? I : never
 // type ExtractParm<F> = F extends { (a: infer A): void } ? A : never
 // type SpliceOne<Union> = Exclude<Union, ExtractOne<Union>>
 // type ExtractOne<Union> = ExtractParm<UnionToSect<UnionToParm<Union>>>
 // type ToTuple<Union> = ToTupleRec<Union, []>
 // type ToTupleRec<Union, Rslt extends any[]> = SpliceOne<Union> extends never
 // 	? [ExtractOne<Union>, ...Rslt]
 // 	: ToTupleRec<SpliceOne<Union>, [ExtractOne<Union>, ...Rslt]>
 // type GenList<N, A extends any[] = []> = N extends A['length'] ? A : GenList<N, [0, ...A]>
 // // Add lists of size: [1, 2] -> [[1, [_]], [2, [_, _]]]
 // type Expand<T extends any[]> = T extends [infer Head, ...infer Rest] ? [[Head, GenList<Head>], ...Expand<Rest>] : []
 // // Drop one from each list, remove whole pair for empty: [[1, [_]], [0, []], [2, [_, _]]] -> [[1, []], [2, [_]]]
 // type DropAndFilter<T> = T extends [infer First, ...infer Rest]
 // 	? First extends [any, []]
 // 		? DropAndFilter<Rest>
 // 		: First extends [infer N, [any, ...infer NREST]]
 // 		? [[N, NREST], ...DropAndFilter<Rest>]
 // 		: []
 // 	: []
 // // [[1, []], [2, [_]]] -> [1]
 // type FindEmpty<T> = T extends [infer First, ...infer Rest]
 // 	? First extends [infer N, []]
 // 		? [N, ...FindEmpty<Rest>]
 // 		: FindEmpty<Rest>
 // 	: []
 // // Sort expanded
 // type Condense<T extends [number, any[]][], Result extends number[] = []> = T extends []
 // 	? Result
 // 	: Condense<DropAndFilter<T>, [...Result, ...FindEmpty<T>]>
 // type Reverse<A extends any[]> = A extends [infer H, ...infer T] ? [...Reverse<T>, H] : []
 // type Sort<T extends any[], R = false> = R extends true ? Reverse<Condense<Expand<T>>> : Condense<Expand<T>>
 // type ToNumberArray<T extends unknown[]> = T extends [infer Item, ...infer Rest]
 // 	? [ToNumber<Item>, ...ToNumberArray<Rest>]
 // 	: []
 // type ToNumber<S, L extends number[] = []> = `${L['length']}` extends S ? L['length'] : ToNumber<S, [...L, 0]>





const $ad026172a6ff2edd$export$9b4f69d68e7f2638 = (cache, text)=>cache[text] || (cache[text] = (0, $fd8f1f7ec5c6336c$export$db8208116b0213ae)(text));
const $ad026172a6ff2edd$var$translateString = (cache, pluralRules, formatters, text, ...args)=>(0, $049426cd8bbd84e4$export$d73ee8ef04f5226a)($ad026172a6ff2edd$export$9b4f69d68e7f2638(cache, text), pluralRules, formatters, args);
const $ad026172a6ff2edd$export$6cdfeb12130cbd37 = (locale, formatters = {})=>$ad026172a6ff2edd$var$translateString.bind(null, {}, new Intl.PluralRules(locale), formatters);
const $ad026172a6ff2edd$export$f68a9d66116a600f = (locale, formatters = {})=>$ad026172a6ff2edd$var$translateString.bind(null, {}, new Intl.PluralRules(locale), formatters);


const $2d484aa36f54fad6$var$getTranslateInstance = (locale, formatters)=>{
    const cache = {};
    const pluralRules = new Intl.PluralRules(locale);
    return (text, ...args)=>(0, $049426cd8bbd84e4$export$d73ee8ef04f5226a)((0, $ad026172a6ff2edd$export$9b4f69d68e7f2638)(cache, text), pluralRules, formatters, args);
};
function $2d484aa36f54fad6$export$1f3149cbc84e43fd(locale, translations, formatters = {}) {
    return $2d484aa36f54fad6$var$createProxy(translations, $2d484aa36f54fad6$var$getTranslateInstance(locale, formatters));
}
function $2d484aa36f54fad6$export$9494db0ad9e1bc23(locale, translations, formatters = {}) {
    return $2d484aa36f54fad6$var$createProxy(translations, $2d484aa36f54fad6$var$getTranslateInstance(locale, formatters));
}
const $2d484aa36f54fad6$var$wrap = (proxyObject = {}, translateFn)=>typeof proxyObject === 'string' ? translateFn.bind(null, proxyObject) : Object.assign(Object.defineProperty(()=>'', 'name', {
        writable: true
    }), proxyObject);
/* PROXY-START */ const $2d484aa36f54fad6$var$createProxy = (proxyObject, translateFn)=>new Proxy($2d484aa36f54fad6$var$wrap(proxyObject, translateFn), {
        get: (target, key)=>{
            if (key === Symbol.iterator) return [][Symbol.iterator].bind(Object.values(target).map((entry)=>$2d484aa36f54fad6$var$wrap(entry, translateFn)));
            return $2d484aa36f54fad6$var$createProxy(target[key], translateFn);
        }
    }); /* PROXY-END */ 


const $0df255e0bce3f127$export$a7357cdd1f0b0168 = (translations, formatters)=>{
    const cache = {};
    return new Proxy({}, {
        get: (_target, locale)=>cache[locale] || (cache[locale] = (0, $2d484aa36f54fad6$export$1f3149cbc84e43fd)(locale, translations[locale], formatters[locale]))
    });
};







// ../../node_modules/.pnpm/just-extend@6.2.0/node_modules/just-extend/index.mjs
var $9709c2ad67d6f783$var$objectExtend = $9709c2ad67d6f783$var$extend;
function $9709c2ad67d6f783$var$extend() {
    var args = [].slice.call(arguments);
    var deep = false;
    if (typeof args[0] == "boolean") deep = args.shift();
    var result = args[0];
    if ($9709c2ad67d6f783$var$isUnextendable(result)) throw new Error("extendee must be an object");
    var extenders = args.slice(1);
    var len = extenders.length;
    for(var i = 0; i < len; i++){
        var extender = extenders[i];
        for(var key in extender)if (Object.prototype.hasOwnProperty.call(extender, key)) {
            var value = extender[key];
            if (deep && $9709c2ad67d6f783$var$isCloneable(value)) {
                var base = Array.isArray(value) ? [] : {};
                result[key] = $9709c2ad67d6f783$var$extend(true, Object.prototype.hasOwnProperty.call(result, key) && !$9709c2ad67d6f783$var$isUnextendable(result[key]) ? result[key] : base, value);
            } else result[key] = value;
        }
    }
    return result;
}
function $9709c2ad67d6f783$var$isCloneable(obj) {
    return Array.isArray(obj) || ({}).toString.call(obj) == "[object Object]";
}
function $9709c2ad67d6f783$var$isUnextendable(val) {
    return !val || typeof val != "object" && typeof val != "function";
}
// src/extendDictionary.mts
var $9709c2ad67d6f783$export$54ec3c4bf3c346d9 = ()=>(base, part)=>$9709c2ad67d6f783$var$objectExtend({}, base, part);
var $9709c2ad67d6f783$export$896ef617af876a60 = $9709c2ad67d6f783$export$54ec3c4bf3c346d9();


const $a84802ac7c43e02d$export$70fedd66af7352b8 = 'en';
const $a84802ac7c43e02d$export$df1c34db1371eeed = [
    'en',
    'es'
];
const $a84802ac7c43e02d$export$894a92ec5bebf83 = (locale)=>$a84802ac7c43e02d$export$df1c34db1371eeed.includes(/** @type { Locales } */ locale);
const $a84802ac7c43e02d$export$83b224dce856dcdd = /** @type { Record<Locales, Translations> } */ {};
const $a84802ac7c43e02d$export$94e8dd934142aa6a = /** @type { Record<Locales, Formatters> } */ {};
const $a84802ac7c43e02d$export$896ef617af876a60 = (0, $9709c2ad67d6f783$export$54ec3c4bf3c346d9)();
const $a84802ac7c43e02d$export$6cdfeb12130cbd37 = (locale)=>(0, $ad026172a6ff2edd$export$6cdfeb12130cbd37)(locale, $a84802ac7c43e02d$export$94e8dd934142aa6a[locale]);
const $a84802ac7c43e02d$export$1f3149cbc84e43fd = (locale)=>(0, $2d484aa36f54fad6$export$1f3149cbc84e43fd)(locale, $a84802ac7c43e02d$export$83b224dce856dcdd[locale], $a84802ac7c43e02d$export$94e8dd934142aa6a[locale]);
const $a84802ac7c43e02d$export$a7357cdd1f0b0168 = ()=>(0, $0df255e0bce3f127$export$a7357cdd1f0b0168)($a84802ac7c43e02d$export$83b224dce856dcdd, $a84802ac7c43e02d$export$94e8dd934142aa6a);
const $a84802ac7c43e02d$export$8aa9c21fdc1955ee = (...detectors)=>(0, $ce8f606811d8b5da$export$8aa9c21fdc1955ee)($a84802ac7c43e02d$export$70fedd66af7352b8, $a84802ac7c43e02d$export$df1c34db1371eeed, ...detectors);


/** @type { ReactInit } */ const { component: $dc3317580ce734b5$var$TypesafeI18n, context: $dc3317580ce734b5$export$5603ab5ced17ce64 } = (0, $589c109e31169a8d$export$5af0174a488ca60a)((0, $a84802ac7c43e02d$export$83b224dce856dcdd), (0, $a84802ac7c43e02d$export$94e8dd934142aa6a));
/** @type { () => I18nContextType } */ const $dc3317580ce734b5$export$22f0ca4c21b6ff4 = ()=>(0, $6F3kv.useContext)($dc3317580ce734b5$export$5603ab5ced17ce64);
var $dc3317580ce734b5$export$2e2bcd8739ae039 = $dc3317580ce734b5$var$TypesafeI18n;



// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
// @ts-check
/* eslint-disable */ /**
 * @typedef { import('./i18n-types.js').Locales } Locales
 * @typedef { import('./i18n-types.js').Translations } Translations
 */ // @ts-check
/**
 * @typedef { import('typesafe-i18n').FormattersInitializer<Locales, Formatters> } FormattersInitializer
 * @typedef { import('./i18n-types.js').Locales } Locales
 * @typedef { import('./i18n-types.js').Formatters } Formatters
 */ /**
 * @param { Locales } locale
 * @return { Formatters }
 */ const $0674246561f07b5b$export$e9fbbe70052d750 = (locale)=>{
    /** @type { Formatters } */ const formatters = {
    };
    return formatters;
};



// @ts-check
/**
 * @typedef { import('../i18n-types').BaseTranslation } BaseTranslation
 */ /** @type { BaseTranslation } */ const $52fa52d3092b2a2f$var$en = {
    // TODO: your translations go here
    common: {
        menu: 'menu',
        settings: 'settings',
        language: 'language',
        theme: 'theme',
        save: 'save',
        share: 'share',
        shareScreen: 'share screen',
        export: 'export',
        exportLabel: 'export all screens',
        import: 'import',
        importLabel: 'import a screen or a full configuration of screens',
        importCaution: 'Are you sure you want to import and remplace {type:string} data? ',
        success: 'success',
        notJSON: 'not a JSON file (.json)',
        badJSON: 'not a valid JSON file',
        formatNotFound: 'file format not reconized (screen or grid)',
        madeBy: "made with \u2764 by {label}",
        advancedConfig: 'Advanced Configuration',
        seeDetails: 'see details',
        lang: {
            es: 'spanish',
            en: 'english'
        },
        close: 'close',
        localStorageNotSupported: "Pictoaccess works better activating cookies and/or localStorage"
    },
    importTable: {
        kind: 'kind',
        old: 'old value',
        new: 'new value',
        screen: 'screen',
        tile: 'tile',
        path: 'path',
        D: 'delete',
        E: 'edit',
        N: 'new',
        noDiff: 'no differences'
    },
    aac: {
        space: 'space',
        screen: 'screen',
        grid: 'grid',
        new: 'new',
        remove: 'remove',
        sure: 'sure',
        voice: 'voice',
        run: 'run',
        speak: 'speak',
        copy: 'copy',
        copied: 'copied',
        clear: 'clear',
        cancel: 'cancel',
        reset: 'reset',
        caution: 'caution',
        notSupported: 'Speech Synthesis not supported :(',
        resetInfo: 'reset all settings & tiles',
        resetCaution: 'Are you sure you want to reset all settings & mosaics?',
        importCaution: 'Are you sure to replace, create or delete this mosaics?',
        pitch: 'pitch',
        rate: 'rate',
        edit: 'edit',
        done: 'done',
        back: 'back',
        speakWords: 'speak each tile',
        actions: {
            yes: 'yes',
            no: 'no'
        },
        fields: {
            id: 'ID',
            imgUrl: 'URL image',
            text: 'text',
            img: 'image',
            url: 'url',
            color: 'color',
            searchIcon: 'search image',
            link: 'collection',
            link_help: 'You can select another collection to link to it, or write a weblink to open it in a new tab'
        }
    }
};
var $52fa52d3092b2a2f$export$2e2bcd8739ae039 = $52fa52d3092b2a2f$var$en;


// @ts-check
/**
 * @typedef { import('../i18n-types').BaseTranslation } BaseTranslation
 */ /** @type { BaseTranslation } */ const $02515e27252a0a23$var$es = {
    // TODO: your translations go here
    common: {
        menu: 'menu',
        settings: 'configuraciones',
        language: 'lenguaje',
        theme: 'tema',
        save: 'guardar',
        share: 'compartir',
        shareScreen: 'compartir pantalla',
        export: 'exportar',
        exportLabel: 'exportar todos las patallas',
        import: 'importar',
        importLabel: 'importar una pantalla o conjunto completo de pantallas',
        importCaution: "Est\xe1 seguro de importar y reemplazar los datos de {type:string}?",
        success: 'Hecho',
        notJSON: "no es un archivo con extensi\xf3n JSON (.json)",
        badJSON: "no es un archivo JSON v\xe1lido",
        formatNotFound: 'formato de archivo no reconocido (pantalla o pantallas)',
        madeBy: "hecho con \u2764 por {label}",
        advancedConfig: "Configuraci\xf3n Avanzada",
        seeDetails: 'ver detalles',
        lang: {
            es: "espa\xf1ol",
            en: "ingl\xe9s"
        },
        close: 'cerrar',
        localStorageNotSupported: "Pictoaccess funciona mejor activando cookies y/o localStorage"
    },
    importTable: {
        kind: 'tipo',
        old: 'valor antiguo',
        new: 'valor nuevo',
        screen: 'pantalla',
        tile: 'mosaico',
        path: 'ruta',
        D: 'borrar',
        E: 'editar',
        N: 'nuevo',
        noDiff: 'no hay diferencias'
    },
    aac: {
        space: 'espacio',
        screen: 'pantalla',
        grid: 'Pantallas',
        new: 'nuevo',
        sure: 'seguro',
        remove: 'eliminar',
        voice: 'voz',
        run: 'reproducir',
        speak: 'hablar',
        copy: 'copiar',
        copied: 'copiado',
        clear: 'borrar',
        cancel: 'cancelar',
        reset: 'restablecer',
        caution: "atenci\xf3n",
        notSupported: "S\xedntesis de voz no soportada :(",
        resetInfo: "Restablecer configuraciones de f\xe1brica & mosaicos",
        resetCaution: "Est\xe1s seguro de reiniciar todas las configuraciones y mosaicos?",
        importCaution: "Est\xe1s seguro de reemplazar, crear o borrar los siguientes mosaicos?",
        pitch: 'tono',
        rate: 'velocidad',
        edit: 'editar',
        done: 'hecho',
        back: "atr\xe1s",
        speakWords: 'vocalizar cada mosaico',
        actions: {
            yes: 'yes',
            no: 'no'
        },
        fields: {
            id: 'ID',
            imgUrl: 'URL imagen',
            img: 'imagen',
            url: 'url',
            text: 'texto',
            color: 'color',
            searchIcon: 'buscar imagen',
            link: "colecci\xf3n",
            link_help: "Puedes seleccionar otra coleccion para acceder a ella, o escribir un link web para abrirlo en una nueva pesta\xf1a"
        }
    }
};
var $02515e27252a0a23$export$2e2bcd8739ae039 = $02515e27252a0a23$var$es;


const $b9adadb6c2c76409$var$localeTranslations = {
    en: $52fa52d3092b2a2f$export$2e2bcd8739ae039,
    es: $02515e27252a0a23$export$2e2bcd8739ae039
};
const $b9adadb6c2c76409$export$3f35861ea9a1becb = (locale)=>{
    if ((0, $a84802ac7c43e02d$export$83b224dce856dcdd)[locale]) return;
    (0, $a84802ac7c43e02d$export$83b224dce856dcdd)[locale] = /** @type { unknown } */ $b9adadb6c2c76409$var$localeTranslations[locale];
    $b9adadb6c2c76409$export$57afb37fef2843f0(locale);
};
const $b9adadb6c2c76409$export$4cb1bc27b584ebdb = ()=>(0, $a84802ac7c43e02d$export$df1c34db1371eeed).forEach($b9adadb6c2c76409$export$3f35861ea9a1becb);
const $b9adadb6c2c76409$export$57afb37fef2843f0 = (locale)=>void ((0, $a84802ac7c43e02d$export$94e8dd934142aa6a)[locale] = (0, $0674246561f07b5b$export$e9fbbe70052d750)(locale));




var $9Oehh = parcelRequire("9Oehh");

var $6F3kv = parcelRequire("6F3kv");
var $f2ea33f18db73d01$var$a = {};
function $f2ea33f18db73d01$var$c(n, t) {
    for(var r in t)n[r] = t[r];
    return n;
}
function $f2ea33f18db73d01$export$78e3044358792147(n, t, r) {
    var i, o = /(?:\?([^#]*))?(#.*)?$/, e = n.match(o), u = {};
    if (e && e[1]) for(var f = e[1].split("&"), c = 0; c < f.length; c++){
        var s = f[c].split("=");
        u[decodeURIComponent(s[0])] = decodeURIComponent(s.slice(1).join("="));
    }
    n = $f2ea33f18db73d01$var$d(n.replace(o, "")), t = $f2ea33f18db73d01$var$d(t || "");
    for(var h = Math.max(n.length, t.length), v = 0; v < h; v++)if (t[v] && ":" === t[v].charAt(0)) {
        var l = t[v].replace(/(^:|[+*?]+$)/g, ""), p = (t[v].match(/[+*?]+$/) || $f2ea33f18db73d01$var$a)[0] || "", m = ~p.indexOf("+"), y = ~p.indexOf("*"), U = n[v] || "";
        if (!U && !y && (p.indexOf("?") < 0 || m)) {
            i = !1;
            break;
        }
        if (u[l] = decodeURIComponent(U), m || y) {
            u[l] = n.slice(v).map(decodeURIComponent).join("/");
            break;
        }
    } else if (t[v] !== n[v]) {
        i = !1;
        break;
    }
    return (!0 === r.default || !1 !== i) && u;
}
function $f2ea33f18db73d01$var$h(n, t) {
    return n.rank < t.rank ? 1 : n.rank > t.rank ? -1 : n.index - t.index;
}
function $f2ea33f18db73d01$var$v(n, t) {
    return n.index = t, n.rank = function(n) {
        return n.props.default ? 0 : $f2ea33f18db73d01$var$d(n.props.path).map($f2ea33f18db73d01$var$l).join("");
    }(n), n.props;
}
function $f2ea33f18db73d01$var$d(n) {
    return n.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $f2ea33f18db73d01$var$l(n) {
    return ":" == n.charAt(0) ? 1 + "*+?".indexOf(n.charAt(n.length - 1)) || 4 : 5;
}
var $f2ea33f18db73d01$var$p = {}, $f2ea33f18db73d01$var$m = [], $f2ea33f18db73d01$var$y = [], $f2ea33f18db73d01$var$U = null, $f2ea33f18db73d01$var$g = {
    url: $f2ea33f18db73d01$export$dc90482e4ef07afd()
}, $f2ea33f18db73d01$var$k = (0, $9Oehh.createContext)($f2ea33f18db73d01$var$g);
function $f2ea33f18db73d01$export$9a302a45f65d0572() {
    var n = (0, $6F3kv.useContext)($f2ea33f18db73d01$var$k);
    if (n === $f2ea33f18db73d01$var$g) {
        var t = (0, $6F3kv.useState)()[1];
        (0, $6F3kv.useEffect)(function() {
            return $f2ea33f18db73d01$var$y.push(t), function() {
                return $f2ea33f18db73d01$var$y.splice($f2ea33f18db73d01$var$y.indexOf(t), 1);
            };
        }, []);
    }
    return [
        n,
        $f2ea33f18db73d01$export$4cb887bfde2d34ca
    ];
}
function $f2ea33f18db73d01$export$dc90482e4ef07afd() {
    var n;
    return "" + ((n = $f2ea33f18db73d01$var$U && $f2ea33f18db73d01$var$U.location ? $f2ea33f18db73d01$var$U.location : $f2ea33f18db73d01$var$U && $f2ea33f18db73d01$var$U.getCurrentLocation ? $f2ea33f18db73d01$var$U.getCurrentLocation() : "undefined" != typeof location ? location : $f2ea33f18db73d01$var$p).pathname || "") + (n.search || "");
}
function $f2ea33f18db73d01$export$4cb887bfde2d34ca(n, t) {
    return void 0 === t && (t = !1), "string" != typeof n && n.url && (t = n.replace, n = n.url), function(n) {
        for(var t = $f2ea33f18db73d01$var$m.length; t--;)if ($f2ea33f18db73d01$var$m[t].canRoute(n)) return !0;
        return !1;
    }(n) && function(n, t) {
        void 0 === t && (t = "push"), $f2ea33f18db73d01$var$U && $f2ea33f18db73d01$var$U[t] ? $f2ea33f18db73d01$var$U[t](n) : "undefined" != typeof history && history[t + "State"] && history[t + "State"](null, null, n);
    }(n, t ? "replace" : "push"), $f2ea33f18db73d01$var$I(n);
}
function $f2ea33f18db73d01$var$I(n) {
    for(var t = !1, r = 0; r < $f2ea33f18db73d01$var$m.length; r++)$f2ea33f18db73d01$var$m[r].routeTo(n) && (t = !0);
    return t;
}
function $f2ea33f18db73d01$var$M(n) {
    if (n && n.getAttribute) {
        var t = n.getAttribute("href"), r = n.getAttribute("target");
        if (t && t.match(/^\//g) && (!r || r.match(/^_?self$/i))) return $f2ea33f18db73d01$export$4cb887bfde2d34ca(t);
    }
}
function $f2ea33f18db73d01$var$b(n) {
    return n.stopImmediatePropagation && n.stopImmediatePropagation(), n.stopPropagation && n.stopPropagation(), n.preventDefault(), !1;
}
function $f2ea33f18db73d01$var$W(n) {
    if (!(n.ctrlKey || n.metaKey || n.altKey || n.shiftKey || n.button)) {
        var t = n.target;
        do if ("a" === t.localName && t.getAttribute("href")) {
            if (t.hasAttribute("data-native") || t.hasAttribute("native")) return;
            if ($f2ea33f18db73d01$var$M(t)) return $f2ea33f18db73d01$var$b(n);
        }
        while (t = t.parentNode);
    }
}
var $f2ea33f18db73d01$var$w = !1;
function $f2ea33f18db73d01$export$55185c17a0fcbe46(n) {
    n.history && ($f2ea33f18db73d01$var$U = n.history), this.state = {
        url: n.url || $f2ea33f18db73d01$export$dc90482e4ef07afd()
    };
}
$f2ea33f18db73d01$var$c($f2ea33f18db73d01$export$55185c17a0fcbe46.prototype = new (0, $9Oehh.Component), {
    shouldComponentUpdate: function(n) {
        return !0 !== n.static || n.url !== this.props.url || n.onChange !== this.props.onChange;
    },
    canRoute: function(n) {
        var t = (0, $9Oehh.toChildArray)(this.props.children);
        return void 0 !== this.g(t, n);
    },
    routeTo: function(n) {
        this.setState({
            url: n
        });
        var t = this.canRoute(n);
        return this.p || this.forceUpdate(), t;
    },
    componentWillMount: function() {
        this.p = !0;
    },
    componentDidMount: function() {
        var n = this;
        $f2ea33f18db73d01$var$w || ($f2ea33f18db73d01$var$w = !0, $f2ea33f18db73d01$var$U || addEventListener("popstate", function() {
            $f2ea33f18db73d01$var$I($f2ea33f18db73d01$export$dc90482e4ef07afd());
        }), addEventListener("click", $f2ea33f18db73d01$var$W)), $f2ea33f18db73d01$var$m.push(this), $f2ea33f18db73d01$var$U && (this.u = $f2ea33f18db73d01$var$U.listen(function(t) {
            var r = t.location || t;
            n.routeTo("" + (r.pathname || "") + (r.search || ""));
        })), this.p = !1;
    },
    componentWillUnmount: function() {
        "function" == typeof this.u && this.u(), $f2ea33f18db73d01$var$m.splice($f2ea33f18db73d01$var$m.indexOf(this), 1);
    },
    componentWillUpdate: function() {
        this.p = !0;
    },
    componentDidUpdate: function() {
        this.p = !1;
    },
    g: function(n, t) {
        n = n.filter($f2ea33f18db73d01$var$v).sort($f2ea33f18db73d01$var$h);
        for(var r = 0; r < n.length; r++){
            var i = n[r], o = $f2ea33f18db73d01$export$78e3044358792147(t, i.props.path, i.props);
            if (o) return [
                i,
                o
            ];
        }
    },
    render: function(n, t) {
        var e, u, f = n.onChange, a = t.url, s = this.c, h = this.g((0, $9Oehh.toChildArray)(n.children), a);
        if (h && (u = (0, $9Oehh.cloneElement)(h[0], $f2ea33f18db73d01$var$c($f2ea33f18db73d01$var$c({
            url: a,
            matches: e = h[1]
        }, e), {
            key: void 0,
            ref: void 0
        }))), a !== (s && s.url)) {
            $f2ea33f18db73d01$var$c($f2ea33f18db73d01$var$g, s = this.c = {
                url: a,
                previous: s && s.url,
                current: u,
                path: u ? u.props.path : null,
                matches: e
            }), s.router = this, s.active = u ? [
                u
            ] : [];
            for(var v = $f2ea33f18db73d01$var$y.length; v--;)$f2ea33f18db73d01$var$y[v]({});
            "function" == typeof f && f(s);
        }
        return (0, $9Oehh.h)($f2ea33f18db73d01$var$k.Provider, {
            value: s
        }, u);
    }
});
var $f2ea33f18db73d01$export$a6c7ac8248d6e38a = function(n) {
    return (0, $9Oehh.h)("a", $f2ea33f18db73d01$var$c({
        onClick: $f2ea33f18db73d01$var$W
    }, n));
}, $f2ea33f18db73d01$export$e7b0ac011bb776c6 = function(n) {
    return (0, $9Oehh.h)(n.component, n);
};




var $9Oehh = parcelRequire("9Oehh");
parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");
var $0b20ce121ee1acb3$exports = {};
'use strict';
var $3a102820b3d4b570$exports = {};

$parcel$export($3a102820b3d4b570$exports, "atom", () => $3a102820b3d4b570$export$5fb5cc0d078610b, (v) => $3a102820b3d4b570$export$5fb5cc0d078610b = v);
$parcel$export($3a102820b3d4b570$exports, "createStore", () => $3a102820b3d4b570$export$f51a9068ac82ea43, (v) => $3a102820b3d4b570$export$f51a9068ac82ea43 = v);
$parcel$export($3a102820b3d4b570$exports, "getDefaultStore", () => $3a102820b3d4b570$export$39b2e4393dfcb8aa, (v) => $3a102820b3d4b570$export$39b2e4393dfcb8aa = v);
var $3a102820b3d4b570$export$5fb5cc0d078610b;
var $3a102820b3d4b570$export$f51a9068ac82ea43;
var $3a102820b3d4b570$export$39b2e4393dfcb8aa;
'use strict';
var $3a102820b3d4b570$var$keyCount = 0;
function $3a102820b3d4b570$var$atom(read, write) {
    var key = "atom" + ++$3a102820b3d4b570$var$keyCount;
    var config = {
        toString: function toString() {
            return key;
        }
    };
    if (typeof read === 'function') config.read = read;
    else {
        config.init = read;
        config.read = $3a102820b3d4b570$var$defaultRead;
        config.write = $3a102820b3d4b570$var$defaultWrite;
    }
    if (write) config.write = write;
    return config;
}
function $3a102820b3d4b570$var$defaultRead(get) {
    return get(this);
}
function $3a102820b3d4b570$var$defaultWrite(get, set, arg) {
    return set(this, typeof arg === 'function' ? arg(get(this)) : arg);
}
function $3a102820b3d4b570$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $3a102820b3d4b570$var$_unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3a102820b3d4b570$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3a102820b3d4b570$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3a102820b3d4b570$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $3a102820b3d4b570$var$isSelfAtom = function isSelfAtom(atom, a) {
    return atom.unstable_is ? atom.unstable_is(a) : a === atom;
};
var $3a102820b3d4b570$var$hasInitialValue = function hasInitialValue(atom) {
    return 'init' in atom;
};
var $3a102820b3d4b570$var$isActuallyWritableAtom = function isActuallyWritableAtom(atom) {
    return !!atom.write;
};
var $3a102820b3d4b570$var$cancelablePromiseMap = new WeakMap();
var $3a102820b3d4b570$var$isPendingPromise = function isPendingPromise(value) {
    var _cancelablePromiseMap;
    return $3a102820b3d4b570$var$isPromiseLike(value) && !((_cancelablePromiseMap = $3a102820b3d4b570$var$cancelablePromiseMap.get(value)) != null && _cancelablePromiseMap[1]);
};
var $3a102820b3d4b570$var$cancelPromise = function cancelPromise(promise, nextValue) {
    var promiseState = $3a102820b3d4b570$var$cancelablePromiseMap.get(promise);
    if (promiseState) {
        promiseState[1] = true;
        promiseState[0].forEach(function(fn) {
            return fn(nextValue);
        });
    }
};
var $3a102820b3d4b570$var$patchPromiseForCancelability = function patchPromiseForCancelability(promise) {
    if ($3a102820b3d4b570$var$cancelablePromiseMap.has(promise)) return;
    var promiseState = [
        new Set(),
        false
    ];
    $3a102820b3d4b570$var$cancelablePromiseMap.set(promise, promiseState);
    var settle = function settle() {
        promiseState[1] = true;
    };
    promise.then(settle, settle);
    promise.onCancel = function(fn) {
        promiseState[0].add(fn);
    };
};
var $3a102820b3d4b570$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === 'function';
};
var $3a102820b3d4b570$var$isAtomStateInitialized = function isAtomStateInitialized(atomState) {
    return 'v' in atomState || 'e' in atomState;
};
var $3a102820b3d4b570$var$returnAtomValue = function returnAtomValue(atomState) {
    if ('e' in atomState) throw atomState.e;
    return atomState.v;
};
var $3a102820b3d4b570$var$addPendingPromiseToDependency = function addPendingPromiseToDependency(atom, promise, dependencyAtomState) {
    if (!dependencyAtomState.p.has(atom)) {
        dependencyAtomState.p.add(atom);
        promise.then(function() {
            dependencyAtomState.p.delete(atom);
        }, function() {
            dependencyAtomState.p.delete(atom);
        });
    }
};
var $3a102820b3d4b570$var$addDependency = function addDependency(pending, atom, atomState, a, aState) {
    var _aState$m;
    atomState.d.set(a, aState.n);
    if ($3a102820b3d4b570$var$isPendingPromise(atomState.v)) $3a102820b3d4b570$var$addPendingPromiseToDependency(atom, atomState.v, aState);
    (_aState$m = aState.m) == null || _aState$m.t.add(atom);
    if (pending) $3a102820b3d4b570$var$addPendingDependent(pending, a, atom);
};
var $3a102820b3d4b570$var$createPending = function createPending() {
    return [
        new Map(),
        new Map(),
        new Set()
    ];
};
var $3a102820b3d4b570$var$addPendingAtom = function addPendingAtom(pending, atom, atomState) {
    if (!pending[0].has(atom)) pending[0].set(atom, new Set());
    pending[1].set(atom, atomState);
};
var $3a102820b3d4b570$var$addPendingDependent = function addPendingDependent(pending, atom, dependent) {
    var dependents = pending[0].get(atom);
    if (dependents) dependents.add(dependent);
};
var $3a102820b3d4b570$var$getPendingDependents = function getPendingDependents(pending, atom) {
    return pending[0].get(atom);
};
var $3a102820b3d4b570$var$addPendingFunction = function addPendingFunction(pending, fn) {
    pending[2].add(fn);
};
var $3a102820b3d4b570$var$flushPending = function flushPending(pending) {
    while(pending[1].size || pending[2].size){
        pending[0].clear();
        var _atomStates = new Set(pending[1].values());
        pending[1].clear();
        var _functions = new Set(pending[2]);
        pending[2].clear();
        _atomStates.forEach(function(atomState) {
            var _atomState$m;
            return (_atomState$m = atomState.m) == null ? void 0 : _atomState$m.l.forEach(function(l) {
                return l();
            });
        });
        _functions.forEach(function(fn) {
            return fn();
        });
    }
};
var $3a102820b3d4b570$var$_buildStore = function buildStore(getAtomState) {
    var debugMountedAtoms;
    var setAtomStateValueOrPromise = function setAtomStateValueOrPromise(atom, atomState, valueOrPromise) {
        var hasPrevValue = 'v' in atomState;
        var prevValue = atomState.v;
        var pendingPromise = $3a102820b3d4b570$var$isPendingPromise(atomState.v) ? atomState.v : null;
        if ($3a102820b3d4b570$var$isPromiseLike(valueOrPromise)) {
            $3a102820b3d4b570$var$patchPromiseForCancelability(valueOrPromise);
            for(var _iterator = $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step; !(_step = _iterator()).done;){
                var a = _step.value;
                $3a102820b3d4b570$var$addPendingPromiseToDependency(atom, valueOrPromise, getAtomState(a, atomState));
            }
            atomState.v = valueOrPromise;
            delete atomState.e;
        } else {
            atomState.v = valueOrPromise;
            delete atomState.e;
        }
        if (!hasPrevValue || !Object.is(prevValue, atomState.v)) {
            ++atomState.n;
            if (pendingPromise) $3a102820b3d4b570$var$cancelPromise(pendingPromise, valueOrPromise);
        }
    };
    var _readAtomState = function readAtomState(pending, atom, atomState, force) {
        if (!(force != null && force(atom)) && $3a102820b3d4b570$var$isAtomStateInitialized(atomState)) {
            if (atomState.m) return atomState;
            if (Array.from(atomState.d).every(function(_ref) {
                var a = _ref[0], n = _ref[1];
                return _readAtomState(pending, a, getAtomState(a, atomState), force).n === n;
            })) return atomState;
        }
        atomState.d.clear();
        var isSync = true;
        var getter = function getter(a) {
            if ($3a102820b3d4b570$var$isSelfAtom(atom, a)) {
                var _aState = getAtomState(a, atomState);
                if (!$3a102820b3d4b570$var$isAtomStateInitialized(_aState)) {
                    if ($3a102820b3d4b570$var$hasInitialValue(a)) setAtomStateValueOrPromise(a, _aState, a.init);
                    else throw new Error('no atom init');
                }
                return $3a102820b3d4b570$var$returnAtomValue(_aState);
            }
            var aState = _readAtomState(pending, a, getAtomState(a, atomState), force);
            if (isSync) $3a102820b3d4b570$var$addDependency(pending, atom, atomState, a, aState);
            else {
                var _pending = $3a102820b3d4b570$var$createPending();
                $3a102820b3d4b570$var$addDependency(_pending, atom, atomState, a, aState);
                mountDependencies(_pending, atom, atomState);
                $3a102820b3d4b570$var$flushPending(_pending);
            }
            return $3a102820b3d4b570$var$returnAtomValue(aState);
        };
        var controller;
        var setSelf;
        var options = {
            get signal () {
                if (!controller) controller = new AbortController();
                return controller.signal;
            },
            get setSelf () {
                if (!setSelf && $3a102820b3d4b570$var$isActuallyWritableAtom(atom)) setSelf = function setSelf() {
                    if (!isSync) {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return writeAtom.apply(void 0, [
                            atom
                        ].concat(args));
                    }
                };
                return setSelf;
            }
        };
        try {
            var valueOrPromise = atom.read(getter, options);
            setAtomStateValueOrPromise(atom, atomState, valueOrPromise);
            if ($3a102820b3d4b570$var$isPromiseLike(valueOrPromise)) {
                valueOrPromise.onCancel == null || valueOrPromise.onCancel(function() {
                    var _controller;
                    return (_controller = controller) == null ? void 0 : _controller.abort();
                });
                var complete = function complete() {
                    if (atomState.m) {
                        var _pending2 = $3a102820b3d4b570$var$createPending();
                        mountDependencies(_pending2, atom, atomState);
                        $3a102820b3d4b570$var$flushPending(_pending2);
                    }
                };
                valueOrPromise.then(complete, complete);
            }
            return atomState;
        } catch (error) {
            delete atomState.v;
            atomState.e = error;
            ++atomState.n;
            return atomState;
        } finally{
            isSync = false;
        }
    };
    var readAtom = function readAtom(atom) {
        return $3a102820b3d4b570$var$returnAtomValue(_readAtomState(undefined, atom, getAtomState(atom)));
    };
    var getDependents = function getDependents(pending, atom, atomState) {
        var _getPendingDependents;
        var dependents = new Map();
        for(var _iterator2 = $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(((_atomState$m2 = atomState.m) == null ? void 0 : _atomState$m2.t) || []), _step2; !(_step2 = _iterator2()).done;){
            var _atomState$m2;
            var a = _step2.value;
            dependents.set(a, getAtomState(a, atomState));
        }
        for(var _iterator3 = $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(atomState.p), _step3; !(_step3 = _iterator3()).done;){
            var atomWithPendingPromise = _step3.value;
            dependents.set(atomWithPendingPromise, getAtomState(atomWithPendingPromise, atomState));
        }
        (_getPendingDependents = $3a102820b3d4b570$var$getPendingDependents(pending, atom)) == null || _getPendingDependents.forEach(function(dependent) {
            dependents.set(dependent, getAtomState(dependent, atomState));
        });
        return dependents;
    };
    var recomputeDependents = function recomputeDependents(pending, atom, atomState) {
        var topsortedAtoms = [];
        var markedAtoms = new Set();
        var _visit = function visit(a, aState) {
            if (markedAtoms.has(a)) return;
            markedAtoms.add(a);
            for(var _iterator4 = $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(getDependents(pending, a, aState)), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, d = _step4$value[0], s = _step4$value[1];
                if (a !== d) _visit(d, s);
            }
            topsortedAtoms.push([
                a,
                aState,
                aState.n
            ]);
        };
        _visit(atom, atomState);
        var changedAtoms = new Set([
            atom
        ]);
        var isMarked = function isMarked(a) {
            return markedAtoms.has(a);
        };
        for(var i = topsortedAtoms.length - 1; i >= 0; --i){
            var _ref2 = topsortedAtoms[i], a = _ref2[0], aState = _ref2[1], prevEpochNumber = _ref2[2];
            var hasChangedDeps = false;
            for(var _iterator5 = $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(aState.d.keys()), _step5; !(_step5 = _iterator5()).done;){
                var dep = _step5.value;
                if (dep !== a && changedAtoms.has(dep)) {
                    hasChangedDeps = true;
                    break;
                }
            }
            if (hasChangedDeps) {
                _readAtomState(pending, a, aState, isMarked);
                mountDependencies(pending, a, aState);
                if (prevEpochNumber !== aState.n) {
                    $3a102820b3d4b570$var$addPendingAtom(pending, a, aState);
                    changedAtoms.add(a);
                }
            }
            markedAtoms.delete(a);
        }
    };
    var _writeAtomState = function writeAtomState(pending, atom, atomState) {
        var getter = function getter(a) {
            return $3a102820b3d4b570$var$returnAtomValue(_readAtomState(pending, a, getAtomState(a, atomState)));
        };
        var setter = function setter(a) {
            var aState = getAtomState(a, atomState);
            var r;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            if ($3a102820b3d4b570$var$isSelfAtom(atom, a)) {
                if (!$3a102820b3d4b570$var$hasInitialValue(a)) throw new Error('atom not writable');
                var hasPrevValue = 'v' in aState;
                var prevValue = aState.v;
                var v = args[0];
                setAtomStateValueOrPromise(a, aState, v);
                mountDependencies(pending, a, aState);
                if (!hasPrevValue || !Object.is(prevValue, aState.v)) {
                    $3a102820b3d4b570$var$addPendingAtom(pending, a, aState);
                    recomputeDependents(pending, a, aState);
                }
            } else r = _writeAtomState.apply(void 0, [
                pending,
                a,
                aState
            ].concat(args));
            $3a102820b3d4b570$var$flushPending(pending);
            return r;
        };
        for(var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)args[_key2 - 3] = arguments[_key2];
        var result = atom.write.apply(atom, [
            getter,
            setter
        ].concat(args));
        return result;
    };
    var writeAtom = function writeAtom(atom) {
        var pending = $3a102820b3d4b570$var$createPending();
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        var result = _writeAtomState.apply(void 0, [
            pending,
            atom,
            getAtomState(atom)
        ].concat(args));
        $3a102820b3d4b570$var$flushPending(pending);
        return result;
    };
    var mountDependencies = function mountDependencies(pending, atom, atomState) {
        if (atomState.m && !$3a102820b3d4b570$var$isPendingPromise(atomState.v)) {
            for(var _iterator6 = $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step6; !(_step6 = _iterator6()).done;){
                var a = _step6.value;
                if (!atomState.m.d.has(a)) {
                    var aMounted = _mountAtom(pending, a, getAtomState(a, atomState));
                    aMounted.t.add(atom);
                    atomState.m.d.add(a);
                }
            }
            for(var _iterator7 = $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(atomState.m.d || []), _step7; !(_step7 = _iterator7()).done;){
                var _a = _step7.value;
                if (!atomState.d.has(_a)) {
                    atomState.m.d.delete(_a);
                    var _aMounted = _unmountAtom(pending, _a, getAtomState(_a, atomState));
                    _aMounted == null || _aMounted.t.delete(atom);
                }
            }
        }
    };
    var _mountAtom = function mountAtom(pending, atom, atomState) {
        if (!atomState.m) {
            _readAtomState(pending, atom, atomState);
            for(var _iterator8 = $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step8; !(_step8 = _iterator8()).done;){
                var a = _step8.value;
                var aMounted = _mountAtom(pending, a, getAtomState(a, atomState));
                aMounted.t.add(atom);
            }
            atomState.m = {
                l: new Set(),
                d: new Set(atomState.d.keys()),
                t: new Set()
            };
            if ($3a102820b3d4b570$var$isActuallyWritableAtom(atom) && atom.onMount) {
                var mounted = atomState.m;
                var onMount = atom.onMount;
                $3a102820b3d4b570$var$addPendingFunction(pending, function() {
                    var onUnmount = onMount(function() {
                        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                        return _writeAtomState.apply(void 0, [
                            pending,
                            atom,
                            atomState
                        ].concat(args));
                    });
                    if (onUnmount) mounted.u = onUnmount;
                });
            }
        }
        return atomState.m;
    };
    var _unmountAtom = function unmountAtom(pending, atom, atomState) {
        if (atomState.m && !atomState.m.l.size && !Array.from(atomState.m.t).some(function(a) {
            var _getAtomState$m;
            return (_getAtomState$m = getAtomState(a, atomState).m) == null ? void 0 : _getAtomState$m.d.has(atom);
        })) {
            var onUnmount = atomState.m.u;
            if (onUnmount) $3a102820b3d4b570$var$addPendingFunction(pending, onUnmount);
            delete atomState.m;
            for(var _iterator9 = $3a102820b3d4b570$var$_createForOfIteratorHelperLoose(atomState.d.keys()), _step9; !(_step9 = _iterator9()).done;){
                var a = _step9.value;
                var aMounted = _unmountAtom(pending, a, getAtomState(a, atomState));
                aMounted == null || aMounted.t.delete(atom);
            }
            return undefined;
        }
        return atomState.m;
    };
    var subscribeAtom = function subscribeAtom(atom, listener) {
        var pending = $3a102820b3d4b570$var$createPending();
        var atomState = getAtomState(atom);
        var mounted = _mountAtom(pending, atom, atomState);
        $3a102820b3d4b570$var$flushPending(pending);
        var listeners = mounted.l;
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
            var pending = $3a102820b3d4b570$var$createPending();
            _unmountAtom(pending, atom, atomState);
            $3a102820b3d4b570$var$flushPending(pending);
        };
    };
    var unstable_derive = function unstable_derive(fn) {
        return $3a102820b3d4b570$var$_buildStore.apply(void 0, fn(getAtomState));
    };
    var store = {
        get: readAtom,
        set: writeAtom,
        sub: subscribeAtom,
        unstable_derive: unstable_derive
    };
    var devStore;
    return store;
};
var $3a102820b3d4b570$var$createStore = function createStore() {
    var atomStateMap = new WeakMap();
    var getAtomState = function getAtomState(atom) {
        var atomState = atomStateMap.get(atom);
        if (!atomState) {
            atomState = {
                d: new Map(),
                p: new Set(),
                n: 0
            };
            atomStateMap.set(atom, atomState);
        }
        return atomState;
    };
    return $3a102820b3d4b570$var$_buildStore(getAtomState);
};
var $3a102820b3d4b570$var$defaultStore;
var $3a102820b3d4b570$var$getDefaultStore = function getDefaultStore() {
    if (!$3a102820b3d4b570$var$defaultStore) {
        $3a102820b3d4b570$var$defaultStore = $3a102820b3d4b570$var$createStore();
        var _ref3;
    }
    return $3a102820b3d4b570$var$defaultStore;
};
$3a102820b3d4b570$export$5fb5cc0d078610b = $3a102820b3d4b570$var$atom;
$3a102820b3d4b570$export$f51a9068ac82ea43 = $3a102820b3d4b570$var$createStore;
$3a102820b3d4b570$export$39b2e4393dfcb8aa = $3a102820b3d4b570$var$getDefaultStore;


var $6c73c2a954dd1869$exports = {};

$parcel$export($6c73c2a954dd1869$exports, "Provider", () => $6c73c2a954dd1869$export$2881499e37b75b9a, (v) => $6c73c2a954dd1869$export$2881499e37b75b9a = v);
$parcel$export($6c73c2a954dd1869$exports, "useAtom", () => $6c73c2a954dd1869$export$83cf7ae8bb57e7ed, (v) => $6c73c2a954dd1869$export$83cf7ae8bb57e7ed = v);
$parcel$export($6c73c2a954dd1869$exports, "useAtomValue", () => $6c73c2a954dd1869$export$89a40582f8c436cc, (v) => $6c73c2a954dd1869$export$89a40582f8c436cc = v);
$parcel$export($6c73c2a954dd1869$exports, "useSetAtom", () => $6c73c2a954dd1869$export$a247c952d39ea7ea, (v) => $6c73c2a954dd1869$export$a247c952d39ea7ea = v);
$parcel$export($6c73c2a954dd1869$exports, "useStore", () => $6c73c2a954dd1869$export$6ccbb43953eebf8, (v) => $6c73c2a954dd1869$export$6ccbb43953eebf8 = v);
var $6c73c2a954dd1869$export$2881499e37b75b9a;
var $6c73c2a954dd1869$export$83cf7ae8bb57e7ed;
var $6c73c2a954dd1869$export$89a40582f8c436cc;
var $6c73c2a954dd1869$export$a247c952d39ea7ea;
var $6c73c2a954dd1869$export$6ccbb43953eebf8;
'use client';
'use strict';
parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $7hzE7 = parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");

var $6c73c2a954dd1869$var$StoreContext = $9Oehh.createContext(undefined);
var $6c73c2a954dd1869$var$useStore = function useStore(options) {
    var store = $6F3kv.useContext($6c73c2a954dd1869$var$StoreContext);
    return (options == null ? void 0 : options.store) || store || $3a102820b3d4b570$export$39b2e4393dfcb8aa();
};
var $6c73c2a954dd1869$var$Provider = function Provider(_ref) {
    var children = _ref.children, store = _ref.store;
    var storeRef = $6F3kv.useRef();
    if (!store && !storeRef.current) storeRef.current = $3a102820b3d4b570$export$f51a9068ac82ea43();
    return $9Oehh.createElement($6c73c2a954dd1869$var$StoreContext.Provider, {
        value: store || storeRef.current
    }, children);
};
var $6c73c2a954dd1869$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === 'function';
};
var $6c73c2a954dd1869$var$attachPromiseMeta = function attachPromiseMeta(promise) {
    promise.status = 'pending';
    promise.then(function(v) {
        promise.status = 'fulfilled';
        promise.value = v;
    }, function(e) {
        promise.status = 'rejected';
        promise.reason = e;
    });
};
var $6c73c2a954dd1869$var$use = $7hzE7.use || function(promise) {
    if (promise.status === 'pending') throw promise;
    else if (promise.status === 'fulfilled') return promise.value;
    else if (promise.status === 'rejected') throw promise.reason;
    else {
        $6c73c2a954dd1869$var$attachPromiseMeta(promise);
        throw promise;
    }
};
var $6c73c2a954dd1869$var$continuablePromiseMap = new WeakMap();
var $6c73c2a954dd1869$var$createContinuablePromise = function createContinuablePromise(promise) {
    var continuablePromise = $6c73c2a954dd1869$var$continuablePromiseMap.get(promise);
    if (!continuablePromise) {
        continuablePromise = new Promise(function(resolve, reject) {
            var curr = promise;
            var onFulfilled = function onFulfilled(me) {
                return function(v) {
                    if (curr === me) resolve(v);
                };
            };
            var onRejected = function onRejected(me) {
                return function(e) {
                    if (curr === me) reject(e);
                };
            };
            var _registerCancelHandler = function registerCancelHandler(p) {
                if ('onCancel' in p && typeof p.onCancel === 'function') p.onCancel(function(nextValue) {
                    if ($6c73c2a954dd1869$var$isPromiseLike(nextValue)) {
                        $6c73c2a954dd1869$var$continuablePromiseMap.set(nextValue, continuablePromise);
                        curr = nextValue;
                        nextValue.then(onFulfilled(nextValue), onRejected(nextValue));
                        _registerCancelHandler(nextValue);
                    } else resolve(nextValue);
                });
            };
            promise.then(onFulfilled(promise), onRejected(promise));
            _registerCancelHandler(promise);
        });
        $6c73c2a954dd1869$var$continuablePromiseMap.set(promise, continuablePromise);
    }
    return continuablePromise;
};
function $6c73c2a954dd1869$var$useAtomValue(atom, options) {
    var store = $6c73c2a954dd1869$var$useStore(options);
    var _useReducer = $6F3kv.useReducer(function(prev) {
        var nextValue = store.get(atom);
        if (Object.is(prev[0], nextValue) && prev[1] === store && prev[2] === atom) return prev;
        return [
            nextValue,
            store,
            atom
        ];
    }, undefined, function() {
        return [
            store.get(atom),
            store,
            atom
        ];
    }), _useReducer$ = _useReducer[0], valueFromReducer = _useReducer$[0], storeFromReducer = _useReducer$[1], atomFromReducer = _useReducer$[2], rerender = _useReducer[1];
    var value = valueFromReducer;
    if (storeFromReducer !== store || atomFromReducer !== atom) {
        rerender();
        value = store.get(atom);
    }
    var delay = options == null ? void 0 : options.delay;
    $6F3kv.useEffect(function() {
        var unsub = store.sub(atom, function() {
            if (typeof delay === 'number') {
                var _value = store.get(atom);
                if ($6c73c2a954dd1869$var$isPromiseLike(_value)) $6c73c2a954dd1869$var$attachPromiseMeta($6c73c2a954dd1869$var$createContinuablePromise(_value));
                setTimeout(rerender, delay);
                return;
            }
            rerender();
        });
        rerender();
        return unsub;
    }, [
        store,
        atom,
        delay
    ]);
    $6F3kv.useDebugValue(value);
    if ($6c73c2a954dd1869$var$isPromiseLike(value)) {
        var promise = $6c73c2a954dd1869$var$createContinuablePromise(value);
        return $6c73c2a954dd1869$var$use(promise);
    }
    return value;
}
function $6c73c2a954dd1869$var$useSetAtom(atom, options) {
    var store = $6c73c2a954dd1869$var$useStore(options);
    var setAtom = $6F3kv.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return store.set.apply(store, [
            atom
        ].concat(args));
    }, [
        store,
        atom
    ]);
    return setAtom;
}
function $6c73c2a954dd1869$var$useAtom(atom, options) {
    return [
        $6c73c2a954dd1869$var$useAtomValue(atom, options),
        $6c73c2a954dd1869$var$useSetAtom(atom, options)
    ];
}
$6c73c2a954dd1869$export$2881499e37b75b9a = $6c73c2a954dd1869$var$Provider;
$6c73c2a954dd1869$export$83cf7ae8bb57e7ed = $6c73c2a954dd1869$var$useAtom;
$6c73c2a954dd1869$export$89a40582f8c436cc = $6c73c2a954dd1869$var$useAtomValue;
$6c73c2a954dd1869$export$a247c952d39ea7ea = $6c73c2a954dd1869$var$useSetAtom;
$6c73c2a954dd1869$export$6ccbb43953eebf8 = $6c73c2a954dd1869$var$useStore;


Object.keys($3a102820b3d4b570$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($0b20ce121ee1acb3$exports, k)) Object.defineProperty($0b20ce121ee1acb3$exports, k, {
        enumerable: true,
        get: function() {
            return $3a102820b3d4b570$exports[k];
        }
    });
});
Object.keys($6c73c2a954dd1869$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($0b20ce121ee1acb3$exports, k)) Object.defineProperty($0b20ce121ee1acb3$exports, k, {
        enumerable: true,
        get: function() {
            return $6c73c2a954dd1869$exports[k];
        }
    });
});


var $2c41129e06adf0dc$exports = {};

$2c41129e06adf0dc$exports = (parcelRequire("2Wppk")).default;

$2c41129e06adf0dc$exports.utils = (parcelRequire("85pJf"));

$2c41129e06adf0dc$exports.calculateUtils = (parcelRequire("6byAd"));

$2c41129e06adf0dc$exports.Responsive = (parcelRequire("lN2PJ")).default;

$2c41129e06adf0dc$exports.Responsive.utils = (parcelRequire("6SzlB"));

$2c41129e06adf0dc$exports.WidthProvider = (parcelRequire("8EWbb")).default;



var $9Oehh = parcelRequire("9Oehh");
parcelRequire("7hzE7");
var $8Zslt = parcelRequire("8Zslt");
var $6F3kv = parcelRequire("6F3kv");
var $2777ab815ff52a44$exports = {};
var $d5cd4d91bf5e58a1$exports = {};
/* MIT license */ var $5772943b4c906d68$exports = {};
'use strict';
$5772943b4c906d68$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $e15decef319e144b$exports = {};
'use strict';
var $289ffb2486fc6457$exports = {};
$289ffb2486fc6457$exports = function isArrayish(obj) {
    if (!obj || typeof obj === 'string') return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};


var $e15decef319e144b$var$concat = Array.prototype.concat;
var $e15decef319e144b$var$slice = Array.prototype.slice;
var $e15decef319e144b$var$swizzle = $e15decef319e144b$exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($289ffb2486fc6457$exports(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $e15decef319e144b$var$concat.call(results, $e15decef319e144b$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$e15decef319e144b$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($e15decef319e144b$var$swizzle(arguments));
    };
};


var $d5cd4d91bf5e58a1$var$hasOwnProperty = Object.hasOwnProperty;
var $d5cd4d91bf5e58a1$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $d5cd4d91bf5e58a1$var$name in $5772943b4c906d68$exports)if ($d5cd4d91bf5e58a1$var$hasOwnProperty.call($5772943b4c906d68$exports, $d5cd4d91bf5e58a1$var$name)) $d5cd4d91bf5e58a1$var$reverseNames[$5772943b4c906d68$exports[$d5cd4d91bf5e58a1$var$name]] = $d5cd4d91bf5e58a1$var$name;
var $d5cd4d91bf5e58a1$var$cs = $d5cd4d91bf5e58a1$exports = {
    to: {},
    get: {}
};
$d5cd4d91bf5e58a1$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case 'hsl':
            val = $d5cd4d91bf5e58a1$var$cs.get.hsl(string);
            model = 'hsl';
            break;
        case 'hwb':
            val = $d5cd4d91bf5e58a1$var$cs.get.hwb(string);
            model = 'hwb';
            break;
        default:
            val = $d5cd4d91bf5e58a1$var$cs.get.rgb(string);
            model = 'rgb';
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$d5cd4d91bf5e58a1$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === 'transparent') return [
            0,
            0,
            0,
            0
        ];
        if (!$d5cd4d91bf5e58a1$var$hasOwnProperty.call($5772943b4c906d68$exports, match[1])) return null;
        rgb = $5772943b4c906d68$exports[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $d5cd4d91bf5e58a1$var$clamp(rgb[i], 0, 255);
    rgb[3] = $d5cd4d91bf5e58a1$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$d5cd4d91bf5e58a1$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $d5cd4d91bf5e58a1$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $d5cd4d91bf5e58a1$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $d5cd4d91bf5e58a1$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$d5cd4d91bf5e58a1$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $d5cd4d91bf5e58a1$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $d5cd4d91bf5e58a1$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $d5cd4d91bf5e58a1$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$d5cd4d91bf5e58a1$var$cs.to.hex = function() {
    var rgba = $e15decef319e144b$exports(arguments);
    return '#' + $d5cd4d91bf5e58a1$var$hexDouble(rgba[0]) + $d5cd4d91bf5e58a1$var$hexDouble(rgba[1]) + $d5cd4d91bf5e58a1$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $d5cd4d91bf5e58a1$var$hexDouble(Math.round(rgba[3] * 255)) : '');
};
$d5cd4d91bf5e58a1$var$cs.to.rgb = function() {
    var rgba = $e15decef319e144b$exports(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};
$d5cd4d91bf5e58a1$var$cs.to.rgb.percent = function() {
    var rgba = $e15decef319e144b$exports(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};
$d5cd4d91bf5e58a1$var$cs.to.hsl = function() {
    var hsla = $e15decef319e144b$exports(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$d5cd4d91bf5e58a1$var$cs.to.hwb = function() {
    var hwba = $e15decef319e144b$exports(arguments);
    var a = '';
    if (hwba.length >= 4 && hwba[3] !== 1) a = ', ' + hwba[3];
    return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};
$d5cd4d91bf5e58a1$var$cs.to.keyword = function(rgb) {
    return $d5cd4d91bf5e58a1$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $d5cd4d91bf5e58a1$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $d5cd4d91bf5e58a1$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? '0' + str : str;
}


var $476df93ca3eecb64$exports = {};
var $c918eaf931f3a21c$exports = {};
/* MIT license */ /* eslint-disable no-mixed-operators */ 
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $c918eaf931f3a21c$var$reverseKeywords = {};
for (const key of Object.keys($5772943b4c906d68$exports))$c918eaf931f3a21c$var$reverseKeywords[$5772943b4c906d68$exports[key]] = key;
const $c918eaf931f3a21c$var$convert = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
$c918eaf931f3a21c$exports = $c918eaf931f3a21c$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($c918eaf931f3a21c$var$convert)){
    if (!('channels' in $c918eaf931f3a21c$var$convert[model])) throw new Error('missing channels property: ' + model);
    if (!('labels' in $c918eaf931f3a21c$var$convert[model])) throw new Error('missing channel labels property: ' + model);
    if ($c918eaf931f3a21c$var$convert[model].labels.length !== $c918eaf931f3a21c$var$convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
    const { channels: channels, labels: labels } = $c918eaf931f3a21c$var$convert[model];
    delete $c918eaf931f3a21c$var$convert[model].channels;
    delete $c918eaf931f3a21c$var$convert[model].labels;
    Object.defineProperty($c918eaf931f3a21c$var$convert[model], 'channels', {
        value: channels
    });
    Object.defineProperty($c918eaf931f3a21c$var$convert[model], 'labels', {
        value: labels
    });
}
$c918eaf931f3a21c$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$c918eaf931f3a21c$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$c918eaf931f3a21c$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $c918eaf931f3a21c$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$c918eaf931f3a21c$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $c918eaf931f3a21c$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$c918eaf931f3a21c$var$convert.rgb.keyword = function(rgb) {
    const reversed = $c918eaf931f3a21c$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($5772943b4c906d68$exports)){
        const value = $5772943b4c906d68$exports[keyword];
        // Compute comparative distance
        const distance = $c918eaf931f3a21c$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$c918eaf931f3a21c$var$convert.keyword.rgb = function(keyword) {
    return $5772943b4c906d68$exports[keyword];
};
$c918eaf931f3a21c$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$c918eaf931f3a21c$var$convert.rgb.lab = function(rgb) {
    const xyz = $c918eaf931f3a21c$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$c918eaf931f3a21c$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$c918eaf931f3a21c$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$c918eaf931f3a21c$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$c918eaf931f3a21c$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$c918eaf931f3a21c$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$c918eaf931f3a21c$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$c918eaf931f3a21c$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$c918eaf931f3a21c$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$c918eaf931f3a21c$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$c918eaf931f3a21c$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$c918eaf931f3a21c$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$c918eaf931f3a21c$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $c918eaf931f3a21c$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$c918eaf931f3a21c$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $c918eaf931f3a21c$var$convert.rgb.ansi16($c918eaf931f3a21c$var$convert.hsv.rgb(args), args[2]);
};
$c918eaf931f3a21c$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$c918eaf931f3a21c$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$c918eaf931f3a21c$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$c918eaf931f3a21c$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$c918eaf931f3a21c$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split('').map((char)=>{
        return char + char;
    }).join('');
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$c918eaf931f3a21c$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$c918eaf931f3a21c$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$c918eaf931f3a21c$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$c918eaf931f3a21c$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$c918eaf931f3a21c$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$c918eaf931f3a21c$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$c918eaf931f3a21c$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$c918eaf931f3a21c$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$c918eaf931f3a21c$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$c918eaf931f3a21c$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$c918eaf931f3a21c$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$c918eaf931f3a21c$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$c918eaf931f3a21c$var$convert.gray.hsv = $c918eaf931f3a21c$var$convert.gray.hsl;
$c918eaf931f3a21c$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$c918eaf931f3a21c$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$c918eaf931f3a21c$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$c918eaf931f3a21c$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$c918eaf931f3a21c$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};


var $9108f07b8881ad0a$exports = {};

/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $9108f07b8881ad0a$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($c918eaf931f3a21c$exports);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $9108f07b8881ad0a$var$deriveBFS(fromModel) {
    const graph = $9108f07b8881ad0a$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($c918eaf931f3a21c$exports[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $9108f07b8881ad0a$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $9108f07b8881ad0a$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $c918eaf931f3a21c$exports[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $9108f07b8881ad0a$var$link($c918eaf931f3a21c$exports[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
$9108f07b8881ad0a$exports = function(fromModel) {
    const graph = $9108f07b8881ad0a$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $9108f07b8881ad0a$var$wrapConversion(toModel, graph);
    }
    return conversion;
};


const $476df93ca3eecb64$var$convert = {};
const $476df93ca3eecb64$var$models = Object.keys($c918eaf931f3a21c$exports);
function $476df93ca3eecb64$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $476df93ca3eecb64$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === 'object') for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$476df93ca3eecb64$var$models.forEach((fromModel)=>{
    $476df93ca3eecb64$var$convert[fromModel] = {};
    Object.defineProperty($476df93ca3eecb64$var$convert[fromModel], 'channels', {
        value: $c918eaf931f3a21c$exports[fromModel].channels
    });
    Object.defineProperty($476df93ca3eecb64$var$convert[fromModel], 'labels', {
        value: $c918eaf931f3a21c$exports[fromModel].labels
    });
    const routes = $9108f07b8881ad0a$exports(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $476df93ca3eecb64$var$convert[fromModel][toModel] = $476df93ca3eecb64$var$wrapRounded(fn);
        $476df93ca3eecb64$var$convert[fromModel][toModel].raw = $476df93ca3eecb64$var$wrapRaw(fn);
    });
});
$476df93ca3eecb64$exports = $476df93ca3eecb64$var$convert;


const $2777ab815ff52a44$var$skippedModels = [
    // To be honest, I don't really feel like keyword belongs in color convert, but eh.
    'keyword',
    // Gray conflicts with some method names, and has its own method defined.
    'gray',
    // Shouldn't really be in color-convert either...
    'hex'
];
const $2777ab815ff52a44$var$hashedModelKeys = {};
for (const model of Object.keys($476df93ca3eecb64$exports))$2777ab815ff52a44$var$hashedModelKeys[[
    ...$476df93ca3eecb64$exports[model].labels
].sort().join('')] = model;
const $2777ab815ff52a44$var$limiters = {};
function $2777ab815ff52a44$var$Color(object, model) {
    if (!(this instanceof $2777ab815ff52a44$var$Color)) return new $2777ab815ff52a44$var$Color(object, model);
    if (model && model in $2777ab815ff52a44$var$skippedModels) model = null;
    if (model && !(model in $476df93ca3eecb64$exports)) throw new Error('Unknown model: ' + model);
    let i;
    let channels;
    if (object == null) {
        this.model = 'rgb';
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (object instanceof $2777ab815ff52a44$var$Color) {
        this.model = object.model;
        this.color = [
            ...object.color
        ];
        this.valpha = object.valpha;
    } else if (typeof object === 'string') {
        const result = $d5cd4d91bf5e58a1$exports.get(object);
        if (result === null) throw new Error('Unable to parse color from string: ' + object);
        this.model = result.model;
        channels = $476df93ca3eecb64$exports[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
    } else if (object.length > 0) {
        this.model = model || 'rgb';
        channels = $476df93ca3eecb64$exports[this.model].channels;
        const newArray = Array.prototype.slice.call(object, 0, channels);
        this.color = $2777ab815ff52a44$var$zeroArray(newArray, channels);
        this.valpha = typeof object[channels] === 'number' ? object[channels] : 1;
    } else if (typeof object === 'number') {
        // This is always RGB - can be converted later on.
        this.model = 'rgb';
        this.color = [
            object >> 16 & 0xFF,
            object >> 8 & 0xFF,
            object & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        const keys = Object.keys(object);
        if ('alpha' in object) {
            keys.splice(keys.indexOf('alpha'), 1);
            this.valpha = typeof object.alpha === 'number' ? object.alpha : 0;
        }
        const hashedKeys = keys.sort().join('');
        if (!(hashedKeys in $2777ab815ff52a44$var$hashedModelKeys)) throw new Error('Unable to parse color from object: ' + JSON.stringify(object));
        this.model = $2777ab815ff52a44$var$hashedModelKeys[hashedKeys];
        const { labels: labels } = $476df93ca3eecb64$exports[this.model];
        const color = [];
        for(i = 0; i < labels.length; i++)color.push(object[labels[i]]);
        this.color = $2777ab815ff52a44$var$zeroArray(color);
    }
    // Perform limitations (clamping, etc.)
    if ($2777ab815ff52a44$var$limiters[this.model]) {
        channels = $476df93ca3eecb64$exports[this.model].channels;
        for(i = 0; i < channels; i++){
            const limit = $2777ab815ff52a44$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$2777ab815ff52a44$var$Color.prototype = {
    toString () {
        return this.string();
    },
    toJSON () {
        return this[this.model]();
    },
    string (places) {
        let self = this.model in $d5cd4d91bf5e58a1$exports.to ? this : this.rgb();
        self = self.round(typeof places === 'number' ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $d5cd4d91bf5e58a1$exports.to[self.model](args);
    },
    percentString (places) {
        const self = this.rgb().round(typeof places === 'number' ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $d5cd4d91bf5e58a1$exports.to.rgb.percent(args);
    },
    array () {
        return this.valpha === 1 ? [
            ...this.color
        ] : [
            ...this.color,
            this.valpha
        ];
    },
    object () {
        const result = {};
        const { channels: channels } = $476df93ca3eecb64$exports[this.model];
        const { labels: labels } = $476df93ca3eecb64$exports[this.model];
        for(let i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray () {
        const rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject () {
        const rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round (places) {
        places = Math.max(places || 0, 0);
        return new $2777ab815ff52a44$var$Color([
            ...this.color.map($2777ab815ff52a44$var$roundToPlace(places)),
            this.valpha
        ], this.model);
    },
    alpha (value) {
        if (value !== undefined) return new $2777ab815ff52a44$var$Color([
            ...this.color,
            Math.max(0, Math.min(1, value))
        ], this.model);
        return this.valpha;
    },
    // Rgb
    red: $2777ab815ff52a44$var$getset('rgb', 0, $2777ab815ff52a44$var$maxfn(255)),
    green: $2777ab815ff52a44$var$getset('rgb', 1, $2777ab815ff52a44$var$maxfn(255)),
    blue: $2777ab815ff52a44$var$getset('rgb', 2, $2777ab815ff52a44$var$maxfn(255)),
    hue: $2777ab815ff52a44$var$getset([
        'hsl',
        'hsv',
        'hsl',
        'hwb',
        'hcg'
    ], 0, (value)=>(value % 360 + 360) % 360),
    saturationl: $2777ab815ff52a44$var$getset('hsl', 1, $2777ab815ff52a44$var$maxfn(100)),
    lightness: $2777ab815ff52a44$var$getset('hsl', 2, $2777ab815ff52a44$var$maxfn(100)),
    saturationv: $2777ab815ff52a44$var$getset('hsv', 1, $2777ab815ff52a44$var$maxfn(100)),
    value: $2777ab815ff52a44$var$getset('hsv', 2, $2777ab815ff52a44$var$maxfn(100)),
    chroma: $2777ab815ff52a44$var$getset('hcg', 1, $2777ab815ff52a44$var$maxfn(100)),
    gray: $2777ab815ff52a44$var$getset('hcg', 2, $2777ab815ff52a44$var$maxfn(100)),
    white: $2777ab815ff52a44$var$getset('hwb', 1, $2777ab815ff52a44$var$maxfn(100)),
    wblack: $2777ab815ff52a44$var$getset('hwb', 2, $2777ab815ff52a44$var$maxfn(100)),
    cyan: $2777ab815ff52a44$var$getset('cmyk', 0, $2777ab815ff52a44$var$maxfn(100)),
    magenta: $2777ab815ff52a44$var$getset('cmyk', 1, $2777ab815ff52a44$var$maxfn(100)),
    yellow: $2777ab815ff52a44$var$getset('cmyk', 2, $2777ab815ff52a44$var$maxfn(100)),
    black: $2777ab815ff52a44$var$getset('cmyk', 3, $2777ab815ff52a44$var$maxfn(100)),
    x: $2777ab815ff52a44$var$getset('xyz', 0, $2777ab815ff52a44$var$maxfn(95.047)),
    y: $2777ab815ff52a44$var$getset('xyz', 1, $2777ab815ff52a44$var$maxfn(100)),
    z: $2777ab815ff52a44$var$getset('xyz', 2, $2777ab815ff52a44$var$maxfn(108.833)),
    l: $2777ab815ff52a44$var$getset('lab', 0, $2777ab815ff52a44$var$maxfn(100)),
    a: $2777ab815ff52a44$var$getset('lab', 1),
    b: $2777ab815ff52a44$var$getset('lab', 2),
    keyword (value) {
        if (value !== undefined) return new $2777ab815ff52a44$var$Color(value);
        return $476df93ca3eecb64$exports[this.model].keyword(this.color);
    },
    hex (value) {
        if (value !== undefined) return new $2777ab815ff52a44$var$Color(value);
        return $d5cd4d91bf5e58a1$exports.to.hex(this.rgb().round().color);
    },
    hexa (value) {
        if (value !== undefined) return new $2777ab815ff52a44$var$Color(value);
        const rgbArray = this.rgb().round().color;
        let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
        if (alphaHex.length === 1) alphaHex = '0' + alphaHex;
        return $d5cd4d91bf5e58a1$exports.to.hex(rgbArray) + alphaHex;
    },
    rgbNumber () {
        const rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity () {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        const rgb = this.rgb().color;
        const lum = [];
        for (const [i, element] of rgb.entries()){
            const chan = element / 255;
            lum[i] = chan <= 0.04045 ? chan / 12.92 : ((chan + 0.055) / 1.055) ** 2.4;
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast (color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        const lum1 = this.luminosity();
        const lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level (color2) {
        // https://www.w3.org/TR/WCAG/#contrast-enhanced
        const contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7) return 'AAA';
        return contrastRatio >= 4.5 ? 'AA' : '';
    },
    isDark () {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        const rgb = this.rgb().color;
        const yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
        return yiq < 128;
    },
    isLight () {
        return !this.isDark();
    },
    negate () {
        const rgb = this.rgb();
        for(let i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten (ratio) {
        const hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken (ratio) {
        const hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten (ratio) {
        const hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken (ratio) {
        const hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale () {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        const rgb = this.rgb().color;
        const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $2777ab815ff52a44$var$Color.rgb(value, value, value);
    },
    fade (ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer (ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate (degrees) {
        const hsl = this.hsl();
        let hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix (mixinColor, weight) {
        // Ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        const color1 = mixinColor.rgb();
        const color2 = this.rgb();
        const p = weight === undefined ? 0.5 : weight;
        const w = 2 * p - 1;
        const a = color1.alpha() - color2.alpha();
        const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        const w2 = 1 - w1;
        return $2777ab815ff52a44$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// Model conversion methods and static constructors
for (const model of Object.keys($476df93ca3eecb64$exports)){
    if ($2777ab815ff52a44$var$skippedModels.includes(model)) continue;
    const { channels: channels } = $476df93ca3eecb64$exports[model];
    // Conversion methods
    $2777ab815ff52a44$var$Color.prototype[model] = function(...args) {
        if (this.model === model) return new $2777ab815ff52a44$var$Color(this);
        if (args.length > 0) return new $2777ab815ff52a44$var$Color(args, model);
        return new $2777ab815ff52a44$var$Color([
            ...$2777ab815ff52a44$var$assertArray($476df93ca3eecb64$exports[this.model][model].raw(this.color)),
            this.valpha
        ], model);
    };
    // 'static' construction methods
    $2777ab815ff52a44$var$Color[model] = function(...args) {
        let color = args[0];
        if (typeof color === 'number') color = $2777ab815ff52a44$var$zeroArray(args, channels);
        return new $2777ab815ff52a44$var$Color(color, model);
    };
}
function $2777ab815ff52a44$var$roundTo(number, places) {
    return Number(number.toFixed(places));
}
function $2777ab815ff52a44$var$roundToPlace(places) {
    return function(number) {
        return $2777ab815ff52a44$var$roundTo(number, places);
    };
}
function $2777ab815ff52a44$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    for (const m of model)($2777ab815ff52a44$var$limiters[m] || ($2777ab815ff52a44$var$limiters[m] = []))[channel] = modifier;
    model = model[0];
    return function(value) {
        let result;
        if (value !== undefined) {
            if (modifier) value = modifier(value);
            result = this[model]();
            result.color[channel] = value;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $2777ab815ff52a44$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $2777ab815ff52a44$var$assertArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $2777ab815ff52a44$var$zeroArray(array, length) {
    for(let i = 0; i < length; i++)if (typeof array[i] !== 'number') array[i] = 0;
    return array;
}
$2777ab815ff52a44$exports = $2777ab815ff52a44$var$Color;




var $787fd5ab8c7121a2$exports = {};
'use strict';
var $d907c2cd5035cc3a$exports = {};

$parcel$export($d907c2cd5035cc3a$exports, "RESET", () => $d907c2cd5035cc3a$export$4a991c87e640ef77, (v) => $d907c2cd5035cc3a$export$4a991c87e640ef77 = v);
$parcel$export($d907c2cd5035cc3a$exports, "atomFamily", () => $d907c2cd5035cc3a$export$98dc87c59e005bfc, (v) => $d907c2cd5035cc3a$export$98dc87c59e005bfc = v);
$parcel$export($d907c2cd5035cc3a$exports, "atomWithDefault", () => $d907c2cd5035cc3a$export$2d6fff7aed134d89, (v) => $d907c2cd5035cc3a$export$2d6fff7aed134d89 = v);
$parcel$export($d907c2cd5035cc3a$exports, "atomWithLazy", () => $d907c2cd5035cc3a$export$fd6cc418c371333, (v) => $d907c2cd5035cc3a$export$fd6cc418c371333 = v);
$parcel$export($d907c2cd5035cc3a$exports, "atomWithObservable", () => $d907c2cd5035cc3a$export$3b2a8474031f51b9, (v) => $d907c2cd5035cc3a$export$3b2a8474031f51b9 = v);
$parcel$export($d907c2cd5035cc3a$exports, "atomWithReducer", () => $d907c2cd5035cc3a$export$17495099fe18a247, (v) => $d907c2cd5035cc3a$export$17495099fe18a247 = v);
$parcel$export($d907c2cd5035cc3a$exports, "atomWithRefresh", () => $d907c2cd5035cc3a$export$3b2add07a6d4dc2e, (v) => $d907c2cd5035cc3a$export$3b2add07a6d4dc2e = v);
$parcel$export($d907c2cd5035cc3a$exports, "atomWithReset", () => $d907c2cd5035cc3a$export$1f78fd6066f888bc, (v) => $d907c2cd5035cc3a$export$1f78fd6066f888bc = v);
$parcel$export($d907c2cd5035cc3a$exports, "atomWithStorage", () => $d907c2cd5035cc3a$export$19a57601fe8d8f7b, (v) => $d907c2cd5035cc3a$export$19a57601fe8d8f7b = v);
$parcel$export($d907c2cd5035cc3a$exports, "createJSONStorage", () => $d907c2cd5035cc3a$export$95a3b7b12ab518f9, (v) => $d907c2cd5035cc3a$export$95a3b7b12ab518f9 = v);
$parcel$export($d907c2cd5035cc3a$exports, "freezeAtom", () => $d907c2cd5035cc3a$export$14251e990c96d1bb, (v) => $d907c2cd5035cc3a$export$14251e990c96d1bb = v);
$parcel$export($d907c2cd5035cc3a$exports, "freezeAtomCreator", () => $d907c2cd5035cc3a$export$62f7c4fe911bb8cf, (v) => $d907c2cd5035cc3a$export$62f7c4fe911bb8cf = v);
$parcel$export($d907c2cd5035cc3a$exports, "loadable", () => $d907c2cd5035cc3a$export$9bbab1a1471800d5, (v) => $d907c2cd5035cc3a$export$9bbab1a1471800d5 = v);
$parcel$export($d907c2cd5035cc3a$exports, "selectAtom", () => $d907c2cd5035cc3a$export$36732b116f66dde9, (v) => $d907c2cd5035cc3a$export$36732b116f66dde9 = v);
$parcel$export($d907c2cd5035cc3a$exports, "splitAtom", () => $d907c2cd5035cc3a$export$6fe7d67a9e4f1865, (v) => $d907c2cd5035cc3a$export$6fe7d67a9e4f1865 = v);
$parcel$export($d907c2cd5035cc3a$exports, "unstable_withStorageValidator", () => $d907c2cd5035cc3a$export$f803079012337c0c, (v) => $d907c2cd5035cc3a$export$f803079012337c0c = v);
$parcel$export($d907c2cd5035cc3a$exports, "unwrap", () => $d907c2cd5035cc3a$export$debb760848ca95a, (v) => $d907c2cd5035cc3a$export$debb760848ca95a = v);
var $d907c2cd5035cc3a$export$4a991c87e640ef77;
var $d907c2cd5035cc3a$export$98dc87c59e005bfc;
var $d907c2cd5035cc3a$export$2d6fff7aed134d89;
var $d907c2cd5035cc3a$export$fd6cc418c371333;
var $d907c2cd5035cc3a$export$3b2a8474031f51b9;
var $d907c2cd5035cc3a$export$17495099fe18a247;
var $d907c2cd5035cc3a$export$3b2add07a6d4dc2e;
var $d907c2cd5035cc3a$export$1f78fd6066f888bc;
var $d907c2cd5035cc3a$export$19a57601fe8d8f7b;
var $d907c2cd5035cc3a$export$95a3b7b12ab518f9;
var $d907c2cd5035cc3a$export$14251e990c96d1bb;
var $d907c2cd5035cc3a$export$62f7c4fe911bb8cf;
var $d907c2cd5035cc3a$export$9bbab1a1471800d5;
var $d907c2cd5035cc3a$export$36732b116f66dde9;
var $d907c2cd5035cc3a$export$6fe7d67a9e4f1865;
var $d907c2cd5035cc3a$export$f803079012337c0c;
var $d907c2cd5035cc3a$export$debb760848ca95a;
'use strict';

var $d907c2cd5035cc3a$var$RESET = Symbol('');
function $d907c2cd5035cc3a$var$atomWithReset(initialValue) {
    var anAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(initialValue, function(get, set, update) {
        var nextValue = typeof update === 'function' ? update(get(anAtom)) : update;
        set(anAtom, nextValue === $d907c2cd5035cc3a$var$RESET ? initialValue : nextValue);
    });
    return anAtom;
}
function $d907c2cd5035cc3a$var$atomWithReducer(initialValue, reducer) {
    return $3a102820b3d4b570$export$5fb5cc0d078610b(initialValue, function(get, set, action) {
        set(this, reducer(get(this), action));
    });
}
function $d907c2cd5035cc3a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d907c2cd5035cc3a$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $d907c2cd5035cc3a$var$_unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d907c2cd5035cc3a$var$_extends() {
    return $d907c2cd5035cc3a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d907c2cd5035cc3a$var$_extends.apply(null, arguments);
}
function $d907c2cd5035cc3a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d907c2cd5035cc3a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d907c2cd5035cc3a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d907c2cd5035cc3a$var$atomFamily(initializeAtom, areEqual) {
    var shouldRemove = null;
    var atoms = new Map();
    var listeners = new Set();
    var _createAtom = function createAtom(param) {
        var item;
        if (areEqual === undefined) item = atoms.get(param);
        else for(var _iterator = $d907c2cd5035cc3a$var$_createForOfIteratorHelperLoose(atoms), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (areEqual(key, param)) {
                item = value;
                break;
            }
        }
        if (item !== undefined) {
            if (shouldRemove != null && shouldRemove(item[1], param)) _createAtom.remove(param);
            else return item[0];
        }
        var newAtom = initializeAtom(param);
        atoms.set(param, [
            newAtom,
            Date.now()
        ]);
        notifyListeners('CREATE', param, newAtom);
        return newAtom;
    };
    function notifyListeners(type, param, atom) {
        for(var _iterator2 = $d907c2cd5035cc3a$var$_createForOfIteratorHelperLoose(listeners), _step2; !(_step2 = _iterator2()).done;){
            var listener = _step2.value;
            listener({
                type: type,
                param: param,
                atom: atom
            });
        }
    }
    _createAtom.unstable_listen = function(callback) {
        listeners.add(callback);
        return function() {
            listeners.delete(callback);
        };
    };
    _createAtom.getParams = function() {
        return atoms.keys();
    };
    _createAtom.remove = function(param) {
        if (areEqual === undefined) {
            if (!atoms.has(param)) return;
            var _ref = atoms.get(param), atom = _ref[0];
            atoms.delete(param);
            notifyListeners('REMOVE', param, atom);
        } else for(var _iterator3 = $d907c2cd5035cc3a$var$_createForOfIteratorHelperLoose(atoms), _step3; !(_step3 = _iterator3()).done;){
            var _step3$value = _step3.value, key = _step3$value[0], _step3$value$ = _step3$value[1], _atom = _step3$value$[0];
            if (areEqual(key, param)) {
                atoms.delete(key);
                notifyListeners('REMOVE', key, _atom);
                break;
            }
        }
    };
    _createAtom.setShouldRemove = function(fn) {
        shouldRemove = fn;
        if (!shouldRemove) return;
        for(var _iterator4 = $d907c2cd5035cc3a$var$_createForOfIteratorHelperLoose(atoms), _step4; !(_step4 = _iterator4()).done;){
            var _step4$value = _step4.value, key = _step4$value[0], _step4$value$ = _step4$value[1], atom = _step4$value$[0], _createdAt = _step4$value$[1];
            if (shouldRemove(_createdAt, key)) {
                atoms.delete(key);
                notifyListeners('REMOVE', key, atom);
            }
        }
    };
    return _createAtom;
}
var $d907c2cd5035cc3a$var$getCached$2 = function getCached(c, m, k) {
    return (m.has(k) ? m : m.set(k, c())).get(k);
};
var $d907c2cd5035cc3a$var$cache1$3 = new WeakMap();
var $d907c2cd5035cc3a$var$memo3 = function memo3(create, dep1, dep2, dep3) {
    var cache2 = $d907c2cd5035cc3a$var$getCached$2(function() {
        return new WeakMap();
    }, $d907c2cd5035cc3a$var$cache1$3, dep1);
    var cache3 = $d907c2cd5035cc3a$var$getCached$2(function() {
        return new WeakMap();
    }, cache2, dep2);
    return $d907c2cd5035cc3a$var$getCached$2(create, cache3, dep3);
};
function $d907c2cd5035cc3a$var$selectAtom(anAtom, selector, equalityFn) {
    if (equalityFn === void 0) equalityFn = Object.is;
    return $d907c2cd5035cc3a$var$memo3(function() {
        var EMPTY = Symbol();
        var selectValue = function selectValue(_ref) {
            var value = _ref[0], prevSlice = _ref[1];
            if (prevSlice === EMPTY) return selector(value);
            var slice = selector(value, prevSlice);
            return equalityFn(prevSlice, slice) ? prevSlice : slice;
        };
        var derivedAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(function(get) {
            var prev = get(derivedAtom);
            var value = get(anAtom);
            return selectValue([
                value,
                prev
            ]);
        });
        derivedAtom.init = EMPTY;
        return derivedAtom;
    }, anAtom, selector, equalityFn);
}
var $d907c2cd5035cc3a$var$frozenAtoms = new WeakSet();
var $d907c2cd5035cc3a$var$_deepFreeze = function deepFreeze(obj) {
    if (typeof obj !== 'object' || obj === null) return;
    Object.freeze(obj);
    var propNames = Object.getOwnPropertyNames(obj);
    for(var _iterator = $d907c2cd5035cc3a$var$_createForOfIteratorHelperLoose(propNames), _step; !(_step = _iterator()).done;){
        var name = _step.value;
        var value = obj[name];
        $d907c2cd5035cc3a$var$_deepFreeze(value);
    }
    return obj;
};
function $d907c2cd5035cc3a$var$freezeAtom(anAtom) {
    if ($d907c2cd5035cc3a$var$frozenAtoms.has(anAtom)) return anAtom;
    $d907c2cd5035cc3a$var$frozenAtoms.add(anAtom);
    var origRead = anAtom.read;
    anAtom.read = function(get, options) {
        return $d907c2cd5035cc3a$var$_deepFreeze(origRead.call(this, get, options));
    };
    if ('write' in anAtom) {
        var origWrite = anAtom.write;
        anAtom.write = function(get, set) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return origWrite.call.apply(origWrite, [
                this,
                get,
                function() {
                    for(var _len2 = arguments.length, setArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)setArgs[_key2] = arguments[_key2];
                    if (setArgs[0] === anAtom) setArgs[1] = $d907c2cd5035cc3a$var$_deepFreeze(setArgs[1]);
                    return set.apply(void 0, setArgs);
                }
            ].concat(args));
        };
    }
    return anAtom;
}
function $d907c2cd5035cc3a$var$freezeAtomCreator(createAtom) {
    return function() {
        return $d907c2cd5035cc3a$var$freezeAtom(createAtom.apply(void 0, arguments));
    };
}
var $d907c2cd5035cc3a$var$getCached$1 = function getCached(c, m, k) {
    return (m.has(k) ? m : m.set(k, c())).get(k);
};
var $d907c2cd5035cc3a$var$cache1$2 = new WeakMap();
var $d907c2cd5035cc3a$var$memo2$1 = function memo2(create, dep1, dep2) {
    var cache2 = $d907c2cd5035cc3a$var$getCached$1(function() {
        return new WeakMap();
    }, $d907c2cd5035cc3a$var$cache1$2, dep1);
    return $d907c2cd5035cc3a$var$getCached$1(create, cache2, dep2);
};
var $d907c2cd5035cc3a$var$cacheKeyForEmptyKeyExtractor = {};
var $d907c2cd5035cc3a$var$isWritable = function isWritable(atom) {
    return !!atom.write;
};
var $d907c2cd5035cc3a$var$isFunction = function isFunction(x) {
    return typeof x === 'function';
};
function $d907c2cd5035cc3a$var$splitAtom(arrAtom, keyExtractor) {
    return $d907c2cd5035cc3a$var$memo2$1(function() {
        var mappingCache = new WeakMap();
        var _getMapping = function getMapping(arr, prev) {
            var mapping = mappingCache.get(arr);
            if (mapping) return mapping;
            var prevMapping = prev && mappingCache.get(prev);
            var atomList = [];
            var keyList = [];
            arr.forEach(function(item, index) {
                var key = keyExtractor ? keyExtractor(item) : index;
                keyList[index] = key;
                var cachedAtom = prevMapping && prevMapping.atomList[prevMapping.keyList.indexOf(key)];
                if (cachedAtom) {
                    atomList[index] = cachedAtom;
                    return;
                }
                var read = function read(get) {
                    var prev = get(mappingAtom);
                    var currArr = get(arrAtom);
                    var mapping = _getMapping(currArr, prev == null ? void 0 : prev.arr);
                    var index = mapping.keyList.indexOf(key);
                    if (index < 0 || index >= currArr.length) {
                        var prevItem = arr[_getMapping(arr).keyList.indexOf(key)];
                        if (prevItem) return prevItem;
                        throw new Error('splitAtom: index out of bounds for read');
                    }
                    return currArr[index];
                };
                var write = function write(get, set, update) {
                    var prev = get(mappingAtom);
                    var arr = get(arrAtom);
                    var mapping = _getMapping(arr, prev == null ? void 0 : prev.arr);
                    var index = mapping.keyList.indexOf(key);
                    if (index < 0 || index >= arr.length) throw new Error('splitAtom: index out of bounds for write');
                    var nextItem = $d907c2cd5035cc3a$var$isFunction(update) ? update(arr[index]) : update;
                    if (!Object.is(arr[index], nextItem)) set(arrAtom, [].concat(arr.slice(0, index), [
                        nextItem
                    ], arr.slice(index + 1)));
                };
                atomList[index] = $d907c2cd5035cc3a$var$isWritable(arrAtom) ? $3a102820b3d4b570$export$5fb5cc0d078610b(read, write) : $3a102820b3d4b570$export$5fb5cc0d078610b(read);
            });
            if (prevMapping && prevMapping.keyList.length === keyList.length && prevMapping.keyList.every(function(x, i) {
                return x === keyList[i];
            })) mapping = prevMapping;
            else mapping = {
                arr: arr,
                atomList: atomList,
                keyList: keyList
            };
            mappingCache.set(arr, mapping);
            return mapping;
        };
        var mappingAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(function(get) {
            var prev = get(mappingAtom);
            var arr = get(arrAtom);
            var mapping = _getMapping(arr, prev == null ? void 0 : prev.arr);
            return mapping;
        });
        mappingAtom.init = undefined;
        var splittedAtom = $d907c2cd5035cc3a$var$isWritable(arrAtom) ? $3a102820b3d4b570$export$5fb5cc0d078610b(function(get) {
            return get(mappingAtom).atomList;
        }, function(get, set, action) {
            switch(action.type){
                case 'remove':
                    var index = get(splittedAtom).indexOf(action.atom);
                    if (index >= 0) {
                        var arr = get(arrAtom);
                        set(arrAtom, [].concat(arr.slice(0, index), arr.slice(index + 1)));
                    }
                    break;
                case 'insert':
                    var _index = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
                    if (_index >= 0) {
                        var _arr = get(arrAtom);
                        set(arrAtom, [].concat(_arr.slice(0, _index), [
                            action.value
                        ], _arr.slice(_index)));
                    }
                    break;
                case 'move':
                    var index1 = get(splittedAtom).indexOf(action.atom);
                    var index2 = action.before ? get(splittedAtom).indexOf(action.before) : get(splittedAtom).length;
                    if (index1 >= 0 && index2 >= 0) {
                        var _arr2 = get(arrAtom);
                        if (index1 < index2) set(arrAtom, [].concat(_arr2.slice(0, index1), _arr2.slice(index1 + 1, index2), [
                            _arr2[index1]
                        ], _arr2.slice(index2)));
                        else set(arrAtom, [].concat(_arr2.slice(0, index2), [
                            _arr2[index1]
                        ], _arr2.slice(index2, index1), _arr2.slice(index1 + 1)));
                    }
                    break;
            }
        }) : $3a102820b3d4b570$export$5fb5cc0d078610b(function(get) {
            return get(mappingAtom).atomList;
        });
        return splittedAtom;
    }, arrAtom, keyExtractor || $d907c2cd5035cc3a$var$cacheKeyForEmptyKeyExtractor);
}
function $d907c2cd5035cc3a$var$atomWithDefault(getDefault) {
    var EMPTY = Symbol();
    var overwrittenAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(EMPTY);
    var anAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(function(get, options) {
        var overwritten = get(overwrittenAtom);
        if (overwritten !== EMPTY) return overwritten;
        return getDefault(get, options);
    }, function(get, set, update) {
        if (update === $d907c2cd5035cc3a$var$RESET) set(overwrittenAtom, EMPTY);
        else if (typeof update === 'function') {
            var prevValue = get(anAtom);
            set(overwrittenAtom, update(prevValue));
        } else set(overwrittenAtom, update);
    });
    return anAtom;
}
var $d907c2cd5035cc3a$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === 'function';
};
function $d907c2cd5035cc3a$var$withStorageValidator(validator) {
    return function(unknownStorage) {
        var storage = $d907c2cd5035cc3a$var$_extends({}, unknownStorage, {
            getItem: function getItem(key, initialValue) {
                var validate = function validate(value) {
                    if (!validator(value)) return initialValue;
                    return value;
                };
                var value = unknownStorage.getItem(key, initialValue);
                if ($d907c2cd5035cc3a$var$isPromiseLike(value)) return value.then(validate);
                return validate(value);
            }
        });
        return storage;
    };
}
function $d907c2cd5035cc3a$var$createJSONStorage(getStringStorage, options) {
    if (getStringStorage === void 0) getStringStorage = function getStringStorage() {
        try {
            return window.localStorage;
        } catch (e) {
            return undefined;
        }
    };
    var lastStr;
    var lastValue;
    var storage = {
        getItem: function getItem(key, initialValue) {
            var _getStringStorage$get, _getStringStorage;
            var parse = function parse(str) {
                str = str || '';
                if (lastStr !== str) {
                    try {
                        lastValue = JSON.parse(str, options == null ? void 0 : options.reviver);
                    } catch (_unused) {
                        return initialValue;
                    }
                    lastStr = str;
                }
                return lastValue;
            };
            var str = (_getStringStorage$get = (_getStringStorage = getStringStorage()) == null ? void 0 : _getStringStorage.getItem(key)) != null ? _getStringStorage$get : null;
            if ($d907c2cd5035cc3a$var$isPromiseLike(str)) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(key, newValue) {
            var _getStringStorage2;
            return (_getStringStorage2 = getStringStorage()) == null ? void 0 : _getStringStorage2.setItem(key, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(key) {
            var _getStringStorage3;
            return (_getStringStorage3 = getStringStorage()) == null ? void 0 : _getStringStorage3.removeItem(key);
        }
    };
    var createHandleSubscribe = function createHandleSubscribe(subscriber) {
        return function(key, callback, initialValue) {
            return subscriber(key, function(v) {
                var newValue;
                try {
                    newValue = JSON.parse(v || '');
                } catch (_unused2) {
                    newValue = initialValue;
                }
                callback(newValue);
            });
        };
    };
    var subscriber;
    try {
        var _getStringStorage4;
        subscriber = (_getStringStorage4 = getStringStorage()) == null ? void 0 : _getStringStorage4.subscribe;
    } catch (_unused3) {}
    if (!subscriber && typeof window !== 'undefined' && typeof window.addEventListener === 'function' && window.Storage) subscriber = function subscriber(key, callback) {
        if (!(getStringStorage() instanceof window.Storage)) return function() {};
        var storageEventCallback = function storageEventCallback(e) {
            if (e.storageArea === getStringStorage() && e.key === key) callback(e.newValue);
        };
        window.addEventListener('storage', storageEventCallback);
        return function() {
            window.removeEventListener('storage', storageEventCallback);
        };
    };
    if (subscriber) storage.subscribe = createHandleSubscribe(subscriber);
    return storage;
}
var $d907c2cd5035cc3a$var$defaultStorage = $d907c2cd5035cc3a$var$createJSONStorage();
function $d907c2cd5035cc3a$var$atomWithStorage(key, initialValue, storage, options) {
    if (storage === void 0) storage = $d907c2cd5035cc3a$var$defaultStorage;
    var getOnInit = options == null ? void 0 : options.getOnInit;
    var baseAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(getOnInit ? storage.getItem(key, initialValue) : initialValue);
    baseAtom.onMount = function(setAtom) {
        setAtom(storage.getItem(key, initialValue));
        var unsub;
        if (storage.subscribe) unsub = storage.subscribe(key, setAtom, initialValue);
        return unsub;
    };
    var anAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(function(get) {
        return get(baseAtom);
    }, function(get, set, update) {
        var nextValue = typeof update === 'function' ? update(get(baseAtom)) : update;
        if (nextValue === $d907c2cd5035cc3a$var$RESET) {
            set(baseAtom, initialValue);
            return storage.removeItem(key);
        }
        if (nextValue instanceof Promise) return nextValue.then(function(resolvedValue) {
            set(baseAtom, resolvedValue);
            return storage.setItem(key, resolvedValue);
        });
        set(baseAtom, nextValue);
        return storage.setItem(key, nextValue);
    });
    return anAtom;
}
function $d907c2cd5035cc3a$var$atomWithObservable(getObservable, options) {
    var returnResultData = function returnResultData(result) {
        if ('e' in result) throw result.e;
        return result.d;
    };
    var observableResultAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(function(get) {
        var _observable$Symbol$ob, _observable;
        var observable = getObservable(get);
        var itself = (_observable$Symbol$ob = (_observable = observable)[Symbol.observable]) == null ? void 0 : _observable$Symbol$ob.call(_observable);
        if (itself) observable = itself;
        var resolve;
        var makePending = function makePending() {
            return new Promise(function(r) {
                resolve = r;
            });
        };
        var initialResult = options && 'initialValue' in options ? {
            d: typeof options.initialValue === 'function' ? options.initialValue() : options.initialValue
        } : makePending();
        var setResult;
        var lastResult;
        var listener = function listener(result) {
            lastResult = result;
            resolve == null || resolve(result);
            setResult == null || setResult(result);
        };
        var subscription;
        var timer;
        var isNotMounted = function isNotMounted() {
            return !setResult;
        };
        var start = function start() {
            if (subscription) {
                clearTimeout(timer);
                subscription.unsubscribe();
            }
            subscription = observable.subscribe({
                next: function next(d) {
                    return listener({
                        d: d
                    });
                },
                error: function error(e) {
                    return listener({
                        e: e
                    });
                },
                complete: function complete() {}
            });
            if (isNotMounted() && options != null && options.unstable_timeout) timer = setTimeout(function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            }, options.unstable_timeout);
        };
        start();
        var resultAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(lastResult || initialResult);
        resultAtom.onMount = function(update) {
            setResult = update;
            if (lastResult) update(lastResult);
            if (subscription) clearTimeout(timer);
            else start();
            return function() {
                setResult = undefined;
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        };
        return [
            resultAtom,
            observable,
            makePending,
            start,
            isNotMounted
        ];
    });
    var observableAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(function(get) {
        var _get = get(observableResultAtom), resultAtom = _get[0];
        var result = get(resultAtom);
        if (result instanceof Promise) return result.then(returnResultData);
        return returnResultData(result);
    }, function(get, set, data) {
        var _get2 = get(observableResultAtom), resultAtom = _get2[0], observable = _get2[1], makePending = _get2[2], start = _get2[3], isNotMounted = _get2[4];
        if ('next' in observable) {
            if (isNotMounted()) {
                set(resultAtom, makePending());
                start();
            }
            observable.next(data);
        } else throw new Error('observable is not subject');
    });
    return observableAtom;
}
var $d907c2cd5035cc3a$var$cache1$1 = new WeakMap();
var $d907c2cd5035cc3a$var$memo1 = function memo1(create, dep1) {
    return ($d907c2cd5035cc3a$var$cache1$1.has(dep1) ? $d907c2cd5035cc3a$var$cache1$1 : $d907c2cd5035cc3a$var$cache1$1.set(dep1, create())).get(dep1);
};
var $d907c2cd5035cc3a$var$isPromise$1 = function isPromise(x) {
    return x instanceof Promise;
};
var $d907c2cd5035cc3a$var$LOADING = {
    state: 'loading'
};
function $d907c2cd5035cc3a$var$loadable(anAtom) {
    return $d907c2cd5035cc3a$var$memo1(function() {
        var loadableCache = new WeakMap();
        var refreshAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(0);
        var derivedAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(function(get, _ref) {
            var setSelf = _ref.setSelf;
            get(refreshAtom);
            var value;
            try {
                value = get(anAtom);
            } catch (error) {
                return {
                    state: 'hasError',
                    error: error
                };
            }
            if (!$d907c2cd5035cc3a$var$isPromise$1(value)) return {
                state: 'hasData',
                data: value
            };
            var promise = value;
            var cached1 = loadableCache.get(promise);
            if (cached1) return cached1;
            promise.then(function(data) {
                loadableCache.set(promise, {
                    state: 'hasData',
                    data: data
                });
            }, function(error) {
                loadableCache.set(promise, {
                    state: 'hasError',
                    error: error
                });
            }).finally(setSelf);
            var cached2 = loadableCache.get(promise);
            if (cached2) return cached2;
            loadableCache.set(promise, $d907c2cd5035cc3a$var$LOADING);
            return $d907c2cd5035cc3a$var$LOADING;
        }, function(_get, set) {
            set(refreshAtom, function(c) {
                return c + 1;
            });
        });
        return $3a102820b3d4b570$export$5fb5cc0d078610b(function(get) {
            return get(derivedAtom);
        });
    }, anAtom);
}
var $d907c2cd5035cc3a$var$getCached = function getCached(c, m, k) {
    return (m.has(k) ? m : m.set(k, c())).get(k);
};
var $d907c2cd5035cc3a$var$cache1 = new WeakMap();
var $d907c2cd5035cc3a$var$memo2 = function memo2(create, dep1, dep2) {
    var cache2 = $d907c2cd5035cc3a$var$getCached(function() {
        return new WeakMap();
    }, $d907c2cd5035cc3a$var$cache1, dep1);
    return $d907c2cd5035cc3a$var$getCached(create, cache2, dep2);
};
var $d907c2cd5035cc3a$var$isPromise = function isPromise(x) {
    return x instanceof Promise;
};
var $d907c2cd5035cc3a$var$defaultFallback = function defaultFallback() {
    return undefined;
};
function $d907c2cd5035cc3a$var$unwrap(anAtom, fallback) {
    if (fallback === void 0) fallback = $d907c2cd5035cc3a$var$defaultFallback;
    return $d907c2cd5035cc3a$var$memo2(function() {
        var promiseErrorCache = new WeakMap();
        var promiseResultCache = new WeakMap();
        var refreshAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(0);
        var promiseAndValueAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(function(get, _ref) {
            var setSelf = _ref.setSelf;
            get(refreshAtom);
            var prev = get(promiseAndValueAtom);
            var promise = get(anAtom);
            if (!$d907c2cd5035cc3a$var$isPromise(promise)) return {
                v: promise
            };
            if (promise !== (prev == null ? void 0 : prev.p)) promise.then(function(v) {
                return promiseResultCache.set(promise, v);
            }, function(e) {
                return promiseErrorCache.set(promise, e);
            }).finally(setSelf);
            if (promiseErrorCache.has(promise)) throw promiseErrorCache.get(promise);
            if (promiseResultCache.has(promise)) return {
                p: promise,
                v: promiseResultCache.get(promise)
            };
            if (prev && 'v' in prev) return {
                p: promise,
                f: fallback(prev.v),
                v: prev.v
            };
            return {
                p: promise,
                f: fallback()
            };
        }, function(_get, set) {
            set(refreshAtom, function(c) {
                return c + 1;
            });
        });
        promiseAndValueAtom.init = undefined;
        return $3a102820b3d4b570$export$5fb5cc0d078610b(function(get) {
            var state = get(promiseAndValueAtom);
            if ('f' in state) return state.f;
            return state.v;
        }, function(_get, set) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return set.apply(void 0, [
                anAtom
            ].concat(args));
        });
    }, anAtom, fallback);
}
function $d907c2cd5035cc3a$var$atomWithRefresh(read, write) {
    var refreshAtom = $3a102820b3d4b570$export$5fb5cc0d078610b(0);
    return $3a102820b3d4b570$export$5fb5cc0d078610b(function(get, options) {
        get(refreshAtom);
        return read(get, options);
    }, function(get, set) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        if (args.length === 0) set(refreshAtom, function(c) {
            return c + 1;
        });
        else if (write) return write.apply(void 0, [
            get,
            set
        ].concat(args));
    });
}
function $d907c2cd5035cc3a$var$atomWithLazy(makeInitial) {
    var a = $3a102820b3d4b570$export$5fb5cc0d078610b(undefined);
    delete a.init;
    Object.defineProperty(a, 'init', {
        get: function get() {
            return makeInitial();
        }
    });
    return a;
}
$d907c2cd5035cc3a$export$4a991c87e640ef77 = $d907c2cd5035cc3a$var$RESET;
$d907c2cd5035cc3a$export$98dc87c59e005bfc = $d907c2cd5035cc3a$var$atomFamily;
$d907c2cd5035cc3a$export$2d6fff7aed134d89 = $d907c2cd5035cc3a$var$atomWithDefault;
$d907c2cd5035cc3a$export$fd6cc418c371333 = $d907c2cd5035cc3a$var$atomWithLazy;
$d907c2cd5035cc3a$export$3b2a8474031f51b9 = $d907c2cd5035cc3a$var$atomWithObservable;
$d907c2cd5035cc3a$export$17495099fe18a247 = $d907c2cd5035cc3a$var$atomWithReducer;
$d907c2cd5035cc3a$export$3b2add07a6d4dc2e = $d907c2cd5035cc3a$var$atomWithRefresh;
$d907c2cd5035cc3a$export$1f78fd6066f888bc = $d907c2cd5035cc3a$var$atomWithReset;
$d907c2cd5035cc3a$export$19a57601fe8d8f7b = $d907c2cd5035cc3a$var$atomWithStorage;
$d907c2cd5035cc3a$export$95a3b7b12ab518f9 = $d907c2cd5035cc3a$var$createJSONStorage;
$d907c2cd5035cc3a$export$14251e990c96d1bb = $d907c2cd5035cc3a$var$freezeAtom;
$d907c2cd5035cc3a$export$62f7c4fe911bb8cf = $d907c2cd5035cc3a$var$freezeAtomCreator;
$d907c2cd5035cc3a$export$9bbab1a1471800d5 = $d907c2cd5035cc3a$var$loadable;
$d907c2cd5035cc3a$export$36732b116f66dde9 = $d907c2cd5035cc3a$var$selectAtom;
$d907c2cd5035cc3a$export$6fe7d67a9e4f1865 = $d907c2cd5035cc3a$var$splitAtom;
$d907c2cd5035cc3a$export$f803079012337c0c = $d907c2cd5035cc3a$var$withStorageValidator;
$d907c2cd5035cc3a$export$debb760848ca95a = $d907c2cd5035cc3a$var$unwrap;


var $9d09a91b9ecf4f81$exports = {};

$parcel$export($9d09a91b9ecf4f81$exports, "useAtomCallback", () => $9d09a91b9ecf4f81$export$f562a3682ac84ee6, (v) => $9d09a91b9ecf4f81$export$f562a3682ac84ee6 = v);
$parcel$export($9d09a91b9ecf4f81$exports, "useHydrateAtoms", () => $9d09a91b9ecf4f81$export$5a6ea65993cf01b0, (v) => $9d09a91b9ecf4f81$export$5a6ea65993cf01b0 = v);
$parcel$export($9d09a91b9ecf4f81$exports, "useReducerAtom", () => $9d09a91b9ecf4f81$export$548a2b3f6cd62e2d, (v) => $9d09a91b9ecf4f81$export$548a2b3f6cd62e2d = v);
$parcel$export($9d09a91b9ecf4f81$exports, "useResetAtom", () => $9d09a91b9ecf4f81$export$7bcdee284706f2ec, (v) => $9d09a91b9ecf4f81$export$7bcdee284706f2ec = v);
var $9d09a91b9ecf4f81$export$f562a3682ac84ee6;
var $9d09a91b9ecf4f81$export$5a6ea65993cf01b0;
var $9d09a91b9ecf4f81$export$548a2b3f6cd62e2d;
var $9d09a91b9ecf4f81$export$7bcdee284706f2ec;
'use client';
'use strict';
parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");



function $9d09a91b9ecf4f81$var$useResetAtom(anAtom, options) {
    var setAtom = $6c73c2a954dd1869$export$a247c952d39ea7ea(anAtom, options);
    var resetAtom = $6F3kv.useCallback(function() {
        return setAtom($d907c2cd5035cc3a$export$4a991c87e640ef77);
    }, [
        setAtom
    ]);
    return resetAtom;
}
function $9d09a91b9ecf4f81$var$useReducerAtom(anAtom, reducer, options) {
    var _useAtom = $6c73c2a954dd1869$export$83cf7ae8bb57e7ed(anAtom, options), state = _useAtom[0], setState = _useAtom[1];
    var dispatch = $6F3kv.useCallback(function(action) {
        setState(function(prev) {
            return reducer(prev, action);
        });
    }, [
        setState,
        reducer
    ]);
    return [
        state,
        dispatch
    ];
}
function $9d09a91b9ecf4f81$var$useAtomCallback(callback, options) {
    var anAtom = $6F3kv.useMemo(function() {
        return $3a102820b3d4b570$export$5fb5cc0d078610b(null, function(get, set) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return callback.apply(void 0, [
                get,
                set
            ].concat(args));
        });
    }, [
        callback
    ]);
    return $6c73c2a954dd1869$export$a247c952d39ea7ea(anAtom, options);
}
function $9d09a91b9ecf4f81$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9d09a91b9ecf4f81$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $9d09a91b9ecf4f81$var$_unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9d09a91b9ecf4f81$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9d09a91b9ecf4f81$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9d09a91b9ecf4f81$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $9d09a91b9ecf4f81$var$hydratedMap = new WeakMap();
function $9d09a91b9ecf4f81$var$useHydrateAtoms(values, options) {
    var store = $6c73c2a954dd1869$export$6ccbb43953eebf8(options);
    var hydratedSet = $9d09a91b9ecf4f81$var$getHydratedSet(store);
    for(var _iterator = $9d09a91b9ecf4f81$var$_createForOfIteratorHelperLoose(values), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, atom = _step$value[0], value = _step$value[1];
        if (!hydratedSet.has(atom) || options != null && options.dangerouslyForceHydrate) {
            hydratedSet.add(atom);
            store.set(atom, value);
        }
    }
}
var $9d09a91b9ecf4f81$var$getHydratedSet = function getHydratedSet(store) {
    var hydratedSet = $9d09a91b9ecf4f81$var$hydratedMap.get(store);
    if (!hydratedSet) {
        hydratedSet = new WeakSet();
        $9d09a91b9ecf4f81$var$hydratedMap.set(store, hydratedSet);
    }
    return hydratedSet;
};
$9d09a91b9ecf4f81$export$f562a3682ac84ee6 = $9d09a91b9ecf4f81$var$useAtomCallback;
$9d09a91b9ecf4f81$export$5a6ea65993cf01b0 = $9d09a91b9ecf4f81$var$useHydrateAtoms;
$9d09a91b9ecf4f81$export$548a2b3f6cd62e2d = $9d09a91b9ecf4f81$var$useReducerAtom;
$9d09a91b9ecf4f81$export$7bcdee284706f2ec = $9d09a91b9ecf4f81$var$useResetAtom;


Object.keys($d907c2cd5035cc3a$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($787fd5ab8c7121a2$exports, k)) Object.defineProperty($787fd5ab8c7121a2$exports, k, {
        enumerable: true,
        get: function() {
            return $d907c2cd5035cc3a$exports[k];
        }
    });
});
Object.keys($9d09a91b9ecf4f81$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($787fd5ab8c7121a2$exports, k)) Object.defineProperty($787fd5ab8c7121a2$exports, k, {
        enumerable: true,
        get: function() {
            return $9d09a91b9ecf4f81$exports[k];
        }
    });
});


/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $a8df7698b59715aa$exports = {};
"use strict";
/* eslint-disable @typescript-eslint/adjacent-overload-signatures, @typescript-eslint/no-unused-vars */ // This file is generated, do not edit! See ../scripts/generate-index.ts
Object.defineProperty($a8df7698b59715aa$exports, "__esModule", {
    value: true
});
$a8df7698b59715aa$exports.pipe = $a8df7698b59715aa$exports.remove = $a8df7698b59715aa$exports.set = $a8df7698b59715aa$exports.modify = $a8df7698b59715aa$exports.collect = $a8df7698b59715aa$exports.preview = $a8df7698b59715aa$exports.get = $a8df7698b59715aa$exports.optic_ = $a8df7698b59715aa$exports.optic = $a8df7698b59715aa$exports.compose = void 0;
var $f72638205590f143$exports = {};
"use strict";
var $f72638205590f143$var$__rest = $f72638205590f143$exports && $f72638205590f143$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($f72638205590f143$exports, "__esModule", {
    value: true
});
$f72638205590f143$exports.optic = $f72638205590f143$exports.Optic = $f72638205590f143$exports.words = $f72638205590f143$exports.chars = $f72638205590f143$exports.appendTo = $f72638205590f143$exports.prependTo = $f72638205590f143$exports.rewrite = $f72638205590f143$exports.reread = $f72638205590f143$exports.partsOf = $f72638205590f143$exports.valueOr = $f72638205590f143$exports.filter = $f72638205590f143$exports.find = $f72638205590f143$exports.guard = $f72638205590f143$exports.optional = $f72638205590f143$exports.atKey = $f72638205590f143$exports.at = $f72638205590f143$exports.when = $f72638205590f143$exports.nth = $f72638205590f143$exports.pick = $f72638205590f143$exports.prop = $f72638205590f143$exports.indexed = $f72638205590f143$exports.collect = $f72638205590f143$exports.preview = $f72638205590f143$exports.get = $f72638205590f143$exports.remove = $f72638205590f143$exports.set = $f72638205590f143$exports.modify = $f72638205590f143$exports.to = $f72638205590f143$exports.elems = $f72638205590f143$exports.lens = $f72638205590f143$exports.iso = $f72638205590f143$exports.eq = $f72638205590f143$exports.compositionType = $f72638205590f143$exports.id = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */ const $f72638205590f143$var$id = (x)=>x;
$f72638205590f143$exports.id = $f72638205590f143$var$id;
const $f72638205590f143$var$Left = (value)=>({
        _tag: 'Left',
        value: value
    });
const $f72638205590f143$var$Right = (value)=>({
        _tag: 'Right',
        value: value
    });
const $f72638205590f143$var$either = (mapLeft, mapRight, e)=>e._tag === 'Left' ? mapLeft(e.value) : mapRight(e.value);
const $f72638205590f143$var$profunctorFn = {
    dimap: (f, g, fn)=>(x)=>g(fn(f(x))),
    first: (f)=>([x, y])=>[
                f(x),
                y
            ],
    right: (f)=>(e)=>e._tag === 'Left' ? e : $f72638205590f143$var$Right(f(e.value)),
    wander: (f)=>(xs)=>xs.map(f)
};
const $f72638205590f143$var$monoidFirst = {
    empty: ()=>undefined,
    foldMap: (f, xs)=>{
        for(let i = 0; i < xs.length; i++){
            const x = f(xs[i]);
            if (x != undefined) return x;
        }
        return undefined;
    }
};
const $f72638205590f143$var$monoidArray = {
    empty: ()=>[],
    foldMap: (f, xs)=>{
        let acc = [];
        xs.forEach((x)=>{
            acc = acc.concat(f(x));
        });
        return acc;
    }
};
const $f72638205590f143$var$profunctorConst = (monoid)=>({
        dimap: (f, _g, toF)=>(x)=>toF(f(x)),
        first: (toF)=>([x, _y])=>toF(x),
        right: (toF)=>(e)=>e._tag === 'Left' ? monoid.empty() : toF(e.value),
        wander: (toF)=>(xs)=>monoid.foldMap(toF, xs)
    });
$f72638205590f143$exports.compositionType = {
    Equivalence: {
        Equivalence: 'Equivalence',
        Iso: 'Iso',
        Lens: 'Lens',
        Prism: 'Prism',
        Traversal: 'Traversal',
        Getter: 'Getter',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: 'Setter'
    },
    Iso: {
        Equivalence: 'Iso',
        Iso: 'Iso',
        Lens: 'Lens',
        Prism: 'Prism',
        Traversal: 'Traversal',
        Getter: 'Getter',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: 'Setter'
    },
    Lens: {
        Equivalence: 'Lens',
        Iso: 'Lens',
        Lens: 'Lens',
        Prism: 'Prism',
        Traversal: 'Traversal',
        Getter: 'Getter',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: 'Setter'
    },
    Prism: {
        Equivalence: 'Prism',
        Iso: 'Prism',
        Lens: 'Prism',
        Prism: 'Prism',
        Traversal: 'Traversal',
        Getter: 'AffineFold',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: 'Setter'
    },
    Traversal: {
        Equivalence: 'Traversal',
        Iso: 'Traversal',
        Lens: 'Traversal',
        Prism: 'Traversal',
        Traversal: 'Traversal',
        Getter: 'Fold',
        AffineFold: 'Fold',
        Fold: 'Fold',
        Setter: 'Setter'
    },
    Getter: {
        Equivalence: 'Getter',
        Iso: 'Getter',
        Lens: 'Getter',
        Prism: 'AffineFold',
        Traversal: 'Fold',
        Getter: 'Getter',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: undefined
    },
    AffineFold: {
        Equivalence: 'AffineFold',
        Iso: 'AffineFold',
        Lens: 'AffineFold',
        Prism: 'AffineFold',
        Traversal: 'Fold',
        Getter: 'AffineFold',
        AffineFold: 'AffineFold',
        Fold: 'Fold',
        Setter: undefined
    },
    Fold: {
        Equivalence: 'Fold',
        Iso: 'Fold',
        Lens: 'Fold',
        Prism: 'Fold',
        Traversal: 'Fold',
        Getter: 'Fold',
        AffineFold: 'Fold',
        Fold: 'Fold',
        Setter: undefined
    },
    Setter: {
        Equivalence: undefined,
        Iso: undefined,
        Lens: undefined,
        Prism: undefined,
        Traversal: undefined,
        Getter: undefined,
        AffineFold: undefined,
        Fold: undefined,
        Setter: undefined
    }
};
const $f72638205590f143$var$withTag = (tag, optic)=>{
    const result = optic;
    result._tag = tag;
    return result;
};
const $f72638205590f143$var$removable = (optic)=>{
    optic._removable = true;
    return optic;
};
function $f72638205590f143$var$compose(optic1, optic2, optic3) {
    switch(arguments.length){
        case 2:
            {
                const next = (P, optic)=>optic1(P, optic2(P, optic));
                next._tag = $f72638205590f143$exports.compositionType[optic1._tag][optic2._tag];
                next._removable = optic2._removable || false;
                return next;
            }
        default:
            {
                const tag1 = $f72638205590f143$exports.compositionType[optic1._tag][optic2._tag];
                const next = (P, optic)=>optic1(P, optic2(P, optic3(P, optic)));
                next._tag = $f72638205590f143$exports.compositionType[tag1][optic3._tag];
                next._removable = optic3._removable || false;
                return next;
            }
    }
}
$f72638205590f143$exports.eq = $f72638205590f143$var$withTag('Equivalence', (_P, optic)=>optic);
const $f72638205590f143$var$iso = (there, back)=>$f72638205590f143$var$withTag('Iso', (P, optic)=>P.dimap(there, back, optic));
$f72638205590f143$exports.iso = $f72638205590f143$var$iso;
const $f72638205590f143$var$lens = (view, update)=>$f72638205590f143$var$withTag('Lens', (P, optic)=>P.dimap((x)=>[
                view(x),
                x
            ], update, P.first(optic)));
$f72638205590f143$exports.lens = $f72638205590f143$var$lens;
const $f72638205590f143$var$prism = (match, build)=>$f72638205590f143$var$withTag('Prism', (P, optic)=>P.dimap(match, (x)=>$f72638205590f143$var$either($f72638205590f143$exports.id, build, x), P.right(optic)));
$f72638205590f143$exports.elems = $f72638205590f143$var$withTag('Traversal', (P, optic)=>P.dimap($f72638205590f143$exports.id, $f72638205590f143$exports.id, P.wander(optic)));
const $f72638205590f143$var$to = (fn)=>$f72638205590f143$var$withTag('Getter', (P, optic)=>P.dimap(fn, $f72638205590f143$exports.id, optic));
$f72638205590f143$exports.to = $f72638205590f143$var$to;
/////////////////////////////////////////////////////////////////////////////
const $f72638205590f143$var$modify = (optic, fn, source)=>optic($f72638205590f143$var$profunctorFn, fn)(source);
$f72638205590f143$exports.modify = $f72638205590f143$var$modify;
const $f72638205590f143$var$set = (optic, value, source)=>optic($f72638205590f143$var$profunctorFn, ()=>value)(source);
$f72638205590f143$exports.set = $f72638205590f143$var$set;
const $f72638205590f143$var$remove = (optic, source)=>(0, $f72638205590f143$exports.set)(optic, $f72638205590f143$var$removeMe, source);
$f72638205590f143$exports.remove = $f72638205590f143$var$remove;
const $f72638205590f143$var$get = (optic, source)=>optic($f72638205590f143$var$profunctorConst({}), $f72638205590f143$exports.id)(source);
$f72638205590f143$exports.get = $f72638205590f143$var$get;
const $f72638205590f143$var$preview = (optic, source)=>optic($f72638205590f143$var$profunctorConst($f72638205590f143$var$monoidFirst), $f72638205590f143$exports.id)(source);
$f72638205590f143$exports.preview = $f72638205590f143$var$preview;
const $f72638205590f143$var$collect = (optic, source)=>optic($f72638205590f143$var$profunctorConst($f72638205590f143$var$monoidArray), (x)=>[
            x
        ])(source);
$f72638205590f143$exports.collect = $f72638205590f143$var$collect;
/////////////////////////////////////////////////////////////////////////////
$f72638205590f143$exports.indexed = (0, $f72638205590f143$exports.iso)((value)=>value.map((v, k)=>[
            k,
            v
        ]), (value)=>{
    const sorted = [
        ...value
    ].sort((a, b)=>a[0] - b[0]);
    const result = [];
    for(let i = 0; i < sorted.length; ++i)if (i === sorted.length - 1 || sorted[i][0] !== sorted[i + 1][0]) result.push(sorted[i][1]);
    return result;
});
const $f72638205590f143$var$prop = (key)=>(0, $f72638205590f143$exports.lens)((source)=>source[key], ([value, source])=>Object.assign(Object.assign({}, source), {
            [key]: value
        }));
$f72638205590f143$exports.prop = $f72638205590f143$var$prop;
const $f72638205590f143$var$pick = (keys)=>(0, $f72638205590f143$exports.lens)((source)=>{
        const value = {};
        for (const key of keys)value[key] = source[key];
        return value;
    }, ([value, source])=>{
        const result = Object.assign({}, source);
        for (const key of keys)delete result[key];
        return Object.assign(result, value);
    });
$f72638205590f143$exports.pick = $f72638205590f143$var$pick;
const $f72638205590f143$var$nth = (n)=>(0, $f72638205590f143$exports.lens)((value)=>value[n], ([value, source])=>{
        const result = source.slice();
        result[n] = value;
        return result;
    });
$f72638205590f143$exports.nth = $f72638205590f143$var$nth;
const $f72638205590f143$var$fst = /* @__PURE__ */ (0, $f72638205590f143$exports.nth)(0);
const $f72638205590f143$var$when = (pred)=>$f72638205590f143$var$prism((x)=>pred(x) ? $f72638205590f143$var$Right(x) : $f72638205590f143$var$Left(x), $f72638205590f143$exports.id);
$f72638205590f143$exports.when = $f72638205590f143$var$when;
const $f72638205590f143$var$noMatch = /* @__PURE__ */ Symbol('__no_match__');
const $f72638205590f143$var$mustMatch = /* @__PURE__ */ (0, $f72638205590f143$exports.when)((source)=>source !== $f72638205590f143$var$noMatch);
const $f72638205590f143$var$removeMe = /* @__PURE__ */ Symbol('__remove_me__');
const $f72638205590f143$var$at = (i)=>$f72638205590f143$var$removable($f72638205590f143$var$compose((0, $f72638205590f143$exports.lens)((source)=>0 <= i && i < source.length ? source[i] : $f72638205590f143$var$noMatch, ([value, source])=>{
        if (value === $f72638205590f143$var$noMatch) return source;
        if (value === $f72638205590f143$var$removeMe) {
            if (typeof source === 'string') return source.substring(0, i) + source.substring(i + 1);
            else return [
                ...source.slice(0, i),
                ...source.slice(i + 1)
            ];
        }
        if (typeof source === 'string') {
            if (i === 0) return value + source.substring(1);
            if (i === source.length) return source.substring(0, i - 1) + value;
            return source.substring(0, i) + value + source.substring(i + 1);
        } else {
            const result = source.slice();
            result[i] = value;
            return result;
        }
    }), $f72638205590f143$var$mustMatch));
$f72638205590f143$exports.at = $f72638205590f143$var$at;
const $f72638205590f143$var$atKey = (key)=>$f72638205590f143$var$removable($f72638205590f143$var$compose((0, $f72638205590f143$exports.lens)((source)=>{
        const value = source[key];
        return value !== undefined ? value : $f72638205590f143$var$noMatch;
    }, ([value, source])=>{
        if (value === $f72638205590f143$var$noMatch) return source;
        if (value === $f72638205590f143$var$removeMe) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _a = source, _b = key, _ = _a[_b], rest = $f72638205590f143$var$__rest(_a, [
                typeof _b === "symbol" ? _b : _b + ""
            ]);
            return rest;
        }
        return Object.assign(Object.assign({}, source), {
            [key]: value
        });
    }), $f72638205590f143$var$mustMatch));
$f72638205590f143$exports.atKey = $f72638205590f143$var$atKey;
$f72638205590f143$exports.optional = $f72638205590f143$var$prism((source)=>source === undefined ? $f72638205590f143$var$Left(undefined) : $f72638205590f143$var$Right(source), $f72638205590f143$exports.id);
const $f72638205590f143$var$guard = (fn)=>$f72638205590f143$var$prism((source)=>fn(source) ? $f72638205590f143$var$Right(source) : $f72638205590f143$var$Left(source), $f72638205590f143$exports.id);
$f72638205590f143$exports.guard = $f72638205590f143$var$guard;
const $f72638205590f143$var$find = (predicate)=>$f72638205590f143$var$removable($f72638205590f143$var$compose((0, $f72638205590f143$exports.lens)((source)=>{
        const index = source.findIndex(predicate);
        if (index === -1) return [
            $f72638205590f143$var$noMatch,
            -1
        ];
        return [
            source[index],
            index
        ];
    }, ([[value, index], source])=>{
        if (value === $f72638205590f143$var$noMatch) return source;
        if (value === $f72638205590f143$var$removeMe) return [
            ...source.slice(0, index),
            ...source.slice(index + 1)
        ];
        const result = source.slice();
        result[index] = value;
        return result;
    }), $f72638205590f143$var$fst, $f72638205590f143$var$mustMatch));
$f72638205590f143$exports.find = $f72638205590f143$var$find;
const $f72638205590f143$var$filter = (predicate)=>$f72638205590f143$var$compose((0, $f72638205590f143$exports.lens)((source)=>{
        const indexes = source.map((item, index)=>predicate(item) ? index : null).filter((index)=>index != null);
        return [
            indexes.map((index)=>source[index]),
            indexes
        ];
    }, ([[values, indexes], source])=>{
        const sn = source.length, vn = values.length;
        let si = 0, ii = 0, vi = 0;
        const result = [];
        while(si < sn){
            if (indexes[ii] === si) {
                ++ii;
                if (vi < vn) {
                    result.push(values[vi]);
                    ++vi;
                }
            } else result.push(source[si]);
            ++si;
        }
        while(vi < vn)result.push(values[vi++]);
        return result;
    }), $f72638205590f143$var$fst);
$f72638205590f143$exports.filter = $f72638205590f143$var$filter;
const $f72638205590f143$var$valueOr = (defaultValue)=>(0, $f72638205590f143$exports.lens)((source)=>source === undefined ? defaultValue : source, ([value, _source])=>value);
$f72638205590f143$exports.valueOr = $f72638205590f143$var$valueOr;
const $f72638205590f143$var$partsOf = (traversal)=>$f72638205590f143$var$compose((0, $f72638205590f143$exports.lens)((source)=>{
        const value = (0, $f72638205590f143$exports.collect)(traversal, source);
        return [
            value,
            value.length
        ];
    }, ([[value, originalLength], source])=>{
        if (value.length !== originalLength) throw new Error('cannot add/remove elements through partsOf');
        let i = 0;
        return (0, $f72638205590f143$exports.modify)(traversal, ()=>value[i++], source);
    }), $f72638205590f143$var$fst);
$f72638205590f143$exports.partsOf = $f72638205590f143$var$partsOf;
const $f72638205590f143$var$reread = (fn)=>(0, $f72638205590f143$exports.lens)((source)=>fn(source), ([value, _])=>value);
$f72638205590f143$exports.reread = $f72638205590f143$var$reread;
const $f72638205590f143$var$rewrite = (fn)=>(0, $f72638205590f143$exports.lens)((source)=>source, ([value, _])=>fn(value));
$f72638205590f143$exports.rewrite = $f72638205590f143$var$rewrite;
$f72638205590f143$exports.prependTo = (0, $f72638205590f143$exports.lens)((_source)=>undefined, ([value, source])=>{
    if (value === undefined) return source;
    return [
        value,
        ...source
    ];
});
$f72638205590f143$exports.appendTo = (0, $f72638205590f143$exports.lens)((_source)=>undefined, ([value, source])=>{
    if (value === undefined) return source;
    return [
        ...source,
        value
    ];
});
$f72638205590f143$exports.chars = $f72638205590f143$var$compose((0, $f72638205590f143$exports.iso)((s)=>s.split(''), (a)=>a.join('')), $f72638205590f143$exports.elems);
$f72638205590f143$exports.words = $f72638205590f143$var$compose((0, $f72638205590f143$exports.iso)((s)=>s.split(/\b/), (a)=>a.join('')), $f72638205590f143$exports.elems, (0, $f72638205590f143$exports.when)((s)=>!/\s+/.test(s)));
/////////////////////////////////////////////////////////////////////////////
class $f72638205590f143$var$Optic {
    constructor(_ref){
        this._ref = _ref;
    }
    get _tag() {
        return this._ref._tag;
    }
    get _removable() {
        return this._ref._removable;
    }
    compose(other) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, other._ref));
    }
    iso(there, back) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.iso)(there, back)));
    }
    lens(view, set) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.lens)(view, ([value, source])=>set(source, value))));
    }
    indexed() {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, $f72638205590f143$exports.indexed));
    }
    prop(key) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.prop)(key)));
    }
    path(...keys) {
        if (keys.length === 1) keys = keys[0].split('.');
        return new $f72638205590f143$var$Optic(keys.reduce((ref, key)=>$f72638205590f143$var$compose(ref, (0, $f72638205590f143$exports.prop)(key)), this._ref));
    }
    pick(keys) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.pick)(keys)));
    }
    nth(n) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.nth)(n)));
    }
    filter(predicate) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.filter)(predicate)));
    }
    valueOr(defaultValue) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.valueOr)(defaultValue)));
    }
    partsOf(traversalOrFn) {
        const traversal = typeof traversalOrFn === 'function' ? traversalOrFn($f72638205590f143$exports.optic) : traversalOrFn;
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.partsOf)(traversal._ref)));
    }
    reread(fn) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.reread)(fn)));
    }
    rewrite(fn) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.rewrite)(fn)));
    }
    optional() {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, $f72638205590f143$exports.optional));
    }
    guard_() {
        return (fn)=>this.guard(fn);
    }
    guard(fn) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.guard)(fn)));
    }
    at(i) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.at)(i)));
    }
    head() {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.at)(0)));
    }
    index(i) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.at)(i)));
    }
    find(predicate) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.find)(predicate)));
    }
    elems() {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, $f72638205590f143$exports.elems));
    }
    to(fn) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.to)(fn)));
    }
    when(predicate) {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, (0, $f72638205590f143$exports.when)(predicate)));
    }
    chars() {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, $f72638205590f143$exports.chars));
    }
    words() {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, $f72638205590f143$exports.words));
    }
    prependTo() {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, $f72638205590f143$exports.prependTo));
    }
    appendTo() {
        return new $f72638205590f143$var$Optic($f72638205590f143$var$compose(this._ref, $f72638205590f143$exports.appendTo));
    }
}
$f72638205590f143$exports.Optic = $f72638205590f143$var$Optic;
$f72638205590f143$exports.optic = new $f72638205590f143$var$Optic($f72638205590f143$exports.eq);


function $a8df7698b59715aa$var$compose(optic1, optic2) {
    return optic1.compose(optic2);
}
$a8df7698b59715aa$exports.compose = $a8df7698b59715aa$var$compose;
function $a8df7698b59715aa$var$optic() {
    return $f72638205590f143$exports.optic;
}
$a8df7698b59715aa$exports.optic = $a8df7698b59715aa$var$optic;
function $a8df7698b59715aa$var$optic_() {
    return $f72638205590f143$exports.optic;
}
$a8df7698b59715aa$exports.optic_ = $a8df7698b59715aa$var$optic_;
function $a8df7698b59715aa$var$get(optic) {
    return (source)=>$f72638205590f143$exports.get(optic._ref, source);
}
$a8df7698b59715aa$exports.get = $a8df7698b59715aa$var$get;
function $a8df7698b59715aa$var$preview(optic) {
    return (source)=>$f72638205590f143$exports.preview(optic._ref, source);
}
$a8df7698b59715aa$exports.preview = $a8df7698b59715aa$var$preview;
function $a8df7698b59715aa$var$collect(optic) {
    return (source)=>$f72638205590f143$exports.collect(optic._ref, source);
}
$a8df7698b59715aa$exports.collect = $a8df7698b59715aa$var$collect;
function $a8df7698b59715aa$var$modify(optic) {
    return (f)=>(source)=>$f72638205590f143$exports.modify(optic._ref, f, source);
}
$a8df7698b59715aa$exports.modify = $a8df7698b59715aa$var$modify;
function $a8df7698b59715aa$var$set(optic) {
    return (value)=>(source)=>$f72638205590f143$exports.set(optic._ref, value, source);
}
$a8df7698b59715aa$exports.set = $a8df7698b59715aa$var$set;
function $a8df7698b59715aa$var$remove(optic) {
    return (source)=>$f72638205590f143$exports.remove(optic._ref, source);
}
$a8df7698b59715aa$exports.remove = $a8df7698b59715aa$var$remove;
var $9d360a5f2a5a77b8$exports = {};
"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/ban-types */ Object.defineProperty($9d360a5f2a5a77b8$exports, "__esModule", {
    value: true
});
$9d360a5f2a5a77b8$exports.pipe = void 0;
function $9d360a5f2a5a77b8$var$pipe(a, ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        case 10:
            return ij(hi(gh(fg(ef(de(cd(bc(ab(a)))))))));
    }
    return;
}
$9d360a5f2a5a77b8$exports.pipe = $9d360a5f2a5a77b8$var$pipe;


Object.defineProperty($a8df7698b59715aa$exports, "pipe", {
    enumerable: true,
    get: function() {
        return $9d360a5f2a5a77b8$exports.pipe;
    }
});


const $8e5a5568fe38e4c8$var$getCached = (c, m, k)=>(m.has(k) ? m : m.set(k, c())).get(k);
const $8e5a5568fe38e4c8$var$cache1 = new WeakMap();
const $8e5a5568fe38e4c8$var$memo2 = (create, dep1, dep2)=>{
    const cache2 = $8e5a5568fe38e4c8$var$getCached(()=>new WeakMap(), $8e5a5568fe38e4c8$var$cache1, dep1);
    return $8e5a5568fe38e4c8$var$getCached(create, cache2, dep2);
};
const $8e5a5568fe38e4c8$var$isFunction = (x)=>typeof x === 'function';
function $8e5a5568fe38e4c8$export$f1fcfbe8d9aad090(baseAtom, callback) {
    return $8e5a5568fe38e4c8$var$memo2(()=>{
        const focus = callback($a8df7698b59715aa$exports.optic());
        const derivedAtom = (0, $3a102820b3d4b570$export$5fb5cc0d078610b)((get)=>{
            const base = get(baseAtom);
            return base instanceof Promise ? base.then((v)=>$8e5a5568fe38e4c8$var$getValueUsingOptic(focus, v)) : $8e5a5568fe38e4c8$var$getValueUsingOptic(focus, base);
        }, (get, set, update)=>{
            const newValueProducer = $8e5a5568fe38e4c8$var$isFunction(update) ? $a8df7698b59715aa$exports.modify(focus)(update) : $a8df7698b59715aa$exports.set(focus)(update);
            const base = get(baseAtom);
            return set(baseAtom, base instanceof Promise ? base.then(newValueProducer) : newValueProducer(base));
        });
        return derivedAtom;
    }, baseAtom, callback);
}
const $8e5a5568fe38e4c8$var$getValueUsingOptic = (focus, bigValue)=>{
    if (focus._tag === 'Traversal') {
        const values = $a8df7698b59715aa$exports.collect(focus)(bigValue);
        return values;
    }
    if (focus._tag === 'Prism') {
        const value = $a8df7698b59715aa$exports.preview(focus)(bigValue);
        return value;
    }
    const value = $a8df7698b59715aa$exports.get(focus)(bigValue);
    return value;
};


const $5a973554b20f67a7$export$482ff399fd242da7 = {
    get: $5a973554b20f67a7$var$get,
    post: $5a973554b20f67a7$var$post,
    put: $5a973554b20f67a7$var$put,
    delete: $5a973554b20f67a7$var$_delete
};
function $5a973554b20f67a7$var$get(url, options = {}) {
    const requestOptions = {
        method: 'GET',
        ...options
    };
    return fetch(url, requestOptions).then($5a973554b20f67a7$var$handleResponse);
}
function $5a973554b20f67a7$var$post(url, body, options) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        ...options,
        body: JSON.stringify(body)
    };
    return fetch(url, requestOptions).then($5a973554b20f67a7$var$handleResponse);
}
function $5a973554b20f67a7$var$put(url, body) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    };
    return fetch(url, requestOptions).then($5a973554b20f67a7$var$handleResponse);
}
// prefixed with underscored because delete is a reserved word in javascript
function $5a973554b20f67a7$var$_delete(url) {
    const requestOptions = {
        method: 'DELETE'
    };
    return fetch(url, requestOptions).then($5a973554b20f67a7$var$handleResponse);
}
// helper functions
function $5a973554b20f67a7$var$handleResponse(response) {
    return response.text().then((text)=>{
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data && data.message || response.statusText;
            return Promise.reject(error);
        }
        return {
            data: data
        };
    });
}


async function $4f6efe0791a5325f$export$c76557890c9dceaa(options) {
    const url = options.url.slice(-1)[0] != '/' ? options.url + '/' : options.url;
    const res = await (0, $5a973554b20f67a7$export$482ff399fd242da7).get(url + `workspaces/${options.workspace ?? 'default'}.json`, {
    });
    // console.log(res)
    const resources = await Promise.all(Object.entries(res.data.content).map(async ([label, resource])=>{
        let f;
        if (typeof resource == 'string') {
            const resourceRes = await (0, $5a973554b20f67a7$export$482ff399fd242da7).get(resource, {
            });
            f = resourceRes.data;
        } else f = resource;
        return f;
    }));
    // console.log(resources)
    const elements = resources.map((f)=>f.content);
    const preOut = elements.flat();
    // console.log(preOut)
    const outScreens = {};
    preOut.forEach((o)=>{
        outScreens[o.id] = o;
    });
    //LOG: console.log(outScreens)
    return Object.values(outScreens);
}
function $4f6efe0791a5325f$export$a3702fbab67b8a52(date) {
    return Math.round(date.getTime() / 1000);
}
function $4f6efe0791a5325f$export$d02631cccf789723(start, end, step) {
    var len = start;
    if (end != undefined) len = Math.floor(Math.abs(start - end) / step);
    step = step === undefined ? 1 : step;
    return new Array(len).fill(0).map(function(el, i) {
        return start + i * step;
    });
}


function $6c5f2c918bcb056e$export$a2ddee470fba72ea(msg) {
    window.top.postMessage(msg, '*');
}



function $203db46044024c1f$export$7f56500bdbdd99d3() {
    try {
        window?.localStorage?.getItem('');
    } catch (e) {
        return false;
    }
    return true;
}


const $46c245b99a10dc85$export$586b30dcaeecb901 = (0, $787fd5ab8c7121a2$exports.createJSONStorage)(()=>{
    if (!(0, $203db46044024c1f$export$7f56500bdbdd99d3)()) return {
        getItem: (key, initialValue)=>initialValue,
        setItem: (key, newValue)=>null
    };
    return typeof window !== 'undefined' ? window.localStorage : undefined;
});
function $46c245b99a10dc85$export$19a57601fe8d8f7b(key, initialValue, storage, ops) {
    return (0, $787fd5ab8c7121a2$exports.atomWithStorage)(key, initialValue, $46c245b99a10dc85$export$586b30dcaeecb901, ops);
}


const $f4acb02d4ec4661e$export$b776ac30f5671b91 = (object)=>Object.fromEntries(Object.entries(object).filter(([, value])=>value != null));
const $f4acb02d4ec4661e$export$23cfe696632d10f4 = (objectName)=>{
    return Object.keys(objectName).length === 0;
};
/**
 * Is the object Mergeable
 *
 * @param val
 * @returns {*|boolean}
 */ function $f4acb02d4ec4661e$var$isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';
    return nonNullObject && Object.prototype.toString.call(val) !== '[object RegExp]' && Object.prototype.toString.call(val) !== '[object Date]';
}
/**
 * Empty the Target
 *
 * @param val
 * @returns {*}
 */ function $f4acb02d4ec4661e$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
/**
 * Clone if Necessary
 *
 * @param value
 * @param optionsArgument
 * @returns {*}
 */ function $f4acb02d4ec4661e$var$cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return clone && $f4acb02d4ec4661e$var$isMergeableObject(value) ? $f4acb02d4ec4661e$export$4950aa0f605343fb($f4acb02d4ec4661e$var$emptyTarget(value), value, optionsArgument) : value;
}
/**
 * Default Array Merge
 *
 * @param target
 * @param source
 * @param optionsArgument
 * @returns {*}
 */ function $f4acb02d4ec4661e$var$defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') destination[i] = $f4acb02d4ec4661e$var$cloneIfNecessary(e, optionsArgument);
        else if ($f4acb02d4ec4661e$var$isMergeableObject(e)) destination[i] = $f4acb02d4ec4661e$export$4950aa0f605343fb(target[i], e, optionsArgument);
        else if (target.indexOf(e) === -1) destination.push($f4acb02d4ec4661e$var$cloneIfNecessary(e, optionsArgument));
    });
    return destination;
}
/**
 * Merge Object
 *
 * @param target
 * @param source
 * @param optionsArgument
 * @returns {{}}
 */ function $f4acb02d4ec4661e$var$mergeObject(target, source, optionsArgument) {
    var destination = {};
    if ($f4acb02d4ec4661e$var$isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $f4acb02d4ec4661e$var$cloneIfNecessary(target[key], optionsArgument);
    });
    Object.keys(source).forEach(function(key) {
        if (!$f4acb02d4ec4661e$var$isMergeableObject(source[key]) || !target[key]) destination[key] = $f4acb02d4ec4661e$var$cloneIfNecessary(source[key], optionsArgument);
        else destination[key] = $f4acb02d4ec4661e$export$4950aa0f605343fb(target[key], source[key], optionsArgument);
    });
    return destination;
}
function $f4acb02d4ec4661e$export$4950aa0f605343fb(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || {
        arrayMerge: $f4acb02d4ec4661e$var$defaultArrayMerge
    };
    var arrayMerge = options.arrayMerge || $f4acb02d4ec4661e$var$defaultArrayMerge;
    if (array) return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : $f4acb02d4ec4661e$var$cloneIfNecessary(source, optionsArgument);
    else return $f4acb02d4ec4661e$var$mergeObject(target, source, optionsArgument);
}
function $f4acb02d4ec4661e$export$3988ae62b71be9a3(object, keys, defaultVal = null) {
    keys = Array.isArray(keys) ? keys : keys.split('.');
    object = object[keys[0]];
    if (object && keys.length > 1) return $f4acb02d4ec4661e$export$3988ae62b71be9a3(object, keys.slice(1));
    return object === undefined ? defaultVal : object;
}
function $f4acb02d4ec4661e$export$a4f4bb6b1453fff5(object, keys) {
    keys = Array.isArray(keys) ? keys : keys.split('.');
    object = object[keys[0]];
    if (object && keys.length > 1) return $f4acb02d4ec4661e$export$3988ae62b71be9a3(object, keys.slice(1));
    return !!object;
}
function $f4acb02d4ec4661e$export$adaa4cf7ef1b65be(object, keys, val) {
    keys = Array.isArray(keys) ? keys : keys.split('.');
    if (keys.length > 1) {
        object[keys[0]] = object[keys[0]] || {};
        return $f4acb02d4ec4661e$export$adaa4cf7ef1b65be(object[keys[0]], keys.slice(1), val);
    }
    object[keys[0]] = val;
}


const $b78da6c1f1424617$export$d788bc089976c004 = Symbol("INIT");
const $b78da6c1f1424617$export$b27f1a8572d7f162 = (0, $0b20ce121ee1acb3$exports.atom)([]);
const $b78da6c1f1424617$export$48639037ba826bfa = (0, $0b20ce121ee1acb3$exports.atom)((get)=>get($b78da6c1f1424617$export$b27f1a8572d7f162), (get, set, value)=>{
    if (value == (0, $787fd5ab8c7121a2$exports.RESET)) {
        set($b78da6c1f1424617$export$b27f1a8572d7f162, []);
        return;
    }
    set($b78da6c1f1424617$export$b27f1a8572d7f162, get($b78da6c1f1424617$export$b27f1a8572d7f162).concat(value));
});
// default env variables, but can be overrite by habitat(widget) props in App.tsx
const $b78da6c1f1424617$var$_runtimeConfigAtom = (0, $46c245b99a10dc85$export$19a57601fe8d8f7b)('config', {
    baseURL: "https://raw.githubusercontent.com/EPI3co/pictoassets/master" ?? '',
    overrideUserdata: undefined ?? false,
    logoLabel: 'Picto Access',
    lang: '',
    theme: 'light',
    grid: {
        cols: {
            xxs: 3,
            xs: 4,
            sm: 6,
            md: 8,
            lg: 10,
            '2xl': 12
        },
        bpx: {
            xxs: 0,
            xs: 450,
            sm: 640,
            md: 768,
            lg: 1024,
            '2xl': 1536
        },
        height: 100,
        minH: 1,
        minW: 1,
        maxW: 4,
        maxH: 4
    },
    speech: {
        pitch: 1,
        rate: 1,
        voiceIndex: -1,
        speakWord: true
    }
});
const $b78da6c1f1424617$export$93d03168ef9b559d = (0, $0b20ce121ee1acb3$exports.atom)(true);
const $b78da6c1f1424617$export$a63c88e4229cc588 = (0, $0b20ce121ee1acb3$exports.atom)((get)=>get($b78da6c1f1424617$var$_runtimeConfigAtom), (get, set, value)=>{
    if (value == (0, $787fd5ab8c7121a2$exports.RESET)) {
        set($b78da6c1f1424617$var$_runtimeConfigAtom, value);
        set($b78da6c1f1424617$export$93d03168ef9b559d, true);
    } else {
        set($b78da6c1f1424617$var$_runtimeConfigAtom, (0, $f4acb02d4ec4661e$export$4950aa0f605343fb)(get($b78da6c1f1424617$var$_runtimeConfigAtom), value));
        if (value.lang) set($b78da6c1f1424617$export$a84d19966bda61f9, value.lang);
    }
});
const $b78da6c1f1424617$export$21313a3d5e4111fc = (0, $8e5a5568fe38e4c8$export$f1fcfbe8d9aad090)($b78da6c1f1424617$var$_runtimeConfigAtom, (optic)=>optic.prop('speech'));
const $b78da6c1f1424617$export$a84d19966bda61f9 = (0, $8e5a5568fe38e4c8$export$f1fcfbe8d9aad090)($b78da6c1f1424617$var$_runtimeConfigAtom, (optic)=>optic.prop('lang'));
const $b78da6c1f1424617$var$_themeAtom = (0, $8e5a5568fe38e4c8$export$f1fcfbe8d9aad090)($b78da6c1f1424617$var$_runtimeConfigAtom, (optic)=>optic.prop('theme'));
const $b78da6c1f1424617$export$8598e3da432e268f = (0, $0b20ce121ee1acb3$exports.atom)((get)=>{
    const theme = get($b78da6c1f1424617$var$_themeAtom);
    if (typeof window != 'undefined') document.documentElement.setAttribute("data-theme", theme);
    (0, $6c5f2c918bcb056e$export$a2ddee470fba72ea)({
        type: 'theme',
        data: theme
    });
    return theme;
}, (get, set, value)=>{
    set($b78da6c1f1424617$var$_themeAtom, value);
    document.documentElement.setAttribute("data-theme", value);
    (0, $6c5f2c918bcb056e$export$a2ddee470fba72ea)({
        type: 'theme',
        data: value
    });
});
const $b78da6c1f1424617$var$_gridAtom = (0, $46c245b99a10dc85$export$19a57601fe8d8f7b)('grid', []);
const $b78da6c1f1424617$export$fdb89ca8367d940b = (0, $0b20ce121ee1acb3$exports.atom)((get)=>{
    return get($b78da6c1f1424617$var$_gridAtom);
}, (get, set, value)=>{
    const old = get($b78da6c1f1424617$var$_gridAtom);
    const configs = get($b78da6c1f1424617$export$a63c88e4229cc588);
    const getData = ()=>{
        (0, $4f6efe0791a5325f$export$c76557890c9dceaa)({
            url: configs.baseURL,
            workspace: configs.workspace
        }).then((data)=>{
            set($b78da6c1f1424617$var$_gridAtom, data);
        }).catch((err)=>{
            console.log("GET screens from server error:", err);
            throw err;
        });
    };
    // console.log(old, value)
    switch(value){
        case $b78da6c1f1424617$export$d788bc089976c004:
            // console.log(configs, old)
            if (configs.overrideUserdata || old?.length == 0) getData();
            break;
        case 0, $787fd5ab8c7121a2$exports.RESET:
            set($b78da6c1f1424617$var$_gridAtom, value);
            getData();
            break;
        default:
            set($b78da6c1f1424617$var$_gridAtom, value);
    }
});
const $b78da6c1f1424617$export$94d10267cc34b952 = (0, $0b20ce121ee1acb3$exports.atom)(false);
const $b78da6c1f1424617$export$db1d63ac91a84676 = (0, $0b20ce121ee1acb3$exports.atom)(false);
const $b78da6c1f1424617$export$bb1d1a77411b2eba = (0, $0b20ce121ee1acb3$exports.atom)((get)=>get($b78da6c1f1424617$export$94d10267cc34b952) && !get($b78da6c1f1424617$export$db1d63ac91a84676));
const $b78da6c1f1424617$export$1fdd444730eb60e6 = (0, $0b20ce121ee1acb3$exports.atom)(10);
const $b78da6c1f1424617$export$3960374d7ca025b9 = (0, $0b20ce121ee1acb3$exports.atom)('lg');
const $b78da6c1f1424617$export$e893c720be9b9aae = 'home';
const $b78da6c1f1424617$export$98ba80ce6e840e63 = (0, $0b20ce121ee1acb3$exports.atom)($b78da6c1f1424617$export$e893c720be9b9aae);
const $b78da6c1f1424617$export$b86f17b235e54c14 = (0, $0b20ce121ee1acb3$exports.atom)([]);


function $bbf84cf9ec8e5154$export$9b96bc9b681eb5fc(input, percentage = 0.8) {
    const inColor = (0, (/*@__PURE__*/$parcel$interopDefault($2777ab815ff52a44$exports)))(input);
    let canditate;
    if (inColor.isDark()) canditate = inColor.mix((0, (/*@__PURE__*/$parcel$interopDefault($2777ab815ff52a44$exports)))("white"), percentage).saturate(10);
    else canditate = inColor.mix((0, (/*@__PURE__*/$parcel$interopDefault($2777ab815ff52a44$exports)))("black"), percentage).saturate(10);
    // test contrast, according to the WCAG 2.1 guidelines
    if (canditate.contrast(inColor) < 4.5) canditate = inColor.grayscale();
    if (canditate.contrast(inColor) < 4.5) canditate = (0, (/*@__PURE__*/$parcel$interopDefault($2777ab815ff52a44$exports)))('white');
    if (canditate.contrast(inColor) < 4.5) canditate = (0, (/*@__PURE__*/$parcel$interopDefault($2777ab815ff52a44$exports)))('black');
    // extreme
    if (canditate.contrast(inColor) < 4.5) canditate = inColor.negate();
    return canditate.hex();
}
function $bbf84cf9ec8e5154$export$5551a2d24ff40153(color, mix = false) {
    const defaultStore = (0, $0b20ce121ee1acb3$exports.getDefaultStore)();
    const theme = defaultStore.get((0, $b78da6c1f1424617$export$8598e3da432e268f));
    const defaultColor = theme == 'dark' ? {
        value: '#171717',
        per: 10
    } : {
        value: '#FFF',
        per: 50
    };
    let outColor;
    try {
        outColor = color && color[0] == '#' ? (0, (/*@__PURE__*/$parcel$interopDefault($2777ab815ff52a44$exports)))(color) : (0, (/*@__PURE__*/$parcel$interopDefault($2777ab815ff52a44$exports)))(color || defaultColor.value);
        // outColor = mix ? outColor.lightness(defaultColor.per) : outColor
        if (mix && theme == 'dark') outColor = outColor.lightness(defaultColor.per);
    } catch  {
        outColor = (0, (/*@__PURE__*/$parcel$interopDefault($2777ab815ff52a44$exports)))(defaultColor.value);
    }
    return outColor.hex();
}


parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");




const $c95f922ce4854eac$export$b24a004ee43dce44 = ()=>{
    const { setLocale: setLocale } = (0, $dc3317580ce734b5$export$22f0ca4c21b6ff4)();
    const _lang = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$a84d19966bda61f9));
    const [lang, setLang] = _lang;
    (0, $6F3kv.useEffect)(()=>{
        if (lang == '') return;
        (0, $b9adadb6c2c76409$export$3f35861ea9a1becb)(lang);
        setLocale(lang);
    // loadLocale(lang)
    }, [
        lang
    ]);
    return _lang;
};


function $96596b87b46525f2$export$c72d34660a162238(el, lang) {
    return el.i18n && el.i18n[lang]?.text ? el.i18n[lang].text : el.text;
}
function $96596b87b46525f2$export$30c5e393d7f8c18b(lang) {
    const speechAPI = window.speechSynthesis;
    const voices = speechAPI.getVoices();
    // console.log(voices, lang)
    return voices.findIndex((item)=>item.lang.split('-')[0] == lang);
}


parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $8d09aba4ba935ead$var$ArrowDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
    }));
}
const $8d09aba4ba935ead$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($8d09aba4ba935ead$var$ArrowDownIcon);
var $8d09aba4ba935ead$export$2e2bcd8739ae039 = $8d09aba4ba935ead$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $cee2bf0ee385e854$var$ArrowLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
    }));
}
const $cee2bf0ee385e854$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($cee2bf0ee385e854$var$ArrowLeftIcon);
var $cee2bf0ee385e854$export$2e2bcd8739ae039 = $cee2bf0ee385e854$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $81b1e29fe1b38da5$var$ArrowRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
    }));
}
const $81b1e29fe1b38da5$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($81b1e29fe1b38da5$var$ArrowRightIcon);
var $81b1e29fe1b38da5$export$2e2bcd8739ae039 = $81b1e29fe1b38da5$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $599145164995687d$var$ArrowUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
    }));
}
const $599145164995687d$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($599145164995687d$var$ArrowUpIcon);
var $599145164995687d$export$2e2bcd8739ae039 = $599145164995687d$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $c32dc85ecaf3a43a$var$Cog6ToothIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
    }), /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }));
}
const $c32dc85ecaf3a43a$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($c32dc85ecaf3a43a$var$Cog6ToothIcon);
var $c32dc85ecaf3a43a$export$2e2bcd8739ae039 = $c32dc85ecaf3a43a$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $1fc9ed6f4f940333$var$Squares2X2Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
    }));
}
const $1fc9ed6f4f940333$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($1fc9ed6f4f940333$var$Squares2X2Icon);
var $1fc9ed6f4f940333$export$2e2bcd8739ae039 = $1fc9ed6f4f940333$var$ForwardRef;





function $bdcc94fa677df125$var$_getPath(path) {
    return path.map((p)=>[
            p,
            'children'
        ]).flat().slice(0, -1);
}
function $bdcc94fa677df125$export$7212fea91513c11f(root, path) {
    return (0, $f4acb02d4ec4661e$export$a4f4bb6b1453fff5)(root, $bdcc94fa677df125$var$_getPath(path));
}
function $bdcc94fa677df125$export$3f778c4e796a1f9c(root, path) {
    return (0, $f4acb02d4ec4661e$export$3988ae62b71be9a3)(root, $bdcc94fa677df125$var$_getPath(path));
}
function $bdcc94fa677df125$export$a11e9bf333819e54(root, node, path) {
    return (0, $f4acb02d4ec4661e$export$adaa4cf7ef1b65be)(root, $bdcc94fa677df125$var$_getPath(path), node);
}
function $bdcc94fa677df125$export$37adcc2e6440d8b3(root, id) {
    const index = root.findIndex((el)=>el.id == id && el.type == 'screen');
    // console.log(index)
    return [
        root?.[index],
        index
    ];
}
function $bdcc94fa677df125$export$afaccf786266e410(id) {
    return {
        type: 'screen',
        id: id,
        children: []
    };
}


function $c64a745d34615282$export$fc99885b7e473d08(str) {
    let url;
    try {
        url = new URL(str);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}



function $797beb6b1327aa54$export$a4a21184d88cac78(input, lang) {
    if (Array.isArray(input)) return input.reduce((prev, el)=>{
        // console.log(el)
        return prev + ((0, $96596b87b46525f2$export$c72d34660a162238)(el, lang) ?? '') + (el.speakOptions?.separator ?? ' ');
    }, '');
    else return (0, $96596b87b46525f2$export$c72d34660a162238)(input, lang);
}
function $797beb6b1327aa54$export$fad6afd6bf685e79(text) {
    return text[0].toUpperCase() + text.substring(1).toLowerCase();
}
const $797beb6b1327aa54$var$addEvent = function(el, type, fn) {
    if (el.addEventListener) el.addEventListener(type, fn, false);
    else el.attachEvent('on' + type, fn);
};
const $797beb6b1327aa54$var$removeEvent = function(el, type, fn) {
    if (el.removeEventListener) el.removeEventListener(type, fn, false);
    else el.detachEvent('on' + type, fn);
};
const $797beb6b1327aa54$var$extend = function(obj, ext) {
    for(const key in ext)if (ext.hasOwnProperty(key)) obj[key] = ext[key];
    return obj;
};
function $797beb6b1327aa54$export$7d055c252aebca58(width, compressor = 1, options = null) {
    const settings = $797beb6b1327aa54$var$extend({
        'minFontSize': -1 / 0,
        'maxFontSize': 1 / 0
    }, options);
    return Math.max(Math.min(width / (compressor * 10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize));
}


var $ca68ed7c68019660$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($ca68ed7c68019660$var$NodeType || ($ca68ed7c68019660$var$NodeType = {}));
function $ca68ed7c68019660$var$isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $ca68ed7c68019660$var$isShadowRoot(n) {
    const host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean((host === null || host === void 0 ? void 0 : host.shadowRoot) === n);
}
function $ca68ed7c68019660$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function $ca68ed7c68019660$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) cssText = cssText.replace(' background-clip: text;', ' -webkit-background-clip: text; background-clip: text;');
    return cssText;
}
function $ca68ed7c68019660$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        '@import',
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === '') statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(' ') + ';';
}
function $ca68ed7c68019660$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $ca68ed7c68019660$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $ca68ed7c68019660$var$stringifyRule).join('')) : null;
    } catch (error) {
        return null;
    }
}
function $ca68ed7c68019660$var$stringifyRule(rule) {
    let importStringified;
    if ($ca68ed7c68019660$var$isCSSImportRule(rule)) try {
        importStringified = $ca68ed7c68019660$var$stringifyStylesheet(rule.styleSheet) || $ca68ed7c68019660$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($ca68ed7c68019660$var$isCSSStyleRule(rule) && rule.selectorText.includes(':')) return $ca68ed7c68019660$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $ca68ed7c68019660$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function $ca68ed7c68019660$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $ca68ed7c68019660$var$isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
class $ca68ed7c68019660$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        var _a;
        if (!n) return -1;
        const id = (_a = this.getMeta(n)) === null || _a === void 0 ? void 0 : _a.id;
        return id !== null && id !== void 0 ? id : -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $ca68ed7c68019660$var$createMirror() {
    return new $ca68ed7c68019660$var$Mirror();
}
function $ca68ed7c68019660$var$maskInputValue({ element: element, maskInputOptions: maskInputOptions, tagName: tagName, type: type, value: value, maskInputFn: maskInputFn }) {
    let text = value || '';
    const actualType = type && $ca68ed7c68019660$var$toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = '*'.repeat(text.length);
    }
    return text;
}
function $ca68ed7c68019660$var$toLowerCase(str) {
    return str.toLowerCase();
}
const $ca68ed7c68019660$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $ca68ed7c68019660$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $ca68ed7c68019660$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$ca68ed7c68019660$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $ca68ed7c68019660$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? $ca68ed7c68019660$var$toLowerCase(type) : null;
}
function $ca68ed7c68019660$var$extractFileExtension(path, baseURL) {
    var _a;
    let url;
    try {
        url = new URL(path, baseURL !== null && baseURL !== void 0 ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : null;
}
let $ca68ed7c68019660$var$_id = 1;
const $ca68ed7c68019660$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
const $ca68ed7c68019660$var$IGNORED_NODE = -2;
function $ca68ed7c68019660$var$genId() {
    return $ca68ed7c68019660$var$_id++;
}
function $ca68ed7c68019660$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    const processedTagName = $ca68ed7c68019660$var$toLowerCase(element.tagName);
    if ($ca68ed7c68019660$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $ca68ed7c68019660$var$extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
let $ca68ed7c68019660$var$canvasService;
let $ca68ed7c68019660$var$canvasCtx;
const $ca68ed7c68019660$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $ca68ed7c68019660$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $ca68ed7c68019660$var$URL_WWW_MATCH = /^www\..*/i;
const $ca68ed7c68019660$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $ca68ed7c68019660$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($ca68ed7c68019660$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if ($ca68ed7c68019660$var$URL_PROTOCOL_MATCH.test(filePath) || $ca68ed7c68019660$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($ca68ed7c68019660$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${$ca68ed7c68019660$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts){
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const $ca68ed7c68019660$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $ca68ed7c68019660$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $ca68ed7c68019660$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    const output = [];
    while(true){
        collectCharacters($ca68ed7c68019660$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($ca68ed7c68019660$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $ca68ed7c68019660$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = '';
            url = $ca68ed7c68019660$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function $ca68ed7c68019660$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function $ca68ed7c68019660$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $ca68ed7c68019660$var$getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function $ca68ed7c68019660$var$transformAttribute(doc, tagName, name, value) {
    if (!value) return value;
    if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) return $ca68ed7c68019660$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $ca68ed7c68019660$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $ca68ed7c68019660$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $ca68ed7c68019660$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $ca68ed7c68019660$var$absoluteToStylesheet(value, $ca68ed7c68019660$var$getHref());
    else if (tagName === 'object' && name === 'data') return $ca68ed7c68019660$var$absoluteToDoc(doc, value);
    return value;
}
function $ca68ed7c68019660$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function $ca68ed7c68019660$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $ca68ed7c68019660$var$classMatchesRegex(node, regex, checkAncestors) {
    if (!node) return false;
    if (node.nodeType !== node.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $ca68ed7c68019660$var$classMatchesRegex(node.parentNode, regex, checkAncestors);
    }
    for(let eIndex = node.classList.length; eIndex--;){
        const className = node.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $ca68ed7c68019660$var$classMatchesRegex(node.parentNode, regex, checkAncestors);
}
function $ca68ed7c68019660$var$needMaskingText(node, maskTextClass, maskTextSelector, checkAncestors) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (typeof maskTextClass === 'string') {
            if (checkAncestors) {
                if (el.closest(`.${maskTextClass}`)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($ca68ed7c68019660$var$classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e) {}
    return false;
}
function $ca68ed7c68019660$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function $ca68ed7c68019660$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $ca68ed7c68019660$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, needsMask: needsMask, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $ca68ed7c68019660$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $ca68ed7c68019660$var$NodeType.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $ca68ed7c68019660$var$NodeType.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $ca68ed7c68019660$var$NodeType.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $ca68ed7c68019660$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n.TEXT_NODE:
            return $ca68ed7c68019660$var$serializeTextNode(n, {
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $ca68ed7c68019660$var$NodeType.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $ca68ed7c68019660$var$NodeType.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $ca68ed7c68019660$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $ca68ed7c68019660$var$serializeTextNode(n, options) {
    var _a;
    const { needsMask: needsMask, maskTextFn: maskTextFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === 'STYLE' ? true : undefined;
    const isScript = parentTagName === 'SCRIPT' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) textContent = $ca68ed7c68019660$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $ca68ed7c68019660$var$absoluteToStylesheet(textContent, $ca68ed7c68019660$var$getHref());
    }
    if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
    if (!isStyle && !isScript && textContent && needsMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
    return {
        type: $ca68ed7c68019660$var$NodeType.Text,
        textContent: textContent || '',
        isStyle: isStyle,
        rootId: rootId
    };
}
function $ca68ed7c68019660$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId } = options;
    const needBlock = $ca68ed7c68019660$var$_isBlockedElement(n, blockClass, blockSelector);
    const tagName = $ca68ed7c68019660$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (!$ca68ed7c68019660$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $ca68ed7c68019660$var$transformAttribute(doc, tagName, $ca68ed7c68019660$var$toLowerCase(attr.name), attr.value);
    }
    if (tagName === 'link' && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $ca68ed7c68019660$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $ca68ed7c68019660$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
        const cssText = $ca68ed7c68019660$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $ca68ed7c68019660$var$absoluteToStylesheet(cssText, $ca68ed7c68019660$var$getHref());
    }
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
        const value = n.value;
        const checked = n.checked;
        if (attributes.type !== 'radio' && attributes.type !== 'checkbox' && attributes.type !== 'submit' && attributes.type !== 'button' && value) attributes.value = $ca68ed7c68019660$var$maskInputValue({
            element: n,
            type: $ca68ed7c68019660$var$getInputType(n),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!$ca68ed7c68019660$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!('__context' in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!$ca68ed7c68019660$var$canvasService) {
            $ca68ed7c68019660$var$canvasService = doc.createElement('canvas');
            $ca68ed7c68019660$var$canvasCtx = $ca68ed7c68019660$var$canvasService.getContext('2d');
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = 'anonymous';
        const recordInlineImage = ()=>{
            image.removeEventListener('load', recordInlineImage);
            try {
                $ca68ed7c68019660$var$canvasService.width = image.naturalWidth;
                $ca68ed7c68019660$var$canvasService.height = image.naturalHeight;
                $ca68ed7c68019660$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $ca68ed7c68019660$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        const mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n.paused ? 'paused' : 'played';
        mediaAttributes.rr_mediaCurrentTime = n.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n.playbackRate;
        mediaAttributes.rr_mediaMuted = n.muted;
        mediaAttributes.rr_mediaLoop = n.loop;
        mediaAttributes.rr_mediaVolume = n.volume;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $ca68ed7c68019660$var$NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $ca68ed7c68019660$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $ca68ed7c68019660$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $ca68ed7c68019660$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $ca68ed7c68019660$var$NodeType.Comment) return true;
    else if (sn.type === $ca68ed7c68019660$var$NodeType.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && $ca68ed7c68019660$var$extractFileExtension(sn.attributes.href) === 'js')) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($ca68ed7c68019660$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'application-name' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.rel) === 'icon' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($ca68ed7c68019660$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'robots' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'author' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'generator' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'framework' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'publisher' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'progid' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'verification' || $ca68ed7c68019660$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $ca68ed7c68019660$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { needsMask: needsMask } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    if (!needsMask && n.childNodes) {
        const checkAncestors = needsMask === undefined;
        needsMask = $ca68ed7c68019660$var$needMaskingText(n, maskTextClass, maskTextSelector, checkAncestors);
    }
    const _serializedNode = $ca68ed7c68019660$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($ca68ed7c68019660$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $ca68ed7c68019660$var$NodeType.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $ca68ed7c68019660$var$IGNORED_NODE;
    else id = $ca68ed7c68019660$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $ca68ed7c68019660$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $ca68ed7c68019660$var$NodeType.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $ca68ed7c68019660$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $ca68ed7c68019660$var$NodeType.Document || serializedNode.type === $ca68ed7c68019660$var$NodeType.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $ca68ed7c68019660$var$NodeType.Element && serializedNode.tagName === 'head') preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        if (serializedNode.type === $ca68ed7c68019660$var$NodeType.Element && serializedNode.tagName === 'textarea' && serializedNode.attributes.value !== undefined) ;
        else for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $ca68ed7c68019660$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($ca68ed7c68019660$var$isElement(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $ca68ed7c68019660$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $ca68ed7c68019660$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $ca68ed7c68019660$var$isShadowRoot(n.parentNode) && $ca68ed7c68019660$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $ca68ed7c68019660$var$NodeType.Element && serializedNode.tagName === 'iframe') $ca68ed7c68019660$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $ca68ed7c68019660$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $ca68ed7c68019660$var$NodeType.Element && serializedNode.tagName === 'link' && typeof serializedNode.attributes.rel === 'string' && (serializedNode.attributes.rel === 'stylesheet' || serializedNode.attributes.rel === 'preload' && typeof serializedNode.attributes.href === 'string' && $ca68ed7c68019660$var$extractFileExtension(serializedNode.attributes.href) === 'css')) $ca68ed7c68019660$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $ca68ed7c68019660$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $ca68ed7c68019660$var$snapshot(n, options) {
    const { mirror: mirror = new $ca68ed7c68019660$var$Mirror(), blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, maskTextClass: maskTextClass = 'rr-mask', maskTextSelector: maskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $ca68ed7c68019660$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $ca68ed7c68019660$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $ca68ed7c68019660$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $ca68ed7c68019660$var$_mirror = {
    map: {},
    getId () {
        console.error($ca68ed7c68019660$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($ca68ed7c68019660$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($ca68ed7c68019660$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($ca68ed7c68019660$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($ca68ed7c68019660$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $ca68ed7c68019660$var$_mirror = new Proxy($ca68ed7c68019660$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($ca68ed7c68019660$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $ca68ed7c68019660$var$throttle(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $ca68ed7c68019660$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$ca68ed7c68019660$var$hookSetter(target, key, original || {}, true);
}
function $ca68ed7c68019660$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (_a) {
        return ()=>{};
    }
}
let $ca68ed7c68019660$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $ca68ed7c68019660$var$nowTimestamp = ()=>new Date().getTime();
function $ca68ed7c68019660$var$getWindowScroll(win) {
    var _a, _b, _c, _d, _e, _f;
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollLeft) || ((_b = (_a = doc === null || doc === void 0 ? void 0 : doc.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || ((_c = doc === null || doc === void 0 ? void 0 : doc.body) === null || _c === void 0 ? void 0 : _c.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollTop) || ((_e = (_d = doc === null || doc === void 0 ? void 0 : doc.body) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.scrollTop) || ((_f = doc === null || doc === void 0 ? void 0 : doc.body) === null || _f === void 0 ? void 0 : _f.scrollTop) || 0
    };
}
function $ca68ed7c68019660$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $ca68ed7c68019660$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $ca68ed7c68019660$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $ca68ed7c68019660$var$isBlocked(node, blockClass, blockSelector, checkAncestors) {
    if (!node) return false;
    const el = $ca68ed7c68019660$var$closestElementOfNode(node);
    if (!el) return false;
    try {
        if (typeof blockClass === 'string') {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest('.' + blockClass) !== null) return true;
        } else {
            if ($ca68ed7c68019660$var$classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function $ca68ed7c68019660$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $ca68ed7c68019660$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $ca68ed7c68019660$var$IGNORED_NODE;
}
function $ca68ed7c68019660$var$isAncestorRemoved(target, mirror) {
    if ($ca68ed7c68019660$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $ca68ed7c68019660$var$isAncestorRemoved(target.parentNode, mirror);
}
function $ca68ed7c68019660$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $ca68ed7c68019660$var$polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $ca68ed7c68019660$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function $ca68ed7c68019660$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function $ca68ed7c68019660$var$hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}
class $ca68ed7c68019660$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        var _a;
        return (_a = this.styleIDMap.get(stylesheet)) !== null && _a !== void 0 ? _a : -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $ca68ed7c68019660$var$getShadowHost(n) {
    var _a, _b;
    let shadowHost = null;
    if (((_b = (_a = n.getRootNode) === null || _a === void 0 ? void 0 : _a.call(n)) === null || _b === void 0 ? void 0 : _b.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $ca68ed7c68019660$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $ca68ed7c68019660$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $ca68ed7c68019660$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $ca68ed7c68019660$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $ca68ed7c68019660$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $ca68ed7c68019660$var$shadowHostInDom(n);
}
var $ca68ed7c68019660$var$EventType$1 = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($ca68ed7c68019660$var$EventType$1 || {});
var $ca68ed7c68019660$var$IncrementalSource$1 = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($ca68ed7c68019660$var$IncrementalSource$1 || {});
var $ca68ed7c68019660$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($ca68ed7c68019660$var$MouseInteractions || {});
var $ca68ed7c68019660$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($ca68ed7c68019660$var$PointerTypes || {});
var $ca68ed7c68019660$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($ca68ed7c68019660$var$CanvasContext || {});
function $ca68ed7c68019660$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
class $ca68ed7c68019660$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        let current = this.head;
        for(let index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $ca68ed7c68019660$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $ca68ed7c68019660$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $ca68ed7c68019660$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $ca68ed7c68019660$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $ca68ed7c68019660$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $ca68ed7c68019660$var$IGNORED_NODE;
                while(nextId === $ca68ed7c68019660$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$ca68ed7c68019660$var$inDom(n) || n.parentNode.tagName === 'TEXTAREA') return;
                const parentId = $ca68ed7c68019660$var$isShadowRoot(n.parentNode) ? this.mirror.getId($ca68ed7c68019660$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $ca68ed7c68019660$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($ca68ed7c68019660$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($ca68ed7c68019660$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($ca68ed7c68019660$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($ca68ed7c68019660$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$ca68ed7c68019660$var$isAncestorInSet(this.droppedSet, n) && !$ca68ed7c68019660$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($ca68ed7c68019660$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>{
                    const n = text.node;
                    if (n.parentNode && n.parentNode.tagName === 'TEXTAREA') this.genTextAreaValueMutation(n.parentNode);
                    return {
                        id: this.mirror.getId(n),
                        value: text.value
                    };
                }).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === 'string') {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.genTextAreaValueMutation = (textarea)=>{
            let item = this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                this.attributes.push(item);
                this.attributeMap.set(textarea, item);
            }
            item.attributes.value = Array.from(textarea.childNodes, (cn)=>cn.textContent || '').join('');
        };
        this.processMutation = (m)=>{
            if ($ca68ed7c68019660$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case 'characterData':
                    {
                        const value = m.target.textContent;
                        if (!$ca68ed7c68019660$var$isBlocked(m.target, this.blockClass, this.blockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $ca68ed7c68019660$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, true) && value ? this.maskTextFn ? this.maskTextFn(value, $ca68ed7c68019660$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === 'value') {
                            const type = $ca68ed7c68019660$var$getInputType(target);
                            value = $ca68ed7c68019660$var$maskInputValue({
                                element: target,
                                maskInputOptions: this.maskInputOptions,
                                tagName: target.tagName,
                                type: type,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($ca68ed7c68019660$var$isBlocked(m.target, this.blockClass, this.blockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === 'IFRAME' && attributeName === 'src' && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = 'rr_src';
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (!$ca68ed7c68019660$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $ca68ed7c68019660$var$transformAttribute(this.doc, $ca68ed7c68019660$var$toLowerCase(target.tagName), $ca68ed7c68019660$var$toLowerCase(attributeName), value);
                            if (attributeName === 'style') {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement('span');
                                if (m.oldValue) old.setAttribute('style', m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === '') item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === '') item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case 'childList':
                    if ($ca68ed7c68019660$var$isBlocked(m.target, this.blockClass, this.blockSelector, true)) return;
                    if (m.target.tagName === 'TEXTAREA') {
                        this.genTextAreaValueMutation(m.target);
                        return;
                    }
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $ca68ed7c68019660$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($ca68ed7c68019660$var$isBlocked(m.target, this.blockClass, this.blockSelector, false) || $ca68ed7c68019660$var$isIgnored(n, this.mirror) || !$ca68ed7c68019660$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $ca68ed7c68019660$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($ca68ed7c68019660$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$ca68ed7c68019660$var$moveKey(nodeId, parentId)]) $ca68ed7c68019660$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $ca68ed7c68019660$var$isShadowRoot(m.target) && $ca68ed7c68019660$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($ca68ed7c68019660$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$ca68ed7c68019660$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$ca68ed7c68019660$var$isBlocked(n, this.blockClass, this.blockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($ca68ed7c68019660$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'maskTextClass',
            'maskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskTextFn',
            'maskInputFn',
            'keepIframeSrcFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'dataURLOptions',
            'doc',
            'mirror',
            'iframeManager',
            'stylesheetManager',
            'shadowDomManager',
            'canvasManager',
            'processedNodeManager'
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $ca68ed7c68019660$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$ca68ed7c68019660$var$deepDelete(addsSet, childN));
}
function $ca68ed7c68019660$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $ca68ed7c68019660$var$_isParentRemoved(removes, n, mirror);
}
function $ca68ed7c68019660$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $ca68ed7c68019660$var$_isParentRemoved(removes, parentNode, mirror);
}
function $ca68ed7c68019660$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $ca68ed7c68019660$var$_isAncestorInSet(set, n);
}
function $ca68ed7c68019660$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $ca68ed7c68019660$var$_isAncestorInSet(set, parentNode);
}
let $ca68ed7c68019660$var$errorHandler;
function $ca68ed7c68019660$var$registerErrorHandler(handler) {
    $ca68ed7c68019660$var$errorHandler = handler;
}
function $ca68ed7c68019660$var$unregisterErrorHandler() {
    $ca68ed7c68019660$var$errorHandler = undefined;
}
const $ca68ed7c68019660$var$callbackWrapper = (cb)=>{
    if (!$ca68ed7c68019660$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($ca68ed7c68019660$var$errorHandler && $ca68ed7c68019660$var$errorHandler(error) === true) return;
            throw error;
        }
    };
    return rrwebWrapped;
};
const $ca68ed7c68019660$var$mutationBuffers = [];
function $ca68ed7c68019660$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (_a) {}
    return event && event.target;
}
function $ca68ed7c68019660$var$initMutationObserver(options, rootEl) {
    var _a, _b;
    const mutationBuffer = new $ca68ed7c68019660$var$MutationBuffer();
    $ca68ed7c68019660$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($ca68ed7c68019660$var$callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $ca68ed7c68019660$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $ca68ed7c68019660$var$throttle($ca68ed7c68019660$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $ca68ed7c68019660$var$callbackWrapper($ca68ed7c68019660$var$throttle($ca68ed7c68019660$var$callbackWrapper((evt)=>{
        const target = $ca68ed7c68019660$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $ca68ed7c68019660$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $ca68ed7c68019660$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $ca68ed7c68019660$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $ca68ed7c68019660$var$IncrementalSource$1.Drag : evt instanceof MouseEvent ? $ca68ed7c68019660$var$IncrementalSource$1.MouseMove : $ca68ed7c68019660$var$IncrementalSource$1.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $ca68ed7c68019660$var$on('mousemove', updatePosition, doc),
        $ca68ed7c68019660$var$on('touchmove', updatePosition, doc),
        $ca68ed7c68019660$var$on('drag', updatePosition, doc)
    ];
    return $ca68ed7c68019660$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca68ed7c68019660$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $ca68ed7c68019660$var$getEventTarget(event);
            if ($ca68ed7c68019660$var$isBlocked(target, blockClass, blockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch(event.pointerType){
                    case 'mouse':
                        pointerType = $ca68ed7c68019660$var$PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = $ca68ed7c68019660$var$PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = $ca68ed7c68019660$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $ca68ed7c68019660$var$PointerTypes.Touch) {
                    if ($ca68ed7c68019660$var$MouseInteractions[eventKey] === $ca68ed7c68019660$var$MouseInteractions.MouseDown) thisEventKey = 'TouchStart';
                    else if ($ca68ed7c68019660$var$MouseInteractions[eventKey] === $ca68ed7c68019660$var$MouseInteractions.MouseUp) thisEventKey = 'TouchEnd';
                } else $ca68ed7c68019660$var$PointerTypes.Pen;
            } else if ($ca68ed7c68019660$var$legacy_isTouchEvent(event)) pointerType = $ca68ed7c68019660$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith('Touch') && pointerType === $ca68ed7c68019660$var$PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === $ca68ed7c68019660$var$PointerTypes.Mouse) pointerType = null;
            } else if ($ca68ed7c68019660$var$MouseInteractions[eventKey] === $ca68ed7c68019660$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $ca68ed7c68019660$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $ca68ed7c68019660$var$callbackWrapper(mouseInteractionCb)(Object.assign({
                type: $ca68ed7c68019660$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys($ca68ed7c68019660$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $ca68ed7c68019660$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($ca68ed7c68019660$var$MouseInteractions[eventKey]){
            case $ca68ed7c68019660$var$MouseInteractions.MouseDown:
            case $ca68ed7c68019660$var$MouseInteractions.MouseUp:
                eventName = eventName.replace('mouse', 'pointer');
                break;
            case $ca68ed7c68019660$var$MouseInteractions.TouchStart:
            case $ca68ed7c68019660$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($ca68ed7c68019660$var$on(eventName, handler, doc));
    });
    return $ca68ed7c68019660$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca68ed7c68019660$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, sampling: sampling }) {
    const updatePosition = $ca68ed7c68019660$var$callbackWrapper($ca68ed7c68019660$var$throttle($ca68ed7c68019660$var$callbackWrapper((evt)=>{
        const target = $ca68ed7c68019660$var$getEventTarget(evt);
        if (!target || $ca68ed7c68019660$var$isBlocked(target, blockClass, blockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $ca68ed7c68019660$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $ca68ed7c68019660$var$on('scroll', updatePosition, doc);
}
function $ca68ed7c68019660$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $ca68ed7c68019660$var$callbackWrapper($ca68ed7c68019660$var$throttle($ca68ed7c68019660$var$callbackWrapper(()=>{
        const height = $ca68ed7c68019660$var$getWindowHeight();
        const width = $ca68ed7c68019660$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $ca68ed7c68019660$var$on('resize', updateDimension, win);
}
const $ca68ed7c68019660$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $ca68ed7c68019660$var$lastInputValueMap = new WeakMap();
function $ca68ed7c68019660$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput }) {
    function eventHandler(event) {
        let target = $ca68ed7c68019660$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && target.tagName;
        if (target && tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $ca68ed7c68019660$var$INPUT_TAGS.indexOf(tagName) < 0 || $ca68ed7c68019660$var$isBlocked(target, blockClass, blockSelector, true)) return;
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) return;
        let text = target.value;
        let isChecked = false;
        const type = $ca68ed7c68019660$var$getInputType(target) || '';
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) text = $ca68ed7c68019660$var$maskInputValue({
            element: target,
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = el.value;
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $ca68ed7c68019660$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $ca68ed7c68019660$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $ca68ed7c68019660$var$callbackWrapper(inputCb)(Object.assign(Object.assign({}, v), {
                id: id
            }));
        }
    }
    const events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    const handlers = events.map((eventName)=>$ca68ed7c68019660$var$on(eventName, $ca68ed7c68019660$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            'checked'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$ca68ed7c68019660$var$hookSetter(p[0], p[1], {
            set () {
                $ca68ed7c68019660$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $ca68ed7c68019660$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca68ed7c68019660$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($ca68ed7c68019660$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $ca68ed7c68019660$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $ca68ed7c68019660$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $ca68ed7c68019660$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $ca68ed7c68019660$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $ca68ed7c68019660$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $ca68ed7c68019660$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $ca68ed7c68019660$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $ca68ed7c68019660$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $ca68ed7c68019660$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $ca68ed7c68019660$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $ca68ed7c68019660$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $ca68ed7c68019660$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $ca68ed7c68019660$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($ca68ed7c68019660$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($ca68ed7c68019660$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($ca68ed7c68019660$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($ca68ed7c68019660$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $ca68ed7c68019660$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $ca68ed7c68019660$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$ca68ed7c68019660$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $ca68ed7c68019660$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $ca68ed7c68019660$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$ca68ed7c68019660$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $ca68ed7c68019660$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $ca68ed7c68019660$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    var _a, _b, _c;
    let hostId = null;
    if (host.nodeName === '#document') hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === '#document' ? (_a = host.defaultView) === null || _a === void 0 ? void 0 : _a.Document : (_c = (_b = host.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView) === null || _c === void 0 ? void 0 : _c.ShadowRoot;
    const originalPropertyDescriptor = (patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype, 'adoptedStyleSheets') : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            var _a;
            return (_a = originalPropertyDescriptor.get) === null || _a === void 0 ? void 0 : _a.call(this);
        },
        set (sheets) {
            var _a;
            const result = (_a = originalPropertyDescriptor.set) === null || _a === void 0 ? void 0 : _a.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $ca68ed7c68019660$var$callbackWrapper(()=>{
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $ca68ed7c68019660$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $ca68ed7c68019660$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a;
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $ca68ed7c68019660$var$getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $ca68ed7c68019660$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $ca68ed7c68019660$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a;
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $ca68ed7c68019660$var$getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $ca68ed7c68019660$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $ca68ed7c68019660$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $ca68ed7c68019660$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $ca68ed7c68019660$var$callbackWrapper((type)=>$ca68ed7c68019660$var$throttle($ca68ed7c68019660$var$callbackWrapper((event)=>{
            const target = $ca68ed7c68019660$var$getEventTarget(event);
            if (!target || $ca68ed7c68019660$var$isBlocked(target, blockClass, blockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate, loop: loop } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate,
                loop: loop
            });
        }), sampling.media || 500));
    const handlers = [
        $ca68ed7c68019660$var$on('play', handler(0), doc),
        $ca68ed7c68019660$var$on('pause', handler(1), doc),
        $ca68ed7c68019660$var$on('seeked', handler(2), doc),
        $ca68ed7c68019660$var$on('volumechange', handler(3), doc),
        $ca68ed7c68019660$var$on('ratechange', handler(4), doc)
    ];
    return $ca68ed7c68019660$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca68ed7c68019660$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $ca68ed7c68019660$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            setTimeout($ca68ed7c68019660$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $ca68ed7c68019660$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca68ed7c68019660$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $ca68ed7c68019660$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && (selection === null || selection === void 0 ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $ca68ed7c68019660$var$isBlocked(startContainer, blockClass, blockSelector, true) || $ca68ed7c68019660$var$isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $ca68ed7c68019660$var$on('selectionchange', updateSelection);
}
function $ca68ed7c68019660$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $ca68ed7c68019660$var$patch(win.customElements, 'define', function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {
                console.warn(`Custom element callback failed for ${name}`);
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $ca68ed7c68019660$var$mergeHooks(o, hooks) {
    const { mutationCb: mutationCb, mousemoveCb: mousemoveCb, mouseInteractionCb: mouseInteractionCb, scrollCb: scrollCb, viewportResizeCb: viewportResizeCb, inputCb: inputCb, mediaInteractionCb: mediaInteractionCb, styleSheetRuleCb: styleSheetRuleCb, styleDeclarationCb: styleDeclarationCb, canvasMutationCb: canvasMutationCb, fontCb: fontCb, selectionCb: selectionCb, customElementCb: customElementCb } = o;
    o.mutationCb = (...p)=>{
        if (hooks.mutation) hooks.mutation(...p);
        mutationCb(...p);
    };
    o.mousemoveCb = (...p)=>{
        if (hooks.mousemove) hooks.mousemove(...p);
        mousemoveCb(...p);
    };
    o.mouseInteractionCb = (...p)=>{
        if (hooks.mouseInteraction) hooks.mouseInteraction(...p);
        mouseInteractionCb(...p);
    };
    o.scrollCb = (...p)=>{
        if (hooks.scroll) hooks.scroll(...p);
        scrollCb(...p);
    };
    o.viewportResizeCb = (...p)=>{
        if (hooks.viewportResize) hooks.viewportResize(...p);
        viewportResizeCb(...p);
    };
    o.inputCb = (...p)=>{
        if (hooks.input) hooks.input(...p);
        inputCb(...p);
    };
    o.mediaInteractionCb = (...p)=>{
        if (hooks.mediaInteaction) hooks.mediaInteaction(...p);
        mediaInteractionCb(...p);
    };
    o.styleSheetRuleCb = (...p)=>{
        if (hooks.styleSheetRule) hooks.styleSheetRule(...p);
        styleSheetRuleCb(...p);
    };
    o.styleDeclarationCb = (...p)=>{
        if (hooks.styleDeclaration) hooks.styleDeclaration(...p);
        styleDeclarationCb(...p);
    };
    o.canvasMutationCb = (...p)=>{
        if (hooks.canvasMutation) hooks.canvasMutation(...p);
        canvasMutationCb(...p);
    };
    o.fontCb = (...p)=>{
        if (hooks.font) hooks.font(...p);
        fontCb(...p);
    };
    o.selectionCb = (...p)=>{
        if (hooks.selection) hooks.selection(...p);
        selectionCb(...p);
    };
    o.customElementCb = (...c)=>{
        if (hooks.customElement) hooks.customElement(...c);
        customElementCb(...c);
    };
}
function $ca68ed7c68019660$var$initObservers(o, hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    $ca68ed7c68019660$var$mergeHooks(o, hooks);
    let mutationObserver;
    if (o.recordDOM) mutationObserver = $ca68ed7c68019660$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $ca68ed7c68019660$var$initMoveObserver(o);
    const mouseInteractionHandler = $ca68ed7c68019660$var$initMouseInteractionObserver(o);
    const scrollHandler = $ca68ed7c68019660$var$initScrollObserver(o);
    const viewportResizeHandler = $ca68ed7c68019660$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $ca68ed7c68019660$var$initInputObserver(o);
    const mediaInteractionHandler = $ca68ed7c68019660$var$initMediaInteractionObserver(o);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o.recordDOM) {
        styleSheetObserver = $ca68ed7c68019660$var$initStyleSheetObserver(o, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $ca68ed7c68019660$var$initAdoptedStyleSheetObserver(o, o.doc);
        styleDeclarationObserver = $ca68ed7c68019660$var$initStyleDeclarationObserver(o, {
            win: currentWindow
        });
        if (o.collectFonts) fontObserver = $ca68ed7c68019660$var$initFontObserver(o);
    }
    const selectionObserver = $ca68ed7c68019660$var$initSelectionObserver(o);
    const customElementObserver = $ca68ed7c68019660$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $ca68ed7c68019660$var$callbackWrapper(()=>{
        $ca68ed7c68019660$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver === null || mutationObserver === void 0 || mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $ca68ed7c68019660$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $ca68ed7c68019660$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class $ca68ed7c68019660$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== 'number') return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $ca68ed7c68019660$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $ca68ed7c68019660$var$CrossOriginIframeMirror($ca68ed7c68019660$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $ca68ed7c68019660$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener('message', this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        (_a = this.loadListener) === null || _a === void 0 || _a.call(this, iframeEl);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        var _a;
        switch(e.type){
            case $ca68ed7c68019660$var$EventType$1.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: {
                            source: $ca68ed7c68019660$var$IncrementalSource$1.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $ca68ed7c68019660$var$EventType$1.Meta:
            case $ca68ed7c68019660$var$EventType$1.Load:
            case $ca68ed7c68019660$var$EventType$1.DomContentLoaded:
                return false;
            case $ca68ed7c68019660$var$EventType$1.Plugin:
                return e;
            case $ca68ed7c68019660$var$EventType$1.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    'id',
                    'parentId',
                    'previousId',
                    'nextId'
                ]);
                return e;
            case $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot:
                switch(e.data.source){
                    case $ca68ed7c68019660$var$IncrementalSource$1.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'nextId',
                                'previousId'
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'id'
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $ca68ed7c68019660$var$IncrementalSource$1.Drag:
                    case $ca68ed7c68019660$var$IncrementalSource$1.TouchMove:
                    case $ca68ed7c68019660$var$IncrementalSource$1.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $ca68ed7c68019660$var$IncrementalSource$1.ViewportResize:
                        return false;
                    case $ca68ed7c68019660$var$IncrementalSource$1.MediaInteraction:
                    case $ca68ed7c68019660$var$IncrementalSource$1.MouseInteraction:
                    case $ca68ed7c68019660$var$IncrementalSource$1.Scroll:
                    case $ca68ed7c68019660$var$IncrementalSource$1.CanvasMutation:
                    case $ca68ed7c68019660$var$IncrementalSource$1.Input:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        return e;
                    case $ca68ed7c68019660$var$IncrementalSource$1.StyleSheetRule:
                    case $ca68ed7c68019660$var$IncrementalSource$1.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleId'
                        ]);
                        return e;
                    case $ca68ed7c68019660$var$IncrementalSource$1.Font:
                        return e;
                    case $ca68ed7c68019660$var$IncrementalSource$1.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                'start',
                                'end'
                            ]);
                        });
                        return e;
                    case $ca68ed7c68019660$var$IncrementalSource$1.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleIds'
                        ]);
                        (_a = e.data.styles) === null || _a === void 0 || _a.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                'styleId'
                            ]);
                        });
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            'id',
            'rootId'
        ]);
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $ca68ed7c68019660$var$NodeType.Document && !node.rootId) node.rootId = rootId;
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $ca68ed7c68019660$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$ca68ed7c68019660$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $ca68ed7c68019660$var$initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($ca68ed7c68019660$var$initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        })));
        setTimeout(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($ca68ed7c68019660$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($ca68ed7c68019660$var$patch(element.prototype, 'attachShadow', function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $ca68ed7c68019660$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $ca68ed7c68019660$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ca68ed7c68019660$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $ca68ed7c68019660$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $ca68ed7c68019660$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var $ca68ed7c68019660$var$i = 0; $ca68ed7c68019660$var$i < $ca68ed7c68019660$var$chars.length; $ca68ed7c68019660$var$i++)$ca68ed7c68019660$var$lookup[$ca68ed7c68019660$var$chars.charCodeAt($ca68ed7c68019660$var$i)] = $ca68ed7c68019660$var$i;
var $ca68ed7c68019660$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $ca68ed7c68019660$var$chars[bytes[i] >> 2];
        base64 += $ca68ed7c68019660$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $ca68ed7c68019660$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $ca68ed7c68019660$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $ca68ed7c68019660$var$canvasVarMap = new Map();
function $ca68ed7c68019660$var$variableListFor(ctx, ctor) {
    let contextMap = $ca68ed7c68019660$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $ca68ed7c68019660$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $ca68ed7c68019660$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($ca68ed7c68019660$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object')) return;
    const name = value.constructor.name;
    const list = $ca68ed7c68019660$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $ca68ed7c68019660$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$ca68ed7c68019660$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $ca68ed7c68019660$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $ca68ed7c68019660$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = 'HTMLImageElement';
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $ca68ed7c68019660$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($ca68ed7c68019660$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        const name = value.constructor.name;
        const index = $ca68ed7c68019660$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $ca68ed7c68019660$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$ca68ed7c68019660$var$serializeArg(arg, win, ctx));
};
const $ca68ed7c68019660$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES'
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === 'function');
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $ca68ed7c68019660$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') continue;
        const restoreHandler = $ca68ed7c68019660$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$ca68ed7c68019660$var$isBlocked(this.canvas, blockClass, blockSelector, true)) setTimeout(()=>{
                    const recordArgs = $ca68ed7c68019660$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $ca68ed7c68019660$var$CanvasContext['2D'],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $ca68ed7c68019660$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $ca68ed7c68019660$var$CanvasContext['2D'],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $ca68ed7c68019660$var$getNormalizedContextName(contextType) {
    return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}
function $ca68ed7c68019660$var$initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $ca68ed7c68019660$var$patch(win.HTMLCanvasElement.prototype, 'getContext', function(original) {
            return function(contextType, ...args) {
                if (!$ca68ed7c68019660$var$isBlocked(this, blockClass, blockSelector, true)) {
                    const ctxName = $ca68ed7c68019660$var$getNormalizedContextName(contextType);
                    if (!('__context' in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        'webgl',
                        'webgl2'
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === 'object') {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $ca68ed7c68019660$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if ([
            'isContextLost',
            'canvas',
            'drawingBufferWidth',
            'drawingBufferHeight'
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== 'function') continue;
            const restoreHandler = $ca68ed7c68019660$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    $ca68ed7c68019660$var$saveWebGLVar(result, win, this);
                    if ('tagName' in this.canvas && !$ca68ed7c68019660$var$isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        const recordArgs = $ca68ed7c68019660$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch (_a) {
            const hookHandler = $ca68ed7c68019660$var$hookSetter(prototype, prop, {
                set (v) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $ca68ed7c68019660$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, mirror) {
    const handlers = [];
    handlers.push(...$ca68ed7c68019660$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $ca68ed7c68019660$var$CanvasContext.WebGL, cb, blockClass, blockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== 'undefined') handlers.push(...$ca68ed7c68019660$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $ca68ed7c68019660$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $ca68ed7c68019660$var$funcToSource(fn, sourcemapArg) {
    var sourcemap = sourcemapArg === undefined ? null : sourcemapArg;
    var source = fn.toString();
    var lines = source.split('\n');
    lines.pop();
    lines.shift();
    var blankPrefixLength = lines[0].search(/\S/);
    var regex = /(['"])__worker_loader_strict__(['"])/g;
    for(var i = 0, n = lines.length; i < n; ++i)lines[i] = lines[i].substring(blankPrefixLength).replace(regex, '$1use strict$2') + '\n';
    if (sourcemap) lines.push('\/\/# sourceMappingURL=' + sourcemap + '\n');
    return lines;
}
function $ca68ed7c68019660$var$createURL(fn, sourcemapArg) {
    var lines = $ca68ed7c68019660$var$funcToSource(fn, sourcemapArg);
    var blob = new Blob(lines, {
        type: 'application/javascript'
    });
    return URL.createObjectURL(blob);
}
function $ca68ed7c68019660$var$createInlineWorkerFactory(fn, sourcemapArg) {
    var url;
    return function WorkerFactory(options) {
        url = url || $ca68ed7c68019660$var$createURL(fn, sourcemapArg);
        return new Worker(url, options);
    };
}
var $ca68ed7c68019660$var$WorkerFactory = $ca68ed7c68019660$var$createInlineWorkerFactory(/* rollup-plugin-web-worker-loader */ function() {
    (function() {
        '__worker_loader_strict__';
        /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function __awaiter(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        }
        /*
     * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        // Use a lookup table to find the index.
        var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
        for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
        var encode = function(arraybuffer) {
            var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
            for(i = 0; i < len; i += 3){
                base64 += chars[bytes[i] >> 2];
                base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                base64 += chars[bytes[i + 2] & 63];
            }
            if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
            else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
            return base64;
        };
        const lastBlobMap = new Map();
        const transparentBlobMap = new Map();
        function getTransparentBlobFor(width, height, dataURLOptions) {
            return __awaiter(this, void 0, void 0, function*() {
                const id = `${width}-${height}`;
                if ('OffscreenCanvas' in globalThis) {
                    if (transparentBlobMap.has(id)) return transparentBlobMap.get(id);
                    const offscreen = new OffscreenCanvas(width, height);
                    offscreen.getContext('2d');
                    const blob = yield offscreen.convertToBlob(dataURLOptions);
                    const arrayBuffer = yield blob.arrayBuffer();
                    const base64 = encode(arrayBuffer);
                    transparentBlobMap.set(id, base64);
                    return base64;
                } else return '';
            });
        }
        const worker = self;
        worker.onmessage = function(e) {
            return __awaiter(this, void 0, void 0, function*() {
                if ('OffscreenCanvas' in globalThis) {
                    const { id: id, bitmap: bitmap, width: width, height: height, dataURLOptions: dataURLOptions } = e.data;
                    const transparentBase64 = getTransparentBlobFor(width, height, dataURLOptions);
                    const offscreen = new OffscreenCanvas(width, height);
                    const ctx = offscreen.getContext('2d');
                    ctx.drawImage(bitmap, 0, 0);
                    bitmap.close();
                    const blob = yield offscreen.convertToBlob(dataURLOptions);
                    const type = blob.type;
                    const arrayBuffer = yield blob.arrayBuffer();
                    const base64 = encode(arrayBuffer);
                    if (!lastBlobMap.has(id) && (yield transparentBase64) === base64) {
                        lastBlobMap.set(id, base64);
                        return worker.postMessage({
                            id: id
                        });
                    }
                    if (lastBlobMap.get(id) === base64) return worker.postMessage({
                        id: id
                    });
                    worker.postMessage({
                        id: id,
                        type: type,
                        base64: base64,
                        width: width,
                        height: height
                    });
                    lastBlobMap.set(id, base64);
                } else return worker.postMessage({
                    id: e.data.id
                });
            });
        };
    })();
}, null);
class $ca68ed7c68019660$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { sampling: sampling = 'all', win: win, blockClass: blockClass, blockSelector: blockSelector, recordCanvas: recordCanvas, dataURLOptions: dataURLOptions } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === 'all') this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === 'number') this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions: dataURLOptions
        });
    }
    initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
        const canvasContextReset = $ca68ed7c68019660$var$initCanvasContextObserver(win, blockClass, blockSelector, true);
        const snapshotInProgressMap = new Map();
        const worker = new $ca68ed7c68019660$var$WorkerFactory();
        worker.onmessage = (e)=>{
            const { id: id } = e.data;
            snapshotInProgressMap.set(id, false);
            if (!('base64' in e.data)) return;
            const { base64: base64, type: type, width: width, height: height } = e.data;
            this.mutationCb({
                id: id,
                type: $ca68ed7c68019660$var$CanvasContext['2D'],
                commands: [
                    {
                        property: 'clearRect',
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: 'drawImage',
                        args: [
                            {
                                rr_type: 'ImageBitmap',
                                args: [
                                    {
                                        rr_type: 'Blob',
                                        data: [
                                            {
                                                rr_type: 'ArrayBuffer',
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        const timeBetweenSnapshots = 1000 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = ()=>{
            const matchedCanvas = [];
            win.document.querySelectorAll('canvas').forEach((canvas)=>{
                if (!$ca68ed7c68019660$var$isBlocked(canvas, blockClass, blockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            getCanvas().forEach((canvas)=>$ca68ed7c68019660$var$__awaiter(this, void 0, void 0, function*() {
                    var _a;
                    const id = this.mirror.getId(canvas);
                    if (snapshotInProgressMap.get(id)) return;
                    if (canvas.width === 0 || canvas.height === 0) return;
                    snapshotInProgressMap.set(id, true);
                    if ([
                        'webgl',
                        'webgl2'
                    ].includes(canvas.__context)) {
                        const context = canvas.getContext(canvas.__context);
                        if (((_a = context === null || context === void 0 ? void 0 : context.getContextAttributes()) === null || _a === void 0 ? void 0 : _a.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                    }
                    const bitmap = yield createImageBitmap(canvas);
                    worker.postMessage({
                        id: id,
                        bitmap: bitmap,
                        width: canvas.width,
                        height: canvas.height,
                        dataURLOptions: options.dataURLOptions
                    }, [
                        bitmap
                    ]);
                }));
            rafId = requestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        this.resetObservers = ()=>{
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    }
    initCanvasMutationObserver(win, blockClass, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $ca68ed7c68019660$var$initCanvasContextObserver(win, blockClass, blockSelector, false);
        const canvas2DReset = $ca68ed7c68019660$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        const canvasWebGL1and2Reset = $ca68ed7c68019660$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const rest = $ca68ed7c68019660$var$__rest(value, [
                "type"
            ]);
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
class $ca68ed7c68019660$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $ca68ed7c68019660$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ('_cssText' in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $ca68ed7c68019660$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $ca68ed7c68019660$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        requestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
function $ca68ed7c68019660$var$wrapEvent(e) {
    return Object.assign(Object.assign({}, e), {
        timestamp: $ca68ed7c68019660$var$nowTimestamp()
    });
}
let $ca68ed7c68019660$var$wrappedEmit;
let $ca68ed7c68019660$var$takeFullSnapshot;
let $ca68ed7c68019660$var$canvasManager;
let $ca68ed7c68019660$var$recording = false;
const $ca68ed7c68019660$var$mirror = $ca68ed7c68019660$var$createMirror();
function $ca68ed7c68019660$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, ignoreClass: ignoreClass = 'rr-ignore', ignoreSelector: ignoreSelector = null, maskTextClass: maskTextClass = 'rr-mask', maskTextSelector: maskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskInputFn: maskInputFn, maskTextFn: maskTextFn, hooks: hooks, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load', userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler } = options;
    $ca68ed7c68019660$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $ca68ed7c68019660$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {
        password: true
    };
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $ca68ed7c68019660$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $ca68ed7c68019660$var$wrappedEmit = (e, isCheckout)=>{
        var _a;
        if (((_a = $ca68ed7c68019660$var$mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== $ca68ed7c68019660$var$EventType$1.FullSnapshot && !(e.type === $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot && e.data.source === $ca68ed7c68019660$var$IncrementalSource$1.Mutation)) $ca68ed7c68019660$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit === null || emit === void 0 || emit(eventProcessor(e), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === $ca68ed7c68019660$var$EventType$1.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot) {
            if (e.data.source === $ca68ed7c68019660$var$IncrementalSource$1.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $ca68ed7c68019660$var$takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
            type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $ca68ed7c68019660$var$IncrementalSource$1.Mutation
            }, m)
        }));
    };
    const wrappedScrollEmit = (p)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
            type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $ca68ed7c68019660$var$IncrementalSource$1.Scroll
            }, p)
        }));
    const wrappedCanvasMutationEmit = (p)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
            type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $ca68ed7c68019660$var$IncrementalSource$1.CanvasMutation
            }, p)
        }));
    const wrappedAdoptedStyleSheetEmit = (a)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
            type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $ca68ed7c68019660$var$IncrementalSource$1.AdoptedStyleSheet
            }, a)
        }));
    const stylesheetManager = new $ca68ed7c68019660$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = new $ca68ed7c68019660$var$IframeManager({
        mirror: $ca68ed7c68019660$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $ca68ed7c68019660$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $ca68ed7c68019660$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $ca68ed7c68019660$var$ProcessedNodeManager();
    $ca68ed7c68019660$var$canvasManager = new $ca68ed7c68019660$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        mirror: $ca68ed7c68019660$var$mirror,
        sampling: sampling.canvas,
        dataURLOptions: dataURLOptions
    });
    const shadowDomManager = new $ca68ed7c68019660$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: $ca68ed7c68019660$var$canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $ca68ed7c68019660$var$mirror
    });
    $ca68ed7c68019660$var$takeFullSnapshot = (isCheckout = false)=>{
        if (!recordDOM) return;
        $ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
            type: $ca68ed7c68019660$var$EventType$1.Meta,
            data: {
                href: window.location.href,
                width: $ca68ed7c68019660$var$getWindowWidth(),
                height: $ca68ed7c68019660$var$getWindowHeight()
            }
        }), isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $ca68ed7c68019660$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $ca68ed7c68019660$var$snapshot(document, {
            mirror: $ca68ed7c68019660$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($ca68ed7c68019660$var$isSerializedIframe(n, $ca68ed7c68019660$var$mirror)) iframeManager.addIframe(n);
                if ($ca68ed7c68019660$var$isSerializedStylesheet(n, $ca68ed7c68019660$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($ca68ed7c68019660$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
            type: $ca68ed7c68019660$var$EventType$1.FullSnapshot,
            data: {
                node: node,
                initialOffset: $ca68ed7c68019660$var$getWindowScroll(window)
            }
        }), isCheckout);
        $ca68ed7c68019660$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $ca68ed7c68019660$var$mirror.getId(document));
    };
    try {
        const handlers = [];
        const observe = (doc)=>{
            var _a;
            return $ca68ed7c68019660$var$callbackWrapper($ca68ed7c68019660$var$initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $ca68ed7c68019660$var$IncrementalSource$1.MouseInteraction
                        }, d)
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $ca68ed7c68019660$var$IncrementalSource$1.ViewportResize
                        }, d)
                    })),
                inputCb: (v)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $ca68ed7c68019660$var$IncrementalSource$1.Input
                        }, v)
                    })),
                mediaInteractionCb: (p)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $ca68ed7c68019660$var$IncrementalSource$1.MediaInteraction
                        }, p)
                    })),
                styleSheetRuleCb: (r)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $ca68ed7c68019660$var$IncrementalSource$1.StyleSheetRule
                        }, r)
                    })),
                styleDeclarationCb: (r)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $ca68ed7c68019660$var$IncrementalSource$1.StyleDeclaration
                        }, r)
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $ca68ed7c68019660$var$IncrementalSource$1.Font
                        }, p)
                    })),
                selectionCb: (p)=>{
                    $ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $ca68ed7c68019660$var$IncrementalSource$1.Selection
                        }, p)
                    }));
                },
                customElementCb: (c)=>{
                    $ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                        type: $ca68ed7c68019660$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $ca68ed7c68019660$var$IncrementalSource$1.CustomElement
                        }, c)
                    }));
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $ca68ed7c68019660$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: $ca68ed7c68019660$var$canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter((p)=>p.observer)) === null || _a === void 0 ? void 0 : _a.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                                type: $ca68ed7c68019660$var$EventType$1.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            }))
                    }))) || []
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            $ca68ed7c68019660$var$takeFullSnapshot();
            handlers.push(observe(document));
            $ca68ed7c68019660$var$recording = true;
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else {
            handlers.push($ca68ed7c68019660$var$on('DOMContentLoaded', ()=>{
                $ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                    type: $ca68ed7c68019660$var$EventType$1.DomContentLoaded,
                    data: {}
                }));
                if (recordAfter === 'DOMContentLoaded') init();
            }));
            handlers.push($ca68ed7c68019660$var$on('load', ()=>{
                $ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
                    type: $ca68ed7c68019660$var$EventType$1.Load,
                    data: {}
                }));
                if (recordAfter === 'load') init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $ca68ed7c68019660$var$recording = false;
            $ca68ed7c68019660$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
$ca68ed7c68019660$var$record.addCustomEvent = (tag, payload)=>{
    if (!$ca68ed7c68019660$var$recording) throw new Error('please add custom event after start recording');
    $ca68ed7c68019660$var$wrappedEmit($ca68ed7c68019660$var$wrapEvent({
        type: $ca68ed7c68019660$var$EventType$1.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    }));
};
$ca68ed7c68019660$var$record.freezePage = ()=>{
    $ca68ed7c68019660$var$mutationBuffers.forEach((buf)=>buf.freeze());
};
$ca68ed7c68019660$var$record.takeFullSnapshot = (isCheckout)=>{
    if (!$ca68ed7c68019660$var$recording) throw new Error('please take full snapshot after start recording');
    $ca68ed7c68019660$var$takeFullSnapshot(isCheckout);
};
$ca68ed7c68019660$var$record.mirror = $ca68ed7c68019660$var$mirror;
var $ca68ed7c68019660$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($ca68ed7c68019660$var$EventType || {});
var $ca68ed7c68019660$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($ca68ed7c68019660$var$IncrementalSource || {});
var $ca68ed7c68019660$var$Config = {
    DEBUG: false,
    LIB_VERSION: '2.55.1'
};
/* eslint camelcase: "off", eqeqeq: "off" */ // since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var $ca68ed7c68019660$var$win;
if (typeof window === 'undefined') {
    var $ca68ed7c68019660$var$loc = {
        hostname: ''
    };
    $ca68ed7c68019660$var$win = {
        navigator: {
            userAgent: '',
            onLine: true
        },
        document: {
            location: $ca68ed7c68019660$var$loc,
            referrer: ''
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $ca68ed7c68019660$var$loc
    };
} else $ca68ed7c68019660$var$win = window;
// Maximum allowed session recording length
var $ca68ed7c68019660$var$MAX_RECORDING_MS = 86400000; // 24 hours
// Maximum allowed value for minimum session recording length
var $ca68ed7c68019660$var$MAX_VALUE_FOR_MIN_RECORDING_MS = 8000; // 8 seconds
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $ca68ed7c68019660$var$ArrayProto = Array.prototype, $ca68ed7c68019660$var$FuncProto = Function.prototype, $ca68ed7c68019660$var$ObjProto = Object.prototype, $ca68ed7c68019660$var$slice = $ca68ed7c68019660$var$ArrayProto.slice, $ca68ed7c68019660$var$toString = $ca68ed7c68019660$var$ObjProto.toString, $ca68ed7c68019660$var$hasOwnProperty = $ca68ed7c68019660$var$ObjProto.hasOwnProperty, $ca68ed7c68019660$var$windowConsole = $ca68ed7c68019660$var$win.console, $ca68ed7c68019660$var$navigator = $ca68ed7c68019660$var$win.navigator, $ca68ed7c68019660$var$document$1 = $ca68ed7c68019660$var$win.document, $ca68ed7c68019660$var$windowOpera = $ca68ed7c68019660$var$win.opera, $ca68ed7c68019660$var$screen = $ca68ed7c68019660$var$win.screen, $ca68ed7c68019660$var$userAgent = $ca68ed7c68019660$var$navigator.userAgent;
var $ca68ed7c68019660$var$nativeBind = $ca68ed7c68019660$var$FuncProto.bind, $ca68ed7c68019660$var$nativeForEach = $ca68ed7c68019660$var$ArrayProto.forEach, $ca68ed7c68019660$var$nativeIndexOf = $ca68ed7c68019660$var$ArrayProto.indexOf, $ca68ed7c68019660$var$nativeMap = $ca68ed7c68019660$var$ArrayProto.map, $ca68ed7c68019660$var$nativeIsArray = Array.isArray, $ca68ed7c68019660$var$breaker = {};
var $ca68ed7c68019660$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};
// Console override
var $ca68ed7c68019660$var$console$1 = {
    /** @type {function(...*)} */ log: function() {
        if ($ca68ed7c68019660$var$Config.DEBUG && !$ca68ed7c68019660$var$_.isUndefined($ca68ed7c68019660$var$windowConsole) && $ca68ed7c68019660$var$windowConsole) try {
            $ca68ed7c68019660$var$windowConsole.log.apply($ca68ed7c68019660$var$windowConsole, arguments);
        } catch (err) {
            $ca68ed7c68019660$var$_.each(arguments, function(arg) {
                $ca68ed7c68019660$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($ca68ed7c68019660$var$Config.DEBUG && !$ca68ed7c68019660$var$_.isUndefined($ca68ed7c68019660$var$windowConsole) && $ca68ed7c68019660$var$windowConsole) {
            var args = [
                'Mixpanel warning:'
            ].concat($ca68ed7c68019660$var$_.toArray(arguments));
            try {
                $ca68ed7c68019660$var$windowConsole.warn.apply($ca68ed7c68019660$var$windowConsole, args);
            } catch (err) {
                $ca68ed7c68019660$var$_.each(args, function(arg) {
                    $ca68ed7c68019660$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($ca68ed7c68019660$var$Config.DEBUG && !$ca68ed7c68019660$var$_.isUndefined($ca68ed7c68019660$var$windowConsole) && $ca68ed7c68019660$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($ca68ed7c68019660$var$_.toArray(arguments));
            try {
                $ca68ed7c68019660$var$windowConsole.error.apply($ca68ed7c68019660$var$windowConsole, args);
            } catch (err) {
                $ca68ed7c68019660$var$_.each(args, function(arg) {
                    $ca68ed7c68019660$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$ca68ed7c68019660$var$_.isUndefined($ca68ed7c68019660$var$windowConsole) && $ca68ed7c68019660$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($ca68ed7c68019660$var$_.toArray(arguments));
            try {
                $ca68ed7c68019660$var$windowConsole.error.apply($ca68ed7c68019660$var$windowConsole, args);
            } catch (err) {
                $ca68ed7c68019660$var$_.each(args, function(arg) {
                    $ca68ed7c68019660$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $ca68ed7c68019660$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply($ca68ed7c68019660$var$console$1, arguments);
    };
};
var $ca68ed7c68019660$var$console_with_prefix = function(prefix) {
    return {
        log: $ca68ed7c68019660$var$log_func_with_prefix($ca68ed7c68019660$var$console$1.log, prefix),
        error: $ca68ed7c68019660$var$log_func_with_prefix($ca68ed7c68019660$var$console$1.error, prefix),
        critical: $ca68ed7c68019660$var$log_func_with_prefix($ca68ed7c68019660$var$console$1.critical, prefix)
    };
};
// UNDERSCORE
// Embed part of the Underscore Library
$ca68ed7c68019660$var$_.bind = function(func, context) {
    var args, bound;
    if ($ca68ed7c68019660$var$nativeBind && func.bind === $ca68ed7c68019660$var$nativeBind) return $ca68ed7c68019660$var$nativeBind.apply(func, $ca68ed7c68019660$var$slice.call(arguments, 1));
    if (!$ca68ed7c68019660$var$_.isFunction(func)) throw new TypeError();
    args = $ca68ed7c68019660$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($ca68ed7c68019660$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self1 = new ctor();
        ctor.prototype = null;
        var result = func.apply(self1, args.concat($ca68ed7c68019660$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self1;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $ca68ed7c68019660$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($ca68ed7c68019660$var$nativeForEach && obj.forEach === $ca68ed7c68019660$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $ca68ed7c68019660$var$breaker) return;
    }
    else {
        for(var key in obj)if ($ca68ed7c68019660$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $ca68ed7c68019660$var$breaker) return;
        }
    }
};
$ca68ed7c68019660$var$_.extend = function(obj) {
    $ca68ed7c68019660$var$_.each($ca68ed7c68019660$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$ca68ed7c68019660$var$_.isArray = $ca68ed7c68019660$var$nativeIsArray || function(obj) {
    return $ca68ed7c68019660$var$toString.call(obj) === '[object Array]';
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$ca68ed7c68019660$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$ca68ed7c68019660$var$_.isArguments = function(obj) {
    return !!(obj && $ca68ed7c68019660$var$hasOwnProperty.call(obj, 'callee'));
};
$ca68ed7c68019660$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($ca68ed7c68019660$var$_.isArray(iterable)) return $ca68ed7c68019660$var$slice.call(iterable);
    if ($ca68ed7c68019660$var$_.isArguments(iterable)) return $ca68ed7c68019660$var$slice.call(iterable);
    return $ca68ed7c68019660$var$_.values(iterable);
};
$ca68ed7c68019660$var$_.map = function(arr, callback, context) {
    if ($ca68ed7c68019660$var$nativeMap && arr.map === $ca68ed7c68019660$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $ca68ed7c68019660$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$ca68ed7c68019660$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $ca68ed7c68019660$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$ca68ed7c68019660$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $ca68ed7c68019660$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$ca68ed7c68019660$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($ca68ed7c68019660$var$nativeIndexOf && obj.indexOf === $ca68ed7c68019660$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $ca68ed7c68019660$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $ca68ed7c68019660$var$breaker;
    });
    return found;
};
$ca68ed7c68019660$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$ca68ed7c68019660$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$ca68ed7c68019660$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$ca68ed7c68019660$var$_.isArray(obj);
};
$ca68ed7c68019660$var$_.isEmptyObject = function(obj) {
    if ($ca68ed7c68019660$var$_.isObject(obj)) {
        for(var key in obj){
            if ($ca68ed7c68019660$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$ca68ed7c68019660$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$ca68ed7c68019660$var$_.isString = function(obj) {
    return $ca68ed7c68019660$var$toString.call(obj) == '[object String]';
};
$ca68ed7c68019660$var$_.isDate = function(obj) {
    return $ca68ed7c68019660$var$toString.call(obj) == '[object Date]';
};
$ca68ed7c68019660$var$_.isNumber = function(obj) {
    return $ca68ed7c68019660$var$toString.call(obj) == '[object Number]';
};
$ca68ed7c68019660$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$ca68ed7c68019660$var$_.encodeDates = function(obj) {
    $ca68ed7c68019660$var$_.each(obj, function(v, k) {
        if ($ca68ed7c68019660$var$_.isDate(v)) obj[k] = $ca68ed7c68019660$var$_.formatDate(v);
        else if ($ca68ed7c68019660$var$_.isObject(v)) obj[k] = $ca68ed7c68019660$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$ca68ed7c68019660$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$ca68ed7c68019660$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
};
$ca68ed7c68019660$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $ca68ed7c68019660$var$_.each(p, function(v, k) {
        if ($ca68ed7c68019660$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $ca68ed7c68019660$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === 'string') ret = obj.slice(0, length);
    else if ($ca68ed7c68019660$var$_.isArray(obj)) {
        ret = [];
        $ca68ed7c68019660$var$_.each(obj, function(val) {
            ret.push($ca68ed7c68019660$var$_.truncate(val, length));
        });
    } else if ($ca68ed7c68019660$var$_.isObject(obj)) {
        ret = {};
        $ca68ed7c68019660$var$_.each(obj, function(val, key) {
            ret[key] = $ca68ed7c68019660$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$ca68ed7c68019660$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' && typeof value.toJSON === 'function') value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case 'string':
                    return quote(value);
                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';
                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return 'null';
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($ca68ed7c68019660$var$toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || 'null';
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($ca68ed7c68019660$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ': ' : ':') + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $ca68ed7c68019660$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        '\\': '\\',
        '/': '/',
        'b': '\b',
        'f': '\f',
        'n': '\n',
        'r': '\r',
        't': '\t'
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error('Expected \'' + c + '\' instead of \'' + ch + '\'');
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = '';
        if (ch === '-') {
            string = '-';
            next('-');
        }
        while(ch >= '0' && ch <= '9'){
            string += ch;
            next();
        }
        if (ch === '.') {
            string += '.';
            while(next() && ch >= '0' && ch <= '9')string += ch;
        }
        if (ch === 'e' || ch === 'E') {
            string += ch;
            next();
            if (ch === '-' || ch === '+') {
                string += ch;
                next();
            }
            while(ch >= '0' && ch <= '9'){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error('Bad number');
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = '', uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === '\\') {
                next();
                if (ch === 'u') {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === 'string') string += escapee[ch];
                else break;
            } else string += ch;
        }
        error('Bad string');
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= ' ')next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === '[') {
            next('[');
            white();
            if (ch === ']') {
                next(']');
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === ']') {
                    next(']');
                    return array;
                }
                next(',');
                white();
            }
        }
        error('Bad array');
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === '{') {
            next('{');
            white();
            if (ch === '}') {
                next('}');
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(':');
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === '}') {
                    next('}');
                    return object;
                }
                next(',');
                white();
            }
        }
        error('Bad object');
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) error('Syntax error');
        return result;
    };
}();
$ca68ed7c68019660$var$_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
    if (!data) return data;
    data = $ca68ed7c68019660$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join('');
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
};
$ca68ed7c68019660$var$_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '', start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$ca68ed7c68019660$var$_.UUID = function() {
    // Time-based entropy
    var T = function() {
        var time = 1 * new Date(); // cross-browser version of Date.now()
        var ticks;
        if ($ca68ed7c68019660$var$win.performance && $ca68ed7c68019660$var$win.performance.now) ticks = $ca68ed7c68019660$var$win.performance.now();
        else {
            // fall back to busy loop
            ticks = 0;
            // this while loop figures how many browser ticks go by
            // before 1*new Date() returns a new number, ie the amount
            // of ticks that go by per millisecond
            while(time == 1 * new Date())ticks++;
        }
        return time.toString(16) + Math.floor(ticks).toString(16);
    };
    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace('.', '');
    };
    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = $ca68ed7c68019660$var$userAgent, i, ch, buffer = [], ret = 0;
        function xor(result, byte_array) {
            var j, tmp = 0;
            for(j = 0; j < byte_array.length; j++)tmp |= buffer[j] << j * 8;
            return result ^ tmp;
        }
        for(i = 0; i < ua.length; i++){
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }
        if (buffer.length > 0) ret = xor(ret, buffer);
        return ret.toString(16);
    };
    return function() {
        var se = ($ca68ed7c68019660$var$screen.height * $ca68ed7c68019660$var$screen.width).toString(16);
        return T() + '-' + R() + '-' + UA() + '-' + se + '-' + T();
    };
}();
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $ca68ed7c68019660$var$BLOCKED_UA_STRS = [
    'ahrefsbot',
    'ahrefssiteaudit',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'chrome-lighthouse',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandexbot',
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
$ca68ed7c68019660$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $ca68ed7c68019660$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($ca68ed7c68019660$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $ca68ed7c68019660$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($ca68ed7c68019660$var$_.isUndefined(arg_separator)) arg_separator = '&';
    $ca68ed7c68019660$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$ca68ed7c68019660$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/g, '\\[').replace(/[\]]/g, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)', regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== 'string' && results[1].length) return '';
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $ca68ed7c68019660$var$console$1.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$ca68ed7c68019660$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = $ca68ed7c68019660$var$document$1.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $ca68ed7c68019660$var$_.JSONDecode($ca68ed7c68019660$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $ca68ed7c68019660$var$extract_domain($ca68ed7c68019660$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        $ca68ed7c68019660$var$document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $ca68ed7c68019660$var$extract_domain($ca68ed7c68019660$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        $ca68ed7c68019660$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $ca68ed7c68019660$var$_.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $ca68ed7c68019660$var$_localStorageSupported = null;
var $ca68ed7c68019660$var$localStorageSupported = function(storage, forceCheck) {
    if ($ca68ed7c68019660$var$_localStorageSupported !== null && !forceCheck) return $ca68ed7c68019660$var$_localStorageSupported;
    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = '__mplss_' + $ca68ed7c68019660$var$cheap_guid(8), val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    $ca68ed7c68019660$var$_localStorageSupported = supported;
    return supported;
};
// _.localStorage
$ca68ed7c68019660$var$_.localStorage = {
    is_supported: function(force_check) {
        var supported = $ca68ed7c68019660$var$localStorageSupported(null, force_check);
        if (!supported) $ca68ed7c68019660$var$console$1.error('localStorage unsupported; falling back to cookie store');
        return supported;
    },
    error: function(msg) {
        $ca68ed7c68019660$var$console$1.error('localStorage error: ' + msg);
    },
    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            $ca68ed7c68019660$var$_.localStorage.error(err);
        }
        return null;
    },
    parse: function(name) {
        try {
            return $ca68ed7c68019660$var$_.JSONDecode($ca68ed7c68019660$var$_.localStorage.get(name)) || {};
        } catch (err) {
        // noop
        }
        return null;
    },
    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            $ca68ed7c68019660$var$_.localStorage.error(err);
        }
    },
    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            $ca68ed7c68019660$var$_.localStorage.error(err);
        }
    }
};
$ca68ed7c68019660$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $ca68ed7c68019660$var$console$1.error('No valid element provided to register_event');
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($ca68ed7c68019660$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $ca68ed7c68019660$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$ca68ed7c68019660$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$ca68ed7c68019660$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $ca68ed7c68019660$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = $ca68ed7c68019660$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = '*';
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $ca68ed7c68019660$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($ca68ed7c68019660$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = '*';
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case '=':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case '~':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
                        };
                        break;
                    case '|':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
                        };
                        break;
                    case '^':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case '$':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case '*':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($ca68ed7c68019660$var$_.isElement(query)) return [
            query
        ];
        else if ($ca68ed7c68019660$var$_.isObject(query) && !$ca68ed7c68019660$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $ca68ed7c68019660$var$CAMPAIGN_KEYWORDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'utm_source_platform',
    'utm_campaign_id',
    'utm_creative_format',
    'utm_marketing_tactic'
];
var $ca68ed7c68019660$var$CLICK_IDS = [
    'dclid',
    'fbclid',
    'gclid',
    'ko_click_id',
    'li_fat_id',
    'msclkid',
    'sccid',
    'ttclid',
    'twclid',
    'wbraid'
];
$ca68ed7c68019660$var$_.info = {
    campaignParams: function(default_value) {
        var kw = '', params = {};
        $ca68ed7c68019660$var$_.each($ca68ed7c68019660$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $ca68ed7c68019660$var$_.getQueryParam($ca68ed7c68019660$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = '', params = {};
        $ca68ed7c68019660$var$_.each($ca68ed7c68019660$var$CLICK_IDS, function(idkey) {
            id = $ca68ed7c68019660$var$_.getQueryParam($ca68ed7c68019660$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $ca68ed7c68019660$var$_.extend($ca68ed7c68019660$var$_.info.campaignParams(), $ca68ed7c68019660$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) return 'google';
        else if (referrer.search('https?://(.*)bing.com') === 0) return 'bing';
        else if (referrer.search('https?://(.*)yahoo.com') === 0) return 'yahoo';
        else if (referrer.search('https?://(.*)duckduckgo.com') === 0) return 'duckduckgo';
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $ca68ed7c68019660$var$_.info.searchEngine(referrer), param = search != 'yahoo' ? 'q' : 'p', ret = {};
        if (search !== null) {
            ret['$search_engine'] = search;
            var keyword = $ca68ed7c68019660$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret['mp_keyword'] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || $ca68ed7c68019660$var$_.includes(user_agent, ' OPR/')) {
            if ($ca68ed7c68019660$var$_.includes(user_agent, 'Mini')) return 'Opera Mini';
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'IEMobile') || $ca68ed7c68019660$var$_.includes(user_agent, 'WPDesktop')) return 'Internet Explorer Mobile';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'SamsungBrowser/')) // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'Edge') || $ca68ed7c68019660$var$_.includes(user_agent, 'Edg/')) return 'Microsoft Edge';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'FBIOS')) return 'Facebook Mobile';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'Chrome')) return 'Chrome';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'CriOS')) return 'Chrome iOS';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'UCWEB') || $ca68ed7c68019660$var$_.includes(user_agent, 'UCBrowser')) return 'UC Browser';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'FxiOS')) return 'Firefox iOS';
        else if ($ca68ed7c68019660$var$_.includes(vendor, 'Apple')) {
            if ($ca68ed7c68019660$var$_.includes(user_agent, 'Mobile')) return 'Mobile Safari';
            return 'Safari';
        } else if ($ca68ed7c68019660$var$_.includes(user_agent, 'Android')) return 'Android Mobile';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'Konqueror')) return 'Konqueror';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'Firefox')) return 'Firefox';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'MSIE') || $ca68ed7c68019660$var$_.includes(user_agent, 'Trident/')) return 'Internet Explorer';
        else if ($ca68ed7c68019660$var$_.includes(user_agent, 'Gecko')) return 'Mozilla';
        else return '';
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $ca68ed7c68019660$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $ca68ed7c68019660$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return 'Windows Phone';
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) return 'iOS';
        else if (/Android/.test(a)) return 'Android';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return 'BlackBerry';
        else if (/Mac/i.test(a)) return 'Mac OS X';
        else if (/Linux/.test(a)) return 'Linux';
        else if (/CrOS/.test(a)) return 'Chrome OS';
        else return '';
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return 'Windows Phone';
        else if (/iPad/.test(user_agent)) return 'iPad';
        else if (/iPod/.test(user_agent)) return 'iPod Touch';
        else if (/iPhone/.test(user_agent)) return 'iPhone';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if (/Android/.test(user_agent)) return 'Android';
        else return '';
    },
    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) return split[2];
        return '';
    },
    currentUrl: function() {
        return $ca68ed7c68019660$var$win.location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== 'object') extra_props = {};
        return $ca68ed7c68019660$var$_.extend($ca68ed7c68019660$var$_.strip_empty_properties({
            '$os': $ca68ed7c68019660$var$_.info.os(),
            '$browser': $ca68ed7c68019660$var$_.info.browser($ca68ed7c68019660$var$userAgent, $ca68ed7c68019660$var$navigator.vendor, $ca68ed7c68019660$var$windowOpera),
            '$referrer': $ca68ed7c68019660$var$document$1.referrer,
            '$referring_domain': $ca68ed7c68019660$var$_.info.referringDomain($ca68ed7c68019660$var$document$1.referrer),
            '$device': $ca68ed7c68019660$var$_.info.device($ca68ed7c68019660$var$userAgent)
        }), {
            '$current_url': $ca68ed7c68019660$var$_.info.currentUrl(),
            '$browser_version': $ca68ed7c68019660$var$_.info.browserVersion($ca68ed7c68019660$var$userAgent, $ca68ed7c68019660$var$navigator.vendor, $ca68ed7c68019660$var$windowOpera),
            '$screen_height': $ca68ed7c68019660$var$screen.height,
            '$screen_width': $ca68ed7c68019660$var$screen.width,
            'mp_lib': 'web',
            '$lib_version': $ca68ed7c68019660$var$Config.LIB_VERSION,
            '$insert_id': $ca68ed7c68019660$var$cheap_guid(),
            'time': $ca68ed7c68019660$var$_.timestamp() / 1000 // epoch time in seconds
        }, $ca68ed7c68019660$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return $ca68ed7c68019660$var$_.extend($ca68ed7c68019660$var$_.strip_empty_properties({
            '$os': $ca68ed7c68019660$var$_.info.os(),
            '$browser': $ca68ed7c68019660$var$_.info.browser($ca68ed7c68019660$var$userAgent, $ca68ed7c68019660$var$navigator.vendor, $ca68ed7c68019660$var$windowOpera)
        }), {
            '$browser_version': $ca68ed7c68019660$var$_.info.browserVersion($ca68ed7c68019660$var$userAgent, $ca68ed7c68019660$var$navigator.vendor, $ca68ed7c68019660$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $ca68ed7c68019660$var$_.strip_empty_properties({
            'current_page_title': $ca68ed7c68019660$var$document$1.title,
            'current_domain': $ca68ed7c68019660$var$win.location.hostname,
            'current_url_path': $ca68ed7c68019660$var$win.location.pathname,
            'current_url_protocol': $ca68ed7c68019660$var$win.location.protocol,
            'current_url_search': $ca68ed7c68019660$var$win.location.search
        });
    }
};
var $ca68ed7c68019660$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $ca68ed7c68019660$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $ca68ed7c68019660$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $ca68ed7c68019660$var$extract_domain = function(hostname) {
    var domain_regex = $ca68ed7c68019660$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') domain_regex = $ca68ed7c68019660$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};
/**
 * Check whether we have network connection. default to true for browsers that don't support navigator.onLine (IE)
 * @returns {boolean}
 */ var $ca68ed7c68019660$var$isOnline = function() {
    var onLine = $ca68ed7c68019660$var$win.navigator['onLine'];
    return $ca68ed7c68019660$var$_.isUndefined(onLine) || onLine;
};
var $ca68ed7c68019660$var$JSONStringify = null, $ca68ed7c68019660$var$JSONParse = null;
if (typeof JSON !== 'undefined') {
    $ca68ed7c68019660$var$JSONStringify = JSON.stringify;
    $ca68ed7c68019660$var$JSONParse = JSON.parse;
}
$ca68ed7c68019660$var$JSONStringify = $ca68ed7c68019660$var$JSONStringify || $ca68ed7c68019660$var$_.JSONEncode;
$ca68ed7c68019660$var$JSONParse = $ca68ed7c68019660$var$JSONParse || $ca68ed7c68019660$var$_.JSONDecode;
// EXPORTS (for closure compiler)
$ca68ed7c68019660$var$_['toArray'] = $ca68ed7c68019660$var$_.toArray;
$ca68ed7c68019660$var$_['isObject'] = $ca68ed7c68019660$var$_.isObject;
$ca68ed7c68019660$var$_['JSONEncode'] = $ca68ed7c68019660$var$_.JSONEncode;
$ca68ed7c68019660$var$_['JSONDecode'] = $ca68ed7c68019660$var$_.JSONDecode;
$ca68ed7c68019660$var$_['isBlockedUA'] = $ca68ed7c68019660$var$_.isBlockedUA;
$ca68ed7c68019660$var$_['isEmptyObject'] = $ca68ed7c68019660$var$_.isEmptyObject;
$ca68ed7c68019660$var$_['info'] = $ca68ed7c68019660$var$_.info;
$ca68ed7c68019660$var$_['info']['device'] = $ca68ed7c68019660$var$_.info.device;
$ca68ed7c68019660$var$_['info']['browser'] = $ca68ed7c68019660$var$_.info.browser;
$ca68ed7c68019660$var$_['info']['browserVersion'] = $ca68ed7c68019660$var$_.info.browserVersion;
$ca68ed7c68019660$var$_['info']['properties'] = $ca68ed7c68019660$var$_.info.properties;
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $ca68ed7c68019660$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $ca68ed7c68019660$var$optIn(token, options) {
    $ca68ed7c68019660$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $ca68ed7c68019660$var$optOut(token, options) {
    $ca68ed7c68019660$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $ca68ed7c68019660$var$hasOptedIn(token, options) {
    return $ca68ed7c68019660$var$_getStorageValue(token, options) === '1';
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $ca68ed7c68019660$var$hasOptedOut(token, options) {
    if ($ca68ed7c68019660$var$_hasDoNotTrackFlagOn(options)) {
        $ca68ed7c68019660$var$console$1.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $ca68ed7c68019660$var$_getStorageValue(token, options) === '0';
    if (optedOut) $ca68ed7c68019660$var$console$1.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $ca68ed7c68019660$var$addOptOutCheckMixpanelLib(method) {
    return $ca68ed7c68019660$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $ca68ed7c68019660$var$addOptOutCheckMixpanelPeople(method) {
    return $ca68ed7c68019660$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $ca68ed7c68019660$var$addOptOutCheckMixpanelGroup(method) {
    return $ca68ed7c68019660$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $ca68ed7c68019660$var$clearOptInOut(token, options) {
    options = options || {};
    $ca68ed7c68019660$var$_getStorage(options).remove($ca68ed7c68019660$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $ca68ed7c68019660$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? $ca68ed7c68019660$var$_.localStorage : $ca68ed7c68019660$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $ca68ed7c68019660$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $ca68ed7c68019660$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $ca68ed7c68019660$var$_getStorageValue(token, options) {
    return $ca68ed7c68019660$var$_getStorage(options).get($ca68ed7c68019660$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $ca68ed7c68019660$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $ca68ed7c68019660$var$win;
    var nav = win$1['navigator'] || {};
    var hasDntOn = false;
    $ca68ed7c68019660$var$_.each([
        nav['doNotTrack'],
        nav['msDoNotTrack'],
        win$1['doNotTrack']
    ], function(dntValue) {
        if ($ca68ed7c68019660$var$_.includes([
            true,
            1,
            '1',
            'yes'
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $ca68ed7c68019660$var$_optInOut(optValue, token, options) {
    if (!$ca68ed7c68019660$var$_.isString(token) || !token.length) {
        $ca68ed7c68019660$var$console$1.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }
    options = options || {};
    $ca68ed7c68019660$var$_getStorage(options).set($ca68ed7c68019660$var$_getStorageKey(token, options), optValue ? 1 : 0, $ca68ed7c68019660$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || '$opt_in', options.trackProperties, {
        'send_immediately': true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $ca68ed7c68019660$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests
            if (token) optedOut = $ca68ed7c68019660$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $ca68ed7c68019660$var$console$1.error('Unexpected error when checking tracking opt-out status: ' + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === 'function') callback(0);
        return;
    };
}
var $ca68ed7c68019660$var$logger$3 = $ca68ed7c68019660$var$console_with_prefix('lock');
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $ca68ed7c68019660$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$ca68ed7c68019660$var$SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== 'function') {
        pid = errorCB;
        errorCB = null;
    }
    var i = pid || new Date().getTime() + '|' + Math.random();
    var startTime = new Date().getTime();
    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;
    var keyX = key + ':X';
    var keyY = key + ':Y';
    var keyZ = key + ':Z';
    var reportError = function(err) {
        errorCB && errorCB(err);
    };
    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            $ca68ed7c68019660$var$logger$3.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch (err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };
    var waitFor = function(predicate, cb) {
        if (predicate()) cb();
        else delay(function() {
            waitFor(predicate, cb);
        });
    };
    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) return false;
        else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) return true;
            else {
                if (!$ca68ed7c68019660$var$localStorageSupported(storage, true)) throw new Error('localStorage support dropped while acquiring lock');
                return false;
            }
        }
    };
    var loop = function() {
        storage.setItem(keyX, i);
        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }
            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };
    var criticalSection = function() {
        storage.setItem(keyZ, '1');
        try {
            lockedCB();
        } finally{
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) storage.removeItem(keyY);
            if (storage.getItem(keyX) === i) storage.removeItem(keyX);
        }
    };
    try {
        if ($ca68ed7c68019660$var$localStorageSupported(storage, true)) loop();
        else throw new Error('localStorage support check failed');
    } catch (err) {
        reportError(err);
    }
};
var $ca68ed7c68019660$var$logger$2 = $ca68ed7c68019660$var$console_with_prefix('batch');
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $ca68ed7c68019660$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.reportError = options.errorReporter || $ca68ed7c68019660$var$_.bind($ca68ed7c68019660$var$logger$2.error, $ca68ed7c68019660$var$logger$2);
    this.lock = new $ca68ed7c68019660$var$SharedLock(storageKey, {
        storage: this.storage
    });
    this.usePersistence = options.usePersistence;
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $ca68ed7c68019660$var$RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        'id': $ca68ed7c68019660$var$cheap_guid(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };
    if (!this.usePersistence) {
        this.memQueue.push(queueEntry);
        if (cb) cb(true);
    } else this.lock.withLock($ca68ed7c68019660$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) // only add to in-memory queue when storage succeeds
            this.memQueue.push(queueEntry);
        } catch (err) {
            this.reportError('Error enqueueing item', item);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $ca68ed7c68019660$var$_.bind(function lockFailure(err) {
        this.reportError('Error acquiring storage lock', err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $ca68ed7c68019660$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (this.usePersistence && batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $ca68ed7c68019660$var$_.each(batch, function(item) {
                idsInBatch[item['id']] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
    }
    return batch;
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $ca68ed7c68019660$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $ca68ed7c68019660$var$_.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $ca68ed7c68019660$var$RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    $ca68ed7c68019660$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $ca68ed7c68019660$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    if (!this.usePersistence) {
        if (cb) cb(true);
    } else {
        var removeFromStorage = $ca68ed7c68019660$var$_.bind(function() {
            var succeeded;
            try {
                var storedQueue = this.readFromStorage();
                storedQueue = $ca68ed7c68019660$var$filterOutIDsAndInvalid(storedQueue, idSet);
                succeeded = this.saveToStorage(storedQueue);
                // an extra check: did storage report success but somehow
                // the items are still there?
                if (succeeded) {
                    storedQueue = this.readFromStorage();
                    for(var i = 0; i < storedQueue.length; i++){
                        var item = storedQueue[i];
                        if (item['id'] && !!idSet[item['id']]) {
                            this.reportError('Item not removed from storage');
                            return false;
                        }
                    }
                }
            } catch (err) {
                this.reportError('Error removing items', ids);
                succeeded = false;
            }
            return succeeded;
        }, this);
        this.lock.withLock(function lockAcquired() {
            var succeeded = removeFromStorage();
            if (cb) cb(succeeded);
        }, $ca68ed7c68019660$var$_.bind(function lockFailure(err) {
            var succeeded = false;
            this.reportError('Error acquiring storage lock', err);
            if (!$ca68ed7c68019660$var$localStorageSupported(this.storage, true)) {
                // Looks like localStorage writes have stopped working sometime after
                // initialization (probably full), and so nobody can acquire locks
                // anymore. Consider it temporarily safe to remove items without the
                // lock, since nobody's writing successfully anyway.
                succeeded = removeFromStorage();
                if (!succeeded) // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                try {
                    this.storage.removeItem(this.storageKey);
                } catch (err) {
                    this.reportError('Error clearing queue', err);
                }
            }
            if (cb) cb(succeeded);
        }, this), this.pid);
    }
};
// internal helper for RequestQueue.updatePayloads
var $ca68ed7c68019660$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $ca68ed7c68019660$var$_.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $ca68ed7c68019660$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = $ca68ed7c68019660$var$updatePayloads(this.memQueue, itemsToUpdate);
    if (!this.usePersistence) {
        if (cb) cb(true);
    } else this.lock.withLock($ca68ed7c68019660$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $ca68ed7c68019660$var$updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch (err) {
            this.reportError('Error updating items', itemsToUpdate);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $ca68ed7c68019660$var$_.bind(function lockFailure(err) {
        this.reportError('Error acquiring storage lock', err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $ca68ed7c68019660$var$RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = $ca68ed7c68019660$var$JSONParse(storageEntry);
            if (!$ca68ed7c68019660$var$_.isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        this.reportError('Error retrieving queue', err);
        storageEntry = null;
    }
    return storageEntry || [];
};
/**
 * Serialize the given items array to localStorage.
 */ $ca68ed7c68019660$var$RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, $ca68ed7c68019660$var$JSONStringify(queue));
        return true;
    } catch (err) {
        this.reportError('Error saving queue', err);
        return false;
    }
};
/**
 * Clear out queues (memory and localStorage).
 */ $ca68ed7c68019660$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    if (this.usePersistence) this.storage.removeItem(this.storageKey);
};
// maximum interval between request retries after exponential backoff
var $ca68ed7c68019660$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $ca68ed7c68019660$var$logger$1 = $ca68ed7c68019660$var$console_with_prefix('batch');
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $ca68ed7c68019660$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $ca68ed7c68019660$var$RequestQueue(storageKey, {
        errorReporter: $ca68ed7c68019660$var$_.bind(this.reportError, this),
        storage: options.storage,
        usePersistence: options.usePersistence
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];
    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
    // Make the flush occur at the interval specified by flushIntervalMs, default behavior will attempt consecutive flushes
    // as long as the queue is not empty. This is useful for high-frequency events like Session Replay where we might end up
    // in a request loop and get ratelimited by the server.
    this.flushOnlyOnInterval = options.flushOnlyOnInterval || false;
};
/**
 * Add one item to queue.
 */ $ca68ed7c68019660$var$RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $ca68ed7c68019660$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $ca68ed7c68019660$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $ca68ed7c68019660$var$RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $ca68ed7c68019660$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $ca68ed7c68019660$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $ca68ed7c68019660$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($ca68ed7c68019660$var$_.bind(function() {
        if (!this.stopped) this.flush();
    }, this), this.flushInterval);
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $ca68ed7c68019660$var$RequestBatcher.prototype.flush = function(options) {
    try {
        if (this.requestInProgress) {
            $ca68ed7c68019660$var$logger$1.log('Flush: Request already in progress');
            return;
        }
        options = options || {};
        var timeoutMS = this.libConfig['batch_request_timeout_ms'];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        // if there's more items in the queue than the batch size, attempt
        // to flush again after the current batch is done.
        var attemptSecondaryFlush = batch.length === currentBatchSize;
        var dataForRequest = [];
        var transformedItems = {};
        $ca68ed7c68019660$var$_.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload['event'] && payload['properties']) payload['properties'] = $ca68ed7c68019660$var$_.extend({}, payload['properties'], {
                    'mp_sent_by_lib_version': $ca68ed7c68019660$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item['id'];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError('[dupe] item ID sent too many times, not sending', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError('[dupe] found item with no ID', {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }
        this.requestInProgress = true;
        var batchSendCallback = $ca68ed7c68019660$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                var removeItemsFromQueue = false;
                if (options.unloading) // update persisted data to include hook transformations
                this.queue.updatePayloads(transformedItems);
                else if ($ca68ed7c68019660$var$_.isObject(res) && res.error === 'timeout' && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError('Network timeout; retrying');
                    this.flush();
                } else if ($ca68ed7c68019660$var$_.isObject(res) && (res.httpStatusCode >= 500 || res.httpStatusCode === 429 || res.httpStatusCode <= 0 && !$ca68ed7c68019660$var$isOnline() || res.error === 'timeout')) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    if (res.retryAfter) retryMS = parseInt(res.retryAfter, 10) * 1000 || retryMS;
                    retryMS = Math.min($ca68ed7c68019660$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                } else if ($ca68ed7c68019660$var$_.isObject(res) && res.httpStatusCode === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                removeItemsFromQueue = true;
                if (removeItemsFromQueue) {
                    this.queue.removeItemsByID($ca68ed7c68019660$var$_.map(batch, function(item) {
                        return item['id'];
                    }), $ca68ed7c68019660$var$_.bind(function(succeeded) {
                        if (succeeded) {
                            this.consecutiveRemovalFailures = 0;
                            if (this.flushOnlyOnInterval && !attemptSecondaryFlush) this.resetFlush(); // schedule next batch with a delay
                            else this.flush(); // handle next batch if the queue isn't empty
                        } else {
                            this.reportError('Failed to remove items from queue');
                            if (++this.consecutiveRemovalFailures > 5) {
                                this.reportError('Too many queue failures; disabling batching system.');
                                this.stopAllBatching();
                            } else this.resetFlush();
                        }
                    }, this));
                    // client-side dedupe
                    $ca68ed7c68019660$var$_.each(batch, $ca68ed7c68019660$var$_.bind(function(item) {
                        var itemId = item['id'];
                        if (itemId) {
                            this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                            this.itemIdsSentSuccessfully[itemId]++;
                            if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError('[dupe] item ID sent too many times', {
                                item: item,
                                batchSize: batch.length,
                                timesSent: this.itemIdsSentSuccessfully[itemId]
                            });
                        } else this.reportError('[dupe] found item with no ID while removing', {
                            item: item
                        });
                    }, this));
                }
            } catch (err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = 'sendBeacon';
        $ca68ed7c68019660$var$logger$1.log('MIXPANEL REQUEST:', dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);
    } catch (err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $ca68ed7c68019660$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $ca68ed7c68019660$var$logger$1.error.apply($ca68ed7c68019660$var$logger$1.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $ca68ed7c68019660$var$logger$1.error(err);
    }
};
var $ca68ed7c68019660$var$logger = $ca68ed7c68019660$var$console_with_prefix('recorder');
var $ca68ed7c68019660$var$CompressionStream = $ca68ed7c68019660$var$win['CompressionStream'];
var $ca68ed7c68019660$var$RECORDER_BATCHER_LIB_CONFIG = {
    'batch_size': 1000,
    'batch_flush_interval_ms': 10000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true
};
var $ca68ed7c68019660$var$ACTIVE_SOURCES = new Set([
    $ca68ed7c68019660$var$IncrementalSource.MouseMove,
    $ca68ed7c68019660$var$IncrementalSource.MouseInteraction,
    $ca68ed7c68019660$var$IncrementalSource.Scroll,
    $ca68ed7c68019660$var$IncrementalSource.ViewportResize,
    $ca68ed7c68019660$var$IncrementalSource.Input,
    $ca68ed7c68019660$var$IncrementalSource.TouchMove,
    $ca68ed7c68019660$var$IncrementalSource.MediaInteraction,
    $ca68ed7c68019660$var$IncrementalSource.Drag,
    $ca68ed7c68019660$var$IncrementalSource.Selection
]);
function $ca68ed7c68019660$var$isUserEvent(ev) {
    return ev.type === $ca68ed7c68019660$var$EventType.IncrementalSnapshot && $ca68ed7c68019660$var$ACTIVE_SOURCES.has(ev.data.source);
}
var $ca68ed7c68019660$var$MixpanelRecorder = function(mixpanelInstance) {
    this._mixpanel = mixpanelInstance;
    // internal rrweb stopRecording function
    this._stopRecording = null;
    this.recEvents = [];
    this.seqNo = 0;
    this.replayId = null;
    this.replayStartTime = null;
    this.sendBatchId = null;
    this.idleTimeoutId = null;
    this.maxTimeoutId = null;
    this.recordMaxMs = $ca68ed7c68019660$var$MAX_RECORDING_MS;
    this.recordMinMs = 0;
    this._initBatcher();
};
$ca68ed7c68019660$var$MixpanelRecorder.prototype._initBatcher = function() {
    this.batcher = new $ca68ed7c68019660$var$RequestBatcher('__mprec', {
        libConfig: $ca68ed7c68019660$var$RECORDER_BATCHER_LIB_CONFIG,
        sendRequestFunc: $ca68ed7c68019660$var$_.bind(this.flushEventsWithOptOut, this),
        errorReporter: $ca68ed7c68019660$var$_.bind(this.reportError, this),
        flushOnlyOnInterval: true,
        usePersistence: false
    });
};
// eslint-disable-next-line camelcase
$ca68ed7c68019660$var$MixpanelRecorder.prototype.get_config = function(configVar) {
    return this._mixpanel.get_config(configVar);
};
$ca68ed7c68019660$var$MixpanelRecorder.prototype.startRecording = function(shouldStopBatcher) {
    if (this._stopRecording !== null) {
        $ca68ed7c68019660$var$logger.log('Recording already in progress, skipping startRecording.');
        return;
    }
    this.recordMaxMs = this.get_config('record_max_ms');
    if (this.recordMaxMs > $ca68ed7c68019660$var$MAX_RECORDING_MS) {
        this.recordMaxMs = $ca68ed7c68019660$var$MAX_RECORDING_MS;
        $ca68ed7c68019660$var$logger.critical('record_max_ms cannot be greater than ' + $ca68ed7c68019660$var$MAX_RECORDING_MS + 'ms. Capping value.');
    }
    this.recordMinMs = this.get_config('record_min_ms');
    if (this.recordMinMs > $ca68ed7c68019660$var$MAX_VALUE_FOR_MIN_RECORDING_MS) {
        this.recordMinMs = $ca68ed7c68019660$var$MAX_VALUE_FOR_MIN_RECORDING_MS;
        $ca68ed7c68019660$var$logger.critical('record_min_ms cannot be greater than ' + $ca68ed7c68019660$var$MAX_VALUE_FOR_MIN_RECORDING_MS + 'ms. Capping value.');
    }
    this.recEvents = [];
    this.seqNo = 0;
    this.replayStartTime = new Date().getTime();
    this.replayId = $ca68ed7c68019660$var$_.UUID();
    if (shouldStopBatcher || this.recordMinMs > 0) // the primary case for shouldStopBatcher is when we're starting recording after a reset
    // and don't want to send anything over the network until there's
    // actual user activity
    // this also applies if the minimum recording length has not been hit yet
    // so that we don't send data until we know the recording will be long enough
    this.batcher.stop();
    else this.batcher.start();
    var resetIdleTimeout = $ca68ed7c68019660$var$_.bind(function() {
        clearTimeout(this.idleTimeoutId);
        this.idleTimeoutId = setTimeout($ca68ed7c68019660$var$_.bind(function() {
            $ca68ed7c68019660$var$logger.log('Idle timeout reached, restarting recording.');
            this.resetRecording();
        }, this), this.get_config('record_idle_timeout_ms'));
    }, this);
    var blockSelector = this.get_config('record_block_selector');
    if (blockSelector === '' || blockSelector === null) blockSelector = undefined;
    this._stopRecording = $ca68ed7c68019660$var$record({
        'emit': $ca68ed7c68019660$var$_.bind(function(ev) {
            this.batcher.enqueue(ev);
            if ($ca68ed7c68019660$var$isUserEvent(ev)) {
                if (this.batcher.stopped && new Date().getTime() - this.replayStartTime >= this.recordMinMs) // start flushing again after user activity
                this.batcher.start();
                resetIdleTimeout();
            }
        }, this),
        'blockClass': this.get_config('record_block_class'),
        'blockSelector': blockSelector,
        'collectFonts': this.get_config('record_collect_fonts'),
        'inlineImages': this.get_config('record_inline_images'),
        'maskAllInputs': true,
        'maskTextClass': this.get_config('record_mask_text_class'),
        'maskTextSelector': this.get_config('record_mask_text_selector')
    });
    resetIdleTimeout();
    this.maxTimeoutId = setTimeout($ca68ed7c68019660$var$_.bind(this.resetRecording, this), this.recordMaxMs);
};
$ca68ed7c68019660$var$MixpanelRecorder.prototype.resetRecording = function() {
    this.stopRecording();
    this.startRecording(true);
};
$ca68ed7c68019660$var$MixpanelRecorder.prototype.stopRecording = function() {
    if (this._stopRecording !== null) {
        this._stopRecording();
        this._stopRecording = null;
    }
    if (this.batcher.stopped) // never got user activity to flush after reset, so just clear the batcher
    this.batcher.clear();
    else {
        // flush any remaining events from running batcher
        this.batcher.flush();
        this.batcher.stop();
    }
    this.replayId = null;
    clearTimeout(this.idleTimeoutId);
    clearTimeout(this.maxTimeoutId);
};
/**
 * Flushes the current batch of events to the server, but passes an opt-out callback to make sure
 * we stop recording and dump any queued events if the user has opted out.
 */ $ca68ed7c68019660$var$MixpanelRecorder.prototype.flushEventsWithOptOut = function(data, options, cb) {
    this._flushEvents(data, options, cb, $ca68ed7c68019660$var$_.bind(this._onOptOut, this));
};
$ca68ed7c68019660$var$MixpanelRecorder.prototype._onOptOut = function(code) {
    // addOptOutCheckMixpanelLib invokes this function with code=0 when the user has opted out
    if (code === 0) {
        this.recEvents = [];
        this.stopRecording();
    }
};
$ca68ed7c68019660$var$MixpanelRecorder.prototype._sendRequest = function(currentReplayId, reqParams, reqBody, callback) {
    var onSuccess = $ca68ed7c68019660$var$_.bind(function(response, responseBody) {
        // Increment sequence counter only if the request was successful to guarantee ordering.
        // RequestBatcher will always flush the next batch after the previous one succeeds.
        // extra check to see if the replay ID has changed so that we don't increment the seqNo on the wrong replay
        if (response.status === 200 && this.replayId === currentReplayId) this.seqNo++;
        callback({
            status: 0,
            httpStatusCode: response.status,
            responseBody: responseBody,
            retryAfter: response.headers.get('Retry-After')
        });
    }, this);
    $ca68ed7c68019660$var$win['fetch'](this.get_config('api_host') + '/' + this.get_config('api_routes')['record'] + '?' + new URLSearchParams(reqParams), {
        'method': 'POST',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.get_config('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        'body': reqBody
    }).then(function(response) {
        response.json().then(function(responseBody) {
            onSuccess(response, responseBody);
        }).catch(function(error) {
            callback({
                error: error
            });
        });
    }).catch(function(error) {
        callback({
            error: error,
            httpStatusCode: 0
        });
    });
};
$ca68ed7c68019660$var$MixpanelRecorder.prototype._flushEvents = $ca68ed7c68019660$var$addOptOutCheckMixpanelLib(function(data, options, callback) {
    const numEvents = data.length;
    if (numEvents > 0) {
        var replayId = this.replayId;
        // each rrweb event has a timestamp - leverage those to get time properties
        var batchStartTime = data[0].timestamp;
        if (this.seqNo === 0 || !this.replayStartTime) {
            // extra safety net so that we don't send a null replay start time
            if (this.seqNo !== 0) this.reportError('Replay start time not set but seqNo is not 0. Using current batch start time as a fallback.');
            this.replayStartTime = batchStartTime;
        }
        var replayLengthMs = data[numEvents - 1].timestamp - this.replayStartTime;
        var reqParams = {
            'distinct_id': String(this._mixpanel.get_distinct_id()),
            'seq': this.seqNo,
            'batch_start_time': batchStartTime / 1000,
            'replay_id': replayId,
            'replay_length_ms': replayLengthMs,
            'replay_start_time': this.replayStartTime / 1000
        };
        var eventsJson = $ca68ed7c68019660$var$_.JSONEncode(data);
        // send ID management props if they exist
        var deviceId = this._mixpanel.get_property('$device_id');
        if (deviceId) reqParams['$device_id'] = deviceId;
        var userId = this._mixpanel.get_property('$user_id');
        if (userId) reqParams['$user_id'] = userId;
        if ($ca68ed7c68019660$var$CompressionStream) {
            var jsonStream = new Blob([
                eventsJson
            ], {
                type: 'application/json'
            }).stream();
            var gzipStream = jsonStream.pipeThrough(new $ca68ed7c68019660$var$CompressionStream('gzip'));
            new Response(gzipStream).blob().then($ca68ed7c68019660$var$_.bind(function(compressedBlob) {
                reqParams['format'] = 'gzip';
                this._sendRequest(replayId, reqParams, compressedBlob, callback);
            }, this));
        } else {
            reqParams['format'] = 'body';
            this._sendRequest(replayId, reqParams, eventsJson, callback);
        }
    }
});
$ca68ed7c68019660$var$MixpanelRecorder.prototype.reportError = function(msg, err) {
    $ca68ed7c68019660$var$logger.error.apply($ca68ed7c68019660$var$logger.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config('error_reporter')(msg, err);
    } catch (err) {
        $ca68ed7c68019660$var$logger.error(err);
    }
};
$ca68ed7c68019660$var$win['__mp_recorder'] = $ca68ed7c68019660$var$MixpanelRecorder;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $ca68ed7c68019660$var$DomTracker = function() {};
// interface
$ca68ed7c68019660$var$DomTracker.prototype.create_properties = function() {};
$ca68ed7c68019660$var$DomTracker.prototype.event_handler = function() {};
$ca68ed7c68019660$var$DomTracker.prototype.after_track_handler = function() {};
$ca68ed7c68019660$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $ca68ed7c68019660$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $ca68ed7c68019660$var$_.dom_query(query);
    if (elements.length === 0) {
        $ca68ed7c68019660$var$console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }
    $ca68ed7c68019660$var$_.each(elements, function(element) {
        $ca68ed7c68019660$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $ca68ed7c68019660$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$ca68ed7c68019660$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === 'function') props = properties(element);
    else props = $ca68ed7c68019660$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $ca68ed7c68019660$var$LinkTracker = function() {
    this.override_event = 'click';
};
$ca68ed7c68019660$var$_.inherit($ca68ed7c68019660$var$LinkTracker, $ca68ed7c68019660$var$DomTracker);
$ca68ed7c68019660$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $ca68ed7c68019660$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props['url'] = element.href;
    return props;
};
$ca68ed7c68019660$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$ca68ed7c68019660$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $ca68ed7c68019660$var$FormTracker = function() {
    this.override_event = 'submit';
};
$ca68ed7c68019660$var$_.inherit($ca68ed7c68019660$var$FormTracker, $ca68ed7c68019660$var$DomTracker);
$ca68ed7c68019660$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$ca68ed7c68019660$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
/* eslint camelcase: "off" */ /** @const */ var $ca68ed7c68019660$var$SET_ACTION = '$set';
/** @const */ var $ca68ed7c68019660$var$SET_ONCE_ACTION = '$set_once';
/** @const */ var $ca68ed7c68019660$var$UNSET_ACTION = '$unset';
/** @const */ var $ca68ed7c68019660$var$ADD_ACTION = '$add';
/** @const */ var $ca68ed7c68019660$var$APPEND_ACTION = '$append';
/** @const */ var $ca68ed7c68019660$var$UNION_ACTION = '$union';
/** @const */ var $ca68ed7c68019660$var$REMOVE_ACTION = '$remove';
/** @const */ var $ca68ed7c68019660$var$DELETE_ACTION = '$delete';
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $ca68ed7c68019660$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($ca68ed7c68019660$var$_.isObject(prop)) $ca68ed7c68019660$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$ca68ed7c68019660$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$ca68ed7c68019660$var$_.isArray(prop)) prop = [
            prop
        ];
        $ca68ed7c68019660$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$ca68ed7c68019660$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($ca68ed7c68019660$var$_.isObject(prop)) $ca68ed7c68019660$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$ca68ed7c68019660$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($ca68ed7c68019660$var$_.isObject(list_name)) $ca68ed7c68019660$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $ca68ed7c68019660$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $ca68ed7c68019660$var$_.isArray(values) ? values : [
            values
        ];
        data[$ca68ed7c68019660$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($ca68ed7c68019660$var$_.isObject(list_name)) $ca68ed7c68019660$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$ca68ed7c68019660$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($ca68ed7c68019660$var$_.isObject(list_name)) $ca68ed7c68019660$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$ca68ed7c68019660$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$ca68ed7c68019660$var$DELETE_ACTION] = '';
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $ca68ed7c68019660$var$MixpanelGroup = function() {};
$ca68ed7c68019660$var$_.extend($ca68ed7c68019660$var$MixpanelGroup.prototype, $ca68ed7c68019660$var$apiActions);
$ca68ed7c68019660$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $ca68ed7c68019660$var$MixpanelGroup.prototype.set = $ca68ed7c68019660$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($ca68ed7c68019660$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $ca68ed7c68019660$var$MixpanelGroup.prototype.set_once = $ca68ed7c68019660$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($ca68ed7c68019660$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $ca68ed7c68019660$var$MixpanelGroup.prototype.unset = $ca68ed7c68019660$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $ca68ed7c68019660$var$MixpanelGroup.prototype.union = $ca68ed7c68019660$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($ca68ed7c68019660$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $ca68ed7c68019660$var$MixpanelGroup.prototype['delete'] = $ca68ed7c68019660$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $ca68ed7c68019660$var$MixpanelGroup.prototype.remove = $ca68ed7c68019660$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$ca68ed7c68019660$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');
    var date_encoded_data = $ca68ed7c68019660$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['groups'],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$ca68ed7c68019660$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};
$ca68ed7c68019660$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$ca68ed7c68019660$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};
// MixpanelGroup Exports
$ca68ed7c68019660$var$MixpanelGroup.prototype['remove'] = $ca68ed7c68019660$var$MixpanelGroup.prototype.remove;
$ca68ed7c68019660$var$MixpanelGroup.prototype['set'] = $ca68ed7c68019660$var$MixpanelGroup.prototype.set;
$ca68ed7c68019660$var$MixpanelGroup.prototype['set_once'] = $ca68ed7c68019660$var$MixpanelGroup.prototype.set_once;
$ca68ed7c68019660$var$MixpanelGroup.prototype['union'] = $ca68ed7c68019660$var$MixpanelGroup.prototype.union;
$ca68ed7c68019660$var$MixpanelGroup.prototype['unset'] = $ca68ed7c68019660$var$MixpanelGroup.prototype.unset;
$ca68ed7c68019660$var$MixpanelGroup.prototype['toString'] = $ca68ed7c68019660$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $ca68ed7c68019660$var$MixpanelPeople = function() {};
$ca68ed7c68019660$var$_.extend($ca68ed7c68019660$var$MixpanelPeople.prototype, $ca68ed7c68019660$var$apiActions);
$ca68ed7c68019660$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $ca68ed7c68019660$var$MixpanelPeople.prototype.set = $ca68ed7c68019660$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($ca68ed7c68019660$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) this._mixpanel['persistence'].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$ca68ed7c68019660$var$SET_ACTION] = $ca68ed7c68019660$var$_.extend({}, $ca68ed7c68019660$var$_.info.people_properties(), data[$ca68ed7c68019660$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $ca68ed7c68019660$var$MixpanelPeople.prototype.set_once = $ca68ed7c68019660$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($ca68ed7c68019660$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $ca68ed7c68019660$var$MixpanelPeople.prototype.unset = $ca68ed7c68019660$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $ca68ed7c68019660$var$MixpanelPeople.prototype.increment = $ca68ed7c68019660$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($ca68ed7c68019660$var$_.isObject(prop)) {
        $ca68ed7c68019660$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $ca68ed7c68019660$var$console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($ca68ed7c68019660$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$ca68ed7c68019660$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $ca68ed7c68019660$var$MixpanelPeople.prototype.append = $ca68ed7c68019660$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($ca68ed7c68019660$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $ca68ed7c68019660$var$MixpanelPeople.prototype.remove = $ca68ed7c68019660$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($ca68ed7c68019660$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $ca68ed7c68019660$var$MixpanelPeople.prototype.union = $ca68ed7c68019660$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($ca68ed7c68019660$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $ca68ed7c68019660$var$MixpanelPeople.prototype.track_charge = $ca68ed7c68019660$var$addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!$ca68ed7c68019660$var$_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            $ca68ed7c68019660$var$console$1.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }
    return this.append('$transactions', $ca68ed7c68019660$var$_.extend({
        '$amount': amount
    }, properties), callback);
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $ca68ed7c68019660$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $ca68ed7c68019660$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $ca68ed7c68019660$var$console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {
        '$delete': this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$ca68ed7c68019660$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};
$ca68ed7c68019660$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) data['$device_id'] = device_id;
    if (user_id) data['$user_id'] = user_id;
    if (had_persisted_distinct_id) data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    var date_encoded_data = $ca68ed7c68019660$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$ca68ed7c68019660$var$_.isUndefined(callback)) {
            if (this._get_config('verbose')) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $ca68ed7c68019660$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['engage'],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$ca68ed7c68019660$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$ca68ed7c68019660$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$ca68ed7c68019660$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($ca68ed7c68019660$var$SET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($ca68ed7c68019660$var$SET_ACTION, data);
    else if ($ca68ed7c68019660$var$SET_ONCE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($ca68ed7c68019660$var$SET_ONCE_ACTION, data);
    else if ($ca68ed7c68019660$var$UNSET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($ca68ed7c68019660$var$UNSET_ACTION, data);
    else if ($ca68ed7c68019660$var$ADD_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($ca68ed7c68019660$var$ADD_ACTION, data);
    else if ($ca68ed7c68019660$var$APPEND_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($ca68ed7c68019660$var$APPEND_ACTION, data);
    else if ($ca68ed7c68019660$var$REMOVE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($ca68ed7c68019660$var$REMOVE_ACTION, data);
    else if ($ca68ed7c68019660$var$UNION_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($ca68ed7c68019660$var$UNION_ACTION, data);
    else $ca68ed7c68019660$var$console$1.error('Invalid call to _enqueue():', data);
};
$ca68ed7c68019660$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $ca68ed7c68019660$var$_.extend({}, this._mixpanel['persistence'].load_queue(action));
    var action_params = queued_data;
    if (!$ca68ed7c68019660$var$_.isUndefined(queued_data) && $ca68ed7c68019660$var$_.isObject(queued_data) && !$ca68ed7c68019660$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        _this._mixpanel['persistence'].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            if (!$ca68ed7c68019660$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$ca68ed7c68019660$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($ca68ed7c68019660$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($ca68ed7c68019660$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($ca68ed7c68019660$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $ca68ed7c68019660$var$_.keys(queue);
    });
    this._flush_one_queue($ca68ed7c68019660$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($ca68ed7c68019660$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel['persistence'].load_queue($ca68ed7c68019660$var$APPEND_ACTION);
    if (!$ca68ed7c68019660$var$_.isUndefined($append_queue) && $ca68ed7c68019660$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($ca68ed7c68019660$var$APPEND_ACTION, $append_item);
            if (!$ca68ed7c68019660$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel['persistence'].load_queue($ca68ed7c68019660$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$ca68ed7c68019660$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel['persistence'].load_queue($ca68ed7c68019660$var$REMOVE_ACTION);
    if (!$ca68ed7c68019660$var$_.isUndefined($remove_queue) && $ca68ed7c68019660$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($ca68ed7c68019660$var$REMOVE_ACTION, $remove_item);
            if (!$ca68ed7c68019660$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel['persistence'].load_queue($ca68ed7c68019660$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$ca68ed7c68019660$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$ca68ed7c68019660$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};
// MixpanelPeople Exports
$ca68ed7c68019660$var$MixpanelPeople.prototype['set'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.set;
$ca68ed7c68019660$var$MixpanelPeople.prototype['set_once'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.set_once;
$ca68ed7c68019660$var$MixpanelPeople.prototype['unset'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.unset;
$ca68ed7c68019660$var$MixpanelPeople.prototype['increment'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.increment;
$ca68ed7c68019660$var$MixpanelPeople.prototype['append'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.append;
$ca68ed7c68019660$var$MixpanelPeople.prototype['remove'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.remove;
$ca68ed7c68019660$var$MixpanelPeople.prototype['union'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.union;
$ca68ed7c68019660$var$MixpanelPeople.prototype['track_charge'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.track_charge;
$ca68ed7c68019660$var$MixpanelPeople.prototype['clear_charges'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.clear_charges;
$ca68ed7c68019660$var$MixpanelPeople.prototype['delete_user'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.delete_user;
$ca68ed7c68019660$var$MixpanelPeople.prototype['toString'] = $ca68ed7c68019660$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $ca68ed7c68019660$var$SET_QUEUE_KEY = '__mps';
/** @const */ var $ca68ed7c68019660$var$SET_ONCE_QUEUE_KEY = '__mpso';
/** @const */ var $ca68ed7c68019660$var$UNSET_QUEUE_KEY = '__mpus';
/** @const */ var $ca68ed7c68019660$var$ADD_QUEUE_KEY = '__mpa';
/** @const */ var $ca68ed7c68019660$var$APPEND_QUEUE_KEY = '__mpap';
/** @const */ var $ca68ed7c68019660$var$REMOVE_QUEUE_KEY = '__mpr';
/** @const */ var $ca68ed7c68019660$var$UNION_QUEUE_KEY = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $ca68ed7c68019660$var$PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var $ca68ed7c68019660$var$ALIAS_ID_KEY = '__alias';
/** @const */ var $ca68ed7c68019660$var$EVENT_TIMERS_KEY = '__timers';
/** @const */ var $ca68ed7c68019660$var$RESERVED_PROPERTIES = [
    $ca68ed7c68019660$var$SET_QUEUE_KEY,
    $ca68ed7c68019660$var$SET_ONCE_QUEUE_KEY,
    $ca68ed7c68019660$var$UNSET_QUEUE_KEY,
    $ca68ed7c68019660$var$ADD_QUEUE_KEY,
    $ca68ed7c68019660$var$APPEND_QUEUE_KEY,
    $ca68ed7c68019660$var$REMOVE_QUEUE_KEY,
    $ca68ed7c68019660$var$UNION_QUEUE_KEY,
    $ca68ed7c68019660$var$PEOPLE_DISTINCT_ID_KEY,
    $ca68ed7c68019660$var$ALIAS_ID_KEY,
    $ca68ed7c68019660$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $ca68ed7c68019660$var$MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;
    if (config['persistence_name']) this.name = 'mp_' + config['persistence_name'];
    else this.name = 'mp_' + config['token'] + '_mixpanel';
    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        $ca68ed7c68019660$var$console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }
    if (storage_type === 'localStorage' && $ca68ed7c68019660$var$_.localStorage.is_supported()) this.storage = $ca68ed7c68019660$var$_.localStorage;
    else this.storage = $ca68ed7c68019660$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade();
    this.save();
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $ca68ed7c68019660$var$_.each(this['props'], function(v, k) {
        if (!$ca68ed7c68019660$var$_.include($ca68ed7c68019660$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this['props'] = $ca68ed7c68019660$var$_.extend({}, entry);
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.upgrade = function() {
    var old_cookie, old_localstorage;
    // if transferring from cookie to localStorage or vice-versa, copy existing
    // super properties over to new storage mode
    if (this.storage === $ca68ed7c68019660$var$_.localStorage) {
        old_cookie = $ca68ed7c68019660$var$_.cookie.parse(this.name);
        $ca68ed7c68019660$var$_.cookie.remove(this.name);
        $ca68ed7c68019660$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    } else if (this.storage === $ca68ed7c68019660$var$_.cookie) {
        old_localstorage = $ca68ed7c68019660$var$_.localStorage.parse(this.name);
        $ca68ed7c68019660$var$_.localStorage.remove(this.name);
        if (old_localstorage) this.register_once(old_localstorage);
    }
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $ca68ed7c68019660$var$_.JSONEncode(this['props']), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this['props'][key];
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$ca68ed7c68019660$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $ca68ed7c68019660$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($ca68ed7c68019660$var$_.isObject(props)) {
        if (typeof default_value === 'undefined') default_value = 'None';
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $ca68ed7c68019660$var$_.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) this['props'][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $ca68ed7c68019660$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($ca68ed7c68019660$var$_.isObject(props)) {
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $ca68ed7c68019660$var$_.extend(this['props'], props);
        this.save();
        return true;
    }
    return false;
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($ca68ed7c68019660$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$ca68ed7c68019660$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': $ca68ed7c68019660$var$_.info.referringDomain(referrer) || '$direct'
    }, '');
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $ca68ed7c68019660$var$_.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($ca68ed7c68019660$var$SET_ACTION), set_once_q = this._get_or_create_queue($ca68ed7c68019660$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($ca68ed7c68019660$var$UNSET_ACTION), add_q = this._get_or_create_queue($ca68ed7c68019660$var$ADD_ACTION), union_q = this._get_or_create_queue($ca68ed7c68019660$var$UNION_ACTION), remove_q = this._get_or_create_queue($ca68ed7c68019660$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($ca68ed7c68019660$var$APPEND_ACTION, []);
    if (q_key === $ca68ed7c68019660$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $ca68ed7c68019660$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($ca68ed7c68019660$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($ca68ed7c68019660$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($ca68ed7c68019660$var$UNSET_ACTION, q_data);
    } else if (q_key === $ca68ed7c68019660$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $ca68ed7c68019660$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($ca68ed7c68019660$var$UNSET_ACTION, q_data);
    } else if (q_key === $ca68ed7c68019660$var$UNSET_QUEUE_KEY) $ca68ed7c68019660$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $ca68ed7c68019660$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $ca68ed7c68019660$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $ca68ed7c68019660$var$ADD_QUEUE_KEY) {
        $ca68ed7c68019660$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($ca68ed7c68019660$var$UNSET_ACTION, q_data);
    } else if (q_key === $ca68ed7c68019660$var$UNION_QUEUE_KEY) {
        $ca68ed7c68019660$var$_.each(q_data, function(v, k) {
            if ($ca68ed7c68019660$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue($ca68ed7c68019660$var$UNSET_ACTION, q_data);
    } else if (q_key === $ca68ed7c68019660$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($ca68ed7c68019660$var$APPEND_ACTION, q_data);
    } else if (q_key === $ca68ed7c68019660$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($ca68ed7c68019660$var$UNSET_ACTION, q_data);
    }
    $ca68ed7c68019660$var$console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    $ca68ed7c68019660$var$console$1.log(data);
    this.save();
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this['props'][this._get_queue_key(queue)];
    if (!$ca68ed7c68019660$var$_.isUndefined(q)) $ca68ed7c68019660$var$_.each(data, function(v, k) {
        if (queue === $ca68ed7c68019660$var$APPEND_ACTION || queue === $ca68ed7c68019660$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $ca68ed7c68019660$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $ca68ed7c68019660$var$SET_ACTION) return $ca68ed7c68019660$var$SET_QUEUE_KEY;
    else if (queue === $ca68ed7c68019660$var$SET_ONCE_ACTION) return $ca68ed7c68019660$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $ca68ed7c68019660$var$UNSET_ACTION) return $ca68ed7c68019660$var$UNSET_QUEUE_KEY;
    else if (queue === $ca68ed7c68019660$var$ADD_ACTION) return $ca68ed7c68019660$var$ADD_QUEUE_KEY;
    else if (queue === $ca68ed7c68019660$var$APPEND_ACTION) return $ca68ed7c68019660$var$APPEND_QUEUE_KEY;
    else if (queue === $ca68ed7c68019660$var$REMOVE_ACTION) return $ca68ed7c68019660$var$REMOVE_QUEUE_KEY;
    else if (queue === $ca68ed7c68019660$var$UNION_ACTION) return $ca68ed7c68019660$var$UNION_QUEUE_KEY;
    else $ca68ed7c68019660$var$console$1.error('Invalid queue:', queue);
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $ca68ed7c68019660$var$_.isUndefined(default_val) ? {} : default_val;
    return this['props'][key] || (this['props'][key] = default_val);
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($ca68ed7c68019660$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this['props'][$ca68ed7c68019660$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$ca68ed7c68019660$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($ca68ed7c68019660$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$ca68ed7c68019660$var$_.isUndefined(timestamp)) {
        delete this['props'][$ca68ed7c68019660$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ // ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==
/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $ca68ed7c68019660$var$init_type; // MODULE or SNIPPET loader
// allow bundlers to specify how extra code (recorder bundle) should be loaded
// eslint-disable-next-line no-unused-vars
var $ca68ed7c68019660$var$load_extra_bundle = function(src, _onload) {
    throw new Error(src + ' not available in this build.');
};
var $ca68ed7c68019660$var$mixpanel_master; // main mixpanel instance / object
var $ca68ed7c68019660$var$INIT_MODULE = 0;
var $ca68ed7c68019660$var$INIT_SNIPPET = 1;
var $ca68ed7c68019660$var$IDENTITY_FUNC = function(x) {
    return x;
};
var $ca68ed7c68019660$var$NOOP_FUNC = function() {};
/** @const */ var $ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var $ca68ed7c68019660$var$PAYLOAD_TYPE_BASE64 = 'base64';
/** @const */ var $ca68ed7c68019660$var$PAYLOAD_TYPE_JSON = 'json';
/** @const */ var $ca68ed7c68019660$var$DEVICE_ID_PREFIX = '$device:';
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $ca68ed7c68019660$var$USE_XHR = $ca68ed7c68019660$var$win.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $ca68ed7c68019660$var$ENQUEUE_REQUESTS = !$ca68ed7c68019660$var$USE_XHR && $ca68ed7c68019660$var$userAgent.indexOf('MSIE') === -1 && $ca68ed7c68019660$var$userAgent.indexOf('Mozilla') === -1;
// save reference to navigator.sendBeacon so it can be minified
var $ca68ed7c68019660$var$sendBeacon = null;
if ($ca68ed7c68019660$var$navigator['sendBeacon']) $ca68ed7c68019660$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $ca68ed7c68019660$var$navigator['sendBeacon'].apply($ca68ed7c68019660$var$navigator, arguments);
};
var $ca68ed7c68019660$var$DEFAULT_API_ROUTES = {
    'track': 'track/',
    'engage': 'engage/',
    'groups': 'groups/',
    'record': 'record/'
};
/*
 * Module-level globals
 */ var $ca68ed7c68019660$var$DEFAULT_CONFIG = {
    'api_host': 'https://api-js.mixpanel.com',
    'api_routes': $ca68ed7c68019660$var$DEFAULT_API_ROUTES,
    'api_method': 'POST',
    'api_transport': 'XHR',
    'api_payload_format': $ca68ed7c68019660$var$PAYLOAD_TYPE_BASE64,
    'app_host': 'https://mixpanel.com',
    'cdn': 'https://cdn.mxpnl.com',
    'cross_site_cookie': false,
    'cross_subdomain_cookie': true,
    'error_reporter': $ca68ed7c68019660$var$NOOP_FUNC,
    'persistence': 'cookie',
    'persistence_name': '',
    'cookie_domain': '',
    'cookie_name': '',
    'loaded': $ca68ed7c68019660$var$NOOP_FUNC,
    'mp_loader': null,
    'track_marketing': true,
    'track_pageview': false,
    'skip_first_touch_marketing': false,
    'store_google': true,
    'stop_utm_persistence': false,
    'save_referrer': true,
    'test': false,
    'verbose': false,
    'img': false,
    'debug': false,
    'track_links_timeout': 300,
    'cookie_expiration': 365,
    'upgrade': false,
    'disable_persistence': false,
    'disable_cookie': false,
    'secure_cookie': false,
    'ip': true,
    'opt_out_tracking_by_default': false,
    'opt_out_persistence_by_default': false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix': null,
    'property_blacklist': [],
    'xhr_headers': {},
    'ignore_dnt': false,
    'batch_requests': true,
    'batch_size': 50,
    'batch_flush_interval_ms': 5000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true,
    'hooks': {},
    'record_block_class': new RegExp('^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$'),
    'record_block_selector': 'img, video',
    'record_collect_fonts': false,
    'record_idle_timeout_ms': 1800000,
    'record_inline_images': false,
    'record_mask_text_class': new RegExp('^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$'),
    'record_mask_text_selector': '*',
    'record_max_ms': $ca68ed7c68019660$var$MAX_RECORDING_MS,
    'record_min_ms': 0,
    'record_sessions_percent': 0,
    'recorder_src': 'https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js'
};
var $ca68ed7c68019660$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $ca68ed7c68019660$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $ca68ed7c68019660$var$create_mplib = function(token, config, name) {
    var instance, target = name === $ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME ? $ca68ed7c68019660$var$mixpanel_master : $ca68ed7c68019660$var$mixpanel_master[name];
    if (target && $ca68ed7c68019660$var$init_type === $ca68ed7c68019660$var$INIT_MODULE) instance = target;
    else {
        if (target && !$ca68ed7c68019660$var$_.isArray(target)) {
            $ca68ed7c68019660$var$console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new $ca68ed7c68019660$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance['people'] = new $ca68ed7c68019660$var$MixpanelPeople();
    instance['people']._init(instance);
    if (!instance.get_config('skip_first_touch_marketing')) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $ca68ed7c68019660$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $ca68ed7c68019660$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params['initial_' + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance['people'].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $ca68ed7c68019660$var$Config.DEBUG = $ca68ed7c68019660$var$Config.DEBUG || instance.get_config('debug');
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$ca68ed7c68019660$var$_.isUndefined(target) && $ca68ed7c68019660$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($ca68ed7c68019660$var$_.isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === $ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }
    var instance = $ca68ed7c68019660$var$create_mplib(token, config, name);
    $ca68ed7c68019660$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$ca68ed7c68019660$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this['__loaded'] = true;
    this['config'] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || $ca68ed7c68019660$var$DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com/)) variable_features['api_payload_format'] = $ca68ed7c68019660$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($ca68ed7c68019660$var$_.extend({}, $ca68ed7c68019660$var$DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': (name === $ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME ? name : $ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));
    this['_jsc'] = $ca68ed7c68019660$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!$ca68ed7c68019660$var$_.localStorage.is_supported(true) || !$ca68ed7c68019660$var$USE_XHR) {
            this._batch_requests = false;
            $ca68ed7c68019660$var$console$1.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
            $ca68ed7c68019660$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $ca68ed7c68019660$var$console$1.log('Clearing batch queue ' + batcher_config.queue_key);
                $ca68ed7c68019660$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($ca68ed7c68019660$var$sendBeacon && $ca68ed7c68019660$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $ca68ed7c68019660$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $ca68ed7c68019660$var$win.addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) flush_on_unload();
                });
                $ca68ed7c68019660$var$win.addEventListener('visibilitychange', function() {
                    if ($ca68ed7c68019660$var$document$1['visibilityState'] === 'hidden') flush_on_unload();
                });
            }
        }
    }
    this['persistence'] = this['cookie'] = new $ca68ed7c68019660$var$MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $ca68ed7c68019660$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        'distinct_id': $ca68ed7c68019660$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    var track_pageview_option = this.get_config('track_pageview');
    if (track_pageview_option) this._init_url_change_tracking(track_pageview_option);
    if (this.get_config('record_sessions_percent') > 0 && Math.random() * 100 <= this.get_config('record_sessions_percent')) this.start_session_recording();
};
$ca68ed7c68019660$var$MixpanelLib.prototype.start_session_recording = $ca68ed7c68019660$var$addOptOutCheckMixpanelLib(function() {
    if (!$ca68ed7c68019660$var$win['MutationObserver']) {
        $ca68ed7c68019660$var$console$1.critical('Browser does not support MutationObserver; skipping session recording');
        return;
    }
    var handleLoadedRecorder = $ca68ed7c68019660$var$_.bind(function() {
        this._recorder = this._recorder || new $ca68ed7c68019660$var$win['__mp_recorder'](this);
        this._recorder['startRecording']();
    }, this);
    if ($ca68ed7c68019660$var$_.isUndefined($ca68ed7c68019660$var$win['__mp_recorder'])) $ca68ed7c68019660$var$load_extra_bundle(this.get_config('recorder_src'), handleLoadedRecorder);
    else handleLoadedRecorder();
});
$ca68ed7c68019660$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) this._recorder['stopRecording']();
    else $ca68ed7c68019660$var$console$1.critical('Session recorder module not loaded');
};
$ca68ed7c68019660$var$MixpanelLib.prototype.get_session_recording_properties = function() {
    var props = {};
    if (this._recorder) {
        var replay_id = this._recorder['replayId'];
        if (replay_id) props['$mp_replay_id'] = replay_id;
    }
    return props;
};
// Private methods
$ca68ed7c68019660$var$MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
    this['people'].set_once(this['persistence'].get_referrer_info());
    // `store_google` is now deprecated and previously stored UTM parameters are cleared
    // from persistence by default.
    if (this.get_config('store_google') && this.get_config('stop_utm_persistence')) {
        var utm_params = $ca68ed7c68019660$var$_.info.campaignParams(null);
        $ca68ed7c68019660$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$ca68ed7c68019660$var$MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword($ca68ed7c68019660$var$document$1.referrer);
    // Registering super properties for UTM persistence by 'store_google' is deprecated.
    if (this.get_config('store_google') && !this.get_config('stop_utm_persistence')) this.register($ca68ed7c68019660$var$_.info.campaignParams());
    if (this.get_config('save_referrer')) this['persistence'].update_referrer_info($ca68ed7c68019660$var$document$1.referrer);
};
$ca68ed7c68019660$var$MixpanelLib.prototype._dom_loaded = function() {
    $ca68ed7c68019660$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $ca68ed7c68019660$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$ca68ed7c68019660$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }
    if (!$ca68ed7c68019660$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
$ca68ed7c68019660$var$MixpanelLib.prototype._init_url_change_tracking = function(track_pageview_option) {
    var previous_tracked_url = '';
    var tracked = this.track_pageview();
    if (tracked) previous_tracked_url = $ca68ed7c68019660$var$_.info.currentUrl();
    if ($ca68ed7c68019660$var$_.include([
        'full-url',
        'url-with-path-and-query-string',
        'url-with-path'
    ], track_pageview_option)) {
        $ca68ed7c68019660$var$win.addEventListener('popstate', function() {
            $ca68ed7c68019660$var$win.dispatchEvent(new Event('mp_locationchange'));
        });
        $ca68ed7c68019660$var$win.addEventListener('hashchange', function() {
            $ca68ed7c68019660$var$win.dispatchEvent(new Event('mp_locationchange'));
        });
        var nativePushState = $ca68ed7c68019660$var$win.history.pushState;
        if (typeof nativePushState === 'function') $ca68ed7c68019660$var$win.history.pushState = function(state, unused, url) {
            nativePushState.call($ca68ed7c68019660$var$win.history, state, unused, url);
            $ca68ed7c68019660$var$win.dispatchEvent(new Event('mp_locationchange'));
        };
        var nativeReplaceState = $ca68ed7c68019660$var$win.history.replaceState;
        if (typeof nativeReplaceState === 'function') $ca68ed7c68019660$var$win.history.replaceState = function(state, unused, url) {
            nativeReplaceState.call($ca68ed7c68019660$var$win.history, state, unused, url);
            $ca68ed7c68019660$var$win.dispatchEvent(new Event('mp_locationchange'));
        };
        $ca68ed7c68019660$var$win.addEventListener('mp_locationchange', (function() {
            var current_url = $ca68ed7c68019660$var$_.info.currentUrl();
            var should_track = false;
            if (track_pageview_option === 'full-url') should_track = current_url !== previous_tracked_url;
            else if (track_pageview_option === 'url-with-path-and-query-string') should_track = current_url.split('#')[0] !== previous_tracked_url.split('#')[0];
            else if (track_pageview_option === 'url-with-path') should_track = current_url.split('#')[0].split('?')[0] !== previous_tracked_url.split('#')[0].split('?')[0];
            if (should_track) {
                var tracked = this.track_pageview();
                if (tracked) previous_tracked_url = current_url;
            }
        }).bind(this));
    }
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($ca68ed7c68019660$var$_.isUndefined(callback)) return null;
    if ($ca68ed7c68019660$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$ca68ed7c68019660$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($ca68ed7c68019660$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;
    if (!callback && ($ca68ed7c68019660$var$_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = $ca68ed7c68019660$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$ca68ed7c68019660$var$USE_XHR) options.method = 'GET';
    var use_post = options.method === 'POST';
    var use_sendBeacon = $ca68ed7c68019660$var$sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) verbose_mode = true;
    if (this.get_config('test')) data['test'] = 1;
    if (verbose_mode) data['verbose'] = 1;
    if (this.get_config('img')) data['img'] = 1;
    if (!$ca68ed7c68019660$var$USE_XHR) {
        if (callback) data['callback'] = callback;
        else if (verbose_mode || this.get_config('test')) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data['callback'] = '(function(){})';
    }
    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();
    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }
    url += '?' + $ca68ed7c68019660$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ('img' in data) {
        var img = $ca68ed7c68019660$var$document$1.createElement('img');
        img.src = url;
        $ca68ed7c68019660$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $ca68ed7c68019660$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($ca68ed7c68019660$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config('xhr_headers');
        if (use_post) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        $ca68ed7c68019660$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== 'undefined') {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $ca68ed7c68019660$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = 'timeout';
                    else error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) {
                            var response_headers = req['responseHeaders'] || {};
                            callback({
                                status: 0,
                                httpStatusCode: req['status'],
                                error: error,
                                retryAfter: response_headers['Retry-After']
                            });
                        } else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $ca68ed7c68019660$var$document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $ca68ed7c68019660$var$document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $ca68ed7c68019660$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $ca68ed7c68019660$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($ca68ed7c68019660$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === 'function') item.call(this);
            else if ($ca68ed7c68019660$var$_.isArray(item) && fn_name === 'alias') alias_calls.push(item);
            else if ($ca68ed7c68019660$var$_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $ca68ed7c68019660$var$_.each(calls, function(item) {
            if ($ca68ed7c68019660$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $ca68ed7c68019660$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$ca68ed7c68019660$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$ca68ed7c68019660$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = '__mpq_' + this.get_config('token');
    var api_routes = this.get_config('api_routes');
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: 'events',
            endpoint: '/' + api_routes['track'],
            queue_key: queue_prefix + '_ev'
        },
        people: {
            type: 'people',
            endpoint: '/' + api_routes['engage'],
            queue_key: queue_prefix + '_pp'
        },
        groups: {
            type: 'groups',
            endpoint: '/' + api_routes['groups'],
            queue_key: queue_prefix + '_gr'
        }
    };
    return this._batcher_configs;
};
$ca68ed7c68019660$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $ca68ed7c68019660$var$_.bind(function(attrs) {
            return new $ca68ed7c68019660$var$RequestBatcher(attrs.queue_key, {
                libConfig: this['config'],
                errorReporter: this.get_config('error_reporter'),
                sendRequestFunc: $ca68ed7c68019660$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config('api_host') + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $ca68ed7c68019660$var$_.bind(function(item) {
                    return this._run_hook('before_send_' + attrs.type, item);
                }, this),
                stopAllBatchingFunc: $ca68ed7c68019660$var$_.bind(this.stop_batch_senders, this),
                usePersistence: true
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config('batch_autostart')) this.start_batch_senders();
};
$ca68ed7c68019660$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $ca68ed7c68019660$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$ca68ed7c68019660$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $ca68ed7c68019660$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === 'undefined') this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$ca68ed7c68019660$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $ca68ed7c68019660$var$_.JSONEncode(data);
    if (this.get_config('api_payload_format') === $ca68ed7c68019660$var$PAYLOAD_TYPE_BASE64) encoded_data = $ca68ed7c68019660$var$_.base64Encode(encoded_data);
    return {
        'data': encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$ca68ed7c68019660$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $ca68ed7c68019660$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $ca68ed7c68019660$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $ca68ed7c68019660$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        if (truncated_data) {
            $ca68ed7c68019660$var$console$1.log('MIXPANEL REQUEST:');
            $ca68ed7c68019660$var$console$1.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data, function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.track = $ca68ed7c68019660$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') callback = $ca68ed7c68019660$var$NOOP_FUNC;
    if ($ca68ed7c68019660$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $ca68ed7c68019660$var$_.extend({}, properties);
    properties['token'] = this.get_config('token');
    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!$ca68ed7c68019660$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config('track_marketing') ? $ca68ed7c68019660$var$_.info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $ca68ed7c68019660$var$_.extend({}, $ca68ed7c68019660$var$_.info.properties({
        'mp_loader': this.get_config('mp_loader')
    }), marketing_properties, this['persistence'].properties(), this.unpersisted_superprops, this.get_session_recording_properties(), properties);
    var property_blacklist = this.get_config('property_blacklist');
    if ($ca68ed7c68019660$var$_.isArray(property_blacklist)) $ca68ed7c68019660$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_config('api_host') + '/' + this.get_config('api_routes')['track'],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.set_group = $ca68ed7c68019660$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$ca68ed7c68019660$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.add_group = $ca68ed7c68019660$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this['people'].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.remove_group = $ca68ed7c68019660$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this['people'].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.track_with_groups = $ca68ed7c68019660$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $ca68ed7c68019660$var$_.extend({}, properties || {});
    $ca68ed7c68019660$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$ca68ed7c68019660$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};
$ca68ed7c68019660$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $ca68ed7c68019660$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.track_pageview = $ca68ed7c68019660$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== 'object') properties = {};
    options = options || {};
    var event_name = options['event_name'] || '$mp_web_page_view';
    var default_page_properties = $ca68ed7c68019660$var$_.extend($ca68ed7c68019660$var$_.info.mpPageViewProperties(), $ca68ed7c68019660$var$_.info.campaignParams(), $ca68ed7c68019660$var$_.info.clickParams());
    var event_properties = $ca68ed7c68019660$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $ca68ed7c68019660$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $ca68ed7c68019660$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($ca68ed7c68019660$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this['persistence'].set_event_timer(event_name, new Date().getTime());
};
var $ca68ed7c68019660$var$REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $ca68ed7c68019660$var$options_for_register = function(days_or_options) {
    var options;
    if ($ca68ed7c68019660$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$ca68ed7c68019660$var$_.isUndefined(days_or_options)) options = {
        'days': days_or_options
    };
    else options = {};
    return $ca68ed7c68019660$var$_.extend({}, $ca68ed7c68019660$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $ca68ed7c68019660$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register(props, options['days']);
    else $ca68ed7c68019660$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $ca68ed7c68019660$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register_once(props, default_value, options['days']);
    else {
        if (typeof default_value === 'undefined') default_value = 'None';
        $ca68ed7c68019660$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $ca68ed7c68019660$var$options_for_register(options);
    if (options['persistent']) this['persistence'].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$ca68ed7c68019660$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === 'string' && new_distinct_id.indexOf($ca68ed7c68019660$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error('distinct_id cannot have $device: prefix');
            return -1;
        }
        this.register({
            '$user_id': new_distinct_id
        });
    }
    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($ca68ed7c68019660$var$ALIAS_ID_KEY)) {
        this.unregister($ca68ed7c68019660$var$ALIAS_ID_KEY);
        this.register({
            'distinct_id': new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track('$identify', {
        'distinct_id': new_distinct_id,
        '$anon_distinct_id': previous_distinct_id
    }, {
        skip_hooks: true
    });
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = $ca68ed7c68019660$var$_.UUID();
    this.register_once({
        'distinct_id': $ca68ed7c68019660$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($ca68ed7c68019660$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }
    var _this = this;
    if ($ca68ed7c68019660$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($ca68ed7c68019660$var$ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.set_config = function(config) {
    if ($ca68ed7c68019660$var$_.isObject(config)) {
        $ca68ed7c68019660$var$_.extend(this['config'], config);
        var new_batch_size = config['batch_size'];
        if (new_batch_size) $ca68ed7c68019660$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config('persistence_name')) this['config']['persistence_name'] = this['config']['cookie_name'];
        if (!this.get_config('disable_persistence')) this['config']['disable_persistence'] = this['config']['disable_cookie'];
        if (this['persistence']) this['persistence'].update_config(this['config']);
        $ca68ed7c68019660$var$Config.DEBUG = $ca68ed7c68019660$var$Config.DEBUG || this.get_config('debug');
    }
};
/**
 * returns the current config object for the library.
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $ca68ed7c68019660$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || $ca68ed7c68019660$var$IDENTITY_FUNC).apply(this, $ca68ed7c68019660$var$slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence'].load_prop([
        property_name
    ]);
};
$ca68ed7c68019660$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== $ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME) name = $ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME + '.' + name;
    return name;
};
$ca68ed7c68019660$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $ca68ed7c68019660$var$_.isBlockedUA($ca68ed7c68019660$var$userAgent) || this._flags.disable_all_events || $ca68ed7c68019660$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$ca68ed7c68019660$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $ca68ed7c68019660$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            'persistence_type': 'cookie'
        })) this.opt_in_tracking({
            'enable_persistence': false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            'persistence_type': 'cookie'
        })) this.opt_out_tracking({
            'clear_persistence': false
        });
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        'clear_persistence': true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config('opt_out_tracking_by_default') || $ca68ed7c68019660$var$_.cookie.get('mp_optout'))) {
        $ca68ed7c68019660$var$_.cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $ca68ed7c68019660$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) disabled = true;
    else if (options && options['enable_persistence']) disabled = false;
    else return;
    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) this['persistence'].set_disabled(disabled);
    if (disabled) this.stop_batch_senders();
    else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$ca68ed7c68019660$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $ca68ed7c68019660$var$_.extend({
        'track': $ca68ed7c68019660$var$_.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$ca68ed7c68019660$var$_.localStorage.is_supported()) options['persistence_type'] = 'cookie';
    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $ca68ed7c68019660$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($ca68ed7c68019660$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $ca68ed7c68019660$var$_.extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }
    this._gdpr_call_func($ca68ed7c68019660$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($ca68ed7c68019660$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($ca68ed7c68019660$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $ca68ed7c68019660$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $ca68ed7c68019660$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($ca68ed7c68019660$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$ca68ed7c68019660$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $ca68ed7c68019660$var$console$1.error.apply($ca68ed7c68019660$var$console$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config('error_reporter')(msg, err);
    } catch (err) {
        $ca68ed7c68019660$var$console$1.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$ca68ed7c68019660$var$MixpanelLib.prototype['init'] = $ca68ed7c68019660$var$MixpanelLib.prototype.init;
$ca68ed7c68019660$var$MixpanelLib.prototype['reset'] = $ca68ed7c68019660$var$MixpanelLib.prototype.reset;
$ca68ed7c68019660$var$MixpanelLib.prototype['disable'] = $ca68ed7c68019660$var$MixpanelLib.prototype.disable;
$ca68ed7c68019660$var$MixpanelLib.prototype['time_event'] = $ca68ed7c68019660$var$MixpanelLib.prototype.time_event;
$ca68ed7c68019660$var$MixpanelLib.prototype['track'] = $ca68ed7c68019660$var$MixpanelLib.prototype.track;
$ca68ed7c68019660$var$MixpanelLib.prototype['track_links'] = $ca68ed7c68019660$var$MixpanelLib.prototype.track_links;
$ca68ed7c68019660$var$MixpanelLib.prototype['track_forms'] = $ca68ed7c68019660$var$MixpanelLib.prototype.track_forms;
$ca68ed7c68019660$var$MixpanelLib.prototype['track_pageview'] = $ca68ed7c68019660$var$MixpanelLib.prototype.track_pageview;
$ca68ed7c68019660$var$MixpanelLib.prototype['register'] = $ca68ed7c68019660$var$MixpanelLib.prototype.register;
$ca68ed7c68019660$var$MixpanelLib.prototype['register_once'] = $ca68ed7c68019660$var$MixpanelLib.prototype.register_once;
$ca68ed7c68019660$var$MixpanelLib.prototype['unregister'] = $ca68ed7c68019660$var$MixpanelLib.prototype.unregister;
$ca68ed7c68019660$var$MixpanelLib.prototype['identify'] = $ca68ed7c68019660$var$MixpanelLib.prototype.identify;
$ca68ed7c68019660$var$MixpanelLib.prototype['alias'] = $ca68ed7c68019660$var$MixpanelLib.prototype.alias;
$ca68ed7c68019660$var$MixpanelLib.prototype['name_tag'] = $ca68ed7c68019660$var$MixpanelLib.prototype.name_tag;
$ca68ed7c68019660$var$MixpanelLib.prototype['set_config'] = $ca68ed7c68019660$var$MixpanelLib.prototype.set_config;
$ca68ed7c68019660$var$MixpanelLib.prototype['get_config'] = $ca68ed7c68019660$var$MixpanelLib.prototype.get_config;
$ca68ed7c68019660$var$MixpanelLib.prototype['get_property'] = $ca68ed7c68019660$var$MixpanelLib.prototype.get_property;
$ca68ed7c68019660$var$MixpanelLib.prototype['get_distinct_id'] = $ca68ed7c68019660$var$MixpanelLib.prototype.get_distinct_id;
$ca68ed7c68019660$var$MixpanelLib.prototype['toString'] = $ca68ed7c68019660$var$MixpanelLib.prototype.toString;
$ca68ed7c68019660$var$MixpanelLib.prototype['opt_out_tracking'] = $ca68ed7c68019660$var$MixpanelLib.prototype.opt_out_tracking;
$ca68ed7c68019660$var$MixpanelLib.prototype['opt_in_tracking'] = $ca68ed7c68019660$var$MixpanelLib.prototype.opt_in_tracking;
$ca68ed7c68019660$var$MixpanelLib.prototype['has_opted_out_tracking'] = $ca68ed7c68019660$var$MixpanelLib.prototype.has_opted_out_tracking;
$ca68ed7c68019660$var$MixpanelLib.prototype['has_opted_in_tracking'] = $ca68ed7c68019660$var$MixpanelLib.prototype.has_opted_in_tracking;
$ca68ed7c68019660$var$MixpanelLib.prototype['clear_opt_in_out_tracking'] = $ca68ed7c68019660$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$ca68ed7c68019660$var$MixpanelLib.prototype['get_group'] = $ca68ed7c68019660$var$MixpanelLib.prototype.get_group;
$ca68ed7c68019660$var$MixpanelLib.prototype['set_group'] = $ca68ed7c68019660$var$MixpanelLib.prototype.set_group;
$ca68ed7c68019660$var$MixpanelLib.prototype['add_group'] = $ca68ed7c68019660$var$MixpanelLib.prototype.add_group;
$ca68ed7c68019660$var$MixpanelLib.prototype['remove_group'] = $ca68ed7c68019660$var$MixpanelLib.prototype.remove_group;
$ca68ed7c68019660$var$MixpanelLib.prototype['track_with_groups'] = $ca68ed7c68019660$var$MixpanelLib.prototype.track_with_groups;
$ca68ed7c68019660$var$MixpanelLib.prototype['start_batch_senders'] = $ca68ed7c68019660$var$MixpanelLib.prototype.start_batch_senders;
$ca68ed7c68019660$var$MixpanelLib.prototype['stop_batch_senders'] = $ca68ed7c68019660$var$MixpanelLib.prototype.stop_batch_senders;
$ca68ed7c68019660$var$MixpanelLib.prototype['start_session_recording'] = $ca68ed7c68019660$var$MixpanelLib.prototype.start_session_recording;
$ca68ed7c68019660$var$MixpanelLib.prototype['stop_session_recording'] = $ca68ed7c68019660$var$MixpanelLib.prototype.stop_session_recording;
$ca68ed7c68019660$var$MixpanelLib.prototype['get_session_recording_properties'] = $ca68ed7c68019660$var$MixpanelLib.prototype.get_session_recording_properties;
$ca68ed7c68019660$var$MixpanelLib.prototype['DEFAULT_API_ROUTES'] = $ca68ed7c68019660$var$DEFAULT_API_ROUTES;
// MixpanelPersistence Exports
$ca68ed7c68019660$var$MixpanelPersistence.prototype['properties'] = $ca68ed7c68019660$var$MixpanelPersistence.prototype.properties;
$ca68ed7c68019660$var$MixpanelPersistence.prototype['update_search_keyword'] = $ca68ed7c68019660$var$MixpanelPersistence.prototype.update_search_keyword;
$ca68ed7c68019660$var$MixpanelPersistence.prototype['update_referrer_info'] = $ca68ed7c68019660$var$MixpanelPersistence.prototype.update_referrer_info;
$ca68ed7c68019660$var$MixpanelPersistence.prototype['get_cross_subdomain'] = $ca68ed7c68019660$var$MixpanelPersistence.prototype.get_cross_subdomain;
$ca68ed7c68019660$var$MixpanelPersistence.prototype['clear'] = $ca68ed7c68019660$var$MixpanelPersistence.prototype.clear;
var $ca68ed7c68019660$var$instances = {};
var $ca68ed7c68019660$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $ca68ed7c68019660$var$_.each($ca68ed7c68019660$var$instances, function(instance, name) {
        if (name !== $ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME) $ca68ed7c68019660$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $ca68ed7c68019660$var$mixpanel_master['_'] = $ca68ed7c68019660$var$_;
};
var $ca68ed7c68019660$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $ca68ed7c68019660$var$mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$ca68ed7c68019660$var$mixpanel_master[name]) {
                $ca68ed7c68019660$var$mixpanel_master[name] = $ca68ed7c68019660$var$instances[name] = $ca68ed7c68019660$var$create_mplib(token, config, name);
                $ca68ed7c68019660$var$mixpanel_master[name]._loaded();
            }
            return $ca68ed7c68019660$var$mixpanel_master[name];
        } else {
            var instance = $ca68ed7c68019660$var$mixpanel_master;
            if ($ca68ed7c68019660$var$instances[$ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $ca68ed7c68019660$var$instances[$ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $ca68ed7c68019660$var$create_mplib(token, config, $ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $ca68ed7c68019660$var$instances[$ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $ca68ed7c68019660$var$mixpanel_master = instance;
            if ($ca68ed7c68019660$var$init_type === $ca68ed7c68019660$var$INIT_SNIPPET) $ca68ed7c68019660$var$win[$ca68ed7c68019660$var$PRIMARY_INSTANCE_NAME] = $ca68ed7c68019660$var$mixpanel_master;
            $ca68ed7c68019660$var$extend_mp();
        }
    };
};
var $ca68ed7c68019660$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $ca68ed7c68019660$var$DOM_LOADED = true;
        $ca68ed7c68019660$var$ENQUEUE_REQUESTS = false;
        $ca68ed7c68019660$var$_.each($ca68ed7c68019660$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $ca68ed7c68019660$var$document$1.documentElement.doScroll('left');
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($ca68ed7c68019660$var$document$1.addEventListener) {
        if ($ca68ed7c68019660$var$document$1.readyState === 'complete') // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $ca68ed7c68019660$var$document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
    } else if ($ca68ed7c68019660$var$document$1.attachEvent) {
        // IE
        $ca68ed7c68019660$var$document$1.attachEvent('onreadystatechange', dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $ca68ed7c68019660$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($ca68ed7c68019660$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $ca68ed7c68019660$var$_.register_event($ca68ed7c68019660$var$win, 'load', dom_loaded_handler, true);
};
function $ca68ed7c68019660$var$init_as_module(bundle_loader) {
    $ca68ed7c68019660$var$load_extra_bundle = bundle_loader;
    $ca68ed7c68019660$var$init_type = $ca68ed7c68019660$var$INIT_MODULE;
    $ca68ed7c68019660$var$mixpanel_master = new $ca68ed7c68019660$var$MixpanelLib();
    $ca68ed7c68019660$var$override_mp_init_func();
    $ca68ed7c68019660$var$mixpanel_master['init']();
    $ca68ed7c68019660$var$add_dom_loaded_handler();
    return $ca68ed7c68019660$var$mixpanel_master;
}
// For loading separate bundles asynchronously via script tag
// For builds that have everything in one bundle, no extra work.
function $ca68ed7c68019660$var$loadNoop(_src, onload) {
    onload();
}
/* eslint camelcase: "off" */ var $ca68ed7c68019660$export$2e2bcd8739ae039 = $ca68ed7c68019660$var$init_as_module($ca68ed7c68019660$var$loadNoop);


const $fe246feeaa6a5f9e$var$eventTrackEnabled = true;
function $fe246feeaa6a5f9e$export$2a47f398eeff8b01() {
    if ($fe246feeaa6a5f9e$var$eventTrackEnabled) {
        (0, $ca68ed7c68019660$export$2e2bcd8739ae039).init("189c341fae2fdb8663be2ce30d46c318", {
            debug: false,
            api_host: "https://pt.epi3.co",
            track_pageview: true
        });
        (0, $ca68ed7c68019660$export$2e2bcd8739ae039).set_config({
            'persistence': 'localStorage'
        });
    // mixpanel.identify('sytabaresa@gmail.com')
    // mixpanel.track('Signed Up', {
    //     'Signup Type': 'Referral'
    // })
    }
}
function $fe246feeaa6a5f9e$export$6503ec6e8aabbaf(meta) {
    if (!$fe246feeaa6a5f9e$var$eventTrackEnabled) return;
    const { id: id, ...rest } = meta || {};
    if (id) {
        (0, $ca68ed7c68019660$export$2e2bcd8739ae039).identify(meta.id);
        (0, $ca68ed7c68019660$export$2e2bcd8739ae039).people.set({
            ...rest
        });
    } else (0, $ca68ed7c68019660$export$2e2bcd8739ae039).register({
        ...rest
    });
}
function $fe246feeaa6a5f9e$export$b4570ea00533c3e5(meta) {
    if (!$fe246feeaa6a5f9e$var$eventTrackEnabled) return;
    (0, $ca68ed7c68019660$export$2e2bcd8739ae039).reset();
}
function $fe246feeaa6a5f9e$export$6b2a7d5132615086(eventName, props = null, ops = null, ...rest) {
    if (!$fe246feeaa6a5f9e$var$eventTrackEnabled) return;
    if (eventName == 'page') (0, $ca68ed7c68019660$export$2e2bcd8739ae039).track_pageview(props);
    if (eventName == 'links') {
        const { selector: selector, event: event, ...rest } = props || {};
        (0, $ca68ed7c68019660$export$2e2bcd8739ae039).track_links(selector, event, rest);
    }
    (0, $ca68ed7c68019660$export$2e2bcd8739ae039).track(eventName, props, ops, ...rest);
}
function $fe246feeaa6a5f9e$export$2d25b96730aee9e3(eventName) {
    if (!$fe246feeaa6a5f9e$var$eventTrackEnabled) return;
    (0, $ca68ed7c68019660$export$2e2bcd8739ae039).time_event(eventName);
} // export function trackLink(e) {
 //     // console.log(e)
 //     // track('page', { page: e.target.href })
 // }


const $fd950d5ed1ac77bd$var$GridCell = ({ className: className, tileData: tile, draggable: draggable, tilePath: tilePath, showModal: showModal, children: children, ...rest }, ref)=>{
    // console.log(rest)
    const [lang] = (0, $c95f922ce4854eac$export$b24a004ee43dce44)();
    const [screenName, setScreenName] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$98ba80ce6e840e63));
    const setInput = (0, $0b20ce121ee1acb3$exports.useSetAtom)((0, $b78da6c1f1424617$export$48639037ba826bfa));
    const setPath = (0, $0b20ce121ee1acb3$exports.useSetAtom)((0, $b78da6c1f1424617$export$b86f17b235e54c14));
    const [grid, setGrid] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$fdb89ca8367d940b));
    const titleRef = (0, $6F3kv.useRef)();
    const color = (0, $bbf84cf9ec8e5154$export$5551a2d24ff40153)(tile.color, true);
    const textColor = (0, $bbf84cf9ec8e5154$export$9b96bc9b681eb5fc)(color);
    const text = (0, $96596b87b46525f2$export$c72d34660a162238)(tile, lang);
    // console.log(tile.color, color, textColor)
    const mainAction = (e)=>{
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('tile click', {
            id: tile.id,
            screen: screenName
        });
        if (tile.link && tile.link != '') {
            if ((0, $c64a745d34615282$export$fc99885b7e473d08)(tile.link)) {
                (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('open external link', {
                    tileId: tile.id,
                    link: tile.link
                });
                window.open(tile.link, '_blank');
            } else {
                let [screen, index] = (0, $bdcc94fa677df125$export$37adcc2e6440d8b3)(grid, tile.link);
                if (!screen) {
                    // console.log('new screen:', tileData.link)
                    screen = (0, $bdcc94fa677df125$export$afaccf786266e410)(tile.link);
                    setGrid(grid.concat(screen));
                    (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('create screen', {
                        id: screen.id,
                        tileId: tile.id,
                        screen: screenName
                    });
                }
                setScreenName(tile.link);
                (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('go to screen', {
                    tileId: tile.id,
                    screen: screenName
                });
            }
        } else {
            const [screen] = (0, $bdcc94fa677df125$export$37adcc2e6440d8b3)(grid, screenName);
            setInput({
                ...tile,
                speakOptions: {
                    ...screen.speakOptions,
                    ...tile.speakOptions
                }
            });
            (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('tile add text', {
                tileId: tile.id,
                screen: screenName
            });
        }
    };
    const showSettings = ()=>{
        showModal();
        setPath(tilePath);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('show settings', {
            id: tile.id,
            screen: screenName
        });
    };
    const height = parseInt(rest.style.height?.split('px')[0]);
    const width = parseInt(rest.style.width?.split('px')[0]);
    const withImage = tile.imgUrl && tile.imgUrl != '';
    const padding = 8;
    (0, $6F3kv.useEffect)(()=>{
        // console.log(width, titleRef.current.clientWidth)
        titleRef.current.style.fontSize = Math.min((0, $797beb6b1327aa54$export$7d055c252aebca58)(titleRef.current.clientWidth, withImage ? .6 : .5), height - 2 * padding) + 'px';
    }, [
        width
    ]);
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        ref: ref,
        // style={{ ...style, }}
        className: `relative ${className || ''}`,
        ...rest,
        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
            className: `relative grid items-stretch btn !animate-none justify-center p-2 w-full h-full 
            group active:border-2 hover:border-2 focus:border-2 shadow-md
            ${draggable ? 'border-dashed' : ''}`,
            style: {
                backgroundColor: color,
                color: textColor,
                borderColor: textColor,
                gridTemplateColumns: `repeat(auto-fit, minmax(${Math.min(width, height) - 2 * padding + 'px'}, 1fr))`,
                gridTemplateRows: 'auto fit-content(25%)'
            },
            "alt-label": text,
            ...!draggable && {
                onclick: mainAction
            },
            children: [
                tile.link && tile.link != '' && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                    onMouseDown: mainAction,
                    onTouchStart: mainAction,
                    className: "absolute top-0 right-0 pr-1 pt-1 z-10",
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $1fc9ed6f4f940333$export$2e2bcd8739ae039), {
                        className: "w-4"
                    })
                }),
                draggable && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                    onMouseDown: showSettings,
                    onTouchStart: showSettings,
                    className: "absolute top-0 left-0 pl-1 pt-1 z-10",
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $c32dc85ecaf3a43a$export$2e2bcd8739ae039), {
                        className: "w-4"
                    })
                }),
                draggable && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9Oehh.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $8d09aba4ba935ead$export$2e2bcd8739ae039), {
                            className: "group-hover:block group-active:block hidden opacity-50 absolute bottom-0 h-4 w-full"
                        }),
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $599145164995687d$export$2e2bcd8739ae039), {
                            className: "group-hover:block group-active:block hidden opacity-50 absolute top-0 h-4 w-full"
                        }),
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $cee2bf0ee385e854$export$2e2bcd8739ae039), {
                            className: "group-hover:block group-active:block hidden opacity-50 absolute left-0 w-4 h-full"
                        }),
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $81b1e29fe1b38da5$export$2e2bcd8739ae039), {
                            className: "group-hover:block group-active:block hidden opacity-50 absolute right-0 w-4 h-full"
                        })
                    ]
                }),
                draggable && children,
                tile.imgUrl && tile.imgUrl != '' ? /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9Oehh.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                            className: "p-2 bg-contain bg-no-repeat bg-center",
                            style: {
                                backgroundImage: `url(${tile.imgUrl})`
                            }
                        }),
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                            className: "pt-2 max-w-full flex items-center",
                            children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h2", {
                                ref: titleRef,
                                className: "uppercase break-words leading-none flex-1 w-full",
                                htmlFor: 'img-' + tile.text,
                                children: text
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                    className: "p-0 flex items-center",
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h2", {
                        ref: titleRef,
                        className: "uppercase break-words leading-none flex-1 w-full",
                        children: text
                    })
                })
            ]
        })
    });
};
var $fd950d5ed1ac77bd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8Zslt.forwardRef)($fd950d5ed1ac77bd$var$GridCell);





var $9Oehh = parcelRequire("9Oehh");
parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");

const $d4aeae9fbbd7cd04$var$createModal = (modalName, defaultValue = false)=>{
    const finalModalName = !modalName || modalName == '' ? `modal-${Math.random().toString().slice(-5)}` : modalName;
    const closeRef = (0, $6F3kv.useRef)();
    const triggerRef = (0, $6F3kv.useRef)();
    const modalRef = (0, $6F3kv.useRef)();
    const modalStateRef = (0, $6F3kv.useRef)();
    const labelProps = {
        tabIndex: 0,
        onKeyPress: (e)=>{
            e.stopPropagation();
            if (e.key == "Enter") e.target.click();
        }
    };
    function onKey(ev) {
        // console.log(ev)
        // if escape pressed
        if (ev.which == 27) {
            closeRef.current.click();
            return;
        }
        // if tab or shift-tab pressed
        if (ev.which == 9) {
            // get list of all children elements in given object
            const focusableItems = [
                ...modalRef.current.querySelectorAll('*')
            ];
            // console.log(focusableItems)
            // get currently focused item
            const focusedItem = document.activeElement;
            // get the index of the currently focused item
            const focusedItemIndex = focusableItems.indexOf(focusedItem);
            // console.log(focusedItemIndex)
            if (ev.shiftKey) //back tab
            // if focused on first item and user preses back-tab, go to the last focusable item
            {
                if (focusedItemIndex == 0) {
                    focusableItems[focusableItems.length - 1].focus();
                    ev.preventDefault();
                }
            } else //forward tab
            // if focused on the last item and user preses tab, go to the first focusable item
            if (focusedItemIndex >= focusableItems.length - 1) {
                focusableItems[0].focus();
                ev.preventDefault();
            }
            return;
        }
    }
    function onClose(ev) {
        triggerRef.current.focus();
    }
    const Label = (props)=>{
        return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
            ...labelProps,
            ref: triggerRef,
            htmlFor: finalModalName,
            onClick: (e)=>{
                setTimeout(()=>closeRef.current.focus(), 500);
            },
            ...props
        });
    };
    const modalState = modalStateRef.current?.checked;
    // const showModal = (state: boolean) => {
    //   if (modalStateRef.current) {
    //     console.log(modalStateRef, state)
    //     modalStateRef.current.value = !!state
    //   }
    // }
    const Modal = ({ modalChild: modalChild, children: children, withClose: withClose = true, className: className, onChange: onChange, ...rest })=>{
        const { LL: LL } = (0, $dc3317580ce734b5$export$22f0ca4c21b6ff4)();
        const [_defModal, showModal] = (0, $6F3kv.useState)(defaultValue);
        const out = /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9Oehh.Fragment), {
            children: [
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                    type: "checkbox",
                    id: finalModalName,
                    ref: modalStateRef,
                    defaultChecked: _defModal,
                    onChange: onChange,
                    className: "modal-toggle hidden"
                }),
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                    htmlFor: finalModalName,
                    className: `modal cursor-pointer`,
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                        htmlFor: "",
                        ref: modalRef,
                        tabIndex: 0,
                        onKeyDown: onKey,
                        className: `modal-box scrollbar-thin scrollbar-thumb-base-content scrollbar-base-100 ${className || ''}`,
                        ...rest,
                        children: [
                            withClose && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                ...labelProps,
                                ref: closeRef,
                                htmlFor: finalModalName,
                                onClick: onClose,
                                className: "btn btn-sm btn-ghost absolute right-2 top-2",
                                "aria-label": LL.common.close(),
                                children: "\u2715"
                            }),
                            typeof children == 'function' ? children({
                                modalState: modalState,
                                showModal: showModal,
                                label: finalModalName
                            }) : children
                        ]
                    })
                })
            ]
        });
        if (typeof document == 'undefined') return out;
        return out //createPortal(out, document?.body)
        ;
    };
    const showModal = ()=>{
        triggerRef.current.click();
    };
    return {
        Modal: Modal,
        Label: Label,
        modalState: modalState,
        showModal: showModal,
        label: finalModalName
    };
};
var $d4aeae9fbbd7cd04$export$2e2bcd8739ae039 = $d4aeae9fbbd7cd04$var$createModal;



var $9Oehh = parcelRequire("9Oehh");

parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");






var $7hzE7 = parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");
function $0d2190c43ce9bee2$var$u() {
    return ($0d2190c43ce9bee2$var$u = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }).apply(this, arguments);
}
function $0d2190c43ce9bee2$var$c(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)r.indexOf(t = a[n]) >= 0 || (o[t] = e[t]);
    return o;
}
function $0d2190c43ce9bee2$var$i(e) {
    var t = (0, $6F3kv.useRef)(e), n = (0, $6F3kv.useRef)(function(e) {
        t.current && t.current(e);
    });
    return t.current = e, n.current;
}
var $0d2190c43ce9bee2$var$s = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = 1), e > t ? t : e < r ? r : e;
}, $0d2190c43ce9bee2$var$f = function(e) {
    return "touches" in e;
}, $0d2190c43ce9bee2$var$v = function(e) {
    return e && e.ownerDocument.defaultView || self;
}, $0d2190c43ce9bee2$var$d = function(e, r, t) {
    var n = e.getBoundingClientRect(), o = $0d2190c43ce9bee2$var$f(r) ? function(e, r) {
        for(var t = 0; t < e.length; t++)if (e[t].identifier === r) return e[t];
        return e[0];
    }(r.touches, t) : r;
    return {
        left: $0d2190c43ce9bee2$var$s((o.pageX - (n.left + $0d2190c43ce9bee2$var$v(e).pageXOffset)) / n.width),
        top: $0d2190c43ce9bee2$var$s((o.pageY - (n.top + $0d2190c43ce9bee2$var$v(e).pageYOffset)) / n.height)
    };
}, $0d2190c43ce9bee2$var$h = function(e) {
    !$0d2190c43ce9bee2$var$f(e) && e.preventDefault();
}, $0d2190c43ce9bee2$var$m = (0, $7hzE7.default).memo(function(o) {
    var a = o.onMove, l = o.onKey, s = $0d2190c43ce9bee2$var$c(o, [
        "onMove",
        "onKey"
    ]), m = (0, $6F3kv.useRef)(null), g = $0d2190c43ce9bee2$var$i(a), p = $0d2190c43ce9bee2$var$i(l), b = (0, $6F3kv.useRef)(null), _ = (0, $6F3kv.useRef)(!1), x = (0, $6F3kv.useMemo)(function() {
        var e = function(e) {
            $0d2190c43ce9bee2$var$h(e), ($0d2190c43ce9bee2$var$f(e) ? e.touches.length > 0 : e.buttons > 0) && m.current ? g($0d2190c43ce9bee2$var$d(m.current, e, b.current)) : t(!1);
        }, r = function() {
            return t(!1);
        };
        function t(t) {
            var n = _.current, o = $0d2190c43ce9bee2$var$v(m.current), a = t ? o.addEventListener : o.removeEventListener;
            a(n ? "touchmove" : "mousemove", e), a(n ? "touchend" : "mouseup", r);
        }
        return [
            function(e) {
                var r = e.nativeEvent, n = m.current;
                if (n && ($0d2190c43ce9bee2$var$h(r), !function(e, r) {
                    return r && !$0d2190c43ce9bee2$var$f(e);
                }(r, _.current) && n)) {
                    if ($0d2190c43ce9bee2$var$f(r)) {
                        _.current = !0;
                        var o = r.changedTouches || [];
                        o.length && (b.current = o[0].identifier);
                    }
                    n.focus(), g($0d2190c43ce9bee2$var$d(n, r, b.current)), t(!0);
                }
            },
            function(e) {
                var r = e.which || e.keyCode;
                r < 37 || r > 40 || (e.preventDefault(), p({
                    left: 39 === r ? .05 : 37 === r ? -0.05 : 0,
                    top: 40 === r ? .05 : 38 === r ? -0.05 : 0
                }));
            },
            t
        ];
    }, [
        p,
        g
    ]), C = x[0], E = x[1], H = x[2];
    return (0, $6F3kv.useEffect)(function() {
        return H;
    }, [
        H
    ]), (0, $7hzE7.default).createElement("div", $0d2190c43ce9bee2$var$u({}, s, {
        onTouchStart: C,
        onMouseDown: C,
        className: "react-colorful__interactive",
        ref: m,
        onKeyDown: E,
        tabIndex: 0,
        role: "slider"
    }));
}), $0d2190c43ce9bee2$var$g = function(e) {
    return e.filter(Boolean).join(" ");
}, $0d2190c43ce9bee2$var$p = function(r) {
    var t = r.color, n = r.left, o = r.top, a = void 0 === o ? .5 : o, l = $0d2190c43ce9bee2$var$g([
        "react-colorful__pointer",
        r.className
    ]);
    return (0, $7hzE7.default).createElement("div", {
        className: l,
        style: {
            top: 100 * a + "%",
            left: 100 * n + "%"
        }
    }, (0, $7hzE7.default).createElement("div", {
        className: "react-colorful__pointer-fill",
        style: {
            backgroundColor: t
        }
    }));
}, $0d2190c43ce9bee2$var$b = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = Math.pow(10, r)), Math.round(t * e) / t;
}, $0d2190c43ce9bee2$var$_ = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $0d2190c43ce9bee2$var$x = function(e) {
    return $0d2190c43ce9bee2$var$L($0d2190c43ce9bee2$var$C(e));
}, $0d2190c43ce9bee2$var$C = function(e) {
    return "#" === e[0] && (e = e.substring(1)), e.length < 6 ? {
        r: parseInt(e[0] + e[0], 16),
        g: parseInt(e[1] + e[1], 16),
        b: parseInt(e[2] + e[2], 16),
        a: 4 === e.length ? $0d2190c43ce9bee2$var$b(parseInt(e[3] + e[3], 16) / 255, 2) : 1
    } : {
        r: parseInt(e.substring(0, 2), 16),
        g: parseInt(e.substring(2, 4), 16),
        b: parseInt(e.substring(4, 6), 16),
        a: 8 === e.length ? $0d2190c43ce9bee2$var$b(parseInt(e.substring(6, 8), 16) / 255, 2) : 1
    };
}, $0d2190c43ce9bee2$var$E = function(e, r) {
    return void 0 === r && (r = "deg"), Number(e) * ($0d2190c43ce9bee2$var$_[r] || 1);
}, $0d2190c43ce9bee2$var$H = function(e) {
    var r = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $0d2190c43ce9bee2$var$N({
        h: $0d2190c43ce9bee2$var$E(r[1], r[2]),
        s: Number(r[3]),
        l: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $0d2190c43ce9bee2$var$M = $0d2190c43ce9bee2$var$H, $0d2190c43ce9bee2$var$N = function(e) {
    var r = e.s, t = e.l;
    return {
        h: e.h,
        s: (r *= (t < 50 ? t : 100 - t) / 100) > 0 ? 2 * r / (t + r) * 100 : 0,
        v: t + r,
        a: e.a
    };
}, $0d2190c43ce9bee2$var$w = function(e) {
    return $0d2190c43ce9bee2$var$K($0d2190c43ce9bee2$var$I(e));
}, $0d2190c43ce9bee2$var$y = function(e) {
    var r = e.s, t = e.v, n = e.a, o = (200 - r) * t / 100;
    return {
        h: $0d2190c43ce9bee2$var$b(e.h),
        s: $0d2190c43ce9bee2$var$b(o > 0 && o < 200 ? r * t / 100 / (o <= 100 ? o : 200 - o) * 100 : 0),
        l: $0d2190c43ce9bee2$var$b(o / 2),
        a: $0d2190c43ce9bee2$var$b(n, 2)
    };
}, $0d2190c43ce9bee2$var$q = function(e) {
    var r = $0d2190c43ce9bee2$var$y(e);
    return "hsl(" + r.h + ", " + r.s + "%, " + r.l + "%)";
}, $0d2190c43ce9bee2$var$k = function(e) {
    var r = $0d2190c43ce9bee2$var$y(e);
    return "hsla(" + r.h + ", " + r.s + "%, " + r.l + "%, " + r.a + ")";
}, $0d2190c43ce9bee2$var$I = function(e) {
    var r = e.h, t = e.s, n = e.v, o = e.a;
    r = r / 360 * 6, t /= 100, n /= 100;
    var a = Math.floor(r), l = n * (1 - t), u = n * (1 - (r - a) * t), c = n * (1 - (1 - r + a) * t), i = a % 6;
    return {
        r: $0d2190c43ce9bee2$var$b(255 * [
            n,
            u,
            l,
            l,
            c,
            n
        ][i]),
        g: $0d2190c43ce9bee2$var$b(255 * [
            c,
            n,
            n,
            u,
            l,
            l
        ][i]),
        b: $0d2190c43ce9bee2$var$b(255 * [
            l,
            l,
            c,
            n,
            n,
            u
        ][i]),
        a: $0d2190c43ce9bee2$var$b(o, 2)
    };
}, $0d2190c43ce9bee2$var$O = function(e) {
    var r = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $0d2190c43ce9bee2$var$A({
        h: $0d2190c43ce9bee2$var$E(r[1], r[2]),
        s: Number(r[3]),
        v: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $0d2190c43ce9bee2$var$j = $0d2190c43ce9bee2$var$O, $0d2190c43ce9bee2$var$z = function(e) {
    var r = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $0d2190c43ce9bee2$var$L({
        r: Number(r[1]) / (r[2] ? 100 / 255 : 1),
        g: Number(r[3]) / (r[4] ? 100 / 255 : 1),
        b: Number(r[5]) / (r[6] ? 100 / 255 : 1),
        a: void 0 === r[7] ? 1 : Number(r[7]) / (r[8] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $0d2190c43ce9bee2$var$B = $0d2190c43ce9bee2$var$z, $0d2190c43ce9bee2$var$D = function(e) {
    var r = e.toString(16);
    return r.length < 2 ? "0" + r : r;
}, $0d2190c43ce9bee2$var$K = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = o < 1 ? $0d2190c43ce9bee2$var$D($0d2190c43ce9bee2$var$b(255 * o)) : "";
    return "#" + $0d2190c43ce9bee2$var$D(r) + $0d2190c43ce9bee2$var$D(t) + $0d2190c43ce9bee2$var$D(n) + a;
}, $0d2190c43ce9bee2$var$L = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = Math.max(r, t, n), l = a - Math.min(r, t, n), u = l ? a === r ? (t - n) / l : a === t ? 2 + (n - r) / l : 4 + (r - t) / l : 0;
    return {
        h: $0d2190c43ce9bee2$var$b(60 * (u < 0 ? u + 6 : u)),
        s: $0d2190c43ce9bee2$var$b(a ? l / a * 100 : 0),
        v: $0d2190c43ce9bee2$var$b(a / 255 * 100),
        a: o
    };
}, $0d2190c43ce9bee2$var$A = function(e) {
    return {
        h: $0d2190c43ce9bee2$var$b(e.h),
        s: $0d2190c43ce9bee2$var$b(e.s),
        v: $0d2190c43ce9bee2$var$b(e.v),
        a: $0d2190c43ce9bee2$var$b(e.a, 2)
    };
}, $0d2190c43ce9bee2$var$S = (0, $7hzE7.default).memo(function(r) {
    var t = r.hue, n = r.onChange, o = $0d2190c43ce9bee2$var$g([
        "react-colorful__hue",
        r.className
    ]);
    return (0, $7hzE7.default).createElement("div", {
        className: o
    }, (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$m, {
        onMove: function(e) {
            n({
                h: 360 * e.left
            });
        },
        onKey: function(e) {
            n({
                h: $0d2190c43ce9bee2$var$s(t + 360 * e.left, 0, 360)
            });
        },
        "aria-label": "Hue",
        "aria-valuenow": $0d2190c43ce9bee2$var$b(t),
        "aria-valuemax": "360",
        "aria-valuemin": "0"
    }, (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$p, {
        className: "react-colorful__hue-pointer",
        left: t / 360,
        color: $0d2190c43ce9bee2$var$q({
            h: t,
            s: 100,
            v: 100,
            a: 1
        })
    })));
}), $0d2190c43ce9bee2$var$T = (0, $7hzE7.default).memo(function(r) {
    var t = r.hsva, n = r.onChange, o = {
        backgroundColor: $0d2190c43ce9bee2$var$q({
            h: t.h,
            s: 100,
            v: 100,
            a: 1
        })
    };
    return (0, $7hzE7.default).createElement("div", {
        className: "react-colorful__saturation",
        style: o
    }, (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$m, {
        onMove: function(e) {
            n({
                s: 100 * e.left,
                v: 100 - 100 * e.top
            });
        },
        onKey: function(e) {
            n({
                s: $0d2190c43ce9bee2$var$s(t.s + 100 * e.left, 0, 100),
                v: $0d2190c43ce9bee2$var$s(t.v - 100 * e.top, 0, 100)
            });
        },
        "aria-label": "Color",
        "aria-valuetext": "Saturation " + $0d2190c43ce9bee2$var$b(t.s) + "%, Brightness " + $0d2190c43ce9bee2$var$b(t.v) + "%"
    }, (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$p, {
        className: "react-colorful__saturation-pointer",
        top: 1 - t.v / 100,
        left: t.s / 100,
        color: $0d2190c43ce9bee2$var$q(t)
    })));
}), $0d2190c43ce9bee2$var$F = function(e, r) {
    if (e === r) return !0;
    for(var t in e)if (e[t] !== r[t]) return !1;
    return !0;
}, $0d2190c43ce9bee2$var$P = function(e, r) {
    return e.replace(/\s/g, "") === r.replace(/\s/g, "");
}, $0d2190c43ce9bee2$var$X = function(e, r) {
    return e.toLowerCase() === r.toLowerCase() || $0d2190c43ce9bee2$var$F($0d2190c43ce9bee2$var$C(e), $0d2190c43ce9bee2$var$C(r));
};
function $0d2190c43ce9bee2$var$Y(e, t, l) {
    var u = $0d2190c43ce9bee2$var$i(l), c = (0, $6F3kv.useState)(function() {
        return e.toHsva(t);
    }), s = c[0], f = c[1], v = (0, $6F3kv.useRef)({
        color: t,
        hsva: s
    });
    (0, $6F3kv.useEffect)(function() {
        if (!e.equal(t, v.current.color)) {
            var r = e.toHsva(t);
            v.current = {
                hsva: r,
                color: t
            }, f(r);
        }
    }, [
        t,
        e
    ]), (0, $6F3kv.useEffect)(function() {
        var r;
        $0d2190c43ce9bee2$var$F(s, v.current.hsva) || e.equal(r = e.fromHsva(s), v.current.color) || (v.current = {
            hsva: s,
            color: r
        }, u(r));
    }, [
        s,
        e,
        u
    ]);
    var d = (0, $6F3kv.useCallback)(function(e) {
        f(function(r) {
            return Object.assign({}, r, e);
        });
    }, []);
    return [
        s,
        d
    ];
}
var $0d2190c43ce9bee2$var$R, $0d2190c43ce9bee2$var$V = "undefined" != typeof window ? (0, $6F3kv.useLayoutEffect) : (0, $6F3kv.useEffect), $0d2190c43ce9bee2$var$$ = function() {
    return $0d2190c43ce9bee2$var$R || ("undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0);
}, $0d2190c43ce9bee2$export$c5f670b24c0ae95a = function(e) {
    $0d2190c43ce9bee2$var$R = e;
}, $0d2190c43ce9bee2$var$J = new Map, $0d2190c43ce9bee2$var$Q = function(e) {
    $0d2190c43ce9bee2$var$V(function() {
        var r = e.current ? e.current.ownerDocument : document;
        if (void 0 !== r && !$0d2190c43ce9bee2$var$J.has(r)) {
            var t = r.createElement("style");
            t.innerHTML = '.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>\')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}', $0d2190c43ce9bee2$var$J.set(r, t);
            var n = $0d2190c43ce9bee2$var$$();
            n && t.setAttribute("nonce", n), r.head.appendChild(t);
        }
    }, []);
}, $0d2190c43ce9bee2$var$U = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $0d2190c43ce9bee2$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $6F3kv.useRef)(null);
    $0d2190c43ce9bee2$var$Q(f);
    var v = $0d2190c43ce9bee2$var$Y(o, l, i), d = v[0], h = v[1], m = $0d2190c43ce9bee2$var$g([
        "react-colorful",
        n
    ]);
    return (0, $7hzE7.default).createElement("div", $0d2190c43ce9bee2$var$u({}, s, {
        ref: f,
        className: m
    }), (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$T, {
        hsva: d,
        onChange: h
    }), (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$S, {
        hue: d.h,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $0d2190c43ce9bee2$var$W = {
    defaultColor: "000",
    toHsva: $0d2190c43ce9bee2$var$x,
    fromHsva: function(e) {
        return $0d2190c43ce9bee2$var$w({
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        });
    },
    equal: $0d2190c43ce9bee2$var$X
}, $0d2190c43ce9bee2$export$a3bc3c32746e9f3a = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$U, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$W
    }));
}, $0d2190c43ce9bee2$var$ee = function(r) {
    var t = r.className, n = r.hsva, o = r.onChange, a = {
        backgroundImage: "linear-gradient(90deg, " + $0d2190c43ce9bee2$var$k(Object.assign({}, n, {
            a: 0
        })) + ", " + $0d2190c43ce9bee2$var$k(Object.assign({}, n, {
            a: 1
        })) + ")"
    }, l = $0d2190c43ce9bee2$var$g([
        "react-colorful__alpha",
        t
    ]), u = $0d2190c43ce9bee2$var$b(100 * n.a);
    return (0, $7hzE7.default).createElement("div", {
        className: l
    }, (0, $7hzE7.default).createElement("div", {
        className: "react-colorful__alpha-gradient",
        style: a
    }), (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$m, {
        onMove: function(e) {
            o({
                a: e.left
            });
        },
        onKey: function(e) {
            o({
                a: $0d2190c43ce9bee2$var$s(n.a + e.left)
            });
        },
        "aria-label": "Alpha",
        "aria-valuetext": u + "%",
        "aria-valuenow": u,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
    }, (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$p, {
        className: "react-colorful__alpha-pointer",
        left: n.a,
        color: $0d2190c43ce9bee2$var$k(n)
    })));
}, $0d2190c43ce9bee2$var$re = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $0d2190c43ce9bee2$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $6F3kv.useRef)(null);
    $0d2190c43ce9bee2$var$Q(f);
    var v = $0d2190c43ce9bee2$var$Y(o, l, i), d = v[0], h = v[1], m = $0d2190c43ce9bee2$var$g([
        "react-colorful",
        n
    ]);
    return (0, $7hzE7.default).createElement("div", $0d2190c43ce9bee2$var$u({}, s, {
        ref: f,
        className: m
    }), (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$T, {
        hsva: d,
        onChange: h
    }), (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$S, {
        hue: d.h,
        onChange: h
    }), (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$ee, {
        hsva: d,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $0d2190c43ce9bee2$var$te = {
    defaultColor: "0001",
    toHsva: $0d2190c43ce9bee2$var$x,
    fromHsva: $0d2190c43ce9bee2$var$w,
    equal: $0d2190c43ce9bee2$var$X
}, $0d2190c43ce9bee2$export$ac2f77823341da45 = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$re, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$te
    }));
}, $0d2190c43ce9bee2$var$oe = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0,
        a: 1
    },
    toHsva: $0d2190c43ce9bee2$var$N,
    fromHsva: $0d2190c43ce9bee2$var$y,
    equal: $0d2190c43ce9bee2$var$F
}, $0d2190c43ce9bee2$export$ee0b0fc8d408da1d = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$re, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$oe
    }));
}, $0d2190c43ce9bee2$var$le = {
    defaultColor: "hsla(0, 0%, 0%, 1)",
    toHsva: $0d2190c43ce9bee2$var$H,
    fromHsva: $0d2190c43ce9bee2$var$k,
    equal: $0d2190c43ce9bee2$var$P
}, $0d2190c43ce9bee2$export$989f0248ad966033 = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$re, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$le
    }));
}, $0d2190c43ce9bee2$var$ce = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0
    },
    toHsva: function(e) {
        return $0d2190c43ce9bee2$var$N({
            h: e.h,
            s: e.s,
            l: e.l,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            h: (r = $0d2190c43ce9bee2$var$y(e)).h,
            s: r.s,
            l: r.l
        };
    },
    equal: $0d2190c43ce9bee2$var$F
}, $0d2190c43ce9bee2$export$c737d6c85aab3af7 = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$U, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$ce
    }));
}, $0d2190c43ce9bee2$var$se = {
    defaultColor: "hsl(0, 0%, 0%)",
    toHsva: $0d2190c43ce9bee2$var$M,
    fromHsva: $0d2190c43ce9bee2$var$q,
    equal: $0d2190c43ce9bee2$var$P
}, $0d2190c43ce9bee2$export$f4f988c96ece960 = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$U, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$se
    }));
}, $0d2190c43ce9bee2$var$ve = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    },
    toHsva: function(e) {
        return e;
    },
    fromHsva: $0d2190c43ce9bee2$var$A,
    equal: $0d2190c43ce9bee2$var$F
}, $0d2190c43ce9bee2$export$a2298f22bee4c5fd = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$re, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$ve
    }));
}, $0d2190c43ce9bee2$var$he = {
    defaultColor: "hsva(0, 0%, 0%, 1)",
    toHsva: $0d2190c43ce9bee2$var$O,
    fromHsva: function(e) {
        var r = $0d2190c43ce9bee2$var$A(e);
        return "hsva(" + r.h + ", " + r.s + "%, " + r.v + "%, " + r.a + ")";
    },
    equal: $0d2190c43ce9bee2$var$P
}, $0d2190c43ce9bee2$export$b2c7d62665b7ee26 = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$re, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$he
    }));
}, $0d2190c43ce9bee2$var$ge = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0
    },
    toHsva: function(e) {
        return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        };
    },
    fromHsva: function(e) {
        var r = $0d2190c43ce9bee2$var$A(e);
        return {
            h: r.h,
            s: r.s,
            v: r.v
        };
    },
    equal: $0d2190c43ce9bee2$var$F
}, $0d2190c43ce9bee2$export$580e7249020ee39f = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$U, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$ge
    }));
}, $0d2190c43ce9bee2$var$be = {
    defaultColor: "hsv(0, 0%, 0%)",
    toHsva: $0d2190c43ce9bee2$var$j,
    fromHsva: function(e) {
        var r = $0d2190c43ce9bee2$var$A(e);
        return "hsv(" + r.h + ", " + r.s + "%, " + r.v + "%)";
    },
    equal: $0d2190c43ce9bee2$var$P
}, $0d2190c43ce9bee2$export$ef09412d0ef04fda = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$U, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$be
    }));
}, $0d2190c43ce9bee2$var$xe = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    },
    toHsva: $0d2190c43ce9bee2$var$L,
    fromHsva: $0d2190c43ce9bee2$var$I,
    equal: $0d2190c43ce9bee2$var$F
}, $0d2190c43ce9bee2$export$e9c07ef2be187cb1 = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$re, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$xe
    }));
}, $0d2190c43ce9bee2$var$Ee = {
    defaultColor: "rgba(0, 0, 0, 1)",
    toHsva: $0d2190c43ce9bee2$var$z,
    fromHsva: function(e) {
        var r = $0d2190c43ce9bee2$var$I(e);
        return "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + r.a + ")";
    },
    equal: $0d2190c43ce9bee2$var$P
}, $0d2190c43ce9bee2$export$be07dcc7abc11a36 = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$re, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$Ee
    }));
}, $0d2190c43ce9bee2$var$Me = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0
    },
    toHsva: function(e) {
        return $0d2190c43ce9bee2$var$L({
            r: e.r,
            g: e.g,
            b: e.b,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            r: (r = $0d2190c43ce9bee2$var$I(e)).r,
            g: r.g,
            b: r.b
        };
    },
    equal: $0d2190c43ce9bee2$var$F
}, $0d2190c43ce9bee2$export$5ac2ba36722d4bd2 = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$U, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$Me
    }));
}, $0d2190c43ce9bee2$var$we = {
    defaultColor: "rgb(0, 0, 0)",
    toHsva: $0d2190c43ce9bee2$var$B,
    fromHsva: function(e) {
        var r = $0d2190c43ce9bee2$var$I(e);
        return "rgb(" + r.r + ", " + r.g + ", " + r.b + ")";
    },
    equal: $0d2190c43ce9bee2$var$P
}, $0d2190c43ce9bee2$export$9d70f030bf44a214 = function(r) {
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$U, $0d2190c43ce9bee2$var$u({}, r, {
        colorModel: $0d2190c43ce9bee2$var$we
    }));
}, $0d2190c43ce9bee2$var$qe = /^#?([0-9A-F]{3,8})$/i, $0d2190c43ce9bee2$var$ke = function(r) {
    var t = r.color, l = void 0 === t ? "" : t, s = r.onChange, f = r.onBlur, v = r.escape, d = r.validate, h = r.format, m = r.process, g = $0d2190c43ce9bee2$var$c(r, [
        "color",
        "onChange",
        "onBlur",
        "escape",
        "validate",
        "format",
        "process"
    ]), p = (0, $6F3kv.useState)(function() {
        return v(l);
    }), b = p[0], _ = p[1], x = $0d2190c43ce9bee2$var$i(s), C = $0d2190c43ce9bee2$var$i(f), E = (0, $6F3kv.useCallback)(function(e) {
        var r = v(e.target.value);
        _(r), d(r) && x(m ? m(r) : r);
    }, [
        v,
        m,
        d,
        x
    ]), H = (0, $6F3kv.useCallback)(function(e) {
        d(e.target.value) || _(v(l)), C(e);
    }, [
        l,
        v,
        d,
        C
    ]);
    return (0, $6F3kv.useEffect)(function() {
        _(v(l));
    }, [
        l,
        v
    ]), (0, $7hzE7.default).createElement("input", $0d2190c43ce9bee2$var$u({}, g, {
        value: h ? h(b) : b,
        spellCheck: "false",
        onChange: E,
        onBlur: H
    }));
}, $0d2190c43ce9bee2$var$Ie = function(e) {
    return "#" + e;
}, $0d2190c43ce9bee2$export$9219d762117624b6 = function(r) {
    var t = r.prefixed, n = r.alpha, o = $0d2190c43ce9bee2$var$c(r, [
        "prefixed",
        "alpha"
    ]), l = (0, $6F3kv.useCallback)(function(e) {
        return e.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
    }, [
        n
    ]), i = (0, $6F3kv.useCallback)(function(e) {
        return function(e, r) {
            var t = $0d2190c43ce9bee2$var$qe.exec(e), n = t ? t[1].length : 0;
            return 3 === n || 6 === n || !!r && 4 === n || !!r && 8 === n;
        }(e, n);
    }, [
        n
    ]);
    return (0, $7hzE7.default).createElement($0d2190c43ce9bee2$var$ke, $0d2190c43ce9bee2$var$u({}, o, {
        escape: l,
        format: t ? $0d2190c43ce9bee2$var$Ie : void 0,
        process: $0d2190c43ce9bee2$var$Ie,
        validate: i
    }));
};



const $e2cc6a122080be57$export$2f281d753966e6df = {
    WHEN_SUPPORTED: "WHEN_SUPPORTED",
    WHEN_REQUIRED: "WHEN_REQUIRED"
};
const $e2cc6a122080be57$export$1fc46fc3555d6f8a = $e2cc6a122080be57$export$2f281d753966e6df.WHEN_SUPPORTED;
const $e2cc6a122080be57$export$d01460c1d7f082de = {
    WHEN_SUPPORTED: "WHEN_SUPPORTED",
    WHEN_REQUIRED: "WHEN_REQUIRED"
};
const $e2cc6a122080be57$export$f0963351604e1d41 = $e2cc6a122080be57$export$2f281d753966e6df.WHEN_SUPPORTED;
var $e2cc6a122080be57$export$578faf5500e50907;
(function(ChecksumAlgorithm) {
    ChecksumAlgorithm["MD5"] = "MD5";
    ChecksumAlgorithm["CRC32"] = "CRC32";
    ChecksumAlgorithm["CRC32C"] = "CRC32C";
    ChecksumAlgorithm["SHA1"] = "SHA1";
    ChecksumAlgorithm["SHA256"] = "SHA256";
})($e2cc6a122080be57$export$578faf5500e50907 || ($e2cc6a122080be57$export$578faf5500e50907 = {}));
var $e2cc6a122080be57$export$6e71e3f58e94f6f3;
(function(ChecksumLocation) {
    ChecksumLocation["HEADER"] = "header";
    ChecksumLocation["TRAILER"] = "trailer";
})($e2cc6a122080be57$export$6e71e3f58e94f6f3 || ($e2cc6a122080be57$export$6e71e3f58e94f6f3 = {}));
const $e2cc6a122080be57$export$73a7a3f195f08c2a = $e2cc6a122080be57$export$578faf5500e50907.MD5;
const $e2cc6a122080be57$export$7a49516591945b27 = $e2cc6a122080be57$export$578faf5500e50907.CRC32;


var $60d3633405d6043d$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})($60d3633405d6043d$export$4e8b093ec8dcab0d || ($60d3633405d6043d$export$4e8b093ec8dcab0d = {}));
const $60d3633405d6043d$export$6874fcc34b7f0c5 = (obj, key, union, type)=>{
    if (!(key in obj)) return undefined;
    const value = obj[key].toUpperCase();
    if (!Object.values(union).includes(value)) throw new TypeError(`Cannot load ${type} '${key}'. Expected one of ${Object.values(union)}, got '${obj[key]}'.`);
    return value;
};


const $bb1c2432386dbb87$export$db45fe8fe4e4af3d = "AWS_REQUEST_CHECKSUM_CALCULATION";
const $bb1c2432386dbb87$export$392bf1d799e14147 = "request_checksum_calculation";
const $bb1c2432386dbb87$export$e54625b1d3354475 = {
    environmentVariableSelector: (env)=>(0, $60d3633405d6043d$export$6874fcc34b7f0c5)(env, $bb1c2432386dbb87$export$db45fe8fe4e4af3d, (0, $e2cc6a122080be57$export$2f281d753966e6df), (0, $60d3633405d6043d$export$4e8b093ec8dcab0d).ENV),
    configFileSelector: (profile)=>(0, $60d3633405d6043d$export$6874fcc34b7f0c5)(profile, $bb1c2432386dbb87$export$392bf1d799e14147, (0, $e2cc6a122080be57$export$2f281d753966e6df), (0, $60d3633405d6043d$export$4e8b093ec8dcab0d).CONFIG),
    default: (0, $e2cc6a122080be57$export$1fc46fc3555d6f8a)
};




const $e302c8e9425ef624$export$83ed1ac0317547f7 = "AWS_RESPONSE_CHECKSUM_VALIDATION";
const $e302c8e9425ef624$export$900095972c81e9a2 = "response_checksum_validation";
const $e302c8e9425ef624$export$b30a66b6ddacf7bf = {
    environmentVariableSelector: (env)=>(0, $60d3633405d6043d$export$6874fcc34b7f0c5)(env, $e302c8e9425ef624$export$83ed1ac0317547f7, (0, $e2cc6a122080be57$export$d01460c1d7f082de), (0, $60d3633405d6043d$export$4e8b093ec8dcab0d).ENV),
    configFileSelector: (profile)=>(0, $60d3633405d6043d$export$6874fcc34b7f0c5)(profile, $e302c8e9425ef624$export$900095972c81e9a2, (0, $e2cc6a122080be57$export$d01460c1d7f082de), (0, $60d3633405d6043d$export$4e8b093ec8dcab0d).CONFIG),
    default: (0, $e2cc6a122080be57$export$f0963351604e1d41)
};



const $4f1aa0a6cb853500$export$663b205817703038 = (runtimeConfig)=>{
    let httpHandler = runtimeConfig.httpHandler;
    return {
        setHttpHandler (handler) {
            httpHandler = handler;
        },
        httpHandler () {
            return httpHandler;
        },
        updateHttpClientConfig (key, value) {
            httpHandler.updateHttpClientConfig(key, value);
        },
        httpHandlerConfigs () {
            return httpHandler.httpHandlerConfigs();
        }
    };
};
const $4f1aa0a6cb853500$export$d94fe0350385c1a8 = (httpHandlerExtensionConfiguration)=>{
    return {
        httpHandler: httpHandlerExtensionConfiguration.httpHandler()
    };
};






var $50cf8cb61355c07c$export$e24756d4ad084ce1;
(function(HttpAuthLocation) {
    HttpAuthLocation["HEADER"] = "header";
    HttpAuthLocation["QUERY"] = "query";
})($50cf8cb61355c07c$export$e24756d4ad084ce1 || ($50cf8cb61355c07c$export$e24756d4ad084ce1 = {}));


var $f71c6ad9eb56b268$export$8c5ca875010cb2a6;
(function(HttpApiKeyAuthLocation) {
    HttpApiKeyAuthLocation["HEADER"] = "header";
    HttpApiKeyAuthLocation["QUERY"] = "query";
})($f71c6ad9eb56b268$export$8c5ca875010cb2a6 || ($f71c6ad9eb56b268$export$8c5ca875010cb2a6 = {}));
































var $d52acda0f7253006$export$b141d049add1dcb5;
(function(EndpointURLScheme) {
    EndpointURLScheme["HTTP"] = "http";
    EndpointURLScheme["HTTPS"] = "https";
})($d52acda0f7253006$export$b141d049add1dcb5 || ($d52acda0f7253006$export$b141d049add1dcb5 = {}));
















var $2faf1e30c31ae8de$export$fe562bf21391d1f0;
(function(AlgorithmId) {
    AlgorithmId["MD5"] = "md5";
    AlgorithmId["CRC32"] = "crc32";
    AlgorithmId["CRC32C"] = "crc32c";
    AlgorithmId["SHA1"] = "sha1";
    AlgorithmId["SHA256"] = "sha256";
})($2faf1e30c31ae8de$export$fe562bf21391d1f0 || ($2faf1e30c31ae8de$export$fe562bf21391d1f0 = {}));
const $2faf1e30c31ae8de$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    if (runtimeConfig.sha256 !== undefined) checksumAlgorithms.push({
        algorithmId: ()=>$2faf1e30c31ae8de$export$fe562bf21391d1f0.SHA256,
        checksumConstructor: ()=>runtimeConfig.sha256
    });
    if (runtimeConfig.md5 != undefined) checksumAlgorithms.push({
        algorithmId: ()=>$2faf1e30c31ae8de$export$fe562bf21391d1f0.MD5,
        checksumConstructor: ()=>runtimeConfig.md5
    });
    return {
        _checksumAlgorithms: checksumAlgorithms,
        addChecksumAlgorithm (algo) {
            this._checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return this._checksumAlgorithms;
        }
    };
};
const $2faf1e30c31ae8de$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};


const $5a301f25efc36485$export$7081660fd0cd662b = (runtimeConfig)=>{
    return {
        ...(0, $2faf1e30c31ae8de$export$129b301e72591856)(runtimeConfig)
    };
};
const $5a301f25efc36485$export$abfa28b95316e0ae = (config)=>{
    return {
        ...(0, $2faf1e30c31ae8de$export$589dfc268e61d391)(config)
    };
};







var $dacddcce2e15e57e$export$54765d03252bd9ed;
(function(FieldPosition) {
    FieldPosition[FieldPosition["HEADER"] = 0] = "HEADER";
    FieldPosition[FieldPosition["TRAILER"] = 1] = "TRAILER";
})($dacddcce2e15e57e$export$54765d03252bd9ed || ($dacddcce2e15e57e$export$54765d03252bd9ed = {}));
















const $73bee794fdd638f0$export$94e7bb1b8aa610cb = "__smithy_context";




var $db850eaa42ce5edb$export$bd84655cbf2c28d9;
(function(IniSectionType) {
    IniSectionType["PROFILE"] = "profile";
    IniSectionType["SSO_SESSION"] = "sso-session";
    IniSectionType["SERVICES"] = "services";
})($db850eaa42ce5edb$export$bd84655cbf2c28d9 || ($db850eaa42ce5edb$export$bd84655cbf2c28d9 = {}));




















var $58597694f4fe836d$export$6431f3fda9a48da2;
(function(RequestHandlerProtocol) {
    RequestHandlerProtocol["HTTP_0_9"] = "http/0.9";
    RequestHandlerProtocol["HTTP_1_0"] = "http/1.0";
    RequestHandlerProtocol["TDS_8_0"] = "tds/8.0";
})($58597694f4fe836d$export$6431f3fda9a48da2 || ($58597694f4fe836d$export$6431f3fda9a48da2 = {}));
















class $36b4bb5e081f1482$export$a455218a85c89869 {
    constructor({ name: name, kind: kind = (0, $dacddcce2e15e57e$export$54765d03252bd9ed).HEADER, values: values = [] }){
        this.name = name;
        this.kind = kind;
        this.values = values;
    }
    add(value) {
        this.values.push(value);
    }
    set(values) {
        this.values = values;
    }
    remove(value) {
        this.values = this.values.filter((v)=>v !== value);
    }
    toString() {
        return this.values.map((v)=>v.includes(",") || v.includes(" ") ? `"${v}"` : v).join(", ");
    }
    get() {
        return this.values;
    }
}


class $467924168eff052f$export$833b3e5a19fb8939 {
    constructor({ fields: fields = [], encoding: encoding = "utf-8" }){
        this.entries = {};
        fields.forEach(this.setField.bind(this));
        this.encoding = encoding;
    }
    setField(field) {
        this.entries[field.name.toLowerCase()] = field;
    }
    getField(name) {
        return this.entries[name.toLowerCase()];
    }
    removeField(name) {
        delete this.entries[name.toLowerCase()];
    }
    getByType(kind) {
        return Object.values(this.entries).filter((field)=>field.kind === kind);
    }
}




class $435a3b4f1285ae7b$export$7587955500404ec3 {
    constructor(options){
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? `${options.protocol}:` : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? `/${options.path}` : options.path : "/";
        this.username = options.username;
        this.password = options.password;
        this.fragment = options.fragment;
    }
    static clone(request) {
        const cloned = new $435a3b4f1285ae7b$export$7587955500404ec3({
            ...request,
            headers: {
                ...request.headers
            }
        });
        if (cloned.query) cloned.query = $435a3b4f1285ae7b$var$cloneQuery(cloned.query);
        return cloned;
    }
    static isInstance(request) {
        if (!request) return false;
        const req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    }
    clone() {
        return $435a3b4f1285ae7b$export$7587955500404ec3.clone(this);
    }
}
function $435a3b4f1285ae7b$var$cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});
}


class $55997741113954a0$export$1d94dfe0d9d1f1e7 {
    constructor(options){
        this.statusCode = options.statusCode;
        this.reason = options.reason;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    static isInstance(response) {
        if (!response) return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
}


function $611e743691c73c8a$export$e024c793399bdd01(hostname) {
    const hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}








const $53773d08d7957dec$export$250d41e5cdcdba3f = [
    (0, $e2cc6a122080be57$export$578faf5500e50907).CRC32,
    (0, $e2cc6a122080be57$export$578faf5500e50907).CRC32C,
    (0, $e2cc6a122080be57$export$578faf5500e50907).SHA1,
    (0, $e2cc6a122080be57$export$578faf5500e50907).SHA256
];
const $53773d08d7957dec$export$d72f0660fe536945 = [
    (0, $e2cc6a122080be57$export$578faf5500e50907).SHA256,
    (0, $e2cc6a122080be57$export$578faf5500e50907).SHA1,
    (0, $e2cc6a122080be57$export$578faf5500e50907).CRC32,
    (0, $e2cc6a122080be57$export$578faf5500e50907).CRC32C
];


const $009cbeb1d7c60656$export$3a8d03296046b4c = (input, { requestChecksumRequired: requestChecksumRequired, requestAlgorithmMember: requestAlgorithmMember }, isS3Express)=>{
    const defaultAlgorithm = isS3Express ? (0, $e2cc6a122080be57$export$7a49516591945b27) : (0, $e2cc6a122080be57$export$73a7a3f195f08c2a);
    if (!requestAlgorithmMember || !input[requestAlgorithmMember]) return requestChecksumRequired ? defaultAlgorithm : undefined;
    const checksumAlgorithm = input[requestAlgorithmMember];
    if (!(0, $53773d08d7957dec$export$250d41e5cdcdba3f).includes(checksumAlgorithm)) throw new Error(`The checksum algorithm "${checksumAlgorithm}" is not supported by the client.` + ` Select one of ${0, $53773d08d7957dec$export$250d41e5cdcdba3f}.`);
    return checksumAlgorithm;
};



const $0049676f8a5af38a$export$f2b25cbe2b26f44a = (algorithm)=>algorithm === (0, $e2cc6a122080be57$export$578faf5500e50907).MD5 ? "content-md5" : `x-amz-checksum-${algorithm.toLowerCase()}`;


const $84a87d811e2719bf$export$17944590be865217 = (header, headers)=>{
    const soughtHeader = header.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};


const $3b71e8cd7dcfdf56$export$9dd3754ae86f0017 = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";


const $f6a7613004805a91$export$cd8dd85fa30a5026 = (body)=>body !== undefined && typeof body !== "string" && !ArrayBuffer.isView(body) && !(0, $3b71e8cd7dcfdf56$export$9dd3754ae86f0017)(body);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3d105b71c9af75be$var$extendStatics = function(d, b) {
    $3d105b71c9af75be$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3d105b71c9af75be$var$extendStatics(d, b);
};
function $3d105b71c9af75be$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3d105b71c9af75be$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3d105b71c9af75be$export$18ce0697a983be9b = function() {
    $3d105b71c9af75be$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3d105b71c9af75be$export$18ce0697a983be9b.apply(this, arguments);
};
function $3d105b71c9af75be$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3d105b71c9af75be$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3d105b71c9af75be$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3d105b71c9af75be$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3d105b71c9af75be$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3d105b71c9af75be$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3d105b71c9af75be$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3d105b71c9af75be$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3d105b71c9af75be$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3d105b71c9af75be$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3d105b71c9af75be$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3d105b71c9af75be$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3d105b71c9af75be$export$45d3717a4c69092e(o, m, p);
}
function $3d105b71c9af75be$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3d105b71c9af75be$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3d105b71c9af75be$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3d105b71c9af75be$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3d105b71c9af75be$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3d105b71c9af75be$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3d105b71c9af75be$export$10c90e4f7922046c(v) {
    return this instanceof $3d105b71c9af75be$export$10c90e4f7922046c ? (this.v = v, this) : new $3d105b71c9af75be$export$10c90e4f7922046c(v);
}
function $3d105b71c9af75be$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3d105b71c9af75be$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3d105b71c9af75be$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3d105b71c9af75be$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3d105b71c9af75be$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3d105b71c9af75be$export$19a8beecd37a4c45 === "function" ? $3d105b71c9af75be$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3d105b71c9af75be$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3d105b71c9af75be$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3d105b71c9af75be$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3d105b71c9af75be$export$45d3717a4c69092e(result, mod, k);
    }
    $3d105b71c9af75be$var$__setModuleDefault(result, mod);
    return result;
}
function $3d105b71c9af75be$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3d105b71c9af75be$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3d105b71c9af75be$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3d105b71c9af75be$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3d105b71c9af75be$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3d105b71c9af75be$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3d105b71c9af75be$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3d105b71c9af75be$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3d105b71c9af75be$export$2e2bcd8739ae039 = {
    __extends: $3d105b71c9af75be$export$a8ba968b8961cb8a,
    __assign: $3d105b71c9af75be$export$18ce0697a983be9b,
    __rest: $3d105b71c9af75be$export$3c9a16f847548506,
    __decorate: $3d105b71c9af75be$export$29e00dfd3077644b,
    __param: $3d105b71c9af75be$export$d5ad3fd78186038f,
    __metadata: $3d105b71c9af75be$export$f1db080c865becb9,
    __awaiter: $3d105b71c9af75be$export$1050f835b63b671e,
    __generator: $3d105b71c9af75be$export$67ebef60e6f28a6,
    __createBinding: $3d105b71c9af75be$export$45d3717a4c69092e,
    __exportStar: $3d105b71c9af75be$export$f33643c0debef087,
    __values: $3d105b71c9af75be$export$19a8beecd37a4c45,
    __read: $3d105b71c9af75be$export$8d051b38c9118094,
    __spread: $3d105b71c9af75be$export$afc72e2116322959,
    __spreadArrays: $3d105b71c9af75be$export$6388937ca91ccae8,
    __spreadArray: $3d105b71c9af75be$export$1216008129fb82ed,
    __await: $3d105b71c9af75be$export$10c90e4f7922046c,
    __asyncGenerator: $3d105b71c9af75be$export$e427f37a30a4de9b,
    __asyncDelegator: $3d105b71c9af75be$export$bbd80228419bb833,
    __asyncValues: $3d105b71c9af75be$export$e3b29a3d6162315f,
    __makeTemplateObject: $3d105b71c9af75be$export$4fb47efe1390b86f,
    __importStar: $3d105b71c9af75be$export$c21735bcef00d192,
    __importDefault: $3d105b71c9af75be$export$da59b14a69baef04,
    __classPrivateFieldGet: $3d105b71c9af75be$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3d105b71c9af75be$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3d105b71c9af75be$export$81fdc39f203e4e04,
    __addDisposableResource: $3d105b71c9af75be$export$88ac25d8e944e405,
    __disposeResources: $3d105b71c9af75be$export$8f076105dc360e92
};


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8bf11bd0ff1e2e05$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $97a64b498e4bdc19$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $8bf11bd0ff1e2e05$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $dfa47a941f3f6ae2$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};




/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $6296820ff05fe490$export$a143d493d941bafc;
var $6296820ff05fe490$export$e4cf37d7f6fb9e0a;
var $6296820ff05fe490$export$f99ded8fe4b79145;
var $6296820ff05fe490$export$599f31c3813fae4d;
'use strict';
var $9c17c36c20a854e3$export$a48f0734ac7c2329;
var $9c17c36c20a854e3$export$d622b2ad8d90c771;
var $9c17c36c20a854e3$export$6100ba28696e12de;
'use strict';
$9c17c36c20a854e3$export$a48f0734ac7c2329 = $9c17c36c20a854e3$var$byteLength;
$9c17c36c20a854e3$export$d622b2ad8d90c771 = $9c17c36c20a854e3$var$toByteArray;
$9c17c36c20a854e3$export$6100ba28696e12de = $9c17c36c20a854e3$var$fromByteArray;
var $9c17c36c20a854e3$var$lookup = [];
var $9c17c36c20a854e3$var$revLookup = [];
var $9c17c36c20a854e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $9c17c36c20a854e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $9c17c36c20a854e3$var$i = 0, $9c17c36c20a854e3$var$len = $9c17c36c20a854e3$var$code.length; $9c17c36c20a854e3$var$i < $9c17c36c20a854e3$var$len; ++$9c17c36c20a854e3$var$i){
    $9c17c36c20a854e3$var$lookup[$9c17c36c20a854e3$var$i] = $9c17c36c20a854e3$var$code[$9c17c36c20a854e3$var$i];
    $9c17c36c20a854e3$var$revLookup[$9c17c36c20a854e3$var$code.charCodeAt($9c17c36c20a854e3$var$i)] = $9c17c36c20a854e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$9c17c36c20a854e3$var$revLookup['-'.charCodeAt(0)] = 62;
$9c17c36c20a854e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $9c17c36c20a854e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $9c17c36c20a854e3$var$byteLength(b64) {
    var lens = $9c17c36c20a854e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9c17c36c20a854e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9c17c36c20a854e3$var$toByteArray(b64) {
    var tmp;
    var lens = $9c17c36c20a854e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $9c17c36c20a854e3$var$Arr($9c17c36c20a854e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $9c17c36c20a854e3$var$revLookup[b64.charCodeAt(i)] << 18 | $9c17c36c20a854e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $9c17c36c20a854e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $9c17c36c20a854e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $9c17c36c20a854e3$var$revLookup[b64.charCodeAt(i)] << 2 | $9c17c36c20a854e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $9c17c36c20a854e3$var$revLookup[b64.charCodeAt(i)] << 10 | $9c17c36c20a854e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $9c17c36c20a854e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $9c17c36c20a854e3$var$tripletToBase64(num) {
    return $9c17c36c20a854e3$var$lookup[num >> 18 & 0x3F] + $9c17c36c20a854e3$var$lookup[num >> 12 & 0x3F] + $9c17c36c20a854e3$var$lookup[num >> 6 & 0x3F] + $9c17c36c20a854e3$var$lookup[num & 0x3F];
}
function $9c17c36c20a854e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($9c17c36c20a854e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $9c17c36c20a854e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($9c17c36c20a854e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($9c17c36c20a854e3$var$lookup[tmp >> 2] + $9c17c36c20a854e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($9c17c36c20a854e3$var$lookup[tmp >> 10] + $9c17c36c20a854e3$var$lookup[tmp >> 4 & 0x3F] + $9c17c36c20a854e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ab1e6d54fc22e60d$export$aafa59e2e03f2942;
var $ab1e6d54fc22e60d$export$68d8715fc104d294;
$ab1e6d54fc22e60d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ab1e6d54fc22e60d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $6296820ff05fe490$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6296820ff05fe490$export$a143d493d941bafc = $6296820ff05fe490$var$Buffer;
$6296820ff05fe490$export$e4cf37d7f6fb9e0a = $6296820ff05fe490$var$SlowBuffer;
$6296820ff05fe490$export$f99ded8fe4b79145 = 50;
const $6296820ff05fe490$var$K_MAX_LENGTH = 0x7fffffff;
$6296820ff05fe490$export$599f31c3813fae4d = $6296820ff05fe490$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6296820ff05fe490$var$Buffer.TYPED_ARRAY_SUPPORT = $6296820ff05fe490$var$typedArraySupport();
if (!$6296820ff05fe490$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6296820ff05fe490$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6296820ff05fe490$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$6296820ff05fe490$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6296820ff05fe490$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$6296820ff05fe490$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6296820ff05fe490$var$createBuffer(length) {
    if (length > $6296820ff05fe490$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6296820ff05fe490$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6296820ff05fe490$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6296820ff05fe490$var$allocUnsafe(arg);
    }
    return $6296820ff05fe490$var$from(arg, encodingOrOffset, length);
}
$6296820ff05fe490$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6296820ff05fe490$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6296820ff05fe490$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6296820ff05fe490$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($6296820ff05fe490$var$isInstance(value, ArrayBuffer) || value && $6296820ff05fe490$var$isInstance(value.buffer, ArrayBuffer)) return $6296820ff05fe490$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6296820ff05fe490$var$isInstance(value, SharedArrayBuffer) || value && $6296820ff05fe490$var$isInstance(value.buffer, SharedArrayBuffer))) return $6296820ff05fe490$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6296820ff05fe490$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $6296820ff05fe490$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6296820ff05fe490$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6296820ff05fe490$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6296820ff05fe490$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6296820ff05fe490$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6296820ff05fe490$var$Buffer, Uint8Array);
function $6296820ff05fe490$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6296820ff05fe490$var$alloc(size, fill, encoding) {
    $6296820ff05fe490$var$assertSize(size);
    if (size <= 0) return $6296820ff05fe490$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6296820ff05fe490$var$createBuffer(size).fill(fill, encoding) : $6296820ff05fe490$var$createBuffer(size).fill(fill);
    return $6296820ff05fe490$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6296820ff05fe490$var$Buffer.alloc = function(size, fill, encoding) {
    return $6296820ff05fe490$var$alloc(size, fill, encoding);
};
function $6296820ff05fe490$var$allocUnsafe(size) {
    $6296820ff05fe490$var$assertSize(size);
    return $6296820ff05fe490$var$createBuffer(size < 0 ? 0 : $6296820ff05fe490$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6296820ff05fe490$var$Buffer.allocUnsafe = function(size) {
    return $6296820ff05fe490$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6296820ff05fe490$var$Buffer.allocUnsafeSlow = function(size) {
    return $6296820ff05fe490$var$allocUnsafe(size);
};
function $6296820ff05fe490$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6296820ff05fe490$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $6296820ff05fe490$var$byteLength(string, encoding) | 0;
    let buf = $6296820ff05fe490$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6296820ff05fe490$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $6296820ff05fe490$var$checked(array.length) | 0;
    const buf = $6296820ff05fe490$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6296820ff05fe490$var$fromArrayView(arrayView) {
    if ($6296820ff05fe490$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $6296820ff05fe490$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6296820ff05fe490$var$fromArrayLike(arrayView);
}
function $6296820ff05fe490$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6296820ff05fe490$var$Buffer.prototype);
    return buf;
}
function $6296820ff05fe490$var$fromObject(obj) {
    if ($6296820ff05fe490$var$Buffer.isBuffer(obj)) {
        const len = $6296820ff05fe490$var$checked(obj.length) | 0;
        const buf = $6296820ff05fe490$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6296820ff05fe490$var$numberIsNaN(obj.length)) return $6296820ff05fe490$var$createBuffer(0);
        return $6296820ff05fe490$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6296820ff05fe490$var$fromArrayLike(obj.data);
}
function $6296820ff05fe490$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6296820ff05fe490$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6296820ff05fe490$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6296820ff05fe490$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6296820ff05fe490$var$Buffer.alloc(+length);
}
$6296820ff05fe490$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6296820ff05fe490$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6296820ff05fe490$var$Buffer.compare = function compare(a, b) {
    if ($6296820ff05fe490$var$isInstance(a, Uint8Array)) a = $6296820ff05fe490$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6296820ff05fe490$var$isInstance(b, Uint8Array)) b = $6296820ff05fe490$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6296820ff05fe490$var$Buffer.isBuffer(a) || !$6296820ff05fe490$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6296820ff05fe490$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6296820ff05fe490$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6296820ff05fe490$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $6296820ff05fe490$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($6296820ff05fe490$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6296820ff05fe490$var$Buffer.isBuffer(buf)) buf = $6296820ff05fe490$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6296820ff05fe490$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6296820ff05fe490$var$byteLength(string, encoding) {
    if ($6296820ff05fe490$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6296820ff05fe490$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6296820ff05fe490$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6296820ff05fe490$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6296820ff05fe490$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6296820ff05fe490$var$Buffer.byteLength = $6296820ff05fe490$var$byteLength;
function $6296820ff05fe490$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6296820ff05fe490$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6296820ff05fe490$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6296820ff05fe490$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6296820ff05fe490$var$latin1Slice(this, start, end);
        case 'base64':
            return $6296820ff05fe490$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6296820ff05fe490$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6296820ff05fe490$var$Buffer.prototype._isBuffer = true;
function $6296820ff05fe490$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6296820ff05fe490$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$6296820ff05fe490$var$swap(this, i, i + 1);
    return this;
};
$6296820ff05fe490$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $6296820ff05fe490$var$swap(this, i, i + 3);
        $6296820ff05fe490$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6296820ff05fe490$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $6296820ff05fe490$var$swap(this, i, i + 7);
        $6296820ff05fe490$var$swap(this, i + 1, i + 6);
        $6296820ff05fe490$var$swap(this, i + 2, i + 5);
        $6296820ff05fe490$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6296820ff05fe490$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6296820ff05fe490$var$utf8Slice(this, 0, length);
    return $6296820ff05fe490$var$slowToString.apply(this, arguments);
};
$6296820ff05fe490$var$Buffer.prototype.toLocaleString = $6296820ff05fe490$var$Buffer.prototype.toString;
$6296820ff05fe490$var$Buffer.prototype.equals = function equals(b) {
    if (!$6296820ff05fe490$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6296820ff05fe490$var$Buffer.compare(this, b) === 0;
};
$6296820ff05fe490$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $6296820ff05fe490$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6296820ff05fe490$var$customInspectSymbol) $6296820ff05fe490$var$Buffer.prototype[$6296820ff05fe490$var$customInspectSymbol] = $6296820ff05fe490$var$Buffer.prototype.inspect;
$6296820ff05fe490$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6296820ff05fe490$var$isInstance(target, Uint8Array)) target = $6296820ff05fe490$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6296820ff05fe490$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6296820ff05fe490$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6296820ff05fe490$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6296820ff05fe490$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6296820ff05fe490$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6296820ff05fe490$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6296820ff05fe490$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6296820ff05fe490$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6296820ff05fe490$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6296820ff05fe490$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6296820ff05fe490$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6296820ff05fe490$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6296820ff05fe490$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6296820ff05fe490$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6296820ff05fe490$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6296820ff05fe490$var$utf8Write(buf, string, offset, length) {
    return $6296820ff05fe490$var$blitBuffer($6296820ff05fe490$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6296820ff05fe490$var$asciiWrite(buf, string, offset, length) {
    return $6296820ff05fe490$var$blitBuffer($6296820ff05fe490$var$asciiToBytes(string), buf, offset, length);
}
function $6296820ff05fe490$var$base64Write(buf, string, offset, length) {
    return $6296820ff05fe490$var$blitBuffer($6296820ff05fe490$var$base64ToBytes(string), buf, offset, length);
}
function $6296820ff05fe490$var$ucs2Write(buf, string, offset, length) {
    return $6296820ff05fe490$var$blitBuffer($6296820ff05fe490$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6296820ff05fe490$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6296820ff05fe490$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6296820ff05fe490$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6296820ff05fe490$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6296820ff05fe490$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6296820ff05fe490$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6296820ff05fe490$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6296820ff05fe490$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9c17c36c20a854e3$export$6100ba28696e12de(buf);
    else return $9c17c36c20a854e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $6296820ff05fe490$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6296820ff05fe490$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $6296820ff05fe490$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6296820ff05fe490$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $6296820ff05fe490$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6296820ff05fe490$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6296820ff05fe490$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6296820ff05fe490$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6296820ff05fe490$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $6296820ff05fe490$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6296820ff05fe490$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6296820ff05fe490$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6296820ff05fe490$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6296820ff05fe490$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6296820ff05fe490$var$Buffer.prototype.readUintLE = $6296820ff05fe490$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6296820ff05fe490$var$Buffer.prototype.readUintBE = $6296820ff05fe490$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6296820ff05fe490$var$Buffer.prototype.readUint8 = $6296820ff05fe490$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6296820ff05fe490$var$Buffer.prototype.readUint16LE = $6296820ff05fe490$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6296820ff05fe490$var$Buffer.prototype.readUint16BE = $6296820ff05fe490$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6296820ff05fe490$var$Buffer.prototype.readUint32LE = $6296820ff05fe490$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6296820ff05fe490$var$Buffer.prototype.readUint32BE = $6296820ff05fe490$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6296820ff05fe490$var$Buffer.prototype.readBigUInt64LE = $6296820ff05fe490$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6296820ff05fe490$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6296820ff05fe490$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6296820ff05fe490$var$Buffer.prototype.readBigUInt64BE = $6296820ff05fe490$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6296820ff05fe490$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6296820ff05fe490$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6296820ff05fe490$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6296820ff05fe490$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6296820ff05fe490$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6296820ff05fe490$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6296820ff05fe490$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6296820ff05fe490$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6296820ff05fe490$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6296820ff05fe490$var$Buffer.prototype.readBigInt64LE = $6296820ff05fe490$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6296820ff05fe490$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6296820ff05fe490$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$6296820ff05fe490$var$Buffer.prototype.readBigInt64BE = $6296820ff05fe490$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6296820ff05fe490$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6296820ff05fe490$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$6296820ff05fe490$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 4, this.length);
    return $ab1e6d54fc22e60d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$6296820ff05fe490$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 4, this.length);
    return $ab1e6d54fc22e60d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$6296820ff05fe490$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 8, this.length);
    return $ab1e6d54fc22e60d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$6296820ff05fe490$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkOffset(offset, 8, this.length);
    return $ab1e6d54fc22e60d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $6296820ff05fe490$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6296820ff05fe490$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6296820ff05fe490$var$Buffer.prototype.writeUintLE = $6296820ff05fe490$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6296820ff05fe490$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6296820ff05fe490$var$Buffer.prototype.writeUintBE = $6296820ff05fe490$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6296820ff05fe490$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6296820ff05fe490$var$Buffer.prototype.writeUint8 = $6296820ff05fe490$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6296820ff05fe490$var$Buffer.prototype.writeUint16LE = $6296820ff05fe490$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6296820ff05fe490$var$Buffer.prototype.writeUint16BE = $6296820ff05fe490$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6296820ff05fe490$var$Buffer.prototype.writeUint32LE = $6296820ff05fe490$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6296820ff05fe490$var$Buffer.prototype.writeUint32BE = $6296820ff05fe490$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6296820ff05fe490$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6296820ff05fe490$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6296820ff05fe490$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6296820ff05fe490$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6296820ff05fe490$var$Buffer.prototype.writeBigUInt64LE = $6296820ff05fe490$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $6296820ff05fe490$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6296820ff05fe490$var$Buffer.prototype.writeBigUInt64BE = $6296820ff05fe490$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $6296820ff05fe490$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6296820ff05fe490$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6296820ff05fe490$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6296820ff05fe490$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6296820ff05fe490$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6296820ff05fe490$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6296820ff05fe490$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6296820ff05fe490$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6296820ff05fe490$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6296820ff05fe490$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6296820ff05fe490$var$Buffer.prototype.writeBigInt64LE = $6296820ff05fe490$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $6296820ff05fe490$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6296820ff05fe490$var$Buffer.prototype.writeBigInt64BE = $6296820ff05fe490$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $6296820ff05fe490$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6296820ff05fe490$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6296820ff05fe490$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ab1e6d54fc22e60d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6296820ff05fe490$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6296820ff05fe490$var$writeFloat(this, value, offset, true, noAssert);
};
$6296820ff05fe490$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6296820ff05fe490$var$writeFloat(this, value, offset, false, noAssert);
};
function $6296820ff05fe490$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6296820ff05fe490$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ab1e6d54fc22e60d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6296820ff05fe490$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6296820ff05fe490$var$writeDouble(this, value, offset, true, noAssert);
};
$6296820ff05fe490$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6296820ff05fe490$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6296820ff05fe490$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6296820ff05fe490$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6296820ff05fe490$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6296820ff05fe490$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $6296820ff05fe490$var$Buffer.isBuffer(val) ? val : $6296820ff05fe490$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $6296820ff05fe490$var$errors = {};
function $6296820ff05fe490$var$E(sym, getMessage, Base) {
    $6296820ff05fe490$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$6296820ff05fe490$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6296820ff05fe490$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$6296820ff05fe490$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6296820ff05fe490$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $6296820ff05fe490$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $6296820ff05fe490$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $6296820ff05fe490$var$checkBounds(buf, offset, byteLength) {
    $6296820ff05fe490$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6296820ff05fe490$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6296820ff05fe490$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $6296820ff05fe490$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6296820ff05fe490$var$checkBounds(buf, offset, byteLength);
}
function $6296820ff05fe490$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6296820ff05fe490$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6296820ff05fe490$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6296820ff05fe490$var$validateNumber(value, type);
        throw new $6296820ff05fe490$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6296820ff05fe490$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6296820ff05fe490$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $6296820ff05fe490$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6296820ff05fe490$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6296820ff05fe490$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6296820ff05fe490$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6296820ff05fe490$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6296820ff05fe490$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6296820ff05fe490$var$base64ToBytes(str) {
    return $9c17c36c20a854e3$export$d622b2ad8d90c771($6296820ff05fe490$var$base64clean(str));
}
function $6296820ff05fe490$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6296820ff05fe490$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6296820ff05fe490$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $6296820ff05fe490$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6296820ff05fe490$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6296820ff05fe490$var$BufferBigIntNotDefined : fn;
}
function $6296820ff05fe490$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $934c9590050643f0$require$Buffer = $6296820ff05fe490$export$a143d493d941bafc;
// Quick polyfill
var $934c9590050643f0$var$fromUtf8 = typeof $934c9590050643f0$require$Buffer !== "undefined" && $934c9590050643f0$require$Buffer.from ? function(input) {
    return $934c9590050643f0$require$Buffer.from(input, "utf8");
} : (0, $8bf11bd0ff1e2e05$export$c7c5cef950a4d2fc);
function $934c9590050643f0$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $934c9590050643f0$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $3c18a85c0a19e10f$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $974af2abdf2ad3d3$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $d09e9fb2a083d837$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $8a400911e4e0b378$export$ea4992a0ab9eff2d = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new (0, $b839d0c14cc0f1ef$export$16d8d62894c71747)();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $3c18a85c0a19e10f$export$ea55f474a468804e)(toHash)) return;
        this.crc32.update((0, $934c9590050643f0$export$4f21f20c2f1a9063)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, $3d105b71c9af75be$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $3d105b71c9af75be$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $974af2abdf2ad3d3$export$2527dfa2a193fcfa)(this.crc32.digest())
                ];
            });
        });
    };
    AwsCrc32.prototype.reset = function() {
        this.crc32 = new (0, $b839d0c14cc0f1ef$export$16d8d62894c71747)();
    };
    return AwsCrc32;
}();


function $b839d0c14cc0f1ef$export$1cd93882633e45f5(data) {
    return new $b839d0c14cc0f1ef$export$16d8d62894c71747().update(data).digest();
}
var $b839d0c14cc0f1ef$export$16d8d62894c71747 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, $3d105b71c9af75be$export$19a8beecd37a4c45)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $b839d0c14cc0f1ef$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
// prettier-ignore
var $b839d0c14cc0f1ef$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $b839d0c14cc0f1ef$var$lookupTable = (0, $d09e9fb2a083d837$export$b6739cd5a63159f9)($b839d0c14cc0f1ef$var$a_lookUpTable);


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $3880c125ae09a628$export$181d26e642ff1de8 = /** @class */ function() {
    function AwsCrc32c() {
        this.crc32c = new (0, $6f7f6ab2b0ccc617$export$8962a54405366ff2)();
    }
    AwsCrc32c.prototype.update = function(toHash) {
        if ((0, $3c18a85c0a19e10f$export$ea55f474a468804e)(toHash)) return;
        this.crc32c.update((0, $934c9590050643f0$export$4f21f20c2f1a9063)(toHash));
    };
    AwsCrc32c.prototype.digest = function() {
        return (0, $3d105b71c9af75be$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $3d105b71c9af75be$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $974af2abdf2ad3d3$export$2527dfa2a193fcfa)(this.crc32c.digest())
                ];
            });
        });
    };
    AwsCrc32c.prototype.reset = function() {
        this.crc32c = new (0, $6f7f6ab2b0ccc617$export$8962a54405366ff2)();
    };
    return AwsCrc32c;
}();


function $6f7f6ab2b0ccc617$export$dd68a1888523627e(data) {
    return new $6f7f6ab2b0ccc617$export$8962a54405366ff2().update(data).digest();
}
var $6f7f6ab2b0ccc617$export$8962a54405366ff2 = /** @class */ function() {
    function Crc32c() {
        this.checksum = 0xffffffff;
    }
    Crc32c.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, $3d105b71c9af75be$export$19a8beecd37a4c45)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $6f7f6ab2b0ccc617$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32c.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32c;
}();
// prettier-ignore
var $6f7f6ab2b0ccc617$var$a_lookupTable = [
    0x00000000,
    0xF26B8303,
    0xE13B70F7,
    0x1350F3F4,
    0xC79A971F,
    0x35F1141C,
    0x26A1E7E8,
    0xD4CA64EB,
    0x8AD958CF,
    0x78B2DBCC,
    0x6BE22838,
    0x9989AB3B,
    0x4D43CFD0,
    0xBF284CD3,
    0xAC78BF27,
    0x5E133C24,
    0x105EC76F,
    0xE235446C,
    0xF165B798,
    0x030E349B,
    0xD7C45070,
    0x25AFD373,
    0x36FF2087,
    0xC494A384,
    0x9A879FA0,
    0x68EC1CA3,
    0x7BBCEF57,
    0x89D76C54,
    0x5D1D08BF,
    0xAF768BBC,
    0xBC267848,
    0x4E4DFB4B,
    0x20BD8EDE,
    0xD2D60DDD,
    0xC186FE29,
    0x33ED7D2A,
    0xE72719C1,
    0x154C9AC2,
    0x061C6936,
    0xF477EA35,
    0xAA64D611,
    0x580F5512,
    0x4B5FA6E6,
    0xB93425E5,
    0x6DFE410E,
    0x9F95C20D,
    0x8CC531F9,
    0x7EAEB2FA,
    0x30E349B1,
    0xC288CAB2,
    0xD1D83946,
    0x23B3BA45,
    0xF779DEAE,
    0x05125DAD,
    0x1642AE59,
    0xE4292D5A,
    0xBA3A117E,
    0x4851927D,
    0x5B016189,
    0xA96AE28A,
    0x7DA08661,
    0x8FCB0562,
    0x9C9BF696,
    0x6EF07595,
    0x417B1DBC,
    0xB3109EBF,
    0xA0406D4B,
    0x522BEE48,
    0x86E18AA3,
    0x748A09A0,
    0x67DAFA54,
    0x95B17957,
    0xCBA24573,
    0x39C9C670,
    0x2A993584,
    0xD8F2B687,
    0x0C38D26C,
    0xFE53516F,
    0xED03A29B,
    0x1F682198,
    0x5125DAD3,
    0xA34E59D0,
    0xB01EAA24,
    0x42752927,
    0x96BF4DCC,
    0x64D4CECF,
    0x77843D3B,
    0x85EFBE38,
    0xDBFC821C,
    0x2997011F,
    0x3AC7F2EB,
    0xC8AC71E8,
    0x1C661503,
    0xEE0D9600,
    0xFD5D65F4,
    0x0F36E6F7,
    0x61C69362,
    0x93AD1061,
    0x80FDE395,
    0x72966096,
    0xA65C047D,
    0x5437877E,
    0x4767748A,
    0xB50CF789,
    0xEB1FCBAD,
    0x197448AE,
    0x0A24BB5A,
    0xF84F3859,
    0x2C855CB2,
    0xDEEEDFB1,
    0xCDBE2C45,
    0x3FD5AF46,
    0x7198540D,
    0x83F3D70E,
    0x90A324FA,
    0x62C8A7F9,
    0xB602C312,
    0x44694011,
    0x5739B3E5,
    0xA55230E6,
    0xFB410CC2,
    0x092A8FC1,
    0x1A7A7C35,
    0xE811FF36,
    0x3CDB9BDD,
    0xCEB018DE,
    0xDDE0EB2A,
    0x2F8B6829,
    0x82F63B78,
    0x709DB87B,
    0x63CD4B8F,
    0x91A6C88C,
    0x456CAC67,
    0xB7072F64,
    0xA457DC90,
    0x563C5F93,
    0x082F63B7,
    0xFA44E0B4,
    0xE9141340,
    0x1B7F9043,
    0xCFB5F4A8,
    0x3DDE77AB,
    0x2E8E845F,
    0xDCE5075C,
    0x92A8FC17,
    0x60C37F14,
    0x73938CE0,
    0x81F80FE3,
    0x55326B08,
    0xA759E80B,
    0xB4091BFF,
    0x466298FC,
    0x1871A4D8,
    0xEA1A27DB,
    0xF94AD42F,
    0x0B21572C,
    0xDFEB33C7,
    0x2D80B0C4,
    0x3ED04330,
    0xCCBBC033,
    0xA24BB5A6,
    0x502036A5,
    0x4370C551,
    0xB11B4652,
    0x65D122B9,
    0x97BAA1BA,
    0x84EA524E,
    0x7681D14D,
    0x2892ED69,
    0xDAF96E6A,
    0xC9A99D9E,
    0x3BC21E9D,
    0xEF087A76,
    0x1D63F975,
    0x0E330A81,
    0xFC588982,
    0xB21572C9,
    0x407EF1CA,
    0x532E023E,
    0xA145813D,
    0x758FE5D6,
    0x87E466D5,
    0x94B49521,
    0x66DF1622,
    0x38CC2A06,
    0xCAA7A905,
    0xD9F75AF1,
    0x2B9CD9F2,
    0xFF56BD19,
    0x0D3D3E1A,
    0x1E6DCDEE,
    0xEC064EED,
    0xC38D26C4,
    0x31E6A5C7,
    0x22B65633,
    0xD0DDD530,
    0x0417B1DB,
    0xF67C32D8,
    0xE52CC12C,
    0x1747422F,
    0x49547E0B,
    0xBB3FFD08,
    0xA86F0EFC,
    0x5A048DFF,
    0x8ECEE914,
    0x7CA56A17,
    0x6FF599E3,
    0x9D9E1AE0,
    0xD3D3E1AB,
    0x21B862A8,
    0x32E8915C,
    0xC083125F,
    0x144976B4,
    0xE622F5B7,
    0xF5720643,
    0x07198540,
    0x590AB964,
    0xAB613A67,
    0xB831C993,
    0x4A5A4A90,
    0x9E902E7B,
    0x6CFBAD78,
    0x7FAB5E8C,
    0x8DC0DD8F,
    0xE330A81A,
    0x115B2B19,
    0x020BD8ED,
    0xF0605BEE,
    0x24AA3F05,
    0xD6C1BC06,
    0xC5914FF2,
    0x37FACCF1,
    0x69E9F0D5,
    0x9B8273D6,
    0x88D28022,
    0x7AB90321,
    0xAE7367CA,
    0x5C18E4C9,
    0x4F48173D,
    0xBD23943E,
    0xF36E6F75,
    0x0105EC76,
    0x12551F82,
    0xE03E9C81,
    0x34F4F86A,
    0xC69F7B69,
    0xD5CF889D,
    0x27A40B9E,
    0x79B737BA,
    0x8BDCB4B9,
    0x988C474D,
    0x6AE7C44E,
    0xBE2DA0A5,
    0x4C4623A6,
    0x5F16D052,
    0xAD7D5351
];
var $6f7f6ab2b0ccc617$var$lookupTable = (0, $d09e9fb2a083d837$export$b6739cd5a63159f9)($6f7f6ab2b0ccc617$var$a_lookupTable);



const $4caee53359490bc1$export$d3ce400302f6a9a2 = (checksumAlgorithm, config)=>({
        [(0, $e2cc6a122080be57$export$578faf5500e50907).MD5]: config.md5,
        [(0, $e2cc6a122080be57$export$578faf5500e50907).CRC32]: (0, $8a400911e4e0b378$export$ea4992a0ab9eff2d),
        [(0, $e2cc6a122080be57$export$578faf5500e50907).CRC32C]: (0, $3880c125ae09a628$export$181d26e642ff1de8),
        [(0, $e2cc6a122080be57$export$578faf5500e50907).SHA1]: config.sha1,
        [(0, $e2cc6a122080be57$export$578faf5500e50907).SHA256]: config.sha256
    })[checksumAlgorithm];


const $4bb30f9042f6d66d$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $475ab5f8acad1e36$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $4bb30f9042f6d66d$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $babd20f9f8bd393c$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};




const $12a2886a1c152ca8$export$f83388b67aa49343 = (checksumAlgorithmFn, body)=>{
    const hash = new checksumAlgorithmFn();
    hash.update((0, $475ab5f8acad1e36$export$73470fd2221e6aef)(body || ""));
    return hash.digest();
};


const $d305909ca99b9c3b$export$e97fa0bb5e52c630 = {
    name: "flexibleChecksumsMiddleware",
    step: "build",
    tags: [
        "BODY_CHECKSUM"
    ],
    override: true
};
const $d305909ca99b9c3b$export$30415c4d5829592d = (config, middlewareConfig)=>(next, context)=>async (args)=>{
            if (!(0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const { request: request } = args;
            const { body: requestBody, headers: headers } = request;
            const { base64Encoder: base64Encoder, streamHasher: streamHasher } = config;
            const { input: input, requestChecksumRequired: requestChecksumRequired, requestAlgorithmMember: requestAlgorithmMember } = middlewareConfig;
            const checksumAlgorithm = (0, $009cbeb1d7c60656$export$3a8d03296046b4c)(input, {
                requestChecksumRequired: requestChecksumRequired,
                requestAlgorithmMember: requestAlgorithmMember
            }, !!context.isS3ExpressBucket);
            let updatedBody = requestBody;
            let updatedHeaders = headers;
            if (checksumAlgorithm) {
                const checksumLocationName = (0, $0049676f8a5af38a$export$f2b25cbe2b26f44a)(checksumAlgorithm);
                const checksumAlgorithmFn = (0, $4caee53359490bc1$export$d3ce400302f6a9a2)(checksumAlgorithm, config);
                if ((0, $f6a7613004805a91$export$cd8dd85fa30a5026)(requestBody)) {
                    const { getAwsChunkedEncodingStream: getAwsChunkedEncodingStream, bodyLengthChecker: bodyLengthChecker } = config;
                    updatedBody = getAwsChunkedEncodingStream(requestBody, {
                        base64Encoder: base64Encoder,
                        bodyLengthChecker: bodyLengthChecker,
                        checksumLocationName: checksumLocationName,
                        checksumAlgorithmFn: checksumAlgorithmFn,
                        streamHasher: streamHasher
                    });
                    updatedHeaders = {
                        ...headers,
                        "content-encoding": headers["content-encoding"] ? `${headers["content-encoding"]},aws-chunked` : "aws-chunked",
                        "transfer-encoding": "chunked",
                        "x-amz-decoded-content-length": headers["content-length"],
                        "x-amz-content-sha256": "STREAMING-UNSIGNED-PAYLOAD-TRAILER",
                        "x-amz-trailer": checksumLocationName
                    };
                    delete updatedHeaders["content-length"];
                } else if (!(0, $84a87d811e2719bf$export$17944590be865217)(checksumLocationName, headers)) {
                    const rawChecksum = await (0, $12a2886a1c152ca8$export$f83388b67aa49343)(checksumAlgorithmFn, requestBody);
                    updatedHeaders = {
                        ...headers,
                        [checksumLocationName]: base64Encoder(rawChecksum)
                    };
                }
            }
            const result = await next({
                ...args,
                request: {
                    ...request,
                    headers: updatedHeaders,
                    body: updatedBody
                }
            });
            return result;
        };





const $a32d0322f55fe495$export$bd7e95f266f35d51 = (responseAlgorithms = [])=>{
    const validChecksumAlgorithms = [];
    for (const algorithm of (0, $53773d08d7957dec$export$d72f0660fe536945)){
        if (!responseAlgorithms.includes(algorithm) || !(0, $53773d08d7957dec$export$250d41e5cdcdba3f).includes(algorithm)) continue;
        validChecksumAlgorithms.push(algorithm);
    }
    return validChecksumAlgorithms;
};



const $1b3277395f162883$export$5dffae3777201f9f = (checksum)=>{
    const lastHyphenIndex = checksum.lastIndexOf("-");
    if (lastHyphenIndex !== -1) {
        const numberPart = checksum.slice(lastHyphenIndex + 1);
        if (!numberPart.startsWith("0")) {
            const number = parseInt(numberPart, 10);
            if (!isNaN(number) && number >= 1 && number <= 10000) return true;
        }
    }
    return false;
};



function $0e7e6a95a339dcea$export$fbd87226306cddec(buffer) {
    return new Blob([
        buffer
    ]).stream();
}




const $2d0a50272cf9e87d$export$5278aa44d35662c5 = async (body, { streamHasher: streamHasher, checksumAlgorithmFn: checksumAlgorithmFn, base64Encoder: base64Encoder })=>{
    const digest = (0, $f6a7613004805a91$export$cd8dd85fa30a5026)(body) ? streamHasher(checksumAlgorithmFn, body) : (0, $12a2886a1c152ca8$export$f83388b67aa49343)(checksumAlgorithmFn, body);
    return base64Encoder(await digest);
};





const $ad5f3da692f33914$export$562693a02c991a20 = async (response, { config: config, responseAlgorithms: responseAlgorithms })=>{
    const checksumAlgorithms = (0, $a32d0322f55fe495$export$bd7e95f266f35d51)(responseAlgorithms);
    const { body: responseBody, headers: responseHeaders } = response;
    for (const algorithm of checksumAlgorithms){
        const responseHeader = (0, $0049676f8a5af38a$export$f2b25cbe2b26f44a)(algorithm);
        const checksumFromResponse = responseHeaders[responseHeader];
        if (checksumFromResponse) {
            const checksumAlgorithmFn = (0, $4caee53359490bc1$export$d3ce400302f6a9a2)(algorithm, config);
            const { streamHasher: streamHasher, base64Encoder: base64Encoder } = config;
            const checksum = await (0, $2d0a50272cf9e87d$export$5278aa44d35662c5)(responseBody, {
                streamHasher: streamHasher,
                checksumAlgorithmFn: checksumAlgorithmFn,
                base64Encoder: base64Encoder
            });
            if (checksum === checksumFromResponse) break;
            throw new Error(`Checksum mismatch: expected "${checksum}" but received "${checksumFromResponse}"` + ` in response header "${responseHeader}".`);
        }
    }
};


const $128cc1c1ceff0683$export$262e4f452e6a04e3 = {
    name: "flexibleChecksumsResponseMiddleware",
    toMiddleware: "deserializerMiddleware",
    relation: "after",
    tags: [
        "BODY_CHECKSUM"
    ],
    override: true
};
const $128cc1c1ceff0683$export$802a4f094d1189e8 = (config, middlewareConfig)=>(next, context)=>async (args)=>{
            if (!(0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const input = args.input;
            const result = await next(args);
            const response = result.response;
            let collectedStream = undefined;
            const { requestValidationModeMember: requestValidationModeMember, responseAlgorithms: responseAlgorithms } = middlewareConfig;
            if (requestValidationModeMember && input[requestValidationModeMember] === "ENABLED") {
                const { clientName: clientName, commandName: commandName } = context;
                const isS3WholeObjectMultipartGetResponseChecksum = clientName === "S3Client" && commandName === "GetObjectCommand" && (0, $a32d0322f55fe495$export$bd7e95f266f35d51)(responseAlgorithms).every((algorithm)=>{
                    const responseHeader = (0, $0049676f8a5af38a$export$f2b25cbe2b26f44a)(algorithm);
                    const checksumFromResponse = response.headers[responseHeader];
                    return !checksumFromResponse || (0, $1b3277395f162883$export$5dffae3777201f9f)(checksumFromResponse);
                });
                if (isS3WholeObjectMultipartGetResponseChecksum) return result;
                const isStreamingBody = (0, $f6a7613004805a91$export$cd8dd85fa30a5026)(response.body);
                if (isStreamingBody) {
                    collectedStream = await config.streamCollector(response.body);
                    response.body = (0, $0e7e6a95a339dcea$export$fbd87226306cddec)(collectedStream);
                }
                await (0, $ad5f3da692f33914$export$562693a02c991a20)(result.response, {
                    config: config,
                    responseAlgorithms: responseAlgorithms
                });
                if (isStreamingBody && collectedStream) response.body = (0, $0e7e6a95a339dcea$export$fbd87226306cddec)(collectedStream);
            }
            return result;
        };


const $cd0db87ef3895103$export$b3c55b56128dbf17 = (config, middlewareConfig)=>({
        applyToStack: (clientStack)=>{
            clientStack.add((0, $d305909ca99b9c3b$export$30415c4d5829592d)(config, middlewareConfig), (0, $d305909ca99b9c3b$export$e97fa0bb5e52c630));
            clientStack.addRelativeTo((0, $128cc1c1ceff0683$export$802a4f094d1189e8)(config, middlewareConfig), (0, $128cc1c1ceff0683$export$262e4f452e6a04e3));
        }
    });



const $7a2c7cffe65767aa$export$1d3c197393275463 = (context)=>context[0, $73bee794fdd638f0$export$94e7bb1b8aa610cb] || (context[0, $73bee794fdd638f0$export$94e7bb1b8aa610cb] = {});


const $c725887315749781$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};





const $ee8b1ad13783793d$export$7a84fd3751940420 = (input)=>({
        ...input,
        requestChecksumCalculation: (0, $c725887315749781$export$b1276c07738d6325)(input.requestChecksumCalculation ?? (0, $e2cc6a122080be57$export$1fc46fc3555d6f8a)),
        responseChecksumValidation: (0, $c725887315749781$export$b1276c07738d6325)(input.responseChecksumValidation ?? (0, $e2cc6a122080be57$export$f0963351604e1d41))
    });





const $2dd08fc34a84b2f5$var$getAllAliases = (name, aliases)=>{
    const _aliases = [];
    if (name) _aliases.push(name);
    if (aliases) for (const alias of aliases)_aliases.push(alias);
    return _aliases;
};
const $2dd08fc34a84b2f5$var$getMiddlewareNameWithAliases = (name, aliases)=>{
    return `${name || "anonymous"}${aliases && aliases.length > 0 ? ` (a.k.a. ${aliases.join(",")})` : ""}`;
};
const $2dd08fc34a84b2f5$export$73604a93307363d8 = ()=>{
    let absoluteEntries = [];
    let relativeEntries = [];
    let identifyOnResolve = false;
    const entriesNameSet = new Set();
    const sort = (entries)=>entries.sort((a, b)=>$2dd08fc34a84b2f5$var$stepWeights[b.step] - $2dd08fc34a84b2f5$var$stepWeights[a.step] || $2dd08fc34a84b2f5$var$priorityWeights[b.priority || "normal"] - $2dd08fc34a84b2f5$var$priorityWeights[a.priority || "normal"]);
    const removeByName = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            const aliases = $2dd08fc34a84b2f5$var$getAllAliases(entry.name, entry.aliases);
            if (aliases.includes(toRemove)) {
                isRemoved = true;
                for (const alias of aliases)entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const removeByReference = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            if (entry.middleware === toRemove) {
                isRemoved = true;
                for (const alias of $2dd08fc34a84b2f5$var$getAllAliases(entry.name, entry.aliases))entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const cloneTo = (toStack)=>{
        absoluteEntries.forEach((entry)=>{
            toStack.add(entry.middleware, {
                ...entry
            });
        });
        relativeEntries.forEach((entry)=>{
            toStack.addRelativeTo(entry.middleware, {
                ...entry
            });
        });
        toStack.identifyOnResolve?.(stack.identifyOnResolve());
        return toStack;
    };
    const expandRelativeMiddlewareList = (from)=>{
        const expandedMiddlewareList = [];
        from.before.forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        return expandedMiddlewareList;
    };
    const getMiddlewareList = (debug = false)=>{
        const normalizedAbsoluteEntries = [];
        const normalizedRelativeEntries = [];
        const normalizedEntriesNameMap = {};
        absoluteEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $2dd08fc34a84b2f5$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $2dd08fc34a84b2f5$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach((entry)=>{
            if (entry.toMiddleware) {
                const toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error(`${entry.toMiddleware} is not found when adding ` + `${$2dd08fc34a84b2f5$var$getMiddlewareNameWithAliases(entry.name, entry.aliases)} ` + `middleware ${entry.relation} ${entry.toMiddleware}`);
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        const mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce((wholeList, expandedMiddlewareList)=>{
            wholeList.push(...expandedMiddlewareList);
            return wholeList;
        }, []);
        return mainChain;
    };
    const stack = {
        add: (middleware, options = {})=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                step: "initialize",
                priority: "normal",
                middleware: middleware,
                ...options
            };
            const aliases = $2dd08fc34a84b2f5$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$2dd08fc34a84b2f5$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = absoluteEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = absoluteEntries[toOverrideIndex];
                        if (toOverride.step !== entry.step || entry.priority !== toOverride.priority) throw new Error(`"${$2dd08fc34a84b2f5$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware with ` + `${toOverride.priority} priority in ${toOverride.step} step cannot ` + `be overridden by "${$2dd08fc34a84b2f5$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware with ` + `${entry.priority} priority in ${entry.step} step.`);
                        absoluteEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: (middleware, options)=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                middleware: middleware,
                ...options
            };
            const aliases = $2dd08fc34a84b2f5$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$2dd08fc34a84b2f5$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = relativeEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = relativeEntries[toOverrideIndex];
                        if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error(`"${$2dd08fc34a84b2f5$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware ` + `${toOverride.relation} "${toOverride.toMiddleware}" middleware cannot be overridden ` + `by "${$2dd08fc34a84b2f5$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware ${entry.relation} ` + `"${entry.toMiddleware}" middleware.`);
                        relativeEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            relativeEntries.push(entry);
        },
        clone: ()=>cloneTo($2dd08fc34a84b2f5$export$73604a93307363d8()),
        use: (plugin)=>{
            plugin.applyToStack(stack);
        },
        remove: (toRemove)=>{
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: (toRemove)=>{
            let isRemoved = false;
            const filterCb = (entry)=>{
                const { tags: tags, name: name, aliases: _aliases } = entry;
                if (tags && tags.includes(toRemove)) {
                    const aliases = $2dd08fc34a84b2f5$var$getAllAliases(name, _aliases);
                    for (const alias of aliases)entriesNameSet.delete(alias);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: (from)=>{
            const cloned = cloneTo($2dd08fc34a84b2f5$export$73604a93307363d8());
            cloned.use(from);
            cloned.identifyOnResolve(identifyOnResolve || cloned.identifyOnResolve() || (from.identifyOnResolve?.() ?? false));
            return cloned;
        },
        applyToStack: cloneTo,
        identify: ()=>{
            return getMiddlewareList(true).map((mw)=>{
                const step = mw.step ?? mw.relation + " " + mw.toMiddleware;
                return $2dd08fc34a84b2f5$var$getMiddlewareNameWithAliases(mw.name, mw.aliases) + " - " + step;
            });
        },
        identifyOnResolve (toggle) {
            if (typeof toggle === "boolean") identifyOnResolve = toggle;
            return identifyOnResolve;
        },
        resolve: (handler, context)=>{
            for (const middleware of getMiddlewareList().map((entry)=>entry.middleware).reverse())handler = middleware(handler, context);
            if (identifyOnResolve) console.log(stack.identify());
            return handler;
        }
    };
    return stack;
};
const $2dd08fc34a84b2f5$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
const $2dd08fc34a84b2f5$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};




class $995316bf5a2e8647$export$1f2bb630327ac4b6 {
    constructor(config){
        this.config = config;
        this.middlewareStack = (0, $2dd08fc34a84b2f5$export$73604a93307363d8)();
    }
    send(command, optionsOrCb, cb) {
        const options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        const callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        const useHandlerCache = options === undefined && this.config.cacheMiddleware === true;
        let handler;
        if (useHandlerCache) {
            if (!this.handlers) this.handlers = new WeakMap();
            const handlers = this.handlers;
            if (handlers.has(command.constructor)) handler = handlers.get(command.constructor);
            else {
                handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
                handlers.set(command.constructor, handler);
            }
        } else {
            delete this.handlers;
            handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        }
        if (callback) handler(command).then((result)=>callback(null, result.output), (err)=>callback(err)).catch(()=>{});
        else return handler(command).then((result)=>result.output);
    }
    destroy() {
        this.config?.requestHandler?.destroy?.();
        delete this.handlers;
    }
}


const $6af11047dc81ca11$export$7753813254d72972 = {};
const $6af11047dc81ca11$export$8f4022378ddff4c7 = new Array(64);
for(let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    $6af11047dc81ca11$export$7753813254d72972[char] = i;
    $6af11047dc81ca11$export$8f4022378ddff4c7[i] = char;
}
for(let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    $6af11047dc81ca11$export$7753813254d72972[char] = index;
    $6af11047dc81ca11$export$8f4022378ddff4c7[index] = char;
}
for(let i = 0; i < 10; i++){
    $6af11047dc81ca11$export$7753813254d72972[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    $6af11047dc81ca11$export$7753813254d72972[char] = index;
    $6af11047dc81ca11$export$8f4022378ddff4c7[index] = char;
}
$6af11047dc81ca11$export$7753813254d72972["+"] = 62;
$6af11047dc81ca11$export$8f4022378ddff4c7[62] = "+";
$6af11047dc81ca11$export$7753813254d72972["/"] = 63;
$6af11047dc81ca11$export$8f4022378ddff4c7[63] = "/";
const $6af11047dc81ca11$export$1c5cfd5e95b84581 = 6;
const $6af11047dc81ca11$export$79b97ac4c24c9385 = 8;
const $6af11047dc81ca11$export$43e943b030ae3d73 = 63;


const $c9672f02a48da6a7$export$c537b38001c583b7 = (input)=>{
    let totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for(let i = 0; i < input.length; i += 4){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in (0, $6af11047dc81ca11$export$7753813254d72972))) throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
            bits |= (0, $6af11047dc81ca11$export$7753813254d72972)[input[j]] << (limit - j) * (0, $6af11047dc81ca11$export$1c5cfd5e95b84581);
            bitLength += (0, $6af11047dc81ca11$export$1c5cfd5e95b84581);
        } else bits >>= (0, $6af11047dc81ca11$export$1c5cfd5e95b84581);
        const chunkOffset = i / 4 * 3;
        bits >>= bitLength % (0, $6af11047dc81ca11$export$79b97ac4c24c9385);
        const byteLength = Math.floor(bitLength / (0, $6af11047dc81ca11$export$79b97ac4c24c9385));
        for(let k = 0; k < byteLength; k++){
            const offset = (byteLength - k - 1) * (0, $6af11047dc81ca11$export$79b97ac4c24c9385);
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
};




function $8720d4d1690563ba$export$37cc283d8fbd3462(_input) {
    let input;
    if (typeof _input === "string") input = (0, $4bb30f9042f6d66d$export$c7c5cef950a4d2fc)(_input);
    else input = _input;
    const isArrayLike = typeof input === "object" && typeof input.length === "number";
    const isUint8Array = typeof input === "object" && typeof input.byteOffset === "number" && typeof input.byteLength === "number";
    if (!isArrayLike && !isUint8Array) throw new Error("@smithy/util-base64: toBase64 encoder function only accepts string | Uint8Array.");
    let str = "";
    for(let i = 0; i < input.length; i += 3){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * (0, $6af11047dc81ca11$export$79b97ac4c24c9385);
            bitLength += (0, $6af11047dc81ca11$export$79b97ac4c24c9385);
        }
        const bitClusterCount = Math.ceil(bitLength / (0, $6af11047dc81ca11$export$1c5cfd5e95b84581));
        bits <<= bitClusterCount * (0, $6af11047dc81ca11$export$1c5cfd5e95b84581) - bitLength;
        for(let k = 1; k <= bitClusterCount; k++){
            const offset = (bitClusterCount - k) * (0, $6af11047dc81ca11$export$1c5cfd5e95b84581);
            str += (0, $6af11047dc81ca11$export$8f4022378ddff4c7)[(bits & (0, $6af11047dc81ca11$export$43e943b030ae3d73) << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}






function $413e54c9728208be$export$e9aa0d127315abe(payload, encoding = "utf-8") {
    if (encoding === "base64") return (0, $8720d4d1690563ba$export$37cc283d8fbd3462)(payload);
    return (0, $babd20f9f8bd393c$export$b4b216764bb846eb)(payload);
}
function $413e54c9728208be$export$ed8c0e91f57de3aa(str, encoding) {
    if (encoding === "base64") return (0, $fcb073f53110d505$export$1465fbad93f83f0a).mutate((0, $c9672f02a48da6a7$export$c537b38001c583b7)(str));
    return (0, $fcb073f53110d505$export$1465fbad93f83f0a).mutate((0, $4bb30f9042f6d66d$export$c7c5cef950a4d2fc)(str));
}


class $fcb073f53110d505$export$1465fbad93f83f0a extends Uint8Array {
    static fromString(source, encoding = "utf-8") {
        switch(typeof source){
            case "string":
                return (0, $413e54c9728208be$export$ed8c0e91f57de3aa)(source, encoding);
            default:
                throw new Error(`Unsupported conversion from ${typeof source} to Uint8ArrayBlobAdapter.`);
        }
    }
    static mutate(source) {
        Object.setPrototypeOf(source, $fcb073f53110d505$export$1465fbad93f83f0a.prototype);
        return source;
    }
    transformToString(encoding = "utf-8") {
        return (0, $413e54c9728208be$export$e9aa0d127315abe)(this, encoding);
    }
}


const $e62cfc45517db9c1$export$cc0c9507624e70d1 = (readableStream, options)=>{
    const { base64Encoder: base64Encoder, bodyLengthChecker: bodyLengthChecker, checksumAlgorithmFn: checksumAlgorithmFn, checksumLocationName: checksumLocationName, streamHasher: streamHasher } = options;
    const checksumRequired = base64Encoder !== undefined && bodyLengthChecker !== undefined && checksumAlgorithmFn !== undefined && checksumLocationName !== undefined && streamHasher !== undefined;
    const digest = checksumRequired ? streamHasher(checksumAlgorithmFn, readableStream) : undefined;
    const reader = readableStream.getReader();
    return new ReadableStream({
        async pull (controller) {
            const { value: value, done: done } = await reader.read();
            if (done) {
                controller.enqueue(`0\r\n`);
                if (checksumRequired) {
                    const checksum = base64Encoder(await digest);
                    controller.enqueue(`${checksumLocationName}:${checksum}\r\n`);
                    controller.enqueue(`\r\n`);
                }
                controller.close();
            } else controller.enqueue(`${(bodyLengthChecker(value) || 0).toString(16)}\r\n${value}\r\n`);
        }
    });
};



const $3f0644962401f658$export$c3b4775ad75a73db = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $3f0644962401f658$var$hexEncode);
const $3f0644962401f658$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;



const $c10e187ee916d2f3$export$547c045505a754ef = (uri)=>uri.split("/").map((0, $3f0644962401f658$export$c3b4775ad75a73db)).join("/");




function $8077db8a8d173057$export$6b17a39e52c8ee53(query) {
    const parts = [];
    for (let key of Object.keys(query).sort()){
        const value = query[key];
        key = (0, $3f0644962401f658$export$c3b4775ad75a73db)(key);
        if (Array.isArray(value)) for(let i = 0, iLen = value.length; i < iLen; i++)parts.push(`${key}=${(0, $3f0644962401f658$export$c3b4775ad75a73db)(value[i])}`);
        else {
            let qsEntry = key;
            if (value || typeof value === "string") qsEntry += `=${(0, $3f0644962401f658$export$c3b4775ad75a73db)(value)}`;
            parts.push(qsEntry);
        }
    }
    return parts.join("&");
}


function $81dbad425c7ea550$export$363ac302bdbd807b(timeoutInMs = 0) {
    return new Promise((resolve, reject)=>{
        if (timeoutInMs) setTimeout(()=>{
            const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}


const $c39c4ec5e8ff2223$export$3d6343d6ab3191df = {
    supported: undefined
};
class $c39c4ec5e8ff2223$export$83588b87edbfa7e0 {
    static create(instanceOrOptions) {
        if (typeof instanceOrOptions?.handle === "function") return instanceOrOptions;
        return new $c39c4ec5e8ff2223$export$83588b87edbfa7e0(instanceOrOptions);
    }
    constructor(options){
        if (typeof options === "function") this.configProvider = options().then((opts)=>opts || {});
        else {
            this.config = options ?? {};
            this.configProvider = Promise.resolve(this.config);
        }
        if ($c39c4ec5e8ff2223$export$3d6343d6ab3191df.supported === undefined) $c39c4ec5e8ff2223$export$3d6343d6ab3191df.supported = Boolean(typeof Request !== "undefined" && "keepalive" in new Request("https://[::1]"));
    }
    destroy() {}
    async handle(request, { abortSignal: abortSignal } = {}) {
        if (!this.config) this.config = await this.configProvider;
        const requestTimeoutInMs = this.config.requestTimeout;
        const keepAlive = this.config.keepAlive === true;
        const credentials = this.config.credentials;
        if (abortSignal?.aborted) {
            const abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        let path = request.path;
        const queryString = (0, $8077db8a8d173057$export$6b17a39e52c8ee53)(request.query || {});
        if (queryString) path += `?${queryString}`;
        if (request.fragment) path += `#${request.fragment}`;
        let auth = "";
        if (request.username != null || request.password != null) {
            const username = request.username ?? "";
            const password = request.password ?? "";
            auth = `${username}:${password}@`;
        }
        const { port: port, method: method } = request;
        const url = `${request.protocol}//${auth}${request.hostname}${port ? `:${port}` : ""}${path}`;
        const body = method === "GET" || method === "HEAD" ? undefined : request.body;
        const requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method,
            credentials: credentials
        };
        if (this.config?.cache) requestOptions.cache = this.config.cache;
        if (body) requestOptions.duplex = "half";
        if (typeof AbortController !== "undefined") requestOptions.signal = abortSignal;
        if ($c39c4ec5e8ff2223$export$3d6343d6ab3191df.supported) requestOptions.keepalive = keepAlive;
        if (typeof this.config.requestInit === "function") Object.assign(requestOptions, this.config.requestInit(request));
        let removeSignalEventListener = ()=>{};
        const fetchRequest = new Request(url, requestOptions);
        const raceOfPromises = [
            fetch(fetchRequest).then((response)=>{
                const fetchHeaders = response.headers;
                const transformedHeaders = {};
                for (const pair of fetchHeaders.entries())transformedHeaders[pair[0]] = pair[1];
                const hasReadableStream = response.body != undefined;
                if (!hasReadableStream) return response.blob().then((body)=>({
                        response: new (0, $55997741113954a0$export$1d94dfe0d9d1f1e7)({
                            headers: transformedHeaders,
                            reason: response.statusText,
                            statusCode: response.status,
                            body: body
                        })
                    }));
                return {
                    response: new (0, $55997741113954a0$export$1d94dfe0d9d1f1e7)({
                        headers: transformedHeaders,
                        reason: response.statusText,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $81dbad425c7ea550$export$363ac302bdbd807b)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise((resolve, reject)=>{
            const onAbort = ()=>{
                const abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
            if (typeof abortSignal.addEventListener === "function") {
                const signal = abortSignal;
                signal.addEventListener("abort", onAbort, {
                    once: true
                });
                removeSignalEventListener = ()=>signal.removeEventListener("abort", onAbort);
            } else abortSignal.onabort = onAbort;
        }));
        return Promise.race(raceOfPromises).finally(removeSignalEventListener);
    }
    updateHttpClientConfig(key, value) {
        this.config = undefined;
        this.configProvider = this.configProvider.then((config)=>{
            config[key] = value;
            return config;
        });
    }
    httpHandlerConfigs() {
        return this.config ?? {};
    }
}



const $0569814c11087424$export$17bf97b72e307d52 = (stream)=>{
    if (typeof Blob === "function" && stream instanceof Blob) return $0569814c11087424$var$collectBlob(stream);
    return $0569814c11087424$var$collectStream(stream);
};
async function $0569814c11087424$var$collectBlob(blob) {
    const base64 = await $0569814c11087424$var$readToBase64(blob);
    const arrayBuffer = (0, $c9672f02a48da6a7$export$c537b38001c583b7)(base64);
    return new Uint8Array(arrayBuffer);
}
async function $0569814c11087424$var$collectStream(stream) {
    const chunks = [];
    const reader = stream.getReader();
    let isDone = false;
    let length = 0;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            chunks.push(value);
            length += value.length;
        }
        isDone = done;
    }
    const collected = new Uint8Array(length);
    let offset = 0;
    for (const chunk of chunks){
        collected.set(chunk, offset);
        offset += chunk.length;
    }
    return collected;
}
function $0569814c11087424$var$readToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            const result = reader.result ?? "";
            const commaIndex = result.indexOf(",");
            const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = ()=>reject(new Error("Read aborted"));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(blob);
    });
}





const $7ec653e03ba7d829$var$SHORT_TO_HEX = {};
const $7ec653e03ba7d829$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $7ec653e03ba7d829$var$SHORT_TO_HEX[i] = encodedByte;
    $7ec653e03ba7d829$var$HEX_TO_SHORT[encodedByte] = i;
}
function $7ec653e03ba7d829$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $7ec653e03ba7d829$var$HEX_TO_SHORT) out[i / 2] = $7ec653e03ba7d829$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $7ec653e03ba7d829$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $7ec653e03ba7d829$var$SHORT_TO_HEX[bytes[i]];
    return out;
}



const $72e3553c194c7737$export$ac613ff475b69d05 = (stream)=>typeof ReadableStream === "function" && (stream?.constructor?.name === ReadableStream.name || stream instanceof ReadableStream);


const $70720bd4dd28b6bd$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED = "The stream has already been transformed.";
const $70720bd4dd28b6bd$export$5f9760b56bbf9f65 = (stream)=>{
    if (!$70720bd4dd28b6bd$var$isBlobInstance(stream) && !(0, $72e3553c194c7737$export$ac613ff475b69d05)(stream)) {
        const name = stream?.__proto__?.constructor?.name || stream;
        throw new Error(`Unexpected stream implementation, expect Blob or ReadableStream, got ${name}`);
    }
    let transformed = false;
    const transformToByteArray = async ()=>{
        if (transformed) throw new Error($70720bd4dd28b6bd$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
        transformed = true;
        return await (0, $0569814c11087424$export$17bf97b72e307d52)(stream);
    };
    const blobToWebStream = (blob)=>{
        if (typeof blob.stream !== "function") throw new Error("Cannot transform payload Blob to web stream. Please make sure the Blob.stream() is polyfilled.\nIf you are using React Native, this API is not yet supported, see: https://react-native.canny.io/feature-requests/p/fetch-streaming-body");
        return blob.stream();
    };
    return Object.assign(stream, {
        transformToByteArray: transformToByteArray,
        transformToString: async (encoding)=>{
            const buf = await transformToByteArray();
            if (encoding === "base64") return (0, $8720d4d1690563ba$export$37cc283d8fbd3462)(buf);
            else if (encoding === "hex") return (0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(buf);
            else if (encoding === undefined || encoding === "utf8" || encoding === "utf-8") return (0, $babd20f9f8bd393c$export$b4b216764bb846eb)(buf);
            else if (typeof TextDecoder === "function") return new TextDecoder(encoding).decode(buf);
            else throw new Error("TextDecoder is not available, please make sure polyfill is provided.");
        },
        transformToWebStream: ()=>{
            if (transformed) throw new Error($70720bd4dd28b6bd$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
            transformed = true;
            if ($70720bd4dd28b6bd$var$isBlobInstance(stream)) return blobToWebStream(stream);
            else if ((0, $72e3553c194c7737$export$ac613ff475b69d05)(stream)) return stream;
            else throw new Error(`Cannot transform payload to web stream, got ${stream}`);
        }
    });
};
const $70720bd4dd28b6bd$var$isBlobInstance = (stream)=>typeof Blob === "function" && stream instanceof Blob;


async function $8e867538439bdc40$export$e0d279bcdde969f4(stream) {
    if (typeof stream.stream === "function") stream = stream.stream();
    const readableStream = stream;
    return readableStream.tee();
}


async function $98e41a3adb6f1aeb$export$c5bd1fa662e233aa(stream, bytes) {
    let byteLengthCounter = 0;
    const chunks = [];
    const reader = stream.getReader();
    let isDone = false;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            chunks.push(value);
            byteLengthCounter += value?.byteLength ?? 0;
        }
        if (byteLengthCounter >= bytes) break;
        isDone = done;
    }
    reader.releaseLock();
    const collected = new Uint8Array(Math.min(bytes, byteLengthCounter));
    let offset = 0;
    for (const chunk of chunks){
        if (chunk.byteLength > collected.byteLength - offset) {
            collected.set(chunk.subarray(0, collected.byteLength - offset), offset);
            break;
        } else collected.set(chunk, offset);
        offset += chunk.length;
    }
    return collected;
}





const $9778ece3ddcb3b83$export$3392bcddb824e5ca = async (streamBody = new Uint8Array(), context)=>{
    if (streamBody instanceof Uint8Array) return (0, $fcb073f53110d505$export$1465fbad93f83f0a).mutate(streamBody);
    if (!streamBody) return (0, $fcb073f53110d505$export$1465fbad93f83f0a).mutate(new Uint8Array());
    const fromContext = context.streamCollector(streamBody);
    return (0, $fcb073f53110d505$export$1465fbad93f83f0a).mutate(await fromContext);
};




class $21ebe134f0322abe$export$cc7e12c76513e857 {
    constructor(){
        this.middlewareStack = (0, $2dd08fc34a84b2f5$export$73604a93307363d8)();
    }
    static classBuilder() {
        return new $21ebe134f0322abe$var$ClassBuilder();
    }
    resolveMiddlewareWithContext(clientStack, configuration, options, { middlewareFn: middlewareFn, clientName: clientName, commandName: commandName, inputFilterSensitiveLog: inputFilterSensitiveLog, outputFilterSensitiveLog: outputFilterSensitiveLog, smithyContext: smithyContext, additionalContext: additionalContext, CommandCtor: CommandCtor }) {
        for (const mw of middlewareFn.bind(this)(CommandCtor, clientStack, configuration, options))this.middlewareStack.use(mw);
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: inputFilterSensitiveLog,
            outputFilterSensitiveLog: outputFilterSensitiveLog,
            [(0, $73bee794fdd638f0$export$94e7bb1b8aa610cb)]: {
                commandInstance: this,
                ...smithyContext
            },
            ...additionalContext
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
}
class $21ebe134f0322abe$var$ClassBuilder {
    constructor(){
        this._init = ()=>{};
        this._ep = {};
        this._middlewareFn = ()=>[];
        this._commandName = "";
        this._clientName = "";
        this._additionalContext = {};
        this._smithyContext = {};
        this._inputFilterSensitiveLog = (_)=>_;
        this._outputFilterSensitiveLog = (_)=>_;
        this._serializer = null;
        this._deserializer = null;
    }
    init(cb) {
        this._init = cb;
    }
    ep(endpointParameterInstructions) {
        this._ep = endpointParameterInstructions;
        return this;
    }
    m(middlewareSupplier) {
        this._middlewareFn = middlewareSupplier;
        return this;
    }
    s(service, operation, smithyContext = {}) {
        this._smithyContext = {
            service: service,
            operation: operation,
            ...smithyContext
        };
        return this;
    }
    c(additionalContext = {}) {
        this._additionalContext = additionalContext;
        return this;
    }
    n(clientName, commandName) {
        this._clientName = clientName;
        this._commandName = commandName;
        return this;
    }
    f(inputFilter = (_)=>_, outputFilter = (_)=>_) {
        this._inputFilterSensitiveLog = inputFilter;
        this._outputFilterSensitiveLog = outputFilter;
        return this;
    }
    ser(serializer) {
        this._serializer = serializer;
        return this;
    }
    de(deserializer) {
        this._deserializer = deserializer;
        return this;
    }
    build() {
        const closure = this;
        let CommandRef;
        return CommandRef = class extends $21ebe134f0322abe$export$cc7e12c76513e857 {
            static getEndpointParameterInstructions() {
                return closure._ep;
            }
            constructor(...[input]){
                super();
                this.serialize = closure._serializer;
                this.deserialize = closure._deserializer;
                this.input = input ?? {};
                closure._init(this);
            }
            resolveMiddleware(stack, configuration, options) {
                return this.resolveMiddlewareWithContext(stack, configuration, options, {
                    CommandCtor: CommandRef,
                    middlewareFn: closure._middlewareFn,
                    clientName: closure._clientName,
                    commandName: closure._commandName,
                    inputFilterSensitiveLog: closure._inputFilterSensitiveLog,
                    outputFilterSensitiveLog: closure._outputFilterSensitiveLog,
                    smithyContext: closure._smithyContext,
                    additionalContext: closure._additionalContext
                });
            }
        };
    }
}


const $77149509850e94fa$export$17127055dc9ac067 = "***SensitiveInformation***";


const $553063449aff052c$export$d13079724e1f0e8b = (commands, Client)=>{
    for (const command of Object.keys(commands)){
        const CommandCtor = commands[command];
        const methodImpl = async function(args, optionsOrCb, cb) {
            const command = new CommandCtor(args);
            if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
            else if (typeof cb === "function") {
                if (typeof optionsOrCb !== "object") throw new Error(`Expected http options but got ${typeof optionsOrCb}`);
                this.send(command, optionsOrCb || {}, cb);
            } else return this.send(command, optionsOrCb);
        };
        const methodName = (command[0].toLowerCase() + command.slice(1)).replace(/Command$/, "");
        Client.prototype[methodName] = methodImpl;
    }
};


const $ffdcd55bd2051dc8$export$3fb54149990fb5b5 = (value)=>{
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error(`Unable to parse boolean value "${value}"`);
    }
};
const $ffdcd55bd2051dc8$export$259b2ebfc29bf466 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) $ffdcd55bd2051dc8$export$af88d00dbe7f521.warn($ffdcd55bd2051dc8$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        const lower = value.toLowerCase();
        if (lower === "false" || lower === "true") $ffdcd55bd2051dc8$export$af88d00dbe7f521.warn($ffdcd55bd2051dc8$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError(`Expected boolean, got ${typeof value}: ${value}`);
};
const $ffdcd55bd2051dc8$export$f3945e48fdb5f9a = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) $ffdcd55bd2051dc8$export$af88d00dbe7f521.warn($ffdcd55bd2051dc8$var$stackTraceWarning(`Expected number but observed string: ${value}`));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError(`Expected number, got ${typeof value}: ${value}`);
};
const $ffdcd55bd2051dc8$var$MAX_FLOAT = Math.ceil(2 ** 127 * (2 - 2 ** -23));
const $ffdcd55bd2051dc8$export$44880ec4d8d4909d = (value)=>{
    const expected = $ffdcd55bd2051dc8$export$f3945e48fdb5f9a(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > $ffdcd55bd2051dc8$var$MAX_FLOAT) throw new TypeError(`Expected 32-bit float, got ${value}`);
    }
    return expected;
};
const $ffdcd55bd2051dc8$export$a883517a83c9c18 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError(`Expected integer, got ${typeof value}: ${value}`);
};
const $ffdcd55bd2051dc8$export$dbec7593c34ded08 = $ffdcd55bd2051dc8$export$a883517a83c9c18;
const $ffdcd55bd2051dc8$export$99c64e845cdac9c1 = (value)=>$ffdcd55bd2051dc8$var$expectSizedInt(value, 32);
const $ffdcd55bd2051dc8$export$d4f903340b146129 = (value)=>$ffdcd55bd2051dc8$var$expectSizedInt(value, 16);
const $ffdcd55bd2051dc8$export$3e4c4435b3b19562 = (value)=>$ffdcd55bd2051dc8$var$expectSizedInt(value, 8);
const $ffdcd55bd2051dc8$var$expectSizedInt = (value, size)=>{
    const expected = $ffdcd55bd2051dc8$export$a883517a83c9c18(value);
    if (expected !== undefined && $ffdcd55bd2051dc8$var$castInt(expected, size) !== expected) throw new TypeError(`Expected ${size}-bit integer, got ${value}`);
    return expected;
};
const $ffdcd55bd2051dc8$var$castInt = (value, size)=>{
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
const $ffdcd55bd2051dc8$export$8413a63dbe548a49 = (value, location)=>{
    if (value === null || value === undefined) {
        if (location) throw new TypeError(`Expected a non-null value for ${location}`);
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
const $ffdcd55bd2051dc8$export$cf825aadce530e7e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    const receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError(`Expected object, got ${receivedType}: ${value}`);
};
const $ffdcd55bd2051dc8$export$7ed80f53fe336639 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        $ffdcd55bd2051dc8$export$af88d00dbe7f521.warn($ffdcd55bd2051dc8$var$stackTraceWarning(`Expected string, got ${typeof value}: ${value}`));
        return String(value);
    }
    throw new TypeError(`Expected string, got ${typeof value}: ${value}`);
};
const $ffdcd55bd2051dc8$export$9ef77073e45b6301 = (value)=>{
    if (value === null || value === undefined) return undefined;
    const asObject = $ffdcd55bd2051dc8$export$cf825aadce530e7e(value);
    const setKeys = Object.entries(asObject).filter(([, v])=>v != null).map(([k])=>k);
    if (setKeys.length === 0) throw new TypeError(`Unions must have exactly one non-null member. None were found.`);
    if (setKeys.length > 1) throw new TypeError(`Unions must have exactly one non-null member. Keys ${setKeys} were not null.`);
    return asObject;
};
const $ffdcd55bd2051dc8$export$89e17ed633a86621 = (value)=>{
    if (typeof value == "string") return $ffdcd55bd2051dc8$export$f3945e48fdb5f9a($ffdcd55bd2051dc8$var$parseNumber(value));
    return $ffdcd55bd2051dc8$export$f3945e48fdb5f9a(value);
};
const $ffdcd55bd2051dc8$export$884f8e3b42a6cfbf = $ffdcd55bd2051dc8$export$89e17ed633a86621;
const $ffdcd55bd2051dc8$export$b15cbcea8b4c492f = (value)=>{
    if (typeof value == "string") return $ffdcd55bd2051dc8$export$44880ec4d8d4909d($ffdcd55bd2051dc8$var$parseNumber(value));
    return $ffdcd55bd2051dc8$export$44880ec4d8d4909d(value);
};
const $ffdcd55bd2051dc8$var$NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
const $ffdcd55bd2051dc8$var$parseNumber = (value)=>{
    const matches = value.match($ffdcd55bd2051dc8$var$NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError(`Expected real number, got implicit NaN`);
    return parseFloat(value);
};
const $ffdcd55bd2051dc8$export$11335e83c8af2784 = (value)=>{
    if (typeof value == "string") return $ffdcd55bd2051dc8$var$parseFloatString(value);
    return $ffdcd55bd2051dc8$export$f3945e48fdb5f9a(value);
};
const $ffdcd55bd2051dc8$export$b6a7906d2e4b31df = $ffdcd55bd2051dc8$export$11335e83c8af2784;
const $ffdcd55bd2051dc8$export$50b04c19f942a079 = $ffdcd55bd2051dc8$export$11335e83c8af2784;
const $ffdcd55bd2051dc8$export$f14938f3036dd492 = (value)=>{
    if (typeof value == "string") return $ffdcd55bd2051dc8$var$parseFloatString(value);
    return $ffdcd55bd2051dc8$export$44880ec4d8d4909d(value);
};
const $ffdcd55bd2051dc8$var$parseFloatString = (value)=>{
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error(`Unable to parse float value: ${value}`);
    }
};
const $ffdcd55bd2051dc8$export$f90617f39a736d36 = (value)=>{
    if (typeof value === "string") return $ffdcd55bd2051dc8$export$a883517a83c9c18($ffdcd55bd2051dc8$var$parseNumber(value));
    return $ffdcd55bd2051dc8$export$a883517a83c9c18(value);
};
const $ffdcd55bd2051dc8$export$39b7be5d28a09fe1 = $ffdcd55bd2051dc8$export$f90617f39a736d36;
const $ffdcd55bd2051dc8$export$c3c2f00b115709e6 = (value)=>{
    if (typeof value === "string") return $ffdcd55bd2051dc8$export$99c64e845cdac9c1($ffdcd55bd2051dc8$var$parseNumber(value));
    return $ffdcd55bd2051dc8$export$99c64e845cdac9c1(value);
};
const $ffdcd55bd2051dc8$export$813d4a13f25c6b38 = (value)=>{
    if (typeof value === "string") return $ffdcd55bd2051dc8$export$d4f903340b146129($ffdcd55bd2051dc8$var$parseNumber(value));
    return $ffdcd55bd2051dc8$export$d4f903340b146129(value);
};
const $ffdcd55bd2051dc8$export$f18d20ea3b6b353 = (value)=>{
    if (typeof value === "string") return $ffdcd55bd2051dc8$export$3e4c4435b3b19562($ffdcd55bd2051dc8$var$parseNumber(value));
    return $ffdcd55bd2051dc8$export$3e4c4435b3b19562(value);
};
const $ffdcd55bd2051dc8$var$stackTraceWarning = (message)=>{
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter((s)=>!s.includes("stackTraceWarning")).join("\n");
};
const $ffdcd55bd2051dc8$export$af88d00dbe7f521 = {
    warn: console.warn
};


const $9ced97d9f13aecca$var$DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $9ced97d9f13aecca$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $9ced97d9f13aecca$export$5b50865171ed23a9(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const dayOfWeek = date.getUTCDay();
    const dayOfMonthInt = date.getUTCDate();
    const hoursInt = date.getUTCHours();
    const minutesInt = date.getUTCMinutes();
    const secondsInt = date.getUTCSeconds();
    const dayOfMonthString = dayOfMonthInt < 10 ? `0${dayOfMonthInt}` : `${dayOfMonthInt}`;
    const hoursString = hoursInt < 10 ? `0${hoursInt}` : `${hoursInt}`;
    const minutesString = minutesInt < 10 ? `0${minutesInt}` : `${minutesInt}`;
    const secondsString = secondsInt < 10 ? `0${secondsInt}` : `${secondsInt}`;
    return `${$9ced97d9f13aecca$var$DAYS[dayOfWeek]}, ${dayOfMonthString} ${$9ced97d9f13aecca$var$MONTHS[month]} ${year} ${hoursString}:${minutesString}:${secondsString} GMT`;
}
const $9ced97d9f13aecca$var$RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
const $9ced97d9f13aecca$export$202e14f4d6038b6c = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $9ced97d9f13aecca$var$RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds] = match;
    const year = (0, $ffdcd55bd2051dc8$export$813d4a13f25c6b38)($9ced97d9f13aecca$var$stripLeadingZeroes(yearStr));
    const month = $9ced97d9f13aecca$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $9ced97d9f13aecca$var$parseDateValue(dayStr, "day", 1, 31);
    return $9ced97d9f13aecca$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
const $9ced97d9f13aecca$var$RFC3339_WITH_OFFSET = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(([-+]\d{2}\:\d{2})|[zZ])$/);
const $9ced97d9f13aecca$export$3cb821e2875b4b7d = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $9ced97d9f13aecca$var$RFC3339_WITH_OFFSET.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, offsetStr] = match;
    const year = (0, $ffdcd55bd2051dc8$export$813d4a13f25c6b38)($9ced97d9f13aecca$var$stripLeadingZeroes(yearStr));
    const month = $9ced97d9f13aecca$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $9ced97d9f13aecca$var$parseDateValue(dayStr, "day", 1, 31);
    const date = $9ced97d9f13aecca$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
    if (offsetStr.toUpperCase() != "Z") date.setTime(date.getTime() - $9ced97d9f13aecca$var$parseOffsetToMilliseconds(offsetStr));
    return date;
};
const $9ced97d9f13aecca$var$IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $9ced97d9f13aecca$var$RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $9ced97d9f13aecca$var$ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
const $9ced97d9f13aecca$export$cf3a566289648a1e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    let match = $9ced97d9f13aecca$var$IMF_FIXDATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $9ced97d9f13aecca$var$buildDate((0, $ffdcd55bd2051dc8$export$813d4a13f25c6b38)($9ced97d9f13aecca$var$stripLeadingZeroes(yearStr)), $9ced97d9f13aecca$var$parseMonthByShortName(monthStr), $9ced97d9f13aecca$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = $9ced97d9f13aecca$var$RFC_850_DATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $9ced97d9f13aecca$var$adjustRfc850Year($9ced97d9f13aecca$var$buildDate($9ced97d9f13aecca$var$parseTwoDigitYear(yearStr), $9ced97d9f13aecca$var$parseMonthByShortName(monthStr), $9ced97d9f13aecca$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = $9ced97d9f13aecca$var$ASC_TIME.exec(value);
    if (match) {
        const [_, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, yearStr] = match;
        return $9ced97d9f13aecca$var$buildDate((0, $ffdcd55bd2051dc8$export$813d4a13f25c6b38)($9ced97d9f13aecca$var$stripLeadingZeroes(yearStr)), $9ced97d9f13aecca$var$parseMonthByShortName(monthStr), $9ced97d9f13aecca$var$parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
const $9ced97d9f13aecca$export$685da212e4e79e10 = (value)=>{
    if (value === null || value === undefined) return undefined;
    let valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, $ffdcd55bd2051dc8$export$89e17ed633a86621)(value);
    else if (typeof value === "object" && value.tag === 1) valueAsDouble = value.value;
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
const $9ced97d9f13aecca$var$buildDate = (year, month, day, time)=>{
    const adjustedMonth = month - 1;
    $9ced97d9f13aecca$var$validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, $9ced97d9f13aecca$var$parseDateValue(time.hours, "hour", 0, 23), $9ced97d9f13aecca$var$parseDateValue(time.minutes, "minute", 0, 59), $9ced97d9f13aecca$var$parseDateValue(time.seconds, "seconds", 0, 60), $9ced97d9f13aecca$var$parseMilliseconds(time.fractionalMilliseconds)));
};
const $9ced97d9f13aecca$var$parseTwoDigitYear = (value)=>{
    const thisYear = new Date().getUTCFullYear();
    const valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, $ffdcd55bd2051dc8$export$813d4a13f25c6b38)($9ced97d9f13aecca$var$stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
const $9ced97d9f13aecca$var$FIFTY_YEARS_IN_MILLIS = 1576800000000;
const $9ced97d9f13aecca$var$adjustRfc850Year = (input)=>{
    if (input.getTime() - new Date().getTime() > $9ced97d9f13aecca$var$FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
const $9ced97d9f13aecca$var$parseMonthByShortName = (value)=>{
    const monthIdx = $9ced97d9f13aecca$var$MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError(`Invalid month: ${value}`);
    return monthIdx + 1;
};
const $9ced97d9f13aecca$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $9ced97d9f13aecca$var$validateDayOfMonth = (year, month, day)=>{
    let maxDays = $9ced97d9f13aecca$var$DAYS_IN_MONTH[month];
    if (month === 1 && $9ced97d9f13aecca$var$isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError(`Invalid day for ${$9ced97d9f13aecca$var$MONTHS[month]} in ${year}: ${day}`);
};
const $9ced97d9f13aecca$var$isLeapYear = (year)=>{
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
const $9ced97d9f13aecca$var$parseDateValue = (value, type, lower, upper)=>{
    const dateVal = (0, $ffdcd55bd2051dc8$export$f18d20ea3b6b353)($9ced97d9f13aecca$var$stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError(`${type} must be between ${lower} and ${upper}, inclusive`);
    return dateVal;
};
const $9ced97d9f13aecca$var$parseMilliseconds = (value)=>{
    if (value === null || value === undefined) return 0;
    return (0, $ffdcd55bd2051dc8$export$b15cbcea8b4c492f)("0." + value) * 1000;
};
const $9ced97d9f13aecca$var$parseOffsetToMilliseconds = (value)=>{
    const directionStr = value[0];
    let direction = 1;
    if (directionStr == "+") direction = 1;
    else if (directionStr == "-") direction = -1;
    else throw new TypeError(`Offset direction, ${directionStr}, must be "+" or "-"`);
    const hour = Number(value.substring(1, 3));
    const minute = Number(value.substring(4, 6));
    return direction * (hour * 60 + minute) * 60000;
};
const $9ced97d9f13aecca$var$stripLeadingZeroes = (value)=>{
    let idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};


class $d8c529a0bf92abea$export$29647f3b4097d3c0 extends Error {
    constructor(options){
        super(options.message);
        Object.setPrototypeOf(this, $d8c529a0bf92abea$export$29647f3b4097d3c0.prototype);
        this.name = options.name;
        this.$fault = options.$fault;
        this.$metadata = options.$metadata;
    }
}
const $d8c529a0bf92abea$export$db01f0c43e877a50 = (exception, additions = {})=>{
    Object.entries(additions).filter(([, v])=>v !== undefined).forEach(([k, v])=>{
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    const message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};


const $566c2d1ff609c075$export$3df0f68aaf858737 = ({ output: output, parsedBody: parsedBody, exceptionCtor: exceptionCtor, errorCode: errorCode })=>{
    const $metadata = $566c2d1ff609c075$var$deserializeMetadata(output);
    const statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    const response = new exceptionCtor({
        name: parsedBody?.code || parsedBody?.Code || errorCode || statusCode || "UnknownError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(response, parsedBody);
};
const $566c2d1ff609c075$export$62ac8acba1748a85 = (ExceptionCtor)=>{
    return ({ output: output, parsedBody: parsedBody, errorCode: errorCode })=>{
        $566c2d1ff609c075$export$3df0f68aaf858737({
            output: output,
            parsedBody: parsedBody,
            exceptionCtor: ExceptionCtor,
            errorCode: errorCode
        });
    };
};
const $566c2d1ff609c075$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });


const $9921fb7c76704fbf$export$b6e2b46631b45a92 = (mode)=>{
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};


let $9f19aca0949e6f21$var$warningEmitted = false;
const $9f19aca0949e6f21$export$96550b8fa3e6f65a = (version)=>{
    if (version && !$9f19aca0949e6f21$var$warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 16) $9f19aca0949e6f21$var$warningEmitted = true;
};



function $c853d4234a3c782c$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}



const $d94133b5772e5548$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    for(const id in 0, $2faf1e30c31ae8de$export$fe562bf21391d1f0){
        const algorithmId = (0, $2faf1e30c31ae8de$export$fe562bf21391d1f0)[id];
        if (runtimeConfig[algorithmId] === undefined) continue;
        checksumAlgorithms.push({
            algorithmId: ()=>algorithmId,
            checksumConstructor: ()=>runtimeConfig[algorithmId]
        });
    }
    return {
        _checksumAlgorithms: checksumAlgorithms,
        addChecksumAlgorithm (algo) {
            this._checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return this._checksumAlgorithms;
        }
    };
};
const $d94133b5772e5548$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};


const $a4d872036fd33ead$export$d36c8ee6d99d60f7 = (runtimeConfig)=>{
    let _retryStrategy = runtimeConfig.retryStrategy;
    return {
        setRetryStrategy (retryStrategy) {
            _retryStrategy = retryStrategy;
        },
        retryStrategy () {
            return _retryStrategy;
        }
    };
};
const $a4d872036fd33ead$export$67f4c4448e6afddf = (retryStrategyConfiguration)=>{
    const runtimeConfig = {};
    runtimeConfig.retryStrategy = retryStrategyConfiguration.retryStrategy();
    return runtimeConfig;
};


const $78752e0d620fa58e$export$2d53aaae46f156f5 = (runtimeConfig)=>{
    return {
        ...(0, $d94133b5772e5548$export$129b301e72591856)(runtimeConfig),
        ...(0, $a4d872036fd33ead$export$d36c8ee6d99d60f7)(runtimeConfig)
    };
};
const $78752e0d620fa58e$export$7081660fd0cd662b = $78752e0d620fa58e$export$2d53aaae46f156f5;
const $78752e0d620fa58e$export$abfa28b95316e0ae = (config)=>{
    return {
        ...(0, $d94133b5772e5548$export$589dfc268e61d391)(config),
        ...(0, $a4d872036fd33ead$export$67f4c4448e6afddf)(config)
    };
};




const $6eb87c253cabe879$export$52272e038712c64e = (mayBeArray)=>Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];


const $9a9a930f3b2c2043$export$113d90026b452881 = (obj)=>{
    const textNodeName = "#text";
    for(const key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $9a9a930f3b2c2043$export$113d90026b452881(obj[key]);
    }
    return obj;
};


const $bb1a032aa13f75dc$export$f25742720bcd7d1c = (value)=>{
    return value != null;
};


const $44a5914fa1e8e76c$export$40e2db4f1ce24b10 = function() {
    const Class = Object.getPrototypeOf(this).constructor;
    const Constructor = Function.bind.apply(String, [
        null,
        ...arguments
    ]);
    const instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$44a5914fa1e8e76c$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $44a5914fa1e8e76c$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($44a5914fa1e8e76c$export$40e2db4f1ce24b10, String);
class $44a5914fa1e8e76c$export$494ed5148690ecaf extends $44a5914fa1e8e76c$export$40e2db4f1ce24b10 {
    deserializeJSON() {
        return JSON.parse(super.toString());
    }
    toJSON() {
        return super.toString();
    }
    static fromObject(object) {
        if (object instanceof $44a5914fa1e8e76c$export$494ed5148690ecaf) return object;
        else if (object instanceof String || typeof object === "string") return new $44a5914fa1e8e76c$export$494ed5148690ecaf(object);
        return new $44a5914fa1e8e76c$export$494ed5148690ecaf(JSON.stringify(object));
    }
}


class $2a2593fbf5316f50$export$4147bde06f294c2e {
    trace() {}
    debug() {}
    info() {}
    warn() {}
    error() {}
}


function $ff5db7a53b053938$export$871de8747c9eaa88(arg0, arg1, arg2) {
    let target;
    let filter;
    let instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return $ff5db7a53b053938$var$mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    for (const key of Object.keys(instructions)){
        if (!Array.isArray(instructions[key])) {
            target[key] = instructions[key];
            continue;
        }
        $ff5db7a53b053938$var$applyInstruction(target, null, instructions, key);
    }
    return target;
}
const $ff5db7a53b053938$export$a2c0df515c751f13 = (target)=>{
    const output = {};
    for (const [k, v] of Object.entries(target || {}))output[k] = [
        ,
        v
    ];
    return output;
};
const $ff5db7a53b053938$export$b7df5d561049483a = (source, instructions)=>{
    const out = {};
    for(const key in instructions)$ff5db7a53b053938$var$applyInstruction(out, source, instructions, key);
    return out;
};
const $ff5db7a53b053938$var$mapWithFilter = (target, filter, instructions)=>{
    return $ff5db7a53b053938$export$871de8747c9eaa88(target, Object.entries(instructions).reduce((_instructions, [key, value])=>{
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};
const $ff5db7a53b053938$var$applyInstruction = (target, source, instructions, targetKey)=>{
    if (source !== null) {
        let instruction = instructions[targetKey];
        if (typeof instruction === "function") instruction = [
            ,
            instruction
        ];
        const [filter = $ff5db7a53b053938$var$nonNullish, valueFn = $ff5db7a53b053938$var$pass, sourceKey = targetKey] = instruction;
        if (typeof filter === "function" && filter(source[sourceKey]) || typeof filter !== "function" && !!filter) target[targetKey] = valueFn(source[sourceKey]);
        return;
    }
    let [filter, value] = instructions[targetKey];
    if (typeof value === "function") {
        let _value;
        const defaultFilterPassed = filter === undefined && (_value = value()) != null;
        const customFilterPassed = typeof filter === "function" && !!filter(void 0) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed) target[targetKey] = _value;
        else if (customFilterPassed) target[targetKey] = value();
    } else {
        const defaultFilterPassed = filter === undefined && value != null;
        const customFilterPassed = typeof filter === "function" && !!filter(value) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed || customFilterPassed) target[targetKey] = value;
    }
};
const $ff5db7a53b053938$var$nonNullish = (_)=>_ != null;
const $ff5db7a53b053938$var$pass = (_)=>_;




const $795414bc2cb832ad$export$405ac9a9ce1cbd80 = (resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel)=>{
    if (input != null && input[memberName] !== undefined) {
        const labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath = resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map((segment)=>(0, $c853d4234a3c782c$export$7640f3c16fe7f54b)(segment)).join("/") : (0, $c853d4234a3c782c$export$7640f3c16fe7f54b)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath;
};


const $65a9c6a67b0b3f34$export$4a2bea4ecaa09ba7 = (value)=>{
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};
const $65a9c6a67b0b3f34$export$93f3a0dd288ea1c8 = (date)=>date.toISOString().replace(".000Z", "Z");


const $10d38ed990d9b769$export$e0ede334cf6ab53c = (obj)=>{
    if (obj == null) return {};
    if (Array.isArray(obj)) return obj.filter((_)=>_ != null).map($10d38ed990d9b769$export$e0ede334cf6ab53c);
    if (typeof obj === "object") {
        const target = {};
        for (const key of Object.keys(obj)){
            if (obj[key] == null) continue;
            target[key] = $10d38ed990d9b769$export$e0ede334cf6ab53c(obj[key]);
        }
        return target;
    }
    return obj;
};


function $d0b217095e23058e$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    const segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    const compoundSegments = [];
    let currentSegment = "";
    for(let i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}




const $c293dde488c95061$var$CONTENT_LENGTH_HEADER = "content-length";
function $c293dde488c95061$export$ef1b67e0faf37c57() {
    return (next, context)=>async (args)=>{
            const { request: request } = args;
            if ((0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(request)) {
                if (!($c293dde488c95061$var$CONTENT_LENGTH_HEADER in request.headers)) {
                    const message = `Are you using a Stream of unknown length as the Body of a PutObject request? Consider using Upload instead from @aws-sdk/lib-storage.`;
                    if (typeof context?.logger?.warn === "function" && !(context.logger instanceof (0, $2a2593fbf5316f50$export$4147bde06f294c2e))) context.logger.warn(message);
                    else console.warn(message);
                }
            }
            return next({
                ...args
            });
        };
}
const $c293dde488c95061$export$cf4a6daea5f975c7 = {
    step: "finalizeRequest",
    tags: [
        "CHECK_CONTENT_LENGTH_HEADER"
    ],
    name: "getCheckContentLengthHeaderPlugin",
    override: true
};
const $c293dde488c95061$export$9cab92d587daac23 = (unused)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($c293dde488c95061$export$ef1b67e0faf37c57(), $c293dde488c95061$export$cf4a6daea5f975c7);
        }
    });


const $4403176c1e3a080a$export$2c92ca6b49a3d200 = (config)=>{
    return (next, context)=>async (args)=>{
            const originalRegion = await config.region();
            const regionProviderRef = config.region;
            let unlock = ()=>{};
            if (context.__s3RegionRedirect) {
                Object.defineProperty(config, "region", {
                    writable: false,
                    value: async ()=>{
                        return context.__s3RegionRedirect;
                    }
                });
                unlock = ()=>Object.defineProperty(config, "region", {
                        writable: true,
                        value: regionProviderRef
                    });
            }
            try {
                const result = await next(args);
                if (context.__s3RegionRedirect) {
                    unlock();
                    const region = await config.region();
                    if (originalRegion !== region) throw new Error("Region was not restored following S3 region redirect.");
                }
                return result;
            } catch (e) {
                unlock();
                throw e;
            }
        };
};
const $4403176c1e3a080a$export$d0480882defff3c5 = {
    tags: [
        "REGION_REDIRECT",
        "S3"
    ],
    name: "regionRedirectEndpointMiddleware",
    override: true,
    relation: "before",
    toMiddleware: "endpointV2Middleware"
};



function $d1be7199c6409301$export$a3e6f9e31dc59b67(clientConfig) {
    return (next, context)=>async (args)=>{
            try {
                return await next(args);
            } catch (err) {
                if (clientConfig.followRegionRedirects && err?.$metadata?.httpStatusCode === 301) {
                    try {
                        const actualRegion = err.$response.headers["x-amz-bucket-region"];
                        context.logger?.debug(`Redirecting from ${await clientConfig.region()} to ${actualRegion}`);
                        context.__s3RegionRedirect = actualRegion;
                    } catch (e) {
                        throw new Error("Region redirect failed: " + e);
                    }
                    return next(args);
                } else throw err;
            }
        };
}
const $d1be7199c6409301$export$64972686e2cce44b = {
    step: "initialize",
    tags: [
        "REGION_REDIRECT",
        "S3"
    ],
    name: "regionRedirectMiddleware",
    override: true
};
const $d1be7199c6409301$export$b3282d0108c14e76 = (clientConfig)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($d1be7199c6409301$export$a3e6f9e31dc59b67(clientConfig), $d1be7199c6409301$export$64972686e2cce44b);
            clientStack.addRelativeTo((0, $4403176c1e3a080a$export$2c92ca6b49a3d200)(clientConfig), (0, $4403176c1e3a080a$export$d0480882defff3c5));
        }
    });




const $dc6c3862b089504d$export$fe6f817fe32a1215 = (config)=>{
    return (next, context)=>async (args)=>{
            const result = await next(args);
            const { response: response } = result;
            if ((0, $55997741113954a0$export$1d94dfe0d9d1f1e7).isInstance(response)) {
                if (response.headers.expires) {
                    response.headers.expiresstring = response.headers.expires;
                    try {
                        (0, $9ced97d9f13aecca$export$cf3a566289648a1e)(response.headers.expires);
                    } catch (e) {
                        context.logger?.warn(`AWS SDK Warning for ${context.clientName}::${context.commandName} response parsing (${response.headers.expires}): ${e}`);
                        delete response.headers.expires;
                    }
                }
            }
            return result;
        };
};
const $dc6c3862b089504d$export$74a09dba68fe7eed = {
    tags: [
        "S3"
    ],
    name: "s3ExpiresMiddleware",
    override: true,
    relation: "after",
    toMiddleware: "deserializerMiddleware"
};
const $dc6c3862b089504d$export$9e4f1429c087e66f = (clientConfig)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($dc6c3862b089504d$export$fe6f817fe32a1215(clientConfig), $dc6c3862b089504d$export$74a09dba68fe7eed);
        }
    });


class $8416ff4fd8303123$export$7b4f8757876ee500 {
    constructor(data = {}){
        this.data = data;
        this.lastPurgeTime = Date.now();
    }
    get(key) {
        const entry = this.data[key];
        if (!entry) return;
        return entry;
    }
    set(key, entry) {
        this.data[key] = entry;
        return entry;
    }
    delete(key) {
        delete this.data[key];
    }
    async purgeExpired() {
        const now = Date.now();
        if (this.lastPurgeTime + $8416ff4fd8303123$export$7b4f8757876ee500.EXPIRED_CREDENTIAL_PURGE_INTERVAL_MS > now) return;
        for(const key in this.data){
            const entry = this.data[key];
            if (!entry.isRefreshing) {
                const credential = await entry.identity;
                if (credential.expiration) {
                    if (credential.expiration.getTime() < now) delete this.data[key];
                }
            }
        }
    }
}
$8416ff4fd8303123$export$7b4f8757876ee500.EXPIRED_CREDENTIAL_PURGE_INTERVAL_MS = 30000;


class $309e66fed6289def$export$e4dbcf7e6e9e615a {
    constructor(_identity, isRefreshing = false, accessed = Date.now()){
        this._identity = _identity;
        this.isRefreshing = isRefreshing;
        this.accessed = accessed;
    }
    get identity() {
        this.accessed = Date.now();
        return this._identity;
    }
}




class $e7501e975b8d3008$export$e26b7fd512d6f999 {
    constructor(createSessionFn, cache = new (0, $8416ff4fd8303123$export$7b4f8757876ee500)()){
        this.createSessionFn = createSessionFn;
        this.cache = cache;
    }
    async getS3ExpressIdentity(awsIdentity, identityProperties) {
        const key = identityProperties.Bucket;
        const { cache: cache } = this;
        const entry = cache.get(key);
        if (entry) return entry.identity.then((identity)=>{
            const isExpired = (identity.expiration?.getTime() ?? 0) < Date.now();
            if (isExpired) return cache.set(key, new (0, $309e66fed6289def$export$e4dbcf7e6e9e615a)(this.getIdentity(key))).identity;
            const isExpiringSoon = (identity.expiration?.getTime() ?? 0) < Date.now() + $e7501e975b8d3008$export$e26b7fd512d6f999.REFRESH_WINDOW_MS;
            if (isExpiringSoon && !entry.isRefreshing) {
                entry.isRefreshing = true;
                this.getIdentity(key).then((id)=>{
                    cache.set(key, new (0, $309e66fed6289def$export$e4dbcf7e6e9e615a)(Promise.resolve(id)));
                });
            }
            return identity;
        });
        return cache.set(key, new (0, $309e66fed6289def$export$e4dbcf7e6e9e615a)(this.getIdentity(key))).identity;
    }
    async getIdentity(key) {
        await this.cache.purgeExpired().catch((error)=>{
            console.warn("Error while clearing expired entries in S3ExpressIdentityCache: \n" + error);
        });
        const session = await this.createSessionFn(key);
        if (!session.Credentials?.AccessKeyId || !session.Credentials?.SecretAccessKey) throw new Error("s3#createSession response credential missing AccessKeyId or SecretAccessKey.");
        const identity = {
            accessKeyId: session.Credentials.AccessKeyId,
            secretAccessKey: session.Credentials.SecretAccessKey,
            sessionToken: session.Credentials.SessionToken,
            expiration: session.Credentials.Expiration ? new Date(session.Credentials.Expiration) : undefined
        };
        return identity;
    }
}
$e7501e975b8d3008$export$e26b7fd512d6f999.REFRESH_WINDOW_MS = 60000;






const $84ae070ab2628d05$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $84ae070ab2628d05$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $84ae070ab2628d05$export$6e114beec37430d7 = "X-Amz-Date";
const $84ae070ab2628d05$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $84ae070ab2628d05$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $84ae070ab2628d05$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $84ae070ab2628d05$export$8e1383b7eea7bee = "X-Amz-Security-Token";
const $84ae070ab2628d05$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $84ae070ab2628d05$export$9924a64a4b8b0d58 = "authorization";
const $84ae070ab2628d05$export$acf4b8bdf24aab34 = $84ae070ab2628d05$export$6e114beec37430d7.toLowerCase();
const $84ae070ab2628d05$export$c65c8c9f514da472 = "date";
const $84ae070ab2628d05$export$20d6a73fd0b10982 = [
    $84ae070ab2628d05$export$9924a64a4b8b0d58,
    $84ae070ab2628d05$export$acf4b8bdf24aab34,
    $84ae070ab2628d05$export$c65c8c9f514da472
];
const $84ae070ab2628d05$export$29961f34c719157e = $84ae070ab2628d05$export$41ae838dc1e0f082.toLowerCase();
const $84ae070ab2628d05$export$eaef12179141669a = "x-amz-content-sha256";
const $84ae070ab2628d05$export$fdc81b663012a8d2 = $84ae070ab2628d05$export$8e1383b7eea7bee.toLowerCase();
const $84ae070ab2628d05$export$96307741595055fc = "host";
const $84ae070ab2628d05$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
const $84ae070ab2628d05$export$8085db98abbe0597 = /^proxy-/;
const $84ae070ab2628d05$export$758380400526c39 = /^sec-/;
const $84ae070ab2628d05$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
const $84ae070ab2628d05$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
const $84ae070ab2628d05$export$7ad82ab3c556a776 = "AWS4-ECDSA-P256-SHA256";
const $84ae070ab2628d05$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
const $84ae070ab2628d05$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
const $84ae070ab2628d05$export$bf665777b4a1722f = 50;
const $84ae070ab2628d05$export$c4bf0942098f6bb = "aws4_request";
const $84ae070ab2628d05$export$274df788bdcca184 = 604800;





const $4c4490000d71ae62$var$signingKeyCache = {};
const $4c4490000d71ae62$var$cacheQueue = [];
const $4c4490000d71ae62$export$41a9651decfe2bde = (shortDate, region, service)=>`${shortDate}/${region}/${service}/${0, $84ae070ab2628d05$export$c4bf0942098f6bb}`;
const $4c4490000d71ae62$export$8b95a069d16dd783 = async (sha256Constructor, credentials, shortDate, region, service)=>{
    const credsHash = await $4c4490000d71ae62$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
    const cacheKey = `${shortDate}:${region}:${service}:${(0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(credsHash)}:${credentials.sessionToken}`;
    if (cacheKey in $4c4490000d71ae62$var$signingKeyCache) return $4c4490000d71ae62$var$signingKeyCache[cacheKey];
    $4c4490000d71ae62$var$cacheQueue.push(cacheKey);
    while($4c4490000d71ae62$var$cacheQueue.length > (0, $84ae070ab2628d05$export$bf665777b4a1722f))delete $4c4490000d71ae62$var$signingKeyCache[$4c4490000d71ae62$var$cacheQueue.shift()];
    let key = `AWS4${credentials.secretAccessKey}`;
    for (const signable of [
        shortDate,
        region,
        service,
        (0, $84ae070ab2628d05$export$c4bf0942098f6bb)
    ])key = await $4c4490000d71ae62$var$hmac(sha256Constructor, key, signable);
    return $4c4490000d71ae62$var$signingKeyCache[cacheKey] = key;
};
const $4c4490000d71ae62$export$a31b95746ea0a30a = ()=>{
    $4c4490000d71ae62$var$cacheQueue.length = 0;
    Object.keys($4c4490000d71ae62$var$signingKeyCache).forEach((cacheKey)=>{
        delete $4c4490000d71ae62$var$signingKeyCache[cacheKey];
    });
};
const $4c4490000d71ae62$var$hmac = (ctor, secret, data)=>{
    const hash = new ctor(secret);
    hash.update((0, $475ab5f8acad1e36$export$73470fd2221e6aef)(data));
    return hash.digest();
};



const $f5928bf291cda5f7$export$859d7f1bb55e2914 = ({ headers: headers }, unsignableHeaders, signableHeaders)=>{
    const canonical = {};
    for (const headerName of Object.keys(headers).sort()){
        if (headers[headerName] == undefined) continue;
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in (0, $84ae070ab2628d05$export$8ffdcd58c4092560) || unsignableHeaders?.has(canonicalHeaderName) || (0, $84ae070ab2628d05$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $84ae070ab2628d05$export$758380400526c39).test(canonicalHeaderName)) {
            if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
};




const $bb169de1925ea9f0$export$8fea7e63ecd1ddbb = ({ query: query = {} })=>{
    const keys = [];
    const serialized = {};
    for (const key of Object.keys(query)){
        if (key.toLowerCase() === (0, $84ae070ab2628d05$export$29961f34c719157e)) continue;
        const encodedKey = (0, $3f0644962401f658$export$c3b4775ad75a73db)(key);
        keys.push(encodedKey);
        const value = query[key];
        if (typeof value === "string") serialized[encodedKey] = `${encodedKey}=${(0, $3f0644962401f658$export$c3b4775ad75a73db)(value)}`;
        else if (Array.isArray(value)) serialized[encodedKey] = value.slice(0).reduce((encoded, value)=>encoded.concat([
                `${encodedKey}=${(0, $3f0644962401f658$export$c3b4775ad75a73db)(value)}`
            ]), []).sort().join("&");
    }
    return keys.sort().map((key)=>serialized[key]).filter((serialized)=>serialized).join("&");
};






const $22554a3a0b98ce95$export$a46a74202b0efd71 = async ({ headers: headers, body: body }, hashConstructor)=>{
    for (const headerName of Object.keys(headers)){
        if (headerName.toLowerCase() === (0, $84ae070ab2628d05$export$eaef12179141669a)) return headers[headerName];
    }
    if (body == undefined) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    else if (typeof body === "string" || ArrayBuffer.isView(body) || (0, $3b71e8cd7dcfdf56$export$9dd3754ae86f0017)(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update((0, $475ab5f8acad1e36$export$73470fd2221e6aef)(body));
        return (0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(await hashCtor.digest());
    }
    return 0, $84ae070ab2628d05$export$91f7321b40d9fd07;
};




class $8db54229afe5acb2$export$2695849af3fba360 {
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = (0, $4bb30f9042f6d66d$export$c7c5cef950a4d2fc)(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = (0, $4bb30f9042f6d66d$export$c7c5cef950a4d2fc)(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set($8db54229afe5acb2$export$8a5e19712a0a5deb.fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$8db54229afe5acb2$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $7ec653e03ba7d829$export$1a8ceedbd5845648)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
}
var $8db54229afe5acb2$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($8db54229afe5acb2$var$HEADER_VALUE_TYPE || ($8db54229afe5acb2$var$HEADER_VALUE_TYPE = {}));
const $8db54229afe5acb2$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
class $8db54229afe5acb2$export$8a5e19712a0a5deb {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $8db54229afe5acb2$var$negate(bytes);
        return new $8db54229afe5acb2$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $8db54229afe5acb2$var$negate(bytes);
        return parseInt((0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function $8db54229afe5acb2$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


const $8db26958f9959cf2$export$17944590be865217 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};
const $8db26958f9959cf2$export$149b1181d497cd = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
    }
    return undefined;
};
const $8db26958f9959cf2$export$d3408eaf94074c90 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers))if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
};



const $00ca53b99a715508$export$bfc08a76d4bd60f6 = (request, options = {})=>{
    const { headers: headers, query: query = {} } = (0, $435a3b4f1285ae7b$export$7587955500404ec3).clone(request);
    for (const name of Object.keys(headers)){
        const lname = name.toLowerCase();
        if (lname.slice(0, 6) === "x-amz-" && !options.unhoistableHeaders?.has(lname)) {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return {
        ...request,
        headers: headers,
        query: query
    };
};




const $b53316051f70aaf5$export$a7cfe9131aa06be4 = (request)=>{
    request = (0, $435a3b4f1285ae7b$export$7587955500404ec3).clone(request);
    for (const headerName of Object.keys(request.headers))if ((0, $84ae070ab2628d05$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
    return request;
};


const $4c6d081ef178bf58$export$b65d57190c224ef2 = (time)=>$4c6d081ef178bf58$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
const $4c6d081ef178bf58$export$e67a095c620b86fe = (time)=>{
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};


class $deda4bd537ce369b$export$20baf4d3f65eb30c {
    constructor({ applyChecksum: applyChecksum, credentials: credentials, region: region, service: service, sha256: sha256, uriEscapePath: uriEscapePath = true }){
        this.headerFormatter = new (0, $8db54229afe5acb2$export$2695849af3fba360)();
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, $c725887315749781$export$b1276c07738d6325)(region);
        this.credentialProvider = (0, $c725887315749781$export$b1276c07738d6325)(credentials);
    }
    async presign(originalRequest, options = {}) {
        const { signingDate: signingDate = new Date(), expiresIn: expiresIn = 3600, unsignableHeaders: unsignableHeaders, unhoistableHeaders: unhoistableHeaders, signableHeaders: signableHeaders, signingRegion: signingRegion, signingService: signingService } = options;
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { longDate: longDate, shortDate: shortDate } = $deda4bd537ce369b$var$formatDate(signingDate);
        if (expiresIn > (0, $84ae070ab2628d05$export$274df788bdcca184)) return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
        const scope = (0, $4c4490000d71ae62$export$41a9651decfe2bde)(shortDate, region, signingService ?? this.service);
        const request = (0, $00ca53b99a715508$export$bfc08a76d4bd60f6)((0, $b53316051f70aaf5$export$a7cfe9131aa06be4)(originalRequest), {
            unhoistableHeaders: unhoistableHeaders
        });
        if (credentials.sessionToken) request.query[0, $84ae070ab2628d05$export$8e1383b7eea7bee] = credentials.sessionToken;
        request.query[0, $84ae070ab2628d05$export$186cd8495ba0377d] = (0, $84ae070ab2628d05$export$863a63fba5b2ddf5);
        request.query[0, $84ae070ab2628d05$export$5c8e6dd7758f59d6] = `${credentials.accessKeyId}/${scope}`;
        request.query[0, $84ae070ab2628d05$export$6e114beec37430d7] = longDate;
        request.query[0, $84ae070ab2628d05$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
        const canonicalHeaders = (0, $f5928bf291cda5f7$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
        request.query[0, $84ae070ab2628d05$export$2dcbb254f883c238] = $deda4bd537ce369b$var$getCanonicalHeaderList(canonicalHeaders);
        request.query[0, $84ae070ab2628d05$export$41ae838dc1e0f082] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await (0, $22554a3a0b98ce95$export$a46a74202b0efd71)(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, options) {
        if (typeof toSign === "string") return this.signString(toSign, options);
        else if (toSign.headers && toSign.payload) return this.signEvent(toSign, options);
        else if (toSign.message) return this.signMessage(toSign, options);
        else return this.signRequest(toSign, options);
    }
    async signEvent({ headers: headers, payload: payload }, { signingDate: signingDate = new Date(), priorSignature: priorSignature, signingRegion: signingRegion, signingService: signingService }) {
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate, longDate: longDate } = $deda4bd537ce369b$var$formatDate(signingDate);
        const scope = (0, $4c4490000d71ae62$export$41a9651decfe2bde)(shortDate, region, signingService ?? this.service);
        const hashedPayload = await (0, $22554a3a0b98ce95$export$a46a74202b0efd71)({
            headers: {},
            body: payload
        }, this.sha256);
        const hash = new this.sha256();
        hash.update(headers);
        const hashedHeaders = (0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(await hash.digest());
        const stringToSign = [
            (0, $84ae070ab2628d05$export$9a1f6cf06ac56167),
            longDate,
            scope,
            priorSignature,
            hashedHeaders,
            hashedPayload
        ].join("\n");
        return this.signString(stringToSign, {
            signingDate: signingDate,
            signingRegion: region,
            signingService: signingService
        });
    }
    async signMessage(signableMessage, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService }) {
        const promise = this.signEvent({
            headers: this.headerFormatter.format(signableMessage.message.headers),
            payload: signableMessage.message.body
        }, {
            signingDate: signingDate,
            signingRegion: signingRegion,
            signingService: signingService,
            priorSignature: signableMessage.priorSignature
        });
        return promise.then((signature)=>{
            return {
                message: signableMessage.message,
                signature: signature
            };
        });
    }
    async signString(stringToSign, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate } = $deda4bd537ce369b$var$formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
        hash.update((0, $475ab5f8acad1e36$export$73470fd2221e6aef)(stringToSign));
        return (0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(await hash.digest());
    }
    async signRequest(requestToSign, { signingDate: signingDate = new Date(), signableHeaders: signableHeaders, unsignableHeaders: unsignableHeaders, signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const request = (0, $b53316051f70aaf5$export$a7cfe9131aa06be4)(requestToSign);
        const { longDate: longDate, shortDate: shortDate } = $deda4bd537ce369b$var$formatDate(signingDate);
        const scope = (0, $4c4490000d71ae62$export$41a9651decfe2bde)(shortDate, region, signingService ?? this.service);
        request.headers[0, $84ae070ab2628d05$export$acf4b8bdf24aab34] = longDate;
        if (credentials.sessionToken) request.headers[0, $84ae070ab2628d05$export$fdc81b663012a8d2] = credentials.sessionToken;
        const payloadHash = await (0, $22554a3a0b98ce95$export$a46a74202b0efd71)(request, this.sha256);
        if (!(0, $8db26958f9959cf2$export$17944590be865217)((0, $84ae070ab2628d05$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $84ae070ab2628d05$export$eaef12179141669a] = payloadHash;
        const canonicalHeaders = (0, $f5928bf291cda5f7$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[0, $84ae070ab2628d05$export$9924a64a4b8b0d58] = `${0, $84ae070ab2628d05$export$863a63fba5b2ddf5} ` + `Credential=${credentials.accessKeyId}/${scope}, ` + `SignedHeaders=${$deda4bd537ce369b$var$getCanonicalHeaderList(canonicalHeaders)}, ` + `Signature=${signature}`;
        return request;
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${(0, $bb169de1925ea9f0$export$8fea7e63ecd1ddbb)(request)}
${sortedHeaders.map((name)=>`${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest) {
        const hash = new this.sha256();
        hash.update((0, $475ab5f8acad1e36$export$73470fd2221e6aef)(canonicalRequest));
        const hashedRequest = await hash.digest();
        return `${0, $84ae070ab2628d05$export$863a63fba5b2ddf5}
${longDate}
${credentialScope}
${(0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(hashedRequest)}`;
    }
    getCanonicalPath({ path: path }) {
        if (this.uriEscapePath) {
            const normalizedPathSegments = [];
            for (const pathSegment of path.split("/")){
                if (pathSegment?.length === 0) continue;
                if (pathSegment === ".") continue;
                if (pathSegment === "..") normalizedPathSegments.pop();
                else normalizedPathSegments.push(pathSegment);
            }
            const normalizedPath = `${path?.startsWith("/") ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && path?.endsWith("/") ? "/" : ""}`;
            const doubleEncoded = (0, $3f0644962401f658$export$c3b4775ad75a73db)(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
        const hash = new this.sha256(await keyPromise);
        hash.update((0, $475ab5f8acad1e36$export$73470fd2221e6aef)(stringToSign));
        return (0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate, service) {
        return (0, $4c4490000d71ae62$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    }
    validateResolvedCredentials(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    }
}
const $deda4bd537ce369b$var$formatDate = (now)=>{
    const longDate = (0, $4c6d081ef178bf58$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
const $deda4bd537ce369b$var$getCanonicalHeaderList = (headers)=>Object.keys(headers).sort().join(";");










const $d24cab3bba32e8b4$export$f8c4049184e0ac3f = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error(`Cannot load ${type} "${key}". Expected "true" or "false", got ${obj[key]}.`);
};


const $fdf5e0685b99d6d6$export$964ee8ab6fdb2cf2 = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    const numberValue = parseInt(obj[key], 10);
    if (Number.isNaN(numberValue)) throw new TypeError(`Cannot load ${type} '${key}'. Expected number, got '${obj[key]}'.`);
    return numberValue;
};


var $eb4cfe18aa41a21a$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})($eb4cfe18aa41a21a$export$4e8b093ec8dcab0d || ($eb4cfe18aa41a21a$export$4e8b093ec8dcab0d = {}));




const $c034be551d1031f4$export$fd6222daa986f604 = "Directory";
const $c034be551d1031f4$export$7f8099eea7f47446 = "S3Express";
const $c034be551d1031f4$export$2e35a6cb21331191 = "sigv4-s3express";
const $c034be551d1031f4$export$b4e54fd7209a729e = "X-Amz-S3session-Token";
const $c034be551d1031f4$export$a3ded8c86d7f94ca = $c034be551d1031f4$export$b4e54fd7209a729e.toLowerCase();
const $c034be551d1031f4$export$f9ad00eed9d4c39c = "AWS_S3_DISABLE_EXPRESS_SESSION_AUTH";
const $c034be551d1031f4$export$38f9c9ab2952ce3e = "s3_disable_express_session_auth";
const $c034be551d1031f4$export$bc9c7dd3424ab3c4 = {
    environmentVariableSelector: (env)=>(0, $d24cab3bba32e8b4$export$f8c4049184e0ac3f)(env, $c034be551d1031f4$export$f9ad00eed9d4c39c, (0, $eb4cfe18aa41a21a$export$4e8b093ec8dcab0d).ENV),
    configFileSelector: (profile)=>(0, $d24cab3bba32e8b4$export$f8c4049184e0ac3f)(profile, $c034be551d1031f4$export$38f9c9ab2952ce3e, (0, $eb4cfe18aa41a21a$export$4e8b093ec8dcab0d).CONFIG),
    default: false
};


class $c53165f0defd1ffe$export$390c799677821231 extends (0, $deda4bd537ce369b$export$20baf4d3f65eb30c) {
    async signWithCredentials(requestToSign, credentials, options) {
        const credentialsWithoutSessionToken = $c53165f0defd1ffe$var$getCredentialsWithoutSessionToken(credentials);
        requestToSign.headers[0, $c034be551d1031f4$export$a3ded8c86d7f94ca] = credentials.sessionToken;
        const privateAccess = this;
        $c53165f0defd1ffe$var$setSingleOverride(privateAccess, credentialsWithoutSessionToken);
        return privateAccess.signRequest(requestToSign, options ?? {});
    }
    async presignWithCredentials(requestToSign, credentials, options) {
        const credentialsWithoutSessionToken = $c53165f0defd1ffe$var$getCredentialsWithoutSessionToken(credentials);
        delete requestToSign.headers[0, $c034be551d1031f4$export$a3ded8c86d7f94ca];
        requestToSign.headers[0, $c034be551d1031f4$export$b4e54fd7209a729e] = credentials.sessionToken;
        requestToSign.query = requestToSign.query ?? {};
        requestToSign.query[0, $c034be551d1031f4$export$b4e54fd7209a729e] = credentials.sessionToken;
        const privateAccess = this;
        $c53165f0defd1ffe$var$setSingleOverride(privateAccess, credentialsWithoutSessionToken);
        return this.presign(requestToSign, options);
    }
}
function $c53165f0defd1ffe$var$getCredentialsWithoutSessionToken(credentials) {
    const credentialsWithoutSessionToken = {
        accessKeyId: credentials.accessKeyId,
        secretAccessKey: credentials.secretAccessKey,
        expiration: credentials.expiration
    };
    return credentialsWithoutSessionToken;
}
function $c53165f0defd1ffe$var$setSingleOverride(privateAccess, credentialsWithoutSessionToken) {
    const id = setTimeout(()=>{
        throw new Error("SignatureV4S3Express credential override was created but not called.");
    }, 10);
    const currentCredentialProvider = privateAccess.credentialProvider;
    const overrideCredentialsProviderOnce = ()=>{
        clearTimeout(id);
        privateAccess.credentialProvider = currentCredentialProvider;
        return Promise.resolve(credentialsWithoutSessionToken);
    };
    privateAccess.credentialProvider = overrideCredentialsProviderOnce;
}





const $6f5918cee414e2ce$export$aa5721e04f12df60 = (options)=>{
    return (next, context)=>async (args)=>{
            if (context.endpointV2) {
                const endpoint = context.endpointV2;
                const isS3ExpressAuth = endpoint.properties?.authSchemes?.[0]?.name === (0, $c034be551d1031f4$export$2e35a6cb21331191);
                const isS3ExpressBucket = endpoint.properties?.backend === (0, $c034be551d1031f4$export$7f8099eea7f47446) || endpoint.properties?.bucketType === (0, $c034be551d1031f4$export$fd6222daa986f604);
                if (isS3ExpressBucket) context.isS3ExpressBucket = true;
                if (isS3ExpressAuth) {
                    const requestBucket = args.input.Bucket;
                    if (requestBucket) {
                        const s3ExpressIdentity = await options.s3ExpressIdentityProvider.getS3ExpressIdentity(await options.credentials(), {
                            Bucket: requestBucket
                        });
                        context.s3ExpressIdentity = s3ExpressIdentity;
                        if ((0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(args.request) && s3ExpressIdentity.sessionToken) args.request.headers[0, $c034be551d1031f4$export$a3ded8c86d7f94ca] = s3ExpressIdentity.sessionToken;
                    }
                }
            }
            return next(args);
        };
};
const $6f5918cee414e2ce$export$a1adb67f4025aa01 = {
    name: "s3ExpressMiddleware",
    step: "build",
    tags: [
        "S3",
        "S3_EXPRESS"
    ],
    override: true
};
const $6f5918cee414e2ce$export$3aa3f237714d7948 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($6f5918cee414e2ce$export$aa5721e04f12df60(options), $6f5918cee414e2ce$export$a1adb67f4025aa01);
        }
    });




function $0a9637d529b081de$var$convertHttpAuthSchemesToMap(httpAuthSchemes) {
    const map = new Map();
    for (const scheme of httpAuthSchemes)map.set(scheme.schemeId, scheme);
    return map;
}
const $0a9637d529b081de$export$681dcf755d3830d0 = (config, mwOptions)=>(next, context)=>async (args)=>{
            const options = config.httpAuthSchemeProvider(await mwOptions.httpAuthSchemeParametersProvider(config, context, args.input));
            const authSchemes = $0a9637d529b081de$var$convertHttpAuthSchemesToMap(config.httpAuthSchemes);
            const smithyContext = (0, $7a2c7cffe65767aa$export$1d3c197393275463)(context);
            const failureReasons = [];
            for (const option of options){
                const scheme = authSchemes.get(option.schemeId);
                if (!scheme) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` was not enabled for this service.`);
                    continue;
                }
                const identityProvider = scheme.identityProvider(await mwOptions.identityProviderConfigProvider(config));
                if (!identityProvider) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` did not have an IdentityProvider configured.`);
                    continue;
                }
                const { identityProperties: identityProperties = {}, signingProperties: signingProperties = {} } = option.propertiesExtractor?.(config, context) || {};
                option.identityProperties = Object.assign(option.identityProperties || {}, identityProperties);
                option.signingProperties = Object.assign(option.signingProperties || {}, signingProperties);
                smithyContext.selectedHttpAuthScheme = {
                    httpAuthOption: option,
                    identity: await identityProvider(option.identityProperties),
                    signer: scheme.signer
                };
                break;
            }
            if (!smithyContext.selectedHttpAuthScheme) throw new Error(failureReasons.join("\n"));
            return next(args);
        };


const $0592a89d634de496$export$972ee8f9276654f0 = async (endpointParams)=>{
    const bucket = endpointParams?.Bucket || "";
    if (typeof endpointParams.Bucket === "string") endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
    if ($0592a89d634de496$export$fe7fec9fee338b98(bucket)) {
        if (endpointParams.ForcePathStyle === true) throw new Error("Path-style addressing cannot be used with ARN buckets");
    } else if (!$0592a89d634de496$export$360a1e07839d0d27(bucket) || bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:") || bucket.toLowerCase() !== bucket || bucket.length < 3) endpointParams.ForcePathStyle = true;
    if (endpointParams.DisableMultiRegionAccessPoints) {
        endpointParams.disableMultiRegionAccessPoints = true;
        endpointParams.DisableMRAP = true;
    }
    return endpointParams;
};
const $0592a89d634de496$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
const $0592a89d634de496$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
const $0592a89d634de496$var$DOTS_PATTERN = /\.\./;
const $0592a89d634de496$export$b0b24e5455be29b0 = /\./;
const $0592a89d634de496$export$43f53815580748f = /^(.+\.)?s3(-fips)?(\.dualstack)?[.-]([a-z0-9-]+)\./;
const $0592a89d634de496$export$360a1e07839d0d27 = (bucketName)=>$0592a89d634de496$var$DOMAIN_PATTERN.test(bucketName) && !$0592a89d634de496$var$IP_ADDRESS_PATTERN.test(bucketName) && !$0592a89d634de496$var$DOTS_PATTERN.test(bucketName);
const $0592a89d634de496$export$fe7fec9fee338b98 = (bucketName)=>{
    const [arn, partition, service, , , bucket] = bucketName.split(":");
    const isArn = arn === "arn" && bucketName.split(":").length >= 6;
    const isValidArn = Boolean(isArn && partition && service && bucket);
    if (isArn && !isValidArn) throw new Error(`Invalid ARN: ${bucketName} was an invalid ARN.`);
    return isValidArn;
};




const $505e56fee4eff852$export$47243fd4b8e52f1e = (configKey, canonicalEndpointParamKey, config)=>{
    const configProvider = async ()=>{
        const configValue = config[configKey] ?? config[canonicalEndpointParamKey];
        if (typeof configValue === "function") return configValue();
        return configValue;
    };
    if (configKey === "credentialScope" || canonicalEndpointParamKey === "CredentialScope") return async ()=>{
        const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
        const configValue = credentials?.credentialScope ?? credentials?.CredentialScope;
        return configValue;
    };
    if (configKey === "accountId" || canonicalEndpointParamKey === "AccountId") return async ()=>{
        const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
        const configValue = credentials?.accountId ?? credentials?.AccountId;
        return configValue;
    };
    if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") return async ()=>{
        const endpoint = await configProvider();
        if (endpoint && typeof endpoint === "object") {
            if ("url" in endpoint) return endpoint.url.href;
            if ("hostname" in endpoint) {
                const { protocol: protocol, hostname: hostname, port: port, path: path } = endpoint;
                return `${protocol}//${hostname}${port ? ":" + port : ""}${path}`;
            }
        }
        return endpoint;
    };
    return configProvider;
};


const $68105446a54ae9db$export$8a5041d6190772fe = async (serviceId)=>undefined;


function $6a01152dc64269f1$export$66256f83798e5415(querystring) {
    const query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) for (const pair of querystring.split("&")){
        let [key, value = null] = pair.split("=");
        key = decodeURIComponent(key);
        if (value) value = decodeURIComponent(value);
        if (!(key in query)) query[key] = value;
        else if (Array.isArray(query[key])) query[key].push(value);
        else query[key] = [
            query[key],
            value
        ];
    }
    return query;
}


const $2b893278b729b3be$export$7a5253c0f62e0150 = (url)=>{
    if (typeof url === "string") return $2b893278b729b3be$export$7a5253c0f62e0150(new URL(url));
    const { hostname: hostname, pathname: pathname, port: port, protocol: protocol, search: search } = url;
    let query;
    if (search) query = (0, $6a01152dc64269f1$export$66256f83798e5415)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};


const $23156e492d58e4ce$export$32d52e935fceeb99 = (endpoint)=>{
    if (typeof endpoint === "object") {
        if ("url" in endpoint) return (0, $2b893278b729b3be$export$7a5253c0f62e0150)(endpoint.url);
        return endpoint;
    }
    return (0, $2b893278b729b3be$export$7a5253c0f62e0150)(endpoint);
};


const $d31625d2ccff255a$export$deed4544608f82ff = async (commandInput, instructionsSupplier, clientConfig, context)=>{
    if (!clientConfig.endpoint) {
        let endpointFromConfig;
        if (clientConfig.serviceConfiguredEndpoint) endpointFromConfig = await clientConfig.serviceConfiguredEndpoint();
        else endpointFromConfig = await (0, $68105446a54ae9db$export$8a5041d6190772fe)(clientConfig.serviceId);
        if (endpointFromConfig) clientConfig.endpoint = ()=>Promise.resolve((0, $23156e492d58e4ce$export$32d52e935fceeb99)(endpointFromConfig));
    }
    const endpointParams = await $d31625d2ccff255a$export$a4c001b14047c450(commandInput, instructionsSupplier, clientConfig);
    if (typeof clientConfig.endpointProvider !== "function") throw new Error("config.endpointProvider is not set.");
    const endpoint = clientConfig.endpointProvider(endpointParams, context);
    return endpoint;
};
const $d31625d2ccff255a$export$a4c001b14047c450 = async (commandInput, instructionsSupplier, clientConfig)=>{
    const endpointParams = {};
    const instructions = instructionsSupplier?.getEndpointParameterInstructions?.() || {};
    for (const [name, instruction] of Object.entries(instructions))switch(instruction.type){
        case "staticContextParams":
            endpointParams[name] = instruction.value;
            break;
        case "contextParams":
            endpointParams[name] = commandInput[instruction.name];
            break;
        case "clientContextParams":
        case "builtInParams":
            endpointParams[name] = await (0, $505e56fee4eff852$export$47243fd4b8e52f1e)(instruction.name, name, clientConfig)();
            break;
        default:
            throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
    }
    if (Object.keys(instructions).length === 0) Object.assign(endpointParams, clientConfig);
    if (String(clientConfig.serviceId).toLowerCase() === "s3") await (0, $0592a89d634de496$export$972ee8f9276654f0)(endpointParams);
    return endpointParams;
};







const $46dc4f9426e78368$export$aa1c2d132a457833 = ({ config: config, instructions: instructions })=>{
    return (next, context)=>async (args)=>{
            const endpoint = await (0, $d31625d2ccff255a$export$deed4544608f82ff)(args.input, {
                getEndpointParameterInstructions () {
                    return instructions;
                }
            }, {
                ...config
            }, context);
            context.endpointV2 = endpoint;
            context.authSchemes = endpoint.properties?.authSchemes;
            const authScheme = context.authSchemes?.[0];
            if (authScheme) {
                context["signing_region"] = authScheme.signingRegion;
                context["signing_service"] = authScheme.signingName;
                const smithyContext = (0, $7a2c7cffe65767aa$export$1d3c197393275463)(context);
                const httpAuthOption = smithyContext?.selectedHttpAuthScheme?.httpAuthOption;
                if (httpAuthOption) httpAuthOption.signingProperties = Object.assign(httpAuthOption.signingProperties || {}, {
                    signing_region: authScheme.signingRegion,
                    signingRegion: authScheme.signingRegion,
                    signing_service: authScheme.signingName,
                    signingName: authScheme.signingName,
                    signingRegionSet: authScheme.signingRegionSet
                }, authScheme.properties);
            }
            return next({
                ...args
            });
        };
};


const $204328b49c03872f$export$d10196e291075f95 = (options, deserializer)=>(next)=>async (args)=>{
            const { response: response } = await next(args);
            try {
                const parsed = await deserializer(response, options);
                return {
                    response: response,
                    output: parsed
                };
            } catch (error) {
                Object.defineProperty(error, "$response", {
                    value: response
                });
                if (!("$metadata" in error)) {
                    const hint = `Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.`;
                    error.message += "\n  " + hint;
                    if (typeof error.$responseBodyText !== "undefined") {
                        if (error.$response) error.$response.body = error.$responseBodyText;
                    }
                }
                throw error;
            }
        };



const $174f6278c5e49d86$export$125a23d36094c5de = (options, serializer)=>(next, context)=>async (args)=>{
            const endpoint = context.endpointV2?.url && options.urlParser ? async ()=>options.urlParser(context.endpointV2.url) : options.endpoint;
            if (!endpoint) throw new Error("No valid endpoint provider available.");
            const request = await serializer(args.input, {
                ...options,
                endpoint: endpoint
            });
            return next({
                ...args,
                request: request
            });
        };


const $5b9375668e859164$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
const $5b9375668e859164$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $5b9375668e859164$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: (commandStack)=>{
            commandStack.add((0, $204328b49c03872f$export$d10196e291075f95)(config, deserializer), $5b9375668e859164$export$f5d82b333b4f39c9);
            commandStack.add((0, $174f6278c5e49d86$export$125a23d36094c5de)(config, serializer), $5b9375668e859164$export$1bd449976e9c484d);
        }
    };
}






const $a239f3bc183c0683$export$1e040b8d263b920b = {
    step: "serialize",
    tags: [
        "ENDPOINT_PARAMETERS",
        "ENDPOINT_V2",
        "ENDPOINT"
    ],
    name: "endpointV2Middleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $5b9375668e859164$export$1bd449976e9c484d).name
};
const $a239f3bc183c0683$export$946c80457b765eab = (config, instructions)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $46dc4f9426e78368$export$aa1c2d132a457833)({
                config: config,
                instructions: instructions
            }), $a239f3bc183c0683$export$1e040b8d263b920b);
        }
    });





const $3d81e12aaba219df$export$8c5b66831e3f26ff = (input)=>{
    const tls = input.tls ?? true;
    const { endpoint: endpoint } = input;
    const customEndpointProvider = endpoint != null ? async ()=>(0, $23156e492d58e4ce$export$32d52e935fceeb99)(await (0, $c725887315749781$export$b1276c07738d6325)(endpoint)()) : undefined;
    const isCustomEndpoint = !!endpoint;
    const resolvedConfig = {
        ...input,
        endpoint: customEndpointProvider,
        tls: tls,
        isCustomEndpoint: isCustomEndpoint,
        useDualstackEndpoint: (0, $c725887315749781$export$b1276c07738d6325)(input.useDualstackEndpoint ?? false),
        useFipsEndpoint: (0, $c725887315749781$export$b1276c07738d6325)(input.useFipsEndpoint ?? false)
    };
    let configuredEndpointPromise = undefined;
    resolvedConfig.serviceConfiguredEndpoint = async ()=>{
        if (input.serviceId && !configuredEndpointPromise) configuredEndpointPromise = (0, $68105446a54ae9db$export$8a5041d6190772fe)(input.serviceId);
        return configuredEndpointPromise;
    };
    return resolvedConfig;
};







const $59539d21e35e811c$export$8c136d4eb4815c3e = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $a239f3bc183c0683$export$1e040b8d263b920b).name
};
const $59539d21e35e811c$export$6ababc1a6356ca41 = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $0a9637d529b081de$export$681dcf755d3830d0)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $59539d21e35e811c$export$8c136d4eb4815c3e);
        }
    });




const $343f1f389fda14c6$export$11cd3870e3f87892 = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $5b9375668e859164$export$1bd449976e9c484d).name
};
const $343f1f389fda14c6$export$ac2af07429c3a20e = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $0a9637d529b081de$export$681dcf755d3830d0)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $343f1f389fda14c6$export$11cd3870e3f87892);
        }
    });







const $897d317150ae165f$var$defaultErrorHandler = (signingProperties)=>(error)=>{
        throw error;
    };
const $897d317150ae165f$var$defaultSuccessHandler = (httpResponse, signingProperties)=>{};
const $897d317150ae165f$export$fe39ed571a606f80 = (config)=>(next, context)=>async (args)=>{
            if (!(0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const smithyContext = (0, $7a2c7cffe65767aa$export$1d3c197393275463)(context);
            const scheme = smithyContext.selectedHttpAuthScheme;
            if (!scheme) throw new Error(`No HttpAuthScheme was selected: unable to sign request`);
            const { httpAuthOption: { signingProperties: signingProperties = {} }, identity: identity, signer: signer } = scheme;
            const output = await next({
                ...args,
                request: await signer.sign(args.request, identity, signingProperties)
            }).catch((signer.errorHandler || $897d317150ae165f$var$defaultErrorHandler)(signingProperties));
            (signer.successHandler || $897d317150ae165f$var$defaultSuccessHandler)(output.response, signingProperties);
            return output;
        };


var $c7803bea46144fee$export$6842199fccd474d3;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})($c7803bea46144fee$export$6842199fccd474d3 || ($c7803bea46144fee$export$6842199fccd474d3 = {}));
const $c7803bea46144fee$export$2c7e51f38ba5a406 = 3;
const $c7803bea46144fee$export$41315747b7c5d042 = $c7803bea46144fee$export$6842199fccd474d3.STANDARD;


const $384c63e9b5e8d9b7$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
const $384c63e9b5e8d9b7$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
const $384c63e9b5e8d9b7$export$18bd3bfe89ded398 = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $384c63e9b5e8d9b7$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];
const $384c63e9b5e8d9b7$export$e4f761fe9d74ce41 = [
    "ECONNRESET",
    "ECONNREFUSED",
    "EPIPE",
    "ETIMEDOUT"
];


const $0aaa9e0fb9266678$export$46428803f4bd8a0c = (error)=>error.$retryable !== undefined;
const $0aaa9e0fb9266678$export$7b87435661177a94 = (error)=>(0, $384c63e9b5e8d9b7$export$9fde012b8b2a10ca).includes(error.name);
const $0aaa9e0fb9266678$export$ca8501ea0db9a003 = (error)=>error.$metadata?.clockSkewCorrected;
const $0aaa9e0fb9266678$export$cbecb89f6256ccc8 = (error)=>error.$metadata?.httpStatusCode === 429 || (0, $384c63e9b5e8d9b7$export$89cd1b0ccfcb99d).includes(error.name) || error.$retryable?.throttling == true;
const $0aaa9e0fb9266678$export$31778435da988512 = (error)=>$0aaa9e0fb9266678$export$ca8501ea0db9a003(error) || (0, $384c63e9b5e8d9b7$export$18bd3bfe89ded398).includes(error.name) || (0, $384c63e9b5e8d9b7$export$e4f761fe9d74ce41).includes(error?.code || "") || (0, $384c63e9b5e8d9b7$export$38bf589d26009e4f).includes(error.$metadata?.httpStatusCode || 0);
const $0aaa9e0fb9266678$export$a7cbe72d7c4012af = (error)=>{
    if (error.$metadata?.httpStatusCode !== undefined) {
        const statusCode = error.$metadata.httpStatusCode;
        if (500 <= statusCode && statusCode <= 599 && !$0aaa9e0fb9266678$export$31778435da988512(error)) return true;
        return false;
    }
    return false;
};


class $3522fff10b612cc8$export$4d4bb1390e4746c4 {
    constructor(options){
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = options?.beta ?? 0.7;
        this.minCapacity = options?.minCapacity ?? 1;
        this.minFillRate = options?.minFillRate ?? 0.5;
        this.scaleConstant = options?.scaleConstant ?? 0.4;
        this.smooth = options?.smooth ?? 0.8;
        const currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    getCurrentTimeInSeconds() {
        return Date.now() / 1000;
    }
    async getSendToken() {
        return this.acquireTokenBucket(1);
    }
    async acquireTokenBucket(amount) {
        if (!this.enabled) return;
        this.refillTokenBucket();
        if (amount > this.currentCapacity) {
            const delay = (amount - this.currentCapacity) / this.fillRate * 1000;
            await new Promise((resolve)=>setTimeout(resolve, delay));
        }
        this.currentCapacity = this.currentCapacity - amount;
    }
    refillTokenBucket() {
        const timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        const fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    }
    updateClientSendingRate(response) {
        let calculatedRate;
        this.updateMeasuredRate();
        if ((0, $0aaa9e0fb9266678$export$cbecb89f6256ccc8)(response)) {
            const rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        const newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    }
    calculateTimeWindow() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    }
    cubicThrottle(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    }
    cubicSuccess(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    }
    enableTokenBucket() {
        this.enabled = true;
    }
    updateTokenBucketRate(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    }
    updateMeasuredRate() {
        const t = this.getCurrentTimeInSeconds();
        const timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            const currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    }
    getPrecise(num) {
        return parseFloat(num.toFixed(8));
    }
}



const $c7a489f1cc1e6642$export$7067ba90effbd789 = 100;
const $c7a489f1cc1e6642$export$2412c80d04e902c6 = 20000;
const $c7a489f1cc1e6642$export$4af31f8250b48e23 = 500;
const $c7a489f1cc1e6642$export$f8c3d11675a1153 = 500;
const $c7a489f1cc1e6642$export$797febae1136bc84 = 5;
const $c7a489f1cc1e6642$export$b643545eaf9af837 = 10;
const $c7a489f1cc1e6642$export$a25da3406dc148e4 = 1;
const $c7a489f1cc1e6642$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
const $c7a489f1cc1e6642$export$d4f764f0ec4f52f = "amz-sdk-request";



const $f61735c591bceff1$export$fc672061560e1611 = ()=>{
    let delayBase = (0, $c7a489f1cc1e6642$export$7067ba90effbd789);
    const computeNextBackoffDelay = (attempts)=>{
        return Math.floor(Math.min((0, $c7a489f1cc1e6642$export$2412c80d04e902c6), Math.random() * 2 ** attempts * delayBase));
    };
    const setDelayBase = (delay)=>{
        delayBase = delay;
    };
    return {
        computeNextBackoffDelay: computeNextBackoffDelay,
        setDelayBase: setDelayBase
    };
};



const $97060ca88166884e$export$330ec27afca1b9b = ({ retryDelay: retryDelay, retryCount: retryCount, retryCost: retryCost })=>{
    const getRetryCount = ()=>retryCount;
    const getRetryDelay = ()=>Math.min((0, $c7a489f1cc1e6642$export$2412c80d04e902c6), retryDelay);
    const getRetryCost = ()=>retryCost;
    return {
        getRetryCount: getRetryCount,
        getRetryDelay: getRetryDelay,
        getRetryCost: getRetryCost
    };
};


class $eeefa37f57099246$export$64af437cce00eae8 {
    constructor(maxAttempts){
        this.maxAttempts = maxAttempts;
        this.mode = (0, $c7803bea46144fee$export$6842199fccd474d3).STANDARD;
        this.capacity = (0, $c7a489f1cc1e6642$export$f8c3d11675a1153);
        this.retryBackoffStrategy = (0, $f61735c591bceff1$export$fc672061560e1611)();
        this.maxAttemptsProvider = typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts;
    }
    async acquireInitialRetryToken(retryTokenScope) {
        return (0, $97060ca88166884e$export$330ec27afca1b9b)({
            retryDelay: (0, $c7a489f1cc1e6642$export$7067ba90effbd789),
            retryCount: 0
        });
    }
    async refreshRetryTokenForRetry(token, errorInfo) {
        const maxAttempts = await this.getMaxAttempts();
        if (this.shouldRetry(token, errorInfo, maxAttempts)) {
            const errorType = errorInfo.errorType;
            this.retryBackoffStrategy.setDelayBase(errorType === "THROTTLING" ? (0, $c7a489f1cc1e6642$export$4af31f8250b48e23) : (0, $c7a489f1cc1e6642$export$7067ba90effbd789));
            const delayFromErrorType = this.retryBackoffStrategy.computeNextBackoffDelay(token.getRetryCount());
            const retryDelay = errorInfo.retryAfterHint ? Math.max(errorInfo.retryAfterHint.getTime() - Date.now() || 0, delayFromErrorType) : delayFromErrorType;
            const capacityCost = this.getCapacityCost(errorType);
            this.capacity -= capacityCost;
            return (0, $97060ca88166884e$export$330ec27afca1b9b)({
                retryDelay: retryDelay,
                retryCount: token.getRetryCount() + 1,
                retryCost: capacityCost
            });
        }
        throw new Error("No retry token available");
    }
    recordSuccess(token) {
        this.capacity = Math.max((0, $c7a489f1cc1e6642$export$f8c3d11675a1153), this.capacity + (token.getRetryCost() ?? (0, $c7a489f1cc1e6642$export$a25da3406dc148e4)));
    }
    getCapacity() {
        return this.capacity;
    }
    async getMaxAttempts() {
        try {
            return await this.maxAttemptsProvider();
        } catch (error) {
            console.warn(`Max attempts provider could not resolve. Using default of ${(0, $c7803bea46144fee$export$2c7e51f38ba5a406)}`);
            return 0, $c7803bea46144fee$export$2c7e51f38ba5a406;
        }
    }
    shouldRetry(tokenToRenew, errorInfo, maxAttempts) {
        const attempts = tokenToRenew.getRetryCount() + 1;
        return attempts < maxAttempts && this.capacity >= this.getCapacityCost(errorInfo.errorType) && this.isRetryableError(errorInfo.errorType);
    }
    getCapacityCost(errorType) {
        return errorType === "TRANSIENT" ? (0, $c7a489f1cc1e6642$export$b643545eaf9af837) : (0, $c7a489f1cc1e6642$export$797febae1136bc84);
    }
    isRetryableError(errorType) {
        return errorType === "THROTTLING" || errorType === "TRANSIENT";
    }
}


class $b3d5a9f96973f447$export$b6f3faf7501de8bc {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $c7803bea46144fee$export$6842199fccd474d3).ADAPTIVE;
        const { rateLimiter: rateLimiter } = options ?? {};
        this.rateLimiter = rateLimiter ?? new (0, $3522fff10b612cc8$export$4d4bb1390e4746c4)();
        this.standardRetryStrategy = new (0, $eeefa37f57099246$export$64af437cce00eae8)(maxAttemptsProvider);
    }
    async acquireInitialRetryToken(retryTokenScope) {
        await this.rateLimiter.getSendToken();
        return this.standardRetryStrategy.acquireInitialRetryToken(retryTokenScope);
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        this.rateLimiter.updateClientSendingRate(errorInfo);
        return this.standardRetryStrategy.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
    }
    recordSuccess(token) {
        this.rateLimiter.updateClientSendingRate({});
        this.standardRetryStrategy.recordSuccess(token);
    }
}




class $76410213c72dbc1f$export$4d488d77e5dad28e extends (0, $eeefa37f57099246$export$64af437cce00eae8) {
    constructor(maxAttempts, computeNextBackoffDelay = (0, $c7a489f1cc1e6642$export$7067ba90effbd789)){
        super(typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts);
        if (typeof computeNextBackoffDelay === "number") this.computeNextBackoffDelay = ()=>computeNextBackoffDelay;
        else this.computeNextBackoffDelay = computeNextBackoffDelay;
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        const token = await super.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
        token.getRetryDelay = ()=>this.computeNextBackoffDelay(token.getRetryCount());
        return token;
    }
}













const $a02ee00542860e32$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $a02ee00542860e32$export$2e2bcd8739ae039 = {
    randomUUID: $a02ee00542860e32$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $c0b2b3372354896f$var$getRandomValues;
const $c0b2b3372354896f$var$rnds8 = new Uint8Array(16);
function $c0b2b3372354896f$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$c0b2b3372354896f$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $c0b2b3372354896f$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$c0b2b3372354896f$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $c0b2b3372354896f$var$getRandomValues($c0b2b3372354896f$var$rnds8);
}


var $72100667688e3808$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $f4377a6f0babb652$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $72100667688e3808$export$2e2bcd8739ae039).test(uuid);
}
var $f4377a6f0babb652$export$2e2bcd8739ae039 = $f4377a6f0babb652$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $af9174b57e5157d7$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$af9174b57e5157d7$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $af9174b57e5157d7$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $af9174b57e5157d7$var$byteToHex[arr[offset + 0]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 1]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 2]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 3]] + '-' + $af9174b57e5157d7$var$byteToHex[arr[offset + 4]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 5]] + '-' + $af9174b57e5157d7$var$byteToHex[arr[offset + 6]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 7]] + '-' + $af9174b57e5157d7$var$byteToHex[arr[offset + 8]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 9]] + '-' + $af9174b57e5157d7$var$byteToHex[arr[offset + 10]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 11]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 12]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 13]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 14]] + $af9174b57e5157d7$var$byteToHex[arr[offset + 15]];
}
function $af9174b57e5157d7$var$stringify(arr, offset = 0) {
    const uuid = $af9174b57e5157d7$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $f4377a6f0babb652$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $af9174b57e5157d7$export$2e2bcd8739ae039 = $af9174b57e5157d7$var$stringify;


function $9aeedc2370106dcc$var$v4(options, buf, offset) {
    if ((0, $a02ee00542860e32$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $a02ee00542860e32$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $c0b2b3372354896f$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $af9174b57e5157d7$export$8fb373d660548968)(rnds);
}
var $9aeedc2370106dcc$export$2e2bcd8739ae039 = $9aeedc2370106dcc$var$v4;



const $a981b5d724dad3ff$export$2ebe7988802fc284 = (initialRetryTokens, options)=>{
    const MAX_CAPACITY = initialRetryTokens;
    const noRetryIncrement = options?.noRetryIncrement ?? (0, $c7a489f1cc1e6642$export$a25da3406dc148e4);
    const retryCost = options?.retryCost ?? (0, $c7a489f1cc1e6642$export$797febae1136bc84);
    const timeoutRetryCost = options?.timeoutRetryCost ?? (0, $c7a489f1cc1e6642$export$b643545eaf9af837);
    let availableCapacity = initialRetryTokens;
    const getCapacityAmount = (error)=>error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    const hasRetryTokens = (error)=>getCapacityAmount(error) <= availableCapacity;
    const retrieveRetryTokens = (error)=>{
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        const capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    const releaseRetryTokens = (capacityReleaseAmount)=>{
        availableCapacity += capacityReleaseAmount ?? noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};



const $f49d540db5ec8b34$export$1cddd42598a3b1f6 = (delayBase, attempts)=>Math.floor(Math.min((0, $c7a489f1cc1e6642$export$2412c80d04e902c6), Math.random() * 2 ** attempts * delayBase));



const $1f94dad3a72fa7e2$export$3839fd261f89ec2 = (error)=>{
    if (!error) return false;
    return (0, $0aaa9e0fb9266678$export$46428803f4bd8a0c)(error) || (0, $0aaa9e0fb9266678$export$7b87435661177a94)(error) || (0, $0aaa9e0fb9266678$export$cbecb89f6256ccc8)(error) || (0, $0aaa9e0fb9266678$export$31778435da988512)(error);
};


const $8814502283ee69bd$export$c780f8210b6eca50 = (error)=>{
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error(`AWS SDK error wrapper for ${error}`);
};


class $3cc5d22fd0fc552e$export$64af437cce00eae8 {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $c7803bea46144fee$export$6842199fccd474d3).STANDARD;
        this.retryDecider = options?.retryDecider ?? (0, $1f94dad3a72fa7e2$export$3839fd261f89ec2);
        this.delayDecider = options?.delayDecider ?? (0, $f49d540db5ec8b34$export$1cddd42598a3b1f6);
        this.retryQuota = options?.retryQuota ?? (0, $a981b5d724dad3ff$export$2ebe7988802fc284)((0, $c7a489f1cc1e6642$export$f8c3d11675a1153));
    }
    shouldRetry(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    }
    async getMaxAttempts() {
        let maxAttempts;
        try {
            maxAttempts = await this.maxAttemptsProvider();
        } catch (error) {
            maxAttempts = (0, $c7803bea46144fee$export$2c7e51f38ba5a406);
        }
        return maxAttempts;
    }
    async retry(next, args, options) {
        let retryTokenAmount;
        let attempts = 0;
        let totalDelay = 0;
        const maxAttempts = await this.getMaxAttempts();
        const { request: request } = args;
        if ((0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(request)) request.headers[0, $c7a489f1cc1e6642$export$197fd517bf66ccb2] = (0, $9aeedc2370106dcc$export$2e2bcd8739ae039)();
        while(true)try {
            if ((0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(request)) request.headers[0, $c7a489f1cc1e6642$export$d4f764f0ec4f52f] = `attempt=${attempts + 1}; max=${maxAttempts}`;
            if (options?.beforeRequest) await options.beforeRequest();
            const { response: response, output: output } = await next(args);
            if (options?.afterRequest) options.afterRequest(response);
            this.retryQuota.releaseRetryTokens(retryTokenAmount);
            output.$metadata.attempts = attempts + 1;
            output.$metadata.totalRetryDelay = totalDelay;
            return {
                response: response,
                output: output
            };
        } catch (e) {
            const err = (0, $8814502283ee69bd$export$c780f8210b6eca50)(e);
            attempts++;
            if (this.shouldRetry(err, attempts, maxAttempts)) {
                retryTokenAmount = this.retryQuota.retrieveRetryTokens(err);
                const delayFromDecider = this.delayDecider((0, $0aaa9e0fb9266678$export$cbecb89f6256ccc8)(err) ? (0, $c7a489f1cc1e6642$export$4af31f8250b48e23) : (0, $c7a489f1cc1e6642$export$7067ba90effbd789), attempts);
                const delayFromResponse = $3cc5d22fd0fc552e$var$getDelayFromRetryAfterHeader(err.$response);
                const delay = Math.max(delayFromResponse || 0, delayFromDecider);
                totalDelay += delay;
                await new Promise((resolve)=>setTimeout(resolve, delay));
                continue;
            }
            if (!err.$metadata) err.$metadata = {};
            err.$metadata.attempts = attempts;
            err.$metadata.totalRetryDelay = totalDelay;
            throw err;
        }
    }
}
const $3cc5d22fd0fc552e$var$getDelayFromRetryAfterHeader = (response)=>{
    if (!(0, $55997741113954a0$export$1d94dfe0d9d1f1e7).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};


class $3be7510d63e2c579$export$b6f3faf7501de8bc extends (0, $3cc5d22fd0fc552e$export$64af437cce00eae8) {
    constructor(maxAttemptsProvider, options){
        const { rateLimiter: rateLimiter, ...superOptions } = options ?? {};
        super(maxAttemptsProvider, superOptions);
        this.rateLimiter = rateLimiter ?? new (0, $3522fff10b612cc8$export$4d4bb1390e4746c4)();
        this.mode = (0, $c7803bea46144fee$export$6842199fccd474d3).ADAPTIVE;
    }
    async retry(next, args) {
        return super.retry(next, args, {
            beforeRequest: async ()=>{
                return this.rateLimiter.getSendToken();
            },
            afterRequest: (response)=>{
                this.rateLimiter.updateClientSendingRate(response);
            }
        });
    }
}





const $aea4bc742db6bc92$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
const $aea4bc742db6bc92$export$9ae8a04532f798bc = "max_attempts";
const $aea4bc742db6bc92$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: (env)=>{
        const value = env[$aea4bc742db6bc92$export$a19952f9e421517c];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Environment variable ${$aea4bc742db6bc92$export$a19952f9e421517c} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    configFileSelector: (profile)=>{
        const value = profile[$aea4bc742db6bc92$export$9ae8a04532f798bc];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Shared config file entry ${$aea4bc742db6bc92$export$9ae8a04532f798bc} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    default: (0, $c7803bea46144fee$export$2c7e51f38ba5a406)
};
const $aea4bc742db6bc92$export$ca7f6138f2c98476 = (input)=>{
    const { retryStrategy: retryStrategy } = input;
    const maxAttempts = (0, $c725887315749781$export$b1276c07738d6325)(input.maxAttempts ?? (0, $c7803bea46144fee$export$2c7e51f38ba5a406));
    return {
        ...input,
        maxAttempts: maxAttempts,
        retryStrategy: async ()=>{
            if (retryStrategy) return retryStrategy;
            const retryMode = await (0, $c725887315749781$export$b1276c07738d6325)(input.retryMode)();
            if (retryMode === (0, $c7803bea46144fee$export$6842199fccd474d3).ADAPTIVE) return new (0, $b3d5a9f96973f447$export$b6f3faf7501de8bc)(maxAttempts);
            return new (0, $eeefa37f57099246$export$64af437cce00eae8)(maxAttempts);
        }
    };
};
const $aea4bc742db6bc92$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
const $aea4bc742db6bc92$export$c5c0171a17765aea = "retry_mode";
const $aea4bc742db6bc92$export$972bf2bb01959ff5 = {
    environmentVariableSelector: (env)=>env[$aea4bc742db6bc92$export$4728af91ff39ef3b],
    configFileSelector: (profile)=>profile[$aea4bc742db6bc92$export$c5c0171a17765aea],
    default: (0, $c7803bea46144fee$export$41315747b7c5d042)
};





const $dabff6f839e4ed35$export$536b11ee0b9c4a95 = ()=>(next)=>async (args)=>{
            const { request: request } = args;
            if ((0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(request)) {
                delete request.headers[0, $c7a489f1cc1e6642$export$197fd517bf66ccb2];
                delete request.headers[0, $c7a489f1cc1e6642$export$d4f764f0ec4f52f];
            }
            return next(args);
        };
const $dabff6f839e4ed35$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
const $dabff6f839e4ed35$export$fa165e6edc16c2a2 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($dabff6f839e4ed35$export$536b11ee0b9c4a95(), $dabff6f839e4ed35$export$3ec587d8f35e7a2c);
        }
    });








const $3175496cb11f61f8$export$e29b4465f2a53696 = (request)=>request?.body instanceof ReadableStream;



const $26a956d2389e09da$export$a3922aa5f87bae85 = (options)=>(next, context)=>async (args)=>{
            let retryStrategy = await options.retryStrategy();
            const maxAttempts = await options.maxAttempts();
            if ($26a956d2389e09da$var$isRetryStrategyV2(retryStrategy)) {
                retryStrategy;
                let retryToken = await retryStrategy.acquireInitialRetryToken(context["partition_id"]);
                let lastError = new Error();
                let attempts = 0;
                let totalRetryDelay = 0;
                const { request: request } = args;
                const isRequest = (0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(request);
                if (isRequest) request.headers[0, $c7a489f1cc1e6642$export$197fd517bf66ccb2] = (0, $9aeedc2370106dcc$export$2e2bcd8739ae039)();
                while(true)try {
                    if (isRequest) request.headers[0, $c7a489f1cc1e6642$export$d4f764f0ec4f52f] = `attempt=${attempts + 1}; max=${maxAttempts}`;
                    const { response: response, output: output } = await next(args);
                    retryStrategy.recordSuccess(retryToken);
                    output.$metadata.attempts = attempts + 1;
                    output.$metadata.totalRetryDelay = totalRetryDelay;
                    return {
                        response: response,
                        output: output
                    };
                } catch (e) {
                    const retryErrorInfo = $26a956d2389e09da$var$getRetryErrorInfo(e);
                    lastError = (0, $8814502283ee69bd$export$c780f8210b6eca50)(e);
                    if (isRequest && (0, $3175496cb11f61f8$export$e29b4465f2a53696)(request)) {
                        (context.logger instanceof (0, $2a2593fbf5316f50$export$4147bde06f294c2e) ? console : context.logger)?.warn("An error was encountered in a non-retryable streaming request.");
                        throw lastError;
                    }
                    try {
                        retryToken = await retryStrategy.refreshRetryTokenForRetry(retryToken, retryErrorInfo);
                    } catch (refreshError) {
                        if (!lastError.$metadata) lastError.$metadata = {};
                        lastError.$metadata.attempts = attempts + 1;
                        lastError.$metadata.totalRetryDelay = totalRetryDelay;
                        throw lastError;
                    }
                    attempts = retryToken.getRetryCount();
                    const delay = retryToken.getRetryDelay();
                    totalRetryDelay += delay;
                    await new Promise((resolve)=>setTimeout(resolve, delay));
                }
            } else {
                retryStrategy;
                if (retryStrategy?.mode) context.userAgent = [
                    ...context.userAgent || [],
                    [
                        "cfg/retry-mode",
                        retryStrategy.mode
                    ]
                ];
                return retryStrategy.retry(next, args);
            }
        };
const $26a956d2389e09da$var$isRetryStrategyV2 = (retryStrategy)=>typeof retryStrategy.acquireInitialRetryToken !== "undefined" && typeof retryStrategy.refreshRetryTokenForRetry !== "undefined" && typeof retryStrategy.recordSuccess !== "undefined";
const $26a956d2389e09da$var$getRetryErrorInfo = (error)=>{
    const errorInfo = {
        error: error,
        errorType: $26a956d2389e09da$var$getRetryErrorType(error)
    };
    const retryAfterHint = $26a956d2389e09da$export$8f45b27d98dcedff(error.$response);
    if (retryAfterHint) errorInfo.retryAfterHint = retryAfterHint;
    return errorInfo;
};
const $26a956d2389e09da$var$getRetryErrorType = (error)=>{
    if ((0, $0aaa9e0fb9266678$export$cbecb89f6256ccc8)(error)) return "THROTTLING";
    if ((0, $0aaa9e0fb9266678$export$31778435da988512)(error)) return "TRANSIENT";
    if ((0, $0aaa9e0fb9266678$export$a7cbe72d7c4012af)(error)) return "SERVER_ERROR";
    return "CLIENT_ERROR";
};
const $26a956d2389e09da$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
const $26a956d2389e09da$export$c73199e2b1df9340 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($26a956d2389e09da$export$a3922aa5f87bae85(options), $26a956d2389e09da$export$44d3d03587957ce9);
        }
    });
const $26a956d2389e09da$export$8f45b27d98dcedff = (response)=>{
    if (!(0, $55997741113954a0$export$1d94dfe0d9d1f1e7).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return new Date(retryAfterSeconds * 1000);
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate;
};





const $3e2ecdf2a83b0ecd$export$dce1f72b9e752c12 = {
    step: "finalizeRequest",
    tags: [
        "HTTP_SIGNING"
    ],
    name: "httpSigningMiddleware",
    aliases: [
        "apiKeyMiddleware",
        "tokenMiddleware",
        "awsAuthMiddleware"
    ],
    override: true,
    relation: "after",
    toMiddleware: (0, $26a956d2389e09da$export$44d3d03587957ce9).name
};
const $3e2ecdf2a83b0ecd$export$ed476aa7e410a = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $897d317150ae165f$export$fe39ed571a606f80)(config), $3e2ecdf2a83b0ecd$export$dce1f72b9e752c12);
        }
    });




class $5ac0e12513678432$export$67f43b78065c5551 {
    constructor(config){
        this.authSchemes = new Map();
        for (const [key, value] of Object.entries(config))if (value !== undefined) this.authSchemes.set(key, value);
    }
    getIdentityProvider(schemeId) {
        return this.authSchemes.get(schemeId);
    }
}




class $db5413ae5aa129b3$export$823b895391979983 {
    async sign(httpRequest, identity, signingProperties) {
        if (!signingProperties) throw new Error("request could not be signed with `apiKey` since the `name` and `in` signer properties are missing");
        if (!signingProperties.name) throw new Error("request could not be signed with `apiKey` since the `name` signer property is missing");
        if (!signingProperties.in) throw new Error("request could not be signed with `apiKey` since the `in` signer property is missing");
        if (!identity.apiKey) throw new Error("request could not be signed with `apiKey` since the `apiKey` is not defined");
        const clonedRequest = (0, $435a3b4f1285ae7b$export$7587955500404ec3).clone(httpRequest);
        if (signingProperties.in === (0, $f71c6ad9eb56b268$export$8c5ca875010cb2a6).QUERY) clonedRequest.query[signingProperties.name] = identity.apiKey;
        else if (signingProperties.in === (0, $f71c6ad9eb56b268$export$8c5ca875010cb2a6).HEADER) clonedRequest.headers[signingProperties.name] = signingProperties.scheme ? `${signingProperties.scheme} ${identity.apiKey}` : identity.apiKey;
        else throw new Error("request can only be signed with `apiKey` locations `query` or `header`, but found: `" + signingProperties.in + "`");
        return clonedRequest;
    }
}



class $7db4a827efca4677$export$f646f7f27c38a496 {
    async sign(httpRequest, identity, signingProperties) {
        const clonedRequest = (0, $435a3b4f1285ae7b$export$7587955500404ec3).clone(httpRequest);
        if (!identity.token) throw new Error("request could not be signed with `token` since the `token` is not defined");
        clonedRequest.headers["Authorization"] = `Bearer ${identity.token}`;
        return clonedRequest;
    }
}


class $91453c7ccc711a9c$export$19622a6daa7bca6e {
    async sign(httpRequest, identity, signingProperties) {
        return httpRequest;
    }
}




const $ad4febab86c9dd74$export$4c74afac7567edb5 = (expirationMs)=>(identity)=>$ad4febab86c9dd74$export$5fef7ca5b4791fa9(identity) && identity.expiration.getTime() - Date.now() < expirationMs;
const $ad4febab86c9dd74$export$1d503351280d1918 = 300000;
const $ad4febab86c9dd74$export$42a11a4dafc8f476 = $ad4febab86c9dd74$export$4c74afac7567edb5($ad4febab86c9dd74$export$1d503351280d1918);
const $ad4febab86c9dd74$export$5fef7ca5b4791fa9 = (identity)=>identity.expiration !== undefined;
const $ad4febab86c9dd74$export$b258763a05c20e85 = (provider, isExpired, requiresRefresh)=>{
    if (provider === undefined) return undefined;
    const normalizedProvider = typeof provider !== "function" ? async ()=>Promise.resolve(provider) : provider;
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async (options)=>{
        if (!pending) pending = normalizedProvider(options);
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        if (isConstant) return resolved;
        if (!requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider(options);
            return resolved;
        }
        return resolved;
    };
};





const $c3c54cfc6272b39b$export$1d3c197393275463 = (context)=>context[0, $73bee794fdd638f0$export$94e7bb1b8aa610cb] || (context[0, $73bee794fdd638f0$export$94e7bb1b8aa610cb] = {});


const $7d37e26bc4ee159f$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};




function $7a010f39785200b2$export$9f1f89e694d26cd0(input, context) {
    return new $7a010f39785200b2$export$e63ecf257fa6a994(input, context);
}
class $7a010f39785200b2$export$e63ecf257fa6a994 {
    constructor(input, context){
        this.input = input;
        this.context = context;
        this.query = {};
        this.method = "";
        this.headers = {};
        this.path = "";
        this.body = null;
        this.hostname = "";
        this.resolvePathStack = [];
    }
    async build() {
        const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await this.context.endpoint();
        this.path = basePath;
        for (const resolvePath of this.resolvePathStack)resolvePath(this.path);
        return new (0, $435a3b4f1285ae7b$export$7587955500404ec3)({
            protocol: protocol,
            hostname: this.hostname || hostname,
            port: port,
            method: this.method,
            path: this.path,
            query: this.query,
            body: this.body,
            headers: this.headers
        });
    }
    hn(hostname) {
        this.hostname = hostname;
        return this;
    }
    bp(uriLabel) {
        this.resolvePathStack.push((basePath)=>{
            this.path = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + uriLabel;
        });
        return this;
    }
    p(memberName, labelValueProvider, uriLabel, isGreedyLabel) {
        this.resolvePathStack.push((path)=>{
            this.path = (0, $795414bc2cb832ad$export$405ac9a9ce1cbd80)(path, this.input, memberName, labelValueProvider, uriLabel, isGreedyLabel);
        });
        return this;
    }
    h(headers) {
        this.headers = headers;
        return this;
    }
    q(query) {
        this.query = query;
        return this;
    }
    b(body) {
        this.body = body;
        return this;
    }
    m(method) {
        this.method = method;
        return this;
    }
}


const $3b36f412383f01dc$var$makePagedClientRequest = async (CommandCtor, client, input, ...args)=>{
    return await client.send(new CommandCtor(input), ...args);
};
function $3b36f412383f01dc$export$531a5724c6bf0340(ClientCtor, CommandCtor, inputTokenName, outputTokenName, pageSizeTokenName) {
    return async function* paginateOperation(config, input, ...additionalArguments) {
        let token = config.startingToken || undefined;
        let hasNext = true;
        let page;
        while(hasNext){
            input[inputTokenName] = token;
            if (pageSizeTokenName) input[pageSizeTokenName] = input[pageSizeTokenName] ?? config.pageSize;
            if (config.client instanceof ClientCtor) page = await $3b36f412383f01dc$var$makePagedClientRequest(CommandCtor, config.client, input, ...additionalArguments);
            else throw new Error(`Invalid client, expected instance of ${ClientCtor.name}`);
            yield page;
            const prevToken = token;
            token = $3b36f412383f01dc$var$get(page, outputTokenName);
            hasNext = !!(token && (!config.stopOnSameToken || token !== prevToken));
        }
        return undefined;
    };
}
const $3b36f412383f01dc$var$get = (fromObject, path)=>{
    let cursor = fromObject;
    const pathComponents = path.split(".");
    for (const step of pathComponents){
        if (!cursor || typeof cursor !== "object") return undefined;
        cursor = cursor[step];
    }
    return cursor;
};







const $82b7882d4c770749$export$31fcf2dc8fe36f2c = async (s3ExpressIdentity, signingOptions, request, sigV4MultiRegionSigner)=>{
    const signedRequest = await sigV4MultiRegionSigner.signWithCredentials(request, s3ExpressIdentity, {});
    if (signedRequest.headers["X-Amz-Security-Token"] || signedRequest.headers["x-amz-security-token"]) throw new Error("X-Amz-Security-Token must not be set for s3-express requests.");
    return signedRequest;
};


const $18f8c43c70de4748$var$defaultErrorHandler = (signingProperties)=>(error)=>{
        throw error;
    };
const $18f8c43c70de4748$var$defaultSuccessHandler = (httpResponse, signingProperties)=>{};
const $18f8c43c70de4748$export$6b73cfcf702d6120 = (0, $3e2ecdf2a83b0ecd$export$dce1f72b9e752c12);
const $18f8c43c70de4748$export$eea084e200ec367a = (config)=>(next, context)=>async (args)=>{
            if (!(0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const smithyContext = (0, $7a2c7cffe65767aa$export$1d3c197393275463)(context);
            const scheme = smithyContext.selectedHttpAuthScheme;
            if (!scheme) throw new Error(`No HttpAuthScheme was selected: unable to sign request`);
            const { httpAuthOption: { signingProperties: signingProperties = {} }, identity: identity, signer: signer } = scheme;
            let request;
            if (context.s3ExpressIdentity) request = await (0, $82b7882d4c770749$export$31fcf2dc8fe36f2c)(context.s3ExpressIdentity, signingProperties, args.request, await config.signer());
            else request = await signer.sign(args.request, identity, signingProperties);
            const output = await next({
                ...args,
                request: request
            }).catch((signer.errorHandler || $18f8c43c70de4748$var$defaultErrorHandler)(signingProperties));
            (signer.successHandler || $18f8c43c70de4748$var$defaultSuccessHandler)(output.response, signingProperties);
            return output;
        };
const $18f8c43c70de4748$export$7b2427df5a87b408 = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($18f8c43c70de4748$export$eea084e200ec367a(config), (0, $3e2ecdf2a83b0ecd$export$dce1f72b9e752c12));
        }
    });





const $9d91e163a2247fef$export$9acff03461140bb6 = (input, { session: session })=>{
    const [s3ClientProvider, CreateSessionCommandCtor] = session;
    return {
        ...input,
        forcePathStyle: input.forcePathStyle ?? false,
        useAccelerateEndpoint: input.useAccelerateEndpoint ?? false,
        disableMultiregionAccessPoints: input.disableMultiregionAccessPoints ?? false,
        followRegionRedirects: input.followRegionRedirects ?? false,
        s3ExpressIdentityProvider: input.s3ExpressIdentityProvider ?? new (0, $e7501e975b8d3008$export$e26b7fd512d6f999)(async (key)=>s3ClientProvider().send(new CreateSessionCommandCtor({
                Bucket: key,
                SessionMode: "ReadWrite"
            }))),
        bucketEndpoint: input.bucketEndpoint ?? false
    };
};




const $32b56a6d9accc693$var$THROW_IF_EMPTY_BODY = {
    CopyObjectCommand: true,
    UploadPartCopyCommand: true,
    CompleteMultipartUploadCommand: true
};
const $32b56a6d9accc693$var$MAX_BYTES_TO_INSPECT = 3000;
const $32b56a6d9accc693$export$61d7988259be6660 = (config)=>(next, context)=>async (args)=>{
            const result = await next(args);
            const { response: response } = result;
            if (!(0, $55997741113954a0$export$1d94dfe0d9d1f1e7).isInstance(response)) return result;
            const { statusCode: statusCode, body: sourceBody } = response;
            if (statusCode < 200 || statusCode >= 300) return result;
            const isSplittableStream = typeof sourceBody?.stream === "function" || typeof sourceBody?.pipe === "function" || typeof sourceBody?.tee === "function";
            if (!isSplittableStream) return result;
            let bodyCopy = sourceBody;
            let body = sourceBody;
            if (sourceBody && typeof sourceBody === "object" && !(sourceBody instanceof Uint8Array)) [bodyCopy, body] = await (0, $8e867538439bdc40$export$e0d279bcdde969f4)(sourceBody);
            response.body = body;
            const bodyBytes = await $32b56a6d9accc693$var$collectBody(bodyCopy, {
                streamCollector: async (stream)=>{
                    return (0, $98e41a3adb6f1aeb$export$c5bd1fa662e233aa)(stream, $32b56a6d9accc693$var$MAX_BYTES_TO_INSPECT);
                }
            });
            if (typeof bodyCopy?.destroy === "function") bodyCopy.destroy();
            const bodyStringTail = config.utf8Encoder(bodyBytes.subarray(bodyBytes.length - 16));
            if (bodyBytes.length === 0 && $32b56a6d9accc693$var$THROW_IF_EMPTY_BODY[context.commandName]) {
                const err = new Error("S3 aborted request");
                err.name = "InternalError";
                throw err;
            }
            if (bodyStringTail && bodyStringTail.endsWith("</Error>")) response.statusCode = 400;
            return result;
        };
const $32b56a6d9accc693$var$collectBody = (streamBody = new Uint8Array(), context)=>{
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
const $32b56a6d9accc693$export$ea0247469da1888 = {
    relation: "after",
    toMiddleware: "deserializerMiddleware",
    tags: [
        "THROW_200_EXCEPTIONS",
        "S3"
    ],
    name: "throw200ExceptionsMiddleware",
    override: true
};
const $32b56a6d9accc693$export$97cbbd0d754f3189 = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($32b56a6d9accc693$export$61d7988259be6660(config), $32b56a6d9accc693$export$ea0247469da1888);
        }
    });


const $bc73940976620671$export$a22775fa5e2eebd9 = (str)=>typeof str === "string" && str.indexOf("arn:") === 0 && str.split(":").length >= 6;
const $bc73940976620671$export$98e6a39c04603d36 = (arn)=>{
    const segments = arn.split(":");
    if (segments.length < 6 || segments[0] !== "arn") throw new Error("Malformed ARN");
    const [, partition, service, region, accountId, ...resource] = segments;
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resource: resource.join(":")
    };
};
const $bc73940976620671$export$3f8fe6489e95757d = (arnObject)=>{
    const { partition: partition = "aws", service: service, region: region, accountId: accountId, resource: resource } = arnObject;
    if ([
        service,
        region,
        accountId,
        resource
    ].some((segment)=>typeof segment !== "string")) throw new Error("Input ARN object is invalid");
    return `arn:${partition}:${service}:${region}:${accountId}:${resource}`;
};


function $8790c9a27bd30974$export$f49f3b47ec112939(options) {
    return (next, context)=>async (args)=>{
            if (options.bucketEndpoint) {
                const endpoint = context.endpointV2;
                if (endpoint) {
                    const bucket = args.input.Bucket;
                    if (typeof bucket === "string") try {
                        const bucketEndpointUrl = new URL(bucket);
                        context.endpointV2 = {
                            ...endpoint,
                            url: bucketEndpointUrl
                        };
                    } catch (e) {
                        const warning = `@aws-sdk/middleware-sdk-s3: bucketEndpoint=true was set but Bucket=${bucket} could not be parsed as URL.`;
                        if (context.logger?.constructor?.name === "NoOpLogger") console.warn(warning);
                        else context.logger?.warn?.(warning);
                        throw e;
                    }
                }
            }
            return next(args);
        };
}
const $8790c9a27bd30974$export$3912e6e4bed18209 = {
    name: "bucketEndpointMiddleware",
    override: true,
    relation: "after",
    toMiddleware: "endpointV2Middleware"
};


function $a9b98b905e7c7f12$export$97e70cdcaaace32a({ bucketEndpoint: bucketEndpoint }) {
    return (next)=>async (args)=>{
            const { input: { Bucket: Bucket } } = args;
            if (!bucketEndpoint && typeof Bucket === "string" && !(0, $bc73940976620671$export$a22775fa5e2eebd9)(Bucket) && Bucket.indexOf("/") >= 0) {
                const err = new Error(`Bucket name shouldn't contain '/', received '${Bucket}'`);
                err.name = "InvalidBucketName";
                throw err;
            }
            return next({
                ...args
            });
        };
}
const $a9b98b905e7c7f12$export$db8005617bec77bd = {
    step: "initialize",
    tags: [
        "VALIDATE_BUCKET_NAME"
    ],
    name: "validateBucketNameMiddleware",
    override: true
};
const $a9b98b905e7c7f12$export$c30d61978fbb3ad8 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($a9b98b905e7c7f12$export$97e70cdcaaace32a(options), $a9b98b905e7c7f12$export$db8005617bec77bd);
            clientStack.addRelativeTo((0, $8790c9a27bd30974$export$f49f3b47ec112939)(options), (0, $8790c9a27bd30974$export$3912e6e4bed18209));
        }
    });




function $db80f9dc151da2fd$export$16515ae394ee1bc8(options) {
    return (next)=>async (args)=>{
            const input = {
                ...args.input
            };
            const properties = [
                {
                    target: "SSECustomerKey",
                    hash: "SSECustomerKeyMD5"
                },
                {
                    target: "CopySourceSSECustomerKey",
                    hash: "CopySourceSSECustomerKeyMD5"
                }
            ];
            for (const prop of properties){
                const value = input[prop.target];
                if (value) {
                    let valueForHash;
                    if (typeof value === "string") {
                        if ($db80f9dc151da2fd$export$7f8788345640ea94(value, options)) valueForHash = options.base64Decoder(value);
                        else {
                            valueForHash = options.utf8Decoder(value);
                            input[prop.target] = options.base64Encoder(valueForHash);
                        }
                    } else {
                        valueForHash = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : new Uint8Array(value);
                        input[prop.target] = options.base64Encoder(valueForHash);
                    }
                    const hash = new options.md5();
                    hash.update(valueForHash);
                    input[prop.hash] = options.base64Encoder(await hash.digest());
                }
            }
            return next({
                ...args,
                input: input
            });
        };
}
const $db80f9dc151da2fd$export$bd3ed071b8ca05b3 = {
    name: "ssecMiddleware",
    step: "initialize",
    tags: [
        "SSE"
    ],
    override: true
};
const $db80f9dc151da2fd$export$baf25e0187b0946b = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($db80f9dc151da2fd$export$16515ae394ee1bc8(config), $db80f9dc151da2fd$export$bd3ed071b8ca05b3);
        }
    });
function $db80f9dc151da2fd$export$7f8788345640ea94(str, options) {
    const base64Regex = /^(?:[A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    if (!base64Regex.test(str)) return false;
    try {
        const decodedBytes = options.base64Decoder(str);
        return decodedBytes.length === 32;
    } catch  {
        return false;
    }
}





const $6f3a98a1538687cd$export$70b6341cd51750a8 = (options)=>{
    return {
        ...options,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        forcePathStyle: options.forcePathStyle ?? false,
        useAccelerateEndpoint: options.useAccelerateEndpoint ?? false,
        useGlobalEndpoint: options.useGlobalEndpoint ?? false,
        disableMultiregionAccessPoints: options.disableMultiregionAccessPoints ?? false,
        defaultSigningName: "s3"
    };
};
const $6f3a98a1538687cd$export$9c07ced2019f0ae0 = {
    ForcePathStyle: {
        type: "clientContextParams",
        name: "forcePathStyle"
    },
    UseArnRegion: {
        type: "clientContextParams",
        name: "useArnRegion"
    },
    DisableMultiRegionAccessPoints: {
        type: "clientContextParams",
        name: "disableMultiregionAccessPoints"
    },
    Accelerate: {
        type: "clientContextParams",
        name: "useAccelerateEndpoint"
    },
    DisableS3ExpressSessionAuth: {
        type: "clientContextParams",
        name: "disableS3ExpressSessionAuth"
    },
    UseGlobalEndpoint: {
        type: "builtInParams",
        name: "useGlobalEndpoint"
    },
    UseFIPS: {
        type: "builtInParams",
        name: "useFipsEndpoint"
    },
    Endpoint: {
        type: "builtInParams",
        name: "endpoint"
    },
    Region: {
        type: "builtInParams",
        name: "region"
    },
    UseDualStack: {
        type: "builtInParams",
        name: "useDualstackEndpoint"
    }
};




class $92dbcbc8228e43d8$export$a53c51960b14a8e5 extends (0, $d8c529a0bf92abea$export$29647f3b4097d3c0) {
    constructor(options){
        super(options);
        Object.setPrototypeOf(this, $92dbcbc8228e43d8$export$a53c51960b14a8e5.prototype);
    }
}


const $971b440947405896$export$d651da0d36c71698 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
class $971b440947405896$export$a97e3c65be291319 extends (0, $92dbcbc8228e43d8$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "ObjectAlreadyInActiveTierError",
            $fault: "client",
            ...opts
        });
        this.name = "ObjectAlreadyInActiveTierError";
        this.$fault = "client";
        Object.setPrototypeOf(this, $971b440947405896$export$a97e3c65be291319.prototype);
    }
}
const $971b440947405896$export$b5ec6150a6c2000b = {
    Bulk: "Bulk",
    Expedited: "Expedited",
    Standard: "Standard"
};
const $971b440947405896$export$32402a1a71d3ed97 = {
    SQL: "SQL"
};
const $971b440947405896$export$cf7621ba1f62c1fb = {
    BZIP2: "BZIP2",
    GZIP: "GZIP",
    NONE: "NONE"
};
const $971b440947405896$export$e0a8b40ee8e7958f = {
    IGNORE: "IGNORE",
    NONE: "NONE",
    USE: "USE"
};
const $971b440947405896$export$b8d04dd3765058e2 = {
    DOCUMENT: "DOCUMENT",
    LINES: "LINES"
};
const $971b440947405896$export$b4890521754421ba = {
    ALWAYS: "ALWAYS",
    ASNEEDED: "ASNEEDED"
};
const $971b440947405896$export$ee855080cc4fa5a8 = {
    SELECT: "SELECT"
};
var $971b440947405896$export$4c951f3462fad8ac;
(function(SelectObjectContentEventStream) {
    SelectObjectContentEventStream.visit = (value, visitor)=>{
        if (value.Records !== undefined) return visitor.Records(value.Records);
        if (value.Stats !== undefined) return visitor.Stats(value.Stats);
        if (value.Progress !== undefined) return visitor.Progress(value.Progress);
        if (value.Cont !== undefined) return visitor.Cont(value.Cont);
        if (value.End !== undefined) return visitor.End(value.End);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($971b440947405896$export$4c951f3462fad8ac || ($971b440947405896$export$4c951f3462fad8ac = {}));
const $971b440947405896$export$4532cbbab0d00c4f = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $971b440947405896$export$35f8aea70e7bdcca = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $971b440947405896$export$37ef1918e28a982e = (obj)=>({
        ...obj,
        ...obj.KMSKeyId && {
            KMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $971b440947405896$export$83a69b3e9aa40aca = (obj)=>({
        ...obj,
        ...obj.Encryption && {
            Encryption: $971b440947405896$export$37ef1918e28a982e(obj.Encryption)
        }
    });
const $971b440947405896$export$a655f667672eabb6 = (obj)=>({
        ...obj,
        ...obj.S3 && {
            S3: $971b440947405896$export$83a69b3e9aa40aca(obj.S3)
        }
    });
const $971b440947405896$export$4488eace7b3ecf8a = (obj)=>({
        ...obj,
        ...obj.OutputLocation && {
            OutputLocation: $971b440947405896$export$a655f667672eabb6(obj.OutputLocation)
        }
    });
const $971b440947405896$export$6b86ebfab0a812dd = (obj)=>({
        ...obj,
        ...obj.RestoreRequest && {
            RestoreRequest: $971b440947405896$export$4488eace7b3ecf8a(obj.RestoreRequest)
        }
    });
const $971b440947405896$export$b33d770effc8305b = (obj)=>{
    if (obj.Records !== undefined) return {
        Records: obj.Records
    };
    if (obj.Stats !== undefined) return {
        Stats: obj.Stats
    };
    if (obj.Progress !== undefined) return {
        Progress: obj.Progress
    };
    if (obj.Cont !== undefined) return {
        Cont: obj.Cont
    };
    if (obj.End !== undefined) return {
        End: obj.End
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $971b440947405896$export$f672474f32fab0f0 = (obj)=>({
        ...obj,
        ...obj.Payload && {
            Payload: "STREAMING_CONTENT"
        }
    });
const $971b440947405896$export$375c9835f190a59b = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $971b440947405896$export$16e90045ae9e0c88 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $971b440947405896$export$d8157ceb4def2c93 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $971b440947405896$export$f6814a8c31592894 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $971b440947405896$export$250bf831eb24996d = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $971b440947405896$export$a8eca9afe1025803 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });



var $f52cd47a5eadbffc$exports = {};
'use strict';
var $fe1029334364915d$exports = {};

$parcel$export($fe1029334364915d$exports, "validate", () => $fe1029334364915d$export$a22775fa5e2eebd9, (v) => $fe1029334364915d$export$a22775fa5e2eebd9 = v);
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $fe1029334364915d$export$a22775fa5e2eebd9;
'use strict';
var $d86fb9779850a704$export$a5edf3f35b6dd392;
var $d86fb9779850a704$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $d86fb9779850a704$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $d86fb9779850a704$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $d86fb9779850a704$export$998d7ff9801e90bb;
var $d86fb9779850a704$export$aaa9734c55cb7a19;
var $d86fb9779850a704$export$e8f2644f7085b4b1;
'use strict';
const $d86fb9779850a704$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $d86fb9779850a704$var$nameChar = $d86fb9779850a704$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $d86fb9779850a704$var$nameRegexp = '[' + $d86fb9779850a704$var$nameStartChar + '][' + $d86fb9779850a704$var$nameChar + ']*';
const $d86fb9779850a704$var$regexName = new RegExp('^' + $d86fb9779850a704$var$nameRegexp + '$');
const $d86fb9779850a704$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $d86fb9779850a704$var$isName = function(string) {
    const match = $d86fb9779850a704$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$d86fb9779850a704$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$d86fb9779850a704$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$d86fb9779850a704$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$d86fb9779850a704$export$bf7199a9ebcb84a9 = function(v) {
    if ($d86fb9779850a704$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
$d86fb9779850a704$export$998d7ff9801e90bb = $d86fb9779850a704$var$isName;
$d86fb9779850a704$export$aaa9734c55cb7a19 = $d86fb9779850a704$var$getAllMatches;
$d86fb9779850a704$export$e8f2644f7085b4b1 = $d86fb9779850a704$var$nameRegexp;


const $fe1029334364915d$var$defaultOptions = {
    allowBooleanAttributes: false,
    unpairedTags: []
};
$fe1029334364915d$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = Object.assign({}, $fe1029334364915d$var$defaultOptions, options);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $fe1029334364915d$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $fe1029334364915d$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$fe1029334364915d$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $fe1029334364915d$var$getErrorObject('InvalidTag', msg, $fe1029334364915d$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $fe1029334364915d$var$readAttributeStr(xmlData, i);
                if (result === false) return $fe1029334364915d$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $fe1029334364915d$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $fe1029334364915d$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $fe1029334364915d$var$getErrorObject(isValid.err.code, isValid.err.msg, $fe1029334364915d$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $fe1029334364915d$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $fe1029334364915d$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $fe1029334364915d$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $fe1029334364915d$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else if (tags.length === 0) return $fe1029334364915d$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' has not been opened.", $fe1029334364915d$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $fe1029334364915d$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $fe1029334364915d$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $fe1029334364915d$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $fe1029334364915d$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $fe1029334364915d$var$getErrorObject(isValid.err.code, isValid.err.msg, $fe1029334364915d$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $fe1029334364915d$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $fe1029334364915d$var$getLineNumberForPosition(xmlData, i));
                    else if (options.unpairedTags.indexOf(tagName) !== -1) ;
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $fe1029334364915d$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $fe1029334364915d$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $fe1029334364915d$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $fe1029334364915d$var$getErrorObject('InvalidChar', "char '&' is not expected.", $fe1029334364915d$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    } else {
                        if (reachedRoot === true && !$fe1029334364915d$var$isWhiteSpace(xmlData[i])) return $fe1029334364915d$var$getErrorObject('InvalidXml', "Extra text at the end", $fe1029334364915d$var$getLineNumberForPosition(xmlData, i));
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if ($fe1029334364915d$var$isWhiteSpace(xmlData[i])) continue;
            return $fe1029334364915d$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $fe1029334364915d$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $fe1029334364915d$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $fe1029334364915d$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $fe1029334364915d$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $fe1029334364915d$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
function $fe1029334364915d$var$isWhiteSpace(char) {
    return char === ' ' || char === '\t' || char === '\n' || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $fe1029334364915d$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $fe1029334364915d$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $fe1029334364915d$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $fe1029334364915d$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $fe1029334364915d$var$doubleQuote = '"';
const $fe1029334364915d$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $fe1029334364915d$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $fe1029334364915d$var$doubleQuote || xmlData[i] === $fe1029334364915d$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $fe1029334364915d$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $fe1029334364915d$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $d86fb9779850a704$export$aaa9734c55cb7a19(attrStr, $fe1029334364915d$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $fe1029334364915d$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $fe1029334364915d$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] !== undefined && matches[i][4] === undefined) return $fe1029334364915d$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' is without value.", $fe1029334364915d$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $fe1029334364915d$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $fe1029334364915d$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$fe1029334364915d$var$validateAttrName(attrName)) return $fe1029334364915d$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $fe1029334364915d$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $fe1029334364915d$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $fe1029334364915d$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $fe1029334364915d$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $fe1029334364915d$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $fe1029334364915d$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $fe1029334364915d$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $fe1029334364915d$var$validateAttrName(attrName) {
    return $d86fb9779850a704$export$998d7ff9801e90bb(attrName);
}
// const startsWithXML = /^xml/i;
function $fe1029334364915d$var$validateTagName(tagname) {
    return $d86fb9779850a704$export$998d7ff9801e90bb(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $fe1029334364915d$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $fe1029334364915d$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}


var $76f8319cf3c47dec$exports = {};
var $80a0d6107e56b23a$export$ecbd7d678ac4909b;
var $80a0d6107e56b23a$export$ba43bf67f3d48107;
const $80a0d6107e56b23a$var$defaultOptions = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true,
    cdataPropName: false,
    numberParseOptions: {
        hex: true,
        leadingZeros: true,
        eNotation: true
    },
    tagValueProcessor: function(tagName, val) {
        return val;
    },
    attributeValueProcessor: function(attrName, val) {
        return val;
    },
    stopNodes: [],
    alwaysCreateTextNode: false,
    isArray: ()=>false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
    transformAttributeName: false,
    updateTag: function(tagName, jPath, attrs) {
        return tagName;
    }
};
const $80a0d6107e56b23a$var$buildOptions = function(options) {
    return Object.assign({}, $80a0d6107e56b23a$var$defaultOptions, options);
};
$80a0d6107e56b23a$export$ecbd7d678ac4909b = $80a0d6107e56b23a$var$buildOptions;
$80a0d6107e56b23a$export$ba43bf67f3d48107 = $80a0d6107e56b23a$var$defaultOptions;


var $76f8319cf3c47dec$require$buildOptions = $80a0d6107e56b23a$export$ecbd7d678ac4909b;
var $f830b202ab6534a2$exports = {};
'use strict';

var $f828037182c2b664$exports = {};
'use strict';
class $f828037182c2b664$var$XmlNode {
    constructor(tagname){
        this.tagname = tagname;
        this.child = []; //nested tags, text, cdata, comments in order
        this[":@"] = {}; //attributes map
    }
    add(key, val) {
        // this.child.push( {name : key, val: val, isCdata: isCdata });
        if (key === "__proto__") key = "#__proto__";
        this.child.push({
            [key]: val
        });
    }
    addChild(node) {
        if (node.tagname === "__proto__") node.tagname = "#__proto__";
        if (node[":@"] && Object.keys(node[":@"]).length > 0) this.child.push({
            [node.tagname]: node.child,
            [":@"]: node[":@"]
        });
        else this.child.push({
            [node.tagname]: node.child
        });
    }
}
$f828037182c2b664$exports = $f828037182c2b664$var$XmlNode;


var $67088a44eb245cef$exports = {};

//TODO: handle comments
function $67088a44eb245cef$var$readDocType(xmlData, i) {
    const entities = {};
    if (xmlData[i + 3] === 'O' && xmlData[i + 4] === 'C' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'Y' && xmlData[i + 7] === 'P' && xmlData[i + 8] === 'E') {
        i = i + 9;
        let angleBracketsCount = 1;
        let hasBody = false, comment = false;
        let exp = "";
        for(; i < xmlData.length; i++){
            if (xmlData[i] === '<' && !comment) {
                if (hasBody && $67088a44eb245cef$var$isEntity(xmlData, i)) {
                    i += 7;
                    [entityName, val, i] = $67088a44eb245cef$var$readEntityExp(xmlData, i + 1);
                    if (val.indexOf("&") === -1) entities[$67088a44eb245cef$var$validateEntityName(entityName)] = {
                        regx: RegExp(`&${entityName};`, "g"),
                        val: val
                    };
                } else if (hasBody && $67088a44eb245cef$var$isElement(xmlData, i)) i += 8; //Not supported
                else if (hasBody && $67088a44eb245cef$var$isAttlist(xmlData, i)) i += 8; //Not supported
                else if (hasBody && $67088a44eb245cef$var$isNotation(xmlData, i)) i += 9; //Not supported
                else if ($67088a44eb245cef$var$isComment) comment = true;
                else throw new Error("Invalid DOCTYPE");
                angleBracketsCount++;
                exp = "";
            } else if (xmlData[i] === '>') {
                if (comment) {
                    if (xmlData[i - 1] === "-" && xmlData[i - 2] === "-") {
                        comment = false;
                        angleBracketsCount--;
                    }
                } else angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            } else if (xmlData[i] === '[') hasBody = true;
            else exp += xmlData[i];
        }
        if (angleBracketsCount !== 0) throw new Error(`Unclosed DOCTYPE`);
    } else throw new Error(`Invalid Tag instead of DOCTYPE`);
    return {
        entities: entities,
        i: i
    };
}
function $67088a44eb245cef$var$readEntityExp(xmlData, i) {
    //External entities are not supported
    //    <!ENTITY ext SYSTEM "http://normal-website.com" >
    //Parameter entities are not supported
    //    <!ENTITY entityname "&anotherElement;">
    //Internal entities are supported
    //    <!ENTITY entityname "replacement text">
    //read EntityName
    let entityName1 = "";
    for(; i < xmlData.length && xmlData[i] !== "'" && xmlData[i] !== '"'; i++)// if(xmlData[i] === " ") continue;
    // else 
    entityName1 += xmlData[i];
    entityName1 = entityName1.trim();
    if (entityName1.indexOf(" ") !== -1) throw new Error("External entites are not supported");
    //read Entity Value
    const startChar = xmlData[i++];
    let val1 = "";
    for(; i < xmlData.length && xmlData[i] !== startChar; i++)val1 += xmlData[i];
    return [
        entityName1,
        val1,
        i
    ];
}
function $67088a44eb245cef$var$isComment(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === '-' && xmlData[i + 3] === '-') return true;
    return false;
}
function $67088a44eb245cef$var$isEntity(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'N' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'I' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'Y') return true;
    return false;
}
function $67088a44eb245cef$var$isElement(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'L' && xmlData[i + 4] === 'E' && xmlData[i + 5] === 'M' && xmlData[i + 6] === 'E' && xmlData[i + 7] === 'N' && xmlData[i + 8] === 'T') return true;
    return false;
}
function $67088a44eb245cef$var$isAttlist(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'A' && xmlData[i + 3] === 'T' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'L' && xmlData[i + 6] === 'I' && xmlData[i + 7] === 'S' && xmlData[i + 8] === 'T') return true;
    return false;
}
function $67088a44eb245cef$var$isNotation(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'N' && xmlData[i + 3] === 'O' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'A' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'I' && xmlData[i + 8] === 'O' && xmlData[i + 9] === 'N') return true;
    return false;
}
function $67088a44eb245cef$var$validateEntityName(name) {
    if ($d86fb9779850a704$export$998d7ff9801e90bb(name)) return name;
    else throw new Error(`Invalid entity name ${name}`);
}
$67088a44eb245cef$exports = $67088a44eb245cef$var$readDocType;


var $74e98d3beadbb714$exports = {};
const $74e98d3beadbb714$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $74e98d3beadbb714$var$numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
// const octRegex = /0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $74e98d3beadbb714$var$consider = {
    hex: true,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
};
function $74e98d3beadbb714$var$toNumber(str, options = {}) {
    // const options = Object.assign({}, consider);
    // if(opt.leadingZeros === false){
    //     options.leadingZeros = false;
    // }else if(opt.hex === false){
    //     options.hex = false;
    // }
    options = Object.assign({}, $74e98d3beadbb714$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    // if(trimmedStr === "0.0") return 0;
    // else if(trimmedStr === "+0.0") return 0;
    // else if(trimmedStr === "-0.0") return -0;
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (options.hex && $74e98d3beadbb714$var$hexRegex.test(trimmedStr)) return Number.parseInt(trimmedStr, 16);
    else {
        //separate negative sign, leading zeros, and rest number
        const match = $74e98d3beadbb714$var$numRegex.exec(trimmedStr);
        if (match) {
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = $74e98d3beadbb714$var$trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            const eNotation = match[4] || match[6];
            if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else {
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if (numStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (eNotation) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    // const decimalPart = match[5].substr(1);
                    // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));
                    // const p = numStr.indexOf(".");
                    // const givenIntPart = numStr.substr(0,p);
                    // const givenDecPart = numStr.substr(p+1);
                    if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                    else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (sign && numStr === "-" + numTrimmedByZeros) return num;
                    else return str;
                }
                if (leadingZeros) {
                    // if(numTrimmedByZeros === numStr){
                    //     if(options.leadingZeros) return num;
                    //     else return str;
                    // }else return str;
                    if (numTrimmedByZeros === numStr) return num;
                    else if (sign + numTrimmedByZeros === numStr) return num;
                    else return str;
                }
                if (trimmedStr === numStr) return num;
                else if (trimmedStr === sign + numStr) return num;
                // else{
                //     //number with +/- sign
                //     trimmedStr.test(/[-+][0-9]);
                // }
                return str;
            }
        // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
        } else return str;
    }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $74e98d3beadbb714$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
$74e98d3beadbb714$exports = $74e98d3beadbb714$var$toNumber;


// const regx =
//   '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'
//   .replace(/NAME/g, util.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
class $f830b202ab6534a2$var$OrderedObjParser {
    constructor(options){
        this.options = options;
        this.currentNode = null;
        this.tagsNodeStack = [];
        this.docTypeEntities = {};
        this.lastEntities = {
            "apos": {
                regex: /&(apos|#39|#x27);/g,
                val: "'"
            },
            "gt": {
                regex: /&(gt|#62|#x3E);/g,
                val: ">"
            },
            "lt": {
                regex: /&(lt|#60|#x3C);/g,
                val: "<"
            },
            "quot": {
                regex: /&(quot|#34|#x22);/g,
                val: "\""
            }
        };
        this.ampEntity = {
            regex: /&(amp|#38|#x26);/g,
            val: "&"
        };
        this.htmlEntities = {
            "space": {
                regex: /&(nbsp|#160);/g,
                val: " "
            },
            // "lt" : { regex: /&(lt|#60);/g, val: "<" },
            // "gt" : { regex: /&(gt|#62);/g, val: ">" },
            // "amp" : { regex: /&(amp|#38);/g, val: "&" },
            // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
            // "apos" : { regex: /&(apos|#39);/g, val: "'" },
            "cent": {
                regex: /&(cent|#162);/g,
                val: "\xa2"
            },
            "pound": {
                regex: /&(pound|#163);/g,
                val: "\xa3"
            },
            "yen": {
                regex: /&(yen|#165);/g,
                val: "\xa5"
            },
            "euro": {
                regex: /&(euro|#8364);/g,
                val: "\u20AC"
            },
            "copyright": {
                regex: /&(copy|#169);/g,
                val: "\xa9"
            },
            "reg": {
                regex: /&(reg|#174);/g,
                val: "\xae"
            },
            "inr": {
                regex: /&(inr|#8377);/g,
                val: "\u20B9"
            },
            "num_dec": {
                regex: /&#([0-9]{1,7});/g,
                val: (_, str)=>String.fromCharCode(Number.parseInt(str, 10))
            },
            "num_hex": {
                regex: /&#x([0-9a-fA-F]{1,6});/g,
                val: (_, str)=>String.fromCharCode(Number.parseInt(str, 16))
            }
        };
        this.addExternalEntities = $f830b202ab6534a2$var$addExternalEntities;
        this.parseXml = $f830b202ab6534a2$var$parseXml;
        this.parseTextData = $f830b202ab6534a2$var$parseTextData;
        this.resolveNameSpace = $f830b202ab6534a2$var$resolveNameSpace;
        this.buildAttributesMap = $f830b202ab6534a2$var$buildAttributesMap;
        this.isItStopNode = $f830b202ab6534a2$var$isItStopNode;
        this.replaceEntitiesValue = $f830b202ab6534a2$var$replaceEntitiesValue;
        this.readStopNodeData = $f830b202ab6534a2$var$readStopNodeData;
        this.saveTextToParentTag = $f830b202ab6534a2$var$saveTextToParentTag;
        this.addChild = $f830b202ab6534a2$var$addChild;
    }
}
function $f830b202ab6534a2$var$addExternalEntities(externalEntities) {
    const entKeys = Object.keys(externalEntities);
    for(let i = 0; i < entKeys.length; i++){
        const ent = entKeys[i];
        this.lastEntities[ent] = {
            regex: new RegExp("&" + ent + ";", "g"),
            val: externalEntities[ent]
        };
    }
}
/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */ function $f830b202ab6534a2$var$parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
    if (val !== undefined) {
        if (this.options.trimValues && !dontTrim) val = val.trim();
        if (val.length > 0) {
            if (!escapeEntities) val = this.replaceEntitiesValue(val);
            const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
            if (newval === null || newval === undefined) //don't parse
            return val;
            else if (typeof newval !== typeof val || newval !== val) //overwrite
            return newval;
            else if (this.options.trimValues) return $f830b202ab6534a2$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
            else {
                const trimmedVal = val.trim();
                if (trimmedVal === val) return $f830b202ab6534a2$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
                else return val;
            }
        }
    }
}
function $f830b202ab6534a2$var$resolveNameSpace(tagname) {
    if (this.options.removeNSPrefix) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $f830b202ab6534a2$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');
function $f830b202ab6534a2$var$buildAttributesMap(attrStr, jPath, tagName) {
    if (!this.options.ignoreAttributes && typeof attrStr === 'string') {
        // attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $d86fb9779850a704$export$aaa9734c55cb7a19(attrStr, $f830b202ab6534a2$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = this.resolveNameSpace(matches[i][1]);
            let oldVal = matches[i][4];
            let aName = this.options.attributeNamePrefix + attrName;
            if (attrName.length) {
                if (this.options.transformAttributeName) aName = this.options.transformAttributeName(aName);
                if (aName === "__proto__") aName = "#__proto__";
                if (oldVal !== undefined) {
                    if (this.options.trimValues) oldVal = oldVal.trim();
                    oldVal = this.replaceEntitiesValue(oldVal);
                    const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
                    if (newVal === null || newVal === undefined) //don't parse
                    attrs[aName] = oldVal;
                    else if (typeof newVal !== typeof oldVal || newVal !== oldVal) //overwrite
                    attrs[aName] = newVal;
                    else //parse
                    attrs[aName] = $f830b202ab6534a2$var$parseValue(oldVal, this.options.parseAttributeValue, this.options.numberParseOptions);
                } else if (this.options.allowBooleanAttributes) attrs[aName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (this.options.attributesGroupName) {
            const attrCollection = {};
            attrCollection[this.options.attributesGroupName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $f830b202ab6534a2$var$parseXml = function(xmlData) {
    xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
    const xmlObj = new $f828037182c2b664$exports('!xml');
    let currentNode = xmlObj;
    let textData = "";
    let jPath = "";
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            // const nextIndex = i+1;
            // const _2ndChar = xmlData[nextIndex];
            if (xmlData[i + 1] === '/') {
                const closeIndex = $f830b202ab6534a2$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (this.options.removeNSPrefix) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                if (currentNode) textData = this.saveTextToParentTag(textData, currentNode, jPath);
                //check if last tag of nested tag was unpaired tag
                const lastTagName = jPath.substring(jPath.lastIndexOf(".") + 1);
                if (tagName && this.options.unpairedTags.indexOf(tagName) !== -1) throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
                let propIndex = 0;
                if (lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1) {
                    propIndex = jPath.lastIndexOf('.', jPath.lastIndexOf('.') - 1);
                    this.tagsNodeStack.pop();
                } else propIndex = jPath.lastIndexOf(".");
                jPath = jPath.substring(0, propIndex);
                currentNode = this.tagsNodeStack.pop(); //avoid recursion, set the parent tag scope
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') {
                let tagData = $f830b202ab6534a2$var$readTagExp(xmlData, i, false, "?>");
                if (!tagData) throw new Error("Pi Tag is not closed.");
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags) ;
                else {
                    const childNode = new $f828037182c2b664$exports(tagData.tagName);
                    childNode.add(this.options.textNodeName, "");
                    if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
                    this.addChild(currentNode, childNode, jPath);
                }
                i = tagData.closeIndex + 1;
            } else if (xmlData.substr(i + 1, 3) === '!--') {
                const endIndex = $f830b202ab6534a2$var$findClosingIndex(xmlData, "-->", i + 4, "Comment is not closed.");
                if (this.options.commentPropName) {
                    const comment = xmlData.substring(i + 4, endIndex - 2);
                    textData = this.saveTextToParentTag(textData, currentNode, jPath);
                    currentNode.add(this.options.commentPropName, [
                        {
                            [this.options.textNodeName]: comment
                        }
                    ]);
                }
                i = endIndex;
            } else if (xmlData.substr(i + 1, 2) === '!D') {
                const result = $67088a44eb245cef$exports(xmlData, i);
                this.docTypeEntities = result.entities;
                i = result.i;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $f830b202ab6534a2$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true, true);
                if (val == undefined) val = "";
                //cdata should be set even if it is 0 length string
                if (this.options.cdataPropName) currentNode.add(this.options.cdataPropName, [
                    {
                        [this.options.textNodeName]: tagExp
                    }
                ]);
                else currentNode.add(this.options.textNodeName, val);
                i = closeIndex + 2;
            } else {
                let result = $f830b202ab6534a2$var$readTagExp(xmlData, i, this.options.removeNSPrefix);
                let tagName = result.tagName;
                const rawTagName = result.rawTagName;
                let tagExp = result.tagExp;
                let attrExpPresent = result.attrExpPresent;
                let closeIndex = result.closeIndex;
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                //save text as child node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') //when nested tag is found
                    textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
                }
                //check if last tag was unpaired tag
                const lastTag = currentNode;
                if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
                    currentNode = this.tagsNodeStack.pop();
                    jPath = jPath.substring(0, jPath.lastIndexOf("."));
                }
                if (tagName !== xmlObj.tagname) jPath += jPath ? "." + tagName : tagName;
                if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) {
                    let tagContent = "";
                    //self-closing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        i = result.closeIndex;
                    } else if (this.options.unpairedTags.indexOf(tagName) !== -1) i = result.closeIndex;
                    else {
                        //read until closing tag is found
                        const result = this.readStopNodeData(xmlData, rawTagName, closeIndex + 1);
                        if (!result) throw new Error(`Unexpected end of ${rawTagName}`);
                        i = result.i;
                        tagContent = result.tagContent;
                    }
                    const childNode = new $f828037182c2b664$exports(tagName);
                    if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                    if (tagContent) tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
                    jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    childNode.add(this.options.textNodeName, tagContent);
                    this.addChild(currentNode, childNode, jPath);
                } else {
                    //selfClosing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                        const childNode = new $f828037182c2b664$exports(tagName);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath);
                        jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    } else {
                        const childNode = new $f828037182c2b664$exports(tagName);
                        this.tagsNodeStack.push(currentNode);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath);
                        currentNode = childNode;
                    }
                    textData = "";
                    i = closeIndex;
                }
            }
        } else textData += xmlData[i];
    }
    return xmlObj.child;
};
function $f830b202ab6534a2$var$addChild(currentNode, childNode, jPath) {
    const result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
    if (result === false) ;
    else if (typeof result === "string") {
        childNode.tagname = result;
        currentNode.addChild(childNode);
    } else currentNode.addChild(childNode);
}
const $f830b202ab6534a2$var$replaceEntitiesValue = function(val) {
    if (this.options.processEntities) {
        for(let entityName in this.docTypeEntities){
            const entity = this.docTypeEntities[entityName];
            val = val.replace(entity.regx, entity.val);
        }
        for(let entityName in this.lastEntities){
            const entity = this.lastEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        if (this.options.htmlEntities) for(let entityName in this.htmlEntities){
            const entity = this.htmlEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        val = val.replace(this.ampEntity.regex, this.ampEntity.val);
    }
    return val;
};
function $f830b202ab6534a2$var$saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
    if (textData) {
        if (isLeafNode === undefined) isLeafNode = Object.keys(currentNode.child).length === 0;
        textData = this.parseTextData(textData, currentNode.tagname, jPath, false, currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false, isLeafNode);
        if (textData !== undefined && textData !== "") currentNode.add(this.options.textNodeName, textData);
        textData = "";
    }
    return textData;
}
//TODO: use jPath to simplify the logic
/**
 * 
 * @param {string[]} stopNodes 
 * @param {string} jPath
 * @param {string} currentTagName 
 */ function $f830b202ab6534a2$var$isItStopNode(stopNodes, jPath, currentTagName) {
    const allNodesExp = "*." + currentTagName;
    for(const stopNodePath in stopNodes){
        const stopNodeExp = stopNodes[stopNodePath];
        if (allNodesExp === stopNodeExp || jPath === stopNodeExp) return true;
    }
    return false;
}
/**
 * Returns the tag Expression and where it is ending handling single-double quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */ function $f830b202ab6534a2$var$tagExpWithClosingIndex(xmlData, i, closingChar = ">") {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < xmlData.length; index++){
        let ch = xmlData[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === closingChar[0]) {
            if (closingChar[1]) {
                if (xmlData[index + 1] === closingChar[1]) return {
                    data: tagExp,
                    index: index
                };
            } else return {
                data: tagExp,
                index: index
            };
        } else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $f830b202ab6534a2$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
function $f830b202ab6534a2$var$readTagExp(xmlData, i, removeNSPrefix, closingChar = ">") {
    const result = $f830b202ab6534a2$var$tagExpWithClosingIndex(xmlData, i + 1, closingChar);
    if (!result) return;
    let tagExp = result.data;
    const closeIndex = result.index;
    const separatorIndex = tagExp.search(/\s/);
    let tagName = tagExp;
    let attrExpPresent = true;
    if (separatorIndex !== -1) {
        tagName = tagExp.substring(0, separatorIndex);
        tagExp = tagExp.substring(separatorIndex + 1).trimStart();
    }
    const rawTagName = tagName;
    if (removeNSPrefix) {
        const colonIndex = tagName.indexOf(":");
        if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
            attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
        }
    }
    return {
        tagName: tagName,
        tagExp: tagExp,
        closeIndex: closeIndex,
        attrExpPresent: attrExpPresent,
        rawTagName: rawTagName
    };
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */ function $f830b202ab6534a2$var$readStopNodeData(xmlData, tagName, i) {
    const startIndex = i;
    // Starting at 1 since we already have an open tag
    let openTagCount = 1;
    for(; i < xmlData.length; i++)if (xmlData[i] === "<") {
        if (xmlData[i + 1] === "/") {
            const closeIndex = $f830b202ab6534a2$var$findClosingIndex(xmlData, ">", i, `${tagName} is not closed`);
            let closeTagName = xmlData.substring(i + 2, closeIndex).trim();
            if (closeTagName === tagName) {
                openTagCount--;
                if (openTagCount === 0) return {
                    tagContent: xmlData.substring(startIndex, i),
                    i: closeIndex
                };
            }
            i = closeIndex;
        } else if (xmlData[i + 1] === '?') {
            const closeIndex = $f830b202ab6534a2$var$findClosingIndex(xmlData, "?>", i + 1, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 3) === '!--') {
            const closeIndex = $f830b202ab6534a2$var$findClosingIndex(xmlData, "-->", i + 3, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 2) === '![') {
            const closeIndex = $f830b202ab6534a2$var$findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
            i = closeIndex;
        } else {
            const tagData = $f830b202ab6534a2$var$readTagExp(xmlData, i, '>');
            if (tagData) {
                const openTagName = tagData && tagData.tagName;
                if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") openTagCount++;
                i = tagData.closeIndex;
            }
        }
    }
     //end for loop
}
function $f830b202ab6534a2$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return $74e98d3beadbb714$exports(val, options);
    } else {
        if ($d86fb9779850a704$export$a5edf3f35b6dd392(val)) return val;
        else return '';
    }
}
$f830b202ab6534a2$exports = $f830b202ab6534a2$var$OrderedObjParser;


var $328f548457426eb9$export$1b80ed980367b7c1;
'use strict';
/**
 * 
 * @param {array} node 
 * @param {any} options 
 * @returns 
 */ function $328f548457426eb9$var$prettify(node, options) {
    return $328f548457426eb9$var$compress(node, options);
}
/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */ function $328f548457426eb9$var$compress(arr, options, jPath) {
    let text;
    const compressedObj = {};
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const property = $328f548457426eb9$var$propName(tagObj);
        let newJpath = "";
        if (jPath === undefined) newJpath = property;
        else newJpath = jPath + "." + property;
        if (property === options.textNodeName) {
            if (text === undefined) text = tagObj[property];
            else text += "" + tagObj[property];
        } else if (property === undefined) continue;
        else if (tagObj[property]) {
            let val = $328f548457426eb9$var$compress(tagObj[property], options, newJpath);
            const isLeaf = $328f548457426eb9$var$isLeafTag(val, options);
            if (tagObj[":@"]) $328f548457426eb9$var$assignAttributes(val, tagObj[":@"], newJpath, options);
            else if (Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode) val = val[options.textNodeName];
            else if (Object.keys(val).length === 0) {
                if (options.alwaysCreateTextNode) val[options.textNodeName] = "";
                else val = "";
            }
            if (compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
                if (!Array.isArray(compressedObj[property])) compressedObj[property] = [
                    compressedObj[property]
                ];
                compressedObj[property].push(val);
            } else //TODO: if a node is not an array, then check if it should be an array
            //also determine if it is a leaf node
            if (options.isArray(property, newJpath, isLeaf)) compressedObj[property] = [
                val
            ];
            else compressedObj[property] = val;
        }
    }
    // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
    if (typeof text === "string") {
        if (text.length > 0) compressedObj[options.textNodeName] = text;
    } else if (text !== undefined) compressedObj[options.textNodeName] = text;
    return compressedObj;
}
function $328f548457426eb9$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key !== ":@") return key;
    }
}
function $328f548457426eb9$var$assignAttributes(obj, attrMap, jpath, options) {
    if (attrMap) {
        const keys = Object.keys(attrMap);
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++){
            const atrrName = keys[i];
            if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) obj[atrrName] = [
                attrMap[atrrName]
            ];
            else obj[atrrName] = attrMap[atrrName];
        }
    }
}
function $328f548457426eb9$var$isLeafTag(obj, options) {
    const { textNodeName: textNodeName } = options;
    const propCount = Object.keys(obj).length;
    if (propCount === 0) return true;
    if (propCount === 1 && (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)) return true;
    return false;
}
$328f548457426eb9$export$1b80ed980367b7c1 = $328f548457426eb9$var$prettify;


var $76f8319cf3c47dec$require$prettify = $328f548457426eb9$export$1b80ed980367b7c1;

class $76f8319cf3c47dec$var$XMLParser {
    constructor(options){
        this.externalEntities = {};
        this.options = $76f8319cf3c47dec$require$buildOptions(options);
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Buffer} xmlData 
     * @param {boolean|Object} validationOption 
     */ parse(xmlData, validationOption) {
        if (typeof xmlData === "string") ;
        else if (xmlData.toString) xmlData = xmlData.toString();
        else throw new Error("XML data is accepted in String or Bytes[] form.");
        if (validationOption) {
            if (validationOption === true) validationOption = {}; //validate with default options
            const result = $fe1029334364915d$export$a22775fa5e2eebd9(xmlData, validationOption);
            if (result !== true) throw Error(`${result.err.msg}:${result.err.line}:${result.err.col}`);
        }
        const orderedObjParser = new $f830b202ab6534a2$exports(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return $76f8319cf3c47dec$require$prettify(orderedResult, this.options);
    }
    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */ addEntity(key, value) {
        if (value.indexOf("&") !== -1) throw new Error("Entity value can't have '&'");
        else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        else if (value === "&") throw new Error("An entity with value '&' is not permitted");
        else this.externalEntities[key] = value;
    }
}
$76f8319cf3c47dec$exports = $76f8319cf3c47dec$var$XMLParser;


var $df28087cac4af051$exports = {};
'use strict';
var $f180fab13b2f03e9$exports = {};
const $f180fab13b2f03e9$var$EOL = "\n";
/**
 * 
 * @param {array} jArray 
 * @param {any} options 
 * @returns 
 */ function $f180fab13b2f03e9$var$toXml(jArray, options) {
    let indentation = "";
    if (options.format && options.indentBy.length > 0) indentation = $f180fab13b2f03e9$var$EOL;
    return $f180fab13b2f03e9$var$arrToStr(jArray, options, "", indentation);
}
function $f180fab13b2f03e9$var$arrToStr(arr, options, jPath, indentation) {
    let xmlStr = "";
    let isPreviousElementTag = false;
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const tagName = $f180fab13b2f03e9$var$propName(tagObj);
        if (tagName === undefined) continue;
        let newJPath = "";
        if (jPath.length === 0) newJPath = tagName;
        else newJPath = `${jPath}.${tagName}`;
        if (tagName === options.textNodeName) {
            let tagText = tagObj[tagName];
            if (!$f180fab13b2f03e9$var$isStopNode(newJPath, options)) {
                tagText = options.tagValueProcessor(tagName, tagText);
                tagText = $f180fab13b2f03e9$var$replaceEntitiesValue(tagText, options);
            }
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += tagText;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.cdataPropName) {
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.commentPropName) {
            xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
            isPreviousElementTag = true;
            continue;
        } else if (tagName[0] === "?") {
            const attStr = $f180fab13b2f03e9$var$attr_to_str(tagObj[":@"], options);
            const tempInd = tagName === "?xml" ? "" : indentation;
            let piTextNodeName = tagObj[tagName][0][options.textNodeName];
            piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
            xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr}?>`;
            isPreviousElementTag = true;
            continue;
        }
        let newIdentation = indentation;
        if (newIdentation !== "") newIdentation += options.indentBy;
        const attStr = $f180fab13b2f03e9$var$attr_to_str(tagObj[":@"], options);
        const tagStart = indentation + `<${tagName}${attStr}`;
        const tagValue = $f180fab13b2f03e9$var$arrToStr(tagObj[tagName], options, newJPath, newIdentation);
        if (options.unpairedTags.indexOf(tagName) !== -1) {
            if (options.suppressUnpairedNode) xmlStr += tagStart + ">";
            else xmlStr += tagStart + "/>";
        } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) xmlStr += tagStart + "/>";
        else if (tagValue && tagValue.endsWith(">")) xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
        else {
            xmlStr += tagStart + ">";
            if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) xmlStr += indentation + options.indentBy + tagValue + indentation;
            else xmlStr += tagValue;
            xmlStr += `</${tagName}>`;
        }
        isPreviousElementTag = true;
    }
    return xmlStr;
}
function $f180fab13b2f03e9$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (!obj.hasOwnProperty(key)) continue;
        if (key !== ":@") return key;
    }
}
function $f180fab13b2f03e9$var$attr_to_str(attrMap, options) {
    let attrStr = "";
    if (attrMap && !options.ignoreAttributes) for(let attr in attrMap){
        if (!attrMap.hasOwnProperty(attr)) continue;
        let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
        attrVal = $f180fab13b2f03e9$var$replaceEntitiesValue(attrVal, options);
        if (attrVal === true && options.suppressBooleanAttributes) attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}`;
        else attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
    }
    return attrStr;
}
function $f180fab13b2f03e9$var$isStopNode(jPath, options) {
    jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
    let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
    for(let index in options.stopNodes){
        if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
    }
    return false;
}
function $f180fab13b2f03e9$var$replaceEntitiesValue(textValue, options) {
    if (textValue && textValue.length > 0 && options.processEntities) for(let i = 0; i < options.entities.length; i++){
        const entity = options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
}
$f180fab13b2f03e9$exports = $f180fab13b2f03e9$var$toXml;


const $df28087cac4af051$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataPropName: false,
    format: false,
    indentBy: '  ',
    suppressEmptyNode: false,
    suppressUnpairedNode: true,
    suppressBooleanAttributes: true,
    tagValueProcessor: function(key, a) {
        return a;
    },
    attributeValueProcessor: function(attrName, a) {
        return a;
    },
    preserveOrder: false,
    commentPropName: false,
    unpairedTags: [],
    entities: [
        {
            regex: new RegExp("&", "g"),
            val: "&amp;"
        },
        {
            regex: new RegExp(">", "g"),
            val: "&gt;"
        },
        {
            regex: new RegExp("<", "g"),
            val: "&lt;"
        },
        {
            regex: new RegExp("\'", "g"),
            val: "&apos;"
        },
        {
            regex: new RegExp("\"", "g"),
            val: "&quot;"
        }
    ],
    processEntities: true,
    stopNodes: [],
    // transformTagName: false,
    // transformAttributeName: false,
    oneListGroup: false
};
function $df28087cac4af051$var$Builder(options) {
    this.options = Object.assign({}, $df28087cac4af051$var$defaultOptions, options);
    if (this.options.ignoreAttributes || this.options.attributesGroupName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $df28087cac4af051$var$isAttribute;
    }
    this.processTextOrObjNode = $df28087cac4af051$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $df28087cac4af051$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
}
$df28087cac4af051$var$Builder.prototype.build = function(jObj) {
    if (this.options.preserveOrder) return $f180fab13b2f03e9$exports(jObj, this.options);
    else {
        if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) jObj = {
            [this.options.arrayNodeName]: jObj
        };
        return this.j2x(jObj, 0).val;
    }
};
$df28087cac4af051$var$Builder.prototype.j2x = function(jObj, level) {
    let attrStr = '';
    let val = '';
    for(let key in jObj){
        if (!Object.prototype.hasOwnProperty.call(jObj, key)) continue;
        if (typeof jObj[key] === 'undefined') // supress undefined node only if it is not an attribute
        {
            if (this.isAttribute(key)) val += '';
        } else if (jObj[key] === null) {
            // null attribute should be ignored by the attribute list, but should not cause the tag closing
            if (this.isAttribute(key)) val += '';
            else if (key[0] === '?') val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
            else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (jObj[key] instanceof Date) val += this.buildTextValNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
            else //tag value
            if (key === this.options.textNodeName) {
                let newval = this.options.tagValueProcessor(key, '' + jObj[key]);
                val += this.replaceEntitiesValue(newval);
            } else val += this.buildTextValNode(jObj[key], key, '', level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            const arrLen = jObj[key].length;
            let listTagVal = "";
            let listTagAttr = "";
            for(let j = 0; j < arrLen; j++){
                const item = jObj[key][j];
                if (typeof item === 'undefined') ;
                else if (item === null) {
                    if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
                    else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                } else if (typeof item === 'object') {
                    if (this.options.oneListGroup) {
                        const result = this.j2x(item, level + 1);
                        listTagVal += result.val;
                        if (this.options.attributesGroupName && item.hasOwnProperty(this.options.attributesGroupName)) listTagAttr += result.attrStr;
                    } else listTagVal += this.processTextOrObjNode(item, key, level);
                } else if (this.options.oneListGroup) {
                    let textValue = this.options.tagValueProcessor(key, item);
                    textValue = this.replaceEntitiesValue(textValue);
                    listTagVal += textValue;
                } else listTagVal += this.buildTextValNode(item, key, '', level);
            }
            if (this.options.oneListGroup) listTagVal = this.buildObjectNode(listTagVal, key, listTagAttr, level);
            val += listTagVal;
        } else //nested node
        if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += this.buildAttrPairStr(Ks[j], '' + jObj[key][Ks[j]]);
        } else val += this.processTextOrObjNode(jObj[key], key, level);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
$df28087cac4af051$var$Builder.prototype.buildAttrPairStr = function(attrName, val) {
    val = this.options.attributeValueProcessor(attrName, '' + val);
    val = this.replaceEntitiesValue(val);
    if (this.options.suppressBooleanAttributes && val === "true") return ' ' + attrName;
    else return ' ' + attrName + '="' + val + '"';
};
function $df28087cac4af051$var$processTextOrObjNode(object, key, level) {
    const result = this.j2x(object, level + 1);
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
    else return this.buildObjectNode(result.val, key, result.attrStr, level);
}
$df28087cac4af051$var$Builder.prototype.buildObjectNode = function(val, key, attrStr, level) {
    if (val === "") {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    } else {
        let tagEndExp = '</' + key + this.tagEndChar;
        let piClosingChar = "";
        if (key[0] === "?") {
            piClosingChar = "?";
            tagEndExp = "";
        }
        // attrStr is an empty string in case the attribute came as undefined or null
        if ((attrStr || attrStr === '') && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + piClosingChar + '>' + val + tagEndExp;
        else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) return this.indentate(level) + `<!--${val}-->` + this.newLine;
        else return this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar + val + this.indentate(level) + tagEndExp;
    }
};
$df28087cac4af051$var$Builder.prototype.closeTag = function(key) {
    let closeTag = "";
    if (this.options.unpairedTags.indexOf(key) !== -1) {
        if (!this.options.suppressUnpairedNode) closeTag = "/";
    } else if (this.options.suppressEmptyNode) closeTag = "/";
    else closeTag = `></${key}`;
    return closeTag;
};
function $df28087cac4af051$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
    }
}
$df28087cac4af051$var$Builder.prototype.buildTextValNode = function(val, key, attrStr, level) {
    if (this.options.cdataPropName !== false && key === this.options.cdataPropName) return this.indentate(level) + `<![CDATA[${val}]]>` + this.newLine;
    else if (this.options.commentPropName !== false && key === this.options.commentPropName) return this.indentate(level) + `<!--${val}-->` + this.newLine;
    else if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
    else {
        let textValue = this.options.tagValueProcessor(key, val);
        textValue = this.replaceEntitiesValue(textValue);
        if (textValue === '') return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '>' + textValue + '</' + key + this.tagEndChar;
    }
};
$df28087cac4af051$var$Builder.prototype.replaceEntitiesValue = function(textValue) {
    if (textValue && textValue.length > 0 && this.options.processEntities) for(let i = 0; i < this.options.entities.length; i++){
        const entity = this.options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
};
function $df28087cac4af051$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $df28087cac4af051$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix) && name !== this.options.textNodeName) return name.substr(this.attrPrefixLen);
    else return false;
}
$df28087cac4af051$exports = $df28087cac4af051$var$Builder;


$f52cd47a5eadbffc$exports = {
    XMLParser: $76f8319cf3c47dec$exports,
    XMLValidator: $fe1029334364915d$exports,
    XMLBuilder: $df28087cac4af051$exports
};



const $6a26d274a29a7ae2$export$3cc1021c6dfb9c3e = (streamBody, context)=>(0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(streamBody, context).then((body)=>context.utf8Encoder(body));


const $748c029693e94b07$export$9f31af2cd814b6c7 = (streamBody, context)=>(0, $6a26d274a29a7ae2$export$3cc1021c6dfb9c3e)(streamBody, context).then((encoded)=>{
        if (encoded.length) {
            const parser = new (0, $f52cd47a5eadbffc$exports.XMLParser)({
                attributeNamePrefix: "",
                htmlEntities: true,
                ignoreAttributes: false,
                ignoreDeclaration: true,
                parseTagValue: false,
                trimValues: false,
                tagValueProcessor: (_, val)=>val.trim() === "" && val.includes("\n") ? "" : undefined
            });
            parser.addEntity("#xD", "\r");
            parser.addEntity("#10", "\n");
            let parsedObj;
            try {
                parsedObj = parser.parse(encoded, true);
            } catch (e) {
                if (e && typeof e === "object") Object.defineProperty(e, "$responseBodyText", {
                    value: encoded
                });
                throw e;
            }
            const textNodeName = "#text";
            const key = Object.keys(parsedObj)[0];
            const parsedObjToReturn = parsedObj[key];
            if (parsedObjToReturn[textNodeName]) {
                parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
                delete parsedObjToReturn[textNodeName];
            }
            return (0, $9a9a930f3b2c2043$export$113d90026b452881)(parsedObjToReturn);
        }
        return {};
    });
const $748c029693e94b07$export$bc3bfbea4e5d3440 = async (errorBody, context)=>{
    const value = await $748c029693e94b07$export$9f31af2cd814b6c7(errorBody, context);
    if (value.Error) value.Error.message = value.Error.message ?? value.Error.Message;
    return value;
};
const $748c029693e94b07$export$e5a272551bb5495c = (output, data)=>{
    if (data?.Error?.Code !== undefined) return data.Error.Code;
    if (data?.Code !== undefined) return data.Code;
    if (output.statusCode == 404) return "NotFound";
};


function $9afd34598aa7b6da$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}


function $b653df1e1c12cb67$export$e5104ffd394b43ec(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r/g, "&#x0D;").replace(/\n/g, "&#x0A;").replace(/\u0085/g, "&#x85;").replace(/\u2028/, "&#x2028;");
}


class $0c5f967439148a05$export$b35b8f45887823df {
    constructor(value){
        this.value = value;
    }
    toString() {
        return (0, $b653df1e1c12cb67$export$e5104ffd394b43ec)("" + this.value);
    }
}


class $44a0d59c11863d38$export$e775a15d806cbddc {
    static of(name, childText, withName) {
        const node = new $44a0d59c11863d38$export$e775a15d806cbddc(name);
        if (childText !== undefined) node.addChildNode(new (0, $0c5f967439148a05$export$b35b8f45887823df)(childText));
        if (withName !== undefined) node.withName(withName);
        return node;
    }
    constructor(name, children = []){
        this.name = name;
        this.children = children;
        this.attributes = {};
    }
    withName(name) {
        this.name = name;
        return this;
    }
    addAttribute(name, value) {
        this.attributes[name] = value;
        return this;
    }
    addChildNode(child) {
        this.children.push(child);
        return this;
    }
    removeAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    n(name) {
        this.name = name;
        return this;
    }
    c(child) {
        this.children.push(child);
        return this;
    }
    a(name, value) {
        if (value != null) this.attributes[name] = value;
        return this;
    }
    cc(input, field, withName = field) {
        if (input[field] != null) {
            const node = $44a0d59c11863d38$export$e775a15d806cbddc.of(field, input[field]).withName(withName);
            this.c(node);
        }
    }
    l(input, listName, memberName, valueProvider) {
        if (input[listName] != null) {
            const nodes = valueProvider();
            nodes.map((node)=>{
                node.withName(memberName);
                this.c(node);
            });
        }
    }
    lc(input, listName, memberName, valueProvider) {
        if (input[listName] != null) {
            const nodes = valueProvider();
            const containerNode = new $44a0d59c11863d38$export$e775a15d806cbddc(memberName);
            nodes.map((node)=>{
                containerNode.c(node);
            });
            this.c(containerNode);
        }
    }
    toString() {
        const hasChildren = Boolean(this.children.length);
        let xmlText = `<${this.name}`;
        const attributes = this.attributes;
        for (const attributeName of Object.keys(attributes)){
            const attribute = attributes[attributeName];
            if (attribute != null) xmlText += ` ${attributeName}="${(0, $9afd34598aa7b6da$export$30330f3d5eb70e11)("" + attribute)}"`;
        }
        return xmlText += !hasChildren ? "/>" : `>${this.children.map((c)=>c.toString()).join("")}</${this.name}>`;
    }
}










const $b50962978b66428d$export$2088a1c61866b42f = {
    requester: "requester"
};
const $b50962978b66428d$export$fb013b91cfe9631c = {
    requester: "requester"
};
class $b50962978b66428d$export$1de06065cff890a8 extends (0, $92dbcbc8228e43d8$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "NoSuchUpload",
            $fault: "client",
            ...opts
        });
        this.name = "NoSuchUpload";
        this.$fault = "client";
        Object.setPrototypeOf(this, $b50962978b66428d$export$1de06065cff890a8.prototype);
    }
}
const $b50962978b66428d$export$461a4b9cc44c53a4 = {
    Enabled: "Enabled",
    Suspended: "Suspended"
};
const $b50962978b66428d$export$92738401e1603719 = {
    AmazonCustomerByEmail: "AmazonCustomerByEmail",
    CanonicalUser: "CanonicalUser",
    Group: "Group"
};
const $b50962978b66428d$export$a461eaf23bef603e = {
    FULL_CONTROL: "FULL_CONTROL",
    READ: "READ",
    READ_ACP: "READ_ACP",
    WRITE: "WRITE",
    WRITE_ACP: "WRITE_ACP"
};
const $b50962978b66428d$export$bb669a85cf08a23d = {
    Destination: "Destination"
};
const $b50962978b66428d$export$7114a33237015736 = {
    AES256: "AES256",
    aws_kms: "aws:kms",
    aws_kms_dsse: "aws:kms:dsse"
};
const $b50962978b66428d$export$2bc4ff953c9f8de4 = {
    authenticated_read: "authenticated-read",
    aws_exec_read: "aws-exec-read",
    bucket_owner_full_control: "bucket-owner-full-control",
    bucket_owner_read: "bucket-owner-read",
    private: "private",
    public_read: "public-read",
    public_read_write: "public-read-write"
};
const $b50962978b66428d$export$578faf5500e50907 = {
    CRC32: "CRC32",
    CRC32C: "CRC32C",
    SHA1: "SHA1",
    SHA256: "SHA256"
};
const $b50962978b66428d$export$62964424255eeec4 = {
    COPY: "COPY",
    REPLACE: "REPLACE"
};
const $b50962978b66428d$export$a107d1c72844e898 = {
    OFF: "OFF",
    ON: "ON"
};
const $b50962978b66428d$export$b06b63840ce459d4 = {
    COMPLIANCE: "COMPLIANCE",
    GOVERNANCE: "GOVERNANCE"
};
const $b50962978b66428d$export$c9f3e7046503c180 = {
    DEEP_ARCHIVE: "DEEP_ARCHIVE",
    EXPRESS_ONEZONE: "EXPRESS_ONEZONE",
    GLACIER: "GLACIER",
    GLACIER_IR: "GLACIER_IR",
    INTELLIGENT_TIERING: "INTELLIGENT_TIERING",
    ONEZONE_IA: "ONEZONE_IA",
    OUTPOSTS: "OUTPOSTS",
    REDUCED_REDUNDANCY: "REDUCED_REDUNDANCY",
    SNOW: "SNOW",
    STANDARD: "STANDARD",
    STANDARD_IA: "STANDARD_IA"
};
const $b50962978b66428d$export$9ee8cb617ddaf4c2 = {
    COPY: "COPY",
    REPLACE: "REPLACE"
};
class $b50962978b66428d$export$77615b2f7cde9dd7 extends (0, $92dbcbc8228e43d8$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "ObjectNotInActiveTierError",
            $fault: "client",
            ...opts
        });
        this.name = "ObjectNotInActiveTierError";
        this.$fault = "client";
        Object.setPrototypeOf(this, $b50962978b66428d$export$77615b2f7cde9dd7.prototype);
    }
}
class $b50962978b66428d$export$b6b374c2bfd60422 extends (0, $92dbcbc8228e43d8$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "BucketAlreadyExists",
            $fault: "client",
            ...opts
        });
        this.name = "BucketAlreadyExists";
        this.$fault = "client";
        Object.setPrototypeOf(this, $b50962978b66428d$export$b6b374c2bfd60422.prototype);
    }
}
class $b50962978b66428d$export$3d44152d602e5b07 extends (0, $92dbcbc8228e43d8$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "BucketAlreadyOwnedByYou",
            $fault: "client",
            ...opts
        });
        this.name = "BucketAlreadyOwnedByYou";
        this.$fault = "client";
        Object.setPrototypeOf(this, $b50962978b66428d$export$3d44152d602e5b07.prototype);
    }
}
const $b50962978b66428d$export$c6537723816e271b = {
    authenticated_read: "authenticated-read",
    private: "private",
    public_read: "public-read",
    public_read_write: "public-read-write"
};
const $b50962978b66428d$export$956a227b10319e76 = {
    SingleAvailabilityZone: "SingleAvailabilityZone"
};
const $b50962978b66428d$export$3e5009acfca75a50 = {
    Directory: "Directory"
};
const $b50962978b66428d$export$ec50e3f346457d89 = {
    AvailabilityZone: "AvailabilityZone"
};
const $b50962978b66428d$export$bb93eee3fe586aa6 = {
    EU: "EU",
    af_south_1: "af-south-1",
    ap_east_1: "ap-east-1",
    ap_northeast_1: "ap-northeast-1",
    ap_northeast_2: "ap-northeast-2",
    ap_northeast_3: "ap-northeast-3",
    ap_south_1: "ap-south-1",
    ap_south_2: "ap-south-2",
    ap_southeast_1: "ap-southeast-1",
    ap_southeast_2: "ap-southeast-2",
    ap_southeast_3: "ap-southeast-3",
    ca_central_1: "ca-central-1",
    cn_north_1: "cn-north-1",
    cn_northwest_1: "cn-northwest-1",
    eu_central_1: "eu-central-1",
    eu_north_1: "eu-north-1",
    eu_south_1: "eu-south-1",
    eu_south_2: "eu-south-2",
    eu_west_1: "eu-west-1",
    eu_west_2: "eu-west-2",
    eu_west_3: "eu-west-3",
    me_south_1: "me-south-1",
    sa_east_1: "sa-east-1",
    us_east_2: "us-east-2",
    us_gov_east_1: "us-gov-east-1",
    us_gov_west_1: "us-gov-west-1",
    us_west_1: "us-west-1",
    us_west_2: "us-west-2"
};
const $b50962978b66428d$export$78011c6a3f9ac7bc = {
    BucketOwnerEnforced: "BucketOwnerEnforced",
    BucketOwnerPreferred: "BucketOwnerPreferred",
    ObjectWriter: "ObjectWriter"
};
const $b50962978b66428d$export$db472b52b1e64273 = {
    ReadOnly: "ReadOnly",
    ReadWrite: "ReadWrite"
};
class $b50962978b66428d$export$bbe89283205bd874 extends (0, $92dbcbc8228e43d8$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "NoSuchBucket",
            $fault: "client",
            ...opts
        });
        this.name = "NoSuchBucket";
        this.$fault = "client";
        Object.setPrototypeOf(this, $b50962978b66428d$export$bbe89283205bd874.prototype);
    }
}
var $b50962978b66428d$export$c9ec61557dcb764a;
(function(AnalyticsFilter) {
    AnalyticsFilter.visit = (value, visitor)=>{
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($b50962978b66428d$export$c9ec61557dcb764a || ($b50962978b66428d$export$c9ec61557dcb764a = {}));
const $b50962978b66428d$export$29fe27c41c8a8938 = {
    CSV: "CSV"
};
const $b50962978b66428d$export$80e034a7f289c3e4 = {
    V_1: "V_1"
};
const $b50962978b66428d$export$7f9a2082b392326e = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $b50962978b66428d$export$678658c19f924e51 = {
    ARCHIVE_ACCESS: "ARCHIVE_ACCESS",
    DEEP_ARCHIVE_ACCESS: "DEEP_ARCHIVE_ACCESS"
};
const $b50962978b66428d$export$191f65f0cb1052dc = {
    CSV: "CSV",
    ORC: "ORC",
    Parquet: "Parquet"
};
const $b50962978b66428d$export$9e2ee342c395e0e0 = {
    All: "All",
    Current: "Current"
};
const $b50962978b66428d$export$1a6ee719036d2ac6 = {
    BucketKeyStatus: "BucketKeyStatus",
    ChecksumAlgorithm: "ChecksumAlgorithm",
    ETag: "ETag",
    EncryptionStatus: "EncryptionStatus",
    IntelligentTieringAccessTier: "IntelligentTieringAccessTier",
    IsMultipartUploaded: "IsMultipartUploaded",
    LastModifiedDate: "LastModifiedDate",
    ObjectAccessControlList: "ObjectAccessControlList",
    ObjectLockLegalHoldStatus: "ObjectLockLegalHoldStatus",
    ObjectLockMode: "ObjectLockMode",
    ObjectLockRetainUntilDate: "ObjectLockRetainUntilDate",
    ObjectOwner: "ObjectOwner",
    ReplicationStatus: "ReplicationStatus",
    Size: "Size",
    StorageClass: "StorageClass"
};
const $b50962978b66428d$export$4e4cd66dff7403f3 = {
    Daily: "Daily",
    Weekly: "Weekly"
};
var $b50962978b66428d$export$4338dba1e93ddaf4;
(function(LifecycleRuleFilter) {
    LifecycleRuleFilter.visit = (value, visitor)=>{
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.ObjectSizeGreaterThan !== undefined) return visitor.ObjectSizeGreaterThan(value.ObjectSizeGreaterThan);
        if (value.ObjectSizeLessThan !== undefined) return visitor.ObjectSizeLessThan(value.ObjectSizeLessThan);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($b50962978b66428d$export$4338dba1e93ddaf4 || ($b50962978b66428d$export$4338dba1e93ddaf4 = {}));
const $b50962978b66428d$export$c5e045ed304f0693 = {
    DEEP_ARCHIVE: "DEEP_ARCHIVE",
    GLACIER: "GLACIER",
    GLACIER_IR: "GLACIER_IR",
    INTELLIGENT_TIERING: "INTELLIGENT_TIERING",
    ONEZONE_IA: "ONEZONE_IA",
    STANDARD_IA: "STANDARD_IA"
};
const $b50962978b66428d$export$e07001eef35cce48 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $b50962978b66428d$export$f61526eb707ec4e5 = {
    FULL_CONTROL: "FULL_CONTROL",
    READ: "READ",
    WRITE: "WRITE"
};
const $b50962978b66428d$export$f4e18909127ba354 = {
    DeliveryTime: "DeliveryTime",
    EventTime: "EventTime"
};
var $b50962978b66428d$export$564a1f9c338cae45;
(function(MetricsFilter) {
    MetricsFilter.visit = (value, visitor)=>{
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.AccessPointArn !== undefined) return visitor.AccessPointArn(value.AccessPointArn);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($b50962978b66428d$export$564a1f9c338cae45 || ($b50962978b66428d$export$564a1f9c338cae45 = {}));
const $b50962978b66428d$export$d61e24a684f9e51 = {
    s3_IntelligentTiering: "s3:IntelligentTiering",
    s3_LifecycleExpiration_: "s3:LifecycleExpiration:*",
    s3_LifecycleExpiration_Delete: "s3:LifecycleExpiration:Delete",
    s3_LifecycleExpiration_DeleteMarkerCreated: "s3:LifecycleExpiration:DeleteMarkerCreated",
    s3_LifecycleTransition: "s3:LifecycleTransition",
    s3_ObjectAcl_Put: "s3:ObjectAcl:Put",
    s3_ObjectCreated_: "s3:ObjectCreated:*",
    s3_ObjectCreated_CompleteMultipartUpload: "s3:ObjectCreated:CompleteMultipartUpload",
    s3_ObjectCreated_Copy: "s3:ObjectCreated:Copy",
    s3_ObjectCreated_Post: "s3:ObjectCreated:Post",
    s3_ObjectCreated_Put: "s3:ObjectCreated:Put",
    s3_ObjectRemoved_: "s3:ObjectRemoved:*",
    s3_ObjectRemoved_Delete: "s3:ObjectRemoved:Delete",
    s3_ObjectRemoved_DeleteMarkerCreated: "s3:ObjectRemoved:DeleteMarkerCreated",
    s3_ObjectRestore_: "s3:ObjectRestore:*",
    s3_ObjectRestore_Completed: "s3:ObjectRestore:Completed",
    s3_ObjectRestore_Delete: "s3:ObjectRestore:Delete",
    s3_ObjectRestore_Post: "s3:ObjectRestore:Post",
    s3_ObjectTagging_: "s3:ObjectTagging:*",
    s3_ObjectTagging_Delete: "s3:ObjectTagging:Delete",
    s3_ObjectTagging_Put: "s3:ObjectTagging:Put",
    s3_ReducedRedundancyLostObject: "s3:ReducedRedundancyLostObject",
    s3_Replication_: "s3:Replication:*",
    s3_Replication_OperationFailedReplication: "s3:Replication:OperationFailedReplication",
    s3_Replication_OperationMissedThreshold: "s3:Replication:OperationMissedThreshold",
    s3_Replication_OperationNotTracked: "s3:Replication:OperationNotTracked",
    s3_Replication_OperationReplicatedAfterThreshold: "s3:Replication:OperationReplicatedAfterThreshold"
};
const $b50962978b66428d$export$8910525d2927db4a = {
    prefix: "prefix",
    suffix: "suffix"
};
const $b50962978b66428d$export$a30282025632e486 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $b50962978b66428d$export$57c6aac8453e0326 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $b50962978b66428d$export$ad9a9bcf96805340 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $b50962978b66428d$export$7450743f85207a6f = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
var $b50962978b66428d$export$c5652b893758d9eb;
(function(ReplicationRuleFilter) {
    ReplicationRuleFilter.visit = (value, visitor)=>{
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($b50962978b66428d$export$c5652b893758d9eb || ($b50962978b66428d$export$c5652b893758d9eb = {}));
const $b50962978b66428d$export$37ed8894bf15c7cc = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $b50962978b66428d$export$6769a00a1513ac8d = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $b50962978b66428d$export$463cbeba2ee6e701 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $b50962978b66428d$export$a0c454341dc6c9b6 = {
    BucketOwner: "BucketOwner",
    Requester: "Requester"
};
const $b50962978b66428d$export$3eb97608f0094ca = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $b50962978b66428d$export$53eb802876329b9c = {
    Enabled: "Enabled",
    Suspended: "Suspended"
};
const $b50962978b66428d$export$377bbedb5576dfa8 = {
    http: "http",
    https: "https"
};
const $b50962978b66428d$export$e94cd17a87edcf61 = {
    COMPLETE: "COMPLETE",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    PENDING: "PENDING",
    REPLICA: "REPLICA"
};
const $b50962978b66428d$export$12fb0f2ce043ea4d = {
    ENABLED: "ENABLED"
};
class $b50962978b66428d$export$6424f05126e7daf8 extends (0, $92dbcbc8228e43d8$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "InvalidObjectState",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidObjectState";
        this.$fault = "client";
        Object.setPrototypeOf(this, $b50962978b66428d$export$6424f05126e7daf8.prototype);
        this.StorageClass = opts.StorageClass;
        this.AccessTier = opts.AccessTier;
    }
}
class $b50962978b66428d$export$1f6f8c73c651f3ca extends (0, $92dbcbc8228e43d8$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "NoSuchKey",
            $fault: "client",
            ...opts
        });
        this.name = "NoSuchKey";
        this.$fault = "client";
        Object.setPrototypeOf(this, $b50962978b66428d$export$1f6f8c73c651f3ca.prototype);
    }
}
const $b50962978b66428d$export$98ca292af92c3ca7 = {
    CHECKSUM: "Checksum",
    ETAG: "ETag",
    OBJECT_PARTS: "ObjectParts",
    OBJECT_SIZE: "ObjectSize",
    STORAGE_CLASS: "StorageClass"
};
const $b50962978b66428d$export$7a910e7bcb8a9f5 = {
    Enabled: "Enabled"
};
const $b50962978b66428d$export$8d22b7763fab892d = {
    COMPLIANCE: "COMPLIANCE",
    GOVERNANCE: "GOVERNANCE"
};
class $b50962978b66428d$export$271f9f08425019c7 extends (0, $92dbcbc8228e43d8$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "NotFound",
            $fault: "client",
            ...opts
        });
        this.name = "NotFound";
        this.$fault = "client";
        Object.setPrototypeOf(this, $b50962978b66428d$export$271f9f08425019c7.prototype);
    }
}
const $b50962978b66428d$export$ca079fdb822b790f = {
    ARCHIVE_ACCESS: "ARCHIVE_ACCESS",
    DEEP_ARCHIVE_ACCESS: "DEEP_ARCHIVE_ACCESS"
};
const $b50962978b66428d$export$456871da275f7922 = {
    url: "url"
};
const $b50962978b66428d$export$d195d5551132983 = {
    DEEP_ARCHIVE: "DEEP_ARCHIVE",
    EXPRESS_ONEZONE: "EXPRESS_ONEZONE",
    GLACIER: "GLACIER",
    GLACIER_IR: "GLACIER_IR",
    INTELLIGENT_TIERING: "INTELLIGENT_TIERING",
    ONEZONE_IA: "ONEZONE_IA",
    OUTPOSTS: "OUTPOSTS",
    REDUCED_REDUNDANCY: "REDUCED_REDUNDANCY",
    SNOW: "SNOW",
    STANDARD: "STANDARD",
    STANDARD_IA: "STANDARD_IA"
};
const $b50962978b66428d$export$dca8e7037d29022 = {
    RESTORE_STATUS: "RestoreStatus"
};
const $b50962978b66428d$export$38f3da1761c0e0d9 = {
    STANDARD: "STANDARD"
};
const $b50962978b66428d$export$ee980f22bb30c0b1 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$eb8e420b7cfdd234 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$fb8699876f0673e1 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$a0f30ec69261ee40 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$5abe7f3ae720ef5a = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$a7b934ef912ebf62 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$6eac6d52d60c7629 = (obj)=>({
        ...obj,
        ...obj.SecretAccessKey && {
            SecretAccessKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SessionToken && {
            SessionToken: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$903b3044017ac69c = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.Credentials && {
            Credentials: $b50962978b66428d$export$6eac6d52d60c7629(obj.Credentials)
        }
    });
const $b50962978b66428d$export$14cdfb40a19d6afd = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$a7e93a6b579d53af = (obj)=>({
        ...obj,
        ...obj.KMSMasterKeyID && {
            KMSMasterKeyID: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$b765ce8faf930a02 = (obj)=>({
        ...obj,
        ...obj.ApplyServerSideEncryptionByDefault && {
            ApplyServerSideEncryptionByDefault: $b50962978b66428d$export$a7e93a6b579d53af(obj.ApplyServerSideEncryptionByDefault)
        }
    });
const $b50962978b66428d$export$53d539a6eea5b6ca = (obj)=>({
        ...obj,
        ...obj.Rules && {
            Rules: obj.Rules.map((item)=>$b50962978b66428d$export$b765ce8faf930a02(item))
        }
    });
const $b50962978b66428d$export$d7df4bcb0241f9e2 = (obj)=>({
        ...obj,
        ...obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $b50962978b66428d$export$53d539a6eea5b6ca(obj.ServerSideEncryptionConfiguration)
        }
    });
const $b50962978b66428d$export$cb892ee53d79e488 = (obj)=>({
        ...obj,
        ...obj.KeyId && {
            KeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$f16a5b3cef976950 = (obj)=>({
        ...obj,
        ...obj.SSEKMS && {
            SSEKMS: $b50962978b66428d$export$cb892ee53d79e488(obj.SSEKMS)
        }
    });
const $b50962978b66428d$export$a1f0f98e9204134c = (obj)=>({
        ...obj,
        ...obj.Encryption && {
            Encryption: $b50962978b66428d$export$f16a5b3cef976950(obj.Encryption)
        }
    });
const $b50962978b66428d$export$e212d4bb36570081 = (obj)=>({
        ...obj,
        ...obj.S3BucketDestination && {
            S3BucketDestination: $b50962978b66428d$export$a1f0f98e9204134c(obj.S3BucketDestination)
        }
    });
const $b50962978b66428d$export$42cfce9f712db38f = (obj)=>({
        ...obj,
        ...obj.Destination && {
            Destination: $b50962978b66428d$export$e212d4bb36570081(obj.Destination)
        }
    });
const $b50962978b66428d$export$770e533990455861 = (obj)=>({
        ...obj,
        ...obj.InventoryConfiguration && {
            InventoryConfiguration: $b50962978b66428d$export$42cfce9f712db38f(obj.InventoryConfiguration)
        }
    });
const $b50962978b66428d$export$5a075da6fc07a9a8 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$19e9479fe773d432 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$6e2d787d30f344ce = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$271fb34028c0c6e7 = (obj)=>({
        ...obj
    });
const $b50962978b66428d$export$af4af8d2ddf19d2e = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$f8e32741b8b3f8f5 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$5af58b20282a23ee = (obj)=>({
        ...obj,
        ...obj.InventoryConfigurationList && {
            InventoryConfigurationList: obj.InventoryConfigurationList.map((item)=>$b50962978b66428d$export$42cfce9f712db38f(item))
        }
    });
const $b50962978b66428d$export$4441acdd50048efe = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $77149509850e94fa$export$17127055dc9ac067)
        }
    });
const $b50962978b66428d$export$92539c3978f21568 = (obj)=>({
        ...obj,
        ...obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $b50962978b66428d$export$53d539a6eea5b6ca(obj.ServerSideEncryptionConfiguration)
        }
    });
const $b50962978b66428d$export$51164d1b54fc6c9a = (obj)=>({
        ...obj,
        ...obj.InventoryConfiguration && {
            InventoryConfiguration: $b50962978b66428d$export$42cfce9f712db38f(obj.InventoryConfiguration)
        }
    });




const $45e1a5f717a7bf0f$export$10d13acf81981e5c = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "AbortMultipartUpload"
        ],
        [$45e1a5f717a7bf0f$var$_uI]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_UI], `UploadId`)
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$c0d6594d5a007c93 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xacc]: input[$45e1a5f717a7bf0f$var$_CCRC],
        [$45e1a5f717a7bf0f$var$_xacc_]: input[$45e1a5f717a7bf0f$var$_CCRCC],
        [$45e1a5f717a7bf0f$var$_xacs]: input[$45e1a5f717a7bf0f$var$_CSHA],
        [$45e1a5f717a7bf0f$var$_xacs_]: input[$45e1a5f717a7bf0f$var$_CSHAh],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_inm]: input[$45e1a5f717a7bf0f$var$_INM],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_uI]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_UI], `UploadId`)
        ]
    });
    let body;
    let contents;
    if (input.MultipartUpload !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_CompletedMultipartUpload(input.MultipartUpload, context);
        contents = contents.n("CompleteMultipartUpload");
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$a4a7e31ebbed0a91 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaa]: input[$45e1a5f717a7bf0f$var$_ACL],
        [$45e1a5f717a7bf0f$var$_cc]: input[$45e1a5f717a7bf0f$var$_CC],
        [$45e1a5f717a7bf0f$var$_xaca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_cd]: input[$45e1a5f717a7bf0f$var$_CD],
        [$45e1a5f717a7bf0f$var$_ce]: input[$45e1a5f717a7bf0f$var$_CE],
        [$45e1a5f717a7bf0f$var$_cl]: input[$45e1a5f717a7bf0f$var$_CL],
        [$45e1a5f717a7bf0f$var$_ct]: input[$45e1a5f717a7bf0f$var$_CT],
        [$45e1a5f717a7bf0f$var$_xacs__]: input[$45e1a5f717a7bf0f$var$_CS],
        [$45e1a5f717a7bf0f$var$_xacsim]: input[$45e1a5f717a7bf0f$var$_CSIM],
        [$45e1a5f717a7bf0f$var$_xacsims]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_CSIMS]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_CSIMS]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xacsinm]: input[$45e1a5f717a7bf0f$var$_CSINM],
        [$45e1a5f717a7bf0f$var$_xacsius]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_CSIUS]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_CSIUS]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_e]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_E]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_E]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xagfc]: input[$45e1a5f717a7bf0f$var$_GFC],
        [$45e1a5f717a7bf0f$var$_xagr]: input[$45e1a5f717a7bf0f$var$_GR],
        [$45e1a5f717a7bf0f$var$_xagra]: input[$45e1a5f717a7bf0f$var$_GRACP],
        [$45e1a5f717a7bf0f$var$_xagwa]: input[$45e1a5f717a7bf0f$var$_GWACP],
        [$45e1a5f717a7bf0f$var$_xamd]: input[$45e1a5f717a7bf0f$var$_MD],
        [$45e1a5f717a7bf0f$var$_xatd]: input[$45e1a5f717a7bf0f$var$_TD],
        [$45e1a5f717a7bf0f$var$_xasse]: input[$45e1a5f717a7bf0f$var$_SSE],
        [$45e1a5f717a7bf0f$var$_xasc]: input[$45e1a5f717a7bf0f$var$_SC],
        [$45e1a5f717a7bf0f$var$_xawrl]: input[$45e1a5f717a7bf0f$var$_WRL],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xasseakki]: input[$45e1a5f717a7bf0f$var$_SSEKMSKI],
        [$45e1a5f717a7bf0f$var$_xassec]: input[$45e1a5f717a7bf0f$var$_SSEKMSEC],
        [$45e1a5f717a7bf0f$var$_xassebke]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_BKE]),
            ()=>input[$45e1a5f717a7bf0f$var$_BKE].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xacssseca]: input[$45e1a5f717a7bf0f$var$_CSSSECA],
        [$45e1a5f717a7bf0f$var$_xacssseck]: input[$45e1a5f717a7bf0f$var$_CSSSECK],
        [$45e1a5f717a7bf0f$var$_xacssseckm]: input[$45e1a5f717a7bf0f$var$_CSSSECKMD],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xat]: input[$45e1a5f717a7bf0f$var$_T],
        [$45e1a5f717a7bf0f$var$_xaolm]: input[$45e1a5f717a7bf0f$var$_OLM],
        [$45e1a5f717a7bf0f$var$_xaolrud]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_OLRUD]),
            ()=>(0, $65a9c6a67b0b3f34$export$93f3a0dd288ea1c8)(input[$45e1a5f717a7bf0f$var$_OLRUD]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xaollh]: input[$45e1a5f717a7bf0f$var$_OLLHS],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xasebo]: input[$45e1a5f717a7bf0f$var$_ESBO],
        ...input.Metadata !== undefined && Object.keys(input.Metadata).reduce((acc, suffix)=>{
            acc[`x-amz-meta-${suffix.toLowerCase()}`] = input.Metadata[suffix];
            return acc;
        }, {})
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "CopyObject"
        ]
    });
    let body;
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$c8f40844147ea2e3 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xaa]: input[$45e1a5f717a7bf0f$var$_ACL],
        [$45e1a5f717a7bf0f$var$_xagfc]: input[$45e1a5f717a7bf0f$var$_GFC],
        [$45e1a5f717a7bf0f$var$_xagr]: input[$45e1a5f717a7bf0f$var$_GR],
        [$45e1a5f717a7bf0f$var$_xagra]: input[$45e1a5f717a7bf0f$var$_GRACP],
        [$45e1a5f717a7bf0f$var$_xagw]: input[$45e1a5f717a7bf0f$var$_GW],
        [$45e1a5f717a7bf0f$var$_xagwa]: input[$45e1a5f717a7bf0f$var$_GWACP],
        [$45e1a5f717a7bf0f$var$_xabole]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_OLEFB]),
            ()=>input[$45e1a5f717a7bf0f$var$_OLEFB].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xaoo]: input[$45e1a5f717a7bf0f$var$_OO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    let body;
    let contents;
    if (input.CreateBucketConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_CreateBucketConfiguration(input.CreateBucketConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$3cc910d56b5ba1fa = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaa]: input[$45e1a5f717a7bf0f$var$_ACL],
        [$45e1a5f717a7bf0f$var$_cc]: input[$45e1a5f717a7bf0f$var$_CC],
        [$45e1a5f717a7bf0f$var$_cd]: input[$45e1a5f717a7bf0f$var$_CD],
        [$45e1a5f717a7bf0f$var$_ce]: input[$45e1a5f717a7bf0f$var$_CE],
        [$45e1a5f717a7bf0f$var$_cl]: input[$45e1a5f717a7bf0f$var$_CL],
        [$45e1a5f717a7bf0f$var$_ct]: input[$45e1a5f717a7bf0f$var$_CT],
        [$45e1a5f717a7bf0f$var$_e]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_E]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_E]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xagfc]: input[$45e1a5f717a7bf0f$var$_GFC],
        [$45e1a5f717a7bf0f$var$_xagr]: input[$45e1a5f717a7bf0f$var$_GR],
        [$45e1a5f717a7bf0f$var$_xagra]: input[$45e1a5f717a7bf0f$var$_GRACP],
        [$45e1a5f717a7bf0f$var$_xagwa]: input[$45e1a5f717a7bf0f$var$_GWACP],
        [$45e1a5f717a7bf0f$var$_xasse]: input[$45e1a5f717a7bf0f$var$_SSE],
        [$45e1a5f717a7bf0f$var$_xasc]: input[$45e1a5f717a7bf0f$var$_SC],
        [$45e1a5f717a7bf0f$var$_xawrl]: input[$45e1a5f717a7bf0f$var$_WRL],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xasseakki]: input[$45e1a5f717a7bf0f$var$_SSEKMSKI],
        [$45e1a5f717a7bf0f$var$_xassec]: input[$45e1a5f717a7bf0f$var$_SSEKMSEC],
        [$45e1a5f717a7bf0f$var$_xassebke]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_BKE]),
            ()=>input[$45e1a5f717a7bf0f$var$_BKE].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xat]: input[$45e1a5f717a7bf0f$var$_T],
        [$45e1a5f717a7bf0f$var$_xaolm]: input[$45e1a5f717a7bf0f$var$_OLM],
        [$45e1a5f717a7bf0f$var$_xaolrud]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_OLRUD]),
            ()=>(0, $65a9c6a67b0b3f34$export$93f3a0dd288ea1c8)(input[$45e1a5f717a7bf0f$var$_OLRUD]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xaollh]: input[$45e1a5f717a7bf0f$var$_OLLHS],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xaca]: input[$45e1a5f717a7bf0f$var$_CA],
        ...input.Metadata !== undefined && Object.keys(input.Metadata).reduce((acc, suffix)=>{
            acc[`x-amz-meta-${suffix.toLowerCase()}`] = input.Metadata[suffix];
            return acc;
        }, {})
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_u]: [
            ,
            ""
        ]
    });
    let body;
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$6d03b8fc370e351b = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xacsm]: input[$45e1a5f717a7bf0f$var$_SM],
        [$45e1a5f717a7bf0f$var$_xasse]: input[$45e1a5f717a7bf0f$var$_SSE],
        [$45e1a5f717a7bf0f$var$_xasseakki]: input[$45e1a5f717a7bf0f$var$_SSEKMSKI],
        [$45e1a5f717a7bf0f$var$_xassec]: input[$45e1a5f717a7bf0f$var$_SSEKMSEC],
        [$45e1a5f717a7bf0f$var$_xassebke]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_BKE]),
            ()=>input[$45e1a5f717a7bf0f$var$_BKE].toString()
        ]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_s]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$c510bfd07b726d28 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    let body;
    b.m("DELETE").h(headers).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$751c46c05d301c2b = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_a]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$a68151826c0ba2c4 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_c]: [
            ,
            ""
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$b0173c5abecf1f23 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_en]: [
            ,
            ""
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$413c02a033f96fb4 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = {};
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_it]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$d830094fff00a099 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_in]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$f91c22f123caef4e = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_l]: [
            ,
            ""
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$12a370f261e5c0dd = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_m]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$332be06b7bac51c2 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_oC]: [
            ,
            ""
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$6ea2dcb93818c52b = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_p]: [
            ,
            ""
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$865c6fe92c9b85ca = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_r]: [
            ,
            ""
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$78d1db3f85a7cb49 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_t]: [
            ,
            ""
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$75fd93177c73ffd5 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_w]: [
            ,
            ""
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$ce8b91db00a48a2d = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xam]: input[$45e1a5f717a7bf0f$var$_MFA],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xabgr]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_BGR]),
            ()=>input[$45e1a5f717a7bf0f$var$_BGR].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "DeleteObject"
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$e4e156dbf32c5986 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xam]: input[$45e1a5f717a7bf0f$var$_MFA],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xabgr]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_BGR]),
            ()=>input[$45e1a5f717a7bf0f$var$_BGR].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_d]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.Delete !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_Delete(input.Delete, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$4b7dd6da3e7aa857 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_t]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$943ebe732e7b80de = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_pAB]: [
            ,
            ""
        ]
    });
    let body;
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$933b5eeb53ef70ac = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_ac]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$a4414c6c1a2fc819 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_acl]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$8982e062abbeffcb = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_a]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "GetBucketAnalyticsConfiguration"
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$37d228a94687306a = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_c]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$72940b3db9c1b61b = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_en]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$be20b5bea56546ee = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = {};
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_it]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "GetBucketIntelligentTieringConfiguration"
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$94863c04fbc3cc82 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_in]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "GetBucketInventoryConfiguration"
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$9a62f47185385e78 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_l]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$e7f73d80f954412c = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_lo]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$f718c2932b08adb4 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_log]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$1d3d4c44931f2a0d = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_m]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "GetBucketMetricsConfiguration"
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$fdabf990f1e6a37d = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_n]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$3928fd24ca8807cc = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_oC]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$43bfb515ecc1108 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_p]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$1fb3135e372980ae = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_pS]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$d719dfb5c8f69272 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_r]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$4fcc412a9b229a66 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_rP]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$97966bb80376c08b = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_t]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$78ef1242631d0fad = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_v]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$bbe0f964a7cdfbdc = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_w]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$d47bb2874555749d = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_im]: input[$45e1a5f717a7bf0f$var$_IM],
        [$45e1a5f717a7bf0f$var$_ims]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_IMS]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_IMS]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_inm]: input[$45e1a5f717a7bf0f$var$_INM],
        [$45e1a5f717a7bf0f$var$_ius]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_IUS]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_IUS]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_ra]: input[$45e1a5f717a7bf0f$var$_R],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xacm]: input[$45e1a5f717a7bf0f$var$_CM]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "GetObject"
        ],
        [$45e1a5f717a7bf0f$var$_rcc]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCC]
        ],
        [$45e1a5f717a7bf0f$var$_rcd]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCD]
        ],
        [$45e1a5f717a7bf0f$var$_rce]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCE]
        ],
        [$45e1a5f717a7bf0f$var$_rcl]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCL]
        ],
        [$45e1a5f717a7bf0f$var$_rct]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCT]
        ],
        [$45e1a5f717a7bf0f$var$_re]: [
            ()=>input.ResponseExpires !== void 0,
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_RE]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ],
        [$45e1a5f717a7bf0f$var$_pN]: [
            ()=>input.PartNumber !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_PN].toString()
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$2eb7a1046962dc4 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_acl]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$6095dc65b65c7ada = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xamp]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_MP]),
            ()=>input[$45e1a5f717a7bf0f$var$_MP].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xapnm]: input[$45e1a5f717a7bf0f$var$_PNM],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xaoa]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_OA]),
            ()=>(input[$45e1a5f717a7bf0f$var$_OA] || []).join(", ")
        ]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_at]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$a8215207fe34efb = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_lh]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$f5a321dcfb8c99ef = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_ol]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$c416bbaad1be2464 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_ret]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$5687757f6416f974 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_t]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$501bfef18f069d5d = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_to]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$653de371a253cce1 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_pAB]: [
            ,
            ""
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$12b7e7cf521a0b4 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    let body;
    b.m("HEAD").h(headers).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$89ef241b7cc6b282 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_im]: input[$45e1a5f717a7bf0f$var$_IM],
        [$45e1a5f717a7bf0f$var$_ims]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_IMS]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_IMS]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_inm]: input[$45e1a5f717a7bf0f$var$_INM],
        [$45e1a5f717a7bf0f$var$_ius]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_IUS]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_IUS]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_ra]: input[$45e1a5f717a7bf0f$var$_R],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xacm]: input[$45e1a5f717a7bf0f$var$_CM]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_rcc]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCC]
        ],
        [$45e1a5f717a7bf0f$var$_rcd]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCD]
        ],
        [$45e1a5f717a7bf0f$var$_rce]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCE]
        ],
        [$45e1a5f717a7bf0f$var$_rcl]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCL]
        ],
        [$45e1a5f717a7bf0f$var$_rct]: [
            ,
            input[$45e1a5f717a7bf0f$var$_RCT]
        ],
        [$45e1a5f717a7bf0f$var$_re]: [
            ()=>input.ResponseExpires !== void 0,
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_RE]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ],
        [$45e1a5f717a7bf0f$var$_pN]: [
            ()=>input.PartNumber !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_PN].toString()
        ]
    });
    let body;
    b.m("HEAD").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$bac987ae75e1b7b3 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_a]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "ListBucketAnalyticsConfigurations"
        ],
        [$45e1a5f717a7bf0f$var$_ct_]: [
            ,
            input[$45e1a5f717a7bf0f$var$_CTo]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$463b553148d5eb2c = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = {};
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_it]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "ListBucketIntelligentTieringConfigurations"
        ],
        [$45e1a5f717a7bf0f$var$_ct_]: [
            ,
            input[$45e1a5f717a7bf0f$var$_CTo]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$91f705f8f090fa7a = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_in]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "ListBucketInventoryConfigurations"
        ],
        [$45e1a5f717a7bf0f$var$_ct_]: [
            ,
            input[$45e1a5f717a7bf0f$var$_CTo]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$db6c7914f5cab208 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_m]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "ListBucketMetricsConfigurations"
        ],
        [$45e1a5f717a7bf0f$var$_ct_]: [
            ,
            input[$45e1a5f717a7bf0f$var$_CTo]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$e3d06ab48ef1f8dd = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = {};
    b.bp("/");
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "ListBuckets"
        ],
        [$45e1a5f717a7bf0f$var$_mb]: [
            ()=>input.MaxBuckets !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_MB].toString()
        ],
        [$45e1a5f717a7bf0f$var$_ct_]: [
            ,
            input[$45e1a5f717a7bf0f$var$_CTo]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$18eea4b14a9dd4b = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = {};
    b.bp("/");
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "ListDirectoryBuckets"
        ],
        [$45e1a5f717a7bf0f$var$_ct_]: [
            ,
            input[$45e1a5f717a7bf0f$var$_CTo]
        ],
        [$45e1a5f717a7bf0f$var$_mdb]: [
            ()=>input.MaxDirectoryBuckets !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_MDB].toString()
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$3cffb625572e4e48 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_u]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_de]: [
            ,
            input[$45e1a5f717a7bf0f$var$_D]
        ],
        [$45e1a5f717a7bf0f$var$_et]: [
            ,
            input[$45e1a5f717a7bf0f$var$_ET]
        ],
        [$45e1a5f717a7bf0f$var$_km]: [
            ,
            input[$45e1a5f717a7bf0f$var$_KM]
        ],
        [$45e1a5f717a7bf0f$var$_mu]: [
            ()=>input.MaxUploads !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_MU].toString()
        ],
        [$45e1a5f717a7bf0f$var$_pr]: [
            ,
            input[$45e1a5f717a7bf0f$var$_P]
        ],
        [$45e1a5f717a7bf0f$var$_uim]: [
            ,
            input[$45e1a5f717a7bf0f$var$_UIM]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$6180c0473e7f5c88 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xaooa]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_OOA]),
            ()=>(input[$45e1a5f717a7bf0f$var$_OOA] || []).join(", ")
        ]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_de]: [
            ,
            input[$45e1a5f717a7bf0f$var$_D]
        ],
        [$45e1a5f717a7bf0f$var$_et]: [
            ,
            input[$45e1a5f717a7bf0f$var$_ET]
        ],
        [$45e1a5f717a7bf0f$var$_ma]: [
            ,
            input[$45e1a5f717a7bf0f$var$_M]
        ],
        [$45e1a5f717a7bf0f$var$_mk]: [
            ()=>input.MaxKeys !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_MK].toString()
        ],
        [$45e1a5f717a7bf0f$var$_pr]: [
            ,
            input[$45e1a5f717a7bf0f$var$_P]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$da301345d3ee143 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xaooa]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_OOA]),
            ()=>(input[$45e1a5f717a7bf0f$var$_OOA] || []).join(", ")
        ]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_lt]: [
            ,
            "2"
        ],
        [$45e1a5f717a7bf0f$var$_de]: [
            ,
            input[$45e1a5f717a7bf0f$var$_D]
        ],
        [$45e1a5f717a7bf0f$var$_et]: [
            ,
            input[$45e1a5f717a7bf0f$var$_ET]
        ],
        [$45e1a5f717a7bf0f$var$_mk]: [
            ()=>input.MaxKeys !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_MK].toString()
        ],
        [$45e1a5f717a7bf0f$var$_pr]: [
            ,
            input[$45e1a5f717a7bf0f$var$_P]
        ],
        [$45e1a5f717a7bf0f$var$_ct_]: [
            ,
            input[$45e1a5f717a7bf0f$var$_CTo]
        ],
        [$45e1a5f717a7bf0f$var$_fo]: [
            ()=>input.FetchOwner !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_FO].toString()
        ],
        [$45e1a5f717a7bf0f$var$_sa]: [
            ,
            input[$45e1a5f717a7bf0f$var$_SA]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$d2331614a12bddc8 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaooa]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_OOA]),
            ()=>(input[$45e1a5f717a7bf0f$var$_OOA] || []).join(", ")
        ]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_ver]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_de]: [
            ,
            input[$45e1a5f717a7bf0f$var$_D]
        ],
        [$45e1a5f717a7bf0f$var$_et]: [
            ,
            input[$45e1a5f717a7bf0f$var$_ET]
        ],
        [$45e1a5f717a7bf0f$var$_km]: [
            ,
            input[$45e1a5f717a7bf0f$var$_KM]
        ],
        [$45e1a5f717a7bf0f$var$_mk]: [
            ()=>input.MaxKeys !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_MK].toString()
        ],
        [$45e1a5f717a7bf0f$var$_pr]: [
            ,
            input[$45e1a5f717a7bf0f$var$_P]
        ],
        [$45e1a5f717a7bf0f$var$_vim]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VIM]
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$9af1da1eab1701a6 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "ListParts"
        ],
        [$45e1a5f717a7bf0f$var$_mp]: [
            ()=>input.MaxParts !== void 0,
            ()=>input[$45e1a5f717a7bf0f$var$_MP].toString()
        ],
        [$45e1a5f717a7bf0f$var$_pnm]: [
            ,
            input[$45e1a5f717a7bf0f$var$_PNM]
        ],
        [$45e1a5f717a7bf0f$var$_uI]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_UI], `UploadId`)
        ]
    });
    let body;
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$3f6fdbe302658691 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_ac]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.AccelerateConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_AccelerateConfiguration(input.AccelerateConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$54a4ba734de35851 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xaa]: input[$45e1a5f717a7bf0f$var$_ACL],
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xagfc]: input[$45e1a5f717a7bf0f$var$_GFC],
        [$45e1a5f717a7bf0f$var$_xagr]: input[$45e1a5f717a7bf0f$var$_GR],
        [$45e1a5f717a7bf0f$var$_xagra]: input[$45e1a5f717a7bf0f$var$_GRACP],
        [$45e1a5f717a7bf0f$var$_xagw]: input[$45e1a5f717a7bf0f$var$_GW],
        [$45e1a5f717a7bf0f$var$_xagwa]: input[$45e1a5f717a7bf0f$var$_GWACP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_acl]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.AccessControlPolicy !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_AccessControlPolicy(input.AccessControlPolicy, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$94d9bfa60902369 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_a]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    let contents;
    if (input.AnalyticsConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_AnalyticsConfiguration(input.AnalyticsConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$f8235149762cf3fe = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_c]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.CORSConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_CORSConfiguration(input.CORSConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$321a9e23524a5161 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_en]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.ServerSideEncryptionConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_ServerSideEncryptionConfiguration(input.ServerSideEncryptionConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$c6f0b8805cfde2aa = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = {
        "content-type": "application/xml"
    };
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_it]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    let contents;
    if (input.IntelligentTieringConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_IntelligentTieringConfiguration(input.IntelligentTieringConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$bbfc84d93fe571ef = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_in]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    let contents;
    if (input.InventoryConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_InventoryConfiguration(input.InventoryConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$84c94e18c9eb3457 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_l]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.LifecycleConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_BucketLifecycleConfiguration(input.LifecycleConfiguration, context);
        contents = contents.n("LifecycleConfiguration");
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$1ffabe3d765e71ea = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_log]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.BucketLoggingStatus !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_BucketLoggingStatus(input.BucketLoggingStatus, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$27715d7c7e0e5e44 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_m]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_i]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_I], `Id`)
        ]
    });
    let body;
    let contents;
    if (input.MetricsConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_MetricsConfiguration(input.MetricsConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$82a3c9e036067c97 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xasdv]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_SDV]),
            ()=>input[$45e1a5f717a7bf0f$var$_SDV].toString()
        ]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_n]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.NotificationConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_NotificationConfiguration(input.NotificationConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$611be6edb4640fcc = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_oC]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.OwnershipControls !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_OwnershipControls(input.OwnershipControls, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$e9a0e1c53a9ac9e5 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "text/plain",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xacrsba]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_CRSBA]),
            ()=>input[$45e1a5f717a7bf0f$var$_CRSBA].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_p]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.Policy !== undefined) {
        contents = input.Policy;
        body = contents;
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$243a83db339eb017 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xabolt]: input[$45e1a5f717a7bf0f$var$_To],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_r]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.ReplicationConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_ReplicationConfiguration(input.ReplicationConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$9c20a21af6ed0bc6 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_rP]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.RequestPaymentConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_RequestPaymentConfiguration(input.RequestPaymentConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$e7a67f9de630d095 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_t]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.Tagging !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_Tagging(input.Tagging, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$b4a6e0bf6c649497 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xam]: input[$45e1a5f717a7bf0f$var$_MFA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_v]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.VersioningConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_VersioningConfiguration(input.VersioningConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$16c3ea57a0ba6053 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_w]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.WebsiteConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_WebsiteConfiguration(input.WebsiteConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$80b592020f8ee8b7 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_ct]: input[$45e1a5f717a7bf0f$var$_CT] || "application/octet-stream",
        [$45e1a5f717a7bf0f$var$_xaa]: input[$45e1a5f717a7bf0f$var$_ACL],
        [$45e1a5f717a7bf0f$var$_cc]: input[$45e1a5f717a7bf0f$var$_CC],
        [$45e1a5f717a7bf0f$var$_cd]: input[$45e1a5f717a7bf0f$var$_CD],
        [$45e1a5f717a7bf0f$var$_ce]: input[$45e1a5f717a7bf0f$var$_CE],
        [$45e1a5f717a7bf0f$var$_cl]: input[$45e1a5f717a7bf0f$var$_CL],
        [$45e1a5f717a7bf0f$var$_cl_]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_CLo]),
            ()=>input[$45e1a5f717a7bf0f$var$_CLo].toString()
        ],
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xacc]: input[$45e1a5f717a7bf0f$var$_CCRC],
        [$45e1a5f717a7bf0f$var$_xacc_]: input[$45e1a5f717a7bf0f$var$_CCRCC],
        [$45e1a5f717a7bf0f$var$_xacs]: input[$45e1a5f717a7bf0f$var$_CSHA],
        [$45e1a5f717a7bf0f$var$_xacs_]: input[$45e1a5f717a7bf0f$var$_CSHAh],
        [$45e1a5f717a7bf0f$var$_e]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_E]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_E]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_inm]: input[$45e1a5f717a7bf0f$var$_INM],
        [$45e1a5f717a7bf0f$var$_xagfc]: input[$45e1a5f717a7bf0f$var$_GFC],
        [$45e1a5f717a7bf0f$var$_xagr]: input[$45e1a5f717a7bf0f$var$_GR],
        [$45e1a5f717a7bf0f$var$_xagra]: input[$45e1a5f717a7bf0f$var$_GRACP],
        [$45e1a5f717a7bf0f$var$_xagwa]: input[$45e1a5f717a7bf0f$var$_GWACP],
        [$45e1a5f717a7bf0f$var$_xasse]: input[$45e1a5f717a7bf0f$var$_SSE],
        [$45e1a5f717a7bf0f$var$_xasc]: input[$45e1a5f717a7bf0f$var$_SC],
        [$45e1a5f717a7bf0f$var$_xawrl]: input[$45e1a5f717a7bf0f$var$_WRL],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xasseakki]: input[$45e1a5f717a7bf0f$var$_SSEKMSKI],
        [$45e1a5f717a7bf0f$var$_xassec]: input[$45e1a5f717a7bf0f$var$_SSEKMSEC],
        [$45e1a5f717a7bf0f$var$_xassebke]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_BKE]),
            ()=>input[$45e1a5f717a7bf0f$var$_BKE].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xat]: input[$45e1a5f717a7bf0f$var$_T],
        [$45e1a5f717a7bf0f$var$_xaolm]: input[$45e1a5f717a7bf0f$var$_OLM],
        [$45e1a5f717a7bf0f$var$_xaolrud]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_OLRUD]),
            ()=>(0, $65a9c6a67b0b3f34$export$93f3a0dd288ea1c8)(input[$45e1a5f717a7bf0f$var$_OLRUD]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xaollh]: input[$45e1a5f717a7bf0f$var$_OLLHS],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        ...input.Metadata !== undefined && Object.keys(input.Metadata).reduce((acc, suffix)=>{
            acc[`x-amz-meta-${suffix.toLowerCase()}`] = input.Metadata[suffix];
            return acc;
        }, {})
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "PutObject"
        ]
    });
    let body;
    let contents;
    if (input.Body !== undefined) {
        contents = input.Body;
        body = contents;
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$9966f17a0fff323b = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xaa]: input[$45e1a5f717a7bf0f$var$_ACL],
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xagfc]: input[$45e1a5f717a7bf0f$var$_GFC],
        [$45e1a5f717a7bf0f$var$_xagr]: input[$45e1a5f717a7bf0f$var$_GR],
        [$45e1a5f717a7bf0f$var$_xagra]: input[$45e1a5f717a7bf0f$var$_GRACP],
        [$45e1a5f717a7bf0f$var$_xagw]: input[$45e1a5f717a7bf0f$var$_GW],
        [$45e1a5f717a7bf0f$var$_xagwa]: input[$45e1a5f717a7bf0f$var$_GWACP],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_acl]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    let contents;
    if (input.AccessControlPolicy !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_AccessControlPolicy(input.AccessControlPolicy, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$e406d8702bc54811 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_lh]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    let contents;
    if (input.LegalHold !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_ObjectLockLegalHold(input.LegalHold, context);
        contents = contents.n("LegalHold");
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$ef8c4e74dbf262ca = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xabolt]: input[$45e1a5f717a7bf0f$var$_To],
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_ol]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.ObjectLockConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_ObjectLockConfiguration(input.ObjectLockConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$b805daaf3fbf99bf = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xabgr]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_BGR]),
            ()=>input[$45e1a5f717a7bf0f$var$_BGR].toString()
        ],
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_ret]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    let contents;
    if (input.Retention !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_ObjectLockRetention(input.Retention, context);
        contents = contents.n("Retention");
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$ecc70053eace4832 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_t]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    let contents;
    if (input.Tagging !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_Tagging(input.Tagging, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$b2b09e9f8ccb7800 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_pAB]: [
            ,
            ""
        ]
    });
    let body;
    let contents;
    if (input.PublicAccessBlockConfiguration !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_PublicAccessBlockConfiguration(input.PublicAccessBlockConfiguration, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$2ea69c74e54da740 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_res]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_vI]: [
            ,
            input[$45e1a5f717a7bf0f$var$_VI]
        ]
    });
    let body;
    let contents;
    if (input.RestoreRequest !== undefined) {
        contents = $45e1a5f717a7bf0f$var$se_RestoreRequest(input.RestoreRequest, context);
        body = $45e1a5f717a7bf0f$var$_ve;
        contents.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$6fd8ebeb11534574 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/xml",
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_se]: [
            ,
            ""
        ],
        [$45e1a5f717a7bf0f$var$_st]: [
            ,
            "2"
        ]
    });
    let body;
    body = $45e1a5f717a7bf0f$var$_ve;
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SOCR);
    bn.a("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
    bn.cc(input, $45e1a5f717a7bf0f$var$_Ex);
    bn.cc(input, $45e1a5f717a7bf0f$var$_ETx);
    if (input[$45e1a5f717a7bf0f$var$_IS] != null) bn.c($45e1a5f717a7bf0f$var$se_InputSerialization(input[$45e1a5f717a7bf0f$var$_IS], context).n($45e1a5f717a7bf0f$var$_IS));
    if (input[$45e1a5f717a7bf0f$var$_OS] != null) bn.c($45e1a5f717a7bf0f$var$se_OutputSerialization(input[$45e1a5f717a7bf0f$var$_OS], context).n($45e1a5f717a7bf0f$var$_OS));
    if (input[$45e1a5f717a7bf0f$var$_RPe] != null) bn.c($45e1a5f717a7bf0f$var$se_RequestProgress(input[$45e1a5f717a7bf0f$var$_RPe], context).n($45e1a5f717a7bf0f$var$_RPe));
    if (input[$45e1a5f717a7bf0f$var$_SR] != null) bn.c($45e1a5f717a7bf0f$var$se_ScanRange(input[$45e1a5f717a7bf0f$var$_SR], context).n($45e1a5f717a7bf0f$var$_SR));
    body += bn.toString();
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$83a6b460ef4fd1f8 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "content-type": "application/octet-stream",
        [$45e1a5f717a7bf0f$var$_cl_]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_CLo]),
            ()=>input[$45e1a5f717a7bf0f$var$_CLo].toString()
        ],
        [$45e1a5f717a7bf0f$var$_cm]: input[$45e1a5f717a7bf0f$var$_CMD],
        [$45e1a5f717a7bf0f$var$_xasca]: input[$45e1a5f717a7bf0f$var$_CA],
        [$45e1a5f717a7bf0f$var$_xacc]: input[$45e1a5f717a7bf0f$var$_CCRC],
        [$45e1a5f717a7bf0f$var$_xacc_]: input[$45e1a5f717a7bf0f$var$_CCRCC],
        [$45e1a5f717a7bf0f$var$_xacs]: input[$45e1a5f717a7bf0f$var$_CSHA],
        [$45e1a5f717a7bf0f$var$_xacs_]: input[$45e1a5f717a7bf0f$var$_CSHAh],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "UploadPart"
        ],
        [$45e1a5f717a7bf0f$var$_pN]: [
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input.PartNumber, `PartNumber`) != null,
            ()=>input[$45e1a5f717a7bf0f$var$_PN].toString()
        ],
        [$45e1a5f717a7bf0f$var$_uI]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_UI], `UploadId`)
        ]
    });
    let body;
    let contents;
    if (input.Body !== undefined) {
        contents = input.Body;
        body = contents;
    }
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$d78018a5b1b8367c = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        [$45e1a5f717a7bf0f$var$_xacs__]: input[$45e1a5f717a7bf0f$var$_CS],
        [$45e1a5f717a7bf0f$var$_xacsim]: input[$45e1a5f717a7bf0f$var$_CSIM],
        [$45e1a5f717a7bf0f$var$_xacsims]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_CSIMS]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_CSIMS]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xacsinm]: input[$45e1a5f717a7bf0f$var$_CSINM],
        [$45e1a5f717a7bf0f$var$_xacsius]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_CSIUS]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_CSIUS]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xacsr]: input[$45e1a5f717a7bf0f$var$_CSR],
        [$45e1a5f717a7bf0f$var$_xasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xasseck]: input[$45e1a5f717a7bf0f$var$_SSECK],
        [$45e1a5f717a7bf0f$var$_xasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xacssseca]: input[$45e1a5f717a7bf0f$var$_CSSSECA],
        [$45e1a5f717a7bf0f$var$_xacssseck]: input[$45e1a5f717a7bf0f$var$_CSSSECK],
        [$45e1a5f717a7bf0f$var$_xacssseckm]: input[$45e1a5f717a7bf0f$var$_CSSSECKMD],
        [$45e1a5f717a7bf0f$var$_xarp]: input[$45e1a5f717a7bf0f$var$_RP],
        [$45e1a5f717a7bf0f$var$_xaebo]: input[$45e1a5f717a7bf0f$var$_EBO],
        [$45e1a5f717a7bf0f$var$_xasebo]: input[$45e1a5f717a7bf0f$var$_ESBO]
    });
    b.bp("/{Key+}");
    b.p("Bucket", ()=>input.Bucket, "{Bucket}", false);
    b.p("Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        [$45e1a5f717a7bf0f$var$_xi]: [
            ,
            "UploadPartCopy"
        ],
        [$45e1a5f717a7bf0f$var$_pN]: [
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input.PartNumber, `PartNumber`) != null,
            ()=>input[$45e1a5f717a7bf0f$var$_PN].toString()
        ],
        [$45e1a5f717a7bf0f$var$_uI]: [
            ,
            (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)(input[$45e1a5f717a7bf0f$var$_UI], `UploadId`)
        ]
    });
    let body;
    b.m("PUT").h(headers).q(query).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$a026a0f9b1f48587 = async (input, context)=>{
    const b = (0, $7a010f39785200b2$export$9f1f89e694d26cd0)(input, context);
    const headers = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({}, (0, $bb1a032aa13f75dc$export$f25742720bcd7d1c), {
        "x-amz-content-sha256": "UNSIGNED-PAYLOAD",
        "content-type": "application/octet-stream",
        [$45e1a5f717a7bf0f$var$_xarr]: input[$45e1a5f717a7bf0f$var$_RR],
        [$45e1a5f717a7bf0f$var$_xart]: input[$45e1a5f717a7bf0f$var$_RT],
        [$45e1a5f717a7bf0f$var$_xafs]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_SCt]),
            ()=>input[$45e1a5f717a7bf0f$var$_SCt].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xafec]: input[$45e1a5f717a7bf0f$var$_EC],
        [$45e1a5f717a7bf0f$var$_xafem]: input[$45e1a5f717a7bf0f$var$_EM],
        [$45e1a5f717a7bf0f$var$_xafhar]: input[$45e1a5f717a7bf0f$var$_AR],
        [$45e1a5f717a7bf0f$var$_xafhcc]: input[$45e1a5f717a7bf0f$var$_CC],
        [$45e1a5f717a7bf0f$var$_xafhcd]: input[$45e1a5f717a7bf0f$var$_CD],
        [$45e1a5f717a7bf0f$var$_xafhce]: input[$45e1a5f717a7bf0f$var$_CE],
        [$45e1a5f717a7bf0f$var$_xafhcl]: input[$45e1a5f717a7bf0f$var$_CL],
        [$45e1a5f717a7bf0f$var$_cl_]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_CLo]),
            ()=>input[$45e1a5f717a7bf0f$var$_CLo].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xafhcr]: input[$45e1a5f717a7bf0f$var$_CR],
        [$45e1a5f717a7bf0f$var$_xafhct]: input[$45e1a5f717a7bf0f$var$_CT],
        [$45e1a5f717a7bf0f$var$_xafhxacc]: input[$45e1a5f717a7bf0f$var$_CCRC],
        [$45e1a5f717a7bf0f$var$_xafhxacc_]: input[$45e1a5f717a7bf0f$var$_CCRCC],
        [$45e1a5f717a7bf0f$var$_xafhxacs]: input[$45e1a5f717a7bf0f$var$_CSHA],
        [$45e1a5f717a7bf0f$var$_xafhxacs_]: input[$45e1a5f717a7bf0f$var$_CSHAh],
        [$45e1a5f717a7bf0f$var$_xafhxadm]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_DM]),
            ()=>input[$45e1a5f717a7bf0f$var$_DM].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xafhe]: input[$45e1a5f717a7bf0f$var$_ETa],
        [$45e1a5f717a7bf0f$var$_xafhe_]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_E]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_E]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xafhxae]: input[$45e1a5f717a7bf0f$var$_Exp],
        [$45e1a5f717a7bf0f$var$_xafhlm]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_LM]),
            ()=>(0, $9ced97d9f13aecca$export$5b50865171ed23a9)(input[$45e1a5f717a7bf0f$var$_LM]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xafhxamm]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_MM]),
            ()=>input[$45e1a5f717a7bf0f$var$_MM].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xafhxaolm]: input[$45e1a5f717a7bf0f$var$_OLM],
        [$45e1a5f717a7bf0f$var$_xafhxaollh]: input[$45e1a5f717a7bf0f$var$_OLLHS],
        [$45e1a5f717a7bf0f$var$_xafhxaolrud]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_OLRUD]),
            ()=>(0, $65a9c6a67b0b3f34$export$93f3a0dd288ea1c8)(input[$45e1a5f717a7bf0f$var$_OLRUD]).toString()
        ],
        [$45e1a5f717a7bf0f$var$_xafhxampc]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_PC]),
            ()=>input[$45e1a5f717a7bf0f$var$_PC].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xafhxars]: input[$45e1a5f717a7bf0f$var$_RS],
        [$45e1a5f717a7bf0f$var$_xafhxarc]: input[$45e1a5f717a7bf0f$var$_RC],
        [$45e1a5f717a7bf0f$var$_xafhxar]: input[$45e1a5f717a7bf0f$var$_Re],
        [$45e1a5f717a7bf0f$var$_xafhxasse]: input[$45e1a5f717a7bf0f$var$_SSE],
        [$45e1a5f717a7bf0f$var$_xafhxasseca]: input[$45e1a5f717a7bf0f$var$_SSECA],
        [$45e1a5f717a7bf0f$var$_xafhxasseakki]: input[$45e1a5f717a7bf0f$var$_SSEKMSKI],
        [$45e1a5f717a7bf0f$var$_xafhxasseckm]: input[$45e1a5f717a7bf0f$var$_SSECKMD],
        [$45e1a5f717a7bf0f$var$_xafhxasc]: input[$45e1a5f717a7bf0f$var$_SC],
        [$45e1a5f717a7bf0f$var$_xafhxatc]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_TC]),
            ()=>input[$45e1a5f717a7bf0f$var$_TC].toString()
        ],
        [$45e1a5f717a7bf0f$var$_xafhxavi]: input[$45e1a5f717a7bf0f$var$_VI],
        [$45e1a5f717a7bf0f$var$_xafhxassebke]: [
            ()=>(0, $bb1a032aa13f75dc$export$f25742720bcd7d1c)(input[$45e1a5f717a7bf0f$var$_BKE]),
            ()=>input[$45e1a5f717a7bf0f$var$_BKE].toString()
        ],
        ...input.Metadata !== undefined && Object.keys(input.Metadata).reduce((acc, suffix)=>{
            acc[`x-amz-meta-${suffix.toLowerCase()}`] = input.Metadata[suffix];
            return acc;
        }, {})
    });
    b.bp("/WriteGetObjectResponse");
    let body;
    let contents;
    if (input.Body !== undefined) {
        contents = input.Body;
        body = contents;
    }
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "{RequestRoute}." + resolvedHostname;
        if (input.RequestRoute === undefined) throw new Error("Empty value provided for input host prefix: RequestRoute.");
        resolvedHostname = resolvedHostname.replace("{RequestRoute}", input.RequestRoute);
        if (!(0, $611e743691c73c8a$export$e024c793399bdd01)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $45e1a5f717a7bf0f$export$584ab52a599445fc = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$c515ac7dad03483f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_Exp]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xae]
        ],
        [$45e1a5f717a7bf0f$var$_SSE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasse]
        ],
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSKI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseakki]
        ],
        [$45e1a5f717a7bf0f$var$_BKE]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xassebke],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xassebke])
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_B] != null) contents[$45e1a5f717a7bf0f$var$_B] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_B]);
    if (data[$45e1a5f717a7bf0f$var$_CCRC] != null) contents[$45e1a5f717a7bf0f$var$_CCRC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CCRC]);
    if (data[$45e1a5f717a7bf0f$var$_CCRCC] != null) contents[$45e1a5f717a7bf0f$var$_CCRCC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CCRCC]);
    if (data[$45e1a5f717a7bf0f$var$_CSHA] != null) contents[$45e1a5f717a7bf0f$var$_CSHA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CSHA]);
    if (data[$45e1a5f717a7bf0f$var$_CSHAh] != null) contents[$45e1a5f717a7bf0f$var$_CSHAh] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CSHAh]);
    if (data[$45e1a5f717a7bf0f$var$_ETa] != null) contents[$45e1a5f717a7bf0f$var$_ETa] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_ETa]);
    if (data[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_K]);
    if (data[$45e1a5f717a7bf0f$var$_L] != null) contents[$45e1a5f717a7bf0f$var$_L] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_L]);
    return contents;
};
const $45e1a5f717a7bf0f$export$8caa46faae53e879 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_Exp]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xae]
        ],
        [$45e1a5f717a7bf0f$var$_CSVI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacsvi]
        ],
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ],
        [$45e1a5f717a7bf0f$var$_SSE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasse]
        ],
        [$45e1a5f717a7bf0f$var$_SSECA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseca]
        ],
        [$45e1a5f717a7bf0f$var$_SSECKMD]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseckm]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSKI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseakki]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSEC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xassec]
        ],
        [$45e1a5f717a7bf0f$var$_BKE]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xassebke],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xassebke])
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.CopyObjectResult = $45e1a5f717a7bf0f$var$de_CopyObjectResult(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$5faed19c2239746d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_L]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_lo]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$26ee6d662365d0aa = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_AD]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xaad],
            ()=>(0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$cf3a566289648a1e)(output.headers[$45e1a5f717a7bf0f$var$_xaad]))
        ],
        [$45e1a5f717a7bf0f$var$_ARI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xaari]
        ],
        [$45e1a5f717a7bf0f$var$_SSE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasse]
        ],
        [$45e1a5f717a7bf0f$var$_SSECA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseca]
        ],
        [$45e1a5f717a7bf0f$var$_SSECKMD]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseckm]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSKI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseakki]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSEC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xassec]
        ],
        [$45e1a5f717a7bf0f$var$_BKE]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xassebke],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xassebke])
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ],
        [$45e1a5f717a7bf0f$var$_CA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xaca]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_B] != null) contents[$45e1a5f717a7bf0f$var$_B] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_B]);
    if (data[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_K]);
    if (data[$45e1a5f717a7bf0f$var$_UI] != null) contents[$45e1a5f717a7bf0f$var$_UI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_UI]);
    return contents;
};
const $45e1a5f717a7bf0f$export$35c5fda0247f7841 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_SSE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasse]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSKI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseakki]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSEC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xassec]
        ],
        [$45e1a5f717a7bf0f$var$_BKE]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xassebke],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xassebke])
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_C] != null) contents[$45e1a5f717a7bf0f$var$_C] = $45e1a5f717a7bf0f$var$de_SessionCredentials(data[$45e1a5f717a7bf0f$var$_C], context);
    return contents;
};
const $45e1a5f717a7bf0f$export$679c7ef3d4347002 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$80d2762c2a3c51e = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$ea45039ce950a575 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$324d6f24b808da3f = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$d025149d0740c2bc = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$f814210bbf0bdc72 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$5133d32b6041d7d7 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$2989b776dea46795 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$c37a7332a9c03010 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$82b7954983c2ced5 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$15f22b651e448e49 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$b0d18a657e86fd9a = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$ad0a40c1d52ed647 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$e2f802b89379cb1b = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_DM]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xadm],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xadm])
        ],
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$439fb3ac4907d2dc = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.Deleted === "") contents[$45e1a5f717a7bf0f$var$_De] = [];
    else if (data[$45e1a5f717a7bf0f$var$_De] != null) contents[$45e1a5f717a7bf0f$var$_De] = $45e1a5f717a7bf0f$var$de_DeletedObjects((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_De]), context);
    if (data.Error === "") contents[$45e1a5f717a7bf0f$var$_Err] = [];
    else if (data[$45e1a5f717a7bf0f$var$_Er] != null) contents[$45e1a5f717a7bf0f$var$_Err] = $45e1a5f717a7bf0f$var$de_Errors((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_Er]), context);
    return contents;
};
const $45e1a5f717a7bf0f$export$4c6ead8dac914c87 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$50e0d8aa45013173 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$4a09c85c1de79ed5 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_S]);
    return contents;
};
const $45e1a5f717a7bf0f$export$64385380d83d3aa = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.AccessControlList === "") contents[$45e1a5f717a7bf0f$var$_Gr] = [];
    else if (data[$45e1a5f717a7bf0f$var$_ACLc] != null && data[$45e1a5f717a7bf0f$var$_ACLc][$45e1a5f717a7bf0f$var$_G] != null) contents[$45e1a5f717a7bf0f$var$_Gr] = $45e1a5f717a7bf0f$var$de_Grants((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_ACLc][$45e1a5f717a7bf0f$var$_G]), context);
    if (data[$45e1a5f717a7bf0f$var$_O] != null) contents[$45e1a5f717a7bf0f$var$_O] = $45e1a5f717a7bf0f$var$de_Owner(data[$45e1a5f717a7bf0f$var$_O], context);
    return contents;
};
const $45e1a5f717a7bf0f$export$a0a71690cdbea2b3 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.AnalyticsConfiguration = $45e1a5f717a7bf0f$var$de_AnalyticsConfiguration(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$a08671b31e44c28a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.CORSRule === "") contents[$45e1a5f717a7bf0f$var$_CORSRu] = [];
    else if (data[$45e1a5f717a7bf0f$var$_CORSR] != null) contents[$45e1a5f717a7bf0f$var$_CORSRu] = $45e1a5f717a7bf0f$var$de_CORSRules((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_CORSR]), context);
    return contents;
};
const $45e1a5f717a7bf0f$export$57205eb10636c925 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.ServerSideEncryptionConfiguration = $45e1a5f717a7bf0f$var$de_ServerSideEncryptionConfiguration(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$1cef593fbdeaf31e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.IntelligentTieringConfiguration = $45e1a5f717a7bf0f$var$de_IntelligentTieringConfiguration(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$82b23f98d76bbdfc = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.InventoryConfiguration = $45e1a5f717a7bf0f$var$de_InventoryConfiguration(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$c752ccb684cd7849 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.Rule === "") contents[$45e1a5f717a7bf0f$var$_Rul] = [];
    else if (data[$45e1a5f717a7bf0f$var$_Ru] != null) contents[$45e1a5f717a7bf0f$var$_Rul] = $45e1a5f717a7bf0f$var$de_LifecycleRules((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_Ru]), context);
    return contents;
};
const $45e1a5f717a7bf0f$export$c9074fcef001d65b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_LC] != null) contents[$45e1a5f717a7bf0f$var$_LC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_LC]);
    return contents;
};
const $45e1a5f717a7bf0f$export$b730a9f24f72747 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_LE] != null) contents[$45e1a5f717a7bf0f$var$_LE] = $45e1a5f717a7bf0f$var$de_LoggingEnabled(data[$45e1a5f717a7bf0f$var$_LE], context);
    return contents;
};
const $45e1a5f717a7bf0f$export$62d97f122a985ee2 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.MetricsConfiguration = $45e1a5f717a7bf0f$var$de_MetricsConfiguration(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$34ec0d820b7b6a02 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_EBC] != null) contents[$45e1a5f717a7bf0f$var$_EBC] = $45e1a5f717a7bf0f$var$de_EventBridgeConfiguration(data[$45e1a5f717a7bf0f$var$_EBC], context);
    if (data.CloudFunctionConfiguration === "") contents[$45e1a5f717a7bf0f$var$_LFC] = [];
    else if (data[$45e1a5f717a7bf0f$var$_CFC] != null) contents[$45e1a5f717a7bf0f$var$_LFC] = $45e1a5f717a7bf0f$var$de_LambdaFunctionConfigurationList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_CFC]), context);
    if (data.QueueConfiguration === "") contents[$45e1a5f717a7bf0f$var$_QCu] = [];
    else if (data[$45e1a5f717a7bf0f$var$_QC] != null) contents[$45e1a5f717a7bf0f$var$_QCu] = $45e1a5f717a7bf0f$var$de_QueueConfigurationList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_QC]), context);
    if (data.TopicConfiguration === "") contents[$45e1a5f717a7bf0f$var$_TCop] = [];
    else if (data[$45e1a5f717a7bf0f$var$_TCo] != null) contents[$45e1a5f717a7bf0f$var$_TCop] = $45e1a5f717a7bf0f$var$de_TopicConfigurationList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_TCo]), context);
    return contents;
};
const $45e1a5f717a7bf0f$export$d8cd2601fb507ba = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.OwnershipControls = $45e1a5f717a7bf0f$var$de_OwnershipControls(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$462280d554ad64e0 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = await $45e1a5f717a7bf0f$var$collectBodyString(output.body, context);
    contents.Policy = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data);
    return contents;
};
const $45e1a5f717a7bf0f$export$5db9869d862d5dba = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.PolicyStatus = $45e1a5f717a7bf0f$var$de_PolicyStatus(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$f0add93faececff5 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.ReplicationConfiguration = $45e1a5f717a7bf0f$var$de_ReplicationConfiguration(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$bbbfb17284d74c03 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_Pa] != null) contents[$45e1a5f717a7bf0f$var$_Pa] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_Pa]);
    return contents;
};
const $45e1a5f717a7bf0f$export$15bd4014a4e6ab66 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.TagSet === "") contents[$45e1a5f717a7bf0f$var$_TS] = [];
    else if (data[$45e1a5f717a7bf0f$var$_TS] != null && data[$45e1a5f717a7bf0f$var$_TS][$45e1a5f717a7bf0f$var$_Ta] != null) contents[$45e1a5f717a7bf0f$var$_TS] = $45e1a5f717a7bf0f$var$de_TagSet((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_TS][$45e1a5f717a7bf0f$var$_Ta]), context);
    return contents;
};
const $45e1a5f717a7bf0f$export$cbc21f30de233f33 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_MDf] != null) contents[$45e1a5f717a7bf0f$var$_MFAD] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_MDf]);
    if (data[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_S]);
    return contents;
};
const $45e1a5f717a7bf0f$export$324b37c649cb6a1f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_ED] != null) contents[$45e1a5f717a7bf0f$var$_ED] = $45e1a5f717a7bf0f$var$de_ErrorDocument(data[$45e1a5f717a7bf0f$var$_ED], context);
    if (data[$45e1a5f717a7bf0f$var$_ID] != null) contents[$45e1a5f717a7bf0f$var$_ID] = $45e1a5f717a7bf0f$var$de_IndexDocument(data[$45e1a5f717a7bf0f$var$_ID], context);
    if (data[$45e1a5f717a7bf0f$var$_RART] != null) contents[$45e1a5f717a7bf0f$var$_RART] = $45e1a5f717a7bf0f$var$de_RedirectAllRequestsTo(data[$45e1a5f717a7bf0f$var$_RART], context);
    if (data.RoutingRules === "") contents[$45e1a5f717a7bf0f$var$_RRo] = [];
    else if (data[$45e1a5f717a7bf0f$var$_RRo] != null && data[$45e1a5f717a7bf0f$var$_RRo][$45e1a5f717a7bf0f$var$_RRou] != null) contents[$45e1a5f717a7bf0f$var$_RRo] = $45e1a5f717a7bf0f$var$de_RoutingRules((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_RRo][$45e1a5f717a7bf0f$var$_RRou]), context);
    return contents;
};
const $45e1a5f717a7bf0f$export$ce97779f2225a8a8 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_DM]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xadm],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xadm])
        ],
        [$45e1a5f717a7bf0f$var$_AR]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_ar]
        ],
        [$45e1a5f717a7bf0f$var$_Exp]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xae]
        ],
        [$45e1a5f717a7bf0f$var$_Re]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xar]
        ],
        [$45e1a5f717a7bf0f$var$_LM]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_lm],
            ()=>(0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$cf3a566289648a1e)(output.headers[$45e1a5f717a7bf0f$var$_lm]))
        ],
        [$45e1a5f717a7bf0f$var$_CLo]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_cl_],
            ()=>(0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output.headers[$45e1a5f717a7bf0f$var$_cl_])
        ],
        [$45e1a5f717a7bf0f$var$_ETa]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_eta]
        ],
        [$45e1a5f717a7bf0f$var$_CCRC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacc]
        ],
        [$45e1a5f717a7bf0f$var$_CCRCC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacc_]
        ],
        [$45e1a5f717a7bf0f$var$_CSHA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacs]
        ],
        [$45e1a5f717a7bf0f$var$_CSHAh]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacs_]
        ],
        [$45e1a5f717a7bf0f$var$_MM]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xamm],
            ()=>(0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output.headers[$45e1a5f717a7bf0f$var$_xamm])
        ],
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ],
        [$45e1a5f717a7bf0f$var$_CC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_cc]
        ],
        [$45e1a5f717a7bf0f$var$_CD]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_cd]
        ],
        [$45e1a5f717a7bf0f$var$_CE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_ce]
        ],
        [$45e1a5f717a7bf0f$var$_CL]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_cl]
        ],
        [$45e1a5f717a7bf0f$var$_CR]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_cr]
        ],
        [$45e1a5f717a7bf0f$var$_CT]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_ct]
        ],
        [$45e1a5f717a7bf0f$var$_E]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_e],
            ()=>(0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$cf3a566289648a1e)(output.headers[$45e1a5f717a7bf0f$var$_e]))
        ],
        [$45e1a5f717a7bf0f$var$_ES]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_ex]
        ],
        [$45e1a5f717a7bf0f$var$_WRL]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xawrl]
        ],
        [$45e1a5f717a7bf0f$var$_SSE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasse]
        ],
        [$45e1a5f717a7bf0f$var$_SSECA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseca]
        ],
        [$45e1a5f717a7bf0f$var$_SSECKMD]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseckm]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSKI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseakki]
        ],
        [$45e1a5f717a7bf0f$var$_BKE]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xassebke],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xassebke])
        ],
        [$45e1a5f717a7bf0f$var$_SC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasc]
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ],
        [$45e1a5f717a7bf0f$var$_RS]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xars]
        ],
        [$45e1a5f717a7bf0f$var$_PC]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xampc],
            ()=>(0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output.headers[$45e1a5f717a7bf0f$var$_xampc])
        ],
        [$45e1a5f717a7bf0f$var$_TC]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xatc],
            ()=>(0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output.headers[$45e1a5f717a7bf0f$var$_xatc])
        ],
        [$45e1a5f717a7bf0f$var$_OLM]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xaolm]
        ],
        [$45e1a5f717a7bf0f$var$_OLRUD]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xaolrud],
            ()=>(0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output.headers[$45e1a5f717a7bf0f$var$_xaolrud]))
        ],
        [$45e1a5f717a7bf0f$var$_OLLHS]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xaollh]
        ],
        Metadata: [
            ,
            Object.keys(output.headers).filter((header)=>header.startsWith("x-amz-meta-")).reduce((acc, header)=>{
                acc[header.substring(11)] = output.headers[header];
                return acc;
            }, {})
        ]
    });
    const data = output.body;
    context.sdkStreamMixin(data);
    contents.Body = data;
    return contents;
};
const $45e1a5f717a7bf0f$export$9983385d19b8a38d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.AccessControlList === "") contents[$45e1a5f717a7bf0f$var$_Gr] = [];
    else if (data[$45e1a5f717a7bf0f$var$_ACLc] != null && data[$45e1a5f717a7bf0f$var$_ACLc][$45e1a5f717a7bf0f$var$_G] != null) contents[$45e1a5f717a7bf0f$var$_Gr] = $45e1a5f717a7bf0f$var$de_Grants((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_ACLc][$45e1a5f717a7bf0f$var$_G]), context);
    if (data[$45e1a5f717a7bf0f$var$_O] != null) contents[$45e1a5f717a7bf0f$var$_O] = $45e1a5f717a7bf0f$var$de_Owner(data[$45e1a5f717a7bf0f$var$_O], context);
    return contents;
};
const $45e1a5f717a7bf0f$export$1a4cc865f2990fe = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_DM]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xadm],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xadm])
        ],
        [$45e1a5f717a7bf0f$var$_LM]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_lm],
            ()=>(0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$cf3a566289648a1e)(output.headers[$45e1a5f717a7bf0f$var$_lm]))
        ],
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_Ch] != null) contents[$45e1a5f717a7bf0f$var$_Ch] = $45e1a5f717a7bf0f$var$de_Checksum(data[$45e1a5f717a7bf0f$var$_Ch], context);
    if (data[$45e1a5f717a7bf0f$var$_ETa] != null) contents[$45e1a5f717a7bf0f$var$_ETa] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_ETa]);
    if (data[$45e1a5f717a7bf0f$var$_OP] != null) contents[$45e1a5f717a7bf0f$var$_OP] = $45e1a5f717a7bf0f$var$de_GetObjectAttributesParts(data[$45e1a5f717a7bf0f$var$_OP], context);
    if (data[$45e1a5f717a7bf0f$var$_OSb] != null) contents[$45e1a5f717a7bf0f$var$_OSb] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(data[$45e1a5f717a7bf0f$var$_OSb]);
    if (data[$45e1a5f717a7bf0f$var$_SC] != null) contents[$45e1a5f717a7bf0f$var$_SC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_SC]);
    return contents;
};
const $45e1a5f717a7bf0f$export$7c10231615fda34b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.LegalHold = $45e1a5f717a7bf0f$var$de_ObjectLockLegalHold(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$aa261c4e9daf9d4a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.ObjectLockConfiguration = $45e1a5f717a7bf0f$var$de_ObjectLockConfiguration(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$430c0fcdeec89b5a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.Retention = $45e1a5f717a7bf0f$var$de_ObjectLockRetention(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$1626c75542346cdd = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.TagSet === "") contents[$45e1a5f717a7bf0f$var$_TS] = [];
    else if (data[$45e1a5f717a7bf0f$var$_TS] != null && data[$45e1a5f717a7bf0f$var$_TS][$45e1a5f717a7bf0f$var$_Ta] != null) contents[$45e1a5f717a7bf0f$var$_TS] = $45e1a5f717a7bf0f$var$de_TagSet((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_TS][$45e1a5f717a7bf0f$var$_Ta]), context);
    return contents;
};
const $45e1a5f717a7bf0f$export$b51a5621ff8a39ba = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = output.body;
    context.sdkStreamMixin(data);
    contents.Body = data;
    return contents;
};
const $45e1a5f717a7bf0f$export$3e244a0093a8d58d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.PublicAccessBlockConfiguration = $45e1a5f717a7bf0f$var$de_PublicAccessBlockConfiguration(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$f3775d528a4c31b5 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_BLT]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xablt]
        ],
        [$45e1a5f717a7bf0f$var$_BLN]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xabln]
        ],
        [$45e1a5f717a7bf0f$var$_BR]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xabr]
        ],
        [$45e1a5f717a7bf0f$var$_APA]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xaapa],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xaapa])
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$c65459f3f5e48f4e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_DM]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xadm],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xadm])
        ],
        [$45e1a5f717a7bf0f$var$_AR]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_ar]
        ],
        [$45e1a5f717a7bf0f$var$_Exp]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xae]
        ],
        [$45e1a5f717a7bf0f$var$_Re]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xar]
        ],
        [$45e1a5f717a7bf0f$var$_AS]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xaas]
        ],
        [$45e1a5f717a7bf0f$var$_LM]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_lm],
            ()=>(0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$cf3a566289648a1e)(output.headers[$45e1a5f717a7bf0f$var$_lm]))
        ],
        [$45e1a5f717a7bf0f$var$_CLo]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_cl_],
            ()=>(0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output.headers[$45e1a5f717a7bf0f$var$_cl_])
        ],
        [$45e1a5f717a7bf0f$var$_CCRC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacc]
        ],
        [$45e1a5f717a7bf0f$var$_CCRCC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacc_]
        ],
        [$45e1a5f717a7bf0f$var$_CSHA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacs]
        ],
        [$45e1a5f717a7bf0f$var$_CSHAh]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacs_]
        ],
        [$45e1a5f717a7bf0f$var$_ETa]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_eta]
        ],
        [$45e1a5f717a7bf0f$var$_MM]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xamm],
            ()=>(0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output.headers[$45e1a5f717a7bf0f$var$_xamm])
        ],
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ],
        [$45e1a5f717a7bf0f$var$_CC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_cc]
        ],
        [$45e1a5f717a7bf0f$var$_CD]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_cd]
        ],
        [$45e1a5f717a7bf0f$var$_CE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_ce]
        ],
        [$45e1a5f717a7bf0f$var$_CL]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_cl]
        ],
        [$45e1a5f717a7bf0f$var$_CT]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_ct]
        ],
        [$45e1a5f717a7bf0f$var$_E]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_e],
            ()=>(0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$cf3a566289648a1e)(output.headers[$45e1a5f717a7bf0f$var$_e]))
        ],
        [$45e1a5f717a7bf0f$var$_ES]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_ex]
        ],
        [$45e1a5f717a7bf0f$var$_WRL]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xawrl]
        ],
        [$45e1a5f717a7bf0f$var$_SSE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasse]
        ],
        [$45e1a5f717a7bf0f$var$_SSECA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseca]
        ],
        [$45e1a5f717a7bf0f$var$_SSECKMD]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseckm]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSKI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseakki]
        ],
        [$45e1a5f717a7bf0f$var$_BKE]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xassebke],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xassebke])
        ],
        [$45e1a5f717a7bf0f$var$_SC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasc]
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ],
        [$45e1a5f717a7bf0f$var$_RS]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xars]
        ],
        [$45e1a5f717a7bf0f$var$_PC]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xampc],
            ()=>(0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output.headers[$45e1a5f717a7bf0f$var$_xampc])
        ],
        [$45e1a5f717a7bf0f$var$_OLM]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xaolm]
        ],
        [$45e1a5f717a7bf0f$var$_OLRUD]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xaolrud],
            ()=>(0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output.headers[$45e1a5f717a7bf0f$var$_xaolrud]))
        ],
        [$45e1a5f717a7bf0f$var$_OLLHS]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xaollh]
        ],
        Metadata: [
            ,
            Object.keys(output.headers).filter((header)=>header.startsWith("x-amz-meta-")).reduce((acc, header)=>{
                acc[header.substring(11)] = output.headers[header];
                return acc;
            }, {})
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$4a580d6152559b0a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.AnalyticsConfiguration === "") contents[$45e1a5f717a7bf0f$var$_ACLn] = [];
    else if (data[$45e1a5f717a7bf0f$var$_AC] != null) contents[$45e1a5f717a7bf0f$var$_ACLn] = $45e1a5f717a7bf0f$var$de_AnalyticsConfigurationList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_AC]), context);
    if (data[$45e1a5f717a7bf0f$var$_CTo] != null) contents[$45e1a5f717a7bf0f$var$_CTo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CTo]);
    if (data[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(data[$45e1a5f717a7bf0f$var$_IT]);
    if (data[$45e1a5f717a7bf0f$var$_NCT] != null) contents[$45e1a5f717a7bf0f$var$_NCT] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NCT]);
    return contents;
};
const $45e1a5f717a7bf0f$export$fb8e43a59b26e374 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_CTo] != null) contents[$45e1a5f717a7bf0f$var$_CTo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CTo]);
    if (data.IntelligentTieringConfiguration === "") contents[$45e1a5f717a7bf0f$var$_ITCL] = [];
    else if (data[$45e1a5f717a7bf0f$var$_ITC] != null) contents[$45e1a5f717a7bf0f$var$_ITCL] = $45e1a5f717a7bf0f$var$de_IntelligentTieringConfigurationList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_ITC]), context);
    if (data[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(data[$45e1a5f717a7bf0f$var$_IT]);
    if (data[$45e1a5f717a7bf0f$var$_NCT] != null) contents[$45e1a5f717a7bf0f$var$_NCT] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NCT]);
    return contents;
};
const $45e1a5f717a7bf0f$export$6b4533e13b7e300f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_CTo] != null) contents[$45e1a5f717a7bf0f$var$_CTo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CTo]);
    if (data.InventoryConfiguration === "") contents[$45e1a5f717a7bf0f$var$_ICL] = [];
    else if (data[$45e1a5f717a7bf0f$var$_IC] != null) contents[$45e1a5f717a7bf0f$var$_ICL] = $45e1a5f717a7bf0f$var$de_InventoryConfigurationList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_IC]), context);
    if (data[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(data[$45e1a5f717a7bf0f$var$_IT]);
    if (data[$45e1a5f717a7bf0f$var$_NCT] != null) contents[$45e1a5f717a7bf0f$var$_NCT] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NCT]);
    return contents;
};
const $45e1a5f717a7bf0f$export$129d146e4f043f73 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_CTo] != null) contents[$45e1a5f717a7bf0f$var$_CTo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CTo]);
    if (data[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(data[$45e1a5f717a7bf0f$var$_IT]);
    if (data.MetricsConfiguration === "") contents[$45e1a5f717a7bf0f$var$_MCL] = [];
    else if (data[$45e1a5f717a7bf0f$var$_MC] != null) contents[$45e1a5f717a7bf0f$var$_MCL] = $45e1a5f717a7bf0f$var$de_MetricsConfigurationList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_MC]), context);
    if (data[$45e1a5f717a7bf0f$var$_NCT] != null) contents[$45e1a5f717a7bf0f$var$_NCT] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NCT]);
    return contents;
};
const $45e1a5f717a7bf0f$export$e054f59953b787ee = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.Buckets === "") contents[$45e1a5f717a7bf0f$var$_Bu] = [];
    else if (data[$45e1a5f717a7bf0f$var$_Bu] != null && data[$45e1a5f717a7bf0f$var$_Bu][$45e1a5f717a7bf0f$var$_B] != null) contents[$45e1a5f717a7bf0f$var$_Bu] = $45e1a5f717a7bf0f$var$de_Buckets((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_Bu][$45e1a5f717a7bf0f$var$_B]), context);
    if (data[$45e1a5f717a7bf0f$var$_CTo] != null) contents[$45e1a5f717a7bf0f$var$_CTo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CTo]);
    if (data[$45e1a5f717a7bf0f$var$_O] != null) contents[$45e1a5f717a7bf0f$var$_O] = $45e1a5f717a7bf0f$var$de_Owner(data[$45e1a5f717a7bf0f$var$_O], context);
    return contents;
};
const $45e1a5f717a7bf0f$export$f820079c03b76e38 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.Buckets === "") contents[$45e1a5f717a7bf0f$var$_Bu] = [];
    else if (data[$45e1a5f717a7bf0f$var$_Bu] != null && data[$45e1a5f717a7bf0f$var$_Bu][$45e1a5f717a7bf0f$var$_B] != null) contents[$45e1a5f717a7bf0f$var$_Bu] = $45e1a5f717a7bf0f$var$de_Buckets((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_Bu][$45e1a5f717a7bf0f$var$_B]), context);
    if (data[$45e1a5f717a7bf0f$var$_CTo] != null) contents[$45e1a5f717a7bf0f$var$_CTo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CTo]);
    return contents;
};
const $45e1a5f717a7bf0f$export$202c2be1cea3d836 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_B] != null) contents[$45e1a5f717a7bf0f$var$_B] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_B]);
    if (data.CommonPrefixes === "") contents[$45e1a5f717a7bf0f$var$_CP] = [];
    else if (data[$45e1a5f717a7bf0f$var$_CP] != null) contents[$45e1a5f717a7bf0f$var$_CP] = $45e1a5f717a7bf0f$var$de_CommonPrefixList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_CP]), context);
    if (data[$45e1a5f717a7bf0f$var$_D] != null) contents[$45e1a5f717a7bf0f$var$_D] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_D]);
    if (data[$45e1a5f717a7bf0f$var$_ET] != null) contents[$45e1a5f717a7bf0f$var$_ET] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_ET]);
    if (data[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(data[$45e1a5f717a7bf0f$var$_IT]);
    if (data[$45e1a5f717a7bf0f$var$_KM] != null) contents[$45e1a5f717a7bf0f$var$_KM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_KM]);
    if (data[$45e1a5f717a7bf0f$var$_MU] != null) contents[$45e1a5f717a7bf0f$var$_MU] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(data[$45e1a5f717a7bf0f$var$_MU]);
    if (data[$45e1a5f717a7bf0f$var$_NKM] != null) contents[$45e1a5f717a7bf0f$var$_NKM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NKM]);
    if (data[$45e1a5f717a7bf0f$var$_NUIM] != null) contents[$45e1a5f717a7bf0f$var$_NUIM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NUIM]);
    if (data[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_P]);
    if (data[$45e1a5f717a7bf0f$var$_UIM] != null) contents[$45e1a5f717a7bf0f$var$_UIM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_UIM]);
    if (data.Upload === "") contents[$45e1a5f717a7bf0f$var$_Up] = [];
    else if (data[$45e1a5f717a7bf0f$var$_U] != null) contents[$45e1a5f717a7bf0f$var$_Up] = $45e1a5f717a7bf0f$var$de_MultipartUploadList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_U]), context);
    return contents;
};
const $45e1a5f717a7bf0f$export$60c32fef378932a4 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.CommonPrefixes === "") contents[$45e1a5f717a7bf0f$var$_CP] = [];
    else if (data[$45e1a5f717a7bf0f$var$_CP] != null) contents[$45e1a5f717a7bf0f$var$_CP] = $45e1a5f717a7bf0f$var$de_CommonPrefixList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_CP]), context);
    if (data.Contents === "") contents[$45e1a5f717a7bf0f$var$_Co] = [];
    else if (data[$45e1a5f717a7bf0f$var$_Co] != null) contents[$45e1a5f717a7bf0f$var$_Co] = $45e1a5f717a7bf0f$var$de_ObjectList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_Co]), context);
    if (data[$45e1a5f717a7bf0f$var$_D] != null) contents[$45e1a5f717a7bf0f$var$_D] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_D]);
    if (data[$45e1a5f717a7bf0f$var$_ET] != null) contents[$45e1a5f717a7bf0f$var$_ET] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_ET]);
    if (data[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(data[$45e1a5f717a7bf0f$var$_IT]);
    if (data[$45e1a5f717a7bf0f$var$_M] != null) contents[$45e1a5f717a7bf0f$var$_M] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_M]);
    if (data[$45e1a5f717a7bf0f$var$_MK] != null) contents[$45e1a5f717a7bf0f$var$_MK] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(data[$45e1a5f717a7bf0f$var$_MK]);
    if (data[$45e1a5f717a7bf0f$var$_N] != null) contents[$45e1a5f717a7bf0f$var$_N] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_N]);
    if (data[$45e1a5f717a7bf0f$var$_NM] != null) contents[$45e1a5f717a7bf0f$var$_NM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NM]);
    if (data[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_P]);
    return contents;
};
const $45e1a5f717a7bf0f$export$feeeb96d3aa8311b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.CommonPrefixes === "") contents[$45e1a5f717a7bf0f$var$_CP] = [];
    else if (data[$45e1a5f717a7bf0f$var$_CP] != null) contents[$45e1a5f717a7bf0f$var$_CP] = $45e1a5f717a7bf0f$var$de_CommonPrefixList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_CP]), context);
    if (data.Contents === "") contents[$45e1a5f717a7bf0f$var$_Co] = [];
    else if (data[$45e1a5f717a7bf0f$var$_Co] != null) contents[$45e1a5f717a7bf0f$var$_Co] = $45e1a5f717a7bf0f$var$de_ObjectList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_Co]), context);
    if (data[$45e1a5f717a7bf0f$var$_CTo] != null) contents[$45e1a5f717a7bf0f$var$_CTo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CTo]);
    if (data[$45e1a5f717a7bf0f$var$_D] != null) contents[$45e1a5f717a7bf0f$var$_D] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_D]);
    if (data[$45e1a5f717a7bf0f$var$_ET] != null) contents[$45e1a5f717a7bf0f$var$_ET] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_ET]);
    if (data[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(data[$45e1a5f717a7bf0f$var$_IT]);
    if (data[$45e1a5f717a7bf0f$var$_KC] != null) contents[$45e1a5f717a7bf0f$var$_KC] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(data[$45e1a5f717a7bf0f$var$_KC]);
    if (data[$45e1a5f717a7bf0f$var$_MK] != null) contents[$45e1a5f717a7bf0f$var$_MK] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(data[$45e1a5f717a7bf0f$var$_MK]);
    if (data[$45e1a5f717a7bf0f$var$_N] != null) contents[$45e1a5f717a7bf0f$var$_N] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_N]);
    if (data[$45e1a5f717a7bf0f$var$_NCT] != null) contents[$45e1a5f717a7bf0f$var$_NCT] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NCT]);
    if (data[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_P]);
    if (data[$45e1a5f717a7bf0f$var$_SA] != null) contents[$45e1a5f717a7bf0f$var$_SA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_SA]);
    return contents;
};
const $45e1a5f717a7bf0f$export$d416390b9e326b20 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data.CommonPrefixes === "") contents[$45e1a5f717a7bf0f$var$_CP] = [];
    else if (data[$45e1a5f717a7bf0f$var$_CP] != null) contents[$45e1a5f717a7bf0f$var$_CP] = $45e1a5f717a7bf0f$var$de_CommonPrefixList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_CP]), context);
    if (data.DeleteMarker === "") contents[$45e1a5f717a7bf0f$var$_DMe] = [];
    else if (data[$45e1a5f717a7bf0f$var$_DM] != null) contents[$45e1a5f717a7bf0f$var$_DMe] = $45e1a5f717a7bf0f$var$de_DeleteMarkers((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_DM]), context);
    if (data[$45e1a5f717a7bf0f$var$_D] != null) contents[$45e1a5f717a7bf0f$var$_D] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_D]);
    if (data[$45e1a5f717a7bf0f$var$_ET] != null) contents[$45e1a5f717a7bf0f$var$_ET] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_ET]);
    if (data[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(data[$45e1a5f717a7bf0f$var$_IT]);
    if (data[$45e1a5f717a7bf0f$var$_KM] != null) contents[$45e1a5f717a7bf0f$var$_KM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_KM]);
    if (data[$45e1a5f717a7bf0f$var$_MK] != null) contents[$45e1a5f717a7bf0f$var$_MK] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(data[$45e1a5f717a7bf0f$var$_MK]);
    if (data[$45e1a5f717a7bf0f$var$_N] != null) contents[$45e1a5f717a7bf0f$var$_N] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_N]);
    if (data[$45e1a5f717a7bf0f$var$_NKM] != null) contents[$45e1a5f717a7bf0f$var$_NKM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NKM]);
    if (data[$45e1a5f717a7bf0f$var$_NVIM] != null) contents[$45e1a5f717a7bf0f$var$_NVIM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NVIM]);
    if (data[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_P]);
    if (data[$45e1a5f717a7bf0f$var$_VIM] != null) contents[$45e1a5f717a7bf0f$var$_VIM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_VIM]);
    if (data.Version === "") contents[$45e1a5f717a7bf0f$var$_Ve] = [];
    else if (data[$45e1a5f717a7bf0f$var$_V] != null) contents[$45e1a5f717a7bf0f$var$_Ve] = $45e1a5f717a7bf0f$var$de_ObjectVersionList((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_V]), context);
    return contents;
};
const $45e1a5f717a7bf0f$export$889118d85a8eede7 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_AD]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xaad],
            ()=>(0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$cf3a566289648a1e)(output.headers[$45e1a5f717a7bf0f$var$_xaad]))
        ],
        [$45e1a5f717a7bf0f$var$_ARI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xaari]
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context)), "body");
    if (data[$45e1a5f717a7bf0f$var$_B] != null) contents[$45e1a5f717a7bf0f$var$_B] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_B]);
    if (data[$45e1a5f717a7bf0f$var$_CA] != null) contents[$45e1a5f717a7bf0f$var$_CA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_CA]);
    if (data[$45e1a5f717a7bf0f$var$_In] != null) contents[$45e1a5f717a7bf0f$var$_In] = $45e1a5f717a7bf0f$var$de_Initiator(data[$45e1a5f717a7bf0f$var$_In], context);
    if (data[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(data[$45e1a5f717a7bf0f$var$_IT]);
    if (data[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_K]);
    if (data[$45e1a5f717a7bf0f$var$_MP] != null) contents[$45e1a5f717a7bf0f$var$_MP] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(data[$45e1a5f717a7bf0f$var$_MP]);
    if (data[$45e1a5f717a7bf0f$var$_NPNM] != null) contents[$45e1a5f717a7bf0f$var$_NPNM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_NPNM]);
    if (data[$45e1a5f717a7bf0f$var$_O] != null) contents[$45e1a5f717a7bf0f$var$_O] = $45e1a5f717a7bf0f$var$de_Owner(data[$45e1a5f717a7bf0f$var$_O], context);
    if (data[$45e1a5f717a7bf0f$var$_PNM] != null) contents[$45e1a5f717a7bf0f$var$_PNM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_PNM]);
    if (data.Part === "") contents[$45e1a5f717a7bf0f$var$_Part] = [];
    else if (data[$45e1a5f717a7bf0f$var$_Par] != null) contents[$45e1a5f717a7bf0f$var$_Part] = $45e1a5f717a7bf0f$var$de_Parts((0, $6eb87c253cabe879$export$52272e038712c64e)(data[$45e1a5f717a7bf0f$var$_Par]), context);
    if (data[$45e1a5f717a7bf0f$var$_SC] != null) contents[$45e1a5f717a7bf0f$var$_SC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_SC]);
    if (data[$45e1a5f717a7bf0f$var$_UI] != null) contents[$45e1a5f717a7bf0f$var$_UI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_UI]);
    return contents;
};
const $45e1a5f717a7bf0f$export$d2a736b57650c456 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$75e6a99b1c339917 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$854cdce50005e56a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$c0c66a8837f2d4b7 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$e7db3ad9c672fd4f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$59e017c5bb66929d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$f255d6249684469e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$c202de193d98138f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$449100442e3176cf = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$25022097f277800e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$440e091cf54e6cab = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$32aa15f0afe296ab = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$b58e3d261138954b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$9391691c9783a112 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$419f306f268e3e00 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$95aca8e80cc02bb4 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$5f7f53ae9422ba4c = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$d80cda07dc7d9c8 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$7b5fb371239d4b24 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_Exp]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xae]
        ],
        [$45e1a5f717a7bf0f$var$_ETa]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_eta]
        ],
        [$45e1a5f717a7bf0f$var$_CCRC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacc]
        ],
        [$45e1a5f717a7bf0f$var$_CCRCC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacc_]
        ],
        [$45e1a5f717a7bf0f$var$_CSHA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacs]
        ],
        [$45e1a5f717a7bf0f$var$_CSHAh]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacs_]
        ],
        [$45e1a5f717a7bf0f$var$_SSE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasse]
        ],
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ],
        [$45e1a5f717a7bf0f$var$_SSECA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseca]
        ],
        [$45e1a5f717a7bf0f$var$_SSECKMD]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseckm]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSKI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseakki]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSEC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xassec]
        ],
        [$45e1a5f717a7bf0f$var$_BKE]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xassebke],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xassebke])
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$bf11fd5d155581b3 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$4b6d1543afbb074f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$90f68ac8a7a0e24 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$b26d670522bae7cd = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$8409a6520dd6d338 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_VI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xavi]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$ca8f3e913af12de5 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$aaca0f50a468a078 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ],
        [$45e1a5f717a7bf0f$var$_ROP]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarop]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$b9e872a6d39a299d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    const data = output.body;
    contents.Payload = $45e1a5f717a7bf0f$var$de_SelectObjectContentEventStream(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$c970fb418cbd6bb1 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_SSE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasse]
        ],
        [$45e1a5f717a7bf0f$var$_ETa]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_eta]
        ],
        [$45e1a5f717a7bf0f$var$_CCRC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacc]
        ],
        [$45e1a5f717a7bf0f$var$_CCRCC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacc_]
        ],
        [$45e1a5f717a7bf0f$var$_CSHA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacs]
        ],
        [$45e1a5f717a7bf0f$var$_CSHAh]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacs_]
        ],
        [$45e1a5f717a7bf0f$var$_SSECA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseca]
        ],
        [$45e1a5f717a7bf0f$var$_SSECKMD]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseckm]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSKI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseakki]
        ],
        [$45e1a5f717a7bf0f$var$_BKE]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xassebke],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xassebke])
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$c431a3723512099a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output),
        [$45e1a5f717a7bf0f$var$_CSVI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xacsvi]
        ],
        [$45e1a5f717a7bf0f$var$_SSE]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasse]
        ],
        [$45e1a5f717a7bf0f$var$_SSECA]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseca]
        ],
        [$45e1a5f717a7bf0f$var$_SSECKMD]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseckm]
        ],
        [$45e1a5f717a7bf0f$var$_SSEKMSKI]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xasseakki]
        ],
        [$45e1a5f717a7bf0f$var$_BKE]: [
            ()=>void 0 !== output.headers[$45e1a5f717a7bf0f$var$_xassebke],
            ()=>(0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output.headers[$45e1a5f717a7bf0f$var$_xassebke])
        ],
        [$45e1a5f717a7bf0f$var$_RC]: [
            ,
            output.headers[$45e1a5f717a7bf0f$var$_xarc]
        ]
    });
    const data = (0, $ffdcd55bd2051dc8$export$cf825aadce530e7e)(await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context));
    contents.CopyPartResult = $45e1a5f717a7bf0f$var$de_CopyPartResult(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$export$7c898350df913e04 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $45e1a5f717a7bf0f$var$de_CommandError(output, context);
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(output)
    });
    await (0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_CommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $748c029693e94b07$export$bc3bfbea4e5d3440)(output.body, context)
    };
    const errorCode = (0, $748c029693e94b07$export$e5a272551bb5495c)(output, parsedOutput.body);
    switch(errorCode){
        case "NoSuchUpload":
        case "com.amazonaws.s3#NoSuchUpload":
            throw await $45e1a5f717a7bf0f$var$de_NoSuchUploadRes(parsedOutput, context);
        case "ObjectNotInActiveTierError":
        case "com.amazonaws.s3#ObjectNotInActiveTierError":
            throw await $45e1a5f717a7bf0f$var$de_ObjectNotInActiveTierErrorRes(parsedOutput, context);
        case "BucketAlreadyExists":
        case "com.amazonaws.s3#BucketAlreadyExists":
            throw await $45e1a5f717a7bf0f$var$de_BucketAlreadyExistsRes(parsedOutput, context);
        case "BucketAlreadyOwnedByYou":
        case "com.amazonaws.s3#BucketAlreadyOwnedByYou":
            throw await $45e1a5f717a7bf0f$var$de_BucketAlreadyOwnedByYouRes(parsedOutput, context);
        case "NoSuchBucket":
        case "com.amazonaws.s3#NoSuchBucket":
            throw await $45e1a5f717a7bf0f$var$de_NoSuchBucketRes(parsedOutput, context);
        case "InvalidObjectState":
        case "com.amazonaws.s3#InvalidObjectState":
            throw await $45e1a5f717a7bf0f$var$de_InvalidObjectStateRes(parsedOutput, context);
        case "NoSuchKey":
        case "com.amazonaws.s3#NoSuchKey":
            throw await $45e1a5f717a7bf0f$var$de_NoSuchKeyRes(parsedOutput, context);
        case "NotFound":
        case "com.amazonaws.s3#NotFound":
            throw await $45e1a5f717a7bf0f$var$de_NotFoundRes(parsedOutput, context);
        case "ObjectAlreadyInActiveTierError":
        case "com.amazonaws.s3#ObjectAlreadyInActiveTierError":
            throw await $45e1a5f717a7bf0f$var$de_ObjectAlreadyInActiveTierErrorRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $45e1a5f717a7bf0f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $45e1a5f717a7bf0f$var$throwDefaultError = (0, $566c2d1ff609c075$export$62ac8acba1748a85)((0, $92dbcbc8228e43d8$export$a53c51960b14a8e5));
const $45e1a5f717a7bf0f$var$de_BucketAlreadyExistsRes = async (parsedOutput, context)=>{
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $b50962978b66428d$export$b6b374c2bfd60422)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $45e1a5f717a7bf0f$var$de_BucketAlreadyOwnedByYouRes = async (parsedOutput, context)=>{
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $b50962978b66428d$export$3d44152d602e5b07)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $45e1a5f717a7bf0f$var$de_InvalidObjectStateRes = async (parsedOutput, context)=>{
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    if (data[$45e1a5f717a7bf0f$var$_AT] != null) contents[$45e1a5f717a7bf0f$var$_AT] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_AT]);
    if (data[$45e1a5f717a7bf0f$var$_SC] != null) contents[$45e1a5f717a7bf0f$var$_SC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(data[$45e1a5f717a7bf0f$var$_SC]);
    const exception = new (0, $b50962978b66428d$export$6424f05126e7daf8)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $45e1a5f717a7bf0f$var$de_NoSuchBucketRes = async (parsedOutput, context)=>{
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $b50962978b66428d$export$bbe89283205bd874)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $45e1a5f717a7bf0f$var$de_NoSuchKeyRes = async (parsedOutput, context)=>{
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $b50962978b66428d$export$1f6f8c73c651f3ca)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $45e1a5f717a7bf0f$var$de_NoSuchUploadRes = async (parsedOutput, context)=>{
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $b50962978b66428d$export$1de06065cff890a8)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $45e1a5f717a7bf0f$var$de_NotFoundRes = async (parsedOutput, context)=>{
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $b50962978b66428d$export$271f9f08425019c7)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $45e1a5f717a7bf0f$var$de_ObjectAlreadyInActiveTierErrorRes = async (parsedOutput, context)=>{
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $971b440947405896$export$a97e3c65be291319)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $45e1a5f717a7bf0f$var$de_ObjectNotInActiveTierErrorRes = async (parsedOutput, context)=>{
    const contents = (0, $ff5db7a53b053938$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $b50962978b66428d$export$77615b2f7cde9dd7)({
        $metadata: $45e1a5f717a7bf0f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $d8c529a0bf92abea$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $45e1a5f717a7bf0f$var$de_SelectObjectContentEventStream = (output, context)=>{
    return context.eventStreamMarshaller.deserialize(output, async (event)=>{
        if (event["Records"] != null) return {
            Records: await $45e1a5f717a7bf0f$var$de_RecordsEvent_event(event["Records"], context)
        };
        if (event["Stats"] != null) return {
            Stats: await $45e1a5f717a7bf0f$var$de_StatsEvent_event(event["Stats"], context)
        };
        if (event["Progress"] != null) return {
            Progress: await $45e1a5f717a7bf0f$var$de_ProgressEvent_event(event["Progress"], context)
        };
        if (event["Cont"] != null) return {
            Cont: await $45e1a5f717a7bf0f$var$de_ContinuationEvent_event(event["Cont"], context)
        };
        if (event["End"] != null) return {
            End: await $45e1a5f717a7bf0f$var$de_EndEvent_event(event["End"], context)
        };
        return {
            $unknown: output
        };
    });
};
const $45e1a5f717a7bf0f$var$de_ContinuationEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context);
    Object.assign(contents, $45e1a5f717a7bf0f$var$de_ContinuationEvent(data, context));
    return contents;
};
const $45e1a5f717a7bf0f$var$de_EndEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context);
    Object.assign(contents, $45e1a5f717a7bf0f$var$de_EndEvent(data, context));
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ProgressEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context);
    contents.Details = $45e1a5f717a7bf0f$var$de_Progress(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_RecordsEvent_event = async (output, context)=>{
    const contents = {};
    contents.Payload = output.body;
    return contents;
};
const $45e1a5f717a7bf0f$var$de_StatsEvent_event = async (output, context)=>{
    const contents = {};
    const data = await (0, $748c029693e94b07$export$9f31af2cd814b6c7)(output.body, context);
    contents.Details = $45e1a5f717a7bf0f$var$de_Stats(data, context);
    return contents;
};
const $45e1a5f717a7bf0f$var$se_AbortIncompleteMultipartUpload = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_AIMU);
    if (input[$45e1a5f717a7bf0f$var$_DAI] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_DAI, String(input[$45e1a5f717a7bf0f$var$_DAI])).n($45e1a5f717a7bf0f$var$_DAI));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_AccelerateConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ACc);
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_BAS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_AccessControlPolicy = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ACP);
    bn.lc(input, "Grants", "AccessControlList", ()=>$45e1a5f717a7bf0f$var$se_Grants(input[$45e1a5f717a7bf0f$var$_Gr], context));
    if (input[$45e1a5f717a7bf0f$var$_O] != null) bn.c($45e1a5f717a7bf0f$var$se_Owner(input[$45e1a5f717a7bf0f$var$_O], context).n($45e1a5f717a7bf0f$var$_O));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_AccessControlTranslation = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ACT);
    if (input[$45e1a5f717a7bf0f$var$_O] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OOw, input[$45e1a5f717a7bf0f$var$_O]).n($45e1a5f717a7bf0f$var$_O));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_AllowedHeaders = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = (0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_AH, entry);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_AllowedMethods = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = (0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_AM, entry);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_AllowedOrigins = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = (0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_AO, entry);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_AnalyticsAndOperator = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_AAO);
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    bn.l(input, "Tags", "Tag", ()=>$45e1a5f717a7bf0f$var$se_TagSet(input[$45e1a5f717a7bf0f$var$_Tag], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_AnalyticsConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_AC);
    if (input[$45e1a5f717a7bf0f$var$_I] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_AI, input[$45e1a5f717a7bf0f$var$_I]).n($45e1a5f717a7bf0f$var$_I));
    if (input[$45e1a5f717a7bf0f$var$_F] != null) bn.c($45e1a5f717a7bf0f$var$se_AnalyticsFilter(input[$45e1a5f717a7bf0f$var$_F], context).n($45e1a5f717a7bf0f$var$_F));
    if (input[$45e1a5f717a7bf0f$var$_SCA] != null) bn.c($45e1a5f717a7bf0f$var$se_StorageClassAnalysis(input[$45e1a5f717a7bf0f$var$_SCA], context).n($45e1a5f717a7bf0f$var$_SCA));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_AnalyticsExportDestination = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_AED);
    if (input[$45e1a5f717a7bf0f$var$_SBD] != null) bn.c($45e1a5f717a7bf0f$var$se_AnalyticsS3BucketDestination(input[$45e1a5f717a7bf0f$var$_SBD], context).n($45e1a5f717a7bf0f$var$_SBD));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_AnalyticsFilter = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_AF);
    (0, $b50962978b66428d$export$c9ec61557dcb764a).visit(input, {
        Prefix: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_P] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_P, value).n($45e1a5f717a7bf0f$var$_P));
        },
        Tag: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_Ta] != null) bn.c($45e1a5f717a7bf0f$var$se_Tag(value, context).n($45e1a5f717a7bf0f$var$_Ta));
        },
        And: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_A] != null) bn.c($45e1a5f717a7bf0f$var$se_AnalyticsAndOperator(value, context).n($45e1a5f717a7bf0f$var$_A));
        },
        _: (name, value)=>{
            if (!(value instanceof (0, $44a0d59c11863d38$export$e775a15d806cbddc) || value instanceof (0, $0c5f967439148a05$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bn.c(new (0, $44a0d59c11863d38$export$e775a15d806cbddc)(name).c(value));
        }
    });
    return bn;
};
const $45e1a5f717a7bf0f$var$se_AnalyticsS3BucketDestination = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ASBD);
    if (input[$45e1a5f717a7bf0f$var$_Fo] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_ASEFF, input[$45e1a5f717a7bf0f$var$_Fo]).n($45e1a5f717a7bf0f$var$_Fo));
    if (input[$45e1a5f717a7bf0f$var$_BAI] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_AIc, input[$45e1a5f717a7bf0f$var$_BAI]).n($45e1a5f717a7bf0f$var$_BAI));
    if (input[$45e1a5f717a7bf0f$var$_B] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_BN, input[$45e1a5f717a7bf0f$var$_B]).n($45e1a5f717a7bf0f$var$_B));
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_BucketInfo = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_BI);
    bn.cc(input, $45e1a5f717a7bf0f$var$_DR);
    if (input[$45e1a5f717a7bf0f$var$_Ty] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_BT, input[$45e1a5f717a7bf0f$var$_Ty]).n($45e1a5f717a7bf0f$var$_Ty));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_BucketLifecycleConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_BLC);
    bn.l(input, "Rules", "Rule", ()=>$45e1a5f717a7bf0f$var$se_LifecycleRules(input[$45e1a5f717a7bf0f$var$_Rul], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_BucketLoggingStatus = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_BLS);
    if (input[$45e1a5f717a7bf0f$var$_LE] != null) bn.c($45e1a5f717a7bf0f$var$se_LoggingEnabled(input[$45e1a5f717a7bf0f$var$_LE], context).n($45e1a5f717a7bf0f$var$_LE));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_CompletedMultipartUpload = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_CMU);
    bn.l(input, "Parts", "Part", ()=>$45e1a5f717a7bf0f$var$se_CompletedPartList(input[$45e1a5f717a7bf0f$var$_Part], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_CompletedPart = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_CPo);
    bn.cc(input, $45e1a5f717a7bf0f$var$_ETa);
    bn.cc(input, $45e1a5f717a7bf0f$var$_CCRC);
    bn.cc(input, $45e1a5f717a7bf0f$var$_CCRCC);
    bn.cc(input, $45e1a5f717a7bf0f$var$_CSHA);
    bn.cc(input, $45e1a5f717a7bf0f$var$_CSHAh);
    if (input[$45e1a5f717a7bf0f$var$_PN] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_PN, String(input[$45e1a5f717a7bf0f$var$_PN])).n($45e1a5f717a7bf0f$var$_PN));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_CompletedPartList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_CompletedPart(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_Condition = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_Con);
    bn.cc(input, $45e1a5f717a7bf0f$var$_HECRE);
    bn.cc(input, $45e1a5f717a7bf0f$var$_KPE);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_CORSConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_CORSC);
    bn.l(input, "CORSRules", "CORSRule", ()=>$45e1a5f717a7bf0f$var$se_CORSRules(input[$45e1a5f717a7bf0f$var$_CORSRu], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_CORSRule = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_CORSR);
    bn.cc(input, $45e1a5f717a7bf0f$var$_ID_);
    bn.l(input, "AllowedHeaders", "AllowedHeader", ()=>$45e1a5f717a7bf0f$var$se_AllowedHeaders(input[$45e1a5f717a7bf0f$var$_AHl], context));
    bn.l(input, "AllowedMethods", "AllowedMethod", ()=>$45e1a5f717a7bf0f$var$se_AllowedMethods(input[$45e1a5f717a7bf0f$var$_AMl], context));
    bn.l(input, "AllowedOrigins", "AllowedOrigin", ()=>$45e1a5f717a7bf0f$var$se_AllowedOrigins(input[$45e1a5f717a7bf0f$var$_AOl], context));
    bn.l(input, "ExposeHeaders", "ExposeHeader", ()=>$45e1a5f717a7bf0f$var$se_ExposeHeaders(input[$45e1a5f717a7bf0f$var$_EH], context));
    if (input[$45e1a5f717a7bf0f$var$_MAS] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_MAS, String(input[$45e1a5f717a7bf0f$var$_MAS])).n($45e1a5f717a7bf0f$var$_MAS));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_CORSRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_CORSRule(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_CreateBucketConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_CBC);
    if (input[$45e1a5f717a7bf0f$var$_LC] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_BLCu, input[$45e1a5f717a7bf0f$var$_LC]).n($45e1a5f717a7bf0f$var$_LC));
    if (input[$45e1a5f717a7bf0f$var$_L] != null) bn.c($45e1a5f717a7bf0f$var$se_LocationInfo(input[$45e1a5f717a7bf0f$var$_L], context).n($45e1a5f717a7bf0f$var$_L));
    if (input[$45e1a5f717a7bf0f$var$_B] != null) bn.c($45e1a5f717a7bf0f$var$se_BucketInfo(input[$45e1a5f717a7bf0f$var$_B], context).n($45e1a5f717a7bf0f$var$_B));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_CSVInput = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_CSVIn);
    bn.cc(input, $45e1a5f717a7bf0f$var$_FHI);
    bn.cc(input, $45e1a5f717a7bf0f$var$_Com);
    bn.cc(input, $45e1a5f717a7bf0f$var$_QEC);
    bn.cc(input, $45e1a5f717a7bf0f$var$_RD);
    bn.cc(input, $45e1a5f717a7bf0f$var$_FD);
    bn.cc(input, $45e1a5f717a7bf0f$var$_QCuo);
    if (input[$45e1a5f717a7bf0f$var$_AQRD] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_AQRD, String(input[$45e1a5f717a7bf0f$var$_AQRD])).n($45e1a5f717a7bf0f$var$_AQRD));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_CSVOutput = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_CSVO);
    bn.cc(input, $45e1a5f717a7bf0f$var$_QF);
    bn.cc(input, $45e1a5f717a7bf0f$var$_QEC);
    bn.cc(input, $45e1a5f717a7bf0f$var$_RD);
    bn.cc(input, $45e1a5f717a7bf0f$var$_FD);
    bn.cc(input, $45e1a5f717a7bf0f$var$_QCuo);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_DefaultRetention = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_DRe);
    if (input[$45e1a5f717a7bf0f$var$_Mo] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OLRM, input[$45e1a5f717a7bf0f$var$_Mo]).n($45e1a5f717a7bf0f$var$_Mo));
    if (input[$45e1a5f717a7bf0f$var$_Da] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Da, String(input[$45e1a5f717a7bf0f$var$_Da])).n($45e1a5f717a7bf0f$var$_Da));
    if (input[$45e1a5f717a7bf0f$var$_Y] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Y, String(input[$45e1a5f717a7bf0f$var$_Y])).n($45e1a5f717a7bf0f$var$_Y));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Delete = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_Del);
    bn.l(input, "Objects", "Object", ()=>$45e1a5f717a7bf0f$var$se_ObjectIdentifierList(input[$45e1a5f717a7bf0f$var$_Ob], context));
    if (input[$45e1a5f717a7bf0f$var$_Q] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Q, String(input[$45e1a5f717a7bf0f$var$_Q])).n($45e1a5f717a7bf0f$var$_Q));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_DeleteMarkerReplication = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_DMR);
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_DMRS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Destination = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_Des);
    if (input[$45e1a5f717a7bf0f$var$_B] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_BN, input[$45e1a5f717a7bf0f$var$_B]).n($45e1a5f717a7bf0f$var$_B));
    if (input[$45e1a5f717a7bf0f$var$_Ac] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_AIc, input[$45e1a5f717a7bf0f$var$_Ac]).n($45e1a5f717a7bf0f$var$_Ac));
    bn.cc(input, $45e1a5f717a7bf0f$var$_SC);
    if (input[$45e1a5f717a7bf0f$var$_ACT] != null) bn.c($45e1a5f717a7bf0f$var$se_AccessControlTranslation(input[$45e1a5f717a7bf0f$var$_ACT], context).n($45e1a5f717a7bf0f$var$_ACT));
    if (input[$45e1a5f717a7bf0f$var$_ECn] != null) bn.c($45e1a5f717a7bf0f$var$se_EncryptionConfiguration(input[$45e1a5f717a7bf0f$var$_ECn], context).n($45e1a5f717a7bf0f$var$_ECn));
    if (input[$45e1a5f717a7bf0f$var$_RTe] != null) bn.c($45e1a5f717a7bf0f$var$se_ReplicationTime(input[$45e1a5f717a7bf0f$var$_RTe], context).n($45e1a5f717a7bf0f$var$_RTe));
    if (input[$45e1a5f717a7bf0f$var$_Me] != null) bn.c($45e1a5f717a7bf0f$var$se_Metrics(input[$45e1a5f717a7bf0f$var$_Me], context).n($45e1a5f717a7bf0f$var$_Me));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Encryption = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_En);
    if (input[$45e1a5f717a7bf0f$var$_ETn] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_SSE, input[$45e1a5f717a7bf0f$var$_ETn]).n($45e1a5f717a7bf0f$var$_ETn));
    if (input[$45e1a5f717a7bf0f$var$_KMSKI] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_SSEKMSKI, input[$45e1a5f717a7bf0f$var$_KMSKI]).n($45e1a5f717a7bf0f$var$_KMSKI));
    bn.cc(input, $45e1a5f717a7bf0f$var$_KMSC);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_EncryptionConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ECn);
    bn.cc(input, $45e1a5f717a7bf0f$var$_RKKID);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ErrorDocument = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ED);
    if (input[$45e1a5f717a7bf0f$var$_K] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OK, input[$45e1a5f717a7bf0f$var$_K]).n($45e1a5f717a7bf0f$var$_K));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_EventBridgeConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_EBC);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_EventList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = (0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Ev, entry);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_ExistingObjectReplication = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_EOR);
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_EORS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ExposeHeaders = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = (0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_EHx, entry);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_FilterRule = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_FR);
    if (input[$45e1a5f717a7bf0f$var$_N] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_FRN, input[$45e1a5f717a7bf0f$var$_N]).n($45e1a5f717a7bf0f$var$_N));
    if (input[$45e1a5f717a7bf0f$var$_Va] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_FRV, input[$45e1a5f717a7bf0f$var$_Va]).n($45e1a5f717a7bf0f$var$_Va));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_FilterRuleList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_FilterRule(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_GlacierJobParameters = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_GJP);
    bn.cc(input, $45e1a5f717a7bf0f$var$_Ti);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Grant = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_G);
    if (input[$45e1a5f717a7bf0f$var$_Gra] != null) {
        const n = $45e1a5f717a7bf0f$var$se_Grantee(input[$45e1a5f717a7bf0f$var$_Gra], context).n($45e1a5f717a7bf0f$var$_Gra);
        n.a("xmlns:xsi", "http://www.w3.org/2001/XMLSchema-instance");
        bn.c(n);
    }
    bn.cc(input, $45e1a5f717a7bf0f$var$_Pe);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Grantee = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_Gra);
    bn.cc(input, $45e1a5f717a7bf0f$var$_DN);
    bn.cc(input, $45e1a5f717a7bf0f$var$_EA);
    bn.cc(input, $45e1a5f717a7bf0f$var$_ID_);
    bn.cc(input, $45e1a5f717a7bf0f$var$_URI);
    bn.a("xsi:type", input[$45e1a5f717a7bf0f$var$_Ty]);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Grants = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_Grant(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_G);
    });
};
const $45e1a5f717a7bf0f$var$se_IndexDocument = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ID);
    bn.cc(input, $45e1a5f717a7bf0f$var$_Su);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_InputSerialization = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_IS);
    if (input[$45e1a5f717a7bf0f$var$_CSV] != null) bn.c($45e1a5f717a7bf0f$var$se_CSVInput(input[$45e1a5f717a7bf0f$var$_CSV], context).n($45e1a5f717a7bf0f$var$_CSV));
    bn.cc(input, $45e1a5f717a7bf0f$var$_CTom);
    if (input[$45e1a5f717a7bf0f$var$_JSON] != null) bn.c($45e1a5f717a7bf0f$var$se_JSONInput(input[$45e1a5f717a7bf0f$var$_JSON], context).n($45e1a5f717a7bf0f$var$_JSON));
    if (input[$45e1a5f717a7bf0f$var$_Parq] != null) bn.c($45e1a5f717a7bf0f$var$se_ParquetInput(input[$45e1a5f717a7bf0f$var$_Parq], context).n($45e1a5f717a7bf0f$var$_Parq));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_IntelligentTieringAndOperator = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ITAO);
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    bn.l(input, "Tags", "Tag", ()=>$45e1a5f717a7bf0f$var$se_TagSet(input[$45e1a5f717a7bf0f$var$_Tag], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_IntelligentTieringConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ITC);
    if (input[$45e1a5f717a7bf0f$var$_I] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_ITI, input[$45e1a5f717a7bf0f$var$_I]).n($45e1a5f717a7bf0f$var$_I));
    if (input[$45e1a5f717a7bf0f$var$_F] != null) bn.c($45e1a5f717a7bf0f$var$se_IntelligentTieringFilter(input[$45e1a5f717a7bf0f$var$_F], context).n($45e1a5f717a7bf0f$var$_F));
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_ITS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    bn.l(input, "Tierings", "Tiering", ()=>$45e1a5f717a7bf0f$var$se_TieringList(input[$45e1a5f717a7bf0f$var$_Tie], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_IntelligentTieringFilter = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ITF);
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    if (input[$45e1a5f717a7bf0f$var$_Ta] != null) bn.c($45e1a5f717a7bf0f$var$se_Tag(input[$45e1a5f717a7bf0f$var$_Ta], context).n($45e1a5f717a7bf0f$var$_Ta));
    if (input[$45e1a5f717a7bf0f$var$_A] != null) bn.c($45e1a5f717a7bf0f$var$se_IntelligentTieringAndOperator(input[$45e1a5f717a7bf0f$var$_A], context).n($45e1a5f717a7bf0f$var$_A));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_InventoryConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_IC);
    if (input[$45e1a5f717a7bf0f$var$_Des] != null) bn.c($45e1a5f717a7bf0f$var$se_InventoryDestination(input[$45e1a5f717a7bf0f$var$_Des], context).n($45e1a5f717a7bf0f$var$_Des));
    if (input[$45e1a5f717a7bf0f$var$_IE] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_IE, String(input[$45e1a5f717a7bf0f$var$_IE])).n($45e1a5f717a7bf0f$var$_IE));
    if (input[$45e1a5f717a7bf0f$var$_F] != null) bn.c($45e1a5f717a7bf0f$var$se_InventoryFilter(input[$45e1a5f717a7bf0f$var$_F], context).n($45e1a5f717a7bf0f$var$_F));
    if (input[$45e1a5f717a7bf0f$var$_I] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_II, input[$45e1a5f717a7bf0f$var$_I]).n($45e1a5f717a7bf0f$var$_I));
    if (input[$45e1a5f717a7bf0f$var$_IOV] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_IIOV, input[$45e1a5f717a7bf0f$var$_IOV]).n($45e1a5f717a7bf0f$var$_IOV));
    bn.lc(input, "OptionalFields", "OptionalFields", ()=>$45e1a5f717a7bf0f$var$se_InventoryOptionalFields(input[$45e1a5f717a7bf0f$var$_OF], context));
    if (input[$45e1a5f717a7bf0f$var$_Sc] != null) bn.c($45e1a5f717a7bf0f$var$se_InventorySchedule(input[$45e1a5f717a7bf0f$var$_Sc], context).n($45e1a5f717a7bf0f$var$_Sc));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_InventoryDestination = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_IDn);
    if (input[$45e1a5f717a7bf0f$var$_SBD] != null) bn.c($45e1a5f717a7bf0f$var$se_InventoryS3BucketDestination(input[$45e1a5f717a7bf0f$var$_SBD], context).n($45e1a5f717a7bf0f$var$_SBD));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_InventoryEncryption = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_IEn);
    if (input[$45e1a5f717a7bf0f$var$_SSES] != null) bn.c($45e1a5f717a7bf0f$var$se_SSES3(input[$45e1a5f717a7bf0f$var$_SSES], context).n($45e1a5f717a7bf0f$var$_SS));
    if (input[$45e1a5f717a7bf0f$var$_SSEKMS] != null) bn.c($45e1a5f717a7bf0f$var$se_SSEKMS(input[$45e1a5f717a7bf0f$var$_SSEKMS], context).n($45e1a5f717a7bf0f$var$_SK));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_InventoryFilter = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_IF);
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_InventoryOptionalFields = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = (0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_IOF, entry);
        return n.n($45e1a5f717a7bf0f$var$_Fi);
    });
};
const $45e1a5f717a7bf0f$var$se_InventoryS3BucketDestination = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ISBD);
    bn.cc(input, $45e1a5f717a7bf0f$var$_AIc);
    if (input[$45e1a5f717a7bf0f$var$_B] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_BN, input[$45e1a5f717a7bf0f$var$_B]).n($45e1a5f717a7bf0f$var$_B));
    if (input[$45e1a5f717a7bf0f$var$_Fo] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_IFn, input[$45e1a5f717a7bf0f$var$_Fo]).n($45e1a5f717a7bf0f$var$_Fo));
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    if (input[$45e1a5f717a7bf0f$var$_En] != null) bn.c($45e1a5f717a7bf0f$var$se_InventoryEncryption(input[$45e1a5f717a7bf0f$var$_En], context).n($45e1a5f717a7bf0f$var$_En));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_InventorySchedule = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ISn);
    if (input[$45e1a5f717a7bf0f$var$_Fr] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_IFnv, input[$45e1a5f717a7bf0f$var$_Fr]).n($45e1a5f717a7bf0f$var$_Fr));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_JSONInput = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_JSONI);
    if (input[$45e1a5f717a7bf0f$var$_Ty] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_JSONT, input[$45e1a5f717a7bf0f$var$_Ty]).n($45e1a5f717a7bf0f$var$_Ty));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_JSONOutput = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_JSONO);
    bn.cc(input, $45e1a5f717a7bf0f$var$_RD);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_LambdaFunctionConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_LFCa);
    if (input[$45e1a5f717a7bf0f$var$_I] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_NI, input[$45e1a5f717a7bf0f$var$_I]).n($45e1a5f717a7bf0f$var$_I));
    if (input[$45e1a5f717a7bf0f$var$_LFA] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_LFA, input[$45e1a5f717a7bf0f$var$_LFA]).n($45e1a5f717a7bf0f$var$_CF));
    bn.l(input, "Events", "Event", ()=>$45e1a5f717a7bf0f$var$se_EventList(input[$45e1a5f717a7bf0f$var$_Eve], context));
    if (input[$45e1a5f717a7bf0f$var$_F] != null) bn.c($45e1a5f717a7bf0f$var$se_NotificationConfigurationFilter(input[$45e1a5f717a7bf0f$var$_F], context).n($45e1a5f717a7bf0f$var$_F));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_LambdaFunctionConfigurationList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_LambdaFunctionConfiguration(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_LifecycleExpiration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_LEi);
    if (input[$45e1a5f717a7bf0f$var$_Dat] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Dat, (0, $65a9c6a67b0b3f34$export$93f3a0dd288ea1c8)(input[$45e1a5f717a7bf0f$var$_Dat]).toString()).n($45e1a5f717a7bf0f$var$_Dat));
    if (input[$45e1a5f717a7bf0f$var$_Da] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Da, String(input[$45e1a5f717a7bf0f$var$_Da])).n($45e1a5f717a7bf0f$var$_Da));
    if (input[$45e1a5f717a7bf0f$var$_EODM] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_EODM, String(input[$45e1a5f717a7bf0f$var$_EODM])).n($45e1a5f717a7bf0f$var$_EODM));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_LifecycleRule = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_LR);
    if (input[$45e1a5f717a7bf0f$var$_Exp] != null) bn.c($45e1a5f717a7bf0f$var$se_LifecycleExpiration(input[$45e1a5f717a7bf0f$var$_Exp], context).n($45e1a5f717a7bf0f$var$_Exp));
    bn.cc(input, $45e1a5f717a7bf0f$var$_ID_);
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    if (input[$45e1a5f717a7bf0f$var$_F] != null) bn.c($45e1a5f717a7bf0f$var$se_LifecycleRuleFilter(input[$45e1a5f717a7bf0f$var$_F], context).n($45e1a5f717a7bf0f$var$_F));
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_ESx, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    bn.l(input, "Transitions", "Transition", ()=>$45e1a5f717a7bf0f$var$se_TransitionList(input[$45e1a5f717a7bf0f$var$_Tr], context));
    bn.l(input, "NoncurrentVersionTransitions", "NoncurrentVersionTransition", ()=>$45e1a5f717a7bf0f$var$se_NoncurrentVersionTransitionList(input[$45e1a5f717a7bf0f$var$_NVT], context));
    if (input[$45e1a5f717a7bf0f$var$_NVE] != null) bn.c($45e1a5f717a7bf0f$var$se_NoncurrentVersionExpiration(input[$45e1a5f717a7bf0f$var$_NVE], context).n($45e1a5f717a7bf0f$var$_NVE));
    if (input[$45e1a5f717a7bf0f$var$_AIMU] != null) bn.c($45e1a5f717a7bf0f$var$se_AbortIncompleteMultipartUpload(input[$45e1a5f717a7bf0f$var$_AIMU], context).n($45e1a5f717a7bf0f$var$_AIMU));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_LifecycleRuleAndOperator = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_LRAO);
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    bn.l(input, "Tags", "Tag", ()=>$45e1a5f717a7bf0f$var$se_TagSet(input[$45e1a5f717a7bf0f$var$_Tag], context));
    if (input[$45e1a5f717a7bf0f$var$_OSGT] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OSGTB, String(input[$45e1a5f717a7bf0f$var$_OSGT])).n($45e1a5f717a7bf0f$var$_OSGT));
    if (input[$45e1a5f717a7bf0f$var$_OSLT] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OSLTB, String(input[$45e1a5f717a7bf0f$var$_OSLT])).n($45e1a5f717a7bf0f$var$_OSLT));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_LifecycleRuleFilter = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_LRF);
    (0, $b50962978b66428d$export$4338dba1e93ddaf4).visit(input, {
        Prefix: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_P] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_P, value).n($45e1a5f717a7bf0f$var$_P));
        },
        Tag: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_Ta] != null) bn.c($45e1a5f717a7bf0f$var$se_Tag(value, context).n($45e1a5f717a7bf0f$var$_Ta));
        },
        ObjectSizeGreaterThan: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_OSGT] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OSGTB, String(value)).n($45e1a5f717a7bf0f$var$_OSGT));
        },
        ObjectSizeLessThan: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_OSLT] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OSLTB, String(value)).n($45e1a5f717a7bf0f$var$_OSLT));
        },
        And: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_A] != null) bn.c($45e1a5f717a7bf0f$var$se_LifecycleRuleAndOperator(value, context).n($45e1a5f717a7bf0f$var$_A));
        },
        _: (name, value)=>{
            if (!(value instanceof (0, $44a0d59c11863d38$export$e775a15d806cbddc) || value instanceof (0, $0c5f967439148a05$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bn.c(new (0, $44a0d59c11863d38$export$e775a15d806cbddc)(name).c(value));
        }
    });
    return bn;
};
const $45e1a5f717a7bf0f$var$se_LifecycleRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_LifecycleRule(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_LocationInfo = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_LI);
    if (input[$45e1a5f717a7bf0f$var$_Ty] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_LT, input[$45e1a5f717a7bf0f$var$_Ty]).n($45e1a5f717a7bf0f$var$_Ty));
    if (input[$45e1a5f717a7bf0f$var$_N] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_LNAS, input[$45e1a5f717a7bf0f$var$_N]).n($45e1a5f717a7bf0f$var$_N));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_LoggingEnabled = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_LE);
    bn.cc(input, $45e1a5f717a7bf0f$var$_TB);
    bn.lc(input, "TargetGrants", "TargetGrants", ()=>$45e1a5f717a7bf0f$var$se_TargetGrants(input[$45e1a5f717a7bf0f$var$_TG], context));
    bn.cc(input, $45e1a5f717a7bf0f$var$_TP);
    if (input[$45e1a5f717a7bf0f$var$_TOKF] != null) bn.c($45e1a5f717a7bf0f$var$se_TargetObjectKeyFormat(input[$45e1a5f717a7bf0f$var$_TOKF], context).n($45e1a5f717a7bf0f$var$_TOKF));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_MetadataEntry = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_ME);
    if (input[$45e1a5f717a7bf0f$var$_N] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_MKe, input[$45e1a5f717a7bf0f$var$_N]).n($45e1a5f717a7bf0f$var$_N));
    if (input[$45e1a5f717a7bf0f$var$_Va] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_MV, input[$45e1a5f717a7bf0f$var$_Va]).n($45e1a5f717a7bf0f$var$_Va));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Metrics = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_Me);
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_MS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    if (input[$45e1a5f717a7bf0f$var$_ETv] != null) bn.c($45e1a5f717a7bf0f$var$se_ReplicationTimeValue(input[$45e1a5f717a7bf0f$var$_ETv], context).n($45e1a5f717a7bf0f$var$_ETv));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_MetricsAndOperator = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_MAO);
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    bn.l(input, "Tags", "Tag", ()=>$45e1a5f717a7bf0f$var$se_TagSet(input[$45e1a5f717a7bf0f$var$_Tag], context));
    bn.cc(input, $45e1a5f717a7bf0f$var$_APAc);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_MetricsConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_MC);
    if (input[$45e1a5f717a7bf0f$var$_I] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_MI, input[$45e1a5f717a7bf0f$var$_I]).n($45e1a5f717a7bf0f$var$_I));
    if (input[$45e1a5f717a7bf0f$var$_F] != null) bn.c($45e1a5f717a7bf0f$var$se_MetricsFilter(input[$45e1a5f717a7bf0f$var$_F], context).n($45e1a5f717a7bf0f$var$_F));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_MetricsFilter = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_MF);
    (0, $b50962978b66428d$export$564a1f9c338cae45).visit(input, {
        Prefix: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_P] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_P, value).n($45e1a5f717a7bf0f$var$_P));
        },
        Tag: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_Ta] != null) bn.c($45e1a5f717a7bf0f$var$se_Tag(value, context).n($45e1a5f717a7bf0f$var$_Ta));
        },
        AccessPointArn: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_APAc] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_APAc, value).n($45e1a5f717a7bf0f$var$_APAc));
        },
        And: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_A] != null) bn.c($45e1a5f717a7bf0f$var$se_MetricsAndOperator(value, context).n($45e1a5f717a7bf0f$var$_A));
        },
        _: (name, value)=>{
            if (!(value instanceof (0, $44a0d59c11863d38$export$e775a15d806cbddc) || value instanceof (0, $0c5f967439148a05$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bn.c(new (0, $44a0d59c11863d38$export$e775a15d806cbddc)(name).c(value));
        }
    });
    return bn;
};
const $45e1a5f717a7bf0f$var$se_NoncurrentVersionExpiration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_NVE);
    if (input[$45e1a5f717a7bf0f$var$_ND] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Da, String(input[$45e1a5f717a7bf0f$var$_ND])).n($45e1a5f717a7bf0f$var$_ND));
    if (input[$45e1a5f717a7bf0f$var$_NNV] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_VC, String(input[$45e1a5f717a7bf0f$var$_NNV])).n($45e1a5f717a7bf0f$var$_NNV));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_NoncurrentVersionTransition = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_NVTo);
    if (input[$45e1a5f717a7bf0f$var$_ND] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Da, String(input[$45e1a5f717a7bf0f$var$_ND])).n($45e1a5f717a7bf0f$var$_ND));
    if (input[$45e1a5f717a7bf0f$var$_SC] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_TSC, input[$45e1a5f717a7bf0f$var$_SC]).n($45e1a5f717a7bf0f$var$_SC));
    if (input[$45e1a5f717a7bf0f$var$_NNV] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_VC, String(input[$45e1a5f717a7bf0f$var$_NNV])).n($45e1a5f717a7bf0f$var$_NNV));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_NoncurrentVersionTransitionList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_NoncurrentVersionTransition(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_NotificationConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_NC);
    bn.l(input, "TopicConfigurations", "TopicConfiguration", ()=>$45e1a5f717a7bf0f$var$se_TopicConfigurationList(input[$45e1a5f717a7bf0f$var$_TCop], context));
    bn.l(input, "QueueConfigurations", "QueueConfiguration", ()=>$45e1a5f717a7bf0f$var$se_QueueConfigurationList(input[$45e1a5f717a7bf0f$var$_QCu], context));
    bn.l(input, "LambdaFunctionConfigurations", "CloudFunctionConfiguration", ()=>$45e1a5f717a7bf0f$var$se_LambdaFunctionConfigurationList(input[$45e1a5f717a7bf0f$var$_LFC], context));
    if (input[$45e1a5f717a7bf0f$var$_EBC] != null) bn.c($45e1a5f717a7bf0f$var$se_EventBridgeConfiguration(input[$45e1a5f717a7bf0f$var$_EBC], context).n($45e1a5f717a7bf0f$var$_EBC));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_NotificationConfigurationFilter = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_NCF);
    if (input[$45e1a5f717a7bf0f$var$_K] != null) bn.c($45e1a5f717a7bf0f$var$se_S3KeyFilter(input[$45e1a5f717a7bf0f$var$_K], context).n($45e1a5f717a7bf0f$var$_SKe));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ObjectIdentifier = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_OI);
    if (input[$45e1a5f717a7bf0f$var$_K] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OK, input[$45e1a5f717a7bf0f$var$_K]).n($45e1a5f717a7bf0f$var$_K));
    if (input[$45e1a5f717a7bf0f$var$_VI] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OVI, input[$45e1a5f717a7bf0f$var$_VI]).n($45e1a5f717a7bf0f$var$_VI));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ObjectIdentifierList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_ObjectIdentifier(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_ObjectLockConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_OLC);
    bn.cc(input, $45e1a5f717a7bf0f$var$_OLE);
    if (input[$45e1a5f717a7bf0f$var$_Ru] != null) bn.c($45e1a5f717a7bf0f$var$se_ObjectLockRule(input[$45e1a5f717a7bf0f$var$_Ru], context).n($45e1a5f717a7bf0f$var$_Ru));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ObjectLockLegalHold = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_OLLH);
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OLLHS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ObjectLockRetention = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_OLR);
    if (input[$45e1a5f717a7bf0f$var$_Mo] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OLRM, input[$45e1a5f717a7bf0f$var$_Mo]).n($45e1a5f717a7bf0f$var$_Mo));
    if (input[$45e1a5f717a7bf0f$var$_RUD] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Dat, (0, $65a9c6a67b0b3f34$export$93f3a0dd288ea1c8)(input[$45e1a5f717a7bf0f$var$_RUD]).toString()).n($45e1a5f717a7bf0f$var$_RUD));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ObjectLockRule = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_OLRb);
    if (input[$45e1a5f717a7bf0f$var$_DRe] != null) bn.c($45e1a5f717a7bf0f$var$se_DefaultRetention(input[$45e1a5f717a7bf0f$var$_DRe], context).n($45e1a5f717a7bf0f$var$_DRe));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_OutputLocation = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_OL);
    if (input[$45e1a5f717a7bf0f$var$_S_] != null) bn.c($45e1a5f717a7bf0f$var$se_S3Location(input[$45e1a5f717a7bf0f$var$_S_], context).n($45e1a5f717a7bf0f$var$_S_));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_OutputSerialization = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_OS);
    if (input[$45e1a5f717a7bf0f$var$_CSV] != null) bn.c($45e1a5f717a7bf0f$var$se_CSVOutput(input[$45e1a5f717a7bf0f$var$_CSV], context).n($45e1a5f717a7bf0f$var$_CSV));
    if (input[$45e1a5f717a7bf0f$var$_JSON] != null) bn.c($45e1a5f717a7bf0f$var$se_JSONOutput(input[$45e1a5f717a7bf0f$var$_JSON], context).n($45e1a5f717a7bf0f$var$_JSON));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Owner = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_O);
    bn.cc(input, $45e1a5f717a7bf0f$var$_DN);
    bn.cc(input, $45e1a5f717a7bf0f$var$_ID_);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_OwnershipControls = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_OC);
    bn.l(input, "Rules", "Rule", ()=>$45e1a5f717a7bf0f$var$se_OwnershipControlsRules(input[$45e1a5f717a7bf0f$var$_Rul], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_OwnershipControlsRule = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_OCR);
    bn.cc(input, $45e1a5f717a7bf0f$var$_OO);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_OwnershipControlsRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_OwnershipControlsRule(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_ParquetInput = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_PI);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_PartitionedPrefix = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_PP);
    bn.cc(input, $45e1a5f717a7bf0f$var$_PDS);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_PublicAccessBlockConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_PABC);
    if (input[$45e1a5f717a7bf0f$var$_BPA] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Se, String(input[$45e1a5f717a7bf0f$var$_BPA])).n($45e1a5f717a7bf0f$var$_BPA));
    if (input[$45e1a5f717a7bf0f$var$_IPA] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Se, String(input[$45e1a5f717a7bf0f$var$_IPA])).n($45e1a5f717a7bf0f$var$_IPA));
    if (input[$45e1a5f717a7bf0f$var$_BPP] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Se, String(input[$45e1a5f717a7bf0f$var$_BPP])).n($45e1a5f717a7bf0f$var$_BPP));
    if (input[$45e1a5f717a7bf0f$var$_RPB] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Se, String(input[$45e1a5f717a7bf0f$var$_RPB])).n($45e1a5f717a7bf0f$var$_RPB));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_QueueConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_QC);
    if (input[$45e1a5f717a7bf0f$var$_I] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_NI, input[$45e1a5f717a7bf0f$var$_I]).n($45e1a5f717a7bf0f$var$_I));
    if (input[$45e1a5f717a7bf0f$var$_QA] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_QA, input[$45e1a5f717a7bf0f$var$_QA]).n($45e1a5f717a7bf0f$var$_Qu));
    bn.l(input, "Events", "Event", ()=>$45e1a5f717a7bf0f$var$se_EventList(input[$45e1a5f717a7bf0f$var$_Eve], context));
    if (input[$45e1a5f717a7bf0f$var$_F] != null) bn.c($45e1a5f717a7bf0f$var$se_NotificationConfigurationFilter(input[$45e1a5f717a7bf0f$var$_F], context).n($45e1a5f717a7bf0f$var$_F));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_QueueConfigurationList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_QueueConfiguration(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_Redirect = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_Red);
    bn.cc(input, $45e1a5f717a7bf0f$var$_HN);
    bn.cc(input, $45e1a5f717a7bf0f$var$_HRC);
    bn.cc(input, $45e1a5f717a7bf0f$var$_Pr);
    bn.cc(input, $45e1a5f717a7bf0f$var$_RKPW);
    bn.cc(input, $45e1a5f717a7bf0f$var$_RKW);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_RedirectAllRequestsTo = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RART);
    bn.cc(input, $45e1a5f717a7bf0f$var$_HN);
    bn.cc(input, $45e1a5f717a7bf0f$var$_Pr);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ReplicaModifications = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RM);
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_RMS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ReplicationConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RCe);
    bn.cc(input, $45e1a5f717a7bf0f$var$_Ro);
    bn.l(input, "Rules", "Rule", ()=>$45e1a5f717a7bf0f$var$se_ReplicationRules(input[$45e1a5f717a7bf0f$var$_Rul], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ReplicationRule = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RRe);
    bn.cc(input, $45e1a5f717a7bf0f$var$_ID_);
    if (input[$45e1a5f717a7bf0f$var$_Pri] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Pri, String(input[$45e1a5f717a7bf0f$var$_Pri])).n($45e1a5f717a7bf0f$var$_Pri));
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    if (input[$45e1a5f717a7bf0f$var$_F] != null) bn.c($45e1a5f717a7bf0f$var$se_ReplicationRuleFilter(input[$45e1a5f717a7bf0f$var$_F], context).n($45e1a5f717a7bf0f$var$_F));
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_RRS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    if (input[$45e1a5f717a7bf0f$var$_SSC] != null) bn.c($45e1a5f717a7bf0f$var$se_SourceSelectionCriteria(input[$45e1a5f717a7bf0f$var$_SSC], context).n($45e1a5f717a7bf0f$var$_SSC));
    if (input[$45e1a5f717a7bf0f$var$_EOR] != null) bn.c($45e1a5f717a7bf0f$var$se_ExistingObjectReplication(input[$45e1a5f717a7bf0f$var$_EOR], context).n($45e1a5f717a7bf0f$var$_EOR));
    if (input[$45e1a5f717a7bf0f$var$_Des] != null) bn.c($45e1a5f717a7bf0f$var$se_Destination(input[$45e1a5f717a7bf0f$var$_Des], context).n($45e1a5f717a7bf0f$var$_Des));
    if (input[$45e1a5f717a7bf0f$var$_DMR] != null) bn.c($45e1a5f717a7bf0f$var$se_DeleteMarkerReplication(input[$45e1a5f717a7bf0f$var$_DMR], context).n($45e1a5f717a7bf0f$var$_DMR));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ReplicationRuleAndOperator = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RRAO);
    bn.cc(input, $45e1a5f717a7bf0f$var$_P);
    bn.l(input, "Tags", "Tag", ()=>$45e1a5f717a7bf0f$var$se_TagSet(input[$45e1a5f717a7bf0f$var$_Tag], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ReplicationRuleFilter = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RRF);
    (0, $b50962978b66428d$export$c5652b893758d9eb).visit(input, {
        Prefix: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_P] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_P, value).n($45e1a5f717a7bf0f$var$_P));
        },
        Tag: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_Ta] != null) bn.c($45e1a5f717a7bf0f$var$se_Tag(value, context).n($45e1a5f717a7bf0f$var$_Ta));
        },
        And: (value)=>{
            if (input[$45e1a5f717a7bf0f$var$_A] != null) bn.c($45e1a5f717a7bf0f$var$se_ReplicationRuleAndOperator(value, context).n($45e1a5f717a7bf0f$var$_A));
        },
        _: (name, value)=>{
            if (!(value instanceof (0, $44a0d59c11863d38$export$e775a15d806cbddc) || value instanceof (0, $0c5f967439148a05$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bn.c(new (0, $44a0d59c11863d38$export$e775a15d806cbddc)(name).c(value));
        }
    });
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ReplicationRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_ReplicationRule(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_ReplicationTime = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RTe);
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_RTS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    if (input[$45e1a5f717a7bf0f$var$_Tim] != null) bn.c($45e1a5f717a7bf0f$var$se_ReplicationTimeValue(input[$45e1a5f717a7bf0f$var$_Tim], context).n($45e1a5f717a7bf0f$var$_Tim));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ReplicationTimeValue = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RTV);
    if (input[$45e1a5f717a7bf0f$var$_Mi] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Mi, String(input[$45e1a5f717a7bf0f$var$_Mi])).n($45e1a5f717a7bf0f$var$_Mi));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_RequestPaymentConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RPC);
    bn.cc(input, $45e1a5f717a7bf0f$var$_Pa);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_RequestProgress = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RPe);
    if (input[$45e1a5f717a7bf0f$var$_Ena] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_ERP, String(input[$45e1a5f717a7bf0f$var$_Ena])).n($45e1a5f717a7bf0f$var$_Ena));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_RestoreRequest = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RRes);
    if (input[$45e1a5f717a7bf0f$var$_Da] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Da, String(input[$45e1a5f717a7bf0f$var$_Da])).n($45e1a5f717a7bf0f$var$_Da));
    if (input[$45e1a5f717a7bf0f$var$_GJP] != null) bn.c($45e1a5f717a7bf0f$var$se_GlacierJobParameters(input[$45e1a5f717a7bf0f$var$_GJP], context).n($45e1a5f717a7bf0f$var$_GJP));
    if (input[$45e1a5f717a7bf0f$var$_Ty] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_RRT, input[$45e1a5f717a7bf0f$var$_Ty]).n($45e1a5f717a7bf0f$var$_Ty));
    bn.cc(input, $45e1a5f717a7bf0f$var$_Ti);
    bn.cc(input, $45e1a5f717a7bf0f$var$_Desc);
    if (input[$45e1a5f717a7bf0f$var$_SP] != null) bn.c($45e1a5f717a7bf0f$var$se_SelectParameters(input[$45e1a5f717a7bf0f$var$_SP], context).n($45e1a5f717a7bf0f$var$_SP));
    if (input[$45e1a5f717a7bf0f$var$_OL] != null) bn.c($45e1a5f717a7bf0f$var$se_OutputLocation(input[$45e1a5f717a7bf0f$var$_OL], context).n($45e1a5f717a7bf0f$var$_OL));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_RoutingRule = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_RRou);
    if (input[$45e1a5f717a7bf0f$var$_Con] != null) bn.c($45e1a5f717a7bf0f$var$se_Condition(input[$45e1a5f717a7bf0f$var$_Con], context).n($45e1a5f717a7bf0f$var$_Con));
    if (input[$45e1a5f717a7bf0f$var$_Red] != null) bn.c($45e1a5f717a7bf0f$var$se_Redirect(input[$45e1a5f717a7bf0f$var$_Red], context).n($45e1a5f717a7bf0f$var$_Red));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_RoutingRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_RoutingRule(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_RRou);
    });
};
const $45e1a5f717a7bf0f$var$se_S3KeyFilter = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SKF);
    bn.l(input, "FilterRules", "FilterRule", ()=>$45e1a5f717a7bf0f$var$se_FilterRuleList(input[$45e1a5f717a7bf0f$var$_FRi], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_S3Location = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SL);
    bn.cc(input, $45e1a5f717a7bf0f$var$_BN);
    if (input[$45e1a5f717a7bf0f$var$_P] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_LP, input[$45e1a5f717a7bf0f$var$_P]).n($45e1a5f717a7bf0f$var$_P));
    if (input[$45e1a5f717a7bf0f$var$_En] != null) bn.c($45e1a5f717a7bf0f$var$se_Encryption(input[$45e1a5f717a7bf0f$var$_En], context).n($45e1a5f717a7bf0f$var$_En));
    if (input[$45e1a5f717a7bf0f$var$_CACL] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OCACL, input[$45e1a5f717a7bf0f$var$_CACL]).n($45e1a5f717a7bf0f$var$_CACL));
    bn.lc(input, "AccessControlList", "AccessControlList", ()=>$45e1a5f717a7bf0f$var$se_Grants(input[$45e1a5f717a7bf0f$var$_ACLc], context));
    if (input[$45e1a5f717a7bf0f$var$_T] != null) bn.c($45e1a5f717a7bf0f$var$se_Tagging(input[$45e1a5f717a7bf0f$var$_T], context).n($45e1a5f717a7bf0f$var$_T));
    bn.lc(input, "UserMetadata", "UserMetadata", ()=>$45e1a5f717a7bf0f$var$se_UserMetadata(input[$45e1a5f717a7bf0f$var$_UM], context));
    bn.cc(input, $45e1a5f717a7bf0f$var$_SC);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ScanRange = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SR);
    if (input[$45e1a5f717a7bf0f$var$_St] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_St, String(input[$45e1a5f717a7bf0f$var$_St])).n($45e1a5f717a7bf0f$var$_St));
    if (input[$45e1a5f717a7bf0f$var$_End] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_End, String(input[$45e1a5f717a7bf0f$var$_End])).n($45e1a5f717a7bf0f$var$_End));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_SelectParameters = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SP);
    if (input[$45e1a5f717a7bf0f$var$_IS] != null) bn.c($45e1a5f717a7bf0f$var$se_InputSerialization(input[$45e1a5f717a7bf0f$var$_IS], context).n($45e1a5f717a7bf0f$var$_IS));
    bn.cc(input, $45e1a5f717a7bf0f$var$_ETx);
    bn.cc(input, $45e1a5f717a7bf0f$var$_Ex);
    if (input[$45e1a5f717a7bf0f$var$_OS] != null) bn.c($45e1a5f717a7bf0f$var$se_OutputSerialization(input[$45e1a5f717a7bf0f$var$_OS], context).n($45e1a5f717a7bf0f$var$_OS));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ServerSideEncryptionByDefault = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SSEBD);
    if (input[$45e1a5f717a7bf0f$var$_SSEA] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_SSE, input[$45e1a5f717a7bf0f$var$_SSEA]).n($45e1a5f717a7bf0f$var$_SSEA));
    if (input[$45e1a5f717a7bf0f$var$_KMSMKID] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_SSEKMSKI, input[$45e1a5f717a7bf0f$var$_KMSMKID]).n($45e1a5f717a7bf0f$var$_KMSMKID));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ServerSideEncryptionConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SSEC);
    bn.l(input, "Rules", "Rule", ()=>$45e1a5f717a7bf0f$var$se_ServerSideEncryptionRules(input[$45e1a5f717a7bf0f$var$_Rul], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ServerSideEncryptionRule = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SSER);
    if (input[$45e1a5f717a7bf0f$var$_ASSEBD] != null) bn.c($45e1a5f717a7bf0f$var$se_ServerSideEncryptionByDefault(input[$45e1a5f717a7bf0f$var$_ASSEBD], context).n($45e1a5f717a7bf0f$var$_ASSEBD));
    if (input[$45e1a5f717a7bf0f$var$_BKE] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_BKE, String(input[$45e1a5f717a7bf0f$var$_BKE])).n($45e1a5f717a7bf0f$var$_BKE));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_ServerSideEncryptionRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_ServerSideEncryptionRule(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_SimplePrefix = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SPi);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_SourceSelectionCriteria = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SSC);
    if (input[$45e1a5f717a7bf0f$var$_SKEO] != null) bn.c($45e1a5f717a7bf0f$var$se_SseKmsEncryptedObjects(input[$45e1a5f717a7bf0f$var$_SKEO], context).n($45e1a5f717a7bf0f$var$_SKEO));
    if (input[$45e1a5f717a7bf0f$var$_RM] != null) bn.c($45e1a5f717a7bf0f$var$se_ReplicaModifications(input[$45e1a5f717a7bf0f$var$_RM], context).n($45e1a5f717a7bf0f$var$_RM));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_SSEKMS = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SK);
    if (input[$45e1a5f717a7bf0f$var$_KI] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_SSEKMSKI, input[$45e1a5f717a7bf0f$var$_KI]).n($45e1a5f717a7bf0f$var$_KI));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_SseKmsEncryptedObjects = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SKEO);
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_SKEOS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_SSES3 = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SS);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_StorageClassAnalysis = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SCA);
    if (input[$45e1a5f717a7bf0f$var$_DE] != null) bn.c($45e1a5f717a7bf0f$var$se_StorageClassAnalysisDataExport(input[$45e1a5f717a7bf0f$var$_DE], context).n($45e1a5f717a7bf0f$var$_DE));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_StorageClassAnalysisDataExport = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_SCADE);
    if (input[$45e1a5f717a7bf0f$var$_OSV] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_SCASV, input[$45e1a5f717a7bf0f$var$_OSV]).n($45e1a5f717a7bf0f$var$_OSV));
    if (input[$45e1a5f717a7bf0f$var$_Des] != null) bn.c($45e1a5f717a7bf0f$var$se_AnalyticsExportDestination(input[$45e1a5f717a7bf0f$var$_Des], context).n($45e1a5f717a7bf0f$var$_Des));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Tag = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_Ta);
    if (input[$45e1a5f717a7bf0f$var$_K] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_OK, input[$45e1a5f717a7bf0f$var$_K]).n($45e1a5f717a7bf0f$var$_K));
    bn.cc(input, $45e1a5f717a7bf0f$var$_Va);
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Tagging = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_T);
    bn.lc(input, "TagSet", "TagSet", ()=>$45e1a5f717a7bf0f$var$se_TagSet(input[$45e1a5f717a7bf0f$var$_TS], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_TagSet = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_Tag(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_Ta);
    });
};
const $45e1a5f717a7bf0f$var$se_TargetGrant = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_TGa);
    if (input[$45e1a5f717a7bf0f$var$_Gra] != null) {
        const n = $45e1a5f717a7bf0f$var$se_Grantee(input[$45e1a5f717a7bf0f$var$_Gra], context).n($45e1a5f717a7bf0f$var$_Gra);
        n.a("xmlns:xsi", "http://www.w3.org/2001/XMLSchema-instance");
        bn.c(n);
    }
    if (input[$45e1a5f717a7bf0f$var$_Pe] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_BLP, input[$45e1a5f717a7bf0f$var$_Pe]).n($45e1a5f717a7bf0f$var$_Pe));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_TargetGrants = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_TargetGrant(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_G);
    });
};
const $45e1a5f717a7bf0f$var$se_TargetObjectKeyFormat = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_TOKF);
    if (input[$45e1a5f717a7bf0f$var$_SPi] != null) bn.c($45e1a5f717a7bf0f$var$se_SimplePrefix(input[$45e1a5f717a7bf0f$var$_SPi], context).n($45e1a5f717a7bf0f$var$_SPi));
    if (input[$45e1a5f717a7bf0f$var$_PP] != null) bn.c($45e1a5f717a7bf0f$var$se_PartitionedPrefix(input[$45e1a5f717a7bf0f$var$_PP], context).n($45e1a5f717a7bf0f$var$_PP));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_Tiering = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_Tier);
    if (input[$45e1a5f717a7bf0f$var$_Da] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_ITD, String(input[$45e1a5f717a7bf0f$var$_Da])).n($45e1a5f717a7bf0f$var$_Da));
    if (input[$45e1a5f717a7bf0f$var$_AT] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_ITAT, input[$45e1a5f717a7bf0f$var$_AT]).n($45e1a5f717a7bf0f$var$_AT));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_TieringList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_Tiering(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_TopicConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_TCo);
    if (input[$45e1a5f717a7bf0f$var$_I] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_NI, input[$45e1a5f717a7bf0f$var$_I]).n($45e1a5f717a7bf0f$var$_I));
    if (input[$45e1a5f717a7bf0f$var$_TA] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_TA, input[$45e1a5f717a7bf0f$var$_TA]).n($45e1a5f717a7bf0f$var$_Top));
    bn.l(input, "Events", "Event", ()=>$45e1a5f717a7bf0f$var$se_EventList(input[$45e1a5f717a7bf0f$var$_Eve], context));
    if (input[$45e1a5f717a7bf0f$var$_F] != null) bn.c($45e1a5f717a7bf0f$var$se_NotificationConfigurationFilter(input[$45e1a5f717a7bf0f$var$_F], context).n($45e1a5f717a7bf0f$var$_F));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_TopicConfigurationList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_TopicConfiguration(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_Transition = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_Tra);
    if (input[$45e1a5f717a7bf0f$var$_Dat] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Dat, (0, $65a9c6a67b0b3f34$export$93f3a0dd288ea1c8)(input[$45e1a5f717a7bf0f$var$_Dat]).toString()).n($45e1a5f717a7bf0f$var$_Dat));
    if (input[$45e1a5f717a7bf0f$var$_Da] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_Da, String(input[$45e1a5f717a7bf0f$var$_Da])).n($45e1a5f717a7bf0f$var$_Da));
    if (input[$45e1a5f717a7bf0f$var$_SC] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_TSC, input[$45e1a5f717a7bf0f$var$_SC]).n($45e1a5f717a7bf0f$var$_SC));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_TransitionList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_Transition(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_me);
    });
};
const $45e1a5f717a7bf0f$var$se_UserMetadata = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const n = $45e1a5f717a7bf0f$var$se_MetadataEntry(entry, context);
        return n.n($45e1a5f717a7bf0f$var$_ME);
    });
};
const $45e1a5f717a7bf0f$var$se_VersioningConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_VCe);
    if (input[$45e1a5f717a7bf0f$var$_MFAD] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_MFAD, input[$45e1a5f717a7bf0f$var$_MFAD]).n($45e1a5f717a7bf0f$var$_MDf));
    if (input[$45e1a5f717a7bf0f$var$_S] != null) bn.c((0, $44a0d59c11863d38$export$e775a15d806cbddc).of($45e1a5f717a7bf0f$var$_BVS, input[$45e1a5f717a7bf0f$var$_S]).n($45e1a5f717a7bf0f$var$_S));
    return bn;
};
const $45e1a5f717a7bf0f$var$se_WebsiteConfiguration = (input, context)=>{
    const bn = new (0, $44a0d59c11863d38$export$e775a15d806cbddc)($45e1a5f717a7bf0f$var$_WC);
    if (input[$45e1a5f717a7bf0f$var$_ED] != null) bn.c($45e1a5f717a7bf0f$var$se_ErrorDocument(input[$45e1a5f717a7bf0f$var$_ED], context).n($45e1a5f717a7bf0f$var$_ED));
    if (input[$45e1a5f717a7bf0f$var$_ID] != null) bn.c($45e1a5f717a7bf0f$var$se_IndexDocument(input[$45e1a5f717a7bf0f$var$_ID], context).n($45e1a5f717a7bf0f$var$_ID));
    if (input[$45e1a5f717a7bf0f$var$_RART] != null) bn.c($45e1a5f717a7bf0f$var$se_RedirectAllRequestsTo(input[$45e1a5f717a7bf0f$var$_RART], context).n($45e1a5f717a7bf0f$var$_RART));
    bn.lc(input, "RoutingRules", "RoutingRules", ()=>$45e1a5f717a7bf0f$var$se_RoutingRules(input[$45e1a5f717a7bf0f$var$_RRo], context));
    return bn;
};
const $45e1a5f717a7bf0f$var$de_AbortIncompleteMultipartUpload = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_DAI] != null) contents[$45e1a5f717a7bf0f$var$_DAI] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_DAI]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_AccessControlTranslation = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_O] != null) contents[$45e1a5f717a7bf0f$var$_O] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_O]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_AllowedHeaders = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(entry);
    });
};
const $45e1a5f717a7bf0f$var$de_AllowedMethods = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(entry);
    });
};
const $45e1a5f717a7bf0f$var$de_AllowedOrigins = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(entry);
    });
};
const $45e1a5f717a7bf0f$var$de_AnalyticsAndOperator = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    if (output.Tag === "") contents[$45e1a5f717a7bf0f$var$_Tag] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ta] != null) contents[$45e1a5f717a7bf0f$var$_Tag] = $45e1a5f717a7bf0f$var$de_TagSet((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ta]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_AnalyticsConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_I] != null) contents[$45e1a5f717a7bf0f$var$_I] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_I]);
    if (output.Filter === "") ;
    else if (output[$45e1a5f717a7bf0f$var$_F] != null) contents[$45e1a5f717a7bf0f$var$_F] = $45e1a5f717a7bf0f$var$de_AnalyticsFilter((0, $ffdcd55bd2051dc8$export$9ef77073e45b6301)(output[$45e1a5f717a7bf0f$var$_F]), context);
    if (output[$45e1a5f717a7bf0f$var$_SCA] != null) contents[$45e1a5f717a7bf0f$var$_SCA] = $45e1a5f717a7bf0f$var$de_StorageClassAnalysis(output[$45e1a5f717a7bf0f$var$_SCA], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_AnalyticsConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_AnalyticsConfiguration(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_AnalyticsExportDestination = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_SBD] != null) contents[$45e1a5f717a7bf0f$var$_SBD] = $45e1a5f717a7bf0f$var$de_AnalyticsS3BucketDestination(output[$45e1a5f717a7bf0f$var$_SBD], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_AnalyticsFilter = (output, context)=>{
    if (output[$45e1a5f717a7bf0f$var$_P] != null) return {
        Prefix: (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P])
    };
    if (output[$45e1a5f717a7bf0f$var$_Ta] != null) return {
        Tag: $45e1a5f717a7bf0f$var$de_Tag(output[$45e1a5f717a7bf0f$var$_Ta], context)
    };
    if (output[$45e1a5f717a7bf0f$var$_A] != null) return {
        And: $45e1a5f717a7bf0f$var$de_AnalyticsAndOperator(output[$45e1a5f717a7bf0f$var$_A], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $45e1a5f717a7bf0f$var$de_AnalyticsS3BucketDestination = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Fo] != null) contents[$45e1a5f717a7bf0f$var$_Fo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Fo]);
    if (output[$45e1a5f717a7bf0f$var$_BAI] != null) contents[$45e1a5f717a7bf0f$var$_BAI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_BAI]);
    if (output[$45e1a5f717a7bf0f$var$_B] != null) contents[$45e1a5f717a7bf0f$var$_B] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_B]);
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Bucket = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_N] != null) contents[$45e1a5f717a7bf0f$var$_N] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_N]);
    if (output[$45e1a5f717a7bf0f$var$_CDr] != null) contents[$45e1a5f717a7bf0f$var$_CDr] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_CDr]));
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Buckets = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_Bucket(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_Checksum = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_CCRC] != null) contents[$45e1a5f717a7bf0f$var$_CCRC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRC]);
    if (output[$45e1a5f717a7bf0f$var$_CCRCC] != null) contents[$45e1a5f717a7bf0f$var$_CCRCC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRCC]);
    if (output[$45e1a5f717a7bf0f$var$_CSHA] != null) contents[$45e1a5f717a7bf0f$var$_CSHA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHA]);
    if (output[$45e1a5f717a7bf0f$var$_CSHAh] != null) contents[$45e1a5f717a7bf0f$var$_CSHAh] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHAh]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ChecksumAlgorithmList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(entry);
    });
};
const $45e1a5f717a7bf0f$var$de_CommonPrefix = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_CommonPrefixList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_CommonPrefix(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_Condition = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_HECRE] != null) contents[$45e1a5f717a7bf0f$var$_HECRE] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_HECRE]);
    if (output[$45e1a5f717a7bf0f$var$_KPE] != null) contents[$45e1a5f717a7bf0f$var$_KPE] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_KPE]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ContinuationEvent = (output, context)=>{
    const contents = {};
    return contents;
};
const $45e1a5f717a7bf0f$var$de_CopyObjectResult = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_ETa] != null) contents[$45e1a5f717a7bf0f$var$_ETa] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ETa]);
    if (output[$45e1a5f717a7bf0f$var$_LM] != null) contents[$45e1a5f717a7bf0f$var$_LM] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_LM]));
    if (output[$45e1a5f717a7bf0f$var$_CCRC] != null) contents[$45e1a5f717a7bf0f$var$_CCRC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRC]);
    if (output[$45e1a5f717a7bf0f$var$_CCRCC] != null) contents[$45e1a5f717a7bf0f$var$_CCRCC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRCC]);
    if (output[$45e1a5f717a7bf0f$var$_CSHA] != null) contents[$45e1a5f717a7bf0f$var$_CSHA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHA]);
    if (output[$45e1a5f717a7bf0f$var$_CSHAh] != null) contents[$45e1a5f717a7bf0f$var$_CSHAh] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHAh]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_CopyPartResult = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_ETa] != null) contents[$45e1a5f717a7bf0f$var$_ETa] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ETa]);
    if (output[$45e1a5f717a7bf0f$var$_LM] != null) contents[$45e1a5f717a7bf0f$var$_LM] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_LM]));
    if (output[$45e1a5f717a7bf0f$var$_CCRC] != null) contents[$45e1a5f717a7bf0f$var$_CCRC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRC]);
    if (output[$45e1a5f717a7bf0f$var$_CCRCC] != null) contents[$45e1a5f717a7bf0f$var$_CCRCC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRCC]);
    if (output[$45e1a5f717a7bf0f$var$_CSHA] != null) contents[$45e1a5f717a7bf0f$var$_CSHA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHA]);
    if (output[$45e1a5f717a7bf0f$var$_CSHAh] != null) contents[$45e1a5f717a7bf0f$var$_CSHAh] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHAh]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_CORSRule = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_ID_] != null) contents[$45e1a5f717a7bf0f$var$_ID_] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ID_]);
    if (output.AllowedHeader === "") contents[$45e1a5f717a7bf0f$var$_AHl] = [];
    else if (output[$45e1a5f717a7bf0f$var$_AH] != null) contents[$45e1a5f717a7bf0f$var$_AHl] = $45e1a5f717a7bf0f$var$de_AllowedHeaders((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_AH]), context);
    if (output.AllowedMethod === "") contents[$45e1a5f717a7bf0f$var$_AMl] = [];
    else if (output[$45e1a5f717a7bf0f$var$_AM] != null) contents[$45e1a5f717a7bf0f$var$_AMl] = $45e1a5f717a7bf0f$var$de_AllowedMethods((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_AM]), context);
    if (output.AllowedOrigin === "") contents[$45e1a5f717a7bf0f$var$_AOl] = [];
    else if (output[$45e1a5f717a7bf0f$var$_AO] != null) contents[$45e1a5f717a7bf0f$var$_AOl] = $45e1a5f717a7bf0f$var$de_AllowedOrigins((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_AO]), context);
    if (output.ExposeHeader === "") contents[$45e1a5f717a7bf0f$var$_EH] = [];
    else if (output[$45e1a5f717a7bf0f$var$_EHx] != null) contents[$45e1a5f717a7bf0f$var$_EH] = $45e1a5f717a7bf0f$var$de_ExposeHeaders((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_EHx]), context);
    if (output[$45e1a5f717a7bf0f$var$_MAS] != null) contents[$45e1a5f717a7bf0f$var$_MAS] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_MAS]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_CORSRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_CORSRule(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_DefaultRetention = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Mo] != null) contents[$45e1a5f717a7bf0f$var$_Mo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Mo]);
    if (output[$45e1a5f717a7bf0f$var$_Da] != null) contents[$45e1a5f717a7bf0f$var$_Da] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_Da]);
    if (output[$45e1a5f717a7bf0f$var$_Y] != null) contents[$45e1a5f717a7bf0f$var$_Y] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_Y]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_DeletedObject = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_K]);
    if (output[$45e1a5f717a7bf0f$var$_VI] != null) contents[$45e1a5f717a7bf0f$var$_VI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_VI]);
    if (output[$45e1a5f717a7bf0f$var$_DM] != null) contents[$45e1a5f717a7bf0f$var$_DM] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_DM]);
    if (output[$45e1a5f717a7bf0f$var$_DMVI] != null) contents[$45e1a5f717a7bf0f$var$_DMVI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_DMVI]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_DeletedObjects = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_DeletedObject(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_DeleteMarkerEntry = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_O] != null) contents[$45e1a5f717a7bf0f$var$_O] = $45e1a5f717a7bf0f$var$de_Owner(output[$45e1a5f717a7bf0f$var$_O], context);
    if (output[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_K]);
    if (output[$45e1a5f717a7bf0f$var$_VI] != null) contents[$45e1a5f717a7bf0f$var$_VI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_VI]);
    if (output[$45e1a5f717a7bf0f$var$_IL] != null) contents[$45e1a5f717a7bf0f$var$_IL] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_IL]);
    if (output[$45e1a5f717a7bf0f$var$_LM] != null) contents[$45e1a5f717a7bf0f$var$_LM] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_LM]));
    return contents;
};
const $45e1a5f717a7bf0f$var$de_DeleteMarkerReplication = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_DeleteMarkers = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_DeleteMarkerEntry(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_Destination = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_B] != null) contents[$45e1a5f717a7bf0f$var$_B] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_B]);
    if (output[$45e1a5f717a7bf0f$var$_Ac] != null) contents[$45e1a5f717a7bf0f$var$_Ac] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Ac]);
    if (output[$45e1a5f717a7bf0f$var$_SC] != null) contents[$45e1a5f717a7bf0f$var$_SC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_SC]);
    if (output[$45e1a5f717a7bf0f$var$_ACT] != null) contents[$45e1a5f717a7bf0f$var$_ACT] = $45e1a5f717a7bf0f$var$de_AccessControlTranslation(output[$45e1a5f717a7bf0f$var$_ACT], context);
    if (output[$45e1a5f717a7bf0f$var$_ECn] != null) contents[$45e1a5f717a7bf0f$var$_ECn] = $45e1a5f717a7bf0f$var$de_EncryptionConfiguration(output[$45e1a5f717a7bf0f$var$_ECn], context);
    if (output[$45e1a5f717a7bf0f$var$_RTe] != null) contents[$45e1a5f717a7bf0f$var$_RTe] = $45e1a5f717a7bf0f$var$de_ReplicationTime(output[$45e1a5f717a7bf0f$var$_RTe], context);
    if (output[$45e1a5f717a7bf0f$var$_Me] != null) contents[$45e1a5f717a7bf0f$var$_Me] = $45e1a5f717a7bf0f$var$de_Metrics(output[$45e1a5f717a7bf0f$var$_Me], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_EncryptionConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_RKKID] != null) contents[$45e1a5f717a7bf0f$var$_RKKID] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_RKKID]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_EndEvent = (output, context)=>{
    const contents = {};
    return contents;
};
const $45e1a5f717a7bf0f$var$de__Error = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_K]);
    if (output[$45e1a5f717a7bf0f$var$_VI] != null) contents[$45e1a5f717a7bf0f$var$_VI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_VI]);
    if (output[$45e1a5f717a7bf0f$var$_Cod] != null) contents[$45e1a5f717a7bf0f$var$_Cod] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Cod]);
    if (output[$45e1a5f717a7bf0f$var$_Mes] != null) contents[$45e1a5f717a7bf0f$var$_Mes] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Mes]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ErrorDocument = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_K]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Errors = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de__Error(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_EventBridgeConfiguration = (output, context)=>{
    const contents = {};
    return contents;
};
const $45e1a5f717a7bf0f$var$de_EventList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(entry);
    });
};
const $45e1a5f717a7bf0f$var$de_ExistingObjectReplication = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ExposeHeaders = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(entry);
    });
};
const $45e1a5f717a7bf0f$var$de_FilterRule = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_N] != null) contents[$45e1a5f717a7bf0f$var$_N] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_N]);
    if (output[$45e1a5f717a7bf0f$var$_Va] != null) contents[$45e1a5f717a7bf0f$var$_Va] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Va]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_FilterRuleList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_FilterRule(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_GetObjectAttributesParts = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_PC] != null) contents[$45e1a5f717a7bf0f$var$_TPC] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_PC]);
    if (output[$45e1a5f717a7bf0f$var$_PNM] != null) contents[$45e1a5f717a7bf0f$var$_PNM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_PNM]);
    if (output[$45e1a5f717a7bf0f$var$_NPNM] != null) contents[$45e1a5f717a7bf0f$var$_NPNM] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_NPNM]);
    if (output[$45e1a5f717a7bf0f$var$_MP] != null) contents[$45e1a5f717a7bf0f$var$_MP] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_MP]);
    if (output[$45e1a5f717a7bf0f$var$_IT] != null) contents[$45e1a5f717a7bf0f$var$_IT] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_IT]);
    if (output.Part === "") contents[$45e1a5f717a7bf0f$var$_Part] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Par] != null) contents[$45e1a5f717a7bf0f$var$_Part] = $45e1a5f717a7bf0f$var$de_PartsList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Par]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Grant = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Gra] != null) contents[$45e1a5f717a7bf0f$var$_Gra] = $45e1a5f717a7bf0f$var$de_Grantee(output[$45e1a5f717a7bf0f$var$_Gra], context);
    if (output[$45e1a5f717a7bf0f$var$_Pe] != null) contents[$45e1a5f717a7bf0f$var$_Pe] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Pe]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Grantee = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_DN] != null) contents[$45e1a5f717a7bf0f$var$_DN] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_DN]);
    if (output[$45e1a5f717a7bf0f$var$_EA] != null) contents[$45e1a5f717a7bf0f$var$_EA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_EA]);
    if (output[$45e1a5f717a7bf0f$var$_ID_] != null) contents[$45e1a5f717a7bf0f$var$_ID_] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ID_]);
    if (output[$45e1a5f717a7bf0f$var$_URI] != null) contents[$45e1a5f717a7bf0f$var$_URI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_URI]);
    if (output[$45e1a5f717a7bf0f$var$_x] != null) contents[$45e1a5f717a7bf0f$var$_Ty] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_x]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Grants = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_Grant(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_IndexDocument = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Su] != null) contents[$45e1a5f717a7bf0f$var$_Su] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Su]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Initiator = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_ID_] != null) contents[$45e1a5f717a7bf0f$var$_ID_] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ID_]);
    if (output[$45e1a5f717a7bf0f$var$_DN] != null) contents[$45e1a5f717a7bf0f$var$_DN] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_DN]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_IntelligentTieringAndOperator = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    if (output.Tag === "") contents[$45e1a5f717a7bf0f$var$_Tag] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ta] != null) contents[$45e1a5f717a7bf0f$var$_Tag] = $45e1a5f717a7bf0f$var$de_TagSet((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ta]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_IntelligentTieringConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_I] != null) contents[$45e1a5f717a7bf0f$var$_I] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_I]);
    if (output[$45e1a5f717a7bf0f$var$_F] != null) contents[$45e1a5f717a7bf0f$var$_F] = $45e1a5f717a7bf0f$var$de_IntelligentTieringFilter(output[$45e1a5f717a7bf0f$var$_F], context);
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    if (output.Tiering === "") contents[$45e1a5f717a7bf0f$var$_Tie] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Tier] != null) contents[$45e1a5f717a7bf0f$var$_Tie] = $45e1a5f717a7bf0f$var$de_TieringList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Tier]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_IntelligentTieringConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_IntelligentTieringConfiguration(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_IntelligentTieringFilter = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    if (output[$45e1a5f717a7bf0f$var$_Ta] != null) contents[$45e1a5f717a7bf0f$var$_Ta] = $45e1a5f717a7bf0f$var$de_Tag(output[$45e1a5f717a7bf0f$var$_Ta], context);
    if (output[$45e1a5f717a7bf0f$var$_A] != null) contents[$45e1a5f717a7bf0f$var$_A] = $45e1a5f717a7bf0f$var$de_IntelligentTieringAndOperator(output[$45e1a5f717a7bf0f$var$_A], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_InventoryConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Des] != null) contents[$45e1a5f717a7bf0f$var$_Des] = $45e1a5f717a7bf0f$var$de_InventoryDestination(output[$45e1a5f717a7bf0f$var$_Des], context);
    if (output[$45e1a5f717a7bf0f$var$_IE] != null) contents[$45e1a5f717a7bf0f$var$_IE] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_IE]);
    if (output[$45e1a5f717a7bf0f$var$_F] != null) contents[$45e1a5f717a7bf0f$var$_F] = $45e1a5f717a7bf0f$var$de_InventoryFilter(output[$45e1a5f717a7bf0f$var$_F], context);
    if (output[$45e1a5f717a7bf0f$var$_I] != null) contents[$45e1a5f717a7bf0f$var$_I] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_I]);
    if (output[$45e1a5f717a7bf0f$var$_IOV] != null) contents[$45e1a5f717a7bf0f$var$_IOV] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_IOV]);
    if (output.OptionalFields === "") contents[$45e1a5f717a7bf0f$var$_OF] = [];
    else if (output[$45e1a5f717a7bf0f$var$_OF] != null && output[$45e1a5f717a7bf0f$var$_OF][$45e1a5f717a7bf0f$var$_Fi] != null) contents[$45e1a5f717a7bf0f$var$_OF] = $45e1a5f717a7bf0f$var$de_InventoryOptionalFields((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_OF][$45e1a5f717a7bf0f$var$_Fi]), context);
    if (output[$45e1a5f717a7bf0f$var$_Sc] != null) contents[$45e1a5f717a7bf0f$var$_Sc] = $45e1a5f717a7bf0f$var$de_InventorySchedule(output[$45e1a5f717a7bf0f$var$_Sc], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_InventoryConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_InventoryConfiguration(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_InventoryDestination = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_SBD] != null) contents[$45e1a5f717a7bf0f$var$_SBD] = $45e1a5f717a7bf0f$var$de_InventoryS3BucketDestination(output[$45e1a5f717a7bf0f$var$_SBD], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_InventoryEncryption = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_SS] != null) contents[$45e1a5f717a7bf0f$var$_SSES] = $45e1a5f717a7bf0f$var$de_SSES3(output[$45e1a5f717a7bf0f$var$_SS], context);
    if (output[$45e1a5f717a7bf0f$var$_SK] != null) contents[$45e1a5f717a7bf0f$var$_SSEKMS] = $45e1a5f717a7bf0f$var$de_SSEKMS(output[$45e1a5f717a7bf0f$var$_SK], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_InventoryFilter = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_InventoryOptionalFields = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(entry);
    });
};
const $45e1a5f717a7bf0f$var$de_InventoryS3BucketDestination = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_AIc] != null) contents[$45e1a5f717a7bf0f$var$_AIc] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_AIc]);
    if (output[$45e1a5f717a7bf0f$var$_B] != null) contents[$45e1a5f717a7bf0f$var$_B] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_B]);
    if (output[$45e1a5f717a7bf0f$var$_Fo] != null) contents[$45e1a5f717a7bf0f$var$_Fo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Fo]);
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    if (output[$45e1a5f717a7bf0f$var$_En] != null) contents[$45e1a5f717a7bf0f$var$_En] = $45e1a5f717a7bf0f$var$de_InventoryEncryption(output[$45e1a5f717a7bf0f$var$_En], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_InventorySchedule = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Fr] != null) contents[$45e1a5f717a7bf0f$var$_Fr] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Fr]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_LambdaFunctionConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_I] != null) contents[$45e1a5f717a7bf0f$var$_I] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_I]);
    if (output[$45e1a5f717a7bf0f$var$_CF] != null) contents[$45e1a5f717a7bf0f$var$_LFA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CF]);
    if (output.Event === "") contents[$45e1a5f717a7bf0f$var$_Eve] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ev] != null) contents[$45e1a5f717a7bf0f$var$_Eve] = $45e1a5f717a7bf0f$var$de_EventList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ev]), context);
    if (output[$45e1a5f717a7bf0f$var$_F] != null) contents[$45e1a5f717a7bf0f$var$_F] = $45e1a5f717a7bf0f$var$de_NotificationConfigurationFilter(output[$45e1a5f717a7bf0f$var$_F], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_LambdaFunctionConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_LambdaFunctionConfiguration(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_LifecycleExpiration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Dat] != null) contents[$45e1a5f717a7bf0f$var$_Dat] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_Dat]));
    if (output[$45e1a5f717a7bf0f$var$_Da] != null) contents[$45e1a5f717a7bf0f$var$_Da] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_Da]);
    if (output[$45e1a5f717a7bf0f$var$_EODM] != null) contents[$45e1a5f717a7bf0f$var$_EODM] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_EODM]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_LifecycleRule = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Exp] != null) contents[$45e1a5f717a7bf0f$var$_Exp] = $45e1a5f717a7bf0f$var$de_LifecycleExpiration(output[$45e1a5f717a7bf0f$var$_Exp], context);
    if (output[$45e1a5f717a7bf0f$var$_ID_] != null) contents[$45e1a5f717a7bf0f$var$_ID_] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ID_]);
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    if (output.Filter === "") ;
    else if (output[$45e1a5f717a7bf0f$var$_F] != null) contents[$45e1a5f717a7bf0f$var$_F] = $45e1a5f717a7bf0f$var$de_LifecycleRuleFilter((0, $ffdcd55bd2051dc8$export$9ef77073e45b6301)(output[$45e1a5f717a7bf0f$var$_F]), context);
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    if (output.Transition === "") contents[$45e1a5f717a7bf0f$var$_Tr] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Tra] != null) contents[$45e1a5f717a7bf0f$var$_Tr] = $45e1a5f717a7bf0f$var$de_TransitionList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Tra]), context);
    if (output.NoncurrentVersionTransition === "") contents[$45e1a5f717a7bf0f$var$_NVT] = [];
    else if (output[$45e1a5f717a7bf0f$var$_NVTo] != null) contents[$45e1a5f717a7bf0f$var$_NVT] = $45e1a5f717a7bf0f$var$de_NoncurrentVersionTransitionList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_NVTo]), context);
    if (output[$45e1a5f717a7bf0f$var$_NVE] != null) contents[$45e1a5f717a7bf0f$var$_NVE] = $45e1a5f717a7bf0f$var$de_NoncurrentVersionExpiration(output[$45e1a5f717a7bf0f$var$_NVE], context);
    if (output[$45e1a5f717a7bf0f$var$_AIMU] != null) contents[$45e1a5f717a7bf0f$var$_AIMU] = $45e1a5f717a7bf0f$var$de_AbortIncompleteMultipartUpload(output[$45e1a5f717a7bf0f$var$_AIMU], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_LifecycleRuleAndOperator = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    if (output.Tag === "") contents[$45e1a5f717a7bf0f$var$_Tag] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ta] != null) contents[$45e1a5f717a7bf0f$var$_Tag] = $45e1a5f717a7bf0f$var$de_TagSet((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ta]), context);
    if (output[$45e1a5f717a7bf0f$var$_OSGT] != null) contents[$45e1a5f717a7bf0f$var$_OSGT] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_OSGT]);
    if (output[$45e1a5f717a7bf0f$var$_OSLT] != null) contents[$45e1a5f717a7bf0f$var$_OSLT] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_OSLT]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_LifecycleRuleFilter = (output, context)=>{
    if (output[$45e1a5f717a7bf0f$var$_P] != null) return {
        Prefix: (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P])
    };
    if (output[$45e1a5f717a7bf0f$var$_Ta] != null) return {
        Tag: $45e1a5f717a7bf0f$var$de_Tag(output[$45e1a5f717a7bf0f$var$_Ta], context)
    };
    if (output[$45e1a5f717a7bf0f$var$_OSGT] != null) return {
        ObjectSizeGreaterThan: (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_OSGT])
    };
    if (output[$45e1a5f717a7bf0f$var$_OSLT] != null) return {
        ObjectSizeLessThan: (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_OSLT])
    };
    if (output[$45e1a5f717a7bf0f$var$_A] != null) return {
        And: $45e1a5f717a7bf0f$var$de_LifecycleRuleAndOperator(output[$45e1a5f717a7bf0f$var$_A], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $45e1a5f717a7bf0f$var$de_LifecycleRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_LifecycleRule(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_LoggingEnabled = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_TB] != null) contents[$45e1a5f717a7bf0f$var$_TB] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_TB]);
    if (output.TargetGrants === "") contents[$45e1a5f717a7bf0f$var$_TG] = [];
    else if (output[$45e1a5f717a7bf0f$var$_TG] != null && output[$45e1a5f717a7bf0f$var$_TG][$45e1a5f717a7bf0f$var$_G] != null) contents[$45e1a5f717a7bf0f$var$_TG] = $45e1a5f717a7bf0f$var$de_TargetGrants((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_TG][$45e1a5f717a7bf0f$var$_G]), context);
    if (output[$45e1a5f717a7bf0f$var$_TP] != null) contents[$45e1a5f717a7bf0f$var$_TP] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_TP]);
    if (output[$45e1a5f717a7bf0f$var$_TOKF] != null) contents[$45e1a5f717a7bf0f$var$_TOKF] = $45e1a5f717a7bf0f$var$de_TargetObjectKeyFormat(output[$45e1a5f717a7bf0f$var$_TOKF], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Metrics = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    if (output[$45e1a5f717a7bf0f$var$_ETv] != null) contents[$45e1a5f717a7bf0f$var$_ETv] = $45e1a5f717a7bf0f$var$de_ReplicationTimeValue(output[$45e1a5f717a7bf0f$var$_ETv], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_MetricsAndOperator = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    if (output.Tag === "") contents[$45e1a5f717a7bf0f$var$_Tag] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ta] != null) contents[$45e1a5f717a7bf0f$var$_Tag] = $45e1a5f717a7bf0f$var$de_TagSet((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ta]), context);
    if (output[$45e1a5f717a7bf0f$var$_APAc] != null) contents[$45e1a5f717a7bf0f$var$_APAc] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_APAc]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_MetricsConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_I] != null) contents[$45e1a5f717a7bf0f$var$_I] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_I]);
    if (output.Filter === "") ;
    else if (output[$45e1a5f717a7bf0f$var$_F] != null) contents[$45e1a5f717a7bf0f$var$_F] = $45e1a5f717a7bf0f$var$de_MetricsFilter((0, $ffdcd55bd2051dc8$export$9ef77073e45b6301)(output[$45e1a5f717a7bf0f$var$_F]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_MetricsConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_MetricsConfiguration(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_MetricsFilter = (output, context)=>{
    if (output[$45e1a5f717a7bf0f$var$_P] != null) return {
        Prefix: (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P])
    };
    if (output[$45e1a5f717a7bf0f$var$_Ta] != null) return {
        Tag: $45e1a5f717a7bf0f$var$de_Tag(output[$45e1a5f717a7bf0f$var$_Ta], context)
    };
    if (output[$45e1a5f717a7bf0f$var$_APAc] != null) return {
        AccessPointArn: (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_APAc])
    };
    if (output[$45e1a5f717a7bf0f$var$_A] != null) return {
        And: $45e1a5f717a7bf0f$var$de_MetricsAndOperator(output[$45e1a5f717a7bf0f$var$_A], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $45e1a5f717a7bf0f$var$de_MultipartUpload = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_UI] != null) contents[$45e1a5f717a7bf0f$var$_UI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_UI]);
    if (output[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_K]);
    if (output[$45e1a5f717a7bf0f$var$_Ini] != null) contents[$45e1a5f717a7bf0f$var$_Ini] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_Ini]));
    if (output[$45e1a5f717a7bf0f$var$_SC] != null) contents[$45e1a5f717a7bf0f$var$_SC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_SC]);
    if (output[$45e1a5f717a7bf0f$var$_O] != null) contents[$45e1a5f717a7bf0f$var$_O] = $45e1a5f717a7bf0f$var$de_Owner(output[$45e1a5f717a7bf0f$var$_O], context);
    if (output[$45e1a5f717a7bf0f$var$_In] != null) contents[$45e1a5f717a7bf0f$var$_In] = $45e1a5f717a7bf0f$var$de_Initiator(output[$45e1a5f717a7bf0f$var$_In], context);
    if (output[$45e1a5f717a7bf0f$var$_CA] != null) contents[$45e1a5f717a7bf0f$var$_CA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CA]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_MultipartUploadList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_MultipartUpload(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_NoncurrentVersionExpiration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_ND] != null) contents[$45e1a5f717a7bf0f$var$_ND] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_ND]);
    if (output[$45e1a5f717a7bf0f$var$_NNV] != null) contents[$45e1a5f717a7bf0f$var$_NNV] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_NNV]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_NoncurrentVersionTransition = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_ND] != null) contents[$45e1a5f717a7bf0f$var$_ND] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_ND]);
    if (output[$45e1a5f717a7bf0f$var$_SC] != null) contents[$45e1a5f717a7bf0f$var$_SC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_SC]);
    if (output[$45e1a5f717a7bf0f$var$_NNV] != null) contents[$45e1a5f717a7bf0f$var$_NNV] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_NNV]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_NoncurrentVersionTransitionList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_NoncurrentVersionTransition(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_NotificationConfigurationFilter = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_SKe] != null) contents[$45e1a5f717a7bf0f$var$_K] = $45e1a5f717a7bf0f$var$de_S3KeyFilter(output[$45e1a5f717a7bf0f$var$_SKe], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de__Object = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_K]);
    if (output[$45e1a5f717a7bf0f$var$_LM] != null) contents[$45e1a5f717a7bf0f$var$_LM] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_LM]));
    if (output[$45e1a5f717a7bf0f$var$_ETa] != null) contents[$45e1a5f717a7bf0f$var$_ETa] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ETa]);
    if (output.ChecksumAlgorithm === "") contents[$45e1a5f717a7bf0f$var$_CA] = [];
    else if (output[$45e1a5f717a7bf0f$var$_CA] != null) contents[$45e1a5f717a7bf0f$var$_CA] = $45e1a5f717a7bf0f$var$de_ChecksumAlgorithmList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_CA]), context);
    if (output[$45e1a5f717a7bf0f$var$_Si] != null) contents[$45e1a5f717a7bf0f$var$_Si] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_Si]);
    if (output[$45e1a5f717a7bf0f$var$_SC] != null) contents[$45e1a5f717a7bf0f$var$_SC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_SC]);
    if (output[$45e1a5f717a7bf0f$var$_O] != null) contents[$45e1a5f717a7bf0f$var$_O] = $45e1a5f717a7bf0f$var$de_Owner(output[$45e1a5f717a7bf0f$var$_O], context);
    if (output[$45e1a5f717a7bf0f$var$_RSe] != null) contents[$45e1a5f717a7bf0f$var$_RSe] = $45e1a5f717a7bf0f$var$de_RestoreStatus(output[$45e1a5f717a7bf0f$var$_RSe], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ObjectList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de__Object(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_ObjectLockConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_OLE] != null) contents[$45e1a5f717a7bf0f$var$_OLE] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_OLE]);
    if (output[$45e1a5f717a7bf0f$var$_Ru] != null) contents[$45e1a5f717a7bf0f$var$_Ru] = $45e1a5f717a7bf0f$var$de_ObjectLockRule(output[$45e1a5f717a7bf0f$var$_Ru], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ObjectLockLegalHold = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ObjectLockRetention = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Mo] != null) contents[$45e1a5f717a7bf0f$var$_Mo] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Mo]);
    if (output[$45e1a5f717a7bf0f$var$_RUD] != null) contents[$45e1a5f717a7bf0f$var$_RUD] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_RUD]));
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ObjectLockRule = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_DRe] != null) contents[$45e1a5f717a7bf0f$var$_DRe] = $45e1a5f717a7bf0f$var$de_DefaultRetention(output[$45e1a5f717a7bf0f$var$_DRe], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ObjectPart = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_PN] != null) contents[$45e1a5f717a7bf0f$var$_PN] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_PN]);
    if (output[$45e1a5f717a7bf0f$var$_Si] != null) contents[$45e1a5f717a7bf0f$var$_Si] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_Si]);
    if (output[$45e1a5f717a7bf0f$var$_CCRC] != null) contents[$45e1a5f717a7bf0f$var$_CCRC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRC]);
    if (output[$45e1a5f717a7bf0f$var$_CCRCC] != null) contents[$45e1a5f717a7bf0f$var$_CCRCC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRCC]);
    if (output[$45e1a5f717a7bf0f$var$_CSHA] != null) contents[$45e1a5f717a7bf0f$var$_CSHA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHA]);
    if (output[$45e1a5f717a7bf0f$var$_CSHAh] != null) contents[$45e1a5f717a7bf0f$var$_CSHAh] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHAh]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ObjectVersion = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_ETa] != null) contents[$45e1a5f717a7bf0f$var$_ETa] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ETa]);
    if (output.ChecksumAlgorithm === "") contents[$45e1a5f717a7bf0f$var$_CA] = [];
    else if (output[$45e1a5f717a7bf0f$var$_CA] != null) contents[$45e1a5f717a7bf0f$var$_CA] = $45e1a5f717a7bf0f$var$de_ChecksumAlgorithmList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_CA]), context);
    if (output[$45e1a5f717a7bf0f$var$_Si] != null) contents[$45e1a5f717a7bf0f$var$_Si] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_Si]);
    if (output[$45e1a5f717a7bf0f$var$_SC] != null) contents[$45e1a5f717a7bf0f$var$_SC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_SC]);
    if (output[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_K]);
    if (output[$45e1a5f717a7bf0f$var$_VI] != null) contents[$45e1a5f717a7bf0f$var$_VI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_VI]);
    if (output[$45e1a5f717a7bf0f$var$_IL] != null) contents[$45e1a5f717a7bf0f$var$_IL] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_IL]);
    if (output[$45e1a5f717a7bf0f$var$_LM] != null) contents[$45e1a5f717a7bf0f$var$_LM] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_LM]));
    if (output[$45e1a5f717a7bf0f$var$_O] != null) contents[$45e1a5f717a7bf0f$var$_O] = $45e1a5f717a7bf0f$var$de_Owner(output[$45e1a5f717a7bf0f$var$_O], context);
    if (output[$45e1a5f717a7bf0f$var$_RSe] != null) contents[$45e1a5f717a7bf0f$var$_RSe] = $45e1a5f717a7bf0f$var$de_RestoreStatus(output[$45e1a5f717a7bf0f$var$_RSe], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ObjectVersionList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_ObjectVersion(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_Owner = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_DN] != null) contents[$45e1a5f717a7bf0f$var$_DN] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_DN]);
    if (output[$45e1a5f717a7bf0f$var$_ID_] != null) contents[$45e1a5f717a7bf0f$var$_ID_] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ID_]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_OwnershipControls = (output, context)=>{
    const contents = {};
    if (output.Rule === "") contents[$45e1a5f717a7bf0f$var$_Rul] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ru] != null) contents[$45e1a5f717a7bf0f$var$_Rul] = $45e1a5f717a7bf0f$var$de_OwnershipControlsRules((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ru]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_OwnershipControlsRule = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_OO] != null) contents[$45e1a5f717a7bf0f$var$_OO] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_OO]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_OwnershipControlsRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_OwnershipControlsRule(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_Part = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_PN] != null) contents[$45e1a5f717a7bf0f$var$_PN] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_PN]);
    if (output[$45e1a5f717a7bf0f$var$_LM] != null) contents[$45e1a5f717a7bf0f$var$_LM] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_LM]));
    if (output[$45e1a5f717a7bf0f$var$_ETa] != null) contents[$45e1a5f717a7bf0f$var$_ETa] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ETa]);
    if (output[$45e1a5f717a7bf0f$var$_Si] != null) contents[$45e1a5f717a7bf0f$var$_Si] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_Si]);
    if (output[$45e1a5f717a7bf0f$var$_CCRC] != null) contents[$45e1a5f717a7bf0f$var$_CCRC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRC]);
    if (output[$45e1a5f717a7bf0f$var$_CCRCC] != null) contents[$45e1a5f717a7bf0f$var$_CCRCC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CCRCC]);
    if (output[$45e1a5f717a7bf0f$var$_CSHA] != null) contents[$45e1a5f717a7bf0f$var$_CSHA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHA]);
    if (output[$45e1a5f717a7bf0f$var$_CSHAh] != null) contents[$45e1a5f717a7bf0f$var$_CSHAh] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_CSHAh]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_PartitionedPrefix = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_PDS] != null) contents[$45e1a5f717a7bf0f$var$_PDS] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_PDS]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Parts = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_Part(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_PartsList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_ObjectPart(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_PolicyStatus = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_IP] != null) contents[$45e1a5f717a7bf0f$var$_IP] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_IP]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Progress = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_BS] != null) contents[$45e1a5f717a7bf0f$var$_BS] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_BS]);
    if (output[$45e1a5f717a7bf0f$var$_BP] != null) contents[$45e1a5f717a7bf0f$var$_BP] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_BP]);
    if (output[$45e1a5f717a7bf0f$var$_BRy] != null) contents[$45e1a5f717a7bf0f$var$_BRy] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_BRy]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_PublicAccessBlockConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_BPA] != null) contents[$45e1a5f717a7bf0f$var$_BPA] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_BPA]);
    if (output[$45e1a5f717a7bf0f$var$_IPA] != null) contents[$45e1a5f717a7bf0f$var$_IPA] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_IPA]);
    if (output[$45e1a5f717a7bf0f$var$_BPP] != null) contents[$45e1a5f717a7bf0f$var$_BPP] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_BPP]);
    if (output[$45e1a5f717a7bf0f$var$_RPB] != null) contents[$45e1a5f717a7bf0f$var$_RPB] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_RPB]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_QueueConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_I] != null) contents[$45e1a5f717a7bf0f$var$_I] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_I]);
    if (output[$45e1a5f717a7bf0f$var$_Qu] != null) contents[$45e1a5f717a7bf0f$var$_QA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Qu]);
    if (output.Event === "") contents[$45e1a5f717a7bf0f$var$_Eve] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ev] != null) contents[$45e1a5f717a7bf0f$var$_Eve] = $45e1a5f717a7bf0f$var$de_EventList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ev]), context);
    if (output[$45e1a5f717a7bf0f$var$_F] != null) contents[$45e1a5f717a7bf0f$var$_F] = $45e1a5f717a7bf0f$var$de_NotificationConfigurationFilter(output[$45e1a5f717a7bf0f$var$_F], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_QueueConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_QueueConfiguration(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_Redirect = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_HN] != null) contents[$45e1a5f717a7bf0f$var$_HN] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_HN]);
    if (output[$45e1a5f717a7bf0f$var$_HRC] != null) contents[$45e1a5f717a7bf0f$var$_HRC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_HRC]);
    if (output[$45e1a5f717a7bf0f$var$_Pr] != null) contents[$45e1a5f717a7bf0f$var$_Pr] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Pr]);
    if (output[$45e1a5f717a7bf0f$var$_RKPW] != null) contents[$45e1a5f717a7bf0f$var$_RKPW] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_RKPW]);
    if (output[$45e1a5f717a7bf0f$var$_RKW] != null) contents[$45e1a5f717a7bf0f$var$_RKW] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_RKW]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_RedirectAllRequestsTo = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_HN] != null) contents[$45e1a5f717a7bf0f$var$_HN] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_HN]);
    if (output[$45e1a5f717a7bf0f$var$_Pr] != null) contents[$45e1a5f717a7bf0f$var$_Pr] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Pr]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ReplicaModifications = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ReplicationConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Ro] != null) contents[$45e1a5f717a7bf0f$var$_Ro] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Ro]);
    if (output.Rule === "") contents[$45e1a5f717a7bf0f$var$_Rul] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ru] != null) contents[$45e1a5f717a7bf0f$var$_Rul] = $45e1a5f717a7bf0f$var$de_ReplicationRules((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ru]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ReplicationRule = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_ID_] != null) contents[$45e1a5f717a7bf0f$var$_ID_] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ID_]);
    if (output[$45e1a5f717a7bf0f$var$_Pri] != null) contents[$45e1a5f717a7bf0f$var$_Pri] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_Pri]);
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    if (output.Filter === "") ;
    else if (output[$45e1a5f717a7bf0f$var$_F] != null) contents[$45e1a5f717a7bf0f$var$_F] = $45e1a5f717a7bf0f$var$de_ReplicationRuleFilter((0, $ffdcd55bd2051dc8$export$9ef77073e45b6301)(output[$45e1a5f717a7bf0f$var$_F]), context);
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    if (output[$45e1a5f717a7bf0f$var$_SSC] != null) contents[$45e1a5f717a7bf0f$var$_SSC] = $45e1a5f717a7bf0f$var$de_SourceSelectionCriteria(output[$45e1a5f717a7bf0f$var$_SSC], context);
    if (output[$45e1a5f717a7bf0f$var$_EOR] != null) contents[$45e1a5f717a7bf0f$var$_EOR] = $45e1a5f717a7bf0f$var$de_ExistingObjectReplication(output[$45e1a5f717a7bf0f$var$_EOR], context);
    if (output[$45e1a5f717a7bf0f$var$_Des] != null) contents[$45e1a5f717a7bf0f$var$_Des] = $45e1a5f717a7bf0f$var$de_Destination(output[$45e1a5f717a7bf0f$var$_Des], context);
    if (output[$45e1a5f717a7bf0f$var$_DMR] != null) contents[$45e1a5f717a7bf0f$var$_DMR] = $45e1a5f717a7bf0f$var$de_DeleteMarkerReplication(output[$45e1a5f717a7bf0f$var$_DMR], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ReplicationRuleAndOperator = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_P] != null) contents[$45e1a5f717a7bf0f$var$_P] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P]);
    if (output.Tag === "") contents[$45e1a5f717a7bf0f$var$_Tag] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ta] != null) contents[$45e1a5f717a7bf0f$var$_Tag] = $45e1a5f717a7bf0f$var$de_TagSet((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ta]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ReplicationRuleFilter = (output, context)=>{
    if (output[$45e1a5f717a7bf0f$var$_P] != null) return {
        Prefix: (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_P])
    };
    if (output[$45e1a5f717a7bf0f$var$_Ta] != null) return {
        Tag: $45e1a5f717a7bf0f$var$de_Tag(output[$45e1a5f717a7bf0f$var$_Ta], context)
    };
    if (output[$45e1a5f717a7bf0f$var$_A] != null) return {
        And: $45e1a5f717a7bf0f$var$de_ReplicationRuleAndOperator(output[$45e1a5f717a7bf0f$var$_A], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $45e1a5f717a7bf0f$var$de_ReplicationRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_ReplicationRule(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_ReplicationTime = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    if (output[$45e1a5f717a7bf0f$var$_Tim] != null) contents[$45e1a5f717a7bf0f$var$_Tim] = $45e1a5f717a7bf0f$var$de_ReplicationTimeValue(output[$45e1a5f717a7bf0f$var$_Tim], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ReplicationTimeValue = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Mi] != null) contents[$45e1a5f717a7bf0f$var$_Mi] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_Mi]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_RestoreStatus = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_IRIP] != null) contents[$45e1a5f717a7bf0f$var$_IRIP] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_IRIP]);
    if (output[$45e1a5f717a7bf0f$var$_RED] != null) contents[$45e1a5f717a7bf0f$var$_RED] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_RED]));
    return contents;
};
const $45e1a5f717a7bf0f$var$de_RoutingRule = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Con] != null) contents[$45e1a5f717a7bf0f$var$_Con] = $45e1a5f717a7bf0f$var$de_Condition(output[$45e1a5f717a7bf0f$var$_Con], context);
    if (output[$45e1a5f717a7bf0f$var$_Red] != null) contents[$45e1a5f717a7bf0f$var$_Red] = $45e1a5f717a7bf0f$var$de_Redirect(output[$45e1a5f717a7bf0f$var$_Red], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_RoutingRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_RoutingRule(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_S3KeyFilter = (output, context)=>{
    const contents = {};
    if (output.FilterRule === "") contents[$45e1a5f717a7bf0f$var$_FRi] = [];
    else if (output[$45e1a5f717a7bf0f$var$_FR] != null) contents[$45e1a5f717a7bf0f$var$_FRi] = $45e1a5f717a7bf0f$var$de_FilterRuleList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_FR]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ServerSideEncryptionByDefault = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_SSEA] != null) contents[$45e1a5f717a7bf0f$var$_SSEA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_SSEA]);
    if (output[$45e1a5f717a7bf0f$var$_KMSMKID] != null) contents[$45e1a5f717a7bf0f$var$_KMSMKID] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_KMSMKID]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ServerSideEncryptionConfiguration = (output, context)=>{
    const contents = {};
    if (output.Rule === "") contents[$45e1a5f717a7bf0f$var$_Rul] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ru] != null) contents[$45e1a5f717a7bf0f$var$_Rul] = $45e1a5f717a7bf0f$var$de_ServerSideEncryptionRules((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ru]), context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ServerSideEncryptionRule = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_ASSEBD] != null) contents[$45e1a5f717a7bf0f$var$_ASSEBD] = $45e1a5f717a7bf0f$var$de_ServerSideEncryptionByDefault(output[$45e1a5f717a7bf0f$var$_ASSEBD], context);
    if (output[$45e1a5f717a7bf0f$var$_BKE] != null) contents[$45e1a5f717a7bf0f$var$_BKE] = (0, $ffdcd55bd2051dc8$export$3fb54149990fb5b5)(output[$45e1a5f717a7bf0f$var$_BKE]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_ServerSideEncryptionRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_ServerSideEncryptionRule(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_SessionCredentials = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_AKI] != null) contents[$45e1a5f717a7bf0f$var$_AKI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_AKI]);
    if (output[$45e1a5f717a7bf0f$var$_SAK] != null) contents[$45e1a5f717a7bf0f$var$_SAK] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_SAK]);
    if (output[$45e1a5f717a7bf0f$var$_ST] != null) contents[$45e1a5f717a7bf0f$var$_ST] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_ST]);
    if (output[$45e1a5f717a7bf0f$var$_Exp] != null) contents[$45e1a5f717a7bf0f$var$_Exp] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_Exp]));
    return contents;
};
const $45e1a5f717a7bf0f$var$de_SimplePrefix = (output, context)=>{
    const contents = {};
    return contents;
};
const $45e1a5f717a7bf0f$var$de_SourceSelectionCriteria = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_SKEO] != null) contents[$45e1a5f717a7bf0f$var$_SKEO] = $45e1a5f717a7bf0f$var$de_SseKmsEncryptedObjects(output[$45e1a5f717a7bf0f$var$_SKEO], context);
    if (output[$45e1a5f717a7bf0f$var$_RM] != null) contents[$45e1a5f717a7bf0f$var$_RM] = $45e1a5f717a7bf0f$var$de_ReplicaModifications(output[$45e1a5f717a7bf0f$var$_RM], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_SSEKMS = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_KI] != null) contents[$45e1a5f717a7bf0f$var$_KI] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_KI]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_SseKmsEncryptedObjects = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_S] != null) contents[$45e1a5f717a7bf0f$var$_S] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_S]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_SSES3 = (output, context)=>{
    const contents = {};
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Stats = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_BS] != null) contents[$45e1a5f717a7bf0f$var$_BS] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_BS]);
    if (output[$45e1a5f717a7bf0f$var$_BP] != null) contents[$45e1a5f717a7bf0f$var$_BP] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_BP]);
    if (output[$45e1a5f717a7bf0f$var$_BRy] != null) contents[$45e1a5f717a7bf0f$var$_BRy] = (0, $ffdcd55bd2051dc8$export$f90617f39a736d36)(output[$45e1a5f717a7bf0f$var$_BRy]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_StorageClassAnalysis = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_DE] != null) contents[$45e1a5f717a7bf0f$var$_DE] = $45e1a5f717a7bf0f$var$de_StorageClassAnalysisDataExport(output[$45e1a5f717a7bf0f$var$_DE], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_StorageClassAnalysisDataExport = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_OSV] != null) contents[$45e1a5f717a7bf0f$var$_OSV] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_OSV]);
    if (output[$45e1a5f717a7bf0f$var$_Des] != null) contents[$45e1a5f717a7bf0f$var$_Des] = $45e1a5f717a7bf0f$var$de_AnalyticsExportDestination(output[$45e1a5f717a7bf0f$var$_Des], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Tag = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_K] != null) contents[$45e1a5f717a7bf0f$var$_K] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_K]);
    if (output[$45e1a5f717a7bf0f$var$_Va] != null) contents[$45e1a5f717a7bf0f$var$_Va] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Va]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_TagSet = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_Tag(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_TargetGrant = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Gra] != null) contents[$45e1a5f717a7bf0f$var$_Gra] = $45e1a5f717a7bf0f$var$de_Grantee(output[$45e1a5f717a7bf0f$var$_Gra], context);
    if (output[$45e1a5f717a7bf0f$var$_Pe] != null) contents[$45e1a5f717a7bf0f$var$_Pe] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Pe]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_TargetGrants = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_TargetGrant(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_TargetObjectKeyFormat = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_SPi] != null) contents[$45e1a5f717a7bf0f$var$_SPi] = $45e1a5f717a7bf0f$var$de_SimplePrefix(output[$45e1a5f717a7bf0f$var$_SPi], context);
    if (output[$45e1a5f717a7bf0f$var$_PP] != null) contents[$45e1a5f717a7bf0f$var$_PP] = $45e1a5f717a7bf0f$var$de_PartitionedPrefix(output[$45e1a5f717a7bf0f$var$_PP], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_Tiering = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Da] != null) contents[$45e1a5f717a7bf0f$var$_Da] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_Da]);
    if (output[$45e1a5f717a7bf0f$var$_AT] != null) contents[$45e1a5f717a7bf0f$var$_AT] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_AT]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_TieringList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_Tiering(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_TopicConfiguration = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_I] != null) contents[$45e1a5f717a7bf0f$var$_I] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_I]);
    if (output[$45e1a5f717a7bf0f$var$_Top] != null) contents[$45e1a5f717a7bf0f$var$_TA] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_Top]);
    if (output.Event === "") contents[$45e1a5f717a7bf0f$var$_Eve] = [];
    else if (output[$45e1a5f717a7bf0f$var$_Ev] != null) contents[$45e1a5f717a7bf0f$var$_Eve] = $45e1a5f717a7bf0f$var$de_EventList((0, $6eb87c253cabe879$export$52272e038712c64e)(output[$45e1a5f717a7bf0f$var$_Ev]), context);
    if (output[$45e1a5f717a7bf0f$var$_F] != null) contents[$45e1a5f717a7bf0f$var$_F] = $45e1a5f717a7bf0f$var$de_NotificationConfigurationFilter(output[$45e1a5f717a7bf0f$var$_F], context);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_TopicConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_TopicConfiguration(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$de_Transition = (output, context)=>{
    const contents = {};
    if (output[$45e1a5f717a7bf0f$var$_Dat] != null) contents[$45e1a5f717a7bf0f$var$_Dat] = (0, $ffdcd55bd2051dc8$export$8413a63dbe548a49)((0, $9ced97d9f13aecca$export$3cb821e2875b4b7d)(output[$45e1a5f717a7bf0f$var$_Dat]));
    if (output[$45e1a5f717a7bf0f$var$_Da] != null) contents[$45e1a5f717a7bf0f$var$_Da] = (0, $ffdcd55bd2051dc8$export$c3c2f00b115709e6)(output[$45e1a5f717a7bf0f$var$_Da]);
    if (output[$45e1a5f717a7bf0f$var$_SC] != null) contents[$45e1a5f717a7bf0f$var$_SC] = (0, $ffdcd55bd2051dc8$export$7ed80f53fe336639)(output[$45e1a5f717a7bf0f$var$_SC]);
    return contents;
};
const $45e1a5f717a7bf0f$var$de_TransitionList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $45e1a5f717a7bf0f$var$de_Transition(entry, context);
    });
};
const $45e1a5f717a7bf0f$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });
const $45e1a5f717a7bf0f$var$collectBodyString = (streamBody, context)=>(0, $9778ece3ddcb3b83$export$3392bcddb824e5ca)(streamBody, context).then((body)=>context.utf8Encoder(body));
const $45e1a5f717a7bf0f$var$_A = "And";
const $45e1a5f717a7bf0f$var$_AAO = "AnalyticsAndOperator";
const $45e1a5f717a7bf0f$var$_AC = "AnalyticsConfiguration";
const $45e1a5f717a7bf0f$var$_ACL = "ACL";
const $45e1a5f717a7bf0f$var$_ACLc = "AccessControlList";
const $45e1a5f717a7bf0f$var$_ACLn = "AnalyticsConfigurationList";
const $45e1a5f717a7bf0f$var$_ACP = "AccessControlPolicy";
const $45e1a5f717a7bf0f$var$_ACT = "AccessControlTranslation";
const $45e1a5f717a7bf0f$var$_ACc = "AccelerateConfiguration";
const $45e1a5f717a7bf0f$var$_AD = "AbortDate";
const $45e1a5f717a7bf0f$var$_AED = "AnalyticsExportDestination";
const $45e1a5f717a7bf0f$var$_AF = "AnalyticsFilter";
const $45e1a5f717a7bf0f$var$_AH = "AllowedHeader";
const $45e1a5f717a7bf0f$var$_AHl = "AllowedHeaders";
const $45e1a5f717a7bf0f$var$_AI = "AnalyticsId";
const $45e1a5f717a7bf0f$var$_AIMU = "AbortIncompleteMultipartUpload";
const $45e1a5f717a7bf0f$var$_AIc = "AccountId";
const $45e1a5f717a7bf0f$var$_AKI = "AccessKeyId";
const $45e1a5f717a7bf0f$var$_AM = "AllowedMethod";
const $45e1a5f717a7bf0f$var$_AMl = "AllowedMethods";
const $45e1a5f717a7bf0f$var$_AO = "AllowedOrigin";
const $45e1a5f717a7bf0f$var$_AOl = "AllowedOrigins";
const $45e1a5f717a7bf0f$var$_APA = "AccessPointAlias";
const $45e1a5f717a7bf0f$var$_APAc = "AccessPointArn";
const $45e1a5f717a7bf0f$var$_AQRD = "AllowQuotedRecordDelimiter";
const $45e1a5f717a7bf0f$var$_AR = "AcceptRanges";
const $45e1a5f717a7bf0f$var$_ARI = "AbortRuleId";
const $45e1a5f717a7bf0f$var$_AS = "ArchiveStatus";
const $45e1a5f717a7bf0f$var$_ASBD = "AnalyticsS3BucketDestination";
const $45e1a5f717a7bf0f$var$_ASEFF = "AnalyticsS3ExportFileFormat";
const $45e1a5f717a7bf0f$var$_ASSEBD = "ApplyServerSideEncryptionByDefault";
const $45e1a5f717a7bf0f$var$_AT = "AccessTier";
const $45e1a5f717a7bf0f$var$_Ac = "Account";
const $45e1a5f717a7bf0f$var$_B = "Bucket";
const $45e1a5f717a7bf0f$var$_BAI = "BucketAccountId";
const $45e1a5f717a7bf0f$var$_BAS = "BucketAccelerateStatus";
const $45e1a5f717a7bf0f$var$_BGR = "BypassGovernanceRetention";
const $45e1a5f717a7bf0f$var$_BI = "BucketInfo";
const $45e1a5f717a7bf0f$var$_BKE = "BucketKeyEnabled";
const $45e1a5f717a7bf0f$var$_BLC = "BucketLifecycleConfiguration";
const $45e1a5f717a7bf0f$var$_BLCu = "BucketLocationConstraint";
const $45e1a5f717a7bf0f$var$_BLN = "BucketLocationName";
const $45e1a5f717a7bf0f$var$_BLP = "BucketLogsPermission";
const $45e1a5f717a7bf0f$var$_BLS = "BucketLoggingStatus";
const $45e1a5f717a7bf0f$var$_BLT = "BucketLocationType";
const $45e1a5f717a7bf0f$var$_BN = "BucketName";
const $45e1a5f717a7bf0f$var$_BP = "BytesProcessed";
const $45e1a5f717a7bf0f$var$_BPA = "BlockPublicAcls";
const $45e1a5f717a7bf0f$var$_BPP = "BlockPublicPolicy";
const $45e1a5f717a7bf0f$var$_BR = "BucketRegion";
const $45e1a5f717a7bf0f$var$_BRy = "BytesReturned";
const $45e1a5f717a7bf0f$var$_BS = "BytesScanned";
const $45e1a5f717a7bf0f$var$_BT = "BucketType";
const $45e1a5f717a7bf0f$var$_BVS = "BucketVersioningStatus";
const $45e1a5f717a7bf0f$var$_Bu = "Buckets";
const $45e1a5f717a7bf0f$var$_C = "Credentials";
const $45e1a5f717a7bf0f$var$_CA = "ChecksumAlgorithm";
const $45e1a5f717a7bf0f$var$_CACL = "CannedACL";
const $45e1a5f717a7bf0f$var$_CBC = "CreateBucketConfiguration";
const $45e1a5f717a7bf0f$var$_CC = "CacheControl";
const $45e1a5f717a7bf0f$var$_CCRC = "ChecksumCRC32";
const $45e1a5f717a7bf0f$var$_CCRCC = "ChecksumCRC32C";
const $45e1a5f717a7bf0f$var$_CD = "ContentDisposition";
const $45e1a5f717a7bf0f$var$_CDr = "CreationDate";
const $45e1a5f717a7bf0f$var$_CE = "ContentEncoding";
const $45e1a5f717a7bf0f$var$_CF = "CloudFunction";
const $45e1a5f717a7bf0f$var$_CFC = "CloudFunctionConfiguration";
const $45e1a5f717a7bf0f$var$_CL = "ContentLanguage";
const $45e1a5f717a7bf0f$var$_CLo = "ContentLength";
const $45e1a5f717a7bf0f$var$_CM = "ChecksumMode";
const $45e1a5f717a7bf0f$var$_CMD = "ContentMD5";
const $45e1a5f717a7bf0f$var$_CMU = "CompletedMultipartUpload";
const $45e1a5f717a7bf0f$var$_CORSC = "CORSConfiguration";
const $45e1a5f717a7bf0f$var$_CORSR = "CORSRule";
const $45e1a5f717a7bf0f$var$_CORSRu = "CORSRules";
const $45e1a5f717a7bf0f$var$_CP = "CommonPrefixes";
const $45e1a5f717a7bf0f$var$_CPo = "CompletedPart";
const $45e1a5f717a7bf0f$var$_CR = "ContentRange";
const $45e1a5f717a7bf0f$var$_CRSBA = "ConfirmRemoveSelfBucketAccess";
const $45e1a5f717a7bf0f$var$_CS = "CopySource";
const $45e1a5f717a7bf0f$var$_CSHA = "ChecksumSHA1";
const $45e1a5f717a7bf0f$var$_CSHAh = "ChecksumSHA256";
const $45e1a5f717a7bf0f$var$_CSIM = "CopySourceIfMatch";
const $45e1a5f717a7bf0f$var$_CSIMS = "CopySourceIfModifiedSince";
const $45e1a5f717a7bf0f$var$_CSINM = "CopySourceIfNoneMatch";
const $45e1a5f717a7bf0f$var$_CSIUS = "CopySourceIfUnmodifiedSince";
const $45e1a5f717a7bf0f$var$_CSR = "CopySourceRange";
const $45e1a5f717a7bf0f$var$_CSSSECA = "CopySourceSSECustomerAlgorithm";
const $45e1a5f717a7bf0f$var$_CSSSECK = "CopySourceSSECustomerKey";
const $45e1a5f717a7bf0f$var$_CSSSECKMD = "CopySourceSSECustomerKeyMD5";
const $45e1a5f717a7bf0f$var$_CSV = "CSV";
const $45e1a5f717a7bf0f$var$_CSVI = "CopySourceVersionId";
const $45e1a5f717a7bf0f$var$_CSVIn = "CSVInput";
const $45e1a5f717a7bf0f$var$_CSVO = "CSVOutput";
const $45e1a5f717a7bf0f$var$_CT = "ContentType";
const $45e1a5f717a7bf0f$var$_CTo = "ContinuationToken";
const $45e1a5f717a7bf0f$var$_CTom = "CompressionType";
const $45e1a5f717a7bf0f$var$_Ch = "Checksum";
const $45e1a5f717a7bf0f$var$_Co = "Contents";
const $45e1a5f717a7bf0f$var$_Cod = "Code";
const $45e1a5f717a7bf0f$var$_Com = "Comments";
const $45e1a5f717a7bf0f$var$_Con = "Condition";
const $45e1a5f717a7bf0f$var$_D = "Delimiter";
const $45e1a5f717a7bf0f$var$_DAI = "DaysAfterInitiation";
const $45e1a5f717a7bf0f$var$_DE = "DataExport";
const $45e1a5f717a7bf0f$var$_DM = "DeleteMarker";
const $45e1a5f717a7bf0f$var$_DMR = "DeleteMarkerReplication";
const $45e1a5f717a7bf0f$var$_DMRS = "DeleteMarkerReplicationStatus";
const $45e1a5f717a7bf0f$var$_DMVI = "DeleteMarkerVersionId";
const $45e1a5f717a7bf0f$var$_DMe = "DeleteMarkers";
const $45e1a5f717a7bf0f$var$_DN = "DisplayName";
const $45e1a5f717a7bf0f$var$_DR = "DataRedundancy";
const $45e1a5f717a7bf0f$var$_DRe = "DefaultRetention";
const $45e1a5f717a7bf0f$var$_Da = "Days";
const $45e1a5f717a7bf0f$var$_Dat = "Date";
const $45e1a5f717a7bf0f$var$_De = "Deleted";
const $45e1a5f717a7bf0f$var$_Del = "Delete";
const $45e1a5f717a7bf0f$var$_Des = "Destination";
const $45e1a5f717a7bf0f$var$_Desc = "Description";
const $45e1a5f717a7bf0f$var$_E = "Expires";
const $45e1a5f717a7bf0f$var$_EA = "EmailAddress";
const $45e1a5f717a7bf0f$var$_EBC = "EventBridgeConfiguration";
const $45e1a5f717a7bf0f$var$_EBO = "ExpectedBucketOwner";
const $45e1a5f717a7bf0f$var$_EC = "ErrorCode";
const $45e1a5f717a7bf0f$var$_ECn = "EncryptionConfiguration";
const $45e1a5f717a7bf0f$var$_ED = "ErrorDocument";
const $45e1a5f717a7bf0f$var$_EH = "ExposeHeaders";
const $45e1a5f717a7bf0f$var$_EHx = "ExposeHeader";
const $45e1a5f717a7bf0f$var$_EM = "ErrorMessage";
const $45e1a5f717a7bf0f$var$_EODM = "ExpiredObjectDeleteMarker";
const $45e1a5f717a7bf0f$var$_EOR = "ExistingObjectReplication";
const $45e1a5f717a7bf0f$var$_EORS = "ExistingObjectReplicationStatus";
const $45e1a5f717a7bf0f$var$_ERP = "EnableRequestProgress";
const $45e1a5f717a7bf0f$var$_ES = "ExpiresString";
const $45e1a5f717a7bf0f$var$_ESBO = "ExpectedSourceBucketOwner";
const $45e1a5f717a7bf0f$var$_ESx = "ExpirationStatus";
const $45e1a5f717a7bf0f$var$_ET = "EncodingType";
const $45e1a5f717a7bf0f$var$_ETa = "ETag";
const $45e1a5f717a7bf0f$var$_ETn = "EncryptionType";
const $45e1a5f717a7bf0f$var$_ETv = "EventThreshold";
const $45e1a5f717a7bf0f$var$_ETx = "ExpressionType";
const $45e1a5f717a7bf0f$var$_En = "Encryption";
const $45e1a5f717a7bf0f$var$_Ena = "Enabled";
const $45e1a5f717a7bf0f$var$_End = "End";
const $45e1a5f717a7bf0f$var$_Er = "Error";
const $45e1a5f717a7bf0f$var$_Err = "Errors";
const $45e1a5f717a7bf0f$var$_Ev = "Event";
const $45e1a5f717a7bf0f$var$_Eve = "Events";
const $45e1a5f717a7bf0f$var$_Ex = "Expression";
const $45e1a5f717a7bf0f$var$_Exp = "Expiration";
const $45e1a5f717a7bf0f$var$_F = "Filter";
const $45e1a5f717a7bf0f$var$_FD = "FieldDelimiter";
const $45e1a5f717a7bf0f$var$_FHI = "FileHeaderInfo";
const $45e1a5f717a7bf0f$var$_FO = "FetchOwner";
const $45e1a5f717a7bf0f$var$_FR = "FilterRule";
const $45e1a5f717a7bf0f$var$_FRN = "FilterRuleName";
const $45e1a5f717a7bf0f$var$_FRV = "FilterRuleValue";
const $45e1a5f717a7bf0f$var$_FRi = "FilterRules";
const $45e1a5f717a7bf0f$var$_Fi = "Field";
const $45e1a5f717a7bf0f$var$_Fo = "Format";
const $45e1a5f717a7bf0f$var$_Fr = "Frequency";
const $45e1a5f717a7bf0f$var$_G = "Grant";
const $45e1a5f717a7bf0f$var$_GFC = "GrantFullControl";
const $45e1a5f717a7bf0f$var$_GJP = "GlacierJobParameters";
const $45e1a5f717a7bf0f$var$_GR = "GrantRead";
const $45e1a5f717a7bf0f$var$_GRACP = "GrantReadACP";
const $45e1a5f717a7bf0f$var$_GW = "GrantWrite";
const $45e1a5f717a7bf0f$var$_GWACP = "GrantWriteACP";
const $45e1a5f717a7bf0f$var$_Gr = "Grants";
const $45e1a5f717a7bf0f$var$_Gra = "Grantee";
const $45e1a5f717a7bf0f$var$_HECRE = "HttpErrorCodeReturnedEquals";
const $45e1a5f717a7bf0f$var$_HN = "HostName";
const $45e1a5f717a7bf0f$var$_HRC = "HttpRedirectCode";
const $45e1a5f717a7bf0f$var$_I = "Id";
const $45e1a5f717a7bf0f$var$_IC = "InventoryConfiguration";
const $45e1a5f717a7bf0f$var$_ICL = "InventoryConfigurationList";
const $45e1a5f717a7bf0f$var$_ID = "IndexDocument";
const $45e1a5f717a7bf0f$var$_ID_ = "ID";
const $45e1a5f717a7bf0f$var$_IDn = "InventoryDestination";
const $45e1a5f717a7bf0f$var$_IE = "IsEnabled";
const $45e1a5f717a7bf0f$var$_IEn = "InventoryEncryption";
const $45e1a5f717a7bf0f$var$_IF = "InventoryFilter";
const $45e1a5f717a7bf0f$var$_IFn = "InventoryFormat";
const $45e1a5f717a7bf0f$var$_IFnv = "InventoryFrequency";
const $45e1a5f717a7bf0f$var$_II = "InventoryId";
const $45e1a5f717a7bf0f$var$_IIOV = "InventoryIncludedObjectVersions";
const $45e1a5f717a7bf0f$var$_IL = "IsLatest";
const $45e1a5f717a7bf0f$var$_IM = "IfMatch";
const $45e1a5f717a7bf0f$var$_IMS = "IfModifiedSince";
const $45e1a5f717a7bf0f$var$_INM = "IfNoneMatch";
const $45e1a5f717a7bf0f$var$_IOF = "InventoryOptionalField";
const $45e1a5f717a7bf0f$var$_IOV = "IncludedObjectVersions";
const $45e1a5f717a7bf0f$var$_IP = "IsPublic";
const $45e1a5f717a7bf0f$var$_IPA = "IgnorePublicAcls";
const $45e1a5f717a7bf0f$var$_IRIP = "IsRestoreInProgress";
const $45e1a5f717a7bf0f$var$_IS = "InputSerialization";
const $45e1a5f717a7bf0f$var$_ISBD = "InventoryS3BucketDestination";
const $45e1a5f717a7bf0f$var$_ISn = "InventorySchedule";
const $45e1a5f717a7bf0f$var$_IT = "IsTruncated";
const $45e1a5f717a7bf0f$var$_ITAO = "IntelligentTieringAndOperator";
const $45e1a5f717a7bf0f$var$_ITAT = "IntelligentTieringAccessTier";
const $45e1a5f717a7bf0f$var$_ITC = "IntelligentTieringConfiguration";
const $45e1a5f717a7bf0f$var$_ITCL = "IntelligentTieringConfigurationList";
const $45e1a5f717a7bf0f$var$_ITD = "IntelligentTieringDays";
const $45e1a5f717a7bf0f$var$_ITF = "IntelligentTieringFilter";
const $45e1a5f717a7bf0f$var$_ITI = "IntelligentTieringId";
const $45e1a5f717a7bf0f$var$_ITS = "IntelligentTieringStatus";
const $45e1a5f717a7bf0f$var$_IUS = "IfUnmodifiedSince";
const $45e1a5f717a7bf0f$var$_In = "Initiator";
const $45e1a5f717a7bf0f$var$_Ini = "Initiated";
const $45e1a5f717a7bf0f$var$_JSON = "JSON";
const $45e1a5f717a7bf0f$var$_JSONI = "JSONInput";
const $45e1a5f717a7bf0f$var$_JSONO = "JSONOutput";
const $45e1a5f717a7bf0f$var$_JSONT = "JSONType";
const $45e1a5f717a7bf0f$var$_K = "Key";
const $45e1a5f717a7bf0f$var$_KC = "KeyCount";
const $45e1a5f717a7bf0f$var$_KI = "KeyId";
const $45e1a5f717a7bf0f$var$_KM = "KeyMarker";
const $45e1a5f717a7bf0f$var$_KMSC = "KMSContext";
const $45e1a5f717a7bf0f$var$_KMSKI = "KMSKeyId";
const $45e1a5f717a7bf0f$var$_KMSMKID = "KMSMasterKeyID";
const $45e1a5f717a7bf0f$var$_KPE = "KeyPrefixEquals";
const $45e1a5f717a7bf0f$var$_L = "Location";
const $45e1a5f717a7bf0f$var$_LC = "LocationConstraint";
const $45e1a5f717a7bf0f$var$_LE = "LoggingEnabled";
const $45e1a5f717a7bf0f$var$_LEi = "LifecycleExpiration";
const $45e1a5f717a7bf0f$var$_LFA = "LambdaFunctionArn";
const $45e1a5f717a7bf0f$var$_LFC = "LambdaFunctionConfigurations";
const $45e1a5f717a7bf0f$var$_LFCa = "LambdaFunctionConfiguration";
const $45e1a5f717a7bf0f$var$_LI = "LocationInfo";
const $45e1a5f717a7bf0f$var$_LM = "LastModified";
const $45e1a5f717a7bf0f$var$_LNAS = "LocationNameAsString";
const $45e1a5f717a7bf0f$var$_LP = "LocationPrefix";
const $45e1a5f717a7bf0f$var$_LR = "LifecycleRule";
const $45e1a5f717a7bf0f$var$_LRAO = "LifecycleRuleAndOperator";
const $45e1a5f717a7bf0f$var$_LRF = "LifecycleRuleFilter";
const $45e1a5f717a7bf0f$var$_LT = "LocationType";
const $45e1a5f717a7bf0f$var$_M = "Marker";
const $45e1a5f717a7bf0f$var$_MAO = "MetricsAndOperator";
const $45e1a5f717a7bf0f$var$_MAS = "MaxAgeSeconds";
const $45e1a5f717a7bf0f$var$_MB = "MaxBuckets";
const $45e1a5f717a7bf0f$var$_MC = "MetricsConfiguration";
const $45e1a5f717a7bf0f$var$_MCL = "MetricsConfigurationList";
const $45e1a5f717a7bf0f$var$_MD = "MetadataDirective";
const $45e1a5f717a7bf0f$var$_MDB = "MaxDirectoryBuckets";
const $45e1a5f717a7bf0f$var$_MDf = "MfaDelete";
const $45e1a5f717a7bf0f$var$_ME = "MetadataEntry";
const $45e1a5f717a7bf0f$var$_MF = "MetricsFilter";
const $45e1a5f717a7bf0f$var$_MFA = "MFA";
const $45e1a5f717a7bf0f$var$_MFAD = "MFADelete";
const $45e1a5f717a7bf0f$var$_MI = "MetricsId";
const $45e1a5f717a7bf0f$var$_MK = "MaxKeys";
const $45e1a5f717a7bf0f$var$_MKe = "MetadataKey";
const $45e1a5f717a7bf0f$var$_MM = "MissingMeta";
const $45e1a5f717a7bf0f$var$_MP = "MaxParts";
const $45e1a5f717a7bf0f$var$_MS = "MetricsStatus";
const $45e1a5f717a7bf0f$var$_MU = "MaxUploads";
const $45e1a5f717a7bf0f$var$_MV = "MetadataValue";
const $45e1a5f717a7bf0f$var$_Me = "Metrics";
const $45e1a5f717a7bf0f$var$_Mes = "Message";
const $45e1a5f717a7bf0f$var$_Mi = "Minutes";
const $45e1a5f717a7bf0f$var$_Mo = "Mode";
const $45e1a5f717a7bf0f$var$_N = "Name";
const $45e1a5f717a7bf0f$var$_NC = "NotificationConfiguration";
const $45e1a5f717a7bf0f$var$_NCF = "NotificationConfigurationFilter";
const $45e1a5f717a7bf0f$var$_NCT = "NextContinuationToken";
const $45e1a5f717a7bf0f$var$_ND = "NoncurrentDays";
const $45e1a5f717a7bf0f$var$_NI = "NotificationId";
const $45e1a5f717a7bf0f$var$_NKM = "NextKeyMarker";
const $45e1a5f717a7bf0f$var$_NM = "NextMarker";
const $45e1a5f717a7bf0f$var$_NNV = "NewerNoncurrentVersions";
const $45e1a5f717a7bf0f$var$_NPNM = "NextPartNumberMarker";
const $45e1a5f717a7bf0f$var$_NUIM = "NextUploadIdMarker";
const $45e1a5f717a7bf0f$var$_NVE = "NoncurrentVersionExpiration";
const $45e1a5f717a7bf0f$var$_NVIM = "NextVersionIdMarker";
const $45e1a5f717a7bf0f$var$_NVT = "NoncurrentVersionTransitions";
const $45e1a5f717a7bf0f$var$_NVTo = "NoncurrentVersionTransition";
const $45e1a5f717a7bf0f$var$_O = "Owner";
const $45e1a5f717a7bf0f$var$_OA = "ObjectAttributes";
const $45e1a5f717a7bf0f$var$_OC = "OwnershipControls";
const $45e1a5f717a7bf0f$var$_OCACL = "ObjectCannedACL";
const $45e1a5f717a7bf0f$var$_OCR = "OwnershipControlsRule";
const $45e1a5f717a7bf0f$var$_OF = "OptionalFields";
const $45e1a5f717a7bf0f$var$_OI = "ObjectIdentifier";
const $45e1a5f717a7bf0f$var$_OK = "ObjectKey";
const $45e1a5f717a7bf0f$var$_OL = "OutputLocation";
const $45e1a5f717a7bf0f$var$_OLC = "ObjectLockConfiguration";
const $45e1a5f717a7bf0f$var$_OLE = "ObjectLockEnabled";
const $45e1a5f717a7bf0f$var$_OLEFB = "ObjectLockEnabledForBucket";
const $45e1a5f717a7bf0f$var$_OLLH = "ObjectLockLegalHold";
const $45e1a5f717a7bf0f$var$_OLLHS = "ObjectLockLegalHoldStatus";
const $45e1a5f717a7bf0f$var$_OLM = "ObjectLockMode";
const $45e1a5f717a7bf0f$var$_OLR = "ObjectLockRetention";
const $45e1a5f717a7bf0f$var$_OLRM = "ObjectLockRetentionMode";
const $45e1a5f717a7bf0f$var$_OLRUD = "ObjectLockRetainUntilDate";
const $45e1a5f717a7bf0f$var$_OLRb = "ObjectLockRule";
const $45e1a5f717a7bf0f$var$_OO = "ObjectOwnership";
const $45e1a5f717a7bf0f$var$_OOA = "OptionalObjectAttributes";
const $45e1a5f717a7bf0f$var$_OOw = "OwnerOverride";
const $45e1a5f717a7bf0f$var$_OP = "ObjectParts";
const $45e1a5f717a7bf0f$var$_OS = "OutputSerialization";
const $45e1a5f717a7bf0f$var$_OSGT = "ObjectSizeGreaterThan";
const $45e1a5f717a7bf0f$var$_OSGTB = "ObjectSizeGreaterThanBytes";
const $45e1a5f717a7bf0f$var$_OSLT = "ObjectSizeLessThan";
const $45e1a5f717a7bf0f$var$_OSLTB = "ObjectSizeLessThanBytes";
const $45e1a5f717a7bf0f$var$_OSV = "OutputSchemaVersion";
const $45e1a5f717a7bf0f$var$_OSb = "ObjectSize";
const $45e1a5f717a7bf0f$var$_OVI = "ObjectVersionId";
const $45e1a5f717a7bf0f$var$_Ob = "Objects";
const $45e1a5f717a7bf0f$var$_P = "Prefix";
const $45e1a5f717a7bf0f$var$_PABC = "PublicAccessBlockConfiguration";
const $45e1a5f717a7bf0f$var$_PC = "PartsCount";
const $45e1a5f717a7bf0f$var$_PDS = "PartitionDateSource";
const $45e1a5f717a7bf0f$var$_PI = "ParquetInput";
const $45e1a5f717a7bf0f$var$_PN = "PartNumber";
const $45e1a5f717a7bf0f$var$_PNM = "PartNumberMarker";
const $45e1a5f717a7bf0f$var$_PP = "PartitionedPrefix";
const $45e1a5f717a7bf0f$var$_Pa = "Payer";
const $45e1a5f717a7bf0f$var$_Par = "Part";
const $45e1a5f717a7bf0f$var$_Parq = "Parquet";
const $45e1a5f717a7bf0f$var$_Part = "Parts";
const $45e1a5f717a7bf0f$var$_Pe = "Permission";
const $45e1a5f717a7bf0f$var$_Pr = "Protocol";
const $45e1a5f717a7bf0f$var$_Pri = "Priority";
const $45e1a5f717a7bf0f$var$_Q = "Quiet";
const $45e1a5f717a7bf0f$var$_QA = "QueueArn";
const $45e1a5f717a7bf0f$var$_QC = "QueueConfiguration";
const $45e1a5f717a7bf0f$var$_QCu = "QueueConfigurations";
const $45e1a5f717a7bf0f$var$_QCuo = "QuoteCharacter";
const $45e1a5f717a7bf0f$var$_QEC = "QuoteEscapeCharacter";
const $45e1a5f717a7bf0f$var$_QF = "QuoteFields";
const $45e1a5f717a7bf0f$var$_Qu = "Queue";
const $45e1a5f717a7bf0f$var$_R = "Range";
const $45e1a5f717a7bf0f$var$_RART = "RedirectAllRequestsTo";
const $45e1a5f717a7bf0f$var$_RC = "RequestCharged";
const $45e1a5f717a7bf0f$var$_RCC = "ResponseCacheControl";
const $45e1a5f717a7bf0f$var$_RCD = "ResponseContentDisposition";
const $45e1a5f717a7bf0f$var$_RCE = "ResponseContentEncoding";
const $45e1a5f717a7bf0f$var$_RCL = "ResponseContentLanguage";
const $45e1a5f717a7bf0f$var$_RCT = "ResponseContentType";
const $45e1a5f717a7bf0f$var$_RCe = "ReplicationConfiguration";
const $45e1a5f717a7bf0f$var$_RD = "RecordDelimiter";
const $45e1a5f717a7bf0f$var$_RE = "ResponseExpires";
const $45e1a5f717a7bf0f$var$_RED = "RestoreExpiryDate";
const $45e1a5f717a7bf0f$var$_RKKID = "ReplicaKmsKeyID";
const $45e1a5f717a7bf0f$var$_RKPW = "ReplaceKeyPrefixWith";
const $45e1a5f717a7bf0f$var$_RKW = "ReplaceKeyWith";
const $45e1a5f717a7bf0f$var$_RM = "ReplicaModifications";
const $45e1a5f717a7bf0f$var$_RMS = "ReplicaModificationsStatus";
const $45e1a5f717a7bf0f$var$_ROP = "RestoreOutputPath";
const $45e1a5f717a7bf0f$var$_RP = "RequestPayer";
const $45e1a5f717a7bf0f$var$_RPB = "RestrictPublicBuckets";
const $45e1a5f717a7bf0f$var$_RPC = "RequestPaymentConfiguration";
const $45e1a5f717a7bf0f$var$_RPe = "RequestProgress";
const $45e1a5f717a7bf0f$var$_RR = "RequestRoute";
const $45e1a5f717a7bf0f$var$_RRAO = "ReplicationRuleAndOperator";
const $45e1a5f717a7bf0f$var$_RRF = "ReplicationRuleFilter";
const $45e1a5f717a7bf0f$var$_RRS = "ReplicationRuleStatus";
const $45e1a5f717a7bf0f$var$_RRT = "RestoreRequestType";
const $45e1a5f717a7bf0f$var$_RRe = "ReplicationRule";
const $45e1a5f717a7bf0f$var$_RRes = "RestoreRequest";
const $45e1a5f717a7bf0f$var$_RRo = "RoutingRules";
const $45e1a5f717a7bf0f$var$_RRou = "RoutingRule";
const $45e1a5f717a7bf0f$var$_RS = "ReplicationStatus";
const $45e1a5f717a7bf0f$var$_RSe = "RestoreStatus";
const $45e1a5f717a7bf0f$var$_RT = "RequestToken";
const $45e1a5f717a7bf0f$var$_RTS = "ReplicationTimeStatus";
const $45e1a5f717a7bf0f$var$_RTV = "ReplicationTimeValue";
const $45e1a5f717a7bf0f$var$_RTe = "ReplicationTime";
const $45e1a5f717a7bf0f$var$_RUD = "RetainUntilDate";
const $45e1a5f717a7bf0f$var$_Re = "Restore";
const $45e1a5f717a7bf0f$var$_Red = "Redirect";
const $45e1a5f717a7bf0f$var$_Ro = "Role";
const $45e1a5f717a7bf0f$var$_Ru = "Rule";
const $45e1a5f717a7bf0f$var$_Rul = "Rules";
const $45e1a5f717a7bf0f$var$_S = "Status";
const $45e1a5f717a7bf0f$var$_SA = "StartAfter";
const $45e1a5f717a7bf0f$var$_SAK = "SecretAccessKey";
const $45e1a5f717a7bf0f$var$_SBD = "S3BucketDestination";
const $45e1a5f717a7bf0f$var$_SC = "StorageClass";
const $45e1a5f717a7bf0f$var$_SCA = "StorageClassAnalysis";
const $45e1a5f717a7bf0f$var$_SCADE = "StorageClassAnalysisDataExport";
const $45e1a5f717a7bf0f$var$_SCASV = "StorageClassAnalysisSchemaVersion";
const $45e1a5f717a7bf0f$var$_SCt = "StatusCode";
const $45e1a5f717a7bf0f$var$_SDV = "SkipDestinationValidation";
const $45e1a5f717a7bf0f$var$_SK = "SSE-KMS";
const $45e1a5f717a7bf0f$var$_SKEO = "SseKmsEncryptedObjects";
const $45e1a5f717a7bf0f$var$_SKEOS = "SseKmsEncryptedObjectsStatus";
const $45e1a5f717a7bf0f$var$_SKF = "S3KeyFilter";
const $45e1a5f717a7bf0f$var$_SKe = "S3Key";
const $45e1a5f717a7bf0f$var$_SL = "S3Location";
const $45e1a5f717a7bf0f$var$_SM = "SessionMode";
const $45e1a5f717a7bf0f$var$_SOCR = "SelectObjectContentRequest";
const $45e1a5f717a7bf0f$var$_SP = "SelectParameters";
const $45e1a5f717a7bf0f$var$_SPi = "SimplePrefix";
const $45e1a5f717a7bf0f$var$_SR = "ScanRange";
const $45e1a5f717a7bf0f$var$_SS = "SSE-S3";
const $45e1a5f717a7bf0f$var$_SSC = "SourceSelectionCriteria";
const $45e1a5f717a7bf0f$var$_SSE = "ServerSideEncryption";
const $45e1a5f717a7bf0f$var$_SSEA = "SSEAlgorithm";
const $45e1a5f717a7bf0f$var$_SSEBD = "ServerSideEncryptionByDefault";
const $45e1a5f717a7bf0f$var$_SSEC = "ServerSideEncryptionConfiguration";
const $45e1a5f717a7bf0f$var$_SSECA = "SSECustomerAlgorithm";
const $45e1a5f717a7bf0f$var$_SSECK = "SSECustomerKey";
const $45e1a5f717a7bf0f$var$_SSECKMD = "SSECustomerKeyMD5";
const $45e1a5f717a7bf0f$var$_SSEKMS = "SSEKMS";
const $45e1a5f717a7bf0f$var$_SSEKMSEC = "SSEKMSEncryptionContext";
const $45e1a5f717a7bf0f$var$_SSEKMSKI = "SSEKMSKeyId";
const $45e1a5f717a7bf0f$var$_SSER = "ServerSideEncryptionRule";
const $45e1a5f717a7bf0f$var$_SSES = "SSES3";
const $45e1a5f717a7bf0f$var$_ST = "SessionToken";
const $45e1a5f717a7bf0f$var$_S_ = "S3";
const $45e1a5f717a7bf0f$var$_Sc = "Schedule";
const $45e1a5f717a7bf0f$var$_Se = "Setting";
const $45e1a5f717a7bf0f$var$_Si = "Size";
const $45e1a5f717a7bf0f$var$_St = "Start";
const $45e1a5f717a7bf0f$var$_Su = "Suffix";
const $45e1a5f717a7bf0f$var$_T = "Tagging";
const $45e1a5f717a7bf0f$var$_TA = "TopicArn";
const $45e1a5f717a7bf0f$var$_TB = "TargetBucket";
const $45e1a5f717a7bf0f$var$_TC = "TagCount";
const $45e1a5f717a7bf0f$var$_TCo = "TopicConfiguration";
const $45e1a5f717a7bf0f$var$_TCop = "TopicConfigurations";
const $45e1a5f717a7bf0f$var$_TD = "TaggingDirective";
const $45e1a5f717a7bf0f$var$_TG = "TargetGrants";
const $45e1a5f717a7bf0f$var$_TGa = "TargetGrant";
const $45e1a5f717a7bf0f$var$_TOKF = "TargetObjectKeyFormat";
const $45e1a5f717a7bf0f$var$_TP = "TargetPrefix";
const $45e1a5f717a7bf0f$var$_TPC = "TotalPartsCount";
const $45e1a5f717a7bf0f$var$_TS = "TagSet";
const $45e1a5f717a7bf0f$var$_TSC = "TransitionStorageClass";
const $45e1a5f717a7bf0f$var$_Ta = "Tag";
const $45e1a5f717a7bf0f$var$_Tag = "Tags";
const $45e1a5f717a7bf0f$var$_Ti = "Tier";
const $45e1a5f717a7bf0f$var$_Tie = "Tierings";
const $45e1a5f717a7bf0f$var$_Tier = "Tiering";
const $45e1a5f717a7bf0f$var$_Tim = "Time";
const $45e1a5f717a7bf0f$var$_To = "Token";
const $45e1a5f717a7bf0f$var$_Top = "Topic";
const $45e1a5f717a7bf0f$var$_Tr = "Transitions";
const $45e1a5f717a7bf0f$var$_Tra = "Transition";
const $45e1a5f717a7bf0f$var$_Ty = "Type";
const $45e1a5f717a7bf0f$var$_U = "Upload";
const $45e1a5f717a7bf0f$var$_UI = "UploadId";
const $45e1a5f717a7bf0f$var$_UIM = "UploadIdMarker";
const $45e1a5f717a7bf0f$var$_UM = "UserMetadata";
const $45e1a5f717a7bf0f$var$_URI = "URI";
const $45e1a5f717a7bf0f$var$_Up = "Uploads";
const $45e1a5f717a7bf0f$var$_V = "Version";
const $45e1a5f717a7bf0f$var$_VC = "VersionCount";
const $45e1a5f717a7bf0f$var$_VCe = "VersioningConfiguration";
const $45e1a5f717a7bf0f$var$_VI = "VersionId";
const $45e1a5f717a7bf0f$var$_VIM = "VersionIdMarker";
const $45e1a5f717a7bf0f$var$_Va = "Value";
const $45e1a5f717a7bf0f$var$_Ve = "Versions";
const $45e1a5f717a7bf0f$var$_WC = "WebsiteConfiguration";
const $45e1a5f717a7bf0f$var$_WRL = "WebsiteRedirectLocation";
const $45e1a5f717a7bf0f$var$_Y = "Years";
const $45e1a5f717a7bf0f$var$_a = "analytics";
const $45e1a5f717a7bf0f$var$_ac = "accelerate";
const $45e1a5f717a7bf0f$var$_acl = "acl";
const $45e1a5f717a7bf0f$var$_ar = "accept-ranges";
const $45e1a5f717a7bf0f$var$_at = "attributes";
const $45e1a5f717a7bf0f$var$_c = "cors";
const $45e1a5f717a7bf0f$var$_cc = "cache-control";
const $45e1a5f717a7bf0f$var$_cd = "content-disposition";
const $45e1a5f717a7bf0f$var$_ce = "content-encoding";
const $45e1a5f717a7bf0f$var$_cl = "content-language";
const $45e1a5f717a7bf0f$var$_cl_ = "content-length";
const $45e1a5f717a7bf0f$var$_cm = "content-md5";
const $45e1a5f717a7bf0f$var$_cr = "content-range";
const $45e1a5f717a7bf0f$var$_ct = "content-type";
const $45e1a5f717a7bf0f$var$_ct_ = "continuation-token";
const $45e1a5f717a7bf0f$var$_d = "delete";
const $45e1a5f717a7bf0f$var$_de = "delimiter";
const $45e1a5f717a7bf0f$var$_e = "expires";
const $45e1a5f717a7bf0f$var$_en = "encryption";
const $45e1a5f717a7bf0f$var$_et = "encoding-type";
const $45e1a5f717a7bf0f$var$_eta = "etag";
const $45e1a5f717a7bf0f$var$_ex = "expiresstring";
const $45e1a5f717a7bf0f$var$_fo = "fetch-owner";
const $45e1a5f717a7bf0f$var$_i = "id";
const $45e1a5f717a7bf0f$var$_im = "if-match";
const $45e1a5f717a7bf0f$var$_ims = "if-modified-since";
const $45e1a5f717a7bf0f$var$_in = "inventory";
const $45e1a5f717a7bf0f$var$_inm = "if-none-match";
const $45e1a5f717a7bf0f$var$_it = "intelligent-tiering";
const $45e1a5f717a7bf0f$var$_ius = "if-unmodified-since";
const $45e1a5f717a7bf0f$var$_km = "key-marker";
const $45e1a5f717a7bf0f$var$_l = "lifecycle";
const $45e1a5f717a7bf0f$var$_lh = "legal-hold";
const $45e1a5f717a7bf0f$var$_lm = "last-modified";
const $45e1a5f717a7bf0f$var$_lo = "location";
const $45e1a5f717a7bf0f$var$_log = "logging";
const $45e1a5f717a7bf0f$var$_lt = "list-type";
const $45e1a5f717a7bf0f$var$_m = "metrics";
const $45e1a5f717a7bf0f$var$_ma = "marker";
const $45e1a5f717a7bf0f$var$_mb = "max-buckets";
const $45e1a5f717a7bf0f$var$_mdb = "max-directory-buckets";
const $45e1a5f717a7bf0f$var$_me = "member";
const $45e1a5f717a7bf0f$var$_mk = "max-keys";
const $45e1a5f717a7bf0f$var$_mp = "max-parts";
const $45e1a5f717a7bf0f$var$_mu = "max-uploads";
const $45e1a5f717a7bf0f$var$_n = "notification";
const $45e1a5f717a7bf0f$var$_oC = "ownershipControls";
const $45e1a5f717a7bf0f$var$_ol = "object-lock";
const $45e1a5f717a7bf0f$var$_p = "policy";
const $45e1a5f717a7bf0f$var$_pAB = "publicAccessBlock";
const $45e1a5f717a7bf0f$var$_pN = "partNumber";
const $45e1a5f717a7bf0f$var$_pS = "policyStatus";
const $45e1a5f717a7bf0f$var$_pnm = "part-number-marker";
const $45e1a5f717a7bf0f$var$_pr = "prefix";
const $45e1a5f717a7bf0f$var$_r = "replication";
const $45e1a5f717a7bf0f$var$_rP = "requestPayment";
const $45e1a5f717a7bf0f$var$_ra = "range";
const $45e1a5f717a7bf0f$var$_rcc = "response-cache-control";
const $45e1a5f717a7bf0f$var$_rcd = "response-content-disposition";
const $45e1a5f717a7bf0f$var$_rce = "response-content-encoding";
const $45e1a5f717a7bf0f$var$_rcl = "response-content-language";
const $45e1a5f717a7bf0f$var$_rct = "response-content-type";
const $45e1a5f717a7bf0f$var$_re = "response-expires";
const $45e1a5f717a7bf0f$var$_res = "restore";
const $45e1a5f717a7bf0f$var$_ret = "retention";
const $45e1a5f717a7bf0f$var$_s = "session";
const $45e1a5f717a7bf0f$var$_sa = "start-after";
const $45e1a5f717a7bf0f$var$_se = "select";
const $45e1a5f717a7bf0f$var$_st = "select-type";
const $45e1a5f717a7bf0f$var$_t = "tagging";
const $45e1a5f717a7bf0f$var$_to = "torrent";
const $45e1a5f717a7bf0f$var$_u = "uploads";
const $45e1a5f717a7bf0f$var$_uI = "uploadId";
const $45e1a5f717a7bf0f$var$_uim = "upload-id-marker";
const $45e1a5f717a7bf0f$var$_v = "versioning";
const $45e1a5f717a7bf0f$var$_vI = "versionId";
const $45e1a5f717a7bf0f$var$_ve = '<?xml version="1.0" encoding="UTF-8"?>';
const $45e1a5f717a7bf0f$var$_ver = "versions";
const $45e1a5f717a7bf0f$var$_vim = "version-id-marker";
const $45e1a5f717a7bf0f$var$_w = "website";
const $45e1a5f717a7bf0f$var$_x = "xsi:type";
const $45e1a5f717a7bf0f$var$_xaa = "x-amz-acl";
const $45e1a5f717a7bf0f$var$_xaad = "x-amz-abort-date";
const $45e1a5f717a7bf0f$var$_xaapa = "x-amz-access-point-alias";
const $45e1a5f717a7bf0f$var$_xaari = "x-amz-abort-rule-id";
const $45e1a5f717a7bf0f$var$_xaas = "x-amz-archive-status";
const $45e1a5f717a7bf0f$var$_xabgr = "x-amz-bypass-governance-retention";
const $45e1a5f717a7bf0f$var$_xabln = "x-amz-bucket-location-name";
const $45e1a5f717a7bf0f$var$_xablt = "x-amz-bucket-location-type";
const $45e1a5f717a7bf0f$var$_xabole = "x-amz-bucket-object-lock-enabled";
const $45e1a5f717a7bf0f$var$_xabolt = "x-amz-bucket-object-lock-token";
const $45e1a5f717a7bf0f$var$_xabr = "x-amz-bucket-region";
const $45e1a5f717a7bf0f$var$_xaca = "x-amz-checksum-algorithm";
const $45e1a5f717a7bf0f$var$_xacc = "x-amz-checksum-crc32";
const $45e1a5f717a7bf0f$var$_xacc_ = "x-amz-checksum-crc32c";
const $45e1a5f717a7bf0f$var$_xacm = "x-amz-checksum-mode";
const $45e1a5f717a7bf0f$var$_xacrsba = "x-amz-confirm-remove-self-bucket-access";
const $45e1a5f717a7bf0f$var$_xacs = "x-amz-checksum-sha1";
const $45e1a5f717a7bf0f$var$_xacs_ = "x-amz-checksum-sha256";
const $45e1a5f717a7bf0f$var$_xacs__ = "x-amz-copy-source";
const $45e1a5f717a7bf0f$var$_xacsim = "x-amz-copy-source-if-match";
const $45e1a5f717a7bf0f$var$_xacsims = "x-amz-copy-source-if-modified-since";
const $45e1a5f717a7bf0f$var$_xacsinm = "x-amz-copy-source-if-none-match";
const $45e1a5f717a7bf0f$var$_xacsius = "x-amz-copy-source-if-unmodified-since";
const $45e1a5f717a7bf0f$var$_xacsm = "x-amz-create-session-mode";
const $45e1a5f717a7bf0f$var$_xacsr = "x-amz-copy-source-range";
const $45e1a5f717a7bf0f$var$_xacssseca = "x-amz-copy-source-server-side-encryption-customer-algorithm";
const $45e1a5f717a7bf0f$var$_xacssseck = "x-amz-copy-source-server-side-encryption-customer-key";
const $45e1a5f717a7bf0f$var$_xacssseckm = "x-amz-copy-source-server-side-encryption-customer-key-md5";
const $45e1a5f717a7bf0f$var$_xacsvi = "x-amz-copy-source-version-id";
const $45e1a5f717a7bf0f$var$_xadm = "x-amz-delete-marker";
const $45e1a5f717a7bf0f$var$_xae = "x-amz-expiration";
const $45e1a5f717a7bf0f$var$_xaebo = "x-amz-expected-bucket-owner";
const $45e1a5f717a7bf0f$var$_xafec = "x-amz-fwd-error-code";
const $45e1a5f717a7bf0f$var$_xafem = "x-amz-fwd-error-message";
const $45e1a5f717a7bf0f$var$_xafhar = "x-amz-fwd-header-accept-ranges";
const $45e1a5f717a7bf0f$var$_xafhcc = "x-amz-fwd-header-cache-control";
const $45e1a5f717a7bf0f$var$_xafhcd = "x-amz-fwd-header-content-disposition";
const $45e1a5f717a7bf0f$var$_xafhce = "x-amz-fwd-header-content-encoding";
const $45e1a5f717a7bf0f$var$_xafhcl = "x-amz-fwd-header-content-language";
const $45e1a5f717a7bf0f$var$_xafhcr = "x-amz-fwd-header-content-range";
const $45e1a5f717a7bf0f$var$_xafhct = "x-amz-fwd-header-content-type";
const $45e1a5f717a7bf0f$var$_xafhe = "x-amz-fwd-header-etag";
const $45e1a5f717a7bf0f$var$_xafhe_ = "x-amz-fwd-header-expires";
const $45e1a5f717a7bf0f$var$_xafhlm = "x-amz-fwd-header-last-modified";
const $45e1a5f717a7bf0f$var$_xafhxacc = "x-amz-fwd-header-x-amz-checksum-crc32";
const $45e1a5f717a7bf0f$var$_xafhxacc_ = "x-amz-fwd-header-x-amz-checksum-crc32c";
const $45e1a5f717a7bf0f$var$_xafhxacs = "x-amz-fwd-header-x-amz-checksum-sha1";
const $45e1a5f717a7bf0f$var$_xafhxacs_ = "x-amz-fwd-header-x-amz-checksum-sha256";
const $45e1a5f717a7bf0f$var$_xafhxadm = "x-amz-fwd-header-x-amz-delete-marker";
const $45e1a5f717a7bf0f$var$_xafhxae = "x-amz-fwd-header-x-amz-expiration";
const $45e1a5f717a7bf0f$var$_xafhxamm = "x-amz-fwd-header-x-amz-missing-meta";
const $45e1a5f717a7bf0f$var$_xafhxampc = "x-amz-fwd-header-x-amz-mp-parts-count";
const $45e1a5f717a7bf0f$var$_xafhxaollh = "x-amz-fwd-header-x-amz-object-lock-legal-hold";
const $45e1a5f717a7bf0f$var$_xafhxaolm = "x-amz-fwd-header-x-amz-object-lock-mode";
const $45e1a5f717a7bf0f$var$_xafhxaolrud = "x-amz-fwd-header-x-amz-object-lock-retain-until-date";
const $45e1a5f717a7bf0f$var$_xafhxar = "x-amz-fwd-header-x-amz-restore";
const $45e1a5f717a7bf0f$var$_xafhxarc = "x-amz-fwd-header-x-amz-request-charged";
const $45e1a5f717a7bf0f$var$_xafhxars = "x-amz-fwd-header-x-amz-replication-status";
const $45e1a5f717a7bf0f$var$_xafhxasc = "x-amz-fwd-header-x-amz-storage-class";
const $45e1a5f717a7bf0f$var$_xafhxasse = "x-amz-fwd-header-x-amz-server-side-encryption";
const $45e1a5f717a7bf0f$var$_xafhxasseakki = "x-amz-fwd-header-x-amz-server-side-encryption-aws-kms-key-id";
const $45e1a5f717a7bf0f$var$_xafhxassebke = "x-amz-fwd-header-x-amz-server-side-encryption-bucket-key-enabled";
const $45e1a5f717a7bf0f$var$_xafhxasseca = "x-amz-fwd-header-x-amz-server-side-encryption-customer-algorithm";
const $45e1a5f717a7bf0f$var$_xafhxasseckm = "x-amz-fwd-header-x-amz-server-side-encryption-customer-key-md5";
const $45e1a5f717a7bf0f$var$_xafhxatc = "x-amz-fwd-header-x-amz-tagging-count";
const $45e1a5f717a7bf0f$var$_xafhxavi = "x-amz-fwd-header-x-amz-version-id";
const $45e1a5f717a7bf0f$var$_xafs = "x-amz-fwd-status";
const $45e1a5f717a7bf0f$var$_xagfc = "x-amz-grant-full-control";
const $45e1a5f717a7bf0f$var$_xagr = "x-amz-grant-read";
const $45e1a5f717a7bf0f$var$_xagra = "x-amz-grant-read-acp";
const $45e1a5f717a7bf0f$var$_xagw = "x-amz-grant-write";
const $45e1a5f717a7bf0f$var$_xagwa = "x-amz-grant-write-acp";
const $45e1a5f717a7bf0f$var$_xam = "x-amz-mfa";
const $45e1a5f717a7bf0f$var$_xamd = "x-amz-metadata-directive";
const $45e1a5f717a7bf0f$var$_xamm = "x-amz-missing-meta";
const $45e1a5f717a7bf0f$var$_xamp = "x-amz-max-parts";
const $45e1a5f717a7bf0f$var$_xampc = "x-amz-mp-parts-count";
const $45e1a5f717a7bf0f$var$_xaoa = "x-amz-object-attributes";
const $45e1a5f717a7bf0f$var$_xaollh = "x-amz-object-lock-legal-hold";
const $45e1a5f717a7bf0f$var$_xaolm = "x-amz-object-lock-mode";
const $45e1a5f717a7bf0f$var$_xaolrud = "x-amz-object-lock-retain-until-date";
const $45e1a5f717a7bf0f$var$_xaoo = "x-amz-object-ownership";
const $45e1a5f717a7bf0f$var$_xaooa = "x-amz-optional-object-attributes";
const $45e1a5f717a7bf0f$var$_xapnm = "x-amz-part-number-marker";
const $45e1a5f717a7bf0f$var$_xar = "x-amz-restore";
const $45e1a5f717a7bf0f$var$_xarc = "x-amz-request-charged";
const $45e1a5f717a7bf0f$var$_xarop = "x-amz-restore-output-path";
const $45e1a5f717a7bf0f$var$_xarp = "x-amz-request-payer";
const $45e1a5f717a7bf0f$var$_xarr = "x-amz-request-route";
const $45e1a5f717a7bf0f$var$_xars = "x-amz-replication-status";
const $45e1a5f717a7bf0f$var$_xart = "x-amz-request-token";
const $45e1a5f717a7bf0f$var$_xasc = "x-amz-storage-class";
const $45e1a5f717a7bf0f$var$_xasca = "x-amz-sdk-checksum-algorithm";
const $45e1a5f717a7bf0f$var$_xasdv = "x-amz-skip-destination-validation";
const $45e1a5f717a7bf0f$var$_xasebo = "x-amz-source-expected-bucket-owner";
const $45e1a5f717a7bf0f$var$_xasse = "x-amz-server-side-encryption";
const $45e1a5f717a7bf0f$var$_xasseakki = "x-amz-server-side-encryption-aws-kms-key-id";
const $45e1a5f717a7bf0f$var$_xassebke = "x-amz-server-side-encryption-bucket-key-enabled";
const $45e1a5f717a7bf0f$var$_xassec = "x-amz-server-side-encryption-context";
const $45e1a5f717a7bf0f$var$_xasseca = "x-amz-server-side-encryption-customer-algorithm";
const $45e1a5f717a7bf0f$var$_xasseck = "x-amz-server-side-encryption-customer-key";
const $45e1a5f717a7bf0f$var$_xasseckm = "x-amz-server-side-encryption-customer-key-md5";
const $45e1a5f717a7bf0f$var$_xat = "x-amz-tagging";
const $45e1a5f717a7bf0f$var$_xatc = "x-amz-tagging-count";
const $45e1a5f717a7bf0f$var$_xatd = "x-amz-tagging-directive";
const $45e1a5f717a7bf0f$var$_xavi = "x-amz-version-id";
const $45e1a5f717a7bf0f$var$_xawrl = "x-amz-website-redirect-location";
const $45e1a5f717a7bf0f$var$_xi = "x-id";


class $b242c7fe13169d1d$export$4afa2352f8871c26 extends (0, $21ebe134f0322abe$export$cc7e12c76513e857).classBuilder().ep({
    ...(0, $6f3a98a1538687cd$export$9c07ced2019f0ae0),
    Bucket: {
        type: "contextParams",
        name: "Bucket"
    },
    Key: {
        type: "contextParams",
        name: "Key"
    }
}).m(function(Command, cs, config, o) {
    return [
        (0, $5b9375668e859164$export$53fdc69654553fd4)(config, this.serialize, this.deserialize),
        (0, $a239f3bc183c0683$export$946c80457b765eab)(config, Command.getEndpointParameterInstructions()),
        (0, $cd0db87ef3895103$export$b3c55b56128dbf17)(config, {
            input: this.input,
            requestAlgorithmMember: "ChecksumAlgorithm",
            requestChecksumRequired: false
        }),
        (0, $c293dde488c95061$export$9cab92d587daac23)(config),
        (0, $32b56a6d9accc693$export$97cbbd0d754f3189)(config),
        (0, $db80f9dc151da2fd$export$baf25e0187b0946b)(config)
    ];
}).s("AmazonS3", "PutObject", {}).n("S3Client", "PutObjectCommand").f((0, $971b440947405896$export$35f8aea70e7bdcca), (0, $971b440947405896$export$4532cbbab0d00c4f)).ser((0, $45e1a5f717a7bf0f$export$80b592020f8ee8b7)).de((0, $45e1a5f717a7bf0f$export$7b5fb371239d4b24)).build() {
}


function $a5877f428f709978$export$ea55ca13ab589d75(options) {
    return (next)=>async (args)=>{
            const { request: request } = args;
            if ((0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(request) && request.body && options.runtime === "node") {
                if (options.requestHandler?.constructor?.name !== "FetchHttpHandler") request.headers = {
                    ...request.headers,
                    Expect: "100-continue"
                };
            }
            return next({
                ...args,
                request: request
            });
        };
}
const $a5877f428f709978$export$582010bfa3126ad3 = {
    step: "build",
    tags: [
        "SET_EXPECT_HEADER",
        "EXPECT_HEADER"
    ],
    name: "addExpectContinueMiddleware",
    override: true
};
const $a5877f428f709978$export$7692e5e7214e5cd1 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($a5877f428f709978$export$ea55ca13ab589d75(options), $a5877f428f709978$export$582010bfa3126ad3);
        }
    });




function $595a3e70bcaf65ce$export$c1625bf0b32b4481(input) {
    return input;
}
const $595a3e70bcaf65ce$export$858685d7aeef192d = (options)=>(next)=>async (args)=>{
            if (!(0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const { request: request } = args;
            const { handlerProtocol: handlerProtocol = "" } = options.requestHandler.metadata || {};
            if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                delete request.headers["host"];
                request.headers[":authority"] = request.hostname + (request.port ? ":" + request.port : "");
            } else if (!request.headers["host"]) {
                let host = request.hostname;
                if (request.port != null) host += `:${request.port}`;
                request.headers["host"] = host;
            }
            return next(args);
        };
const $595a3e70bcaf65ce$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
const $595a3e70bcaf65ce$export$23d3b647211be53a = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($595a3e70bcaf65ce$export$858685d7aeef192d(options), $595a3e70bcaf65ce$export$696d244ba96181e8);
        }
    });


const $e9c6b1e0e6ce110e$export$fe0e777ee4f58cde = ()=>(next, context)=>async (args)=>{
            try {
                const response = await next(args);
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog: overrideOutputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                const outputFilterSensitiveLog = overrideOutputFilterSensitiveLog ?? context.outputFilterSensitiveLog;
                const { $metadata: $metadata, ...outputWithoutMetadata } = response.output;
                logger?.info?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                    metadata: $metadata
                });
                return response;
            } catch (error) {
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                logger?.error?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    error: error,
                    metadata: error.$metadata
                });
                throw error;
            }
        };
const $e9c6b1e0e6ce110e$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
const $e9c6b1e0e6ce110e$export$f6ef65d7766fc255 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($e9c6b1e0e6ce110e$export$fe0e777ee4f58cde(), $e9c6b1e0e6ce110e$export$877c148ab4ad0722);
        }
    });





var $75dc674caa964d8d$exports = {};
// shim for using process in browser
var $75dc674caa964d8d$var$process = $75dc674caa964d8d$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $75dc674caa964d8d$var$cachedSetTimeout;
var $75dc674caa964d8d$var$cachedClearTimeout;
function $75dc674caa964d8d$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $75dc674caa964d8d$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $75dc674caa964d8d$var$cachedSetTimeout = setTimeout;
        else $75dc674caa964d8d$var$cachedSetTimeout = $75dc674caa964d8d$var$defaultSetTimout;
    } catch (e) {
        $75dc674caa964d8d$var$cachedSetTimeout = $75dc674caa964d8d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $75dc674caa964d8d$var$cachedClearTimeout = clearTimeout;
        else $75dc674caa964d8d$var$cachedClearTimeout = $75dc674caa964d8d$var$defaultClearTimeout;
    } catch (e) {
        $75dc674caa964d8d$var$cachedClearTimeout = $75dc674caa964d8d$var$defaultClearTimeout;
    }
})();
function $75dc674caa964d8d$var$runTimeout(fun) {
    if ($75dc674caa964d8d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($75dc674caa964d8d$var$cachedSetTimeout === $75dc674caa964d8d$var$defaultSetTimout || !$75dc674caa964d8d$var$cachedSetTimeout) && setTimeout) {
        $75dc674caa964d8d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $75dc674caa964d8d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $75dc674caa964d8d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $75dc674caa964d8d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $75dc674caa964d8d$var$runClearTimeout(marker) {
    if ($75dc674caa964d8d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($75dc674caa964d8d$var$cachedClearTimeout === $75dc674caa964d8d$var$defaultClearTimeout || !$75dc674caa964d8d$var$cachedClearTimeout) && clearTimeout) {
        $75dc674caa964d8d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $75dc674caa964d8d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $75dc674caa964d8d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $75dc674caa964d8d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $75dc674caa964d8d$var$queue = [];
var $75dc674caa964d8d$var$draining = false;
var $75dc674caa964d8d$var$currentQueue;
var $75dc674caa964d8d$var$queueIndex = -1;
function $75dc674caa964d8d$var$cleanUpNextTick() {
    if (!$75dc674caa964d8d$var$draining || !$75dc674caa964d8d$var$currentQueue) return;
    $75dc674caa964d8d$var$draining = false;
    if ($75dc674caa964d8d$var$currentQueue.length) $75dc674caa964d8d$var$queue = $75dc674caa964d8d$var$currentQueue.concat($75dc674caa964d8d$var$queue);
    else $75dc674caa964d8d$var$queueIndex = -1;
    if ($75dc674caa964d8d$var$queue.length) $75dc674caa964d8d$var$drainQueue();
}
function $75dc674caa964d8d$var$drainQueue() {
    if ($75dc674caa964d8d$var$draining) return;
    var timeout = $75dc674caa964d8d$var$runTimeout($75dc674caa964d8d$var$cleanUpNextTick);
    $75dc674caa964d8d$var$draining = true;
    var len = $75dc674caa964d8d$var$queue.length;
    while(len){
        $75dc674caa964d8d$var$currentQueue = $75dc674caa964d8d$var$queue;
        $75dc674caa964d8d$var$queue = [];
        while(++$75dc674caa964d8d$var$queueIndex < len)if ($75dc674caa964d8d$var$currentQueue) $75dc674caa964d8d$var$currentQueue[$75dc674caa964d8d$var$queueIndex].run();
        $75dc674caa964d8d$var$queueIndex = -1;
        len = $75dc674caa964d8d$var$queue.length;
    }
    $75dc674caa964d8d$var$currentQueue = null;
    $75dc674caa964d8d$var$draining = false;
    $75dc674caa964d8d$var$runClearTimeout(timeout);
}
$75dc674caa964d8d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $75dc674caa964d8d$var$queue.push(new $75dc674caa964d8d$var$Item(fun, args));
    if ($75dc674caa964d8d$var$queue.length === 1 && !$75dc674caa964d8d$var$draining) $75dc674caa964d8d$var$runTimeout($75dc674caa964d8d$var$drainQueue);
};
// v8 likes predictible objects
function $75dc674caa964d8d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$75dc674caa964d8d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$75dc674caa964d8d$var$process.title = 'browser';
$75dc674caa964d8d$var$process.browser = true;
$75dc674caa964d8d$var$process.env = {};
$75dc674caa964d8d$var$process.argv = [];
$75dc674caa964d8d$var$process.version = ''; // empty string to avoid regexp issues
$75dc674caa964d8d$var$process.versions = {};
function $75dc674caa964d8d$var$noop() {}
$75dc674caa964d8d$var$process.on = $75dc674caa964d8d$var$noop;
$75dc674caa964d8d$var$process.addListener = $75dc674caa964d8d$var$noop;
$75dc674caa964d8d$var$process.once = $75dc674caa964d8d$var$noop;
$75dc674caa964d8d$var$process.off = $75dc674caa964d8d$var$noop;
$75dc674caa964d8d$var$process.removeListener = $75dc674caa964d8d$var$noop;
$75dc674caa964d8d$var$process.removeAllListeners = $75dc674caa964d8d$var$noop;
$75dc674caa964d8d$var$process.emit = $75dc674caa964d8d$var$noop;
$75dc674caa964d8d$var$process.prependListener = $75dc674caa964d8d$var$noop;
$75dc674caa964d8d$var$process.prependOnceListener = $75dc674caa964d8d$var$noop;
$75dc674caa964d8d$var$process.listeners = function(name) {
    return [];
};
$75dc674caa964d8d$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$75dc674caa964d8d$var$process.cwd = function() {
    return '/';
};
$75dc674caa964d8d$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$75dc674caa964d8d$var$process.umask = function() {
    return 0;
};


const $4e2c384433fa29cd$var$TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
const $4e2c384433fa29cd$var$ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
const $4e2c384433fa29cd$var$ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
const $4e2c384433fa29cd$export$d12885408d4c0634 = (options)=>(next)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty($4e2c384433fa29cd$var$TRACE_ID_HEADER_NAME)) return next(args);
            const functionName = $75dc674caa964d8d$exports.env[$4e2c384433fa29cd$var$ENV_LAMBDA_FUNCTION_NAME];
            const traceId = $75dc674caa964d8d$exports.env[$4e2c384433fa29cd$var$ENV_TRACE_ID];
            const nonEmptyString = (str)=>typeof str === "string" && str.length > 0;
            if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[$4e2c384433fa29cd$var$TRACE_ID_HEADER_NAME] = traceId;
            return next({
                ...args,
                request: request
            });
        };
const $4e2c384433fa29cd$export$1f1705db3faed8f3 = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
const $4e2c384433fa29cd$export$11d0b9345788bd5 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($4e2c384433fa29cd$export$d12885408d4c0634(options), $4e2c384433fa29cd$export$1f1705db3faed8f3);
        }
    });



function $82f38ee817687adf$export$ec9a2d5663958cb(input) {
    return {
        ...input,
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    };
}


class $9d81209341f48a16$export$262eb2e4804ef909 {
    constructor({ size: size, params: params }){
        this.data = new Map();
        this.parameters = [];
        this.capacity = size ?? 50;
        if (params) this.parameters = params;
    }
    get(endpointParams, resolver) {
        const key = this.hash(endpointParams);
        if (key === false) return resolver();
        if (!this.data.has(key)) {
            if (this.data.size > this.capacity + 10) {
                const keys = this.data.keys();
                let i = 0;
                while(true){
                    const { value: value, done: done } = keys.next();
                    this.data.delete(value);
                    if (done || ++i > 10) break;
                }
            }
            this.data.set(key, resolver());
        }
        return this.data.get(key);
    }
    size() {
        return this.data.size;
    }
    hash(endpointParams) {
        let buffer = "";
        const { parameters: parameters } = this;
        if (parameters.length === 0) return false;
        for (const param of parameters){
            const val = String(endpointParams[param] ?? "");
            if (val.includes("|;")) return false;
            buffer += val + "|;";
        }
        return buffer;
    }
}


const $b9f093067acb2b88$var$IP_V4_REGEX = new RegExp(`^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$`);
const $b9f093067acb2b88$export$2c835f0fe38d2e0e = (value)=>$b9f093067acb2b88$var$IP_V4_REGEX.test(value) || value.startsWith("[") && value.endsWith("]");


const $f07cc3516c9e2d84$var$VALID_HOST_LABEL_REGEX = new RegExp(`^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$`);
const $f07cc3516c9e2d84$export$8a024457acd8bb49 = (value, allowSubDomains = false)=>{
    if (!allowSubDomains) return $f07cc3516c9e2d84$var$VALID_HOST_LABEL_REGEX.test(value);
    const labels = value.split(".");
    for (const label of labels){
        if (!$f07cc3516c9e2d84$export$8a024457acd8bb49(label)) return false;
    }
    return true;
};


const $1efb1fecaf394dc7$export$2614fba0847da171 = {};


const $cbbc5fdd278143f4$export$2a09d6727e5ecede = "endpoints";


function $5af610d75b4a62f2$export$7b48b8905f46d631(input) {
    if (typeof input !== "object" || input == null) return input;
    if ("ref" in input) return `$${$5af610d75b4a62f2$export$7b48b8905f46d631(input.ref)}`;
    if ("fn" in input) return `${input.fn}(${(input.argv || []).map($5af610d75b4a62f2$export$7b48b8905f46d631).join(", ")})`;
    return JSON.stringify(input, null, 2);
}




class $5da99cb522dbc6f4$export$603f31e9980bccaf extends Error {
    constructor(message){
        super(message);
        this.name = "EndpointError";
    }
}























const $1bf1237f2408dd31$export$6608cbdc537206b3 = (value1, value2)=>value1 === value2;




const $7a4cc2caae3969be$export$e8fa1ee343c456a5 = (path)=>{
    const parts = path.split(".");
    const pathList = [];
    for (const part of parts){
        const squareBracketIndex = part.indexOf("[");
        if (squareBracketIndex !== -1) {
            if (part.indexOf("]") !== part.length - 1) throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Path: '${path}' does not end with ']'`);
            const arrayIndex = part.slice(squareBracketIndex + 1, -1);
            if (Number.isNaN(parseInt(arrayIndex))) throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Invalid array index: '${arrayIndex}' in path: '${path}'`);
            if (squareBracketIndex !== 0) pathList.push(part.slice(0, squareBracketIndex));
            pathList.push(arrayIndex);
        } else pathList.push(part);
    }
    return pathList;
};


const $1e0cc5de3012cbd0$export$6a93fe6b2b4c71a0 = (value, path)=>(0, $7a4cc2caae3969be$export$e8fa1ee343c456a5)(path).reduce((acc, index)=>{
        if (typeof acc !== "object") throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Index '${index}' in '${path}' not found in '${JSON.stringify(value)}'`);
        else if (Array.isArray(acc)) return acc[parseInt(index)];
        return acc[index];
    }, value);


const $c518d4b6f87840be$export$6750766a7c7ec627 = (value)=>value != null;



const $fd58732bef89ae21$export$6003a5f097c73977 = (value)=>!value;




const $c6ada3baf7e92c61$var$DEFAULT_PORTS = {
    [(0, $d52acda0f7253006$export$b141d049add1dcb5).HTTP]: 80,
    [(0, $d52acda0f7253006$export$b141d049add1dcb5).HTTPS]: 443
};
const $c6ada3baf7e92c61$export$4b3d9a5bae55976 = (value)=>{
    const whatwgURL = (()=>{
        try {
            if (value instanceof URL) return value;
            if (typeof value === "object" && "hostname" in value) {
                const { hostname: hostname, port: port, protocol: protocol = "", path: path = "", query: query = {} } = value;
                const url = new URL(`${protocol}//${hostname}${port ? `:${port}` : ""}${path}`);
                url.search = Object.entries(query).map(([k, v])=>`${k}=${v}`).join("&");
                return url;
            }
            return new URL(value);
        } catch (error) {
            return null;
        }
    })();
    if (!whatwgURL) {
        console.error(`Unable to parse ${JSON.stringify(value)} as a whatwg URL.`);
        return null;
    }
    const urlString = whatwgURL.href;
    const { host: host, hostname: hostname, pathname: pathname, protocol: protocol, search: search } = whatwgURL;
    if (search) return null;
    const scheme = protocol.slice(0, -1);
    if (!Object.values((0, $d52acda0f7253006$export$b141d049add1dcb5)).includes(scheme)) return null;
    const isIp = (0, $b9f093067acb2b88$export$2c835f0fe38d2e0e)(hostname);
    const inputContainsDefaultPort = urlString.includes(`${host}:${$c6ada3baf7e92c61$var$DEFAULT_PORTS[scheme]}`) || typeof value === "string" && value.includes(`${host}:${$c6ada3baf7e92c61$var$DEFAULT_PORTS[scheme]}`);
    const authority = `${host}${inputContainsDefaultPort ? `:${$c6ada3baf7e92c61$var$DEFAULT_PORTS[scheme]}` : ``}`;
    return {
        scheme: scheme,
        authority: authority,
        path: pathname,
        normalizedPath: pathname.endsWith("/") ? pathname : `${pathname}/`,
        isIp: isIp
    };
};


const $1691ab46b5f86ae9$export$f8f73f238947765e = (value1, value2)=>value1 === value2;


const $8599aeff3bdeb483$export$662d3818631fba36 = (input, start, stop, reverse)=>{
    if (start >= stop || input.length < stop) return null;
    if (!reverse) return input.substring(start, stop);
    return input.substring(input.length - stop, input.length - start);
};


const $3c0ca9676daed7fc$export$1ea6cdab375898b5 = (value)=>encodeURIComponent(value).replace(/[!*'()]/g, (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`);




const $f7a4cebe2ae6fa9a$export$fffca6040ff170c9 = {
    booleanEquals: $1bf1237f2408dd31$export$6608cbdc537206b3,
    getAttr: $1e0cc5de3012cbd0$export$6a93fe6b2b4c71a0,
    isSet: $c518d4b6f87840be$export$6750766a7c7ec627,
    isValidHostLabel: $f07cc3516c9e2d84$export$8a024457acd8bb49,
    not: $fd58732bef89ae21$export$6003a5f097c73977,
    parseURL: $c6ada3baf7e92c61$export$4b3d9a5bae55976,
    stringEquals: $1691ab46b5f86ae9$export$f8f73f238947765e,
    substring: $8599aeff3bdeb483$export$662d3818631fba36,
    uriEncode: $3c0ca9676daed7fc$export$1ea6cdab375898b5
};





const $22cc85c1fa2c6ac7$export$c77ca0e5a2c5469c = (template, options)=>{
    const evaluatedTemplateArr = [];
    const templateContext = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    let currentIndex = 0;
    while(currentIndex < template.length){
        const openingBraceIndex = template.indexOf("{", currentIndex);
        if (openingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(currentIndex));
            break;
        }
        evaluatedTemplateArr.push(template.slice(currentIndex, openingBraceIndex));
        const closingBraceIndex = template.indexOf("}", openingBraceIndex);
        if (closingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex));
            break;
        }
        if (template[openingBraceIndex + 1] === "{" && template[closingBraceIndex + 1] === "}") {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex + 1, closingBraceIndex));
            currentIndex = closingBraceIndex + 2;
        }
        const parameterName = template.substring(openingBraceIndex + 1, closingBraceIndex);
        if (parameterName.includes("#")) {
            const [refName, attrName] = parameterName.split("#");
            evaluatedTemplateArr.push((0, $1e0cc5de3012cbd0$export$6a93fe6b2b4c71a0)(templateContext[refName], attrName));
        } else evaluatedTemplateArr.push(templateContext[parameterName]);
        currentIndex = closingBraceIndex + 1;
    }
    return evaluatedTemplateArr.join("");
};


const $02a921e533adb8b5$export$812bd59fe014e418 = ({ ref: ref }, options)=>{
    const referenceRecord = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    return referenceRecord[ref];
};


const $04f74b3a97a04bca$export$3191fa0ae67b450c = (obj, keyName, options)=>{
    if (typeof obj === "string") return (0, $22cc85c1fa2c6ac7$export$c77ca0e5a2c5469c)(obj, options);
    else if (obj["fn"]) return (0, $5671c69c50bfdf0e$export$d883fbf232f0d35a)(obj, options);
    else if (obj["ref"]) return (0, $02a921e533adb8b5$export$812bd59fe014e418)(obj, options);
    throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`'${keyName}': ${String(obj)} is not a string, function or reference.`);
};


const $5671c69c50bfdf0e$export$d883fbf232f0d35a = ({ fn: fn, argv: argv }, options)=>{
    const evaluatedArgs = argv.map((arg)=>[
            "boolean",
            "number"
        ].includes(typeof arg) ? arg : (0, $04f74b3a97a04bca$export$3191fa0ae67b450c)(arg, "arg", options));
    const fnSegments = fn.split(".");
    if (fnSegments[0] in (0, $1efb1fecaf394dc7$export$2614fba0847da171) && fnSegments[1] != null) return (0, $1efb1fecaf394dc7$export$2614fba0847da171)[fnSegments[0]][fnSegments[1]](...evaluatedArgs);
    return (0, $f7a4cebe2ae6fa9a$export$fffca6040ff170c9)[fn](...evaluatedArgs);
};


const $31e81bfa50931e3b$export$6695392473e235ae = ({ assign: assign, ...fnArgs }, options)=>{
    if (assign && assign in options.referenceRecord) throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`'${assign}' is already defined in Reference Record.`);
    const value = (0, $5671c69c50bfdf0e$export$d883fbf232f0d35a)(fnArgs, options);
    options.logger?.debug?.(`${(0, $cbbc5fdd278143f4$export$2a09d6727e5ecede)} evaluateCondition: ${(0, $5af610d75b4a62f2$export$7b48b8905f46d631)(fnArgs)} = ${(0, $5af610d75b4a62f2$export$7b48b8905f46d631)(value)}`);
    return {
        result: value === "" ? true : !!value,
        ...assign != null && {
            toAssign: {
                name: assign,
                value: value
            }
        }
    };
};


const $dde3c55e9cd36996$export$bad219652748f1f3 = (conditions = [], options)=>{
    const conditionsReferenceRecord = {};
    for (const condition of conditions){
        const { result: result, toAssign: toAssign } = (0, $31e81bfa50931e3b$export$6695392473e235ae)(condition, {
            ...options,
            referenceRecord: {
                ...options.referenceRecord,
                ...conditionsReferenceRecord
            }
        });
        if (!result) return {
            result: result
        };
        if (toAssign) {
            conditionsReferenceRecord[toAssign.name] = toAssign.value;
            options.logger?.debug?.(`${(0, $cbbc5fdd278143f4$export$2a09d6727e5ecede)} assign: ${toAssign.name} := ${(0, $5af610d75b4a62f2$export$7b48b8905f46d631)(toAssign.value)}`);
        }
    }
    return {
        result: true,
        referenceRecord: conditionsReferenceRecord
    };
};




const $1291331a93801352$export$479dec716600cbb = (headers, options)=>Object.entries(headers).reduce((acc, [headerKey, headerVal])=>({
            ...acc,
            [headerKey]: headerVal.map((headerValEntry)=>{
                const processedExpr = (0, $04f74b3a97a04bca$export$3191fa0ae67b450c)(headerValEntry, "Header value entry", options);
                if (typeof processedExpr !== "string") throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Header '${headerKey}' value '${processedExpr}' is not a string`);
                return processedExpr;
            })
        }), {});





const $db7391b48e07599d$export$39bc8a0c7360c2f4 = (property, options)=>{
    if (Array.isArray(property)) return property.map((propertyEntry)=>$db7391b48e07599d$export$39bc8a0c7360c2f4(propertyEntry, options));
    switch(typeof property){
        case "string":
            return (0, $22cc85c1fa2c6ac7$export$c77ca0e5a2c5469c)(property, options);
        case "object":
            if (property === null) throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Unexpected endpoint property: ${property}`);
            return (0, $bc065ec6f80cdb28$export$f7b44341c2929056)(property, options);
        case "boolean":
            return property;
        default:
            throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Unexpected endpoint property type: ${typeof property}`);
    }
};


const $bc065ec6f80cdb28$export$f7b44341c2929056 = (properties, options)=>Object.entries(properties).reduce((acc, [propertyKey, propertyVal])=>({
            ...acc,
            [propertyKey]: (0, $db7391b48e07599d$export$39bc8a0c7360c2f4)(propertyVal, options)
        }), {});




const $a2eab23baf2db59a$export$c54f5a49b5be9709 = (endpointUrl, options)=>{
    const expression = (0, $04f74b3a97a04bca$export$3191fa0ae67b450c)(endpointUrl, "Endpoint URL", options);
    if (typeof expression === "string") try {
        return new URL(expression);
    } catch (error) {
        console.error(`Failed to construct URL with ${expression}`, error);
        throw error;
    }
    throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Endpoint URL must be a string, got ${typeof expression}`);
};


const $cf63b06b57d08123$export$791799461674b1cb = (endpointRule, options)=>{
    const { conditions: conditions, endpoint: endpoint } = endpointRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $dde3c55e9cd36996$export$bad219652748f1f3)(conditions, options);
    if (!result) return;
    const endpointRuleOptions = {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    };
    const { url: url, properties: properties, headers: headers } = endpoint;
    options.logger?.debug?.(`${(0, $cbbc5fdd278143f4$export$2a09d6727e5ecede)} Resolving endpoint from template: ${(0, $5af610d75b4a62f2$export$7b48b8905f46d631)(endpoint)}`);
    return {
        ...headers != undefined && {
            headers: (0, $1291331a93801352$export$479dec716600cbb)(headers, endpointRuleOptions)
        },
        ...properties != undefined && {
            properties: (0, $bc065ec6f80cdb28$export$f7b44341c2929056)(properties, endpointRuleOptions)
        },
        url: (0, $a2eab23baf2db59a$export$c54f5a49b5be9709)(url, endpointRuleOptions)
    };
};





const $5425f3518cce3d39$export$a36dfbc7e1fb8626 = (errorRule, options)=>{
    const { conditions: conditions, error: error } = errorRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $dde3c55e9cd36996$export$bad219652748f1f3)(conditions, options);
    if (!result) return;
    throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)((0, $04f74b3a97a04bca$export$3191fa0ae67b450c)(error, "Error", {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    }));
};




const $2d7aa314159e2853$export$2e518b103c26ca79 = (treeRule, options)=>{
    const { conditions: conditions, rules: rules } = treeRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $dde3c55e9cd36996$export$bad219652748f1f3)(conditions, options);
    if (!result) return;
    return (0, $aa9b7214d40f62d9$export$cd6fa289eb934f12)(rules, {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    });
};


const $aa9b7214d40f62d9$export$cd6fa289eb934f12 = (rules, options)=>{
    for (const rule of rules){
        if (rule.type === "endpoint") {
            const endpointOrUndefined = (0, $cf63b06b57d08123$export$791799461674b1cb)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else if (rule.type === "error") (0, $5425f3518cce3d39$export$a36dfbc7e1fb8626)(rule, options);
        else if (rule.type === "tree") {
            const endpointOrUndefined = (0, $2d7aa314159e2853$export$2e518b103c26ca79)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Unknown endpoint rule: ${rule}`);
    }
    throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Rules evaluation failed`);
};




const $b169f1dc494e85ef$export$48b88e4e5ecac119 = (ruleSetObject, options)=>{
    const { endpointParams: endpointParams, logger: logger } = options;
    const { parameters: parameters, rules: rules } = ruleSetObject;
    options.logger?.debug?.(`${(0, $cbbc5fdd278143f4$export$2a09d6727e5ecede)} Initial EndpointParams: ${(0, $5af610d75b4a62f2$export$7b48b8905f46d631)(endpointParams)}`);
    const paramsWithDefault = Object.entries(parameters).filter(([, v])=>v.default != null).map(([k, v])=>[
            k,
            v.default
        ]);
    if (paramsWithDefault.length > 0) for (const [paramKey, paramDefaultValue] of paramsWithDefault)endpointParams[paramKey] = endpointParams[paramKey] ?? paramDefaultValue;
    const requiredParams = Object.entries(parameters).filter(([, v])=>v.required).map(([k])=>k);
    for (const requiredParam of requiredParams){
        if (endpointParams[requiredParam] == null) throw new (0, $5da99cb522dbc6f4$export$603f31e9980bccaf)(`Missing required parameter: '${requiredParam}'`);
    }
    const endpoint = (0, $aa9b7214d40f62d9$export$cd6fa289eb934f12)(rules, {
        endpointParams: endpointParams,
        logger: logger,
        referenceRecord: {}
    });
    options.logger?.debug?.(`${(0, $cbbc5fdd278143f4$export$2a09d6727e5ecede)} Resolved endpoint: ${(0, $5af610d75b4a62f2$export$7b48b8905f46d631)(endpoint)}`);
    return endpoint;
};









const $04a0eaf68e8f866e$export$6b6a3f4e857868ec = (value, allowSubDomains = false)=>{
    if (allowSubDomains) {
        for (const label of value.split(".")){
            if (!$04a0eaf68e8f866e$export$6b6a3f4e857868ec(label)) return false;
        }
        return true;
    }
    if (!(0, $f07cc3516c9e2d84$export$8a024457acd8bb49)(value)) return false;
    if (value.length < 3 || value.length > 63) return false;
    if (value !== value.toLowerCase()) return false;
    if ((0, $b9f093067acb2b88$export$2c835f0fe38d2e0e)(value)) return false;
    return true;
};


const $5c30f5b7e40727dc$var$ARN_DELIMITER = ":";
const $5c30f5b7e40727dc$var$RESOURCE_DELIMITER = "/";
const $5c30f5b7e40727dc$export$ec6a98ce8737fc2c = (value)=>{
    const segments = value.split($5c30f5b7e40727dc$var$ARN_DELIMITER);
    if (segments.length < 6) return null;
    const [arn, partition, service, region, accountId, ...resourcePath] = segments;
    if (arn !== "arn" || partition === "" || service === "" || resourcePath.join($5c30f5b7e40727dc$var$ARN_DELIMITER) === "") return null;
    const resourceId = resourcePath.map((resource)=>resource.split($5c30f5b7e40727dc$var$RESOURCE_DELIMITER)).flat();
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resourceId: resourceId
    };
};


var $a97bff061491a597$exports = {};
$a97bff061491a597$exports = JSON.parse("{\"partitions\":[{\"id\":\"aws\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com\",\"dualStackDnsSuffix\":\"api.aws\",\"implicitGlobalRegion\":\"us-east-1\",\"name\":\"aws\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^(us|eu|ap|sa|ca|me|af|il|mx)\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"af-south-1\":{\"description\":\"Africa (Cape Town)\"},\"ap-east-1\":{\"description\":\"Asia Pacific (Hong Kong)\"},\"ap-northeast-1\":{\"description\":\"Asia Pacific (Tokyo)\"},\"ap-northeast-2\":{\"description\":\"Asia Pacific (Seoul)\"},\"ap-northeast-3\":{\"description\":\"Asia Pacific (Osaka)\"},\"ap-south-1\":{\"description\":\"Asia Pacific (Mumbai)\"},\"ap-south-2\":{\"description\":\"Asia Pacific (Hyderabad)\"},\"ap-southeast-1\":{\"description\":\"Asia Pacific (Singapore)\"},\"ap-southeast-2\":{\"description\":\"Asia Pacific (Sydney)\"},\"ap-southeast-3\":{\"description\":\"Asia Pacific (Jakarta)\"},\"ap-southeast-4\":{\"description\":\"Asia Pacific (Melbourne)\"},\"ap-southeast-5\":{\"description\":\"Asia Pacific (Malaysia)\"},\"aws-global\":{\"description\":\"AWS Standard global region\"},\"ca-central-1\":{\"description\":\"Canada (Central)\"},\"ca-west-1\":{\"description\":\"Canada West (Calgary)\"},\"eu-central-1\":{\"description\":\"Europe (Frankfurt)\"},\"eu-central-2\":{\"description\":\"Europe (Zurich)\"},\"eu-north-1\":{\"description\":\"Europe (Stockholm)\"},\"eu-south-1\":{\"description\":\"Europe (Milan)\"},\"eu-south-2\":{\"description\":\"Europe (Spain)\"},\"eu-west-1\":{\"description\":\"Europe (Ireland)\"},\"eu-west-2\":{\"description\":\"Europe (London)\"},\"eu-west-3\":{\"description\":\"Europe (Paris)\"},\"il-central-1\":{\"description\":\"Israel (Tel Aviv)\"},\"me-central-1\":{\"description\":\"Middle East (UAE)\"},\"me-south-1\":{\"description\":\"Middle East (Bahrain)\"},\"sa-east-1\":{\"description\":\"South America (Sao Paulo)\"},\"us-east-1\":{\"description\":\"US East (N. Virginia)\"},\"us-east-2\":{\"description\":\"US East (Ohio)\"},\"us-west-1\":{\"description\":\"US West (N. California)\"},\"us-west-2\":{\"description\":\"US West (Oregon)\"}}},{\"id\":\"aws-cn\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com.cn\",\"dualStackDnsSuffix\":\"api.amazonwebservices.com.cn\",\"implicitGlobalRegion\":\"cn-northwest-1\",\"name\":\"aws-cn\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^cn\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-cn-global\":{\"description\":\"AWS China global region\"},\"cn-north-1\":{\"description\":\"China (Beijing)\"},\"cn-northwest-1\":{\"description\":\"China (Ningxia)\"}}},{\"id\":\"aws-us-gov\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com\",\"dualStackDnsSuffix\":\"api.aws\",\"implicitGlobalRegion\":\"us-gov-west-1\",\"name\":\"aws-us-gov\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-gov\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-us-gov-global\":{\"description\":\"AWS GovCloud (US) global region\"},\"us-gov-east-1\":{\"description\":\"AWS GovCloud (US-East)\"},\"us-gov-west-1\":{\"description\":\"AWS GovCloud (US-West)\"}}},{\"id\":\"aws-iso\",\"outputs\":{\"dnsSuffix\":\"c2s.ic.gov\",\"dualStackDnsSuffix\":\"c2s.ic.gov\",\"implicitGlobalRegion\":\"us-iso-east-1\",\"name\":\"aws-iso\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-iso\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-global\":{\"description\":\"AWS ISO (US) global region\"},\"us-iso-east-1\":{\"description\":\"US ISO East\"},\"us-iso-west-1\":{\"description\":\"US ISO WEST\"}}},{\"id\":\"aws-iso-b\",\"outputs\":{\"dnsSuffix\":\"sc2s.sgov.gov\",\"dualStackDnsSuffix\":\"sc2s.sgov.gov\",\"implicitGlobalRegion\":\"us-isob-east-1\",\"name\":\"aws-iso-b\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-isob\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-b-global\":{\"description\":\"AWS ISOB (US) global region\"},\"us-isob-east-1\":{\"description\":\"US ISOB East (Ohio)\"}}},{\"id\":\"aws-iso-e\",\"outputs\":{\"dnsSuffix\":\"cloud.adc-e.uk\",\"dualStackDnsSuffix\":\"cloud.adc-e.uk\",\"implicitGlobalRegion\":\"eu-isoe-west-1\",\"name\":\"aws-iso-e\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^eu\\\\-isoe\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"eu-isoe-west-1\":{\"description\":\"EU ISOE West\"}}},{\"id\":\"aws-iso-f\",\"outputs\":{\"dnsSuffix\":\"csp.hci.ic.gov\",\"dualStackDnsSuffix\":\"csp.hci.ic.gov\",\"implicitGlobalRegion\":\"us-isof-south-1\",\"name\":\"aws-iso-f\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-isof\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{}}],\"version\":\"1.1\"}");


let $957247ab745e3add$var$selectedPartitionsInfo = (0, (/*@__PURE__*/$parcel$interopDefault($a97bff061491a597$exports)));
let $957247ab745e3add$var$selectedUserAgentPrefix = "";
const $957247ab745e3add$export$b29f828819edca8d = (value)=>{
    const { partitions: partitions } = $957247ab745e3add$var$selectedPartitionsInfo;
    for (const partition of partitions){
        const { regions: regions, outputs: outputs } = partition;
        for (const [region, regionData] of Object.entries(regions)){
            if (region === value) return {
                ...outputs,
                ...regionData
            };
        }
    }
    for (const partition of partitions){
        const { regionRegex: regionRegex, outputs: outputs } = partition;
        if (new RegExp(regionRegex).test(value)) return {
            ...outputs
        };
    }
    const DEFAULT_PARTITION = partitions.find((partition)=>partition.id === "aws");
    if (!DEFAULT_PARTITION) throw new Error("Provided region was not found in the partition array or regex, and default partition with id 'aws' doesn't exist.");
    return {
        ...DEFAULT_PARTITION.outputs
    };
};
const $957247ab745e3add$export$5b2daaf969a6da2e = (partitionsInfo, userAgentPrefix = "")=>{
    $957247ab745e3add$var$selectedPartitionsInfo = partitionsInfo;
    $957247ab745e3add$var$selectedUserAgentPrefix = userAgentPrefix;
};
const $957247ab745e3add$export$1003c50da40cdce = ()=>{
    $957247ab745e3add$export$5b2daaf969a6da2e((0, (/*@__PURE__*/$parcel$interopDefault($a97bff061491a597$exports))), "");
};
const $957247ab745e3add$export$c249da7071246380 = ()=>$957247ab745e3add$var$selectedUserAgentPrefix;


const $e0d4557714be146d$export$1bfd97ffc6d0eef8 = {
    isVirtualHostableS3Bucket: (0, $04a0eaf68e8f866e$export$6b6a3f4e857868ec),
    parseArn: (0, $5c30f5b7e40727dc$export$ec6a98ce8737fc2c),
    partition: (0, $957247ab745e3add$export$b29f828819edca8d)
};
(0, $1efb1fecaf394dc7$export$2614fba0847da171).aws = $e0d4557714be146d$export$1bfd97ffc6d0eef8;

























const $5e1078232e047005$export$97a08a1bb7ee0545 = "user-agent";
const $5e1078232e047005$export$e010e3d6246262a3 = "x-amz-user-agent";
const $5e1078232e047005$export$27b7b95a5fde2b31 = " ";
const $5e1078232e047005$export$43290ff793d1777d = "/";
const $5e1078232e047005$export$2d1b87b5b2a59af3 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;
const $5e1078232e047005$export$84cb6e726944481 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w\#]/g;
const $5e1078232e047005$export$f810014d932f8c3e = "-";


const $3fbf02e27f5744df$export$62c460923941c0b0 = (options)=>(next, context)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(request)) return next(args);
            const { headers: headers } = request;
            const userAgent = context?.userAgent?.map($3fbf02e27f5744df$var$escapeUserAgent) || [];
            const defaultUserAgent = (await options.defaultUserAgentProvider()).map($3fbf02e27f5744df$var$escapeUserAgent);
            const customUserAgent = options?.customUserAgent?.map($3fbf02e27f5744df$var$escapeUserAgent) || [];
            const prefix = (0, $957247ab745e3add$export$c249da7071246380)();
            const sdkUserAgentValue = (prefix ? [
                prefix
            ] : []).concat([
                ...defaultUserAgent,
                ...userAgent,
                ...customUserAgent
            ]).join((0, $5e1078232e047005$export$27b7b95a5fde2b31));
            const normalUAValue = [
                ...defaultUserAgent.filter((section)=>section.startsWith("aws-sdk-")),
                ...customUserAgent
            ].join((0, $5e1078232e047005$export$27b7b95a5fde2b31));
            if (options.runtime !== "browser") {
                if (normalUAValue) headers[0, $5e1078232e047005$export$e010e3d6246262a3] = headers[0, $5e1078232e047005$export$e010e3d6246262a3] ? `${headers[0, $5e1078232e047005$export$97a08a1bb7ee0545]} ${normalUAValue}` : normalUAValue;
                headers[0, $5e1078232e047005$export$97a08a1bb7ee0545] = sdkUserAgentValue;
            } else headers[0, $5e1078232e047005$export$e010e3d6246262a3] = sdkUserAgentValue;
            return next({
                ...args,
                request: request
            });
        };
const $3fbf02e27f5744df$var$escapeUserAgent = (userAgentPair)=>{
    const name = userAgentPair[0].split((0, $5e1078232e047005$export$43290ff793d1777d)).map((part)=>part.replace((0, $5e1078232e047005$export$2d1b87b5b2a59af3), (0, $5e1078232e047005$export$f810014d932f8c3e))).join((0, $5e1078232e047005$export$43290ff793d1777d));
    const version = userAgentPair[1]?.replace((0, $5e1078232e047005$export$84cb6e726944481), (0, $5e1078232e047005$export$f810014d932f8c3e));
    const prefixSeparatorIndex = name.indexOf((0, $5e1078232e047005$export$43290ff793d1777d));
    const prefix = name.substring(0, prefixSeparatorIndex);
    let uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter((item)=>item && item.length > 0).reduce((acc, item, index)=>{
        switch(index){
            case 0:
                return item;
            case 1:
                return `${acc}/${item}`;
            default:
                return `${acc}#${item}`;
        }
    }, "");
};
const $3fbf02e27f5744df$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
const $3fbf02e27f5744df$export$5393c0d2d7f4f5f0 = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($3fbf02e27f5744df$export$62c460923941c0b0(config), $3fbf02e27f5744df$export$29eb04da6afef73f);
        }
    });





const $070dc7231f6b186c$export$eacd91361c129033 = "AWS_USE_DUALSTACK_ENDPOINT";
const $070dc7231f6b186c$export$71f82540e79c63bf = "use_dualstack_endpoint";
const $070dc7231f6b186c$export$beb01fae7626c427 = false;
const $070dc7231f6b186c$export$522137fc0ae615ab = {
    environmentVariableSelector: (env)=>(0, $d24cab3bba32e8b4$export$f8c4049184e0ac3f)(env, $070dc7231f6b186c$export$eacd91361c129033, (0, $eb4cfe18aa41a21a$export$4e8b093ec8dcab0d).ENV),
    configFileSelector: (profile)=>(0, $d24cab3bba32e8b4$export$f8c4049184e0ac3f)(profile, $070dc7231f6b186c$export$71f82540e79c63bf, (0, $eb4cfe18aa41a21a$export$4e8b093ec8dcab0d).CONFIG),
    default: false
};



const $145959cf010d2c12$export$b7eebc18f98c6d7f = "AWS_USE_FIPS_ENDPOINT";
const $145959cf010d2c12$export$30cf725f60d4be3e = "use_fips_endpoint";
const $145959cf010d2c12$export$5555deeca435a10b = false;
const $145959cf010d2c12$export$42f76cc8f259f4b8 = {
    environmentVariableSelector: (env)=>(0, $d24cab3bba32e8b4$export$f8c4049184e0ac3f)(env, $145959cf010d2c12$export$b7eebc18f98c6d7f, (0, $eb4cfe18aa41a21a$export$4e8b093ec8dcab0d).ENV),
    configFileSelector: (profile)=>(0, $d24cab3bba32e8b4$export$f8c4049184e0ac3f)(profile, $145959cf010d2c12$export$30cf725f60d4be3e, (0, $eb4cfe18aa41a21a$export$4e8b093ec8dcab0d).CONFIG),
    default: false
};



const $9a8d8f10a32f32f5$export$6cd750975e36686c = (input)=>{
    const { endpoint: endpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: (0, $c725887315749781$export$b1276c07738d6325)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, $c725887315749781$export$b1276c07738d6325)(input.useDualstackEndpoint ?? false)
    };
};



const $bd3b01635d0dae4b$export$c69bd155af41e6f1 = async (input)=>{
    const { tls: tls = true } = input;
    const region = await input.region();
    const dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
    const useDualstackEndpoint = await input.useDualstackEndpoint();
    const useFipsEndpoint = await input.useFipsEndpoint();
    const { hostname: hostname } = await input.regionInfoProvider(region, {
        useDualstackEndpoint: useDualstackEndpoint,
        useFipsEndpoint: useFipsEndpoint
    }) ?? {};
    if (!hostname) throw new Error("Cannot resolve hostname from client config");
    return input.urlParser(`${tls ? "https:" : "http:"}//${hostname}`);
};


const $48969f0a3eb81d0a$export$24f352b1bd1e2f8b = (input)=>{
    const useDualstackEndpoint = (0, $c725887315749781$export$b1276c07738d6325)(input.useDualstackEndpoint ?? false);
    const { endpoint: endpoint, useFipsEndpoint: useFipsEndpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: endpoint ? (0, $c725887315749781$export$b1276c07738d6325)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : ()=>(0, $bd3b01635d0dae4b$export$c69bd155af41e6f1)({
                ...input,
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }),
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
};




const $a95aa4169b797b16$export$26513716e2900bad = "AWS_REGION";
const $a95aa4169b797b16$export$8afb1c306a7d01b = "region";
const $a95aa4169b797b16$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$a95aa4169b797b16$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$a95aa4169b797b16$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $a95aa4169b797b16$export$9a37503ca194454d = {
    preferredFile: "credentials"
};


const $70c866d87a1a7639$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));


const $ac4a6282f937255d$export$ecbdf004a8547a7f = (region)=>(0, $70c866d87a1a7639$export$cc893cb7e6a508dd)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;



const $193ca8b4cd43cadc$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return {
        ...input,
        region: async ()=>{
            if (typeof region === "string") return (0, $ac4a6282f937255d$export$ecbdf004a8547a7f)(region);
            const providedRegion = await region();
            return (0, $ac4a6282f937255d$export$ecbdf004a8547a7f)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $70c866d87a1a7639$export$cc893cb7e6a508dd)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    };
};








const $8f3f0eb256732f8d$export$75494cb913bf7ef6 = (variants = [], { useFipsEndpoint: useFipsEndpoint, useDualstackEndpoint: useDualstackEndpoint })=>variants.find(({ tags: tags })=>useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack"))?.hostname;


const $37a12db4fd98be28$export$d062b2a57a5d579b = (resolvedRegion, { regionHostname: regionHostname, partitionHostname: partitionHostname })=>regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;


const $00e9a3c708f76cf2$export$2ba1c8e181ae49f8 = (region, { partitionHash: partitionHash })=>Object.keys(partitionHash || {}).find((key)=>partitionHash[key].regions.includes(region)) ?? "aws";


const $d7fea72be9455fec$export$be75b39beeb48b5c = (hostname, { signingRegion: signingRegion, regionRegex: regionRegex, useFipsEndpoint: useFipsEndpoint })=>{
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        const regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        const regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};


const $b910fa206751c478$export$2b789d827caebed0 = (region, { useFipsEndpoint: useFipsEndpoint = false, useDualstackEndpoint: useDualstackEndpoint = false, signingService: signingService, regionHash: regionHash, partitionHash: partitionHash })=>{
    const partition = (0, $00e9a3c708f76cf2$export$2ba1c8e181ae49f8)(region, {
        partitionHash: partitionHash
    });
    const resolvedRegion = region in regionHash ? region : partitionHash[partition]?.endpoint ?? region;
    const hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    const regionHostname = (0, $8f3f0eb256732f8d$export$75494cb913bf7ef6)(regionHash[resolvedRegion]?.variants, hostnameOptions);
    const partitionHostname = (0, $8f3f0eb256732f8d$export$75494cb913bf7ef6)(partitionHash[partition]?.variants, hostnameOptions);
    const hostname = (0, $37a12db4fd98be28$export$d062b2a57a5d579b)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error(`Endpoint resolution failed for: ${{
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }}`);
    const signingRegion = (0, $d7fea72be9455fec$export$be75b39beeb48b5c)(hostname, {
        signingRegion: regionHash[resolvedRegion]?.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return {
        partition: partition,
        signingService: signingService,
        hostname: hostname,
        ...signingRegion && {
            signingRegion: signingRegion
        },
        ...regionHash[resolvedRegion]?.signingService && {
            signingService: regionHash[resolvedRegion].signingService
        }
    };
};







const $7d0a4a87429f4ad7$export$5e2ae00bf65442f0 = (input)=>({
        ...input,
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });





const $4c73293e516924e8$var$CONTENT_LENGTH_HEADER = "content-length";
function $4c73293e516924e8$export$940b29eb2788b975(bodyLengthChecker) {
    return (next)=>async (args)=>{
            const request = args.request;
            if ((0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(request)) {
                const { body: body, headers: headers } = request;
                if (body && Object.keys(headers).map((str)=>str.toLowerCase()).indexOf($4c73293e516924e8$var$CONTENT_LENGTH_HEADER) === -1) try {
                    const length = bodyLengthChecker(body);
                    request.headers = {
                        ...request.headers,
                        [$4c73293e516924e8$var$CONTENT_LENGTH_HEADER]: String(length)
                    };
                } catch (error) {}
            }
            return next({
                ...args,
                request: request
            });
        };
}
const $4c73293e516924e8$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
const $4c73293e516924e8$export$7e6ddf9365a30fe9 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($4c73293e516924e8$export$940b29eb2788b975(options.bodyLengthChecker), $4c73293e516924e8$export$1f7816f8f350b2f5);
        }
    });






class $50bbf44b02e10279$export$478ec1fdae99aa79 extends Error {
    constructor(message, options = true){
        let logger;
        let tryNextLink = true;
        if (typeof options === "boolean") {
            logger = undefined;
            tryNextLink = options;
        } else if (options != null && typeof options === "object") {
            logger = options.logger;
            tryNextLink = options.tryNextLink ?? true;
        }
        super(message);
        this.name = "ProviderError";
        this.tryNextLink = tryNextLink;
        Object.setPrototypeOf(this, $50bbf44b02e10279$export$478ec1fdae99aa79.prototype);
        logger?.debug?.(`@smithy/property-provider ${tryNextLink ? "->" : "(!)"} ${message}`);
    }
    static from(error, options = true) {
        return Object.assign(new this(error.message, options), error);
    }
}


class $263698327335125d$export$921076535eff0df5 extends (0, $50bbf44b02e10279$export$478ec1fdae99aa79) {
    constructor(message, options = true){
        super(message, options);
        this.name = "CredentialsProviderError";
        Object.setPrototypeOf(this, $263698327335125d$export$921076535eff0df5.prototype);
    }
}




class $17698f66ef68fde2$export$5c605c2f83e2f56b extends (0, $50bbf44b02e10279$export$478ec1fdae99aa79) {
    constructor(message, options = true){
        super(message, options);
        this.name = "TokenProviderError";
        Object.setPrototypeOf(this, $17698f66ef68fde2$export$5c605c2f83e2f56b.prototype);
    }
}



const $f3dd97d7721776a1$export$e08e3b67e392101e = (...providers)=>async ()=>{
        if (providers.length === 0) throw new (0, $50bbf44b02e10279$export$478ec1fdae99aa79)("No providers in chain");
        let lastProviderError;
        for (const provider of providers)try {
            const credentials = await provider();
            return credentials;
        } catch (err) {
            lastProviderError = err;
            if (err?.tryNextLink) continue;
            throw err;
        }
        throw lastProviderError;
    };


const $54d3dc3612cacd55$export$294ab423a8f4a426 = (staticValue)=>()=>Promise.resolve(staticValue);


const $dfbbfa0f5ddf7bfc$export$fc10aeed3a532e2a = (provider, isExpired, requiresRefresh)=>{
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async ()=>{
        if (!pending) pending = provider();
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        if (isConstant) return resolved;
        if (requiresRefresh && !requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider();
            return resolved;
        }
        return resolved;
    };
};




const $b22594fd29f7762d$export$f3c0a1c0e9557d6b = (config)=>{
    config.sigv4aSigningRegionSet = (0, $7d37e26bc4ee159f$export$b1276c07738d6325)(config.sigv4aSigningRegionSet);
    return config;
};
const $b22594fd29f7762d$export$45597e0468567441 = {
    environmentVariableSelector (env) {
        if (env.AWS_SIGV4A_SIGNING_REGION_SET) return env.AWS_SIGV4A_SIGNING_REGION_SET.split(",").map((_)=>_.trim());
        throw new (0, $50bbf44b02e10279$export$478ec1fdae99aa79)("AWS_SIGV4A_SIGNING_REGION_SET not set in env.", {
            tryNextLink: true
        });
    },
    configFileSelector (profile) {
        if (profile.sigv4a_signing_region_set) return (profile.sigv4a_signing_region_set ?? "").split(",").map((_)=>_.trim());
        throw new (0, $50bbf44b02e10279$export$478ec1fdae99aa79)("sigv4a_signing_region_set not set in profile.", {
            tryNextLink: true
        });
    },
    default: undefined
};



const $16283d5b0805f93c$export$e18f3f8a841a90ec = (config)=>{
    let normalizedCreds;
    if (config.credentials) normalizedCreds = (0, $ad4febab86c9dd74$export$b258763a05c20e85)(config.credentials, (0, $ad4febab86c9dd74$export$42a11a4dafc8f476), (0, $ad4febab86c9dd74$export$5fef7ca5b4791fa9));
    if (!normalizedCreds) {
        if (config.credentialDefaultProvider) normalizedCreds = (0, $7d37e26bc4ee159f$export$b1276c07738d6325)(config.credentialDefaultProvider(Object.assign({}, config, {
            parentClientConfig: config
        })));
        else normalizedCreds = async ()=>{
            throw new Error("`credentials` is missing");
        };
    }
    const { signingEscapePath: signingEscapePath = true, systemClockOffset: systemClockOffset = config.systemClockOffset || 0, sha256: sha256 } = config;
    let signer;
    if (config.signer) signer = (0, $7d37e26bc4ee159f$export$b1276c07738d6325)(config.signer);
    else if (config.regionInfoProvider) signer = ()=>(0, $7d37e26bc4ee159f$export$b1276c07738d6325)(config.region)().then(async (region)=>[
                await config.regionInfoProvider(region, {
                    useFipsEndpoint: await config.useFipsEndpoint(),
                    useDualstackEndpoint: await config.useDualstackEndpoint()
                }) || {},
                region
            ]).then(([regionInfo, region])=>{
            const { signingRegion: signingRegion, signingService: signingService } = regionInfo;
            config.signingRegion = config.signingRegion || signingRegion || region;
            config.signingName = config.signingName || signingService || config.serviceId;
            const params = {
                ...config,
                credentials: normalizedCreds,
                region: config.signingRegion,
                service: config.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            };
            const SignerCtor = config.signerConstructor || (0, $deda4bd537ce369b$export$20baf4d3f65eb30c);
            return new SignerCtor(params);
        });
    else signer = async (authScheme)=>{
        authScheme = Object.assign({}, {
            name: "sigv4",
            signingName: config.signingName || config.defaultSigningName,
            signingRegion: await (0, $7d37e26bc4ee159f$export$b1276c07738d6325)(config.region)(),
            properties: {}
        }, authScheme);
        const signingRegion = authScheme.signingRegion;
        const signingService = authScheme.signingName;
        config.signingRegion = config.signingRegion || signingRegion;
        config.signingName = config.signingName || signingService || config.serviceId;
        const params = {
            ...config,
            credentials: normalizedCreds,
            region: config.signingRegion,
            service: config.signingName,
            sha256: sha256,
            uriEscapePath: signingEscapePath
        };
        const SignerCtor = config.signerConstructor || (0, $deda4bd537ce369b$export$20baf4d3f65eb30c);
        return new SignerCtor(params);
    };
    return {
        ...config,
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    };
};
const $16283d5b0805f93c$export$d85a20fa3e1218b1 = $16283d5b0805f93c$export$e18f3f8a841a90ec;



const $fffab07a6c30e081$export$7c225a620e2ca4fe = {
    CrtSignerV4: null
};


class $9a7bea7ba9b05dd8$export$9b641ca3a5f7a09 {
    constructor(options){
        this.sigv4Signer = new (0, $c53165f0defd1ffe$export$390c799677821231)(options);
        this.signerOptions = options;
    }
    async sign(requestToSign, options = {}) {
        if (options.signingRegion === "*") {
            if (this.signerOptions.runtime !== "node") throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
            return this.getSigv4aSigner().sign(requestToSign, options);
        }
        return this.sigv4Signer.sign(requestToSign, options);
    }
    async signWithCredentials(requestToSign, credentials, options = {}) {
        if (options.signingRegion === "*") {
            if (this.signerOptions.runtime !== "node") throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
            return this.getSigv4aSigner().signWithCredentials(requestToSign, credentials, options);
        }
        return this.sigv4Signer.signWithCredentials(requestToSign, credentials, options);
    }
    async presign(originalRequest, options = {}) {
        if (options.signingRegion === "*") {
            if (this.signerOptions.runtime !== "node") throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
            return this.getSigv4aSigner().presign(originalRequest, options);
        }
        return this.sigv4Signer.presign(originalRequest, options);
    }
    async presignWithCredentials(originalRequest, credentials, options = {}) {
        if (options.signingRegion === "*") throw new Error("Method presignWithCredentials is not supported for [signingRegion=*].");
        return this.sigv4Signer.presignWithCredentials(originalRequest, credentials, options);
    }
    getSigv4aSigner() {
        if (!this.sigv4aSigner) {
            let CrtSignerV4 = null;
            try {
                CrtSignerV4 = (0, $fffab07a6c30e081$export$7c225a620e2ca4fe).CrtSignerV4;
                if (typeof CrtSignerV4 !== "function") throw new Error();
            } catch (e) {
                e.message = `${e.message}\n` + `Please check whether you have installed the "@aws-sdk/signature-v4-crt" package explicitly. \n` + `You must also register the package by calling [require("@aws-sdk/signature-v4-crt");] ` + `or an ESM equivalent such as [import "@aws-sdk/signature-v4-crt";]. \n` + "For more information please go to " + "https://github.com/aws/aws-sdk-js-v3#functionality-requiring-aws-common-runtime-crt";
                throw e;
            }
            this.sigv4aSigner = new CrtSignerV4({
                ...this.signerOptions,
                signingAlgorithm: 1
            });
        }
        return this.sigv4aSigner;
    }
}









const $1ac07ed6efda80da$var$ce = "required", $1ac07ed6efda80da$var$cf = "type", $1ac07ed6efda80da$var$cg = "conditions", $1ac07ed6efda80da$var$ch = "fn", $1ac07ed6efda80da$var$ci = "argv", $1ac07ed6efda80da$var$cj = "ref", $1ac07ed6efda80da$var$ck = "assign", $1ac07ed6efda80da$var$cl = "url", $1ac07ed6efda80da$var$cm = "properties", $1ac07ed6efda80da$var$cn = "backend", $1ac07ed6efda80da$var$co = "authSchemes", $1ac07ed6efda80da$var$cp = "disableDoubleEncoding", $1ac07ed6efda80da$var$cq = "signingName", $1ac07ed6efda80da$var$cr = "signingRegion", $1ac07ed6efda80da$var$cs = "headers", $1ac07ed6efda80da$var$ct = "signingRegionSet";
const $1ac07ed6efda80da$var$a = false, $1ac07ed6efda80da$var$b = true, $1ac07ed6efda80da$var$c = "isSet", $1ac07ed6efda80da$var$d = "booleanEquals", $1ac07ed6efda80da$var$e = "error", $1ac07ed6efda80da$var$f = "aws.partition", $1ac07ed6efda80da$var$g = "stringEquals", $1ac07ed6efda80da$var$h = "getAttr", $1ac07ed6efda80da$var$i = "name", $1ac07ed6efda80da$var$j = "substring", $1ac07ed6efda80da$var$k = "bucketSuffix", $1ac07ed6efda80da$var$l = "parseURL", $1ac07ed6efda80da$var$m = "{url#scheme}://{url#authority}/{uri_encoded_bucket}{url#path}", $1ac07ed6efda80da$var$n = "endpoint", $1ac07ed6efda80da$var$o = "tree", $1ac07ed6efda80da$var$p = "aws.isVirtualHostableS3Bucket", $1ac07ed6efda80da$var$q = "{url#scheme}://{Bucket}.{url#authority}{url#path}", $1ac07ed6efda80da$var$r = "not", $1ac07ed6efda80da$var$s = "{url#scheme}://{url#authority}{url#path}", $1ac07ed6efda80da$var$t = "hardwareType", $1ac07ed6efda80da$var$u = "regionPrefix", $1ac07ed6efda80da$var$v = "bucketAliasSuffix", $1ac07ed6efda80da$var$w = "outpostId", $1ac07ed6efda80da$var$x = "isValidHostLabel", $1ac07ed6efda80da$var$y = "sigv4a", $1ac07ed6efda80da$var$z = "s3-outposts", $1ac07ed6efda80da$var$A = "s3", $1ac07ed6efda80da$var$B = "{url#scheme}://{url#authority}{url#normalizedPath}{Bucket}", $1ac07ed6efda80da$var$C = "https://{Bucket}.s3-accelerate.{partitionResult#dnsSuffix}", $1ac07ed6efda80da$var$D = "https://{Bucket}.s3.{partitionResult#dnsSuffix}", $1ac07ed6efda80da$var$E = "aws.parseArn", $1ac07ed6efda80da$var$F = "bucketArn", $1ac07ed6efda80da$var$G = "arnType", $1ac07ed6efda80da$var$H = "", $1ac07ed6efda80da$var$I = "s3-object-lambda", $1ac07ed6efda80da$var$J = "accesspoint", $1ac07ed6efda80da$var$K = "accessPointName", $1ac07ed6efda80da$var$L = "{url#scheme}://{accessPointName}-{bucketArn#accountId}.{url#authority}{url#path}", $1ac07ed6efda80da$var$M = "mrapPartition", $1ac07ed6efda80da$var$N = "outpostType", $1ac07ed6efda80da$var$O = "arnPrefix", $1ac07ed6efda80da$var$P = "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", $1ac07ed6efda80da$var$Q = "https://s3.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", $1ac07ed6efda80da$var$R = "https://s3.{partitionResult#dnsSuffix}", $1ac07ed6efda80da$var$S = {
    [$1ac07ed6efda80da$var$ce]: false,
    [$1ac07ed6efda80da$var$cf]: "String"
}, $1ac07ed6efda80da$var$T = {
    [$1ac07ed6efda80da$var$ce]: true,
    "default": false,
    [$1ac07ed6efda80da$var$cf]: "Boolean"
}, $1ac07ed6efda80da$var$U = {
    [$1ac07ed6efda80da$var$ce]: false,
    [$1ac07ed6efda80da$var$cf]: "Boolean"
}, $1ac07ed6efda80da$var$V = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "Accelerate"
        },
        true
    ]
}, $1ac07ed6efda80da$var$W = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "UseFIPS"
        },
        true
    ]
}, $1ac07ed6efda80da$var$X = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "UseDualStack"
        },
        true
    ]
}, $1ac07ed6efda80da$var$Y = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "Endpoint"
        }
    ]
}, $1ac07ed6efda80da$var$Z = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$f,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "Region"
        }
    ],
    [$1ac07ed6efda80da$var$ck]: "partitionResult"
}, $1ac07ed6efda80da$var$aa = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
            [$1ac07ed6efda80da$var$ci]: [
                {
                    [$1ac07ed6efda80da$var$cj]: "partitionResult"
                },
                $1ac07ed6efda80da$var$i
            ]
        },
        "aws-cn"
    ]
}, $1ac07ed6efda80da$var$ab = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "Bucket"
        }
    ]
}, $1ac07ed6efda80da$var$ac = {
    [$1ac07ed6efda80da$var$cj]: "Bucket"
}, $1ac07ed6efda80da$var$ad = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$l,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "Endpoint"
        }
    ],
    [$1ac07ed6efda80da$var$ck]: "url"
}, $1ac07ed6efda80da$var$ae = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
            [$1ac07ed6efda80da$var$ci]: [
                {
                    [$1ac07ed6efda80da$var$cj]: "url"
                },
                "isIp"
            ]
        },
        true
    ]
}, $1ac07ed6efda80da$var$af = {
    [$1ac07ed6efda80da$var$cj]: "url"
}, $1ac07ed6efda80da$var$ag = {
    [$1ac07ed6efda80da$var$ch]: "uriEncode",
    [$1ac07ed6efda80da$var$ci]: [
        $1ac07ed6efda80da$var$ac
    ],
    [$1ac07ed6efda80da$var$ck]: "uri_encoded_bucket"
}, $1ac07ed6efda80da$var$ah = {
    [$1ac07ed6efda80da$var$cn]: "S3Express",
    [$1ac07ed6efda80da$var$co]: [
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: "sigv4",
            [$1ac07ed6efda80da$var$cq]: "s3express",
            [$1ac07ed6efda80da$var$cr]: "{Region}"
        }
    ]
}, $1ac07ed6efda80da$var$ai = {}, $1ac07ed6efda80da$var$aj = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$p,
    [$1ac07ed6efda80da$var$ci]: [
        $1ac07ed6efda80da$var$ac,
        false
    ]
}, $1ac07ed6efda80da$var$ak = {
    [$1ac07ed6efda80da$var$e]: "S3Express bucket name is not a valid virtual hostable name.",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$al = {
    [$1ac07ed6efda80da$var$cn]: "S3Express",
    [$1ac07ed6efda80da$var$co]: [
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: "sigv4-s3express",
            [$1ac07ed6efda80da$var$cq]: "s3express",
            [$1ac07ed6efda80da$var$cr]: "{Region}"
        }
    ]
}, $1ac07ed6efda80da$var$am = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "UseS3ExpressControlEndpoint"
        }
    ]
}, $1ac07ed6efda80da$var$an = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "UseS3ExpressControlEndpoint"
        },
        true
    ]
}, $1ac07ed6efda80da$var$ao = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
    [$1ac07ed6efda80da$var$ci]: [
        $1ac07ed6efda80da$var$Y
    ]
}, $1ac07ed6efda80da$var$ap = {
    [$1ac07ed6efda80da$var$e]: "Unrecognized S3Express bucket name format.",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$aq = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
    [$1ac07ed6efda80da$var$ci]: [
        $1ac07ed6efda80da$var$ab
    ]
}, $1ac07ed6efda80da$var$ar = {
    [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$t
}, $1ac07ed6efda80da$var$as = {
    [$1ac07ed6efda80da$var$cg]: [
        $1ac07ed6efda80da$var$ao
    ],
    [$1ac07ed6efda80da$var$e]: "Expected a endpoint to be specified but no endpoint was found",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$at = {
    [$1ac07ed6efda80da$var$co]: [
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: $1ac07ed6efda80da$var$y,
            [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$z,
            [$1ac07ed6efda80da$var$ct]: [
                "*"
            ]
        },
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: "sigv4",
            [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$z,
            [$1ac07ed6efda80da$var$cr]: "{Region}"
        }
    ]
}, $1ac07ed6efda80da$var$au = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "ForcePathStyle"
        },
        false
    ]
}, $1ac07ed6efda80da$var$av = {
    [$1ac07ed6efda80da$var$cj]: "ForcePathStyle"
}, $1ac07ed6efda80da$var$aw = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "Accelerate"
        },
        false
    ]
}, $1ac07ed6efda80da$var$ax = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "Region"
        },
        "aws-global"
    ]
}, $1ac07ed6efda80da$var$ay = {
    [$1ac07ed6efda80da$var$co]: [
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: "sigv4",
            [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$A,
            [$1ac07ed6efda80da$var$cr]: "us-east-1"
        }
    ]
}, $1ac07ed6efda80da$var$az = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
    [$1ac07ed6efda80da$var$ci]: [
        $1ac07ed6efda80da$var$ax
    ]
}, $1ac07ed6efda80da$var$aA = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "UseGlobalEndpoint"
        },
        true
    ]
}, $1ac07ed6efda80da$var$aB = {
    [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}",
    [$1ac07ed6efda80da$var$cm]: {
        [$1ac07ed6efda80da$var$co]: [
            {
                [$1ac07ed6efda80da$var$cp]: true,
                [$1ac07ed6efda80da$var$i]: "sigv4",
                [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$A,
                [$1ac07ed6efda80da$var$cr]: "{Region}"
            }
        ]
    },
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$aC = {
    [$1ac07ed6efda80da$var$co]: [
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: "sigv4",
            [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$A,
            [$1ac07ed6efda80da$var$cr]: "{Region}"
        }
    ]
}, $1ac07ed6efda80da$var$aD = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "UseGlobalEndpoint"
        },
        false
    ]
}, $1ac07ed6efda80da$var$aE = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "UseDualStack"
        },
        false
    ]
}, $1ac07ed6efda80da$var$aF = {
    [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3-fips.{Region}.{partitionResult#dnsSuffix}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$aG = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "UseFIPS"
        },
        false
    ]
}, $1ac07ed6efda80da$var$aH = {
    [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3-accelerate.dualstack.{partitionResult#dnsSuffix}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$aI = {
    [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3.dualstack.{Region}.{partitionResult#dnsSuffix}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$aJ = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
            [$1ac07ed6efda80da$var$ci]: [
                $1ac07ed6efda80da$var$af,
                "isIp"
            ]
        },
        false
    ]
}, $1ac07ed6efda80da$var$aK = {
    [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$B,
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$aL = {
    [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$q,
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$aM = {
    [$1ac07ed6efda80da$var$n]: $1ac07ed6efda80da$var$aL,
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
}, $1ac07ed6efda80da$var$aN = {
    [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$C,
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$aO = {
    [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3.{Region}.{partitionResult#dnsSuffix}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$aP = {
    [$1ac07ed6efda80da$var$e]: "Invalid region: region was not a valid DNS name.",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$aQ = {
    [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$F
}, $1ac07ed6efda80da$var$aR = {
    [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$G
}, $1ac07ed6efda80da$var$aS = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
    [$1ac07ed6efda80da$var$ci]: [
        $1ac07ed6efda80da$var$aQ,
        "service"
    ]
}, $1ac07ed6efda80da$var$aT = {
    [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$K
}, $1ac07ed6efda80da$var$aU = {
    [$1ac07ed6efda80da$var$cg]: [
        $1ac07ed6efda80da$var$X
    ],
    [$1ac07ed6efda80da$var$e]: "S3 Object Lambda does not support Dual-stack",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$aV = {
    [$1ac07ed6efda80da$var$cg]: [
        $1ac07ed6efda80da$var$V
    ],
    [$1ac07ed6efda80da$var$e]: "S3 Object Lambda does not support S3 Accelerate",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$aW = {
    [$1ac07ed6efda80da$var$cg]: [
        {
            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
            [$1ac07ed6efda80da$var$ci]: [
                {
                    [$1ac07ed6efda80da$var$cj]: "DisableAccessPoints"
                }
            ]
        },
        {
            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
            [$1ac07ed6efda80da$var$ci]: [
                {
                    [$1ac07ed6efda80da$var$cj]: "DisableAccessPoints"
                },
                true
            ]
        }
    ],
    [$1ac07ed6efda80da$var$e]: "Access points are not supported for this operation",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$aX = {
    [$1ac07ed6efda80da$var$cg]: [
        {
            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
            [$1ac07ed6efda80da$var$ci]: [
                {
                    [$1ac07ed6efda80da$var$cj]: "UseArnRegion"
                }
            ]
        },
        {
            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
            [$1ac07ed6efda80da$var$ci]: [
                {
                    [$1ac07ed6efda80da$var$cj]: "UseArnRegion"
                },
                false
            ]
        },
        {
            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
            [$1ac07ed6efda80da$var$ci]: [
                {
                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                    [$1ac07ed6efda80da$var$ci]: [
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                            [$1ac07ed6efda80da$var$ci]: [
                                $1ac07ed6efda80da$var$aQ,
                                "region"
                            ]
                        },
                        "{Region}"
                    ]
                }
            ]
        }
    ],
    [$1ac07ed6efda80da$var$e]: "Invalid configuration: region from ARN `{bucketArn#region}` does not match client region `{Region}` and UseArnRegion is `false`",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$aY = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
    [$1ac07ed6efda80da$var$ci]: [
        {
            [$1ac07ed6efda80da$var$cj]: "bucketPartition"
        },
        $1ac07ed6efda80da$var$i
    ]
}, $1ac07ed6efda80da$var$aZ = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
    [$1ac07ed6efda80da$var$ci]: [
        $1ac07ed6efda80da$var$aQ,
        "accountId"
    ]
}, $1ac07ed6efda80da$var$ba = {
    [$1ac07ed6efda80da$var$co]: [
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: "sigv4",
            [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$I,
            [$1ac07ed6efda80da$var$cr]: "{bucketArn#region}"
        }
    ]
}, $1ac07ed6efda80da$var$bb = {
    [$1ac07ed6efda80da$var$e]: "Invalid ARN: The access point name may only contain a-z, A-Z, 0-9 and `-`. Found: `{accessPointName}`",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$bc = {
    [$1ac07ed6efda80da$var$e]: "Invalid ARN: The account id may only contain a-z, A-Z, 0-9 and `-`. Found: `{bucketArn#accountId}`",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$bd = {
    [$1ac07ed6efda80da$var$e]: "Invalid region in ARN: `{bucketArn#region}` (invalid DNS name)",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$be = {
    [$1ac07ed6efda80da$var$e]: "Client was configured for partition `{partitionResult#name}` but ARN (`{Bucket}`) has `{bucketPartition#name}`",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$bf = {
    [$1ac07ed6efda80da$var$e]: "Invalid ARN: The ARN may only contain a single resource component after `accesspoint`.",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$bg = {
    [$1ac07ed6efda80da$var$e]: "Invalid ARN: Expected a resource of the format `accesspoint:<accesspoint name>` but no name was provided",
    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
}, $1ac07ed6efda80da$var$bh = {
    [$1ac07ed6efda80da$var$co]: [
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: "sigv4",
            [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$A,
            [$1ac07ed6efda80da$var$cr]: "{bucketArn#region}"
        }
    ]
}, $1ac07ed6efda80da$var$bi = {
    [$1ac07ed6efda80da$var$co]: [
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: $1ac07ed6efda80da$var$y,
            [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$z,
            [$1ac07ed6efda80da$var$ct]: [
                "*"
            ]
        },
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: "sigv4",
            [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$z,
            [$1ac07ed6efda80da$var$cr]: "{bucketArn#region}"
        }
    ]
}, $1ac07ed6efda80da$var$bj = {
    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$E,
    [$1ac07ed6efda80da$var$ci]: [
        $1ac07ed6efda80da$var$ac
    ]
}, $1ac07ed6efda80da$var$bk = {
    [$1ac07ed6efda80da$var$cl]: "https://s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bl = {
    [$1ac07ed6efda80da$var$cl]: "https://s3-fips.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bm = {
    [$1ac07ed6efda80da$var$cl]: "https://s3.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bn = {
    [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$P,
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bo = {
    [$1ac07ed6efda80da$var$cl]: "https://s3.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bp = {
    [$1ac07ed6efda80da$var$cj]: "UseObjectLambdaEndpoint"
}, $1ac07ed6efda80da$var$bq = {
    [$1ac07ed6efda80da$var$co]: [
        {
            [$1ac07ed6efda80da$var$cp]: true,
            [$1ac07ed6efda80da$var$i]: "sigv4",
            [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$I,
            [$1ac07ed6efda80da$var$cr]: "{Region}"
        }
    ]
}, $1ac07ed6efda80da$var$br = {
    [$1ac07ed6efda80da$var$cl]: "https://s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bs = {
    [$1ac07ed6efda80da$var$cl]: "https://s3-fips.{Region}.{partitionResult#dnsSuffix}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bt = {
    [$1ac07ed6efda80da$var$cl]: "https://s3.dualstack.{Region}.{partitionResult#dnsSuffix}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bu = {
    [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$s,
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bv = {
    [$1ac07ed6efda80da$var$cl]: "https://s3.{Region}.{partitionResult#dnsSuffix}",
    [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
    [$1ac07ed6efda80da$var$cs]: {}
}, $1ac07ed6efda80da$var$bw = [
    {
        [$1ac07ed6efda80da$var$cj]: "Region"
    }
], $1ac07ed6efda80da$var$bx = [
    {
        [$1ac07ed6efda80da$var$cj]: "Endpoint"
    }
], $1ac07ed6efda80da$var$by = [
    $1ac07ed6efda80da$var$ac
], $1ac07ed6efda80da$var$bz = [
    $1ac07ed6efda80da$var$X
], $1ac07ed6efda80da$var$bA = [
    $1ac07ed6efda80da$var$V
], $1ac07ed6efda80da$var$bB = [
    $1ac07ed6efda80da$var$Y,
    $1ac07ed6efda80da$var$ad
], $1ac07ed6efda80da$var$bC = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$cj]: "DisableS3ExpressSessionAuth"
            }
        ]
    },
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$cj]: "DisableS3ExpressSessionAuth"
            },
            true
        ]
    }
], $1ac07ed6efda80da$var$bD = [
    $1ac07ed6efda80da$var$ae
], $1ac07ed6efda80da$var$bE = [
    $1ac07ed6efda80da$var$ag
], $1ac07ed6efda80da$var$bF = [
    $1ac07ed6efda80da$var$aj
], $1ac07ed6efda80da$var$bG = [
    $1ac07ed6efda80da$var$W
], $1ac07ed6efda80da$var$bH = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
        [$1ac07ed6efda80da$var$ci]: [
            $1ac07ed6efda80da$var$ac,
            6,
            14,
            true
        ],
        [$1ac07ed6efda80da$var$ck]: "s3expressAvailabilityZoneId"
    },
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
        [$1ac07ed6efda80da$var$ci]: [
            $1ac07ed6efda80da$var$ac,
            14,
            16,
            true
        ],
        [$1ac07ed6efda80da$var$ck]: "s3expressAvailabilityZoneDelim"
    },
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$cj]: "s3expressAvailabilityZoneDelim"
            },
            "--"
        ]
    }
], $1ac07ed6efda80da$var$bI = [
    {
        [$1ac07ed6efda80da$var$cg]: [
            $1ac07ed6efda80da$var$W
        ],
        [$1ac07ed6efda80da$var$n]: {
            [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3express-fips-{s3expressAvailabilityZoneId}.{Region}.amazonaws.com",
            [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ah,
            [$1ac07ed6efda80da$var$cs]: {}
        },
        [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
    },
    {
        [$1ac07ed6efda80da$var$n]: {
            [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3express-{s3expressAvailabilityZoneId}.{Region}.amazonaws.com",
            [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ah,
            [$1ac07ed6efda80da$var$cs]: {}
        },
        [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
    }
], $1ac07ed6efda80da$var$bJ = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
        [$1ac07ed6efda80da$var$ci]: [
            $1ac07ed6efda80da$var$ac,
            6,
            15,
            true
        ],
        [$1ac07ed6efda80da$var$ck]: "s3expressAvailabilityZoneId"
    },
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
        [$1ac07ed6efda80da$var$ci]: [
            $1ac07ed6efda80da$var$ac,
            15,
            17,
            true
        ],
        [$1ac07ed6efda80da$var$ck]: "s3expressAvailabilityZoneDelim"
    },
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$cj]: "s3expressAvailabilityZoneDelim"
            },
            "--"
        ]
    }
], $1ac07ed6efda80da$var$bK = [
    {
        [$1ac07ed6efda80da$var$cg]: [
            $1ac07ed6efda80da$var$W
        ],
        [$1ac07ed6efda80da$var$n]: {
            [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3express-fips-{s3expressAvailabilityZoneId}.{Region}.amazonaws.com",
            [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$al,
            [$1ac07ed6efda80da$var$cs]: {}
        },
        [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
    },
    {
        [$1ac07ed6efda80da$var$n]: {
            [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3express-{s3expressAvailabilityZoneId}.{Region}.amazonaws.com",
            [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$al,
            [$1ac07ed6efda80da$var$cs]: {}
        },
        [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
    }
], $1ac07ed6efda80da$var$bL = [
    $1ac07ed6efda80da$var$ab
], $1ac07ed6efda80da$var$bM = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$x,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$w
            },
            false
        ]
    }
], $1ac07ed6efda80da$var$bN = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$u
            },
            "beta"
        ]
    }
], $1ac07ed6efda80da$var$bO = [
    "*"
], $1ac07ed6efda80da$var$bP = [
    $1ac07ed6efda80da$var$Z
], $1ac07ed6efda80da$var$bQ = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$x,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$cj]: "Region"
            },
            false
        ]
    }
], $1ac07ed6efda80da$var$bR = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$cj]: "Region"
            },
            "us-east-1"
        ]
    }
], $1ac07ed6efda80da$var$bS = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
        [$1ac07ed6efda80da$var$ci]: [
            $1ac07ed6efda80da$var$aR,
            $1ac07ed6efda80da$var$J
        ]
    }
], $1ac07ed6efda80da$var$bT = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
        [$1ac07ed6efda80da$var$ci]: [
            $1ac07ed6efda80da$var$aQ,
            "resourceId[1]"
        ],
        [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$K
    },
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                [$1ac07ed6efda80da$var$ci]: [
                    $1ac07ed6efda80da$var$aT,
                    $1ac07ed6efda80da$var$H
                ]
            }
        ]
    }
], $1ac07ed6efda80da$var$bU = [
    $1ac07ed6efda80da$var$aQ,
    "resourceId[1]"
], $1ac07ed6efda80da$var$bV = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                [$1ac07ed6efda80da$var$ci]: [
                    {
                        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                        [$1ac07ed6efda80da$var$ci]: [
                            $1ac07ed6efda80da$var$aQ,
                            "region"
                        ]
                    },
                    $1ac07ed6efda80da$var$H
                ]
            }
        ]
    }
], $1ac07ed6efda80da$var$bW = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
                [$1ac07ed6efda80da$var$ci]: [
                    {
                        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                        [$1ac07ed6efda80da$var$ci]: [
                            $1ac07ed6efda80da$var$aQ,
                            "resourceId[2]"
                        ]
                    }
                ]
            }
        ]
    }
], $1ac07ed6efda80da$var$bX = [
    $1ac07ed6efda80da$var$aQ,
    "resourceId[2]"
], $1ac07ed6efda80da$var$bY = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$f,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                [$1ac07ed6efda80da$var$ci]: [
                    $1ac07ed6efda80da$var$aQ,
                    "region"
                ]
            }
        ],
        [$1ac07ed6efda80da$var$ck]: "bucketPartition"
    }
], $1ac07ed6efda80da$var$bZ = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
        [$1ac07ed6efda80da$var$ci]: [
            $1ac07ed6efda80da$var$aY,
            {
                [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                [$1ac07ed6efda80da$var$ci]: [
                    {
                        [$1ac07ed6efda80da$var$cj]: "partitionResult"
                    },
                    $1ac07ed6efda80da$var$i
                ]
            }
        ]
    }
], $1ac07ed6efda80da$var$ca = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$x,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                [$1ac07ed6efda80da$var$ci]: [
                    $1ac07ed6efda80da$var$aQ,
                    "region"
                ]
            },
            true
        ]
    }
], $1ac07ed6efda80da$var$cb = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$x,
        [$1ac07ed6efda80da$var$ci]: [
            $1ac07ed6efda80da$var$aZ,
            false
        ]
    }
], $1ac07ed6efda80da$var$cc = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$x,
        [$1ac07ed6efda80da$var$ci]: [
            $1ac07ed6efda80da$var$aT,
            false
        ]
    }
], $1ac07ed6efda80da$var$cd = [
    {
        [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$x,
        [$1ac07ed6efda80da$var$ci]: [
            {
                [$1ac07ed6efda80da$var$cj]: "Region"
            },
            true
        ]
    }
];
const $1ac07ed6efda80da$var$_data = {
    version: "1.0",
    parameters: {
        Bucket: $1ac07ed6efda80da$var$S,
        Region: $1ac07ed6efda80da$var$S,
        UseFIPS: $1ac07ed6efda80da$var$T,
        UseDualStack: $1ac07ed6efda80da$var$T,
        Endpoint: $1ac07ed6efda80da$var$S,
        ForcePathStyle: $1ac07ed6efda80da$var$T,
        Accelerate: $1ac07ed6efda80da$var$T,
        UseGlobalEndpoint: $1ac07ed6efda80da$var$T,
        UseObjectLambdaEndpoint: $1ac07ed6efda80da$var$U,
        Key: $1ac07ed6efda80da$var$S,
        Prefix: $1ac07ed6efda80da$var$S,
        CopySource: $1ac07ed6efda80da$var$S,
        DisableAccessPoints: $1ac07ed6efda80da$var$U,
        DisableMultiRegionAccessPoints: $1ac07ed6efda80da$var$T,
        UseArnRegion: $1ac07ed6efda80da$var$U,
        UseS3ExpressControlEndpoint: $1ac07ed6efda80da$var$U,
        DisableS3ExpressSessionAuth: $1ac07ed6efda80da$var$U
    },
    rules: [
        {
            [$1ac07ed6efda80da$var$cg]: [
                {
                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
                    [$1ac07ed6efda80da$var$ci]: $1ac07ed6efda80da$var$bw
                }
            ],
            rules: [
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        $1ac07ed6efda80da$var$V,
                        $1ac07ed6efda80da$var$W
                    ],
                    error: "Accelerate cannot be used with FIPS",
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                },
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        $1ac07ed6efda80da$var$X,
                        $1ac07ed6efda80da$var$Y
                    ],
                    error: "Cannot set dual-stack in combination with a custom endpoint.",
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                },
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        $1ac07ed6efda80da$var$Y,
                        $1ac07ed6efda80da$var$W
                    ],
                    error: "A custom endpoint cannot be combined with FIPS",
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                },
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        $1ac07ed6efda80da$var$Y,
                        $1ac07ed6efda80da$var$V
                    ],
                    error: "A custom endpoint cannot be combined with S3 Accelerate",
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                },
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        $1ac07ed6efda80da$var$W,
                        $1ac07ed6efda80da$var$Z,
                        $1ac07ed6efda80da$var$aa
                    ],
                    error: "Partition does not support FIPS",
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                },
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        $1ac07ed6efda80da$var$ab,
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
                            [$1ac07ed6efda80da$var$ci]: [
                                $1ac07ed6efda80da$var$ac,
                                0,
                                6,
                                $1ac07ed6efda80da$var$b
                            ],
                            [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$k
                        },
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                            [$1ac07ed6efda80da$var$ci]: [
                                {
                                    [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$k
                                },
                                "--x-s3"
                            ]
                        }
                    ],
                    rules: [
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bz,
                            error: "S3Express does not support Dual-stack.",
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bA,
                            error: "S3Express does not support S3 Accelerate.",
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bB,
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bC,
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bD,
                                            rules: [
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bE,
                                                    rules: [
                                                        {
                                                            endpoint: {
                                                                [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$m,
                                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ah,
                                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                            },
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bF,
                                            rules: [
                                                {
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$q,
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ah,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        $1ac07ed6efda80da$var$ak
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bD,
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bE,
                                            rules: [
                                                {
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$m,
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$al,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        }
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bF,
                                    rules: [
                                        {
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$q,
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$al,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        }
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                $1ac07ed6efda80da$var$ak
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: [
                                $1ac07ed6efda80da$var$am,
                                $1ac07ed6efda80da$var$an
                            ],
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: [
                                        $1ac07ed6efda80da$var$ag,
                                        $1ac07ed6efda80da$var$ao
                                    ],
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bG,
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: "https://s3express-control-fips.{Region}.amazonaws.com/{uri_encoded_bucket}",
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ah,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: "https://s3express-control.{Region}.amazonaws.com/{uri_encoded_bucket}",
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ah,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        }
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                }
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bF,
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bC,
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bH,
                                            rules: $1ac07ed6efda80da$var$bI,
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bJ,
                                            rules: $1ac07ed6efda80da$var$bI,
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        $1ac07ed6efda80da$var$ap
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bH,
                                    rules: $1ac07ed6efda80da$var$bK,
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bJ,
                                    rules: $1ac07ed6efda80da$var$bK,
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                $1ac07ed6efda80da$var$ap
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        },
                        $1ac07ed6efda80da$var$ak
                    ],
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                },
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        $1ac07ed6efda80da$var$aq,
                        $1ac07ed6efda80da$var$am,
                        $1ac07ed6efda80da$var$an
                    ],
                    rules: [
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bB,
                            endpoint: {
                                [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$s,
                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ah,
                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                            },
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bG,
                            endpoint: {
                                [$1ac07ed6efda80da$var$cl]: "https://s3express-control-fips.{Region}.amazonaws.com",
                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ah,
                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                            },
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                        },
                        {
                            endpoint: {
                                [$1ac07ed6efda80da$var$cl]: "https://s3express-control.{Region}.amazonaws.com",
                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ah,
                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                            },
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                        }
                    ],
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                },
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        $1ac07ed6efda80da$var$ab,
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
                            [$1ac07ed6efda80da$var$ci]: [
                                $1ac07ed6efda80da$var$ac,
                                49,
                                50,
                                $1ac07ed6efda80da$var$b
                            ],
                            [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$t
                        },
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
                            [$1ac07ed6efda80da$var$ci]: [
                                $1ac07ed6efda80da$var$ac,
                                8,
                                12,
                                $1ac07ed6efda80da$var$b
                            ],
                            [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$u
                        },
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
                            [$1ac07ed6efda80da$var$ci]: [
                                $1ac07ed6efda80da$var$ac,
                                0,
                                7,
                                $1ac07ed6efda80da$var$b
                            ],
                            [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$v
                        },
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
                            [$1ac07ed6efda80da$var$ci]: [
                                $1ac07ed6efda80da$var$ac,
                                32,
                                49,
                                $1ac07ed6efda80da$var$b
                            ],
                            [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$w
                        },
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$f,
                            [$1ac07ed6efda80da$var$ci]: $1ac07ed6efda80da$var$bw,
                            [$1ac07ed6efda80da$var$ck]: "regionPartition"
                        },
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                            [$1ac07ed6efda80da$var$ci]: [
                                {
                                    [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$v
                                },
                                "--op-s3"
                            ]
                        }
                    ],
                    rules: [
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bM,
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: [
                                        {
                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                            [$1ac07ed6efda80da$var$ci]: [
                                                $1ac07ed6efda80da$var$ar,
                                                "e"
                                            ]
                                        }
                                    ],
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bN,
                                            rules: [
                                                $1ac07ed6efda80da$var$as,
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bB,
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.ec2.{url#authority}",
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$at,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.ec2.s3-outposts.{Region}.{regionPartition#dnsSuffix}",
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$at,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        }
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                {
                                    [$1ac07ed6efda80da$var$cg]: [
                                        {
                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                            [$1ac07ed6efda80da$var$ci]: [
                                                $1ac07ed6efda80da$var$ar,
                                                "o"
                                            ]
                                        }
                                    ],
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bN,
                                            rules: [
                                                $1ac07ed6efda80da$var$as,
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bB,
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.op-{outpostId}.{url#authority}",
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$at,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.op-{outpostId}.s3-outposts.{Region}.{regionPartition#dnsSuffix}",
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$at,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        }
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                {
                                    error: "Unrecognized hardware type: \"Expected hardware type o or e but got {hardwareType}\"",
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                }
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        },
                        {
                            error: "Invalid ARN: The outpost Id must only contain a-z, A-Z, 0-9 and `-`.",
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                        }
                    ],
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                },
                {
                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bL,
                    rules: [
                        {
                            [$1ac07ed6efda80da$var$cg]: [
                                $1ac07ed6efda80da$var$Y,
                                {
                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
                                    [$1ac07ed6efda80da$var$ci]: [
                                        {
                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
                                            [$1ac07ed6efda80da$var$ci]: [
                                                {
                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$l,
                                                    [$1ac07ed6efda80da$var$ci]: $1ac07ed6efda80da$var$bx
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            error: "Custom endpoint `{Endpoint}` was not a valid URI",
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: [
                                $1ac07ed6efda80da$var$au,
                                $1ac07ed6efda80da$var$aj
                            ],
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bP,
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bQ,
                                            rules: [
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$V,
                                                        $1ac07ed6efda80da$var$aa
                                                    ],
                                                    error: "S3 Accelerate cannot be used in this region",
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$aB,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$aB,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3-fips.us-east-1.{partitionResult#dnsSuffix}",
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$aF,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$aF,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$V,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3-accelerate.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$V,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$aH,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$V,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$aH,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: "https://{Bucket}.s3.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$aI,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$aI,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$Y,
                                                        $1ac07ed6efda80da$var$ad,
                                                        $1ac07ed6efda80da$var$ae,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$B,
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$Y,
                                                        $1ac07ed6efda80da$var$ad,
                                                        $1ac07ed6efda80da$var$aJ,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$q,
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$Y,
                                                        $1ac07ed6efda80da$var$ad,
                                                        $1ac07ed6efda80da$var$ae,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bR,
                                                            endpoint: $1ac07ed6efda80da$var$aK,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        },
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$aK,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$Y,
                                                        $1ac07ed6efda80da$var$ad,
                                                        $1ac07ed6efda80da$var$aJ,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bR,
                                                            endpoint: $1ac07ed6efda80da$var$aL,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        },
                                                        $1ac07ed6efda80da$var$aM
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$Y,
                                                        $1ac07ed6efda80da$var$ad,
                                                        $1ac07ed6efda80da$var$ae,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$aK,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$Y,
                                                        $1ac07ed6efda80da$var$ad,
                                                        $1ac07ed6efda80da$var$aJ,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$aL,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$V,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$C,
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$V,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bR,
                                                            endpoint: $1ac07ed6efda80da$var$aN,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        },
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$aN,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$V,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$aN,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$D,
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bR,
                                                            endpoint: {
                                                                [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$D,
                                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
                                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                            },
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        },
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$aO,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$aw,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$aO,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        $1ac07ed6efda80da$var$aP
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                }
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: [
                                $1ac07ed6efda80da$var$Y,
                                $1ac07ed6efda80da$var$ad,
                                {
                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                    [$1ac07ed6efda80da$var$ci]: [
                                        {
                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                                            [$1ac07ed6efda80da$var$ci]: [
                                                $1ac07ed6efda80da$var$af,
                                                "scheme"
                                            ]
                                        },
                                        "http"
                                    ]
                                },
                                {
                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$p,
                                    [$1ac07ed6efda80da$var$ci]: [
                                        $1ac07ed6efda80da$var$ac,
                                        $1ac07ed6efda80da$var$b
                                    ]
                                },
                                $1ac07ed6efda80da$var$au,
                                $1ac07ed6efda80da$var$aG,
                                $1ac07ed6efda80da$var$aE,
                                $1ac07ed6efda80da$var$aw
                            ],
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bP,
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bQ,
                                            rules: [
                                                $1ac07ed6efda80da$var$aM
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        $1ac07ed6efda80da$var$aP
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                }
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: [
                                $1ac07ed6efda80da$var$au,
                                {
                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$E,
                                    [$1ac07ed6efda80da$var$ci]: $1ac07ed6efda80da$var$by,
                                    [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$F
                                }
                            ],
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: [
                                        {
                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                                            [$1ac07ed6efda80da$var$ci]: [
                                                $1ac07ed6efda80da$var$aQ,
                                                "resourceId[0]"
                                            ],
                                            [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$G
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
                                            [$1ac07ed6efda80da$var$ci]: [
                                                {
                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                                    [$1ac07ed6efda80da$var$ci]: [
                                                        $1ac07ed6efda80da$var$aR,
                                                        $1ac07ed6efda80da$var$H
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                {
                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                                    [$1ac07ed6efda80da$var$ci]: [
                                                        $1ac07ed6efda80da$var$aS,
                                                        $1ac07ed6efda80da$var$I
                                                    ]
                                                }
                                            ],
                                            rules: [
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bS,
                                                    rules: [
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bT,
                                                            rules: [
                                                                $1ac07ed6efda80da$var$aU,
                                                                $1ac07ed6efda80da$var$aV,
                                                                {
                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bV,
                                                                    rules: [
                                                                        $1ac07ed6efda80da$var$aW,
                                                                        {
                                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bW,
                                                                            rules: [
                                                                                $1ac07ed6efda80da$var$aX,
                                                                                {
                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bY,
                                                                                    rules: [
                                                                                        {
                                                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bP,
                                                                                            rules: [
                                                                                                {
                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bZ,
                                                                                                    rules: [
                                                                                                        {
                                                                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$ca,
                                                                                                            rules: [
                                                                                                                {
                                                                                                                    [$1ac07ed6efda80da$var$cg]: [
                                                                                                                        {
                                                                                                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                                                                                                            [$1ac07ed6efda80da$var$ci]: [
                                                                                                                                $1ac07ed6efda80da$var$aZ,
                                                                                                                                $1ac07ed6efda80da$var$H
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    error: "Invalid ARN: Missing account id",
                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                                                                },
                                                                                                                {
                                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$cb,
                                                                                                                    rules: [
                                                                                                                        {
                                                                                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$cc,
                                                                                                                            rules: [
                                                                                                                                {
                                                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bB,
                                                                                                                                    endpoint: {
                                                                                                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$L,
                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ba,
                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                    },
                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bG,
                                                                                                                                    endpoint: {
                                                                                                                                        [$1ac07ed6efda80da$var$cl]: "https://{accessPointName}-{bucketArn#accountId}.s3-object-lambda-fips.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ba,
                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                    },
                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    endpoint: {
                                                                                                                                        [$1ac07ed6efda80da$var$cl]: "https://{accessPointName}-{bucketArn#accountId}.s3-object-lambda.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ba,
                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                    },
                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                                        },
                                                                                                                        $1ac07ed6efda80da$var$bb
                                                                                                                    ],
                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                                },
                                                                                                                $1ac07ed6efda80da$var$bc
                                                                                                            ],
                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                        },
                                                                                                        $1ac07ed6efda80da$var$bd
                                                                                                    ],
                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                },
                                                                                                $1ac07ed6efda80da$var$be
                                                                                            ],
                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                        }
                                                                                    ],
                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                }
                                                                            ],
                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                        },
                                                                        $1ac07ed6efda80da$var$bf
                                                                    ],
                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                },
                                                                {
                                                                    error: "Invalid ARN: bucket ARN is missing a region",
                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                }
                                                            ],
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                        },
                                                        $1ac07ed6efda80da$var$bg
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    error: "Invalid ARN: Object Lambda ARNs only support `accesspoint` arn types, but found: `{arnType}`",
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bS,
                                            rules: [
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bT,
                                                    rules: [
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bV,
                                                            rules: [
                                                                {
                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bS,
                                                                    rules: [
                                                                        {
                                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bV,
                                                                            rules: [
                                                                                $1ac07ed6efda80da$var$aW,
                                                                                {
                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bW,
                                                                                    rules: [
                                                                                        $1ac07ed6efda80da$var$aX,
                                                                                        {
                                                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bY,
                                                                                            rules: [
                                                                                                {
                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bP,
                                                                                                    rules: [
                                                                                                        {
                                                                                                            [$1ac07ed6efda80da$var$cg]: [
                                                                                                                {
                                                                                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                                                                                                    [$1ac07ed6efda80da$var$ci]: [
                                                                                                                        $1ac07ed6efda80da$var$aY,
                                                                                                                        "{partitionResult#name}"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            rules: [
                                                                                                                {
                                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$ca,
                                                                                                                    rules: [
                                                                                                                        {
                                                                                                                            [$1ac07ed6efda80da$var$cg]: [
                                                                                                                                {
                                                                                                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                                                                                                                    [$1ac07ed6efda80da$var$ci]: [
                                                                                                                                        $1ac07ed6efda80da$var$aS,
                                                                                                                                        $1ac07ed6efda80da$var$A
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            rules: [
                                                                                                                                {
                                                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$cb,
                                                                                                                                    rules: [
                                                                                                                                        {
                                                                                                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$cc,
                                                                                                                                            rules: [
                                                                                                                                                {
                                                                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bA,
                                                                                                                                                    error: "Access Points do not support S3 Accelerate",
                                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$1ac07ed6efda80da$var$cg]: [
                                                                                                                                                        $1ac07ed6efda80da$var$W,
                                                                                                                                                        $1ac07ed6efda80da$var$X
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$1ac07ed6efda80da$var$cl]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint-fips.dualstack.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bh,
                                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                                    },
                                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$1ac07ed6efda80da$var$cg]: [
                                                                                                                                                        $1ac07ed6efda80da$var$W,
                                                                                                                                                        $1ac07ed6efda80da$var$aE
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$1ac07ed6efda80da$var$cl]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint-fips.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bh,
                                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                                    },
                                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$1ac07ed6efda80da$var$cg]: [
                                                                                                                                                        $1ac07ed6efda80da$var$aG,
                                                                                                                                                        $1ac07ed6efda80da$var$X
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$1ac07ed6efda80da$var$cl]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint.dualstack.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bh,
                                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                                    },
                                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$1ac07ed6efda80da$var$cg]: [
                                                                                                                                                        $1ac07ed6efda80da$var$aG,
                                                                                                                                                        $1ac07ed6efda80da$var$aE,
                                                                                                                                                        $1ac07ed6efda80da$var$Y,
                                                                                                                                                        $1ac07ed6efda80da$var$ad
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$L,
                                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bh,
                                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                                    },
                                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$1ac07ed6efda80da$var$cg]: [
                                                                                                                                                        $1ac07ed6efda80da$var$aG,
                                                                                                                                                        $1ac07ed6efda80da$var$aE
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$1ac07ed6efda80da$var$cl]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bh,
                                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                                    },
                                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                                                        },
                                                                                                                                        $1ac07ed6efda80da$var$bb
                                                                                                                                    ],
                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                                                },
                                                                                                                                $1ac07ed6efda80da$var$bc
                                                                                                                            ],
                                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                                        },
                                                                                                                        {
                                                                                                                            error: "Invalid ARN: The ARN was not for the S3 service, found: {bucketArn#service}",
                                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                                },
                                                                                                                $1ac07ed6efda80da$var$bd
                                                                                                            ],
                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                        },
                                                                                                        $1ac07ed6efda80da$var$be
                                                                                                    ],
                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                }
                                                                                            ],
                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                        }
                                                                                    ],
                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                },
                                                                                $1ac07ed6efda80da$var$bf
                                                                            ],
                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                        }
                                                                    ],
                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                }
                                                            ],
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                        },
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: [
                                                                {
                                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$x,
                                                                    [$1ac07ed6efda80da$var$ci]: [
                                                                        $1ac07ed6efda80da$var$aT,
                                                                        $1ac07ed6efda80da$var$b
                                                                    ]
                                                                }
                                                            ],
                                                            rules: [
                                                                {
                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bz,
                                                                    error: "S3 MRAP does not support dual-stack",
                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                },
                                                                {
                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bG,
                                                                    error: "S3 MRAP does not support FIPS",
                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                },
                                                                {
                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bA,
                                                                    error: "S3 MRAP does not support S3 Accelerate",
                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                },
                                                                {
                                                                    [$1ac07ed6efda80da$var$cg]: [
                                                                        {
                                                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
                                                                            [$1ac07ed6efda80da$var$ci]: [
                                                                                {
                                                                                    [$1ac07ed6efda80da$var$cj]: "DisableMultiRegionAccessPoints"
                                                                                },
                                                                                $1ac07ed6efda80da$var$b
                                                                            ]
                                                                        }
                                                                    ],
                                                                    error: "Invalid configuration: Multi-Region Access Point ARNs are disabled.",
                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                },
                                                                {
                                                                    [$1ac07ed6efda80da$var$cg]: [
                                                                        {
                                                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$f,
                                                                            [$1ac07ed6efda80da$var$ci]: $1ac07ed6efda80da$var$bw,
                                                                            [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$M
                                                                        }
                                                                    ],
                                                                    rules: [
                                                                        {
                                                                            [$1ac07ed6efda80da$var$cg]: [
                                                                                {
                                                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                                                                    [$1ac07ed6efda80da$var$ci]: [
                                                                                        {
                                                                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                                                                                            [$1ac07ed6efda80da$var$ci]: [
                                                                                                {
                                                                                                    [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$M
                                                                                                },
                                                                                                $1ac07ed6efda80da$var$i
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                                                                                            [$1ac07ed6efda80da$var$ci]: [
                                                                                                $1ac07ed6efda80da$var$aQ,
                                                                                                "partition"
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            rules: [
                                                                                {
                                                                                    endpoint: {
                                                                                        [$1ac07ed6efda80da$var$cl]: "https://{accessPointName}.accesspoint.s3-global.{mrapPartition#dnsSuffix}",
                                                                                        [$1ac07ed6efda80da$var$cm]: {
                                                                                            [$1ac07ed6efda80da$var$co]: [
                                                                                                {
                                                                                                    [$1ac07ed6efda80da$var$cp]: $1ac07ed6efda80da$var$b,
                                                                                                    name: $1ac07ed6efda80da$var$y,
                                                                                                    [$1ac07ed6efda80da$var$cq]: $1ac07ed6efda80da$var$A,
                                                                                                    [$1ac07ed6efda80da$var$ct]: $1ac07ed6efda80da$var$bO
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                    },
                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                }
                                                                            ],
                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                        },
                                                                        {
                                                                            error: "Client was configured for partition `{mrapPartition#name}` but bucket referred to partition `{bucketArn#partition}`",
                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                        }
                                                                    ],
                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                }
                                                            ],
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                        },
                                                        {
                                                            error: "Invalid Access Point Name",
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                $1ac07ed6efda80da$var$bg
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                {
                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                                    [$1ac07ed6efda80da$var$ci]: [
                                                        $1ac07ed6efda80da$var$aS,
                                                        $1ac07ed6efda80da$var$z
                                                    ]
                                                }
                                            ],
                                            rules: [
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bz,
                                                    error: "S3 Outposts does not support Dual-stack",
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bG,
                                                    error: "S3 Outposts does not support FIPS",
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bA,
                                                    error: "S3 Outposts does not support S3 Accelerate",
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        {
                                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
                                                            [$1ac07ed6efda80da$var$ci]: [
                                                                {
                                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                                                                    [$1ac07ed6efda80da$var$ci]: [
                                                                        $1ac07ed6efda80da$var$aQ,
                                                                        "resourceId[4]"
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    error: "Invalid Arn: Outpost Access Point ARN contains sub resources",
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        {
                                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                                                            [$1ac07ed6efda80da$var$ci]: $1ac07ed6efda80da$var$bU,
                                                            [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$w
                                                        }
                                                    ],
                                                    rules: [
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bM,
                                                            rules: [
                                                                $1ac07ed6efda80da$var$aX,
                                                                {
                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bY,
                                                                    rules: [
                                                                        {
                                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bP,
                                                                            rules: [
                                                                                {
                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bZ,
                                                                                    rules: [
                                                                                        {
                                                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$ca,
                                                                                            rules: [
                                                                                                {
                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$cb,
                                                                                                    rules: [
                                                                                                        {
                                                                                                            [$1ac07ed6efda80da$var$cg]: [
                                                                                                                {
                                                                                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                                                                                                                    [$1ac07ed6efda80da$var$ci]: $1ac07ed6efda80da$var$bX,
                                                                                                                    [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$N
                                                                                                                }
                                                                                                            ],
                                                                                                            rules: [
                                                                                                                {
                                                                                                                    [$1ac07ed6efda80da$var$cg]: [
                                                                                                                        {
                                                                                                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$h,
                                                                                                                            [$1ac07ed6efda80da$var$ci]: [
                                                                                                                                $1ac07ed6efda80da$var$aQ,
                                                                                                                                "resourceId[3]"
                                                                                                                            ],
                                                                                                                            [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$K
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    rules: [
                                                                                                                        {
                                                                                                                            [$1ac07ed6efda80da$var$cg]: [
                                                                                                                                {
                                                                                                                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                                                                                                                    [$1ac07ed6efda80da$var$ci]: [
                                                                                                                                        {
                                                                                                                                            [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$N
                                                                                                                                        },
                                                                                                                                        $1ac07ed6efda80da$var$J
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            rules: [
                                                                                                                                {
                                                                                                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bB,
                                                                                                                                    endpoint: {
                                                                                                                                        [$1ac07ed6efda80da$var$cl]: "https://{accessPointName}-{bucketArn#accountId}.{outpostId}.{url#authority}",
                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bi,
                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                    },
                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    endpoint: {
                                                                                                                                        [$1ac07ed6efda80da$var$cl]: "https://{accessPointName}-{bucketArn#accountId}.{outpostId}.s3-outposts.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bi,
                                                                                                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                                                                                                    },
                                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                                        },
                                                                                                                        {
                                                                                                                            error: "Expected an outpost type `accesspoint`, found {outpostType}",
                                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                                },
                                                                                                                {
                                                                                                                    error: "Invalid ARN: expected an access point name",
                                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                                                                }
                                                                                                            ],
                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                        },
                                                                                                        {
                                                                                                            error: "Invalid ARN: Expected a 4-component resource",
                                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                                                                        }
                                                                                                    ],
                                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                                },
                                                                                                $1ac07ed6efda80da$var$bc
                                                                                            ],
                                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                        },
                                                                                        $1ac07ed6efda80da$var$bd
                                                                                    ],
                                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                                },
                                                                                $1ac07ed6efda80da$var$be
                                                                            ],
                                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                        }
                                                                    ],
                                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                                }
                                                            ],
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                        },
                                                        {
                                                            error: "Invalid ARN: The outpost Id may only contain a-z, A-Z, 0-9 and `-`. Found: `{outpostId}`",
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    error: "Invalid ARN: The Outpost Id was not set",
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            error: "Invalid ARN: Unrecognized format: {Bucket} (type: {arnType})",
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                        }
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                {
                                    error: "Invalid ARN: No ARN type specified",
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                }
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: [
                                {
                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$j,
                                    [$1ac07ed6efda80da$var$ci]: [
                                        $1ac07ed6efda80da$var$ac,
                                        0,
                                        4,
                                        $1ac07ed6efda80da$var$a
                                    ],
                                    [$1ac07ed6efda80da$var$ck]: $1ac07ed6efda80da$var$O
                                },
                                {
                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$g,
                                    [$1ac07ed6efda80da$var$ci]: [
                                        {
                                            [$1ac07ed6efda80da$var$cj]: $1ac07ed6efda80da$var$O
                                        },
                                        "arn:"
                                    ]
                                },
                                {
                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$r,
                                    [$1ac07ed6efda80da$var$ci]: [
                                        {
                                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
                                            [$1ac07ed6efda80da$var$ci]: [
                                                $1ac07ed6efda80da$var$bj
                                            ]
                                        }
                                    ]
                                }
                            ],
                            error: "Invalid ARN: `{Bucket}` was not a valid ARN",
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: [
                                {
                                    [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
                                    [$1ac07ed6efda80da$var$ci]: [
                                        $1ac07ed6efda80da$var$av,
                                        $1ac07ed6efda80da$var$b
                                    ]
                                },
                                $1ac07ed6efda80da$var$bj
                            ],
                            error: "Path-style addressing cannot be used with ARN buckets",
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                        },
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bE,
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bP,
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aw
                                            ],
                                            rules: [
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: "https://s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$bk,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$bk,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: "https://s3-fips.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$bl,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$W,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$bl,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: "https://s3.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$bm,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$X,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$bm,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$Y,
                                                        $1ac07ed6efda80da$var$ad,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$P,
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$Y,
                                                        $1ac07ed6efda80da$var$ad,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bR,
                                                            endpoint: $1ac07ed6efda80da$var$bn,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        },
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$bn,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$Y,
                                                        $1ac07ed6efda80da$var$ad,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$bn,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$ax
                                                    ],
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$Q,
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aA
                                                    ],
                                                    rules: [
                                                        {
                                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bR,
                                                            endpoint: {
                                                                [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$Q,
                                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
                                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                            },
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        },
                                                        {
                                                            endpoint: $1ac07ed6efda80da$var$bo,
                                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                        }
                                                    ],
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                                },
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: [
                                                        $1ac07ed6efda80da$var$aE,
                                                        $1ac07ed6efda80da$var$ao,
                                                        $1ac07ed6efda80da$var$aG,
                                                        $1ac07ed6efda80da$var$az,
                                                        $1ac07ed6efda80da$var$aD
                                                    ],
                                                    endpoint: $1ac07ed6efda80da$var$bo,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            error: "Path-style addressing cannot be used with S3 Accelerate",
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
                                        }
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                }
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        }
                    ],
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                },
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$c,
                            [$1ac07ed6efda80da$var$ci]: [
                                $1ac07ed6efda80da$var$bp
                            ]
                        },
                        {
                            [$1ac07ed6efda80da$var$ch]: $1ac07ed6efda80da$var$d,
                            [$1ac07ed6efda80da$var$ci]: [
                                $1ac07ed6efda80da$var$bp,
                                $1ac07ed6efda80da$var$b
                            ]
                        }
                    ],
                    rules: [
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bP,
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$cd,
                                    rules: [
                                        $1ac07ed6efda80da$var$aU,
                                        $1ac07ed6efda80da$var$aV,
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bB,
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$s,
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bq,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bG,
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: "https://s3-object-lambda-fips.{Region}.{partitionResult#dnsSuffix}",
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bq,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: "https://s3-object-lambda.{Region}.{partitionResult#dnsSuffix}",
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$bq,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        }
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                $1ac07ed6efda80da$var$aP
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        }
                    ],
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                },
                {
                    [$1ac07ed6efda80da$var$cg]: [
                        $1ac07ed6efda80da$var$aq
                    ],
                    rules: [
                        {
                            [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bP,
                            rules: [
                                {
                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$cd,
                                    rules: [
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$W,
                                                $1ac07ed6efda80da$var$X,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$ax
                                            ],
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: "https://s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$W,
                                                $1ac07ed6efda80da$var$X,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aA
                                            ],
                                            rules: [
                                                {
                                                    endpoint: $1ac07ed6efda80da$var$br,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$W,
                                                $1ac07ed6efda80da$var$X,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aD
                                            ],
                                            endpoint: $1ac07ed6efda80da$var$br,
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$W,
                                                $1ac07ed6efda80da$var$aE,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$ax
                                            ],
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: "https://s3-fips.us-east-1.{partitionResult#dnsSuffix}",
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$W,
                                                $1ac07ed6efda80da$var$aE,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aA
                                            ],
                                            rules: [
                                                {
                                                    endpoint: $1ac07ed6efda80da$var$bs,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$W,
                                                $1ac07ed6efda80da$var$aE,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aD
                                            ],
                                            endpoint: $1ac07ed6efda80da$var$bs,
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aG,
                                                $1ac07ed6efda80da$var$X,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$ax
                                            ],
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: "https://s3.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aG,
                                                $1ac07ed6efda80da$var$X,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aA
                                            ],
                                            rules: [
                                                {
                                                    endpoint: $1ac07ed6efda80da$var$bt,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aG,
                                                $1ac07ed6efda80da$var$X,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aD
                                            ],
                                            endpoint: $1ac07ed6efda80da$var$bt,
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aG,
                                                $1ac07ed6efda80da$var$aE,
                                                $1ac07ed6efda80da$var$Y,
                                                $1ac07ed6efda80da$var$ad,
                                                $1ac07ed6efda80da$var$ax
                                            ],
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$s,
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aG,
                                                $1ac07ed6efda80da$var$aE,
                                                $1ac07ed6efda80da$var$Y,
                                                $1ac07ed6efda80da$var$ad,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aA
                                            ],
                                            rules: [
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bR,
                                                    endpoint: $1ac07ed6efda80da$var$bu,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    endpoint: $1ac07ed6efda80da$var$bu,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aG,
                                                $1ac07ed6efda80da$var$aE,
                                                $1ac07ed6efda80da$var$Y,
                                                $1ac07ed6efda80da$var$ad,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aD
                                            ],
                                            endpoint: $1ac07ed6efda80da$var$bu,
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aG,
                                                $1ac07ed6efda80da$var$aE,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$ax
                                            ],
                                            endpoint: {
                                                [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$R,
                                                [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$ay,
                                                [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                            },
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aG,
                                                $1ac07ed6efda80da$var$aE,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aA
                                            ],
                                            rules: [
                                                {
                                                    [$1ac07ed6efda80da$var$cg]: $1ac07ed6efda80da$var$bR,
                                                    endpoint: {
                                                        [$1ac07ed6efda80da$var$cl]: $1ac07ed6efda80da$var$R,
                                                        [$1ac07ed6efda80da$var$cm]: $1ac07ed6efda80da$var$aC,
                                                        [$1ac07ed6efda80da$var$cs]: $1ac07ed6efda80da$var$ai
                                                    },
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                },
                                                {
                                                    endpoint: $1ac07ed6efda80da$var$bv,
                                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                                }
                                            ],
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                        },
                                        {
                                            [$1ac07ed6efda80da$var$cg]: [
                                                $1ac07ed6efda80da$var$aG,
                                                $1ac07ed6efda80da$var$aE,
                                                $1ac07ed6efda80da$var$ao,
                                                $1ac07ed6efda80da$var$az,
                                                $1ac07ed6efda80da$var$aD
                                            ],
                                            endpoint: $1ac07ed6efda80da$var$bv,
                                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$n
                                        }
                                    ],
                                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                                },
                                $1ac07ed6efda80da$var$aP
                            ],
                            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                        }
                    ],
                    [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
                }
            ],
            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$o
        },
        {
            error: "A region must be set when sending requests to S3.",
            [$1ac07ed6efda80da$var$cf]: $1ac07ed6efda80da$var$e
        }
    ]
};
const $1ac07ed6efda80da$export$7b249e066372152f = $1ac07ed6efda80da$var$_data;


const $db95b6a52533afa5$var$cache = new (0, $9d81209341f48a16$export$262eb2e4804ef909)({
    size: 50,
    params: [
        "Accelerate",
        "Bucket",
        "DisableAccessPoints",
        "DisableMultiRegionAccessPoints",
        "DisableS3ExpressSessionAuth",
        "Endpoint",
        "ForcePathStyle",
        "Region",
        "UseArnRegion",
        "UseDualStack",
        "UseFIPS",
        "UseGlobalEndpoint",
        "UseObjectLambdaEndpoint",
        "UseS3ExpressControlEndpoint"
    ]
});
const $db95b6a52533afa5$export$47fc6e98c86e06e3 = (endpointParams, context = {})=>{
    return $db95b6a52533afa5$var$cache.get(endpointParams, ()=>(0, $b169f1dc494e85ef$export$48b88e4e5ecac119)((0, $1ac07ed6efda80da$export$7b249e066372152f), {
            endpointParams: endpointParams,
            logger: context.logger
        }));
};
(0, $1efb1fecaf394dc7$export$2614fba0847da171).aws = (0, $e0d4557714be146d$export$1bfd97ffc6d0eef8);


const $25528546c573dfbf$var$createEndpointRuleSetHttpAuthSchemeParametersProvider = (defaultHttpAuthSchemeParametersProvider)=>async (config, context, input)=>{
        if (!input) throw new Error(`Could not find \`input\` for \`defaultEndpointRuleSetHttpAuthSchemeParametersProvider\``);
        const defaultParameters = await defaultHttpAuthSchemeParametersProvider(config, context, input);
        const instructionsFn = (0, $7a2c7cffe65767aa$export$1d3c197393275463)(context)?.commandInstance?.constructor?.getEndpointParameterInstructions;
        if (!instructionsFn) throw new Error(`getEndpointParameterInstructions() is not defined on \`${context.commandName}\``);
        const endpointParameters = await (0, $d31625d2ccff255a$export$a4c001b14047c450)(input, {
            getEndpointParameterInstructions: instructionsFn
        }, config);
        return Object.assign(defaultParameters, endpointParameters);
    };
const $25528546c573dfbf$var$_defaultS3HttpAuthSchemeParametersProvider = async (config, context, input)=>{
    return {
        operation: (0, $7a2c7cffe65767aa$export$1d3c197393275463)(context).operation,
        region: await (0, $c725887315749781$export$b1276c07738d6325)(config.region)() || (()=>{
            throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
        })()
    };
};
const $25528546c573dfbf$export$51f8fd3bd6b63513 = $25528546c573dfbf$var$createEndpointRuleSetHttpAuthSchemeParametersProvider($25528546c573dfbf$var$_defaultS3HttpAuthSchemeParametersProvider);
function $25528546c573dfbf$var$createAwsAuthSigv4HttpAuthOption(authParameters) {
    return {
        schemeId: "aws.auth#sigv4",
        signingProperties: {
            name: "s3",
            region: authParameters.region
        },
        propertiesExtractor: (config, context)=>({
                signingProperties: {
                    config: config,
                    context: context
                }
            })
    };
}
function $25528546c573dfbf$var$createAwsAuthSigv4aHttpAuthOption(authParameters) {
    return {
        schemeId: "aws.auth#sigv4a",
        signingProperties: {
            name: "s3",
            region: authParameters.region
        },
        propertiesExtractor: (config, context)=>({
                signingProperties: {
                    config: config,
                    context: context
                }
            })
    };
}
const $25528546c573dfbf$var$createEndpointRuleSetHttpAuthSchemeProvider = (defaultEndpointResolver, defaultHttpAuthSchemeResolver, createHttpAuthOptionFunctions)=>{
    const endpointRuleSetHttpAuthSchemeProvider = (authParameters)=>{
        const endpoint = defaultEndpointResolver(authParameters);
        const authSchemes = endpoint.properties?.authSchemes;
        if (!authSchemes) return defaultHttpAuthSchemeResolver(authParameters);
        const options = [];
        for (const scheme of authSchemes){
            const { name: resolvedName, properties: properties = {}, ...rest } = scheme;
            const name = resolvedName.toLowerCase();
            if (resolvedName !== name) console.warn(`HttpAuthScheme has been normalized with lowercasing: \`${resolvedName}\` to \`${name}\``);
            let schemeId;
            if (name === "sigv4a") {
                schemeId = "aws.auth#sigv4a";
                const sigv4Present = authSchemes.find((s)=>{
                    const name = s.name.toLowerCase();
                    return name !== "sigv4a" && name.startsWith("sigv4");
                });
                if (!(0, $fffab07a6c30e081$export$7c225a620e2ca4fe).CrtSignerV4 && sigv4Present) continue;
            } else if (name.startsWith("sigv4")) schemeId = "aws.auth#sigv4";
            else throw new Error(`Unknown HttpAuthScheme found in \`@smithy.rules#endpointRuleSet\`: \`${name}\``);
            const createOption = createHttpAuthOptionFunctions[schemeId];
            if (!createOption) throw new Error(`Could not find HttpAuthOption create function for \`${schemeId}\``);
            const option = createOption(authParameters);
            option.schemeId = schemeId;
            option.signingProperties = {
                ...option.signingProperties || {},
                ...rest,
                ...properties
            };
            options.push(option);
        }
        return options;
    };
    return endpointRuleSetHttpAuthSchemeProvider;
};
const $25528546c573dfbf$var$_defaultS3HttpAuthSchemeProvider = (authParameters)=>{
    const options = [];
    authParameters.operation;
    options.push($25528546c573dfbf$var$createAwsAuthSigv4HttpAuthOption(authParameters));
    options.push($25528546c573dfbf$var$createAwsAuthSigv4aHttpAuthOption(authParameters));
    return options;
};
const $25528546c573dfbf$export$abc938646fa5843c = $25528546c573dfbf$var$createEndpointRuleSetHttpAuthSchemeProvider((0, $db95b6a52533afa5$export$47fc6e98c86e06e3), $25528546c573dfbf$var$_defaultS3HttpAuthSchemeProvider, {
    "aws.auth#sigv4": $25528546c573dfbf$var$createAwsAuthSigv4HttpAuthOption,
    "aws.auth#sigv4a": $25528546c573dfbf$var$createAwsAuthSigv4aHttpAuthOption
});
const $25528546c573dfbf$export$d38ef9c0c6c649ab = (config)=>{
    const config_0 = (0, $16283d5b0805f93c$export$e18f3f8a841a90ec)(config);
    const config_1 = (0, $b22594fd29f7762d$export$f3c0a1c0e9557d6b)(config_0);
    return {
        ...config_1
    };
};









class $c78cc8f3d96e6d6f$export$dc5bfdef4d64657b extends (0, $21ebe134f0322abe$export$cc7e12c76513e857).classBuilder().ep({
    ...(0, $6f3a98a1538687cd$export$9c07ced2019f0ae0),
    DisableS3ExpressSessionAuth: {
        type: "staticContextParams",
        value: true
    },
    Bucket: {
        type: "contextParams",
        name: "Bucket"
    }
}).m(function(Command, cs, config, o) {
    return [
        (0, $5b9375668e859164$export$53fdc69654553fd4)(config, this.serialize, this.deserialize),
        (0, $a239f3bc183c0683$export$946c80457b765eab)(config, Command.getEndpointParameterInstructions()),
        (0, $32b56a6d9accc693$export$97cbbd0d754f3189)(config)
    ];
}).s("AmazonS3", "CreateSession", {}).n("S3Client", "CreateSessionCommand").f((0, $b50962978b66428d$export$14cdfb40a19d6afd), (0, $b50962978b66428d$export$903b3044017ac69c)).ser((0, $45e1a5f717a7bf0f$export$6d03b8fc370e351b)).de((0, $45e1a5f717a7bf0f$export$35c5fda0247f7841)).build() {
}



var $86de223a6102276f$exports = {};
$86de223a6102276f$exports = JSON.parse("{\"name\":\"@aws-sdk/client-s3\",\"description\":\"AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native\",\"version\":\"3.658.1\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"node ../../scripts/compilation/inline client-s3\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\",\"extract:docs\":\"api-extractor run --local\",\"generate:client\":\"node ../../scripts/generate-clients/single-service --solo s3\",\"test\":\"yarn test:unit\",\"test:e2e\":\"yarn test:e2e:node && yarn test:e2e:browser\",\"test:e2e:browser\":\"ts-mocha test/**/*.browser.ispec.ts && karma start karma.conf.js\",\"test:e2e:node\":\"jest --c jest.config.e2e.js\",\"test:unit\":\"ts-mocha test/unit/**/*.spec.ts\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha1-browser\":\"5.2.0\",\"@aws-crypto/sha256-browser\":\"5.2.0\",\"@aws-crypto/sha256-js\":\"5.2.0\",\"@aws-sdk/client-sso-oidc\":\"3.658.1\",\"@aws-sdk/client-sts\":\"3.658.1\",\"@aws-sdk/core\":\"3.658.1\",\"@aws-sdk/credential-provider-node\":\"3.658.1\",\"@aws-sdk/middleware-bucket-endpoint\":\"3.654.0\",\"@aws-sdk/middleware-expect-continue\":\"3.654.0\",\"@aws-sdk/middleware-flexible-checksums\":\"3.658.1\",\"@aws-sdk/middleware-host-header\":\"3.654.0\",\"@aws-sdk/middleware-location-constraint\":\"3.654.0\",\"@aws-sdk/middleware-logger\":\"3.654.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.654.0\",\"@aws-sdk/middleware-sdk-s3\":\"3.658.1\",\"@aws-sdk/middleware-ssec\":\"3.654.0\",\"@aws-sdk/middleware-user-agent\":\"3.654.0\",\"@aws-sdk/region-config-resolver\":\"3.654.0\",\"@aws-sdk/signature-v4-multi-region\":\"3.658.1\",\"@aws-sdk/types\":\"3.654.0\",\"@aws-sdk/util-endpoints\":\"3.654.0\",\"@aws-sdk/util-user-agent-browser\":\"3.654.0\",\"@aws-sdk/util-user-agent-node\":\"3.654.0\",\"@aws-sdk/xml-builder\":\"3.654.0\",\"@smithy/config-resolver\":\"^3.0.8\",\"@smithy/core\":\"^2.4.6\",\"@smithy/eventstream-serde-browser\":\"^3.0.9\",\"@smithy/eventstream-serde-config-resolver\":\"^3.0.6\",\"@smithy/eventstream-serde-node\":\"^3.0.8\",\"@smithy/fetch-http-handler\":\"^3.2.8\",\"@smithy/hash-blob-browser\":\"^3.1.5\",\"@smithy/hash-node\":\"^3.0.6\",\"@smithy/hash-stream-node\":\"^3.1.5\",\"@smithy/invalid-dependency\":\"^3.0.6\",\"@smithy/md5-js\":\"^3.0.6\",\"@smithy/middleware-content-length\":\"^3.0.8\",\"@smithy/middleware-endpoint\":\"^3.1.3\",\"@smithy/middleware-retry\":\"^3.0.21\",\"@smithy/middleware-serde\":\"^3.0.6\",\"@smithy/middleware-stack\":\"^3.0.6\",\"@smithy/node-config-provider\":\"^3.1.7\",\"@smithy/node-http-handler\":\"^3.2.3\",\"@smithy/protocol-http\":\"^4.1.3\",\"@smithy/smithy-client\":\"^3.3.5\",\"@smithy/types\":\"^3.4.2\",\"@smithy/url-parser\":\"^3.0.6\",\"@smithy/util-base64\":\"^3.0.0\",\"@smithy/util-body-length-browser\":\"^3.0.0\",\"@smithy/util-body-length-node\":\"^3.0.0\",\"@smithy/util-defaults-mode-browser\":\"^3.0.21\",\"@smithy/util-defaults-mode-node\":\"^3.0.21\",\"@smithy/util-endpoints\":\"^2.1.2\",\"@smithy/util-middleware\":\"^3.0.6\",\"@smithy/util-retry\":\"^3.0.6\",\"@smithy/util-stream\":\"^3.1.8\",\"@smithy/util-utf8\":\"^3.0.0\",\"@smithy/util-waiter\":\"^3.1.5\",\"tslib\":\"^2.6.2\"},\"devDependencies\":{\"@aws-sdk/signature-v4-crt\":\"3.658.1\",\"@tsconfig/node16\":\"16.1.3\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^8.0.4\",\"@types/node\":\"^16.18.96\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typescript\":\"~4.9.5\"},\"engines\":{\"node\":\">=16.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*/**\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-s3\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-s3\"}}");



function $001cb43eb32df9da$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


var $8b10f128843b51b0$export$94539f84ed5fc908 = {
    name: "SHA-1"
};
var $8b10f128843b51b0$export$a201ebcdc3d6dbff = {
    name: "HMAC",
    hash: $8b10f128843b51b0$export$94539f84ed5fc908
};
var $8b10f128843b51b0$export$becd5c64e77cc59d = new Uint8Array([
    218,
    57,
    163,
    238,
    94,
    107,
    75,
    13,
    50,
    85,
    191,
    239,
    149,
    96,
    24,
    144,
    175,
    216,
    7,
    9
]);


const $da81302d5dc8b4c9$var$fallbackWindow = {};
function $da81302d5dc8b4c9$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $da81302d5dc8b4c9$var$fallbackWindow;
}


var $085bc7b0b440786a$export$c85d589bf4e25fef = /** @class */ function() {
    function Sha1(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $da81302d5dc8b4c9$export$2a77db4d0e0dd1ff)().crypto.subtle.importKey("raw", $085bc7b0b440786a$var$convertToBuffer(secret), (0, $8b10f128843b51b0$export$a201ebcdc3d6dbff), false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha1.prototype.update = function(data) {
        if ((0, $001cb43eb32df9da$export$ea55f474a468804e)(data)) return;
        var update = $085bc7b0b440786a$var$convertToBuffer(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha1.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $da81302d5dc8b4c9$export$2a77db4d0e0dd1ff)().crypto.subtle.sign((0, $8b10f128843b51b0$export$a201ebcdc3d6dbff), key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $001cb43eb32df9da$export$ea55f474a468804e)(this.toHash)) return Promise.resolve((0, $8b10f128843b51b0$export$becd5c64e77cc59d));
        return Promise.resolve().then(function() {
            return (0, $da81302d5dc8b4c9$export$2a77db4d0e0dd1ff)().crypto.subtle.digest((0, $8b10f128843b51b0$export$94539f84ed5fc908), _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    Sha1.prototype.reset = function() {
        this.toHash = new Uint8Array(0);
    };
    return Sha1;
}();
function $085bc7b0b440786a$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $8bf11bd0ff1e2e05$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}



var $b29a9f906be20c73$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $b29a9f906be20c73$export$519d4361bb708a57(window) {
    if ($b29a9f906be20c73$export$c4783ac5e58b0ef6(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $b29a9f906be20c73$export$17b9b1d09487d874(subtle);
    }
    return false;
}
function $b29a9f906be20c73$export$c4783ac5e58b0ef6(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
function $b29a9f906be20c73$export$17b9b1d09487d874(subtle) {
    return subtle && $b29a9f906be20c73$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
function $b29a9f906be20c73$export$d94d4c5ec4742a(subtle) {
    return (0, $3d105b71c9af75be$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return (0, $3d105b71c9af75be$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$b29a9f906be20c73$export$17b9b1d09487d874(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}






var $918ff770b9b74388$export$c85d589bf4e25fef = /** @class */ function() {
    function Sha1(secret) {
        if ((0, $b29a9f906be20c73$export$519d4361bb708a57)((0, $da81302d5dc8b4c9$export$2a77db4d0e0dd1ff)())) this.hash = new (0, $085bc7b0b440786a$export$c85d589bf4e25fef)(secret);
        else throw new Error("SHA1 not supported");
    }
    Sha1.prototype.update = function(data, encoding) {
        this.hash.update((0, $934c9590050643f0$export$4f21f20c2f1a9063)(data));
    };
    Sha1.prototype.digest = function() {
        return this.hash.digest();
    };
    Sha1.prototype.reset = function() {
        this.hash.reset();
    };
    return Sha1;
}();






var $a05911e407cb5d75$export$2113793cf72f4599 = {
    name: "SHA-256"
};
var $a05911e407cb5d75$export$1f80374c274e65a6 = {
    name: "HMAC",
    hash: $a05911e407cb5d75$export$2113793cf72f4599
};
var $a05911e407cb5d75$export$b6c4a2c4743c9cae = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);



var $4a43f6ab9d832717$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(data) {
        if ((0, $3c18a85c0a19e10f$export$ea55f474a468804e)(data)) return;
        var update = (0, $934c9590050643f0$export$4f21f20c2f1a9063)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $da81302d5dc8b4c9$export$2a77db4d0e0dd1ff)().crypto.subtle.sign((0, $a05911e407cb5d75$export$1f80374c274e65a6), key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $3c18a85c0a19e10f$export$ea55f474a468804e)(this.toHash)) return Promise.resolve((0, $a05911e407cb5d75$export$b6c4a2c4743c9cae));
        return Promise.resolve().then(function() {
            return (0, $da81302d5dc8b4c9$export$2a77db4d0e0dd1ff)().crypto.subtle.digest((0, $a05911e407cb5d75$export$2113793cf72f4599), _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    Sha256.prototype.reset = function() {
        var _this = this;
        this.toHash = new Uint8Array(0);
        if (this.secret && this.secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $da81302d5dc8b4c9$export$2a77db4d0e0dd1ff)().crypto.subtle.importKey("raw", (0, $934c9590050643f0$export$4f21f20c2f1a9063)(_this.secret), (0, $a05911e407cb5d75$export$1f80374c274e65a6), false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    };
    return Sha256;
}();



/**
 * @internal
 */ var $a291c9974be52edb$export$b2e3d6d444266a5c = 64;
var $a291c9974be52edb$export$d7bd469488748c5f = 32;
var $a291c9974be52edb$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $a291c9974be52edb$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $a291c9974be52edb$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $e92964e9d0901788$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $a291c9974be52edb$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $a291c9974be52edb$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $a291c9974be52edb$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $a291c9974be52edb$export$b2e3d6d444266a5c) >= (0, $a291c9974be52edb$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $a291c9974be52edb$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $a291c9974be52edb$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $a291c9974be52edb$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $a291c9974be52edb$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $a291c9974be52edb$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $a291c9974be52edb$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $a291c9974be52edb$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();



var $cbfbdd85b808cf14$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $e92964e9d0901788$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $3c18a85c0a19e10f$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $934c9590050643f0$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $3d105b71c9af75be$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $3d105b71c9af75be$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $e92964e9d0901788$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $e92964e9d0901788$export$aab6bc1ad3c77a42)();
            var inner = $cbfbdd85b808cf14$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $a291c9974be52edb$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $a291c9974be52edb$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $cbfbdd85b808cf14$var$bufferFromSecret(secret) {
    var input = (0, $934c9590050643f0$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $a291c9974be52edb$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $e92964e9d0901788$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $a291c9974be52edb$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}







var $6787848122dde962$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $b29a9f906be20c73$export$519d4361bb708a57)((0, $da81302d5dc8b4c9$export$2a77db4d0e0dd1ff)())) this.hash = new (0, $4a43f6ab9d832717$export$3b58ea8124ac5e28)(secret);
        else this.hash = new (0, $cbfbdd85b808cf14$export$3b58ea8124ac5e28)(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update((0, $934c9590050643f0$export$4f21f20c2f1a9063)(data));
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function() {
        this.hash.reset();
    };
    return Sha256;
}();





var $373e5cbd79fcd03e$exports = {};
!function(e, t) {
    $373e5cbd79fcd03e$exports = t();
}($373e5cbd79fcd03e$exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


const $46ce50aad5f87415$export$69d579f32876892f = ({ serviceId: serviceId, clientVersion: clientVersion })=>async ()=>{
        const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($373e5cbd79fcd03e$exports))).parse(window.navigator.userAgent) : undefined;
        const sections = [
            [
                "aws-sdk-js",
                clientVersion
            ],
            [
                "ua",
                "2.0"
            ],
            [
                `os/${parsedUA?.os?.name || "other"}`,
                parsedUA?.os?.version
            ],
            [
                "lang/js"
            ],
            [
                "md/browser",
                `${parsedUA?.browser?.name ?? "unknown"}_${parsedUA?.browser?.version ?? "unknown"}`
            ]
        ];
        if (serviceId) sections.push([
            `api/${serviceId}`,
            clientVersion
        ]);
        return sections;
    };






class $0cf31f39b234bf8f$export$8a5e19712a0a5deb {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $0cf31f39b234bf8f$var$negate(bytes);
        return new $0cf31f39b234bf8f$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $0cf31f39b234bf8f$var$negate(bytes);
        return parseInt((0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function $0cf31f39b234bf8f$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


class $0e26798bb80f7023$export$74fd41a85c5dcec9 {
    constructor(toUtf8, fromUtf8){
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = this.fromUtf8(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = this.fromUtf8(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set((0, $0cf31f39b234bf8f$export$8a5e19712a0a5deb).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$0e26798bb80f7023$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $7ec653e03ba7d829$export$1a8ceedbd5845648)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
    parse(headers) {
        const out = {};
        let position = 0;
        while(position < headers.byteLength){
            const nameLength = headers.getUint8(position++);
            const name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0:
                    out[name] = {
                        type: $0e26798bb80f7023$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1:
                    out[name] = {
                        type: $0e26798bb80f7023$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2:
                    out[name] = {
                        type: $0e26798bb80f7023$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3:
                    out[name] = {
                        type: $0e26798bb80f7023$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4:
                    out[name] = {
                        type: $0e26798bb80f7023$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5:
                    out[name] = {
                        type: $0e26798bb80f7023$var$LONG_TAG,
                        value: new (0, $0cf31f39b234bf8f$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6:
                    const binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $0e26798bb80f7023$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7:
                    const stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $0e26798bb80f7023$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8:
                    out[name] = {
                        type: $0e26798bb80f7023$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $0cf31f39b234bf8f$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9:
                    const uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $0e26798bb80f7023$var$UUID_TAG,
                        value: `${(0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(uuidBytes.subarray(0, 4))}-${(0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(uuidBytes.subarray(4, 6))}-${(0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(uuidBytes.subarray(6, 8))}-${(0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(uuidBytes.subarray(8, 10))}-${(0, $7ec653e03ba7d829$export$7ea66e3774a60b67)(uuidBytes.subarray(10))}`
                    };
                    break;
                default:
                    throw new Error(`Unrecognized header type tag`);
            }
        }
        return out;
    }
}
var $0e26798bb80f7023$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($0e26798bb80f7023$var$HEADER_VALUE_TYPE || ($0e26798bb80f7023$var$HEADER_VALUE_TYPE = {}));
const $0e26798bb80f7023$var$BOOLEAN_TAG = "boolean";
const $0e26798bb80f7023$var$BYTE_TAG = "byte";
const $0e26798bb80f7023$var$SHORT_TAG = "short";
const $0e26798bb80f7023$var$INT_TAG = "integer";
const $0e26798bb80f7023$var$LONG_TAG = "long";
const $0e26798bb80f7023$var$BINARY_TAG = "binary";
const $0e26798bb80f7023$var$STRING_TAG = "string";
const $0e26798bb80f7023$var$TIMESTAMP_TAG = "timestamp";
const $0e26798bb80f7023$var$UUID_TAG = "uuid";
const $0e26798bb80f7023$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;



const $76707645de2242b0$var$PRELUDE_MEMBER_LENGTH = 4;
const $76707645de2242b0$var$PRELUDE_LENGTH = $76707645de2242b0$var$PRELUDE_MEMBER_LENGTH * 2;
const $76707645de2242b0$var$CHECKSUM_LENGTH = 4;
const $76707645de2242b0$var$MINIMUM_MESSAGE_LENGTH = $76707645de2242b0$var$PRELUDE_LENGTH + $76707645de2242b0$var$CHECKSUM_LENGTH * 2;
function $76707645de2242b0$export$546b6bc432bd9a53({ byteLength: byteLength, byteOffset: byteOffset, buffer: buffer }) {
    if (byteLength < $76707645de2242b0$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    const view = new DataView(buffer, byteOffset, byteLength);
    const messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    const headerLength = view.getUint32($76707645de2242b0$var$PRELUDE_MEMBER_LENGTH, false);
    const expectedPreludeChecksum = view.getUint32($76707645de2242b0$var$PRELUDE_LENGTH, false);
    const expectedMessageChecksum = view.getUint32(byteLength - $76707645de2242b0$var$CHECKSUM_LENGTH, false);
    const checksummer = new (0, $b839d0c14cc0f1ef$export$16d8d62894c71747)().update(new Uint8Array(buffer, byteOffset, $76707645de2242b0$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error(`The prelude checksum specified in the message (${expectedPreludeChecksum}) does not match the calculated CRC32 checksum (${checksummer.digest()})`);
    checksummer.update(new Uint8Array(buffer, byteOffset + $76707645de2242b0$var$PRELUDE_LENGTH, byteLength - ($76707645de2242b0$var$PRELUDE_LENGTH + $76707645de2242b0$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error(`The message checksum (${checksummer.digest()}) did not match the expected value of ${expectedMessageChecksum}`);
    return {
        headers: new DataView(buffer, byteOffset + $76707645de2242b0$var$PRELUDE_LENGTH + $76707645de2242b0$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $76707645de2242b0$var$PRELUDE_LENGTH + $76707645de2242b0$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($76707645de2242b0$var$PRELUDE_LENGTH + $76707645de2242b0$var$CHECKSUM_LENGTH + $76707645de2242b0$var$CHECKSUM_LENGTH))
    };
}


class $419f1d3bf998eb6b$export$60e2ad0c77b6bab {
    constructor(toUtf8, fromUtf8){
        this.headerMarshaller = new (0, $0e26798bb80f7023$export$74fd41a85c5dcec9)(toUtf8, fromUtf8);
        this.messageBuffer = [];
        this.isEndOfStream = false;
    }
    feed(message) {
        this.messageBuffer.push(this.decode(message));
    }
    endOfStream() {
        this.isEndOfStream = true;
    }
    getMessage() {
        const message = this.messageBuffer.pop();
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessage () {
                return message;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    getAvailableMessages() {
        const messages = this.messageBuffer;
        this.messageBuffer = [];
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessages () {
                return messages;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    encode({ headers: rawHeaders, body: body }) {
        const headers = this.headerMarshaller.format(rawHeaders);
        const length = headers.byteLength + body.byteLength + 16;
        const out = new Uint8Array(length);
        const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        const checksum = new (0, $b839d0c14cc0f1ef$export$16d8d62894c71747)();
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    }
    decode(message) {
        const { headers: headers, body: body } = (0, $76707645de2242b0$export$546b6bc432bd9a53)(message);
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    }
    formatHeaders(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    }
}






class $3c63156f93a27d1a$export$4ffe73dc7dfe29dd {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const bytes of this.options.inputStream){
            const decoded = this.options.decoder.decode(bytes);
            yield decoded;
        }
    }
}


class $c5c6c571589c5516$export$1204278c33e35f1b {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const msg of this.options.messageStream){
            const encoded = this.options.encoder.encode(msg);
            yield encoded;
        }
        if (this.options.includeEndFrame) yield new Uint8Array(0);
    }
}


class $babe59404a7217bf$export$c78403d78d3ee8a {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const message of this.options.messageStream){
            const deserialized = await this.options.deserializer(message);
            if (deserialized === undefined) continue;
            yield deserialized;
        }
    }
}


class $4fc0d9cc3b30bb54$export$96361fe9dd919a8e {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const chunk of this.options.inputStream){
            const payloadBuf = this.options.serializer(chunk);
            yield payloadBuf;
        }
    }
}




function $e8899a39eb7dba2c$export$3071cd8be9cd01e0(source) {
    let currentMessageTotalLength = 0;
    let currentMessagePendingLength = 0;
    let currentMessage = null;
    let messageLengthBuffer = null;
    const allocateMessage = (size)=>{
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        const currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false);
    };
    const iterator = async function*() {
        const sourceIterator = source[Symbol.asyncIterator]();
        while(true){
            const { value: value, done: done } = await sourceIterator.next();
            if (done) {
                if (!currentMessageTotalLength) return;
                else if (currentMessageTotalLength === currentMessagePendingLength) yield currentMessage;
                else throw new Error("Truncated event message received.");
                return;
            }
            const chunkLength = value.length;
            let currentOffset = 0;
            while(currentOffset < chunkLength){
                if (!currentMessage) {
                    const bytesRemaining = chunkLength - currentOffset;
                    if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                    const numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining);
                    messageLengthBuffer.set(value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                    currentMessagePendingLength += numBytesForTotal;
                    currentOffset += numBytesForTotal;
                    if (currentMessagePendingLength < 4) break;
                    allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                    messageLengthBuffer = null;
                }
                const numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset);
                currentMessage.set(value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                currentMessagePendingLength += numBytesToWrite;
                currentOffset += numBytesToWrite;
                if (currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength) {
                    yield currentMessage;
                    currentMessage = null;
                    currentMessageTotalLength = 0;
                    currentMessagePendingLength = 0;
                }
            }
        }
    };
    return {
        [Symbol.asyncIterator]: iterator
    };
}


function $06ae7cda3e967cbf$export$a1a364c5c6ddc1b4(source, options) {
    const messageUnmarshaller = $06ae7cda3e967cbf$export$5ecf053b59827691(options.deserializer, options.toUtf8);
    return {
        [Symbol.asyncIterator]: async function*() {
            for await (const chunk of source){
                const message = options.eventStreamCodec.decode(chunk);
                const type = await messageUnmarshaller(message);
                if (type === undefined) continue;
                yield type;
            }
        }
    };
}
function $06ae7cda3e967cbf$export$5ecf053b59827691(deserializer, toUtf8) {
    return async function(message) {
        const { value: messageType } = message.headers[":message-type"];
        if (messageType === "error") {
            const unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
            unmodeledError.name = message.headers[":error-code"].value;
            throw unmodeledError;
        } else if (messageType === "exception") {
            const code = message.headers[":exception-type"].value;
            const exception = {
                [code]: message
            };
            const deserializedException = await deserializer(exception);
            if (deserializedException.$unknown) {
                const error = new Error(toUtf8(message.body));
                error.name = code;
                throw error;
            }
            throw deserializedException[code];
        } else if (messageType === "event") {
            const event = {
                [message.headers[":event-type"].value]: message
            };
            const deserialized = await deserializer(event);
            if (deserialized.$unknown) return;
            return deserialized;
        } else throw Error(`Unrecognizable event type: ${message.headers[":event-type"].value}`);
    };
}


class $c3dfd31c12aacbb5$export$b64afa0aa6ce60e2 {
    constructor({ utf8Encoder: utf8Encoder, utf8Decoder: utf8Decoder }){
        this.eventStreamCodec = new (0, $419f1d3bf998eb6b$export$60e2ad0c77b6bab)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    deserialize(body, deserializer) {
        const inputStream = (0, $e8899a39eb7dba2c$export$3071cd8be9cd01e0)(body);
        return new (0, $babe59404a7217bf$export$c78403d78d3ee8a)({
            messageStream: new (0, $3c63156f93a27d1a$export$4ffe73dc7dfe29dd)({
                inputStream: inputStream,
                decoder: this.eventStreamCodec
            }),
            deserializer: (0, $06ae7cda3e967cbf$export$5ecf053b59827691)(deserializer, this.utfEncoder)
        });
    }
    serialize(inputStream, serializer) {
        return new (0, $c5c6c571589c5516$export$1204278c33e35f1b)({
            messageStream: new (0, $4fc0d9cc3b30bb54$export$96361fe9dd919a8e)({
                inputStream: inputStream,
                serializer: serializer
            }),
            encoder: this.eventStreamCodec,
            includeEndFrame: true
        });
    }
}



const $1571218b3c976523$export$9d23a885702ebafb = (options)=>new (0, $c3dfd31c12aacbb5$export$b64afa0aa6ce60e2)(options);




const $e23867a7a2bf78dc$export$2346526b0991dd88 = (readableStream)=>({
        [Symbol.asyncIterator]: async function*() {
            const reader = readableStream.getReader();
            try {
                while(true){
                    const { done: done, value: value } = await reader.read();
                    if (done) return;
                    yield value;
                }
            } finally{
                reader.releaseLock();
            }
        }
    });
const $e23867a7a2bf78dc$export$92326f9d37f111f = (asyncIterable)=>{
    const iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) return controller.close();
            controller.enqueue(value);
        }
    });
};


class $5715bc2ccfc2cfc9$export$b64afa0aa6ce60e2 {
    constructor({ utf8Encoder: utf8Encoder, utf8Decoder: utf8Decoder }){
        this.universalMarshaller = new (0, $c3dfd31c12aacbb5$export$b64afa0aa6ce60e2)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    deserialize(body, deserializer) {
        const bodyIterable = $5715bc2ccfc2cfc9$var$isReadableStream(body) ? (0, $e23867a7a2bf78dc$export$2346526b0991dd88)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    }
    serialize(input, serializer) {
        const serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, $e23867a7a2bf78dc$export$92326f9d37f111f)(serialziedIterable) : serialziedIterable;
    }
}
const $5715bc2ccfc2cfc9$var$isReadableStream = (body)=>typeof ReadableStream === "function" && body instanceof ReadableStream;



const $06afec79a04ede4d$export$9d23a885702ebafb = (options)=>new (0, $5715bc2ccfc2cfc9$export$b64afa0aa6ce60e2)(options);






function $7b46c3c2be15c43f$export$7541dba16c2127c8(blob, onChunk, chunkSize = 1048576) {
    return new Promise((resolve, reject)=>{
        const fileReader = new FileReader();
        fileReader.addEventListener("error", reject);
        fileReader.addEventListener("abort", reject);
        const size = blob.size;
        let totalBytesRead = 0;
        function read() {
            if (totalBytesRead >= size) {
                resolve();
                return;
            }
            fileReader.readAsArrayBuffer(blob.slice(totalBytesRead, Math.min(size, totalBytesRead + chunkSize)));
        }
        fileReader.addEventListener("load", (event)=>{
            const result = event.target.result;
            onChunk(new Uint8Array(result));
            totalBytesRead += result.byteLength;
            read();
        });
        read();
    });
}


const $2fdbe4f4d4ddd199$export$ea66e9c498b7933c = async function blobHasher(hashCtor, blob) {
    const hash = new hashCtor();
    await (0, $7b46c3c2be15c43f$export$7541dba16c2127c8)(blob, (chunk)=>{
        hash.update(chunk);
    });
    return hash.digest();
};


const $5531d04e523a5f99$export$8b6362171c4dfa64 = (message)=>()=>{
        throw new Error(message);
    };


const $f3d8ada63f9bc41f$export$d59dd53963f8f3d5 = (message)=>()=>Promise.reject(message);





const $efd19bf30cf82d4f$export$b2e3d6d444266a5c = 64;
const $efd19bf30cf82d4f$export$d7bd469488748c5f = 16;
const $efd19bf30cf82d4f$export$d788bc089976c004 = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];


class $cdc91e68aeda053f$export$9f5a3dfc7a9f5dd {
    constructor(){
        this.reset();
    }
    update(sourceData) {
        if ($cdc91e68aeda053f$var$isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        const data = $cdc91e68aeda053f$var$convertToBuffer(sourceData);
        let position = 0;
        let { byteLength: byteLength } = data;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, $efd19bf30cf82d4f$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    }
    async digest() {
        if (!this.finished) {
            const { buffer: buffer, bufferLength: undecoratedLength, bytesHashed: bytesHashed } = this;
            const bitsHashed = bytesHashed * 8;
            buffer.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % (0, $efd19bf30cf82d4f$export$b2e3d6d444266a5c) >= (0, $efd19bf30cf82d4f$export$b2e3d6d444266a5c) - 8) {
                for(let i = this.bufferLength; i < (0, $efd19bf30cf82d4f$export$b2e3d6d444266a5c); i++)buffer.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(let i = this.bufferLength; i < (0, $efd19bf30cf82d4f$export$b2e3d6d444266a5c) - 8; i++)buffer.setUint8(i, 0);
            buffer.setUint32((0, $efd19bf30cf82d4f$export$b2e3d6d444266a5c) - 8, bitsHashed >>> 0, true);
            buffer.setUint32((0, $efd19bf30cf82d4f$export$b2e3d6d444266a5c) - 4, Math.floor(bitsHashed / 0x100000000), true);
            this.hashBuffer();
            this.finished = true;
        }
        const out = new DataView(new ArrayBuffer((0, $efd19bf30cf82d4f$export$d7bd469488748c5f)));
        for(let i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
        return new Uint8Array(out.buffer, out.byteOffset, out.byteLength);
    }
    hashBuffer() {
        const { buffer: buffer, state: state } = this;
        let a = state[0], b = state[1], c = state[2], d = state[3];
        a = $cdc91e68aeda053f$var$ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = $cdc91e68aeda053f$var$ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = $cdc91e68aeda053f$var$ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = $cdc91e68aeda053f$var$ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = $cdc91e68aeda053f$var$ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = $cdc91e68aeda053f$var$ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = $cdc91e68aeda053f$var$ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = $cdc91e68aeda053f$var$ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = $cdc91e68aeda053f$var$ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = $cdc91e68aeda053f$var$ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = $cdc91e68aeda053f$var$ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = $cdc91e68aeda053f$var$ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = $cdc91e68aeda053f$var$ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = $cdc91e68aeda053f$var$ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = $cdc91e68aeda053f$var$ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = $cdc91e68aeda053f$var$ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = $cdc91e68aeda053f$var$gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = $cdc91e68aeda053f$var$gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = $cdc91e68aeda053f$var$gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = $cdc91e68aeda053f$var$gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = $cdc91e68aeda053f$var$gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = $cdc91e68aeda053f$var$gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = $cdc91e68aeda053f$var$gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = $cdc91e68aeda053f$var$gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = $cdc91e68aeda053f$var$gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = $cdc91e68aeda053f$var$gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = $cdc91e68aeda053f$var$gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = $cdc91e68aeda053f$var$gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = $cdc91e68aeda053f$var$gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = $cdc91e68aeda053f$var$gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = $cdc91e68aeda053f$var$gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = $cdc91e68aeda053f$var$gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = $cdc91e68aeda053f$var$hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = $cdc91e68aeda053f$var$hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = $cdc91e68aeda053f$var$hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = $cdc91e68aeda053f$var$hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = $cdc91e68aeda053f$var$hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = $cdc91e68aeda053f$var$hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = $cdc91e68aeda053f$var$hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = $cdc91e68aeda053f$var$hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = $cdc91e68aeda053f$var$hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = $cdc91e68aeda053f$var$hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = $cdc91e68aeda053f$var$hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = $cdc91e68aeda053f$var$hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = $cdc91e68aeda053f$var$hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = $cdc91e68aeda053f$var$hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = $cdc91e68aeda053f$var$hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = $cdc91e68aeda053f$var$hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = $cdc91e68aeda053f$var$ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = $cdc91e68aeda053f$var$ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = $cdc91e68aeda053f$var$ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = $cdc91e68aeda053f$var$ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = $cdc91e68aeda053f$var$ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = $cdc91e68aeda053f$var$ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = $cdc91e68aeda053f$var$ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = $cdc91e68aeda053f$var$ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = $cdc91e68aeda053f$var$ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = $cdc91e68aeda053f$var$ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = $cdc91e68aeda053f$var$ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = $cdc91e68aeda053f$var$ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = $cdc91e68aeda053f$var$ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = $cdc91e68aeda053f$var$ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = $cdc91e68aeda053f$var$ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = $cdc91e68aeda053f$var$ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    }
    reset() {
        this.state = Uint32Array.from((0, $efd19bf30cf82d4f$export$d788bc089976c004));
        this.buffer = new DataView(new ArrayBuffer((0, $efd19bf30cf82d4f$export$b2e3d6d444266a5c)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
}
function $cdc91e68aeda053f$var$cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function $cdc91e68aeda053f$var$ff(a, b, c, d, x, s, t) {
    return $cdc91e68aeda053f$var$cmn(b & c | ~b & d, a, b, x, s, t);
}
function $cdc91e68aeda053f$var$gg(a, b, c, d, x, s, t) {
    return $cdc91e68aeda053f$var$cmn(b & d | c & ~d, a, b, x, s, t);
}
function $cdc91e68aeda053f$var$hh(a, b, c, d, x, s, t) {
    return $cdc91e68aeda053f$var$cmn(b ^ c ^ d, a, b, x, s, t);
}
function $cdc91e68aeda053f$var$ii(a, b, c, d, x, s, t) {
    return $cdc91e68aeda053f$var$cmn(c ^ (b | ~d), a, b, x, s, t);
}
function $cdc91e68aeda053f$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $cdc91e68aeda053f$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $4bb30f9042f6d66d$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


const $e4f7277a32834481$var$TEXT_ENCODER = typeof TextEncoder == "function" ? new TextEncoder() : null;
const $e4f7277a32834481$export$967f3527bf233bc0 = (body)=>{
    if (typeof body === "string") {
        if ($e4f7277a32834481$var$TEXT_ENCODER) return $e4f7277a32834481$var$TEXT_ENCODER.encode(body).byteLength;
        let len = body.length;
        for(let i = len - 1; i >= 0; i--){
            const code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error(`Body Length computation failed for ${body}`);
};






const $ca5abb7f53535b53$export$86d5c90340985ada = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);




const $f41f909799a0a302$export$6a001c300b5a041e = (response)=>(0, $55997741113954a0$export$1d94dfe0d9d1f1e7).isInstance(response) ? response.headers?.date ?? response.headers?.Date : undefined;


const $b7957e234a61f40a$export$c162a01d4a03ea6f = (clockTime, systemClockOffset)=>Math.abs((0, $ca5abb7f53535b53$export$86d5c90340985ada)(systemClockOffset).getTime() - clockTime) >= 300000;


const $d58c7070976e65d4$export$1ed4d48b860b1348 = (clockTime, currentSystemClockOffset)=>{
    const clockTimeInMs = Date.parse(clockTime);
    if ((0, $b7957e234a61f40a$export$c162a01d4a03ea6f)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};


const $e5326613105e9f22$var$throwSigningPropertyError = (name, property)=>{
    if (!property) throw new Error(`Property \`${name}\` is not resolved for AWS SDK SigV4Auth`);
    return property;
};
const $e5326613105e9f22$export$bca4a894ff7cfe11 = async (signingProperties)=>{
    const context = $e5326613105e9f22$var$throwSigningPropertyError("context", signingProperties.context);
    const config = $e5326613105e9f22$var$throwSigningPropertyError("config", signingProperties.config);
    const authScheme = context.endpointV2?.properties?.authSchemes?.[0];
    const signerFunction = $e5326613105e9f22$var$throwSigningPropertyError("signer", config.signer);
    const signer = await signerFunction(authScheme);
    const signingRegion = signingProperties?.signingRegion;
    const signingRegionSet = signingProperties?.signingRegionSet;
    const signingName = signingProperties?.signingName;
    return {
        config: config,
        signer: signer,
        signingRegion: signingRegion,
        signingRegionSet: signingRegionSet,
        signingName: signingName
    };
};
class $e5326613105e9f22$export$8d10c019aa195a2b {
    async sign(httpRequest, identity, signingProperties) {
        if (!(0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(httpRequest)) throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
        const validatedProps = await $e5326613105e9f22$export$bca4a894ff7cfe11(signingProperties);
        const { config: config, signer: signer } = validatedProps;
        let { signingRegion: signingRegion, signingName: signingName } = validatedProps;
        const handlerExecutionContext = signingProperties.context;
        if (handlerExecutionContext?.authSchemes?.length ?? false) {
            const [first, second] = handlerExecutionContext.authSchemes;
            if (first?.name === "sigv4a" && second?.name === "sigv4") {
                signingRegion = second?.signingRegion ?? signingRegion;
                signingName = second?.signingName ?? signingName;
            }
        }
        const signedRequest = await signer.sign(httpRequest, {
            signingDate: (0, $ca5abb7f53535b53$export$86d5c90340985ada)(config.systemClockOffset),
            signingRegion: signingRegion,
            signingService: signingName
        });
        return signedRequest;
    }
    errorHandler(signingProperties) {
        return (error)=>{
            const serverTime = error.ServerTime ?? (0, $f41f909799a0a302$export$6a001c300b5a041e)(error.$response);
            if (serverTime) {
                const config = $e5326613105e9f22$var$throwSigningPropertyError("config", signingProperties.config);
                const initialSystemClockOffset = config.systemClockOffset;
                config.systemClockOffset = (0, $d58c7070976e65d4$export$1ed4d48b860b1348)(serverTime, config.systemClockOffset);
                const clockSkewCorrected = config.systemClockOffset !== initialSystemClockOffset;
                if (clockSkewCorrected && error.$metadata) error.$metadata.clockSkewCorrected = true;
            }
            throw error;
        };
    }
    successHandler(httpResponse, signingProperties) {
        const dateHeader = (0, $f41f909799a0a302$export$6a001c300b5a041e)(httpResponse);
        if (dateHeader) {
            const config = $e5326613105e9f22$var$throwSigningPropertyError("config", signingProperties.config);
            config.systemClockOffset = (0, $d58c7070976e65d4$export$1ed4d48b860b1348)(dateHeader, config.systemClockOffset);
        }
    }
}
const $e5326613105e9f22$export$9e647fbacb03e1b7 = $e5326613105e9f22$export$8d10c019aa195a2b;


class $c0ab6846276dc7bd$export$1e85d3ad6cefeda6 extends (0, $e5326613105e9f22$export$8d10c019aa195a2b) {
    async sign(httpRequest, identity, signingProperties) {
        if (!(0, $435a3b4f1285ae7b$export$7587955500404ec3).isInstance(httpRequest)) throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
        const { config: config, signer: signer, signingRegion: signingRegion, signingRegionSet: signingRegionSet, signingName: signingName } = await (0, $e5326613105e9f22$export$bca4a894ff7cfe11)(signingProperties);
        const configResolvedSigningRegionSet = await config.sigv4aSigningRegionSet?.();
        const multiRegionOverride = (configResolvedSigningRegionSet ?? signingRegionSet ?? [
            signingRegion
        ]).join(",");
        const signedRequest = await signer.sign(httpRequest, {
            signingDate: (0, $ca5abb7f53535b53$export$86d5c90340985ada)(config.systemClockOffset),
            signingRegion: multiRegionOverride,
            signingService: signingName
        });
        return signedRequest;
    }
}










const $ae29b1b9858341aa$export$ad0966540b0e71e5 = (config)=>{
    return {
        apiVersion: "2006-03-01",
        base64Decoder: config?.base64Decoder ?? (0, $c9672f02a48da6a7$export$c537b38001c583b7),
        base64Encoder: config?.base64Encoder ?? (0, $8720d4d1690563ba$export$37cc283d8fbd3462),
        disableHostPrefix: config?.disableHostPrefix ?? false,
        endpointProvider: config?.endpointProvider ?? (0, $db95b6a52533afa5$export$47fc6e98c86e06e3),
        extensions: config?.extensions ?? [],
        getAwsChunkedEncodingStream: config?.getAwsChunkedEncodingStream ?? (0, $e62cfc45517db9c1$export$cc0c9507624e70d1),
        httpAuthSchemeProvider: config?.httpAuthSchemeProvider ?? (0, $25528546c573dfbf$export$abc938646fa5843c),
        httpAuthSchemes: config?.httpAuthSchemes ?? [
            {
                schemeId: "aws.auth#sigv4",
                identityProvider: (ipc)=>ipc.getIdentityProvider("aws.auth#sigv4"),
                signer: new (0, $e5326613105e9f22$export$8d10c019aa195a2b)()
            },
            {
                schemeId: "aws.auth#sigv4a",
                identityProvider: (ipc)=>ipc.getIdentityProvider("aws.auth#sigv4a"),
                signer: new (0, $c0ab6846276dc7bd$export$1e85d3ad6cefeda6)()
            }
        ],
        logger: config?.logger ?? new (0, $2a2593fbf5316f50$export$4147bde06f294c2e)(),
        sdkStreamMixin: config?.sdkStreamMixin ?? (0, $70720bd4dd28b6bd$export$5f9760b56bbf9f65),
        serviceId: config?.serviceId ?? "S3",
        signerConstructor: config?.signerConstructor ?? (0, $9a7bea7ba9b05dd8$export$9b641ca3a5f7a09),
        signingEscapePath: config?.signingEscapePath ?? false,
        urlParser: config?.urlParser ?? (0, $2b893278b729b3be$export$7a5253c0f62e0150),
        useArnRegion: config?.useArnRegion ?? false,
        utf8Decoder: config?.utf8Decoder ?? (0, $4bb30f9042f6d66d$export$c7c5cef950a4d2fc),
        utf8Encoder: config?.utf8Encoder ?? (0, $babd20f9f8bd393c$export$b4b216764bb846eb)
    };
};





const $714b35cadf0744bf$export$32aeb2667d16f7c1 = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];


const $6ac6ee415aaf5555$export$b146d618450007ac = ({ defaultsMode: defaultsMode } = {})=>(0, $dfbbfa0f5ddf7bfc$export$fc10aeed3a532e2a)(async ()=>{
        const mode = typeof defaultsMode === "function" ? await defaultsMode() : defaultsMode;
        switch(mode?.toLowerCase()){
            case "auto":
                return Promise.resolve($6ac6ee415aaf5555$var$isMobileBrowser() ? "mobile" : "standard");
            case "mobile":
            case "in-region":
            case "cross-region":
            case "standard":
            case "legacy":
                return Promise.resolve(mode?.toLocaleLowerCase());
            case undefined:
                return Promise.resolve("legacy");
            default:
                throw new Error(`Invalid parameter for "defaultsMode", expect ${(0, $714b35cadf0744bf$export$32aeb2667d16f7c1).join(", ")}, got ${mode}`);
        }
    });
const $6ac6ee415aaf5555$var$isMobileBrowser = ()=>{
    const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($373e5cbd79fcd03e$exports))).parse(window.navigator.userAgent) : undefined;
    const platform = parsedUA?.platform?.type;
    return platform === "tablet" || platform === "mobile";
};




const $79581daf2e92f468$export$ad0966540b0e71e5 = (config)=>{
    const defaultsMode = (0, $6ac6ee415aaf5555$export$b146d618450007ac)(config);
    const defaultConfigProvider = ()=>defaultsMode().then((0, $9921fb7c76704fbf$export$b6e2b46631b45a92));
    const clientSharedValues = (0, $ae29b1b9858341aa$export$ad0966540b0e71e5)(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode: defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? (0, $e4f7277a32834481$export$967f3527bf233bc0),
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_)=>()=>Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ?? (0, $46ce50aad5f87415$export$69d579f32876892f)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($86de223a6102276f$exports))).version
        }),
        eventStreamSerdeProvider: config?.eventStreamSerdeProvider ?? (0, $06afec79a04ede4d$export$9d23a885702ebafb),
        maxAttempts: config?.maxAttempts ?? (0, $c7803bea46144fee$export$2c7e51f38ba5a406),
        md5: config?.md5 ?? (0, $cdc91e68aeda053f$export$9f5a3dfc7a9f5dd),
        region: config?.region ?? (0, $f3d8ada63f9bc41f$export$d59dd53963f8f3d5)("Region is missing"),
        requestHandler: (0, $c39c4ec5e8ff2223$export$83588b87edbfa7e0).create(config?.requestHandler ?? defaultConfigProvider),
        retryMode: config?.retryMode ?? (async ()=>(await defaultConfigProvider()).retryMode || (0, $c7803bea46144fee$export$41315747b7c5d042)),
        sha1: config?.sha1 ?? (0, $918ff770b9b74388$export$c85d589bf4e25fef),
        sha256: config?.sha256 ?? (0, $6787848122dde962$export$3b58ea8124ac5e28),
        streamCollector: config?.streamCollector ?? (0, $0569814c11087424$export$17bf97b72e307d52),
        streamHasher: config?.streamHasher ?? (0, $2fdbe4f4d4ddd199$export$ea66e9c498b7933c),
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (()=>Promise.resolve((0, $070dc7231f6b186c$export$beb01fae7626c427))),
        useFipsEndpoint: config?.useFipsEndpoint ?? (()=>Promise.resolve((0, $145959cf010d2c12$export$5555deeca435a10b)))
    };
};


const $a9feb3296e3b25d7$export$be3086d183cd8ea6 = (runtimeConfig)=>{
    let runtimeConfigRegion = async ()=>{
        if (runtimeConfig.region === undefined) throw new Error("Region is missing from runtimeConfig");
        const region = runtimeConfig.region;
        if (typeof region === "string") return region;
        return region();
    };
    return {
        setRegion (region) {
            runtimeConfigRegion = region;
        },
        region () {
            return runtimeConfigRegion;
        }
    };
};
const $a9feb3296e3b25d7$export$74973a8fb8dfc16e = (awsRegionExtensionConfiguration)=>{
    return {
        region: awsRegionExtensionConfiguration.region()
    };
};


const $3f028430718fe930$export$26513716e2900bad = "AWS_REGION";
const $3f028430718fe930$export$8afb1c306a7d01b = "region";
const $3f028430718fe930$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$3f028430718fe930$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$3f028430718fe930$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $3f028430718fe930$export$9a37503ca194454d = {
    preferredFile: "credentials"
};


const $2bbc07c0600bfb0c$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));


const $8e81b69b74cacce5$export$ecbdf004a8547a7f = (region)=>(0, $2bbc07c0600bfb0c$export$cc893cb7e6a508dd)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;



const $133e8fef7788f82e$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return {
        ...input,
        region: async ()=>{
            if (typeof region === "string") return (0, $8e81b69b74cacce5$export$ecbdf004a8547a7f)(region);
            const providedRegion = await region();
            return (0, $8e81b69b74cacce5$export$ecbdf004a8547a7f)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $2bbc07c0600bfb0c$export$cc893cb7e6a508dd)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    };
};








const $e30c1fec59ec090f$export$e536d87ced0d9700 = (runtimeConfig)=>{
    const _httpAuthSchemes = runtimeConfig.httpAuthSchemes;
    let _httpAuthSchemeProvider = runtimeConfig.httpAuthSchemeProvider;
    let _credentials = runtimeConfig.credentials;
    return {
        setHttpAuthScheme (httpAuthScheme) {
            const index = _httpAuthSchemes.findIndex((scheme)=>scheme.schemeId === httpAuthScheme.schemeId);
            if (index === -1) _httpAuthSchemes.push(httpAuthScheme);
            else _httpAuthSchemes.splice(index, 1, httpAuthScheme);
        },
        httpAuthSchemes () {
            return _httpAuthSchemes;
        },
        setHttpAuthSchemeProvider (httpAuthSchemeProvider) {
            _httpAuthSchemeProvider = httpAuthSchemeProvider;
        },
        httpAuthSchemeProvider () {
            return _httpAuthSchemeProvider;
        },
        setCredentials (credentials) {
            _credentials = credentials;
        },
        credentials () {
            return _credentials;
        }
    };
};
const $e30c1fec59ec090f$export$60c55f59b27530a8 = (config)=>{
    return {
        httpAuthSchemes: config.httpAuthSchemes(),
        httpAuthSchemeProvider: config.httpAuthSchemeProvider(),
        credentials: config.credentials()
    };
};


const $395e9ad73826cce6$var$asPartial = (t)=>t;
const $395e9ad73826cce6$export$4278118b303a14cf = (runtimeConfig, extensions)=>{
    const extensionConfiguration = {
        ...$395e9ad73826cce6$var$asPartial((0, $a9feb3296e3b25d7$export$be3086d183cd8ea6)(runtimeConfig)),
        ...$395e9ad73826cce6$var$asPartial((0, $78752e0d620fa58e$export$2d53aaae46f156f5)(runtimeConfig)),
        ...$395e9ad73826cce6$var$asPartial((0, $4f1aa0a6cb853500$export$663b205817703038)(runtimeConfig)),
        ...$395e9ad73826cce6$var$asPartial((0, $e30c1fec59ec090f$export$e536d87ced0d9700)(runtimeConfig))
    };
    extensions.forEach((extension)=>extension.configure(extensionConfiguration));
    return {
        ...runtimeConfig,
        ...(0, $a9feb3296e3b25d7$export$74973a8fb8dfc16e)(extensionConfiguration),
        ...(0, $78752e0d620fa58e$export$abfa28b95316e0ae)(extensionConfiguration),
        ...(0, $4f1aa0a6cb853500$export$d94fe0350385c1a8)(extensionConfiguration),
        ...(0, $e30c1fec59ec090f$export$60c55f59b27530a8)(extensionConfiguration)
    };
};


class $0390444a65a27fd3$export$b5be36c66bc46237 extends (0, $995316bf5a2e8647$export$1f2bb630327ac4b6) {
    constructor(...[configuration]){
        const _config_0 = (0, $79581daf2e92f468$export$ad0966540b0e71e5)(configuration || {});
        const _config_1 = (0, $6f3a98a1538687cd$export$70b6341cd51750a8)(_config_0);
        const _config_2 = (0, $82f38ee817687adf$export$ec9a2d5663958cb)(_config_1);
        const _config_3 = (0, $ee8b1ad13783793d$export$7a84fd3751940420)(_config_2);
        const _config_4 = (0, $aea4bc742db6bc92$export$ca7f6138f2c98476)(_config_3);
        const _config_5 = (0, $193ca8b4cd43cadc$export$7696ef37558bd0ec)(_config_4);
        const _config_6 = (0, $595a3e70bcaf65ce$export$c1625bf0b32b4481)(_config_5);
        const _config_7 = (0, $3d81e12aaba219df$export$8c5b66831e3f26ff)(_config_6);
        const _config_8 = (0, $7d0a4a87429f4ad7$export$5e2ae00bf65442f0)(_config_7);
        const _config_9 = (0, $25528546c573dfbf$export$d38ef9c0c6c649ab)(_config_8);
        const _config_10 = (0, $9d91e163a2247fef$export$9acff03461140bb6)(_config_9, {
            session: [
                ()=>this,
                (0, $c78cc8f3d96e6d6f$export$dc5bfdef4d64657b)
            ]
        });
        const _config_11 = (0, $395e9ad73826cce6$export$4278118b303a14cf)(_config_10, configuration?.extensions || []);
        super(_config_11);
        this.config = _config_11;
        this.middlewareStack.use((0, $3fbf02e27f5744df$export$5393c0d2d7f4f5f0)(this.config));
        this.middlewareStack.use((0, $26a956d2389e09da$export$c73199e2b1df9340)(this.config));
        this.middlewareStack.use((0, $4c73293e516924e8$export$7e6ddf9365a30fe9)(this.config));
        this.middlewareStack.use((0, $595a3e70bcaf65ce$export$23d3b647211be53a)(this.config));
        this.middlewareStack.use((0, $e9c6b1e0e6ce110e$export$f6ef65d7766fc255)(this.config));
        this.middlewareStack.use((0, $4e2c384433fa29cd$export$11d0b9345788bd5)(this.config));
        this.middlewareStack.use((0, $59539d21e35e811c$export$6ababc1a6356ca41)(this.config, {
            httpAuthSchemeParametersProvider: (0, $25528546c573dfbf$export$51f8fd3bd6b63513),
            identityProviderConfigProvider: async (config)=>new (0, $5ac0e12513678432$export$67f43b78065c5551)({
                    "aws.auth#sigv4": config.credentials,
                    "aws.auth#sigv4a": config.credentials
                })
        }));
        this.middlewareStack.use((0, $3e2ecdf2a83b0ecd$export$ed476aa7e410a)(this.config));
        this.middlewareStack.use((0, $a9b98b905e7c7f12$export$c30d61978fbb3ad8)(this.config));
        this.middlewareStack.use((0, $a5877f428f709978$export$7692e5e7214e5cd1)(this.config));
        this.middlewareStack.use((0, $d1be7199c6409301$export$b3282d0108c14e76)(this.config));
        this.middlewareStack.use((0, $6f5918cee414e2ce$export$3aa3f237714d7948)(this.config));
        this.middlewareStack.use((0, $18f8c43c70de4748$export$7b2427df5a87b408)(this.config));
    }
    destroy() {
        super.destroy();
    }
}


var $f61a90bcb0910d0e$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $f61a90bcb0910d0e$export$2e2bcd8739ae039 = {
    randomUUID: $f61a90bcb0910d0e$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $a54c3fa1610b8439$var$getRandomValues;
var $a54c3fa1610b8439$var$rnds8 = new Uint8Array(16);
function $a54c3fa1610b8439$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$a54c3fa1610b8439$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $a54c3fa1610b8439$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$a54c3fa1610b8439$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $a54c3fa1610b8439$var$getRandomValues($a54c3fa1610b8439$var$rnds8);
}


var $60cda7c2cb40bc69$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $76ae484a16c2a818$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $60cda7c2cb40bc69$export$2e2bcd8739ae039).test(uuid);
}
var $76ae484a16c2a818$export$2e2bcd8739ae039 = $76ae484a16c2a818$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $4e227a77f60c4f64$var$byteToHex = [];
for(var $4e227a77f60c4f64$var$i = 0; $4e227a77f60c4f64$var$i < 256; ++$4e227a77f60c4f64$var$i)$4e227a77f60c4f64$var$byteToHex.push(($4e227a77f60c4f64$var$i + 0x100).toString(16).slice(1));
function $4e227a77f60c4f64$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($4e227a77f60c4f64$var$byteToHex[arr[offset + 0]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 1]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 2]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 3]] + '-' + $4e227a77f60c4f64$var$byteToHex[arr[offset + 4]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 5]] + '-' + $4e227a77f60c4f64$var$byteToHex[arr[offset + 6]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 7]] + '-' + $4e227a77f60c4f64$var$byteToHex[arr[offset + 8]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 9]] + '-' + $4e227a77f60c4f64$var$byteToHex[arr[offset + 10]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 11]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 12]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 13]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 14]] + $4e227a77f60c4f64$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $4e227a77f60c4f64$var$stringify(arr, offset = 0) {
    var uuid = $4e227a77f60c4f64$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $76ae484a16c2a818$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $4e227a77f60c4f64$export$2e2bcd8739ae039 = $4e227a77f60c4f64$var$stringify;


function $c2ac610612430f2d$var$v4(options, buf, offset) {
    if ((0, $f61a90bcb0910d0e$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $f61a90bcb0910d0e$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $a54c3fa1610b8439$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $4e227a77f60c4f64$export$8fb373d660548968)(rnds);
}
var $c2ac610612430f2d$export$2e2bcd8739ae039 = $c2ac610612430f2d$var$v4;


const $fe4a2b0f79dbb85a$export$f27e8bd7ef04a112 = {
    'image/png': 'png',
    'image/jpeg': 'jpg',
    'image/webp': 'webp'
};
const $fe4a2b0f79dbb85a$export$388e0302ca0d9a41 = new (0, $0390444a65a27fd3$export$b5be36c66bc46237)({
    region: "us-east-2",
    credentials: {
        accessKeyId: "AKIA6ODU2LBJIQOXJPUU",
        secretAccessKey: "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"
    }
});
const $fe4a2b0f79dbb85a$export$a5575dbeeffdad98 = async (file)=>{
    if (!Object.keys($fe4a2b0f79dbb85a$export$f27e8bd7ef04a112).includes(file.type)) {
        console.log(file.name, file.type);
        return {
            error: `not valid file format: ${file.type}`
        };
    }
    const key = `media/images/${(0, $c2ac610612430f2d$export$2e2bcd8739ae039)()}.${$fe4a2b0f79dbb85a$export$f27e8bd7ef04a112[file.type]}`;
    const command = new (0, $b242c7fe13169d1d$export$4afa2352f8871c26)({
        Bucket: "pictoassets.epi3.co",
        Key: key,
        Body: file,
        ContentType: file.type
    });
    try {
        const response = await $fe4a2b0f79dbb85a$export$388e0302ca0d9a41.send(command);
        console.log(response);
        const url = `${"https://raw.githubusercontent.com/EPI3co/pictoassets/master"}/${key}`;
        return {
            response: response,
            key: key,
            url: url
        };
    } catch (err) {
        console.error(err);
        return {
            error: err
        };
    }
};




const $ad0a2f3a4b06e045$var$token = 'X0vjEUN6KRlxbp2DoUkyHeM0VOmxY91rA6BbU5j3Xu6wDodwS0McmilLPBWDUcJ1' //generic not private token
;
async function $ad0a2f3a4b06e045$export$240828cc9e1c5254(search) {
    const result1 = await (0, $5a973554b20f67a7$export$482ff399fd242da7).get('https://iconfinder-api-auth.herokuapp.com//v4/icons/search?' + new URLSearchParams({
        query: search,
        count: '10',
        premium: 'false',
        style: 'filled-outline',
        is_explicit: 'false'
    }), {
        headers: {
            Authorization: `Bearer ${$ad0a2f3a4b06e045$var$token}`,
            "accept": "application/json"
        }
    });
    // console.log(result)
    const result2 = await (0, $5a973554b20f67a7$export$482ff399fd242da7).get('https://iconfinder-api-auth.herokuapp.com//v4/icons/search?' + new URLSearchParams({
        query: search,
        count: '10',
        premium: 'false',
        style: 'flat',
        is_explicit: 'false'
    }), {
        headers: {
            Authorization: `Bearer ${$ad0a2f3a4b06e045$var$token}`,
            "accept": "application/json"
        }
    });
    return [
        ...result1.data.icons,
        ...result2.data.icons
    ];
}


function $a716c45d2093e4c5$export$61fc7d43ac8f84b0(func, wait, immediate = false) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        if (immediate && !timeout) func.apply(context, args);
        timeout = setTimeout(function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }, wait);
    };
}


let $4a7d13cd0d37b97d$var$time;
const $4a7d13cd0d37b97d$var$TilePropsForm = ({ modalState: modalState, showModal: showModal })=>{
    const { LL: LL } = (0, $dc3317580ce734b5$export$22f0ca4c21b6ff4)();
    const [lang] = (0, $c95f922ce4854eac$export$b24a004ee43dce44)();
    const path = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$b86f17b235e54c14));
    const [grid, setGrid] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$fdb89ca8367d940b));
    const [defImg, setDefImg] = (0, $6F3kv.useState)(true);
    const [remove, setRemove] = (0, $6F3kv.useState)(false);
    const [data, setData] = (0, $6F3kv.useState)({});
    const screenName = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$98ba80ce6e840e63));
    const [error, setError] = (0, $6F3kv.useState)('');
    const [inputErr, setInputErr] = (0, $6F3kv.useState)('');
    const [searchIcons, setSearchIcons] = (0, $6F3kv.useState)([]);
    const screenSearch = grid.filter((g)=>!data?.link || g.id.toLowerCase().includes(data?.link.toLowerCase())).filter((s)=>data?.link !== s.id).slice(0, 5);
    const tile = (0, $6F3kv.useMemo)(()=>(0, $bdcc94fa677df125$export$3f778c4e796a1f9c)(grid, path), [
        path
    ]);
    // console.log(data)
    (0, $6F3kv.useEffect)(()=>{
        // console.log('change tile', tile)
        if (tile) setData({
            ...tile,
            text: (0, $96596b87b46525f2$export$c72d34660a162238)(tile, lang)
        });
    }, [
        tile
    ]);
    // console.log(data)
    // console.log(path, tile)
    const updateData = (e)=>{
        let value = e.target.value.trim();
        // console.log(e.target.name, value)
        setData({
            ...data,
            [e.target.name]: value
        });
    };
    const submit = (ev)=>{
        ev.preventDefault();
        // console.log(JSON.stringify(data), data.text)
        const i18n = {
            ...tile?.i18n,
            [lang]: {
                ...tile?.i18n?.[lang],
                ...data.text && {
                    text: data.text
                }
            }
        };
        if (lang != 'en') delete data?.text;
        // if (data.color) {
        //     data.color = /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(data.color) ? data.color : '#' + data.color
        // }
        const newTile = {
            ...tile,
            ...data,
            i18n: i18n
        };
        // console.log(newTile, data, tile)
        (0, $bdcc94fa677df125$export$a11e9bf333819e54)(grid, newTile, path);
        setGrid([
            ...grid
        ]);
        showModal(false);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('tile edit', {
            old: tile,
            new: newTile,
            screen: screenName
        });
    };
    const removeAction = (ev)=>{
        clearTimeout($4a7d13cd0d37b97d$var$time);
        // console.log(ev.target.checked)
        if (ev.target.checked) $4a7d13cd0d37b97d$var$time = setTimeout(()=>{
            const [screen, index] = (0, $bdcc94fa677df125$export$37adcc2e6440d8b3)(grid, screenName);
            screen.children = screen.children.filter((t)=>t.id != tile?.id);
            grid[index] = screen;
            setGrid([
                ...grid
            ]);
            showModal(false);
            (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('remove tile', {
                screen: screenName,
                id: tile?.id
            });
        }, 1500);
    };
    const uploadAction = async (event)=>{
        setInputErr('');
        const file = event.target.files[0];
        const { response: response, key: key, url: url, error: error } = await (0, $fe4a2b0f79dbb85a$export$a5575dbeeffdad98)(file);
        if (error) {
            setInputErr(error);
            return;
        }
        setData({
            ...data,
            imgUrl: url
        });
    };
    const getItems = (0, $a716c45d2093e4c5$export$61fc7d43ac8f84b0)(async (ev)=>{
        const search = ev.target.value;
        const items = await (0, $ad0a2f3a4b06e045$export$240828cc9e1c5254)(search);
        // console.log(items)
        setSearchIcons(items);
    }, 2000);
    const searchImage = async (ev)=>{
        getItems(ev);
    };
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        id: "tile-cont",
        className: "flex flex-col items-center overflow-visible",
        children: [
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                className: "flex flex-col items-start w-full",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h2", {
                        className: "font-bold uppercase text-2xl mb-4",
                        children: LL.aac.edit()
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        className: "join mb-4 w-full",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                htmlFor: "input-id",
                                className: "join-item input-label",
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                    children: LL.aac.fields.id()
                                })
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                type: "text",
                                placeholder: "...",
                                id: "input-id",
                                name: "id",
                                value: data?.id ?? '',
                                onChange: updateData,
                                className: "join-item input input-bordered flex-1 w-full"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        className: "mb-4 w-full",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h3", {
                                className: "font-bold uppercase text-xl ",
                                children: LL.aac.fields.img()
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                className: "join w-full mb-1",
                                children: [
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                        htmlFor: "input-img-url",
                                        className: "join-item input-label",
                                        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                            children: LL.aac.fields.url()
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                        type: "text",
                                        placeholder: "http://...",
                                        id: "input-img-url",
                                        name: "imgUrl",
                                        value: data?.imgUrl ?? '',
                                        onChange: updateData,
                                        className: "join-item input input-bordered flex-1 w-full"
                                    }),
                                    data?.imgUrl && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                        className: `join-item input-label transition-all ${defImg ? 'opacity-0 w-0 p-0' : 'w-16 opacity-100'}`,
                                        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("img", {
                                            onError: ()=>setDefImg(true),
                                            onLoad: ()=>setDefImg(false),
                                            src: data?.imgUrl,
                                            className: `w-10 ${defImg ? 'hidden' : ''}`,
                                            alt: data?.id
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                type: "file",
                                onChange: uploadAction,
                                className: "file-input input-bordered w-full"
                            }),
                            inputErr && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                className: "text-error",
                                children: JSON.stringify(inputErr)
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                className: "join w-full my-1",
                                children: [
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                        htmlFor: "input-img-url",
                                        className: "join-item input-label",
                                        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                            children: LL.aac.fields.searchIcon()
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                        type: "text",
                                        placeholder: "search",
                                        onChange: searchImage,
                                        className: "join-item input input-bordered flex-1 w-full"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                className: "w-full overflow-y-hidden overflow-x-scroll flex scrollbar-thin scrollbar-thumb-base-content ",
                                children: searchIcons.map((icon)=>{
                                    const img = icon?.raster_sizes?.filter((el)=>el?.size == 64)[0];
                                    if (!img) return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9Oehh.Fragment), {});
                                    const url = img.formats[0]?.preview_url;
                                    if (!url) return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9Oehh.Fragment), {});
                                    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                                        className: "p-2 btn btn-ghost w-16 h-16",
                                        onClick: ()=>setData({
                                                ...data,
                                                imgUrl: url
                                            }),
                                        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("img", {
                                            src: url,
                                            className: "",
                                            alt: ""
                                        })
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        className: "join mb-4 w-full",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                htmlFor: "input-text",
                                className: "join-item input-label",
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                    children: LL.aac.fields.text()
                                })
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                type: "text",
                                placeholder: "",
                                id: "input-text",
                                name: "text",
                                value: data?.text ?? '',
                                onChange: updateData,
                                className: "join-item input input-bordered flex-1 w-full"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        className: "join mb-4 dropdown w-full",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                htmlFor: "input-color",
                                className: "join-item input-label",
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                    children: LL.aac.fields.color()
                                })
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                tabIndex: 0,
                                className: `dropdown-content card top-[-14rem] left-[5rem] bg-base-100 p-2 z-10 shadow-md `,
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $0d2190c43ce9bee2$export$a3bc3c32746e9f3a), {
                                    color: (0, $bbf84cf9ec8e5154$export$5551a2d24ff40153)(data?.color ?? ''),
                                    onChange: (color)=>setData({
                                            ...data,
                                            color: color
                                        }),
                                    className: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                tabIndex: 0,
                                type: "text",
                                placeholder: "#ABCDEF",
                                id: "input-color",
                                name: "color",
                                value: data?.color ?? '',
                                onChange: updateData,
                                className: "join-item input input-bordered flex-1 w-full"
                            }),
                            data?.color && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                className: `join-item w-16 transition-all border border-base-content ${data?.color ? 'opacity-100' : 'opacity-0 w-0 p-0'}`,
                                style: {
                                    backgroundColor: (0, $bbf84cf9ec8e5154$export$5551a2d24ff40153)(data?.color)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                        className: "join dropdown dropdown-top mb-4 w-full",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                htmlFor: "input-link",
                                className: "join-item input-label",
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                    children: LL.aac.fields.link()
                                })
                            }),
                            screenSearch.length > 0 && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("ul", {
                                tabIndex: 0,
                                class: "dropdown-content menu menu-compact p-2 shadow bg-base-100 rounded-box w-52 z-10",
                                children: screenSearch.map((s)=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("li", {
                                        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("a", {
                                            onClick: ()=>setData({
                                                    ...data,
                                                    link: s.id
                                                }),
                                            children: s.id
                                        })
                                    }))
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                tabIndex: 0,
                                type: "text",
                                placeholder: "",
                                id: "input-link",
                                name: "link",
                                value: data?.link ?? '',
                                onChange: updateData,
                                className: "join-item input input-bordered flex-1 w-full"
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                "data-tip": LL.aac.fields.link_help(),
                                className: "tooltip tooltip-left",
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                    className: "join-item btn w-16 transition-all border border-base-content ",
                                    children: "?"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        className: "flex mb-4",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                                className: "btn btn-warning",
                                onClick: ()=>setRemove(true),
                                children: LL.aac.remove()
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                className: `form-control transition-all ${remove ? '' : 'w-0 opacity-0'}`,
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                    className: "label cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                            className: "label-text mx-4",
                                            children: LL.aac.sure() + "?"
                                        }),
                                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                            type: "checkbox",
                                            className: "toggle",
                                            onChange: removeAction
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                onClick: submit,
                className: "btn btn-primary",
                children: LL.common.save()
            })
        ]
    });
};
var $4a7d13cd0d37b97d$export$2e2bcd8739ae039 = $4a7d13cd0d37b97d$var$TilePropsForm;




const $67aa8c2df751bea2$var$getXY = (n, a)=>{
    return {
        y: Math.floor(n / a),
        x: n % a
    };
};
const $67aa8c2df751bea2$var$getData = (layout)=>{
    let col = -1, row = -1;
    layout.forEach((el)=>{
        if (el.x > col) col = el.x;
        if (el.y > row) row = el.y;
    });
    return [
        col + 1,
        row + 1
    ];
};
const $67aa8c2df751bea2$var$iterObj = (obj)=>{
    return Object.entries(obj).map(([k, v])=>[
            k,
            $67aa8c2df751bea2$var$getData(v)
        ]);
};
function $67aa8c2df751bea2$var$usePartial(step) {
    const [value, setN] = (0, $6F3kv.useState)(0);
    const r = (0, $6F3kv.useRef)();
    function reset(max) {
        setN(step);
        clearTimeout(r.current);
        r.current = setInterval(()=>action(max), 50);
    }
    function action(max) {
        setN((value)=>{
            //LOG: console.log('max', value)
            if (value >= max) {
                clearInterval(r.current);
                return value;
            }
            return value + step;
        });
    }
    return [
        value,
        reset
    ];
}
// console.log(dataFile, data, dataGrouped)
const $67aa8c2df751bea2$var$Grid = ({ className: className, ...rest })=>{
    const editMode = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$db1d63ac91a84676));
    const screenName = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$98ba80ce6e840e63));
    const [grid, setGrid] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$fdb89ca8367d940b));
    const setCols = (0, $0b20ce121ee1acb3$exports.useSetAtom)((0, $b78da6c1f1424617$export$1fdd444730eb60e6));
    const [breakpoint, setBreakpoint] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$3960374d7ca025b9));
    const global = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$a63c88e4229cc588));
    const [val, res] = $67aa8c2df751bea2$var$usePartial(100);
    // console.log(grid)
    const tileModal = (0, $d4aeae9fbbd7cd04$export$2e2bcd8739ae039)('tiles-props', false);
    const bpLabels = Object.keys(global.grid.cols);
    const getRenderItems = (name)=>{
        let [screen, index] = (0, $bdcc94fa677df125$export$37adcc2e6440d8b3)(grid, name);
        const renderItems = screen?.children?.map((el, i)=>{
            return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $fd950d5ed1ac77bd$export$2e2bcd8739ae039), {
                tileData: el,
                tilePath: [
                    index,
                    i
                ],
                showModal: tileModal.showModal,
                draggable: editMode
            }, el.id);
        }) ?? [];
        return renderItems;
    };
    const getScreenData = (name)=>{
        // console.log(name, grid) 
        // console.log(breakpoint)
        let [screen, index] = (0, $bdcc94fa677df125$export$37adcc2e6440d8b3)(grid, name);
        let grouped = {};
        for(const i in screen?.children){
            const tile = screen?.children[i];
            grouped[tile.id] = i;
        }
        return {
            index: index,
            screen: screen,
            grouped: grouped
        };
    };
    const getLayouts = (name, bp)=>{
        let [screen, index] = (0, $bdcc94fa677df125$export$37adcc2e6440d8b3)(grid, name);
        let layouts = {};
        for (const [i, el] of (screen?.children.slice(0, val) ?? []).entries())for (const _bp of bpLabels){
            if (!layouts[_bp]) layouts[_bp] = [];
            if (el.grid && el.grid[_bp]) layouts[_bp].push({
                i: el.id,
                ...el.grid[_bp]
            });
            else if (_bp == 'lg' && Array.isArray(el.grid)) layouts['lg'].push({
                i: el.id,
                ...el.grid
            });
            else layouts[_bp].push({
                i: el.id,
                w: 1,
                h: 1,
                ...$67aa8c2df751bea2$var$getXY(i, global.grid.cols[_bp])
            });
        }
        // console.log(JSON.stringify(iterObj(layouts)), layouts)
        return layouts;
    };
    const init = grid.length > 0;
    const ResponsiveGridLayout = (0, $6F3kv.useMemo)(()=>(0, $2c41129e06adf0dc$exports.WidthProvider)((0, $2c41129e06adf0dc$exports.Responsive)), [
        init,
        screenName
    ]);
    const renderItems = (0, $6F3kv.useMemo)(()=>getRenderItems(screenName), [
        screenName,
        grid,
        editMode
    ]);
    const screenData = (0, $6F3kv.useMemo)(()=>getScreenData(screenName), [
        screenName,
        grid
    ]);
    (0, $6F3kv.useEffect)(()=>{
        res(renderItems.length);
    }, [
        screenName
    ]);
    const layouts = (0, $6F3kv.useMemo)(()=>getLayouts(screenName, breakpoint), [
        screenName,
        breakpoint,
        grid,
        val
    ]);
    // console.log(screen, screenData)
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9Oehh.Fragment), {
        children: [
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)(tileModal.Modal, {
                children: (props)=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $4a7d13cd0d37b97d$export$2e2bcd8739ae039), {
                        ...props
                    })
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)(tileModal.Label, {}),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)(ResponsiveGridLayout, {
                className: `layout relative ${editMode ? 'border border-dashed border-neutral rounded-md' : ''} ${className}`,
                style: {
                    minHeight: global.grid.height + 'px'
                },
                layouts: layouts,
                isDraggable: editMode,
                defaultPosition: {
                    x: 0,
                    y: 0
                },
                isBounded: true,
                breakpoints: global.grid.bpx,
                cols: global.grid.cols,
                onBreakpointChange: (newBp, newCols)=>{
                    //LOG: console.log("new breakpoint", newBp, newCols)
                    setCols(newCols);
                    setBreakpoint(newBp);
                    (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('change breakpoint', {
                        breakpoint: newBp
                    });
                },
                onDragStop: (lc)=>{
                    (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('drag', {
                        old: lc.oldItem,
                        new: lc.newItem
                    });
                },
                onResizeStop: (lc)=>{
                    (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('resize', {
                        old: lc.oldItem,
                        new: lc.newItem
                    });
                },
                onLayoutChange: (currentLayout, allLayouts)=>{
                    const colsRows = $67aa8c2df751bea2$var$getData(currentLayout);
                    // console.log(JSON.stringify(iterObj(allLayouts)), allLayouts)
                    let bp = '';
                    for(const _bp in global.grid.cols)if (global.grid.cols[_bp] == colsRows[0]) bp = _bp;
                    // console.log(bp, currentLayout)
                    // console.log(grid)
                    if (editMode && !(0, $f4acb02d4ec4661e$export$23cfe696632d10f4)(allLayouts) && allLayouts?.[bp]) {
                        // for (const _bp in allLayouts) {
                        const screen = grid[screenData.index].children;
                        for (const tile of allLayouts[bp]){
                            const { i: i, ...rest } = tile;
                            const data = (0, $f4acb02d4ec4661e$export$b776ac30f5671b91)(rest);
                            delete data.static;
                            delete data.moved;
                            const index = screenData.grouped[i];
                            // console.log(index,screen)
                            if (!screen[index].grid) screen[index].grid = {};
                            if (screen[index].grid.x) screen[index].grid = {
                                lg: screen[index].grid
                            };
                            screen[index].grid[bp] = data;
                        // }
                        }
                        grid[screenData.index].children = screen;
                        // // console.log(out)
                        // if (!isObjectEmpty(out)) {
                        //     grid[screenData.index].children = Object.values(out)
                        setGrid(grid) // Caution if needed to get value in a reactive manner
                        ;
                        // }
                        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('layout change', {
                            length: currentLayout.length
                        });
                    }
                },
                // onResize={() => {
                // const event = new Event("changeFont");
                // window.dispatchEvent(event);
                // }}
                draggableCancel: ".resizable-handler",
                resizeHandle: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                    className: "resizable-handler absolute right-0 bottom-0 z-20 cursor-se-resize pb-1 pr-1",
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "1.5",
                        stroke: "currentColor",
                        class: "w-4",
                        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M 17.303301,6.6966992 V 17.303301 H 6.6966992"
                        })
                    })
                }),
                rowHeight: global.grid.height,
                // width={1500}
                // useCSSTransforms={true}
                minW: global.grid.minW,
                minH: global.grid.minH,
                maxW: global.grid.maxW,
                maxH: global.grid.maxH,
                children: renderItems.slice(0, val)
            })
        ]
    });
};
var $67aa8c2df751bea2$export$2e2bcd8739ae039 = $67aa8c2df751bea2$var$Grid;



parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $872461b2db5134bd$var$AdjustmentsHorizontalIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        d: "M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
    }));
}
const $872461b2db5134bd$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($872461b2db5134bd$var$AdjustmentsHorizontalIcon);
var $872461b2db5134bd$export$2e2bcd8739ae039 = $872461b2db5134bd$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $b468d662cfd8a738$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
        clipRule: "evenodd"
    }));
}
const $b468d662cfd8a738$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($b468d662cfd8a738$var$CheckCircleIcon);
var $b468d662cfd8a738$export$2e2bcd8739ae039 = $b468d662cfd8a738$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $b0d008fd01c37922$var$PencilIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        d: "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z"
    }));
}
const $b0d008fd01c37922$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($b0d008fd01c37922$var$PencilIcon);
var $b0d008fd01c37922$export$2e2bcd8739ae039 = $b0d008fd01c37922$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $8fd06be661cdca6a$var$PlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        fillRule: "evenodd",
        d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
        clipRule: "evenodd"
    }));
}
const $8fd06be661cdca6a$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($8fd06be661cdca6a$var$PlusIcon);
var $8fd06be661cdca6a$export$2e2bcd8739ae039 = $8fd06be661cdca6a$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $72d22b3f3d80a78a$var$ShareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        fillRule: "evenodd",
        d: "M15.75 4.5a3 3 0 1 1 .825 2.066l-8.421 4.679a3.002 3.002 0 0 1 0 1.51l8.421 4.679a3 3 0 1 1-.729 1.31l-8.421-4.678a3 3 0 1 1 0-4.132l8.421-4.679a3 3 0 0 1-.096-.755Z",
        clipRule: "evenodd"
    }));
}
const $72d22b3f3d80a78a$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($72d22b3f3d80a78a$var$ShareIcon);
var $72d22b3f3d80a78a$export$2e2bcd8739ae039 = $72d22b3f3d80a78a$var$ForwardRef;







function $1d55beab0580260f$export$bb3b75778e3e272(content, fileName, type = 'application/json') {
    const blob = new Blob([
        content
    ], {
        type: type
    });
    const urlForDownload = window.URL.createObjectURL(blob);
    const linkElement = document.createElement('a'); // create hyperlink HTML element
    linkElement.href = urlForDownload;
    linkElement.download = fileName;
    linkElement.click();
    URL.revokeObjectURL(urlForDownload) // free memory
    ;
    return {
        name: fileName,
        size: blob.size,
        type: type,
        lastModified: (0, $4f6efe0791a5325f$export$a3702fbab67b8a52)(new Date())
    };
}
function $1d55beab0580260f$export$72c04af63de9061a(file, callback) {
    // Check if the file is a JSON file.
    if (file.type && file.type != 'application/json') {
        console.log('File is not an JSON File.', file.type, file);
        return 'notJSON';
    }
    const reader = new FileReader();
    reader.addEventListener('load', (event)=>{
        callback(event);
    });
    reader.addEventListener('progress', (event)=>{
        if (event.loaded && event.total) {
            const percent = event.loaded / event.total * 100;
            console.log(`Progress: ${Math.round(percent)}`);
        }
    });
    reader.readAsText(file);
    return '';
}



var $c301439804b8d900$exports = {};
$c301439804b8d900$exports = import.meta.resolve("gguN5");


const $cdb8457cb6f488fc$var$Layout = ({ children: children, className: className, ...rest })=>{
    const { LL: LL } = (0, $dc3317580ce734b5$export$22f0ca4c21b6ff4)();
    const [openMenu, setOpenMenu] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$94d10267cc34b952));
    const [editMode, setEditMode] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$db1d63ac91a84676));
    const [grid, setGrid] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$fdb89ca8367d940b));
    const currentScreen = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$98ba80ce6e840e63));
    const cols = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$1fdd444730eb60e6));
    const runtime = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$a63c88e4229cc588));
    const editLabel = editMode ? LL.aac.done() : LL.aac.edit();
    const createAction = ()=>{
        // console.log(grid)
        let [screen, index] = (0, $bdcc94fa677df125$export$37adcc2e6440d8b3)(grid, currentScreen);
        if (!screen) {
            screen = {
                id: 'home',
                type: 'screen'
            };
            index = 0;
        }
        screen.children = screen?.children ?? [];
        const id = `tile-${Math.random().toString().slice(-5)}`;
        const tile = {
            type: 'tile',
            id: id,
            text: '',
            i18n: {},
            color: '#fff',
            grid: {
                w: 1,
                h: 1,
                x: screen.children.length % (cols || 10),
                y: Infinity
            }
        };
        screen.children.push(tile);
        grid[index] = screen;
        setGrid([
            ...grid
        ]);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('create tile', {
            id: id,
            tile: tile,
            screen: screen.id
        });
    };
    const shareAction = ()=>{
        const [screen] = (0, $bdcc94fa677df125$export$37adcc2e6440d8b3)(grid, currentScreen);
        const date = new Date().toISOString();
        const outFile = {
            createdAt: date,
            type: 'screen',
            content: screen
        };
        const outName = `screen-${currentScreen}-${date.split('.')[0]}.json`;
        const file = (0, $1d55beab0580260f$export$bb3b75778e3e272)(JSON.stringify(outFile), outName);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('download screen', {
            filename: outName,
            screen: screen.id,
            length: screen.children.length,
            file: {
                name: file.name,
                size: file.size,
                mime: file.type,
                lastModified: file.lastModified
            }
        });
    };
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("nav", {
        className: `navbar ${className}`,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                className: `dropdown ${editMode ? 'dropdown-open' : ''}`,
                onfocusin: ()=>setOpenMenu(true),
                onfocusout: ()=>setOpenMenu(false),
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                        tabIndex: 0,
                        className: `btn btn-square bg-white hover:bg-gray-200 !flex-nowrap overflow-hidden ${editMode ? 'h-16' : 'h-14'} ${openMenu && !editMode ? 'w-64' : 'w-16'}
                rounded-t-none border-2 border-base-content 
            drop-shadow-lg tooltip tooltip-right flex mt-[-.7rem] ml-[-.3rem] xl:ml-[-.75rem] transition-all`,
                        "data-tip": LL.common.menu(),
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("img", {
                                src: runtime.logoUrl ?? new URL($c301439804b8d900$exports),
                                className: "w-9",
                                alt: "picto access logo"
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                className: `text-xl text-black font-extrabold transition-all truncate ${openMenu && !editMode ? 'delay-200' : 'absolute opacity-0 invisible'}`,
                                children: runtime.logoLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("ul", {
                        tabIndex: 0,
                        className: "z-50 ml-1 xl:ml-[-.75rem] menu dropdown-content p-2 bg-base-100 mt-2 rounded-full border-2 border-base-content drop-shadow-lg",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("li", {
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("a", {
                                    role: "button",
                                    className: "tooltip tooltip-right p-1 uppercase font-bold",
                                    "data-tip": editLabel,
                                    "aria-label": editLabel,
                                    onClick: (e)=>{
                                        setEditMode(!editMode);
                                    },
                                    children: editMode ? /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $b468d662cfd8a738$export$2e2bcd8739ae039), {
                                        className: "w-10"
                                    }) : /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $b0d008fd01c37922$export$2e2bcd8739ae039), {
                                        className: "w-9"
                                    })
                                })
                            }),
                            !editMode && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("li", {
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("a", {
                                    role: "button",
                                    href: "/settings",
                                    className: "tooltip tooltip-right px-1 uppercase font-bold",
                                    "data-tip": LL.common.settings(),
                                    "aria-label": LL.common.settings(),
                                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $872461b2db5134bd$export$2e2bcd8739ae039), {
                                        className: "w-10"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                className: `z-50 ml-2 bg-base-100 flex items-center rounded-full border-2 border-base-content px-4 py-1 transition-all drop-shadow-lg ${editMode ? '' : 'invisible opacity-0'}`,
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                        className: "btn btn-square btn-ghost tooltip tooltip-bottom",
                        "data-tip": LL.aac.new(),
                        "aria-label": LL.aac.new(),
                        onClick: createAction,
                        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $8fd06be661cdca6a$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                        className: "btn btn-square btn-ghost tooltip tooltip-bottom",
                        "data-tip": LL.common.shareScreen(),
                        "aria-label": LL.common.shareScreen(),
                        onClick: shareAction,
                        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $72d22b3f3d80a78a$export$2e2bcd8739ae039), {
                            className: "h-10"
                        })
                    })
                ]
            })
        ]
    });
};
var $cdb8457cb6f488fc$export$2e2bcd8739ae039 = $cdb8457cb6f488fc$var$Layout;






var $9Oehh = parcelRequire("9Oehh");


const $4e05228978379029$var$InputCell = ({ tileData: tileData, className: className, style: style, ...rest })=>{
    const [lang] = (0, $c95f922ce4854eac$export$b24a004ee43dce44)();
    const text = (0, $96596b87b46525f2$export$c72d34660a162238)(tileData, lang);
    const renderText = text == ' ' ? /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
        className: "mr-2"
    }) : text;
    // console.log(style)
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        className: `flex flex-col px-1 items-center justify-center ${className || ''}`,
        style: {
            ...style,
            ...tileData.style
        },
        ...rest,
        children: tileData.imgUrl && tileData.imgUrl != '' ? /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9Oehh.Fragment), {
            children: [
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("figure", {
                    className: "flex-1 flex items-center",
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("img", {
                        id: 'img-' + tileData.text,
                        src: tileData.imgUrl,
                        alt: text + ' logo',
                        className: "w-9"
                    })
                }),
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                    className: "pt-2 w-full",
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h2", {
                        className: "uppercase break-words text-center",
                        htmlFor: 'img-' + tileData.text,
                        children: renderText
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h2", {
            className: "font-bold text-2xl",
            children: renderText
        })
    });
};
var $4e05228978379029$export$2e2bcd8739ae039 = $4e05228978379029$var$InputCell;


const $9f0f52acda0ab377$var$SpeakBar = ({ className: className, children: children, tiles: tiles, ...rest })=>{
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
        className: `btn btn-outline flex flex-row flex-wrap px-4 ${className}`,
        ...rest,
        children: [
            tiles.map((item)=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $4e05228978379029$export$2e2bcd8739ae039), {
                    tileData: item
                })),
            children
        ]
    });
};
var $9f0f52acda0ab377$export$2e2bcd8739ae039 = $9f0f52acda0ab377$var$SpeakBar;




var $3851751ef97de198$exports = {};
'use strict';
Object.defineProperty($3851751ef97de198$exports, "__esModule", {
    value: true
});
var $05b679ece066844f$exports = {};
'use strict';
Object.defineProperty($05b679ece066844f$exports, "__esModule", {
    value: true
});
var $05b679ece066844f$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");
function $05b679ece066844f$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
/**
 * Custom hook similar to useCallback, but for callbacks where the dependencies
 * change frequently. Ensures that references to state and props inside the
 * callback always get the latest values. Used to keep the `listen` and `stop`
 * functions in sync with the latest values of the `listening` and `supported`
 * state variables. See this issue for an example of why this is needed:
 *
 *   https://github.com/MikeyParton/react-speech-kit/issues/31
 *
 * Implementation taken from "How to read an often-changing value from
 * useCallback?" in the React hooks API reference:
 *
 *   https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
 */ var $05b679ece066844f$var$useEventCallback = function useEventCallback(fn, dependencies) {
    var ref = (0, $6F3kv.useRef)(function() {
        throw new Error('Cannot call an event handler while rendering.');
    });
    (0, $6F3kv.useEffect)(function() {
        ref.current = fn;
    }, [
        fn
    ].concat($05b679ece066844f$var$_toConsumableArray(dependencies)));
    return (0, $6F3kv.useCallback)(function(args) {
        var fn = ref.current;
        return fn(args);
    }, [
        ref
    ]);
};
var $05b679ece066844f$var$useSpeechRecognition = function useSpeechRecognition() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$onEnd = props.onEnd, onEnd = _props$onEnd === undefined ? function() {} : _props$onEnd, _props$onResult = props.onResult, onResult = _props$onResult === undefined ? function() {} : _props$onResult, _props$onError = props.onError, onError = _props$onError === undefined ? function() {} : _props$onError;
    var recognition = (0, $6F3kv.useRef)(null);
    var _useState = (0, $6F3kv.useState)(false), _useState2 = $05b679ece066844f$var$_slicedToArray(_useState, 2), listening = _useState2[0], setListening = _useState2[1];
    var _useState3 = (0, $6F3kv.useState)(false), _useState4 = $05b679ece066844f$var$_slicedToArray(_useState3, 2), supported = _useState4[0], setSupported = _useState4[1];
    var processResult = function processResult(event) {
        var transcript = Array.from(event.results).map(function(result) {
            return result[0];
        }).map(function(result) {
            return result.transcript;
        }).join('');
        onResult(transcript);
    };
    var handleError = function handleError(event) {
        if (event.error === 'not-allowed') {
            recognition.current.onend = function() {};
            setListening(false);
        }
        onError(event);
    };
    var listen = $05b679ece066844f$var$useEventCallback(function() {
        var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (listening || !supported) return;
        var _args$lang = args.lang, lang = _args$lang === undefined ? '' : _args$lang, _args$interimResults = args.interimResults, interimResults = _args$interimResults === undefined ? true : _args$interimResults, _args$continuous = args.continuous, continuous = _args$continuous === undefined ? false : _args$continuous, _args$maxAlternatives = args.maxAlternatives, maxAlternatives = _args$maxAlternatives === undefined ? 1 : _args$maxAlternatives, grammars = args.grammars;
        setListening(true);
        recognition.current.lang = lang;
        recognition.current.interimResults = interimResults;
        recognition.current.onresult = processResult;
        recognition.current.onerror = handleError;
        recognition.current.continuous = continuous;
        recognition.current.maxAlternatives = maxAlternatives;
        if (grammars) recognition.current.grammars = grammars;
        // SpeechRecognition stops automatically after inactivity
        // We want it to keep going until we tell it to stop
        recognition.current.onend = function() {
            return recognition.current.start();
        };
        recognition.current.start();
    }, [
        listening,
        supported,
        recognition
    ]);
    var stop = $05b679ece066844f$var$useEventCallback(function() {
        if (!listening || !supported) return;
        recognition.current.onresult = function() {};
        recognition.current.onend = function() {};
        recognition.current.onerror = function() {};
        setListening(false);
        recognition.current.stop();
        onEnd();
    }, [
        listening,
        supported,
        recognition,
        onEnd
    ]);
    (0, $6F3kv.useEffect)(function() {
        if (typeof window === 'undefined') return;
        window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (window.SpeechRecognition) {
            setSupported(true);
            recognition.current = new window.SpeechRecognition();
        }
    }, []);
    return {
        listen: listen,
        listening: listening,
        stop: stop,
        supported: supported
    };
};
$05b679ece066844f$exports.default = $05b679ece066844f$var$useSpeechRecognition;


Object.defineProperty($3851751ef97de198$exports, 'useSpeechRecognition', {
    enumerable: true,
    get: function get() {
        return $3851751ef97de198$var$_interopRequireDefault($05b679ece066844f$exports).default;
    }
});
var $4ab0596872e3463f$exports = {};
'use strict';
Object.defineProperty($4ab0596872e3463f$exports, "__esModule", {
    value: true
});
var $4ab0596872e3463f$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");
var $4ab0596872e3463f$var$useSpeechSynthesis = function useSpeechSynthesis() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$onEnd = props.onEnd, onEnd = _props$onEnd === undefined ? function() {} : _props$onEnd;
    var _useState = (0, $6F3kv.useState)([]), _useState2 = $4ab0596872e3463f$var$_slicedToArray(_useState, 2), voices = _useState2[0], setVoices = _useState2[1];
    var _useState3 = (0, $6F3kv.useState)(false), _useState4 = $4ab0596872e3463f$var$_slicedToArray(_useState3, 2), speaking = _useState4[0], setSpeaking = _useState4[1];
    var _useState5 = (0, $6F3kv.useState)(false), _useState6 = $4ab0596872e3463f$var$_slicedToArray(_useState5, 2), supported = _useState6[0], setSupported = _useState6[1];
    var processVoices = function processVoices(voiceOptions) {
        setVoices(voiceOptions);
    };
    var getVoices = function getVoices() {
        // Firefox seems to have voices upfront and never calls the
        // voiceschanged event
        var voiceOptions = window.speechSynthesis.getVoices();
        if (voiceOptions.length > 0) {
            processVoices(voiceOptions);
            return;
        }
        window.speechSynthesis.onvoiceschanged = function(event) {
            voiceOptions = event.target.getVoices();
            processVoices(voiceOptions);
        };
    };
    var handleEnd = function handleEnd() {
        setSpeaking(false);
        onEnd();
    };
    (0, $6F3kv.useEffect)(function() {
        if (typeof window !== 'undefined' && window.speechSynthesis) {
            setSupported(true);
            getVoices();
        }
    }, []);
    var speak = function speak() {
        var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _args$voice = args.voice, voice = _args$voice === undefined ? null : _args$voice, _args$text = args.text, text = _args$text === undefined ? '' : _args$text, _args$rate = args.rate, rate = _args$rate === undefined ? 1 : _args$rate, _args$pitch = args.pitch, pitch = _args$pitch === undefined ? 1 : _args$pitch, _args$volume = args.volume, volume = _args$volume === undefined ? 1 : _args$volume;
        if (!supported) return;
        setSpeaking(true);
        // Firefox won't repeat an utterance that has been
        // spoken, so we need to create a new instance each time
        var utterance = new window.SpeechSynthesisUtterance();
        utterance.text = text;
        utterance.voice = voice;
        utterance.onend = handleEnd;
        utterance.rate = rate;
        utterance.pitch = pitch;
        utterance.volume = volume;
        window.speechSynthesis.speak(utterance);
    };
    var cancel = function cancel() {
        if (!supported) return;
        setSpeaking(false);
        window.speechSynthesis.cancel();
    };
    return {
        supported: supported,
        speak: speak,
        speaking: speaking,
        cancel: cancel,
        voices: voices
    };
};
$4ab0596872e3463f$exports.default = $4ab0596872e3463f$var$useSpeechSynthesis;


Object.defineProperty($3851751ef97de198$exports, 'useSpeechSynthesis', {
    enumerable: true,
    get: function get() {
        return $3851751ef97de198$var$_interopRequireDefault($4ab0596872e3463f$exports).default;
    }
});
function $3851751ef97de198$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}




parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $63b86002891a1b3e$var$ArrowUturnLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
    }));
}
const $63b86002891a1b3e$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($63b86002891a1b3e$var$ArrowUturnLeftIcon);
var $63b86002891a1b3e$export$2e2bcd8739ae039 = $63b86002891a1b3e$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $8a9611576e15c643$var$BackspaceIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z"
    }));
}
const $8a9611576e15c643$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($8a9611576e15c643$var$BackspaceIcon);
var $8a9611576e15c643$export$2e2bcd8739ae039 = $8a9611576e15c643$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $a0cd141cb9803ce9$var$ClipboardIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
    }));
}
const $a0cd141cb9803ce9$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($a0cd141cb9803ce9$var$ClipboardIcon);
var $a0cd141cb9803ce9$export$2e2bcd8739ae039 = $a0cd141cb9803ce9$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $b72b2a2fb3b87abb$var$PlayIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
    }));
}
const $b72b2a2fb3b87abb$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($b72b2a2fb3b87abb$var$PlayIcon);
var $b72b2a2fb3b87abb$export$2e2bcd8739ae039 = $b72b2a2fb3b87abb$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $284fc52f12aa9c29$var$QuestionMarkCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
    }));
}
const $284fc52f12aa9c29$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($284fc52f12aa9c29$var$QuestionMarkCircleIcon);
var $284fc52f12aa9c29$export$2e2bcd8739ae039 = $284fc52f12aa9c29$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $09ac706bf4de83a3$var$TrashIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    }));
}
const $09ac706bf4de83a3$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($09ac706bf4de83a3$var$TrashIcon);
var $09ac706bf4de83a3$export$2e2bcd8739ae039 = $09ac706bf4de83a3$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $f24b07451cc3b6ce$var$XCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $f24b07451cc3b6ce$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($f24b07451cc3b6ce$var$XCircleIcon);
var $f24b07451cc3b6ce$export$2e2bcd8739ae039 = $f24b07451cc3b6ce$var$ForwardRef;


parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");

async function $9efd31b4f3ac5cb3$export$24d14393bf96a0bd(filename, filetype) {
    return new Promise((resolve, reject)=>{
        let fileref;
        if (filetype == "js") {
            fileref = document.createElement('script');
            fileref.setAttribute("type", "text/javascript");
            fileref.setAttribute("src", filename);
        } else if (filetype == "css") {
            fileref = document.createElement("link");
            fileref.setAttribute("rel", "stylesheet");
            fileref.setAttribute("type", "text/css");
            fileref.setAttribute("href", filename);
        }
        if (typeof fileref != "undefined") {
            document.getElementsByTagName("head")[0].appendChild(fileref);
            if (typeof fileref.onload != 'undefined') fileref.onload = f;
            else {
                // old browsers
                var img = document.createElement("img");
                img.onerror = function() {
                    f();
                    document.body.removeChild(img);
                };
                document.body.appendChild(img);
                img.src = filename;
            }
            function f() {
                resolve(true);
            }
        } else reject();
    });
}
function $9efd31b4f3ac5cb3$export$dbf350e5966cf602(element, style) {
    for(const property in style){
        if (style[property] === '') continue;
        element.style[property] = style[property];
    }
}
function $9efd31b4f3ac5cb3$export$ada60a8d5e04651e() {}
function $9efd31b4f3ac5cb3$export$e6c5ffa684aac4d7() {
    return window.location !== window.parent.location;
}
async function $9efd31b4f3ac5cb3$export$2cdf1b96a9f86d16(text) {
    try {
        if (!navigator.clipboard) // IE support
        window.clipboardData.setData('Text', text);
        else await navigator.clipboard.writeText(text);
    } catch  {
        console.log("copy into clipboard not suported in this browser :(");
        return false;
    }
    console.log('text copied:', text);
    return true;
}
function $9efd31b4f3ac5cb3$export$795910f5f15a9633(el) {
    var style = window.getComputedStyle(el);
    return style.visibility != 'hidden';
}




const $227a9cdbe0f25d11$var$InputBar = ({ className: className })=>{
    const { LL: LL } = (0, $dc3317580ce734b5$export$22f0ca4c21b6ff4)();
    const [lang] = (0, $c95f922ce4854eac$export$b24a004ee43dce44)();
    const speechConf = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$21313a3d5e4111fc));
    const editMode = (0, $0b20ce121ee1acb3$exports.useAtomValue)((0, $b78da6c1f1424617$export$db1d63ac91a84676));
    const [input, setInput] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$48639037ba826bfa));
    const setBackInput = (0, $0b20ce121ee1acb3$exports.useSetAtom)((0, $b78da6c1f1424617$export$b27f1a8572d7f162));
    const [screenName, setScreenName] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$98ba80ce6e840e63));
    const [copied, setCopied] = (0, $6F3kv.useState)(false);
    const onEnd = ()=>{
    // You could do something here after speaking has finished
    };
    const onResult = ()=>{
    // You could do something here after speaking has finished
    };
    const { speak: speak, cancel: cancel, speaking: speaking, supported: supported, voices: voices } = (0, $3851751ef97de198$exports.useSpeechSynthesis)({
        onEnd: onEnd,
        onResult: onResult
    });
    const speakText = (text)=>{
        const voice = voices[speechConf.voiceIndex] || null;
        // const text = 'Hola mundo!'
        // console.log(text)
        speak({
            text: text,
            voice: voice,
            rate: speechConf.rate,
            pitch: speechConf.pitch
        });
    };
    (0, $6F3kv.useEffect)(()=>{
        if (speechConf.speakWord && input.length > 0) {
            const lastWord = input.slice(-1)[0];
            const text = (0, $797beb6b1327aa54$export$a4a21184d88cac78)(lastWord, lang);
            // console.log('word', text, lastWord)
            speakText(text == ' ' ? LL.aac.space() : text);
        }
    }, [
        input
    ]);
    const runAction = ()=>{
        // console.log(input)
        const text = (0, $797beb6b1327aa54$export$a4a21184d88cac78)(input, lang);
        // console.log(text)
        if (text && text != '') speakText(text);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('speak', {
            text: text,
            screen: screenName
        });
    };
    const copyAction = async (event)=>{
        event.preventDefault();
        const selText = (0, $797beb6b1327aa54$export$fad6afd6bf685e79)((0, $797beb6b1327aa54$export$a4a21184d88cac78)(input, lang));
        if ((0, $9efd31b4f3ac5cb3$export$e6c5ffa684aac4d7)()) {
            (0, $6c5f2c918bcb056e$export$a2ddee470fba72ea)({
                type: 'clipboard',
                data: selText
            });
            return;
        }
        (0, $9efd31b4f3ac5cb3$export$2cdf1b96a9f86d16)(selText);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('copy to clipboard', {
            text: selText,
            screen: screenName
        });
    };
    const clear = ()=>{
        setInput((0, $787fd5ab8c7121a2$exports.RESET));
        cancel();
        const selText = (0, $797beb6b1327aa54$export$a4a21184d88cac78)(input, lang);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('cancel', {
            text: selText,
            screen: screenName
        });
    };
    const removeLast = ()=>{
        const last = input.slice(-1)[0];
        setBackInput(input.slice(0, -1));
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('remove last', {
            last: last,
            screen: screenName
        });
    };
    const copy = (e)=>{
        setCopied(true);
        copyAction(e);
    };
    const copyExit = ()=>{
        setCopied(false);
    };
    const back = ()=>{
        setScreenName((0, $b78da6c1f1424617$export$e893c720be9b9aae));
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('page', {
            screen: screenName
        });
    };
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        className: `flex font-bold items-center justify-center flex-wrap ${className ?? ''}`,
        children: [
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9f0f52acda0ab377$export$2e2bcd8739ae039), {
                className: "flex-1 mx-2 mt-2 h-32 cursor-pointer hover:bg-base-100 hover:border-2 hover:text-base-content hover:grayscale active:grayscale [--btn-focus-scale:0.98] relative group min-w-full xs:min-w-0 scrollbar-thin scrollbar-thumb-base-content scrollbar-base-100 overflow-y-auto",
                tiles: input,
                onClick: removeLast,
                disabled: !supported,
                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                    className: "absolute bottom-0 right-0 mr-2 mb-2",
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $8a9611576e15c643$export$2e2bcd8739ae039), {
                        className: "w-10 h-10 group-hover:opacity-70 opacity-30 text-base-content"
                    })
                })
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                className: "mt-2 xs:w-auto flex xs:flex-col xs:h-32 lg:h-auto lg:flex-row justify-center",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        className: "flex flex-row-reverse xs:flex-row lg:flex-row-reverse",
                        children: [
                            supported ? !speaking ? /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                                className: "btn inbar-btn btn-primary text-base-content p-2 mr-2 mb-1 mb:mb-0 tooltip tooltip-bottom",
                                "data-tip": LL.aac.run(),
                                "aria-label": LL.aac.run(),
                                onClick: runAction,
                                disabled: editMode,
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $b72b2a2fb3b87abb$export$2e2bcd8739ae039), {})
                            }) : /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                                className: "btn inbar-btn btn-warning text-base-content p-2 mr-2 mb-1 mb:mb-0 tooltip tooltip-bottom",
                                "data-tip": LL.aac.cancel(),
                                "aria-label": LL.aac.cancel(),
                                onClick: cancel,
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $f24b07451cc3b6ce$export$2e2bcd8739ae039), {})
                            }) : /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                                className: "btn inbar-btn btn-neutral text-base-content p-2 mr-2 mb-1 mb:mb-0 tooltip tooltip-bottom",
                                "data-tip": LL.aac.notSupported(),
                                "aria-label": LL.aac.notSupported(),
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $284fc52f12aa9c29$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                                className: `btn inbar-btn btn-primary text-base-content p-2 mr-2 tooltip tooltip-bottom ${screenName != (0, $b78da6c1f1424617$export$e893c720be9b9aae) ? '' : 'invisible lg:hidden'}`,
                                "data-tip": LL.aac.back(),
                                "aria-label": LL.aac.back(),
                                onClick: back,
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $63b86002891a1b3e$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                                className: "btn inbar-btn btn-error text-base-content p-2 mr-2 mb-1 mb:mb-0 tooltip tooltip-bottom",
                                "data-tip": LL.aac.clear(),
                                "aria-label": LL.aac.clear(),
                                onClick: clear,
                                disabled: editMode,
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $09ac706bf4de83a3$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                                className: "btn inbar-btn btn-secondary text-base-content p-2 mr-2 tooltip tooltip-bottom",
                                "data-tip": copied ? LL.aac.copied() + '!' : LL.aac.copy(),
                                "aria-label": LL.aac.copy(),
                                onClick: copy,
                                onBlur: copyExit,
                                disabled: editMode,
                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $a0cd141cb9803ce9$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $227a9cdbe0f25d11$export$2e2bcd8739ae039 = $227a9cdbe0f25d11$var$InputBar;



const $7666a39762970fe0$var$DefaultLayout = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        className: "h-full max-h-screen scrollbar-thin scrollbar-thumb-base-content scrollbar-base-100 overflow-y-auto",
        ...rest,
        children: children
    });
};
var $7666a39762970fe0$export$2e2bcd8739ae039 = $7666a39762970fe0$var$DefaultLayout;



parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $4e487639d4d36a43$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18 18 6M6 6l12 12"
    }));
}
const $4e487639d4d36a43$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($4e487639d4d36a43$var$XMarkIcon);
var $4e487639d4d36a43$export$2e2bcd8739ae039 = $4e487639d4d36a43$var$ForwardRef;


parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");


const $a6910c8dd2f821e0$var$AlertError = ({ className: className, style: style, ...rest })=>{
    const { LL: LL } = (0, $dc3317580ce734b5$export$22f0ca4c21b6ff4)();
    const validStorage = (0, $6F3kv.useMemo)(()=>(0, $203db46044024c1f$export$7f56500bdbdd99d3)(), []);
    const [errorDisplay, setErrorDisplay] = (0, $6F3kv.useState)(!validStorage);
    return errorDisplay && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        className: "toast",
        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
            className: "alert alert-error",
            children: [
                LL.common.localStorageNotSupported(),
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                    className: "btn btn-ghost btn-square btn-xs",
                    onClick: ()=>setErrorDisplay(false),
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $4e487639d4d36a43$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};
var $a6910c8dd2f821e0$export$2e2bcd8739ae039 = $a6910c8dd2f821e0$var$AlertError;


const $1fc4fa1ecb2b4a9a$var$GridPage = (props)=>{
    //WARNING: not include i18n hooks from here (uknown error)
    // const dimMode = useAtomValue(dimModeAtom)
    // const Grid = useMemo(() => <Grid2 />, []);
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $7666a39762970fe0$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
            className: "relative h-screen m-auto xl:w-4/5 2xl:w-2/3 w-full overflow-x-hidden xl:overflow-x-visible flex flex-col",
            children: [
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $cdb8457cb6f488fc$export$2e2bcd8739ae039), {
                    className: "p-0 absolute top-0 left-0 z-20 flex w-0 h-0"
                }),
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                    className: `flex flex-col relative overflow-hidden`,
                    children: [
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $227a9cdbe0f25d11$export$2e2bcd8739ae039), {
                            className: "p-2 w-full bg-base-100 z-10"
                        }),
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                            className: "flex-1 p-2 pt-0 scrollbar-thin scrollbar-thumb-base-content scrollbar-base-100 overflow-y-auto",
                            children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $67aa8c2df751bea2$export$2e2bcd8739ae039), {
                                className: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $a6910c8dd2f821e0$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $1fc4fa1ecb2b4a9a$export$2e2bcd8739ae039 = $1fc4fa1ecb2b4a9a$var$GridPage;




var $9Oehh = parcelRequire("9Oehh");







parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");





parcelRequire("7hzE7");
var $6F3kv = parcelRequire("6F3kv");

var $4c935dde2abcccb3$exports = {};
(function(root, factory) {
    var deepDiff = factory(root);
    // eslint-disable-next-line no-undef
    if (typeof define === 'function' && define.amd) // AMD
    define('DeepDiff', function() {
        return deepDiff;
    });
    else {
        var _deepdiff;
        // Node.js or ReactNative
        $4c935dde2abcccb3$exports = deepDiff;
    }
})($4c935dde2abcccb3$exports, function(root) {
    var validKinds = [
        'N',
        'E',
        'A',
        'D'
    ];
    // nodejs compatible on server side and in the browser.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
    function Diff(kind, path) {
        Object.defineProperty(this, 'kind', {
            value: kind,
            enumerable: true
        });
        if (path && path.length) Object.defineProperty(this, 'path', {
            value: path,
            enumerable: true
        });
    }
    function DiffEdit(path, origin, value) {
        DiffEdit.super_.call(this, 'E', path);
        Object.defineProperty(this, 'lhs', {
            value: origin,
            enumerable: true
        });
        Object.defineProperty(this, 'rhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffEdit, Diff);
    function DiffNew(path, value) {
        DiffNew.super_.call(this, 'N', path);
        Object.defineProperty(this, 'rhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffNew, Diff);
    function DiffDeleted(path, value) {
        DiffDeleted.super_.call(this, 'D', path);
        Object.defineProperty(this, 'lhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffDeleted, Diff);
    function DiffArray(path, index, item) {
        DiffArray.super_.call(this, 'A', path);
        Object.defineProperty(this, 'index', {
            value: index,
            enumerable: true
        });
        Object.defineProperty(this, 'item', {
            value: item,
            enumerable: true
        });
    }
    inherits(DiffArray, Diff);
    function arrayRemove(arr, from, to) {
        var rest = arr.slice((to || from) + 1 || arr.length);
        arr.length = from < 0 ? arr.length + from : from;
        arr.push.apply(arr, rest);
        return arr;
    }
    function realTypeOf(subject) {
        var type = typeof subject;
        if (type !== 'object') return type;
        if (subject === Math) return 'math';
        else if (subject === null) return 'null';
        else if (Array.isArray(subject)) return 'array';
        else if (Object.prototype.toString.call(subject) === '[object Date]') return 'date';
        else if (typeof subject.toString === 'function' && /^\/.*\//.test(subject.toString())) return 'regexp';
        return 'object';
    }
    // http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
    function hashThisString(string) {
        var hash = 0;
        if (string.length === 0) return hash;
        for(var i = 0; i < string.length; i++){
            var char = string.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
    // Gets a hash of the given object in an array order-independent fashion
    // also object key order independent (easier since they can be alphabetized)
    function getOrderIndependentHash(object) {
        var accum = 0;
        var type = realTypeOf(object);
        if (type === 'array') {
            object.forEach(function(item) {
                // Addition is commutative so this is order indep
                accum += getOrderIndependentHash(item);
            });
            var arrayString = '[type: array, hash: ' + accum + ']';
            return accum + hashThisString(arrayString);
        }
        if (type === 'object') {
            for(var key in object)if (object.hasOwnProperty(key)) {
                var keyValueString = '[ type: object, key: ' + key + ', value hash: ' + getOrderIndependentHash(object[key]) + ']';
                accum += hashThisString(keyValueString);
            }
            return accum;
        }
        // Non object, non array...should be good?
        var stringToHash = '[ type: ' + type + ' ; value: ' + object + ']';
        return accum + hashThisString(stringToHash);
    }
    function deepDiff(lhs, rhs, changes, prefilter, path, key, stack, orderIndependent) {
        changes = changes || [];
        path = path || [];
        stack = stack || [];
        var currentPath = path.slice(0);
        if (typeof key !== 'undefined' && key !== null) {
            if (prefilter) {
                if (typeof prefilter === 'function' && prefilter(currentPath, key)) return;
                else if (typeof prefilter === 'object') {
                    if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) return;
                    if (prefilter.normalize) {
                        var alt = prefilter.normalize(currentPath, key, lhs, rhs);
                        if (alt) {
                            lhs = alt[0];
                            rhs = alt[1];
                        }
                    }
                }
            }
            currentPath.push(key);
        }
        // Use string comparison for regexes
        if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
            lhs = lhs.toString();
            rhs = rhs.toString();
        }
        var ltype = typeof lhs;
        var rtype = typeof rhs;
        var i, j, k, other;
        var ldefined = ltype !== 'undefined' || stack && stack.length > 0 && stack[stack.length - 1].lhs && Object.getOwnPropertyDescriptor(stack[stack.length - 1].lhs, key);
        var rdefined = rtype !== 'undefined' || stack && stack.length > 0 && stack[stack.length - 1].rhs && Object.getOwnPropertyDescriptor(stack[stack.length - 1].rhs, key);
        if (!ldefined && rdefined) changes.push(new DiffNew(currentPath, rhs));
        else if (!rdefined && ldefined) changes.push(new DiffDeleted(currentPath, lhs));
        else if (realTypeOf(lhs) !== realTypeOf(rhs)) changes.push(new DiffEdit(currentPath, lhs, rhs));
        else if (realTypeOf(lhs) === 'date' && lhs - rhs !== 0) changes.push(new DiffEdit(currentPath, lhs, rhs));
        else if (ltype === 'object' && lhs !== null && rhs !== null) {
            for(i = stack.length - 1; i > -1; --i)if (stack[i].lhs === lhs) {
                other = true;
                break;
            }
            if (!other) {
                stack.push({
                    lhs: lhs,
                    rhs: rhs
                });
                if (Array.isArray(lhs)) {
                    // If order doesn't matter, we need to sort our arrays
                    if (orderIndependent) {
                        lhs.sort(function(a, b) {
                            return getOrderIndependentHash(a) - getOrderIndependentHash(b);
                        });
                        rhs.sort(function(a, b) {
                            return getOrderIndependentHash(a) - getOrderIndependentHash(b);
                        });
                    }
                    i = rhs.length - 1;
                    j = lhs.length - 1;
                    while(i > j)changes.push(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i--])));
                    while(j > i)changes.push(new DiffArray(currentPath, j, new DiffDeleted(undefined, lhs[j--])));
                    for(; i >= 0; --i)deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack, orderIndependent);
                } else {
                    var akeys = Object.keys(lhs);
                    var pkeys = Object.keys(rhs);
                    for(i = 0; i < akeys.length; ++i){
                        k = akeys[i];
                        other = pkeys.indexOf(k);
                        if (other >= 0) {
                            deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
                            pkeys[other] = null;
                        } else deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack, orderIndependent);
                    }
                    for(i = 0; i < pkeys.length; ++i){
                        k = pkeys[i];
                        if (k) deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
                    }
                }
                stack.length = stack.length - 1;
            } else if (lhs !== rhs) // lhs is contains a cycle at this element and it differs from rhs
            changes.push(new DiffEdit(currentPath, lhs, rhs));
        } else if (lhs !== rhs) {
            if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) changes.push(new DiffEdit(currentPath, lhs, rhs));
        }
    }
    function observableDiff(lhs, rhs, observer, prefilter, orderIndependent) {
        var changes = [];
        deepDiff(lhs, rhs, changes, prefilter, null, null, null, orderIndependent);
        if (observer) for(var i = 0; i < changes.length; ++i)observer(changes[i]);
        return changes;
    }
    function orderIndependentDeepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
        return deepDiff(lhs, rhs, changes, prefilter, path, key, stack, true);
    }
    function accumulateDiff(lhs, rhs, prefilter, accum) {
        var observer = accum ? function(difference) {
            if (difference) accum.push(difference);
        } : undefined;
        var changes = observableDiff(lhs, rhs, observer, prefilter);
        return accum ? accum : changes.length ? changes : undefined;
    }
    function accumulateOrderIndependentDiff(lhs, rhs, prefilter, accum) {
        var observer = accum ? function(difference) {
            if (difference) accum.push(difference);
        } : undefined;
        var changes = observableDiff(lhs, rhs, observer, prefilter, true);
        return accum ? accum : changes.length ? changes : undefined;
    }
    function applyArrayChange(arr, index, change) {
        if (change.path && change.path.length) {
            var it = arr[index], i, u = change.path.length - 1;
            for(i = 0; i < u; i++)it = it[change.path[i]];
            switch(change.kind){
                case 'A':
                    applyArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    delete it[change.path[i]];
                    break;
                case 'E':
                case 'N':
                    it[change.path[i]] = change.rhs;
                    break;
            }
        } else switch(change.kind){
            case 'A':
                applyArrayChange(arr[index], change.index, change.item);
                break;
            case 'D':
                arr = arrayRemove(arr, index);
                break;
            case 'E':
            case 'N':
                arr[index] = change.rhs;
                break;
        }
        return arr;
    }
    function applyChange(target, source, change) {
        if (typeof change === 'undefined' && source && ~validKinds.indexOf(source.kind)) change = source;
        if (target && change && change.kind) {
            var it = target, i = -1, last = change.path ? change.path.length - 1 : 0;
            while(++i < last){
                if (typeof it[change.path[i]] === 'undefined') it[change.path[i]] = typeof change.path[i + 1] !== 'undefined' && typeof change.path[i + 1] === 'number' ? [] : {};
                it = it[change.path[i]];
            }
            switch(change.kind){
                case 'A':
                    if (change.path && typeof it[change.path[i]] === 'undefined') it[change.path[i]] = [];
                    applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
                    break;
                case 'D':
                    delete it[change.path[i]];
                    break;
                case 'E':
                case 'N':
                    it[change.path[i]] = change.rhs;
                    break;
            }
        }
    }
    function revertArrayChange(arr, index, change) {
        if (change.path && change.path.length) {
            // the structure of the object at the index has changed...
            var it = arr[index], i, u = change.path.length - 1;
            for(i = 0; i < u; i++)it = it[change.path[i]];
            switch(change.kind){
                case 'A':
                    revertArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    it[change.path[i]] = change.lhs;
                    break;
                case 'E':
                    it[change.path[i]] = change.lhs;
                    break;
                case 'N':
                    delete it[change.path[i]];
                    break;
            }
        } else // the array item is different...
        switch(change.kind){
            case 'A':
                revertArrayChange(arr[index], change.index, change.item);
                break;
            case 'D':
                arr[index] = change.lhs;
                break;
            case 'E':
                arr[index] = change.lhs;
                break;
            case 'N':
                arr = arrayRemove(arr, index);
                break;
        }
        return arr;
    }
    function revertChange(target, source, change) {
        if (target && source && change && change.kind) {
            var it = target, i, u;
            u = change.path.length - 1;
            for(i = 0; i < u; i++){
                if (typeof it[change.path[i]] === 'undefined') it[change.path[i]] = {};
                it = it[change.path[i]];
            }
            switch(change.kind){
                case 'A':
                    // Array was modified...
                    // it will be an array...
                    revertArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    // Item was deleted...
                    it[change.path[i]] = change.lhs;
                    break;
                case 'E':
                    // Item was edited...
                    it[change.path[i]] = change.lhs;
                    break;
                case 'N':
                    // Item is new...
                    delete it[change.path[i]];
                    break;
            }
        }
    }
    function applyDiff(target, source, filter) {
        if (target && source) {
            var onChange = function(change) {
                if (!filter || filter(target, source, change)) applyChange(target, source, change);
            };
            observableDiff(target, source, onChange);
        }
    }
    Object.defineProperties(accumulateDiff, {
        diff: {
            value: accumulateDiff,
            enumerable: true
        },
        orderIndependentDiff: {
            value: accumulateOrderIndependentDiff,
            enumerable: true
        },
        observableDiff: {
            value: observableDiff,
            enumerable: true
        },
        orderIndependentObservableDiff: {
            value: orderIndependentDeepDiff,
            enumerable: true
        },
        orderIndepHash: {
            value: getOrderIndependentHash,
            enumerable: true
        },
        applyDiff: {
            value: applyDiff,
            enumerable: true
        },
        applyChange: {
            value: applyChange,
            enumerable: true
        },
        revertChange: {
            value: revertChange,
            enumerable: true
        },
        isConflict: {
            value: function() {
                return typeof $conflict !== 'undefined';
            },
            enumerable: true
        }
    });
    // hackish...
    accumulateDiff.DeepDiff = accumulateDiff;
    // ...but works with:
    // import DeepDiff from 'deep-diff'
    // import { DeepDiff } from 'deep-diff'
    // const DeepDiff = require('deep-diff');
    // const { DeepDiff } = require('deep-diff');
    if (root) root.DeepDiff = accumulateDiff;
    return accumulateDiff;
});


function $05c47183961465b0$var$toObject(arr) {
    return arr.reduce((obj, cur)=>({
            ...obj,
            [cur.id]: cur
        }), {});
}
const $05c47183961465b0$export$e4ce02951ef8a57b = (g1, g2)=>{
    const gg1 = Array.isArray(g1) ? $05c47183961465b0$var$toObject(g1) : g1;
    const gg2 = Array.isArray(g2) ? $05c47183961465b0$var$toObject(g2) : g2;
    const out = (0, (/*@__PURE__*/$parcel$interopDefault($4c935dde2abcccb3$exports)))(gg1, gg2, {
        normalize: (path, key, lhs, rhs)=>{
            if (key == 'children') // console.log(key, path, rhs, lhs)
            return [
                $05c47183961465b0$var$toObject(lhs),
                $05c47183961465b0$var$toObject(rhs)
            ];
            return false;
        }
    });
    return out;
};


const $5cd2f77b6195bfca$var$kindMap = {
    D: 'bg-red-100',
    E: 'bg-amber-100',
    N: 'bg-green-100'
};
const $5cd2f77b6195bfca$var$DiffView = ({ value: value, oldValue: oldValue, type: type })=>{
    const { LL: LL } = (0, $dc3317580ce734b5$export$22f0ca4c21b6ff4)();
    const [diff, setDiff] = (0, $6F3kv.useState)(null);
    // console.log(value, oldValue)
    (0, $6F3kv.useEffect)(()=>{
        if (oldValue && value) {
            const d = (0, $05c47183961465b0$export$e4ce02951ef8a57b)(oldValue, value);
            console.log(d);
            setDiff(d);
        }
    }, [
        value,
        oldValue
    ]);
    const getPath = (path)=>{
        let out;
        switch(type){
            case 'grid':
                out = {
                    screen: path[0],
                    tile: path[2],
                    path: '/' + path.slice(3).join('/')
                };
                break;
            case 'screen':
                out = {
                    tile: '',
                    path: '/'
                };
                break;
        }
        return out;
    };
    return diff ? /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        className: "overflow-auto scrollbar-thin scrollbar-thumb-base-content scrollbar-base-100",
        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("table", {
            className: "table w-full",
            children: [
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("thead", {
                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("th", {
                                className: "bg-primary"
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("th", {
                                className: "bg-primary",
                                children: LL.importTable.kind()
                            }),
                            Object.entries(getPath([
                                '',
                                '',
                                '',
                                ''
                            ])).map(([k, v])=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("th", {
                                    className: "bg-primary",
                                    children: LL.importTable[k]()
                                })),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("th", {
                                className: "bg-primary",
                                children: LL.importTable.old()
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("th", {
                                className: "bg-primary"
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("th", {
                                className: "bg-primary",
                                children: LL.importTable.new()
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("tbody", {
                    children: diff?.map((row, index)=>{
                        const newPath = getPath(row.path);
                        const lhs = JSON.stringify(row.lhs, null, '\t');
                        const rhs = JSON.stringify(row.rhs, null, '\t');
                        return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("th", {
                                    className: `border-base-content`,
                                    children: index + 1
                                }),
                                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("td", {
                                    className: `border-base-content`,
                                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                        className: `badge badge-outline font-bold uppercase`,
                                        children: LL.importTable[row.kind]()
                                    })
                                }),
                                Object.entries(getPath(row.path)).map(([k, v])=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("td", {
                                        className: `border-base-content`,
                                        children: v && v != '' ? v : '/'
                                    })),
                                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("td", {
                                    className: `border-base-content ${lhs ? $5cd2f77b6195bfca$var$kindMap[row.kind] : ''}`,
                                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("pre", {
                                        className: "max-w-lg overflow-hidden",
                                        children: lhs ?? 'null'
                                    })
                                }),
                                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("td", {
                                    className: "border-base-content",
                                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $81b1e29fe1b38da5$export$2e2bcd8739ae039), {
                                        className: "h-6"
                                    })
                                }),
                                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("td", {
                                    className: `border-base-content ${rhs ? $5cd2f77b6195bfca$var$kindMap[row.kind] : ''}`,
                                    children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("pre", {
                                        className: "max-w-lg overflow-hidden",
                                        children: rhs ?? 'null'
                                    })
                                })
                            ]
                        });
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
            className: "badge badge-primary py-4",
            children: LL.importTable.noDiff()
        })
    });
};
var $5cd2f77b6195bfca$export$2e2bcd8739ae039 = $5cd2f77b6195bfca$var$DiffView;


parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $8efe34543848423b$var$MoonIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
    }));
}
const $8efe34543848423b$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($8efe34543848423b$var$MoonIcon);
var $8efe34543848423b$export$2e2bcd8739ae039 = $8efe34543848423b$var$ForwardRef;

parcelRequire("7hzE7");
var $9Oehh = parcelRequire("9Oehh");
var $8Zslt = parcelRequire("8Zslt");
function $d6b8e736bba18031$var$SunIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $9Oehh.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $9Oehh.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $9Oehh.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
    }));
}
const $d6b8e736bba18031$var$ForwardRef = /*#__PURE__*/ $8Zslt.forwardRef($d6b8e736bba18031$var$SunIcon);
var $d6b8e736bba18031$export$2e2bcd8739ae039 = $d6b8e736bba18031$var$ForwardRef;




const $c6fd99463d8899ef$var$errorVariants = {
    'error': 'text-error',
    'warning': 'text-warning',
    'success': 'text-success'
};
const $c6fd99463d8899ef$var$SettingsForm = ({ className: className, ...rest })=>{
    const { LL: LL } = (0, $dc3317580ce734b5$export$22f0ca4c21b6ff4)();
    const [lang, setLang] = (0, $c95f922ce4854eac$export$b24a004ee43dce44)();
    const [theme, setTheme] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$8598e3da432e268f));
    const { supported: supported, voices: voices } = (0, $3851751ef97de198$exports.useSpeechSynthesis)({});
    const [config, setConfig] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$21313a3d5e4111fc));
    const [grid, setGrid] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$fdb89ca8367d940b));
    const [runtime, setRuntime] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$a63c88e4229cc588));
    const [importConf, setImportConf] = (0, $6F3kv.useState)(null);
    const [importMsg, setImportMsg] = (0, $6F3kv.useState)({
        value: '',
        type: ''
    });
    const [textMsg, setTextMsg] = (0, $6F3kv.useState)(null);
    const resetModal = (0, $d4aeae9fbbd7cd04$export$2e2bcd8739ae039)('reset-modal');
    const importModal = (0, $d4aeae9fbbd7cd04$export$2e2bcd8739ae039)('import-modal', !!importConf);
    const importAction = (event)=>{
        importConf.action();
        setImportConf(null);
        const file = importConf.file;
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('import file', {
            type: importConf.type,
            file: {
                name: file.name,
                size: file.size,
                mime: file.type,
                lastModified: file.lastModified
            }
        });
    };
    const exportAction = (event)=>{
        const date = new Date().toISOString();
        const outFile = {
            createdAt: date,
            type: 'grid',
            content: grid
        };
        const filename = `grid-${date.split('.')[0]}.json`;
        const file = (0, $1d55beab0580260f$export$bb3b75778e3e272)(JSON.stringify(outFile), filename);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('download grid', {
            filename: filename,
            length: grid.length,
            file: {
                name: file.name,
                size: file.size,
                mime: file.type,
                lastModified: file.lastModified
            }
        });
    };
    const readFileAction = (event)=>{
        setImportMsg({
            type: '',
            value: ''
        });
        const fileList = event.target.files;
        // console.log(fileList);
        if (fileList.length == 0) return;
        const file = fileList[0];
        const outMsg = (0, $1d55beab0580260f$export$72c04af63de9061a)(file, (event)=>{
            try {
                const data = JSON.parse(event.target.result);
                // console.log(data)
                switch(data.type){
                    case 'grid':
                        const newGrid = data.content;
                        console.log('grid file, screens:', newGrid.length);
                        //alert
                        // console.log('alert')
                        setImportConf({
                            type: 'grid',
                            value: newGrid,
                            oldValue: grid,
                            file: file,
                            action: ()=>{
                                setGrid(newGrid);
                                setImportMsg({
                                    value: 'success',
                                    type: 'sucesss'
                                });
                            }
                        });
                        break;
                    case 'screen':
                        const screen = data.content;
                        console.log('screen file:', screen.id);
                        const [oldScreen, index] = (0, $bdcc94fa677df125$export$37adcc2e6440d8b3)(grid, screen.id);
                        if (index == -1) {
                            setGrid(grid.concat(screen));
                            setImportMsg({
                                value: 'success',
                                type: 'sucesss'
                            });
                        } else // altert
                        // console.log('alert')
                        setImportConf({
                            type: 'screen',
                            value: screen,
                            oldValue: oldScreen,
                            file: file,
                            action: ()=>{
                                grid[index] = screen;
                                setGrid([
                                    ...grid
                                ]);
                                setImportMsg({
                                    value: 'success',
                                    type: 'sucesss'
                                });
                            }
                        });
                        break;
                    default:
                        console.log('file format not reconized');
                        setImportMsg({
                            value: 'formatNotFound',
                            type: 'error'
                        });
                }
            } catch (err) {
                console.log("JSON parse file error", err);
                setImportMsg({
                    value: 'badJSON',
                    type: 'error'
                });
            }
        });
        if (outMsg != '') setImportMsg({
            value: outMsg,
            type: 'error'
        });
    };
    const changeTheme = (e)=>{
        const _theme = e.target.checked ? "light" : "dark";
        setTheme(_theme);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('change theme', {
            theme: _theme
        });
    };
    const changeLang = (e)=>{
        const _lang = e.target.value;
        setLang(_lang);
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)("change lang", {
            lang: _lang
        });
    };
    const changeVoice = (e)=>{
        const index = parseInt(e.target.value);
        setConfig({
            ...config,
            voiceIndex: index
        });
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('change voice', {
            voice: voices[index],
            index: index
        });
    };
    // console.log(voices, config)
    const resetConfigs = ()=>{
        setGrid((0, $787fd5ab8c7121a2$exports.RESET));
        setRuntime((0, $787fd5ab8c7121a2$exports.RESET));
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('reset config', {
            old: runtime
        });
    };
    const changeConfigs = (e)=>{
        try {
            setTextMsg(null);
            const data = JSON.parse(e.target.value);
            setRuntime(data);
            (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('change configs', {
                old: runtime,
                new: data
            });
        } catch (err) {
            // console.log(err)
            setTextMsg(err);
        }
    };
    // console.log(config)
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        className: `relative ${className || ''}`,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("a", {
                href: "/",
                className: "btn btn-sm btn-ghost btn-circle absolute right-2 top-2 text-xl",
                children: "\u2715"
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h1", {
                className: "font-bold text-3xl my-4 uppercase",
                children: LL.common.settings()
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("fieldset", {
                className: "fieldset mb-4",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("legend", {
                        className: "fieldset-legend uppercase",
                        children: LL.common.language()
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("select", {
                        className: "select select-bordered w-full capitalize",
                        value: lang,
                        onChange: changeLang,
                        children: (0, $a84802ac7c43e02d$export$df1c34db1371eeed).map((item, i)=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("option", {
                                className: "capitalize",
                                value: item,
                                children: LL.common.lang[item]()
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("fieldset", {
                className: "fieldset mb-4",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("legend", {
                        className: "fieldset-legend uppercase",
                        children: LL.common.theme()
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $8efe34543848423b$export$2e2bcd8739ae039), {
                                className: "w-6"
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                type: "checkbox",
                                className: "toggle mx-2",
                                checked: theme == 'light',
                                onChange: changeTheme
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $d6b8e736bba18031$export$2e2bcd8739ae039), {
                                className: "w-6"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("fieldset", {
                className: "fieldset mb-4",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("legend", {
                        className: "fieldset-legend uppercase",
                        children: LL.aac.voice()
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("select", {
                        className: "select select-bordered w-full",
                        value: config.voiceIndex,
                        onChange: changeVoice,
                        children: !supported ? /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("option", {
                            disabled: true,
                            selected: true,
                            children: LL.aac.notSupported()
                        }) : voices.map((item, i)=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("option", {
                                value: i,
                                children: `${item.name} (${item.lang})`
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("fieldset", {
                className: "fieldset mb-4",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("legend", {
                        className: "fieldset-legend uppercase",
                        children: LL.aac.pitch()
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                        type: "range",
                        min: "0",
                        max: "2",
                        className: "range",
                        step: ".2",
                        value: config.pitch,
                        onChange: (e)=>setConfig({
                                ...config,
                                pitch: parseFloat(e.target.value)
                            })
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        className: "w-full flex justify-between text-xs px-2 mt-1",
                        children: (0, $4f6efe0791a5325f$export$d02631cccf789723)(0, 2.2, .2).map((v)=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                children: v.toFixed(1)
                            }, v))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("fieldset", {
                className: "fieldset mb-4",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("legend", {
                        className: "fieldset-legend uppercase",
                        children: LL.aac.rate()
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                        className: "join",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                type: "number",
                                placeholder: "1",
                                min: "0",
                                max: "10",
                                step: ".1",
                                className: "input input-bordered join-item",
                                value: config.rate,
                                onChange: (e)=>setConfig({
                                        ...config,
                                        rate: parseFloat(e.target.value == 0 ? 0.1 : e.target.value)
                                    })
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                className: "btn btn-neutral join-item pointer-events-none",
                                children: "x"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("fieldset", {
                className: "fieldset mb-4",
                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                    className: "fieldset-label cursor-pointer justify-between w-full",
                    children: [
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                            className: "uppercase font-semibold text-base-content",
                            children: LL.aac.speakWords()
                        }),
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                            type: "checkbox",
                            className: "toggle",
                            checked: config.speakWord,
                            onChange: (e)=>setConfig({
                                    ...config,
                                    speakWord: e.target.checked
                                })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("fieldset", {
                className: "fieldset mb-4",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("legend", {
                        className: "fieldset-legend uppercase",
                        children: LL.common.importLabel()
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                        type: "file",
                        className: "file-input file-input-bordered w-full max-w-xs",
                        accept: ".json",
                        onChange: readFileAction
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                        className: `text-success ${importMsg.value != '' ? '' : 'hidden'} 
            ${$c6fd99463d8899ef$var$errorVariants[importMsg.type]}`,
                        children: LL.common[importMsg.value]() + '!'
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)(importModal.Label, {}),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)(importModal.Modal, {
                        className: "overflow-y-auto !max-w-max overflow-x-auto",
                        onChange: (ev)=>{
                            if (!ev.target.checked) setImportConf(null);
                        },
                        children: ({ label: label })=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9Oehh.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h3", {
                                        className: "font-bold text-lg uppercase",
                                        children: LL.aac.caution()
                                    }),
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("p", {
                                        className: "py-4",
                                        children: LL.aac.importCaution()
                                    }),
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                        className: "modal-action my-2",
                                        children: [
                                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                                htmlFor: label,
                                                className: "btn btn-error",
                                                onClick: importAction,
                                                children: LL.aac.actions.yes()
                                            }),
                                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                                htmlFor: label,
                                                className: "btn",
                                                children: LL.aac.actions.no()
                                            })
                                        ]
                                    }),
                                    importConf && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                        className: "collapse collapse-arrow",
                                        children: [
                                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                                                type: "checkbox"
                                            }),
                                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                                className: "collapse-title text-sm uppercase",
                                                children: LL.common.seeDetails()
                                            }),
                                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                                className: "collapse-content",
                                                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $5cd2f77b6195bfca$export$2e2bcd8739ae039), {
                                                    ...importConf
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("fieldset", {
                className: "fieldset mb-4",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("legend", {
                        className: "fieldset-legend uppercase",
                        children: LL.common.exportLabel()
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("button", {
                        className: "btn btn-primary w-56",
                        onClick: exportAction,
                        children: LL.common.export()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("fieldset", {
                className: "fieldset my-4",
                children: [
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("legend", {
                        className: "fieldset-legend uppercase",
                        children: LL.aac.resetInfo()
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)(resetModal.Label, {
                        role: "button",
                        className: "btn btn-warning w-56 relative overflow-hidden justify-start",
                        children: [
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                className: "ml-6",
                                children: LL.aac.reset()
                            }),
                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                className: "-skew-x-12 h-full flex absolute -right-1",
                                children: [
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                        className: "h-full bg-black ml-6 w-6"
                                    }),
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                        className: "h-full bg-black ml-6 w-6"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)(resetModal.Modal, {
                        children: ({ label: label })=>/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9Oehh.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h3", {
                                        className: "font-bold text-lg uppercase",
                                        children: LL.aac.caution()
                                    }),
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("p", {
                                        className: "py-4",
                                        children: LL.aac.resetCaution()
                                    }),
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                        className: "modal-action",
                                        children: [
                                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                                htmlFor: label,
                                                className: "btn btn-error",
                                                onClick: resetConfigs,
                                                children: LL.aac.actions.yes()
                                            }),
                                            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("label", {
                                                htmlFor: label,
                                                className: "btn",
                                                children: LL.aac.actions.no()
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                className: "mb-4",
                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                    className: "collapse collapse-arrow border border-base-300 bg-base-100 rounded-box",
                    children: [
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("input", {
                            type: "checkbox"
                        }),
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                            className: "collapse-title text-sm uppercase font-semibold",
                            children: LL.common.advancedConfig()
                        }),
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                            className: "collapse-content",
                            children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                                className: "mockup-code bg-base-200 text-base-content px-4",
                                children: [
                                    textMsg && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("span", {
                                        className: "pb-4",
                                        children: `${textMsg.name}: ${textMsg.message}`
                                    }),
                                    /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("textarea", {
                                        name: "",
                                        id: "",
                                        // cols="30"
                                        rows: "20",
                                        className: `textarea numbered textarea-ghost w-full font-mono bg-transparent 
                            scrollbar-thin scrollbar-thumb-base-content scrollbar-base-100`,
                                        defaultValue: JSON.stringify(runtime, null, ' '),
                                        onChange: changeConfigs
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
                className: "my-10",
                children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h2", {
                    className: "font-bold font-mono",
                    children: [
                        LL.common.madeBy({
                            label: ''
                        }),
                        /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("a", {
                            className: "link mr-1",
                            href: "https://epi3.co",
                            children: "epi3.co"
                        }),
                        ` \xa9 ${Math.max(2023, new Date().getFullYear())}`
                    ]
                })
            })
        ]
    });
};
var $c6fd99463d8899ef$export$2e2bcd8739ae039 = $c6fd99463d8899ef$var$SettingsForm;



const $2894824154e7985e$var$SettingsPage = (props)=>{
    // const Grid = useMemo(() => <Grid2 />, []);
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $7666a39762970fe0$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
            className: "flex flex-col items-center",
            children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $c6fd99463d8899ef$export$2e2bcd8739ae039), {
                className: "w-full md:w-2/3 lg:w-1/2 px-4"
            })
        })
    });
};
var $2894824154e7985e$export$2e2bcd8739ae039 = $2894824154e7985e$var$SettingsPage;


function $e768722187d03dbc$export$2e2bcd8739ae039() {
    $e768722187d03dbc$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e768722187d03dbc$export$2e2bcd8739ae039.apply(this, arguments);
}


/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $d0bbc61425f1c26a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d0bbc61425f1c26a$export$e19cd5f9376f8cee || ($d0bbc61425f1c26a$export$e19cd5f9376f8cee = {}));
var $d0bbc61425f1c26a$var$readOnly = function(obj) {
    return obj;
};
function $d0bbc61425f1c26a$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $d0bbc61425f1c26a$var$BeforeUnloadEventType = 'beforeunload';
var $d0bbc61425f1c26a$var$HashChangeEventType = 'hashchange';
var $d0bbc61425f1c26a$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d0bbc61425f1c26a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $d0bbc61425f1c26a$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($d0bbc61425f1c26a$var$PopStateEventType, handlePop);
    var action = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $d0bbc61425f1c26a$var$createEvents();
    var blockers = $d0bbc61425f1c26a$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $e768722187d03dbc$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $d0bbc61425f1c26a$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $d0bbc61425f1c26a$var$readOnly((0, $e768722187d03dbc$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $d0bbc61425f1c26a$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $d0bbc61425f1c26a$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($d0bbc61425f1c26a$var$BeforeUnloadEventType, $d0bbc61425f1c26a$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($d0bbc61425f1c26a$var$BeforeUnloadEventType, $d0bbc61425f1c26a$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d0bbc61425f1c26a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $d0bbc61425f1c26a$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $d0bbc61425f1c26a$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($d0bbc61425f1c26a$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($d0bbc61425f1c26a$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($d0bbc61425f1c26a$export$fe53371bee54353d(nextLocation) !== $d0bbc61425f1c26a$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $d0bbc61425f1c26a$var$createEvents();
    var blockers = $d0bbc61425f1c26a$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $e768722187d03dbc$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $d0bbc61425f1c26a$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $d0bbc61425f1c26a$var$readOnly((0, $e768722187d03dbc$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $d0bbc61425f1c26a$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $d0bbc61425f1c26a$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($d0bbc61425f1c26a$var$BeforeUnloadEventType, $d0bbc61425f1c26a$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($d0bbc61425f1c26a$var$BeforeUnloadEventType, $d0bbc61425f1c26a$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $d0bbc61425f1c26a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $d0bbc61425f1c26a$var$readOnly((0, $e768722187d03dbc$export$2e2bcd8739ae039)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $d0bbc61425f1c26a$var$createKey()
        }, typeof entry === 'string' ? $d0bbc61425f1c26a$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $d0bbc61425f1c26a$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $d0bbc61425f1c26a$var$createEvents();
    var blockers = $d0bbc61425f1c26a$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $d0bbc61425f1c26a$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $d0bbc61425f1c26a$var$readOnly((0, $e768722187d03dbc$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $d0bbc61425f1c26a$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $d0bbc61425f1c26a$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $d0bbc61425f1c26a$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $d0bbc61425f1c26a$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $d0bbc61425f1c26a$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $d0bbc61425f1c26a$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $d0bbc61425f1c26a$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $d0bbc61425f1c26a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $d0bbc61425f1c26a$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $d0bbc61425f1c26a$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}



const $9ad6186f2011cc05$var$RouterComp = ()=>{
    const handleRoute = async (e)=>{
        // switch (e.url) {
        //   case '/profile':
        //     const isAuthed = await this.isAuthenticated();
        //     if (!isAuthed) route('/', true);
        //     break;
        // }
        (0, $fe246feeaa6a5f9e$export$6b2a7d5132615086)('page', {
            url: e.url,
            page: e.path,
            // active: e.active,
            current: e.current,
            previous: e.previous,
            matches: e.matches
        });
    };
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $f2ea33f18db73d01$export$55185c17a0fcbe46), {
        history: (0, $d0bbc61425f1c26a$export$b71fdd3798280242)(),
        onChange: handleRoute,
        children: [
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $1fc4fa1ecb2b4a9a$export$2e2bcd8739ae039), {
                path: "/"
            }),
            /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $2894824154e7985e$export$2e2bcd8739ae039), {
                path: "/settings"
            })
        ]
    });
};
var $9ad6186f2011cc05$export$2e2bcd8739ae039 = $9ad6186f2011cc05$var$RouterComp;







let $edd1e569c67b39dd$var$tim;
function $edd1e569c67b39dd$var$App(props) {
    const [lang, setLang] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$a84d19966bda61f9));
    const setRuntimeConfig = (0, $0b20ce121ee1acb3$exports.useSetAtom)((0, $b78da6c1f1424617$export$a63c88e4229cc588));
    const setSpeechConf = (0, $0b20ce121ee1acb3$exports.useSetAtom)((0, $b78da6c1f1424617$export$21313a3d5e4111fc));
    const setGrid = (0, $0b20ce121ee1acb3$exports.useSetAtom)((0, $b78da6c1f1424617$export$fdb89ca8367d940b));
    const [resetConfig, setResetConfig] = (0, $0b20ce121ee1acb3$exports.useAtom)((0, $b78da6c1f1424617$export$93d03168ef9b559d));
    const { supported: supported, voices: voices } = (0, $3851751ef97de198$exports.useSpeechSynthesis)({});
    const { baseURL: baseURL, overrideUserdata: overrideUserdata, workspace: workspace, lang: configLang, theme: theme, logoUrl: logoUrl, logoLabel: logoLabel, grid: grid, speech: speech, meta: meta, ...extraProps } = props;
    // habitat(widget) props
    (0, $6F3kv.useEffect)(()=>{
        // console.log(props)
        if (resetConfig) setTimeout(()=>{
            setGrid((0, $b78da6c1f1424617$export$d788bc089976c004));
            const validRuntimeConfig = Object.fromEntries(Object.entries({
                baseURL: baseURL,
                overrideUserdata: overrideUserdata,
                workspace: workspace,
                lang: configLang,
                theme: theme,
                logoUrl: logoUrl,
                logoLabel: logoLabel,
                grid: grid,
                speech: speech
            }).filter(([_, v])=>v !== undefined));
            // console.log(validRuntimeConfig)
            setRuntimeConfig({
                //  overrideUserdata: false
                ...validRuntimeConfig
            });
            setResetConfig(false);
        }, 500) // hardcpde value TODO: (calculate localstorage value to load)
        ;
        const combinedMeta = {
            ...extraProps,
            ...configLang && {
                lang: configLang
            },
            ...meta && typeof meta === 'object' ? meta : {}
        };
        if (Object.keys(combinedMeta).length > 0) // metadata to mixpanel
        (0, $fe246feeaa6a5f9e$export$6503ec6e8aabbaf)(combinedMeta);
    }, [
        props,
        resetConfig
    ]);
    // Detect locale
    // (Use as advanaced locale detection strategy as you like.
    // More info: https://github.com/ivanhofer/typesafe-i18n/tree/main/packages/detectors)
    let locale;
    if (typeof window !== "undefined") locale = lang != '' ? lang : (0, $a84802ac7c43e02d$export$8aa9c21fdc1955ee)((0, $fa2c1c82139800cc$export$8131985a11e9904f));
    else locale = lang != '' ? lang : 'en';
    // console.log(lang, locale)
    // Load locales
    // (Use a data fetching solution that you prefer)
    const [localesLoaded, setLocalesLoaded] = (0, $6F3kv.useState)(false);
    (0, $6F3kv.useEffect)(()=>{
        // console.log(locale)
        if (locale != '') {
            // loadLocaleAsync(locale).then(() => setLocalesLoaded(true))
            (0, $b9adadb6c2c76409$export$3f35861ea9a1becb)(locale);
            setLocalesLoaded(true);
        }
        clearTimeout($edd1e569c67b39dd$var$tim);
        $edd1e569c67b39dd$var$tim = setTimeout(()=>lang == '' && setLang(locale), 2000);
    }, [
        locale
    ]);
    if (!localesLoaded) return null;
    (0, $6F3kv.useEffect)(()=>{
        const index = (0, $96596b87b46525f2$export$30c5e393d7f8c18b)(locale);
        setSpeechConf((a)=>({
                ...a,
                voiceIndex: index
            }));
    }, [
        voices,
        locale
    ]);
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $dc3317580ce734b5$export$2e2bcd8739ae039), {
        locale: locale,
        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $9ad6186f2011cc05$export$2e2bcd8739ae039), {})
    });
}
var $edd1e569c67b39dd$export$2e2bcd8739ae039 = $edd1e569c67b39dd$var$App;




// track initialize
(0, $fe246feeaa6a5f9e$export$2a47f398eeff8b01)();




const $ecece3a6d7a30975$var$Splash = ()=>{
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        className: "absolute top-0 left-0 w-full h-screen bg-base-100 flex items-center justify-center z-50",
        children: /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
            className: "flex flex-col items-center",
            children: [
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("img", {
                    src: new URL($c301439804b8d900$exports),
                    className: "w-24",
                    alt: "picto access logo"
                }),
                /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("h1", {
                    className: "font-bold text-2xl",
                    children: "Picto Access"
                })
            ]
        })
    });
};
var $ecece3a6d7a30975$export$2e2bcd8739ae039 = $ecece3a6d7a30975$var$Splash;




const $b245de47ffd0296a$var$Wrapper = ()=>{
    const [runtime, setRuntime] = (0, $6F3kv.useState)(null);
    const [splash, setSplash] = (0, $6F3kv.useState)(true);
    function receiveMessage() {
        window.onmessage = function(e) {
            const msg = e.data;
            // console.log(msg)
            if (msg.type == 'runtime') setRuntime(msg.data);
        // sendMessage({ type: 'ack', data: msg.data })
        };
    }
    (0, $6F3kv.useEffect)(()=>{
        receiveMessage();
        (0, $6c5f2c918bcb056e$export$a2ddee470fba72ea)({
            type: 'init',
            data: null
        });
        // non iframe case
        setTimeout(()=>{
            !runtime && setRuntime({});
        }, 500);
        // splash time
        setTimeout(()=>{
            setSplash(false);
        }, 1500);
    }, []);
    return /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)("div", {
        className: "relative",
        children: [
            splash && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $ecece3a6d7a30975$export$2e2bcd8739ae039), {}),
            !!runtime && /*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $edd1e569c67b39dd$export$2e2bcd8739ae039), {
                ...runtime
            })
        ]
    });
};
var $b245de47ffd0296a$export$2e2bcd8739ae039 = $b245de47ffd0296a$var$Wrapper;


const $476e56c0ae003a94$var$container = document.getElementById("app");
(0, $8Zslt.render)(/*#__PURE__*/ (0, $046b5a639d530697$export$34b9dba7ce09269b)((0, $b245de47ffd0296a$export$2e2bcd8739ae039), {}), $476e56c0ae003a94$var$container, $476e56c0ae003a94$var$container.lastChild);
// Hot Module Replacement
if (null) null.accept();


//# sourceMappingURL=web.18c38e46.js.map
